(function() {
  typeof window > "u" || ("SVGPathSeg" in window || (window.SVGPathSeg = function(r, e, t) {
    this.pathSegType = r, this.pathSegTypeAsLetter = e, this._owningPathSegList = t;
  }, window.SVGPathSeg.prototype.classname = "SVGPathSeg", window.SVGPathSeg.PATHSEG_UNKNOWN = 0, window.SVGPathSeg.PATHSEG_CLOSEPATH = 1, window.SVGPathSeg.PATHSEG_MOVETO_ABS = 2, window.SVGPathSeg.PATHSEG_MOVETO_REL = 3, window.SVGPathSeg.PATHSEG_LINETO_ABS = 4, window.SVGPathSeg.PATHSEG_LINETO_REL = 5, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS = 6, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL = 7, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS = 8, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL = 9, window.SVGPathSeg.PATHSEG_ARC_ABS = 10, window.SVGPathSeg.PATHSEG_ARC_REL = 11, window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS = 12, window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL = 13, window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS = 14, window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL = 15, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS = 16, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL = 17, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS = 18, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL = 19, window.SVGPathSeg.prototype._segmentChanged = function() {
    this._owningPathSegList && this._owningPathSegList.segmentChanged(this);
  }, window.SVGPathSegClosePath = function(r) {
    window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CLOSEPATH, "z", r);
  }, window.SVGPathSegClosePath.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegClosePath.prototype.toString = function() {
    return "[object SVGPathSegClosePath]";
  }, window.SVGPathSegClosePath.prototype._asPathString = function() {
    return this.pathSegTypeAsLetter;
  }, window.SVGPathSegClosePath.prototype.clone = function() {
    return new window.SVGPathSegClosePath(void 0);
  }, window.SVGPathSegMovetoAbs = function(r, e, t) {
    window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_MOVETO_ABS, "M", r), this._x = e, this._y = t;
  }, window.SVGPathSegMovetoAbs.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegMovetoAbs.prototype.toString = function() {
    return "[object SVGPathSegMovetoAbs]";
  }, window.SVGPathSegMovetoAbs.prototype._asPathString = function() {
    return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
  }, window.SVGPathSegMovetoAbs.prototype.clone = function() {
    return new window.SVGPathSegMovetoAbs(void 0, this._x, this._y);
  }, Object.defineProperty(window.SVGPathSegMovetoAbs.prototype, "x", { get: function() {
    return this._x;
  }, set: function(r) {
    this._x = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegMovetoAbs.prototype, "y", { get: function() {
    return this._y;
  }, set: function(r) {
    this._y = r, this._segmentChanged();
  }, enumerable: !0 }), window.SVGPathSegMovetoRel = function(r, e, t) {
    window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_MOVETO_REL, "m", r), this._x = e, this._y = t;
  }, window.SVGPathSegMovetoRel.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegMovetoRel.prototype.toString = function() {
    return "[object SVGPathSegMovetoRel]";
  }, window.SVGPathSegMovetoRel.prototype._asPathString = function() {
    return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
  }, window.SVGPathSegMovetoRel.prototype.clone = function() {
    return new window.SVGPathSegMovetoRel(void 0, this._x, this._y);
  }, Object.defineProperty(window.SVGPathSegMovetoRel.prototype, "x", { get: function() {
    return this._x;
  }, set: function(r) {
    this._x = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegMovetoRel.prototype, "y", { get: function() {
    return this._y;
  }, set: function(r) {
    this._y = r, this._segmentChanged();
  }, enumerable: !0 }), window.SVGPathSegLinetoAbs = function(r, e, t) {
    window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_ABS, "L", r), this._x = e, this._y = t;
  }, window.SVGPathSegLinetoAbs.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegLinetoAbs.prototype.toString = function() {
    return "[object SVGPathSegLinetoAbs]";
  }, window.SVGPathSegLinetoAbs.prototype._asPathString = function() {
    return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
  }, window.SVGPathSegLinetoAbs.prototype.clone = function() {
    return new window.SVGPathSegLinetoAbs(void 0, this._x, this._y);
  }, Object.defineProperty(window.SVGPathSegLinetoAbs.prototype, "x", { get: function() {
    return this._x;
  }, set: function(r) {
    this._x = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegLinetoAbs.prototype, "y", { get: function() {
    return this._y;
  }, set: function(r) {
    this._y = r, this._segmentChanged();
  }, enumerable: !0 }), window.SVGPathSegLinetoRel = function(r, e, t) {
    window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_REL, "l", r), this._x = e, this._y = t;
  }, window.SVGPathSegLinetoRel.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegLinetoRel.prototype.toString = function() {
    return "[object SVGPathSegLinetoRel]";
  }, window.SVGPathSegLinetoRel.prototype._asPathString = function() {
    return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
  }, window.SVGPathSegLinetoRel.prototype.clone = function() {
    return new window.SVGPathSegLinetoRel(void 0, this._x, this._y);
  }, Object.defineProperty(window.SVGPathSegLinetoRel.prototype, "x", { get: function() {
    return this._x;
  }, set: function(r) {
    this._x = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegLinetoRel.prototype, "y", { get: function() {
    return this._y;
  }, set: function(r) {
    this._y = r, this._segmentChanged();
  }, enumerable: !0 }), window.SVGPathSegCurvetoCubicAbs = function(r, e, t, A, n, i, s) {
    window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS, "C", r), this._x = e, this._y = t, this._x1 = A, this._y1 = n, this._x2 = i, this._y2 = s;
  }, window.SVGPathSegCurvetoCubicAbs.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegCurvetoCubicAbs.prototype.toString = function() {
    return "[object SVGPathSegCurvetoCubicAbs]";
  }, window.SVGPathSegCurvetoCubicAbs.prototype._asPathString = function() {
    return this.pathSegTypeAsLetter + " " + this._x1 + " " + this._y1 + " " + this._x2 + " " + this._y2 + " " + this._x + " " + this._y;
  }, window.SVGPathSegCurvetoCubicAbs.prototype.clone = function() {
    return new window.SVGPathSegCurvetoCubicAbs(void 0, this._x, this._y, this._x1, this._y1, this._x2, this._y2);
  }, Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "x", { get: function() {
    return this._x;
  }, set: function(r) {
    this._x = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "y", { get: function() {
    return this._y;
  }, set: function(r) {
    this._y = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "x1", { get: function() {
    return this._x1;
  }, set: function(r) {
    this._x1 = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "y1", { get: function() {
    return this._y1;
  }, set: function(r) {
    this._y1 = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "x2", { get: function() {
    return this._x2;
  }, set: function(r) {
    this._x2 = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "y2", { get: function() {
    return this._y2;
  }, set: function(r) {
    this._y2 = r, this._segmentChanged();
  }, enumerable: !0 }), window.SVGPathSegCurvetoCubicRel = function(r, e, t, A, n, i, s) {
    window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL, "c", r), this._x = e, this._y = t, this._x1 = A, this._y1 = n, this._x2 = i, this._y2 = s;
  }, window.SVGPathSegCurvetoCubicRel.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegCurvetoCubicRel.prototype.toString = function() {
    return "[object SVGPathSegCurvetoCubicRel]";
  }, window.SVGPathSegCurvetoCubicRel.prototype._asPathString = function() {
    return this.pathSegTypeAsLetter + " " + this._x1 + " " + this._y1 + " " + this._x2 + " " + this._y2 + " " + this._x + " " + this._y;
  }, window.SVGPathSegCurvetoCubicRel.prototype.clone = function() {
    return new window.SVGPathSegCurvetoCubicRel(void 0, this._x, this._y, this._x1, this._y1, this._x2, this._y2);
  }, Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "x", { get: function() {
    return this._x;
  }, set: function(r) {
    this._x = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "y", { get: function() {
    return this._y;
  }, set: function(r) {
    this._y = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "x1", { get: function() {
    return this._x1;
  }, set: function(r) {
    this._x1 = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "y1", { get: function() {
    return this._y1;
  }, set: function(r) {
    this._y1 = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "x2", { get: function() {
    return this._x2;
  }, set: function(r) {
    this._x2 = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "y2", { get: function() {
    return this._y2;
  }, set: function(r) {
    this._y2 = r, this._segmentChanged();
  }, enumerable: !0 }), window.SVGPathSegCurvetoQuadraticAbs = function(r, e, t, A, n) {
    window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS, "Q", r), this._x = e, this._y = t, this._x1 = A, this._y1 = n;
  }, window.SVGPathSegCurvetoQuadraticAbs.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegCurvetoQuadraticAbs.prototype.toString = function() {
    return "[object SVGPathSegCurvetoQuadraticAbs]";
  }, window.SVGPathSegCurvetoQuadraticAbs.prototype._asPathString = function() {
    return this.pathSegTypeAsLetter + " " + this._x1 + " " + this._y1 + " " + this._x + " " + this._y;
  }, window.SVGPathSegCurvetoQuadraticAbs.prototype.clone = function() {
    return new window.SVGPathSegCurvetoQuadraticAbs(void 0, this._x, this._y, this._x1, this._y1);
  }, Object.defineProperty(window.SVGPathSegCurvetoQuadraticAbs.prototype, "x", { get: function() {
    return this._x;
  }, set: function(r) {
    this._x = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoQuadraticAbs.prototype, "y", { get: function() {
    return this._y;
  }, set: function(r) {
    this._y = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoQuadraticAbs.prototype, "x1", { get: function() {
    return this._x1;
  }, set: function(r) {
    this._x1 = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoQuadraticAbs.prototype, "y1", { get: function() {
    return this._y1;
  }, set: function(r) {
    this._y1 = r, this._segmentChanged();
  }, enumerable: !0 }), window.SVGPathSegCurvetoQuadraticRel = function(r, e, t, A, n) {
    window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL, "q", r), this._x = e, this._y = t, this._x1 = A, this._y1 = n;
  }, window.SVGPathSegCurvetoQuadraticRel.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegCurvetoQuadraticRel.prototype.toString = function() {
    return "[object SVGPathSegCurvetoQuadraticRel]";
  }, window.SVGPathSegCurvetoQuadraticRel.prototype._asPathString = function() {
    return this.pathSegTypeAsLetter + " " + this._x1 + " " + this._y1 + " " + this._x + " " + this._y;
  }, window.SVGPathSegCurvetoQuadraticRel.prototype.clone = function() {
    return new window.SVGPathSegCurvetoQuadraticRel(void 0, this._x, this._y, this._x1, this._y1);
  }, Object.defineProperty(window.SVGPathSegCurvetoQuadraticRel.prototype, "x", { get: function() {
    return this._x;
  }, set: function(r) {
    this._x = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoQuadraticRel.prototype, "y", { get: function() {
    return this._y;
  }, set: function(r) {
    this._y = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoQuadraticRel.prototype, "x1", { get: function() {
    return this._x1;
  }, set: function(r) {
    this._x1 = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoQuadraticRel.prototype, "y1", { get: function() {
    return this._y1;
  }, set: function(r) {
    this._y1 = r, this._segmentChanged();
  }, enumerable: !0 }), window.SVGPathSegArcAbs = function(r, e, t, A, n, i, s, a) {
    window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_ARC_ABS, "A", r), this._x = e, this._y = t, this._r1 = A, this._r2 = n, this._angle = i, this._largeArcFlag = s, this._sweepFlag = a;
  }, window.SVGPathSegArcAbs.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegArcAbs.prototype.toString = function() {
    return "[object SVGPathSegArcAbs]";
  }, window.SVGPathSegArcAbs.prototype._asPathString = function() {
    return this.pathSegTypeAsLetter + " " + this._r1 + " " + this._r2 + " " + this._angle + " " + (this._largeArcFlag ? "1" : "0") + " " + (this._sweepFlag ? "1" : "0") + " " + this._x + " " + this._y;
  }, window.SVGPathSegArcAbs.prototype.clone = function() {
    return new window.SVGPathSegArcAbs(void 0, this._x, this._y, this._r1, this._r2, this._angle, this._largeArcFlag, this._sweepFlag);
  }, Object.defineProperty(window.SVGPathSegArcAbs.prototype, "x", { get: function() {
    return this._x;
  }, set: function(r) {
    this._x = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegArcAbs.prototype, "y", { get: function() {
    return this._y;
  }, set: function(r) {
    this._y = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegArcAbs.prototype, "r1", { get: function() {
    return this._r1;
  }, set: function(r) {
    this._r1 = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegArcAbs.prototype, "r2", { get: function() {
    return this._r2;
  }, set: function(r) {
    this._r2 = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegArcAbs.prototype, "angle", { get: function() {
    return this._angle;
  }, set: function(r) {
    this._angle = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegArcAbs.prototype, "largeArcFlag", { get: function() {
    return this._largeArcFlag;
  }, set: function(r) {
    this._largeArcFlag = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegArcAbs.prototype, "sweepFlag", { get: function() {
    return this._sweepFlag;
  }, set: function(r) {
    this._sweepFlag = r, this._segmentChanged();
  }, enumerable: !0 }), window.SVGPathSegArcRel = function(r, e, t, A, n, i, s, a) {
    window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_ARC_REL, "a", r), this._x = e, this._y = t, this._r1 = A, this._r2 = n, this._angle = i, this._largeArcFlag = s, this._sweepFlag = a;
  }, window.SVGPathSegArcRel.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegArcRel.prototype.toString = function() {
    return "[object SVGPathSegArcRel]";
  }, window.SVGPathSegArcRel.prototype._asPathString = function() {
    return this.pathSegTypeAsLetter + " " + this._r1 + " " + this._r2 + " " + this._angle + " " + (this._largeArcFlag ? "1" : "0") + " " + (this._sweepFlag ? "1" : "0") + " " + this._x + " " + this._y;
  }, window.SVGPathSegArcRel.prototype.clone = function() {
    return new window.SVGPathSegArcRel(void 0, this._x, this._y, this._r1, this._r2, this._angle, this._largeArcFlag, this._sweepFlag);
  }, Object.defineProperty(window.SVGPathSegArcRel.prototype, "x", { get: function() {
    return this._x;
  }, set: function(r) {
    this._x = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegArcRel.prototype, "y", { get: function() {
    return this._y;
  }, set: function(r) {
    this._y = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegArcRel.prototype, "r1", { get: function() {
    return this._r1;
  }, set: function(r) {
    this._r1 = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegArcRel.prototype, "r2", { get: function() {
    return this._r2;
  }, set: function(r) {
    this._r2 = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegArcRel.prototype, "angle", { get: function() {
    return this._angle;
  }, set: function(r) {
    this._angle = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegArcRel.prototype, "largeArcFlag", { get: function() {
    return this._largeArcFlag;
  }, set: function(r) {
    this._largeArcFlag = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegArcRel.prototype, "sweepFlag", { get: function() {
    return this._sweepFlag;
  }, set: function(r) {
    this._sweepFlag = r, this._segmentChanged();
  }, enumerable: !0 }), window.SVGPathSegLinetoHorizontalAbs = function(r, e) {
    window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS, "H", r), this._x = e;
  }, window.SVGPathSegLinetoHorizontalAbs.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegLinetoHorizontalAbs.prototype.toString = function() {
    return "[object SVGPathSegLinetoHorizontalAbs]";
  }, window.SVGPathSegLinetoHorizontalAbs.prototype._asPathString = function() {
    return this.pathSegTypeAsLetter + " " + this._x;
  }, window.SVGPathSegLinetoHorizontalAbs.prototype.clone = function() {
    return new window.SVGPathSegLinetoHorizontalAbs(void 0, this._x);
  }, Object.defineProperty(window.SVGPathSegLinetoHorizontalAbs.prototype, "x", { get: function() {
    return this._x;
  }, set: function(r) {
    this._x = r, this._segmentChanged();
  }, enumerable: !0 }), window.SVGPathSegLinetoHorizontalRel = function(r, e) {
    window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL, "h", r), this._x = e;
  }, window.SVGPathSegLinetoHorizontalRel.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegLinetoHorizontalRel.prototype.toString = function() {
    return "[object SVGPathSegLinetoHorizontalRel]";
  }, window.SVGPathSegLinetoHorizontalRel.prototype._asPathString = function() {
    return this.pathSegTypeAsLetter + " " + this._x;
  }, window.SVGPathSegLinetoHorizontalRel.prototype.clone = function() {
    return new window.SVGPathSegLinetoHorizontalRel(void 0, this._x);
  }, Object.defineProperty(window.SVGPathSegLinetoHorizontalRel.prototype, "x", { get: function() {
    return this._x;
  }, set: function(r) {
    this._x = r, this._segmentChanged();
  }, enumerable: !0 }), window.SVGPathSegLinetoVerticalAbs = function(r, e) {
    window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS, "V", r), this._y = e;
  }, window.SVGPathSegLinetoVerticalAbs.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegLinetoVerticalAbs.prototype.toString = function() {
    return "[object SVGPathSegLinetoVerticalAbs]";
  }, window.SVGPathSegLinetoVerticalAbs.prototype._asPathString = function() {
    return this.pathSegTypeAsLetter + " " + this._y;
  }, window.SVGPathSegLinetoVerticalAbs.prototype.clone = function() {
    return new window.SVGPathSegLinetoVerticalAbs(void 0, this._y);
  }, Object.defineProperty(window.SVGPathSegLinetoVerticalAbs.prototype, "y", { get: function() {
    return this._y;
  }, set: function(r) {
    this._y = r, this._segmentChanged();
  }, enumerable: !0 }), window.SVGPathSegLinetoVerticalRel = function(r, e) {
    window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL, "v", r), this._y = e;
  }, window.SVGPathSegLinetoVerticalRel.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegLinetoVerticalRel.prototype.toString = function() {
    return "[object SVGPathSegLinetoVerticalRel]";
  }, window.SVGPathSegLinetoVerticalRel.prototype._asPathString = function() {
    return this.pathSegTypeAsLetter + " " + this._y;
  }, window.SVGPathSegLinetoVerticalRel.prototype.clone = function() {
    return new window.SVGPathSegLinetoVerticalRel(void 0, this._y);
  }, Object.defineProperty(window.SVGPathSegLinetoVerticalRel.prototype, "y", { get: function() {
    return this._y;
  }, set: function(r) {
    this._y = r, this._segmentChanged();
  }, enumerable: !0 }), window.SVGPathSegCurvetoCubicSmoothAbs = function(r, e, t, A, n) {
    window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS, "S", r), this._x = e, this._y = t, this._x2 = A, this._y2 = n;
  }, window.SVGPathSegCurvetoCubicSmoothAbs.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegCurvetoCubicSmoothAbs.prototype.toString = function() {
    return "[object SVGPathSegCurvetoCubicSmoothAbs]";
  }, window.SVGPathSegCurvetoCubicSmoothAbs.prototype._asPathString = function() {
    return this.pathSegTypeAsLetter + " " + this._x2 + " " + this._y2 + " " + this._x + " " + this._y;
  }, window.SVGPathSegCurvetoCubicSmoothAbs.prototype.clone = function() {
    return new window.SVGPathSegCurvetoCubicSmoothAbs(void 0, this._x, this._y, this._x2, this._y2);
  }, Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothAbs.prototype, "x", { get: function() {
    return this._x;
  }, set: function(r) {
    this._x = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothAbs.prototype, "y", { get: function() {
    return this._y;
  }, set: function(r) {
    this._y = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothAbs.prototype, "x2", { get: function() {
    return this._x2;
  }, set: function(r) {
    this._x2 = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothAbs.prototype, "y2", { get: function() {
    return this._y2;
  }, set: function(r) {
    this._y2 = r, this._segmentChanged();
  }, enumerable: !0 }), window.SVGPathSegCurvetoCubicSmoothRel = function(r, e, t, A, n) {
    window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL, "s", r), this._x = e, this._y = t, this._x2 = A, this._y2 = n;
  }, window.SVGPathSegCurvetoCubicSmoothRel.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegCurvetoCubicSmoothRel.prototype.toString = function() {
    return "[object SVGPathSegCurvetoCubicSmoothRel]";
  }, window.SVGPathSegCurvetoCubicSmoothRel.prototype._asPathString = function() {
    return this.pathSegTypeAsLetter + " " + this._x2 + " " + this._y2 + " " + this._x + " " + this._y;
  }, window.SVGPathSegCurvetoCubicSmoothRel.prototype.clone = function() {
    return new window.SVGPathSegCurvetoCubicSmoothRel(void 0, this._x, this._y, this._x2, this._y2);
  }, Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothRel.prototype, "x", { get: function() {
    return this._x;
  }, set: function(r) {
    this._x = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothRel.prototype, "y", { get: function() {
    return this._y;
  }, set: function(r) {
    this._y = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothRel.prototype, "x2", { get: function() {
    return this._x2;
  }, set: function(r) {
    this._x2 = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothRel.prototype, "y2", { get: function() {
    return this._y2;
  }, set: function(r) {
    this._y2 = r, this._segmentChanged();
  }, enumerable: !0 }), window.SVGPathSegCurvetoQuadraticSmoothAbs = function(r, e, t) {
    window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS, "T", r), this._x = e, this._y = t;
  }, window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype.toString = function() {
    return "[object SVGPathSegCurvetoQuadraticSmoothAbs]";
  }, window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype._asPathString = function() {
    return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
  }, window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype.clone = function() {
    return new window.SVGPathSegCurvetoQuadraticSmoothAbs(void 0, this._x, this._y);
  }, Object.defineProperty(window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype, "x", { get: function() {
    return this._x;
  }, set: function(r) {
    this._x = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype, "y", { get: function() {
    return this._y;
  }, set: function(r) {
    this._y = r, this._segmentChanged();
  }, enumerable: !0 }), window.SVGPathSegCurvetoQuadraticSmoothRel = function(r, e, t) {
    window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL, "t", r), this._x = e, this._y = t;
  }, window.SVGPathSegCurvetoQuadraticSmoothRel.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegCurvetoQuadraticSmoothRel.prototype.toString = function() {
    return "[object SVGPathSegCurvetoQuadraticSmoothRel]";
  }, window.SVGPathSegCurvetoQuadraticSmoothRel.prototype._asPathString = function() {
    return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
  }, window.SVGPathSegCurvetoQuadraticSmoothRel.prototype.clone = function() {
    return new window.SVGPathSegCurvetoQuadraticSmoothRel(void 0, this._x, this._y);
  }, Object.defineProperty(window.SVGPathSegCurvetoQuadraticSmoothRel.prototype, "x", { get: function() {
    return this._x;
  }, set: function(r) {
    this._x = r, this._segmentChanged();
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathSegCurvetoQuadraticSmoothRel.prototype, "y", { get: function() {
    return this._y;
  }, set: function(r) {
    this._y = r, this._segmentChanged();
  }, enumerable: !0 }), window.SVGPathElement.prototype.createSVGPathSegClosePath = function() {
    return new window.SVGPathSegClosePath(void 0);
  }, window.SVGPathElement.prototype.createSVGPathSegMovetoAbs = function(r, e) {
    return new window.SVGPathSegMovetoAbs(void 0, r, e);
  }, window.SVGPathElement.prototype.createSVGPathSegMovetoRel = function(r, e) {
    return new window.SVGPathSegMovetoRel(void 0, r, e);
  }, window.SVGPathElement.prototype.createSVGPathSegLinetoAbs = function(r, e) {
    return new window.SVGPathSegLinetoAbs(void 0, r, e);
  }, window.SVGPathElement.prototype.createSVGPathSegLinetoRel = function(r, e) {
    return new window.SVGPathSegLinetoRel(void 0, r, e);
  }, window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicAbs = function(r, e, t, A, n, i) {
    return new window.SVGPathSegCurvetoCubicAbs(void 0, r, e, t, A, n, i);
  }, window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicRel = function(r, e, t, A, n, i) {
    return new window.SVGPathSegCurvetoCubicRel(void 0, r, e, t, A, n, i);
  }, window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticAbs = function(r, e, t, A) {
    return new window.SVGPathSegCurvetoQuadraticAbs(void 0, r, e, t, A);
  }, window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticRel = function(r, e, t, A) {
    return new window.SVGPathSegCurvetoQuadraticRel(void 0, r, e, t, A);
  }, window.SVGPathElement.prototype.createSVGPathSegArcAbs = function(r, e, t, A, n, i, s) {
    return new window.SVGPathSegArcAbs(void 0, r, e, t, A, n, i, s);
  }, window.SVGPathElement.prototype.createSVGPathSegArcRel = function(r, e, t, A, n, i, s) {
    return new window.SVGPathSegArcRel(void 0, r, e, t, A, n, i, s);
  }, window.SVGPathElement.prototype.createSVGPathSegLinetoHorizontalAbs = function(r) {
    return new window.SVGPathSegLinetoHorizontalAbs(void 0, r);
  }, window.SVGPathElement.prototype.createSVGPathSegLinetoHorizontalRel = function(r) {
    return new window.SVGPathSegLinetoHorizontalRel(void 0, r);
  }, window.SVGPathElement.prototype.createSVGPathSegLinetoVerticalAbs = function(r) {
    return new window.SVGPathSegLinetoVerticalAbs(void 0, r);
  }, window.SVGPathElement.prototype.createSVGPathSegLinetoVerticalRel = function(r) {
    return new window.SVGPathSegLinetoVerticalRel(void 0, r);
  }, window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicSmoothAbs = function(r, e, t, A) {
    return new window.SVGPathSegCurvetoCubicSmoothAbs(void 0, r, e, t, A);
  }, window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicSmoothRel = function(r, e, t, A) {
    return new window.SVGPathSegCurvetoCubicSmoothRel(void 0, r, e, t, A);
  }, window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticSmoothAbs = function(r, e) {
    return new window.SVGPathSegCurvetoQuadraticSmoothAbs(void 0, r, e);
  }, window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticSmoothRel = function(r, e) {
    return new window.SVGPathSegCurvetoQuadraticSmoothRel(void 0, r, e);
  }, "getPathSegAtLength" in window.SVGPathElement.prototype || (window.SVGPathElement.prototype.getPathSegAtLength = function(r) {
    if (r === void 0 || !isFinite(r))
      throw "Invalid arguments.";
    var e = document.createElementNS("http://www.w3.org/2000/svg", "path");
    e.setAttribute("d", this.getAttribute("d"));
    var t = e.pathSegList.numberOfItems - 1;
    if (t <= 0)
      return 0;
    do {
      if (e.pathSegList.removeItem(t), r > e.getTotalLength())
        break;
      t--;
    } while (t > 0);
    return t;
  })), (!("SVGPathSegList" in window) || !("appendItem" in window.SVGPathSegList.prototype)) && (window.SVGPathSegList = function(r) {
    this._pathElement = r, this._list = this._parsePath(this._pathElement.getAttribute("d")), this._mutationObserverConfig = { attributes: !0, attributeFilter: ["d"] }, this._pathElementMutationObserver = new MutationObserver(this._updateListFromPathMutations.bind(this)), this._pathElementMutationObserver.observe(this._pathElement, this._mutationObserverConfig);
  }, window.SVGPathSegList.prototype.classname = "SVGPathSegList", Object.defineProperty(window.SVGPathSegList.prototype, "numberOfItems", {
    get: function() {
      return this._checkPathSynchronizedToList(), this._list.length;
    },
    enumerable: !0
  }), Object.defineProperty(window.SVGPathSegList.prototype, "length", {
    get: function() {
      return this._checkPathSynchronizedToList(), this._list.length;
    },
    enumerable: !0
  }), Object.defineProperty(window.SVGPathElement.prototype, "pathSegList", {
    get: function() {
      return this._pathSegList || (this._pathSegList = new window.SVGPathSegList(this)), this._pathSegList;
    },
    enumerable: !0
  }), Object.defineProperty(window.SVGPathElement.prototype, "normalizedPathSegList", { get: function() {
    return this.pathSegList;
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathElement.prototype, "animatedPathSegList", { get: function() {
    return this.pathSegList;
  }, enumerable: !0 }), Object.defineProperty(window.SVGPathElement.prototype, "animatedNormalizedPathSegList", { get: function() {
    return this.pathSegList;
  }, enumerable: !0 }), window.SVGPathSegList.prototype._checkPathSynchronizedToList = function() {
    this._updateListFromPathMutations(this._pathElementMutationObserver.takeRecords());
  }, window.SVGPathSegList.prototype._updateListFromPathMutations = function(r) {
    if (this._pathElement) {
      var e = !1;
      r.forEach(function(t) {
        t.attributeName == "d" && (e = !0);
      }), e && (this._list = this._parsePath(this._pathElement.getAttribute("d")));
    }
  }, window.SVGPathSegList.prototype._writeListToPath = function() {
    this._pathElementMutationObserver.disconnect(), this._pathElement.setAttribute("d", window.SVGPathSegList._pathSegArrayAsString(this._list)), this._pathElementMutationObserver.observe(this._pathElement, this._mutationObserverConfig);
  }, window.SVGPathSegList.prototype.segmentChanged = function(r) {
    this._writeListToPath();
  }, window.SVGPathSegList.prototype.clear = function() {
    this._checkPathSynchronizedToList(), this._list.forEach(function(r) {
      r._owningPathSegList = null;
    }), this._list = [], this._writeListToPath();
  }, window.SVGPathSegList.prototype.initialize = function(r) {
    return this._checkPathSynchronizedToList(), this._list = [r], r._owningPathSegList = this, this._writeListToPath(), r;
  }, window.SVGPathSegList.prototype._checkValidIndex = function(r) {
    if (isNaN(r) || r < 0 || r >= this.numberOfItems)
      throw "INDEX_SIZE_ERR";
  }, window.SVGPathSegList.prototype.getItem = function(r) {
    return this._checkPathSynchronizedToList(), this._checkValidIndex(r), this._list[r];
  }, window.SVGPathSegList.prototype.insertItemBefore = function(r, e) {
    return this._checkPathSynchronizedToList(), e > this.numberOfItems && (e = this.numberOfItems), r._owningPathSegList && (r = r.clone()), this._list.splice(e, 0, r), r._owningPathSegList = this, this._writeListToPath(), r;
  }, window.SVGPathSegList.prototype.replaceItem = function(r, e) {
    return this._checkPathSynchronizedToList(), r._owningPathSegList && (r = r.clone()), this._checkValidIndex(e), this._list[e] = r, r._owningPathSegList = this, this._writeListToPath(), r;
  }, window.SVGPathSegList.prototype.removeItem = function(r) {
    this._checkPathSynchronizedToList(), this._checkValidIndex(r);
    var e = this._list[r];
    return this._list.splice(r, 1), this._writeListToPath(), e;
  }, window.SVGPathSegList.prototype.appendItem = function(r) {
    return this._checkPathSynchronizedToList(), r._owningPathSegList && (r = r.clone()), this._list.push(r), r._owningPathSegList = this, this._writeListToPath(), r;
  }, window.SVGPathSegList._pathSegArrayAsString = function(r) {
    var e = "", t = !0;
    return r.forEach(function(A) {
      t ? (t = !1, e += A._asPathString()) : e += " " + A._asPathString();
    }), e;
  }, window.SVGPathSegList.prototype._parsePath = function(r) {
    if (!r || r.length == 0)
      return [];
    var e = this, t = function() {
      this.pathSegList = [];
    };
    t.prototype.appendSegment = function(a) {
      this.pathSegList.push(a);
    };
    var A = function(a) {
      this._string = a, this._currentIndex = 0, this._endIndex = this._string.length, this._previousCommand = window.SVGPathSeg.PATHSEG_UNKNOWN, this._skipOptionalSpaces();
    };
    A.prototype._isCurrentSpace = function() {
      var a = this._string[this._currentIndex];
      return a <= " " && (a == " " || a == `
` || a == "	" || a == "\r" || a == "\f");
    }, A.prototype._skipOptionalSpaces = function() {
      for (; this._currentIndex < this._endIndex && this._isCurrentSpace(); )
        this._currentIndex++;
      return this._currentIndex < this._endIndex;
    }, A.prototype._skipOptionalSpacesOrDelimiter = function() {
      return this._currentIndex < this._endIndex && !this._isCurrentSpace() && this._string.charAt(this._currentIndex) != "," ? !1 : (this._skipOptionalSpaces() && this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == "," && (this._currentIndex++, this._skipOptionalSpaces()), this._currentIndex < this._endIndex);
    }, A.prototype.hasMoreData = function() {
      return this._currentIndex < this._endIndex;
    }, A.prototype.peekSegmentType = function() {
      var a = this._string[this._currentIndex];
      return this._pathSegTypeFromChar(a);
    }, A.prototype._pathSegTypeFromChar = function(a) {
      switch (a) {
        case "Z":
        case "z":
          return window.SVGPathSeg.PATHSEG_CLOSEPATH;
        case "M":
          return window.SVGPathSeg.PATHSEG_MOVETO_ABS;
        case "m":
          return window.SVGPathSeg.PATHSEG_MOVETO_REL;
        case "L":
          return window.SVGPathSeg.PATHSEG_LINETO_ABS;
        case "l":
          return window.SVGPathSeg.PATHSEG_LINETO_REL;
        case "C":
          return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS;
        case "c":
          return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL;
        case "Q":
          return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS;
        case "q":
          return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL;
        case "A":
          return window.SVGPathSeg.PATHSEG_ARC_ABS;
        case "a":
          return window.SVGPathSeg.PATHSEG_ARC_REL;
        case "H":
          return window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS;
        case "h":
          return window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL;
        case "V":
          return window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS;
        case "v":
          return window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL;
        case "S":
          return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS;
        case "s":
          return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL;
        case "T":
          return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS;
        case "t":
          return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL;
        default:
          return window.SVGPathSeg.PATHSEG_UNKNOWN;
      }
    }, A.prototype._nextCommandHelper = function(a, o) {
      return (a == "+" || a == "-" || a == "." || a >= "0" && a <= "9") && o != window.SVGPathSeg.PATHSEG_CLOSEPATH ? o == window.SVGPathSeg.PATHSEG_MOVETO_ABS ? window.SVGPathSeg.PATHSEG_LINETO_ABS : o == window.SVGPathSeg.PATHSEG_MOVETO_REL ? window.SVGPathSeg.PATHSEG_LINETO_REL : o : window.SVGPathSeg.PATHSEG_UNKNOWN;
    }, A.prototype.initialCommandIsMoveTo = function() {
      if (!this.hasMoreData())
        return !0;
      var a = this.peekSegmentType();
      return a == window.SVGPathSeg.PATHSEG_MOVETO_ABS || a == window.SVGPathSeg.PATHSEG_MOVETO_REL;
    }, A.prototype._parseNumber = function() {
      var a = 0, o = 0, l = 1, u = 0, h = 1, f = 1, c = this._currentIndex;
      if (this._skipOptionalSpaces(), this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == "+" ? this._currentIndex++ : this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == "-" && (this._currentIndex++, h = -1), !(this._currentIndex == this._endIndex || (this._string.charAt(this._currentIndex) < "0" || this._string.charAt(this._currentIndex) > "9") && this._string.charAt(this._currentIndex) != ".")) {
        for (var p = this._currentIndex; this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) >= "0" && this._string.charAt(this._currentIndex) <= "9"; )
          this._currentIndex++;
        if (this._currentIndex != p)
          for (var g = this._currentIndex - 1, v = 1; g >= p; )
            o += v * (this._string.charAt(g--) - "0"), v *= 10;
        if (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == ".") {
          if (this._currentIndex++, this._currentIndex >= this._endIndex || this._string.charAt(this._currentIndex) < "0" || this._string.charAt(this._currentIndex) > "9")
            return;
          for (; this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) >= "0" && this._string.charAt(this._currentIndex) <= "9"; )
            l *= 10, u += (this._string.charAt(this._currentIndex) - "0") / l, this._currentIndex += 1;
        }
        if (this._currentIndex != c && this._currentIndex + 1 < this._endIndex && (this._string.charAt(this._currentIndex) == "e" || this._string.charAt(this._currentIndex) == "E") && this._string.charAt(this._currentIndex + 1) != "x" && this._string.charAt(this._currentIndex + 1) != "m") {
          if (this._currentIndex++, this._string.charAt(this._currentIndex) == "+" ? this._currentIndex++ : this._string.charAt(this._currentIndex) == "-" && (this._currentIndex++, f = -1), this._currentIndex >= this._endIndex || this._string.charAt(this._currentIndex) < "0" || this._string.charAt(this._currentIndex) > "9")
            return;
          for (; this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) >= "0" && this._string.charAt(this._currentIndex) <= "9"; )
            a *= 10, a += this._string.charAt(this._currentIndex) - "0", this._currentIndex++;
        }
        var w = o + u;
        if (w *= h, a && (w *= Math.pow(10, f * a)), c != this._currentIndex)
          return this._skipOptionalSpacesOrDelimiter(), w;
      }
    }, A.prototype._parseArcFlag = function() {
      if (!(this._currentIndex >= this._endIndex)) {
        var a = !1, o = this._string.charAt(this._currentIndex++);
        if (o == "0")
          a = !1;
        else if (o == "1")
          a = !0;
        else
          return;
        return this._skipOptionalSpacesOrDelimiter(), a;
      }
    }, A.prototype.parseSegment = function() {
      var a = this._string[this._currentIndex], o = this._pathSegTypeFromChar(a);
      if (o == window.SVGPathSeg.PATHSEG_UNKNOWN) {
        if (this._previousCommand == window.SVGPathSeg.PATHSEG_UNKNOWN || (o = this._nextCommandHelper(a, this._previousCommand), o == window.SVGPathSeg.PATHSEG_UNKNOWN))
          return null;
      } else
        this._currentIndex++;
      switch (this._previousCommand = o, o) {
        case window.SVGPathSeg.PATHSEG_MOVETO_REL:
          return new window.SVGPathSegMovetoRel(e, this._parseNumber(), this._parseNumber());
        case window.SVGPathSeg.PATHSEG_MOVETO_ABS:
          return new window.SVGPathSegMovetoAbs(e, this._parseNumber(), this._parseNumber());
        case window.SVGPathSeg.PATHSEG_LINETO_REL:
          return new window.SVGPathSegLinetoRel(e, this._parseNumber(), this._parseNumber());
        case window.SVGPathSeg.PATHSEG_LINETO_ABS:
          return new window.SVGPathSegLinetoAbs(e, this._parseNumber(), this._parseNumber());
        case window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL:
          return new window.SVGPathSegLinetoHorizontalRel(e, this._parseNumber());
        case window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS:
          return new window.SVGPathSegLinetoHorizontalAbs(e, this._parseNumber());
        case window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL:
          return new window.SVGPathSegLinetoVerticalRel(e, this._parseNumber());
        case window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS:
          return new window.SVGPathSegLinetoVerticalAbs(e, this._parseNumber());
        case window.SVGPathSeg.PATHSEG_CLOSEPATH:
          return this._skipOptionalSpaces(), new window.SVGPathSegClosePath(e);
        case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL:
          var l = { x1: this._parseNumber(), y1: this._parseNumber(), x2: this._parseNumber(), y2: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber() };
          return new window.SVGPathSegCurvetoCubicRel(e, l.x, l.y, l.x1, l.y1, l.x2, l.y2);
        case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS:
          var l = { x1: this._parseNumber(), y1: this._parseNumber(), x2: this._parseNumber(), y2: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber() };
          return new window.SVGPathSegCurvetoCubicAbs(e, l.x, l.y, l.x1, l.y1, l.x2, l.y2);
        case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL:
          var l = { x2: this._parseNumber(), y2: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber() };
          return new window.SVGPathSegCurvetoCubicSmoothRel(e, l.x, l.y, l.x2, l.y2);
        case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS:
          var l = { x2: this._parseNumber(), y2: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber() };
          return new window.SVGPathSegCurvetoCubicSmoothAbs(e, l.x, l.y, l.x2, l.y2);
        case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL:
          var l = { x1: this._parseNumber(), y1: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber() };
          return new window.SVGPathSegCurvetoQuadraticRel(e, l.x, l.y, l.x1, l.y1);
        case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS:
          var l = { x1: this._parseNumber(), y1: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber() };
          return new window.SVGPathSegCurvetoQuadraticAbs(e, l.x, l.y, l.x1, l.y1);
        case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL:
          return new window.SVGPathSegCurvetoQuadraticSmoothRel(e, this._parseNumber(), this._parseNumber());
        case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS:
          return new window.SVGPathSegCurvetoQuadraticSmoothAbs(e, this._parseNumber(), this._parseNumber());
        case window.SVGPathSeg.PATHSEG_ARC_REL:
          var l = { x1: this._parseNumber(), y1: this._parseNumber(), arcAngle: this._parseNumber(), arcLarge: this._parseArcFlag(), arcSweep: this._parseArcFlag(), x: this._parseNumber(), y: this._parseNumber() };
          return new window.SVGPathSegArcRel(e, l.x, l.y, l.x1, l.y1, l.arcAngle, l.arcLarge, l.arcSweep);
        case window.SVGPathSeg.PATHSEG_ARC_ABS:
          var l = { x1: this._parseNumber(), y1: this._parseNumber(), arcAngle: this._parseNumber(), arcLarge: this._parseArcFlag(), arcSweep: this._parseArcFlag(), x: this._parseNumber(), y: this._parseNumber() };
          return new window.SVGPathSegArcAbs(e, l.x, l.y, l.x1, l.y1, l.arcAngle, l.arcLarge, l.arcSweep);
        default:
          throw "Unknown path seg type.";
      }
    };
    var n = new t(), i = new A(r);
    if (!i.initialCommandIsMoveTo())
      return [];
    for (; i.hasMoreData(); ) {
      var s = i.parseSegment();
      if (!s)
        return [];
      n.appendSegment(s);
    }
    return n.pathSegList;
  }));
})();
class uS {
  /**
   * @param {module:jGraduate.jGraduatePaintOptions} [opt]
   */
  constructor(e) {
    const t = e || {};
    if (this.alpha = isNaN(t.alpha) ? 100 : t.alpha, t.copy)
      switch (this.type = t.copy.type, this.alpha = t.copy.alpha, this.solidColor = null, this.linearGradient = null, this.radialGradient = null, this.type) {
        case "none":
          break;
        case "solidColor":
          this.solidColor = t.copy.solidColor;
          break;
        case "linearGradient":
          this.linearGradient = t.copy.linearGradient.cloneNode(!0);
          break;
        case "radialGradient":
          this.radialGradient = t.copy.radialGradient.cloneNode(!0);
          break;
      }
    else if (t.linearGradient) {
      this.type = "linearGradient", this.solidColor = null, this.radialGradient = null;
      const A = t.linearGradient.getAttribute("href") || t.linearGradient.getAttribute("xlink:href");
      if (A) {
        const n = document.getElementById(A.replace(/^#/, ""));
        this.linearGradient = n.cloneNode(!0);
      } else
        this.linearGradient = t.linearGradient.cloneNode(!0);
    } else if (t.radialGradient) {
      this.type = "radialGradient", this.solidColor = null, this.linearGradient = null;
      const A = t.radialGradient.getAttribute("href") || t.radialGradient.getAttribute("xlink:href");
      if (A) {
        const n = document.getElementById(A.replace(/^#/, ""));
        this.radialGradient = n.cloneNode(!0);
      } else
        this.radialGradient = t.radialGradient.cloneNode(!0);
    } else t.solidColor ? (this.type = "solidColor", this.solidColor = t.solidColor) : (this.type = "none", this.solidColor = null, this.linearGradient = null, this.radialGradient = null);
  }
}
const N1 = "http://www.w3.org/2000/svg", cS = ["x", "x1", "cx", "rx", "width"], hS = ["y", "y1", "cy", "ry", "height"], S4 = ["r", "radius", ...cS, ...hS];
let Fo, tu = {};
const x4 = function(r) {
  Fo = r;
  const e = document.createElementNS(N1, "svg");
  document.body.append(e);
  const t = document.createElementNS(N1, "rect");
  t.setAttribute("width", "1em"), t.setAttribute("height", "1ex"), t.setAttribute("x", "1in"), e.append(t);
  const A = t.getBBox();
  e.remove();
  const n = A.x;
  tu = {
    em: A.width,
    ex: A.height,
    in: n,
    cm: n / 2.54,
    mm: n / 25.4,
    pt: n / 72,
    pc: n / 6,
    px: 1,
    "%": 0
  };
}, Gm = () => tu, yn = (r) => {
  const e = Fo.getRoundDigits();
  return isNaN(r) ? Array.isArray(r) ? yn(r[0]) + "," + yn(r[1]) : Number.parseFloat(r).toFixed(e) - 0 : Number(Number(r).toFixed(e));
}, ch = (r, e) => (e = e || Fo.getBaseUnit(), yn(r / tu[e])), E4 = (r, e, t) => {
  r.setAttribute(e, t);
}, xA = (r, e) => {
  if (!isNaN(e))
    return e - 0;
  if (e.substr(-1) === "%") {
    const n = e.substr(0, e.length - 1) / 100, i = Fo.getWidth(), s = Fo.getHeight();
    return cS.includes(r) ? n * i : hS.includes(r) ? n * s : n * Math.sqrt(i * i + s * s) / Math.sqrt(2);
  }
  const t = e.substr(-2);
  return e.substr(0, e.length - 2) * tu[t];
}, F4 = (r, e, t) => {
  if (S4.includes(r))
    return isNaN(e) ? (e = e.toLowerCase(), Object.keys(tu).some((A) => new RegExp("^-?[\\d\\.]+" + A + "$").test(e))) : !0;
  if (r === "id") {
    let A = !1;
    try {
      const n = Fo.getElement(e);
      A = !n || n === t;
    } catch (n) {
      console.error(n);
    }
    return A;
  }
  return !0;
};
const nt = {
  HTML: "http://www.w3.org/1999/xhtml",
  MATH: "http://www.w3.org/1998/Math/MathML",
  SE: "http://svg-edit.googlecode.com",
  SVG: "http://www.w3.org/2000/svg",
  XLINK: "http://www.w3.org/1999/xlink",
  OI: "http://www.optimistik.fr/namespace/svg/OIdata",
  XML: "http://www.w3.org/XML/1998/namespace",
  XMLNS: "http://www.w3.org/2000/xmlns/"
  // see http://www.w3.org/TR/REC-xml-names/#xmlReserved
  // SODIPODI: 'http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd',
  // INKSCAPE: 'http://www.inkscape.org/namespaces/inkscape',
  // RDF: 'http://www.w3.org/1999/02/22-rdf-syntax-ns#',
  // OSB: 'http://www.openswatchbook.org/uri/2009/osb',
  // CC: 'http://creativecommons.org/ns#',
  // DC: 'http://purl.org/dc/elements/1.1/'
}, fS = function() {
  const r = {};
  return Object.entries(nt).forEach(([e, t]) => {
    r[t] = e.toLowerCase();
  }), r;
};
const Za = 1e-10, uo = document.createElementNS(nt.SVG, "svg"), zt = (r, e, t) => ({
  x: t.a * r + t.c * e + t.e,
  y: t.b * r + t.d * e + t.f
}), yr = (r) => {
  if (r.transform?.baseVal)
    return r.transform.baseVal;
  if (r.gradientTransform?.baseVal)
    return r.gradientTransform.baseVal;
  if (r.patternTransform?.baseVal)
    return r.patternTransform.baseVal;
  console.warn("No transform list found. Check browser compatibility.", r);
}, dS = (r) => r.a === 1 && r.b === 0 && r.c === 0 && r.d === 1 && r.e === 0 && r.f === 0, wn = (...r) => {
  if (r.length === 0)
    return uo.createSVGMatrix();
  const e = r.reduceRight((t, A) => A.multiply(t));
  return Math.abs(e.a) < Za && (e.a = 0), Math.abs(e.b) < Za && (e.b = 0), Math.abs(e.c) < Za && (e.c = 0), Math.abs(e.d) < Za && (e.d = 0), Math.abs(e.e) < Za && (e.e = 0), Math.abs(e.f) < Za && (e.f = 0), e;
}, Qo = (r) => {
  if (!r) return !1;
  for (let e = 0; e < r.numberOfItems; e++) {
    const t = r.getItem(e);
    if (t.type === SVGTransform.SVG_TRANSFORM_MATRIX && !dS(t.matrix))
      return !0;
  }
  return !1;
}, Vm = (r, e, t, A, n) => {
  const i = zt(r, e, n), s = zt(r + t, e, n), a = zt(r, e + A, n), o = zt(r + t, e + A, n), l = Math.min(i.x, s.x, a.x, o.x), u = Math.max(i.x, s.x, a.x, o.x), h = Math.min(i.y, s.y, a.y, o.y), f = Math.max(i.y, s.y, a.y, o.y);
  return {
    tl: i,
    tr: s,
    bl: a,
    br: o,
    aabox: {
      x: l,
      y: h,
      width: u - l,
      height: f - h
    }
  };
}, vr = (r, e = 0, t = null) => {
  if (!r)
    return uo.createSVGTransformFromMatrix(uo.createSVGMatrix());
  const A = Number.parseInt(e, 10), n = Number.parseInt(t ?? r.numberOfItems - 1, 10), i = Math.min(A, n), s = Math.max(A, n);
  let a = uo.createSVGMatrix();
  for (let o = i; o <= s; o++) {
    const l = o >= 0 && o < r.numberOfItems ? r.getItem(o).matrix : uo.createSVGMatrix();
    a = wn(a, l);
  }
  return uo.createSVGTransformFromMatrix(a);
}, Km = (r) => {
  const e = yr(r);
  return vr(e).matrix;
}, O0 = (r, e, t, A) => {
  const n = Math.PI / 4, i = t - r, s = A - e, a = Math.atan2(s, i), o = Math.hypot(i, s), l = Math.round(a / n) * n;
  return {
    x: r + o * Math.cos(l),
    y: e + o * Math.sin(l),
    a: l
  };
}, gS = (r, e) => e.x < r.x + r.width && e.x + e.width > r.x && e.y < r.y + r.height && e.y + e.height > r.y;
function _4(r) {
  let e = 0, t = 0;
  if (r.offsetParent) {
    do
      e += r.offsetLeft, t += r.offsetTop;
    while (r = r.offsetParent);
    return { left: e, top: t };
  }
  return { left: e, top: t };
}
function Gf(r) {
  return r && typeof r == "object" && !Array.isArray(r);
}
function ru(r, e) {
  const t = Object.assign({}, r);
  return Gf(r) && Gf(e) && Object.keys(e).forEach((A) => {
    Gf(e[A]) ? A in r ? t[A] = ru(r[A], e[A]) : Object.assign(t, { [A]: e[A] }) : Object.assign(t, { [A]: e[A] });
  }), t;
}
function Au(r, e) {
  const t = e.charAt(0), A = "classList" in document.documentElement;
  let n, i;
  for (t === "[" && (e = e.substr(1, e.length - 2), n = e.split("="), n.length > 1 && (i = !0, n[1] = n[1].replace(/"/g, "").replace(/'/g, ""))); r && r !== document && r.nodeType === 1; r = r.parentNode) {
    if (t === ".") {
      if (A) {
        if (r.classList.contains(e.substr(1)))
          return r;
      } else if (new RegExp("(^|\\s)" + e.substr(1) + "(\\s|$)").test(r.className))
        return r;
    }
    if (t === "#" && r.id === e.substr(1))
      return r;
    if (t === "[" && r.hasAttribute(n[0]))
      if (i) {
        if (r.getAttribute(n[0]) === n[1])
          return r;
      } else
        return r;
    if (r.tagName.toLowerCase() === e)
      return r;
  }
  return null;
}
function nu(r, e) {
  const t = [], A = e?.charAt(0);
  for (; r && r !== document; r = r.parentNode)
    e ? (A === "." && r.classList.contains(e.substr(1)) && t.push(r), A === "#" && r.id === e.substr(1) && t.push(r), A === "[" && r.hasAttribute(e.substr(1, e.length - 1)) && t.push(r), r.tagName.toLowerCase() === e && t.push(r)) : t.push(r);
  return t.length ? t : null;
}
function U4(r, e, t) {
  const A = [], n = e?.charAt(0);
  for (; r && r !== document && !(n === "." && r.classList.contains(e.substr(1)) || n === "#" && r.id === e.substr(1) || n === "[" && r.hasAttribute(e.substr(1, e.length - 1)) || r.tagName.toLowerCase() === e); r = r.parentNode)
    A.push(r);
  return A.length ? A : null;
}
const I4 = "a,circle,ellipse,foreignObject,g,image,line,path,polygon,polyline,rect,svg,text,tspan,use,clipPath", Q4 = I4.split(",");
let ts = null, pS = null;
const L4 = (r) => {
  ts = r, pS = r.getSvgRoot();
}, Tl = (r) => r.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
function mS(r) {
  return r = P4(r), window.btoa(r);
}
function vS(r) {
  return T4(window.atob(r));
}
function N4(r) {
  let e = 0, t;
  if (r.length === 0) return e;
  for (let A = 0; A < r.length; A++)
    t = r.charCodeAt(A), e = (e << 5) - e + t, e |= 0;
  return e;
}
function T4(r) {
  return decodeURIComponent(escape(r));
}
const P4 = (r) => unescape(encodeURIComponent(r)), O4 = (r) => !r || typeof URL > "u" || !URL.createObjectURL ? "" : URL.createObjectURL(r), M4 = (() => {
  if (typeof Blob > "u")
    return "";
  const r = new Blob(
    ["<html><head><title>SVG-edit</title></head><body>&nbsp;</body></html>"],
    { type: "text/html" }
  );
  return O4(r);
})(), jm = (r) => {
  r.includes("<svg:svg") && (r = r.replace(/<(\/?)svg:/g, "<$1").replace("xmlns:svg", "xmlns"));
  let e, t;
  try {
    t = new DOMParser(), t.async = !1;
  } catch {
    throw new Error("XML Parser could not be instantiated");
  }
  try {
    e = t.parseFromString(r, "text/xml");
  } catch {
    throw new Error("Error parsing XML string");
  }
  return e;
}, R4 = ({ x: r, y: e, width: t, height: A }) => ({ x: r, y: e, width: t, height: A }), rs = (r, e) => {
  if (r?.nodeType === 1) {
    e(r);
    let t = r.childNodes.length;
    for (; t--; )
      rs(r.childNodes.item(t), e);
  }
}, k4 = (r, e) => {
  if (r?.nodeType === 1) {
    let t = r.childNodes.length;
    for (; t--; )
      rs(r.childNodes.item(t), e);
    e(r);
  }
}, hh = function(r) {
  if (r) {
    if (r.startsWith('url("'))
      return r.substring(5, r.indexOf('"', 6));
    if (r.startsWith("url('"))
      return r.substring(5, r.indexOf("'", 6));
    if (r.startsWith("url("))
      return r.substring(4, r.indexOf(")"));
  }
  return null;
};
let $i = function(r) {
  return r.getAttribute("href") || r.getAttributeNS(nt.XLINK, "href");
}, Rn = function(r, e) {
  r.setAttribute("href", e);
};
const Cn = function() {
  const r = ts.getSvgContent();
  let e = r.getElementsByTagNameNS(nt.SVG, "defs");
  return e.length > 0 ? e = e[0] : (e = r.ownerDocument.createElementNS(nt.SVG, "defs"), r.firstChild ? r.insertBefore(e, r.firstChild.nextSibling) : r.append(e)), e;
}, Nr = function(r) {
  const e = r || ts.getSelectedElements()[0];
  if (r.nodeType !== 1)
    return null;
  const t = e.nodeName;
  let A = null;
  switch (t) {
    case "text":
      e.textContent === "" ? (e.textContent = "a", A = e.getBBox(), e.textContent = "") : e.getBBox && (A = e.getBBox());
      break;
    case "path":
    case "g":
    case "a":
      e.getBBox && (A = e.getBBox());
      break;
    default:
      if (t === "use")
        A = e.getBBox();
      else if (Q4.includes(t))
        if (e)
          try {
            A = e.getBBox();
          } catch {
            const i = e.getExtentOfChar(0), s = e.getComputedTextLength();
            A = {
              x: i.x,
              y: i.y,
              width: s,
              height: i.height
            };
          }
        else {
          const n = Au(e.parentNode, "foreignObject");
          n.length && n[0].getBBox && (A = n[0].getBBox());
        }
  }
  if (A) {
    if (A.width === 0 && A.height === 0) {
      const n = t.toLowerCase(), i = (a, o = 0) => Number.parseFloat(e.getAttribute(a) ?? o), s = (() => {
        switch (n) {
          case "path": {
            const o = ((e.getAttribute("d") || "").match(/-?\d*\.?\d+/g) || []).map(Number).filter((l) => !Number.isNaN(l));
            if (o.length >= 2) {
              const l = o.filter((h, f) => f % 2 === 0), u = o.filter((h, f) => f % 2 === 1);
              return {
                x: Math.min(...l),
                y: Math.min(...u),
                width: Math.max(...l) - Math.min(...l),
                height: Math.max(...u) - Math.min(...u)
              };
            }
            break;
          }
          case "rect":
            return { x: i("x"), y: i("y"), width: i("width"), height: i("height") };
          case "line": {
            const a = i("x1"), o = i("x2"), l = i("y1"), u = i("y2");
            return { x: Math.min(a, o), y: Math.min(l, u), width: Math.abs(o - a), height: Math.abs(u - l) };
          }
          case "g": {
            const a = Array.from(e.children || []).map((o) => Nr(o)).filter(Boolean);
            if (a.length) {
              const o = Math.min(...a.map((f) => f.x)), l = Math.min(...a.map((f) => f.y)), u = Math.max(...a.map((f) => f.x + f.width)), h = Math.max(...a.map((f) => f.y + f.height));
              return { x: o, y: l, width: u - o, height: h - l };
            }
            break;
          }
        }
      })();
      s && (A = s);
    }
    A = R4(A);
  }
  return A;
}, Vf = function(r) {
  let e = "";
  return r.forEach(function([t, A], n) {
    e += t;
    for (let i = 0; i < A.length; i += 2)
      e += A[i] + "," + A[i + 1] + " ";
  }), e;
}, wS = function(r) {
  let e = 1.81, t, A, n;
  switch (r.tagName) {
    case "ellipse":
    case "circle": {
      A = Number(r.getAttribute("rx")), n = Number(r.getAttribute("ry"));
      const i = Number(r.getAttribute("cx")), s = Number(r.getAttribute("cy"));
      r.tagName === "circle" && r.hasAttribute("r") && (n = Number(r.getAttribute("r")), A = n), t = Vf([
        ["M", [i - A, s]],
        ["C", [i - A, s - n / e, i - A / e, s - n, i, s - n]],
        ["C", [i + A / e, s - n, i + A, s - n / e, i + A, s]],
        ["C", [i + A, s + n / e, i + A / e, s + n, i, s + n]],
        ["C", [i - A / e, s + n, i - A, s + n / e, i - A, s]],
        ["Z", []]
      ]);
      break;
    }
    case "path":
      t = r.getAttribute("d");
      break;
    case "line":
      {
        const i = r.getAttribute("x1"), s = r.getAttribute("y1"), a = r.getAttribute("x2"), o = r.getAttribute("y2");
        t = "M" + i + "," + s + "L" + a + "," + o;
      }
      break;
    case "polyline":
      t = "M" + r.getAttribute("points");
      break;
    case "polygon":
      t = "M" + r.getAttribute("points") + " Z";
      break;
    case "rect": {
      A = Number(r.getAttribute("rx")), n = Number(r.getAttribute("ry"));
      const i = r.getBBox(), { x: s, y: a } = i, o = i.width, l = i.height;
      e = 4 - e, t = Vf(!A && !n ? [
        ["M", [s, a]],
        ["L", [s + o, a]],
        ["L", [s + o, a + l]],
        ["L", [s, a + l]],
        ["L", [s, a]],
        ["Z", []]
      ] : [
        ["M", [s, a + n]],
        ["C", [s, a + n / e, s + A / e, a, s + A, a]],
        ["L", [s + o - A, a]],
        ["C", [s + o - A / e, a, s + o, a + n / e, s + o, a + n]],
        ["L", [s + o, a + l - n]],
        [
          "C",
          [
            s + o,
            a + l - n / e,
            s + o - A / e,
            a + l,
            s + o - A,
            a + l
          ]
        ],
        ["L", [s + A, a + l]],
        ["C", [s + A / e, a + l, s, a + l - n / e, s, a + l - n]],
        ["L", [s, a + n]],
        ["Z", []]
      ]);
      break;
    }
  }
  return t;
}, yS = function(r) {
  const e = {};
  return ["marker-start", "marker-end", "marker-mid", "filter", "clip-path"].forEach(
    function(t) {
      const A = r.getAttribute(t);
      A && (e[t] = A);
    }
  ), e;
}, M0 = function(r, e, t) {
  const A = e({
    element: "path",
    attr: yS(r)
  }), n = r.getAttribute("transform");
  n && A.setAttribute("transform", n);
  const { parentNode: i } = r;
  r.nextSibling ? r.before(A) : i.append(A);
  const s = wS(r);
  s ? A.setAttribute("d", s) : A.remove(), t.resetOrientation(A);
  let a = !1;
  try {
    a = A.getBBox();
  } catch {
  }
  if (a && a.width === 0 && a.height === 0) {
    const l = ((A.getAttribute("d") || "").match(/-?\d*\.?\d+/g) || []).map(Number).filter((u) => !Number.isNaN(u));
    if (l.length >= 2) {
      const u = l.filter((f, c) => c % 2 === 0), h = l.filter((f, c) => c % 2 === 1);
      a = {
        x: Math.min(...u),
        y: Math.min(...h),
        width: Math.max(...u) - Math.min(...u),
        height: Math.max(...h) - Math.min(...h)
      };
    }
  }
  return A.remove(), a;
}, H4 = (r, e, t) => {
  const A = new t.history.BatchCommand("Convert element to Path");
  e = ru(e, yS(r));
  const n = t.addSVGElementsFromJson({
    element: "path",
    attr: e
  }), i = r.getAttribute("transform");
  i && n.setAttribute("transform", i);
  const { id: s } = r, { parentNode: a } = r;
  r.nextSibling ? r.before(n) : a.append(n);
  const o = wS(r);
  if (o) {
    if (n.setAttribute("d", o), i) {
      const u = yr(n);
      Qo(u) && t.pathActions.resetOrientation(n);
    }
    const { nextSibling: l } = r;
    return A.addSubCommand(
      new t.history.RemoveElementCommand(
        r,
        l,
        r.parentNode
      )
    ), t.clearSelection(), r.remove(), A.addSubCommand(new t.history.InsertElementCommand(n)), n.setAttribute("id", s), n.removeAttribute("visibility"), t.addToSelection([n], !0), t.addCommandToHistory(A), n;
  }
  return n.remove(), null;
};
function D4(r, e) {
  const t = r % 90, A = t < -89.99 || t > 89.99, n = t > -1e-3 && t < 1e-3;
  return e || !(n || A);
}
const T1 = function(r, e, t) {
  let A = Nr(r);
  if (!A)
    return null;
  const n = r.getAttribute?.("transform") || "", i = n.includes("matrix(");
  if (n.includes("rotate(") && !i) {
    const l = n.match(/-?\d*\.?\d+/g)?.map(Number) || [], [u = 0, h = 0, f = 0] = l, c = u * Math.PI / 180, p = Math.cos(c), g = Math.sin(c), v = r.tagName?.toLowerCase();
    let w = [];
    if (v === "path") {
      const S = ((r.getAttribute("d") || "").match(/-?\d*\.?\d+/g) || []).map(Number).filter((C) => !Number.isNaN(C));
      for (let C = 0; C < S.length; C += 2)
        w.push({ x: S[C], y: S[C + 1] ?? 0 });
    } else if (v === "rect") {
      const B = Number(r.getAttribute("x") ?? 0), S = Number(r.getAttribute("y") ?? 0), C = Number(r.getAttribute("width") ?? 0), E = Number(r.getAttribute("height") ?? 0);
      w = [
        { x: B, y: S },
        { x: B + C, y: S },
        { x: B, y: S + E },
        { x: B + C, y: S + E }
      ];
    }
    if (w.length) {
      const B = w.map((O) => {
        const U = O.x - h, V = O.y - f;
        return {
          x: h + (U * p - V * g),
          y: f + (U * g + V * p)
        };
      }), S = B.map((O) => O.x), C = B.map((O) => O.y);
      let E = {
        x: Math.min(...S),
        y: Math.min(...C),
        width: Math.max(...S) - Math.min(...S),
        height: Math.max(...C) - Math.min(...C)
      };
      const _ = n.match(/matrix\(([^)]+)\)/);
      if (_) {
        const O = _[1].split(/[,\s]+/).filter(Boolean).map(Number), U = O[4] ?? 0, V = O[5] ?? 0;
        E = { ...E, x: E.x + U, y: E.y + V };
      }
      const I = Math.abs(u % 90) < 1e-3;
      return v !== "path" && I && typeof e == "function" && e({ element: "path", attr: {} }), E;
    }
  }
  const s = yr(r), a = bS(s), o = Qo(s);
  if (a || o) {
    let l = !1;
    if (D4(a, o)) {
      if (["ellipse", "path", "line", "polyline", "polygon"].includes(r.tagName)) {
        const h = M0(
          r,
          e,
          t
        );
        h && !(h.width === 0 && h.height === 0) && (l = h, A = h);
      } else if (r.tagName === "rect") {
        const h = Number(r.getAttribute("rx")), f = Number(r.getAttribute("ry"));
        if (h || f) {
          const c = M0(
            r,
            e,
            t
          );
          c && !(c.width === 0 && c.height === 0) && (l = c, A = c);
        }
      }
    }
    if (!l) {
      const { matrix: u } = vr(s);
      A = Vm(A.x, A.y, A.width, A.height, u).aabox;
    }
  }
  return A;
}, P1 = (r) => {
  const e = r.getAttribute("stroke-width");
  return !isNaN(e) && r.getAttribute("stroke") !== "none" ? e / 2 : 0;
}, BS = (r, e, t) => {
  if (!r || !r.length)
    return !1;
  let A;
  if (r.forEach((o) => {
    A || o.parentNode && (A = T1(o, e, t));
  }), !A)
    return null;
  let n = A.x + A.width, i = A.y + A.height, s = A.x, a = A.y;
  if (r.length === 1) {
    const o = P1(r[0]);
    s -= o, a -= o, n += o, i += o;
  } else
    r.forEach((o) => {
      const l = T1(
        o,
        e,
        t
      );
      if (l) {
        const u = P1(o);
        s = Math.min(s, l.x - u), a = Math.min(a, l.y - u), o.nodeType === 1 && (n = Math.max(n, l.x + l.width + u), i = Math.max(i, l.y + l.height + u));
      }
    });
  return A.x = yn(s), A.y = yn(a), A.width = yn(n - s), A.height = yn(i - a), A;
}, iu = (r) => {
  if (!r) {
    const t = ts.getSvgContent();
    for (let A = 0; A < t.children.length; A++)
      if (t.children[A].getBBox) {
        const n = t.children[A].getBBox();
        if (n.width !== 0 && n.height !== 0 && n.width !== 0 && n.height !== 0) {
          r = t.children[A];
          break;
        }
      }
  }
  const e = [];
  if (r) {
    const t = r.children;
    Array.from(t, (A) => {
      A.getBBox && e.push(A);
    });
  }
  return e.reverse();
}, Mn = (r) => (r || (r = iu()), BS(
  r,
  ts.addSVGElementsFromJson,
  ts.pathActions
)), bS = (r, e) => {
  if (!r)
    return 0;
  for (let t = 0; t < r.numberOfItems; ++t) {
    const A = r.getItem(t);
    if (A.type === 4)
      return e ? A.angle * Math.PI / 180 : A.angle;
  }
  return 0;
};
let MA = (r, e) => {
  const t = r || ts.getSelectedElements()[0], A = yr(t);
  return bS(A, e);
};
const Ua = (r) => {
  if (!r) return null;
  const e = hh(r);
  if (!e) return null;
  const t = e[0] === "#" ? e.substr(1) : e;
  return Xt(t);
}, R0 = (r) => {
  if (r?.firstChild?.tagName === "feGaussianBlur")
    return r.firstChild;
  {
    const e = r.children;
    for (const [t, A] of Object.entries(e))
      if (A.tagName === "feGaussianBlur")
        return A;
  }
  return null;
}, Xt = (r) => pS.querySelector("#" + r), qt = (r, e, t, A) => {
  for (const [n, i] of Object.entries(e)) {
    const s = n.substr(0, 4) === "xml:" ? nt.XML : n.substr(0, 6) === "xlink:" ? nt.XLINK : null;
    if (i === void 0) {
      s ? r.removeAttributeNS(s, n) : r.removeAttribute(n);
      continue;
    }
    s ? r.setAttributeNS(s, n, i) : A ? E4(r, n, i) : r.setAttribute(n, i);
  }
}, Ih = (r) => {
  const e = {
    "fill-opacity": 1,
    "stop-opacity": 1,
    opacity: 1,
    stroke: "none",
    "stroke-dasharray": "none",
    "stroke-linejoin": "miter",
    "stroke-linecap": "butt",
    "stroke-opacity": 1,
    "stroke-width": 1,
    rx: 0,
    ry: 0
  };
  r.nodeName === "ellipse" && (delete e.rx, delete e.ry), Object.entries(e).forEach(([t, A]) => {
    r.getAttribute(t) === String(A) && r.removeAttribute(t);
  });
}, Ot = (r) => {
  const e = ts.getBaseUnit();
  let t = ts.getSnappingStep();
  return e !== "px" && (t *= Gm()[e]), r = Math.round(r / t) * t, r;
}, qm = (r) => {
  fh(r, (e) => {
    e.preventDefault();
  });
}, CS = (r) => new DOMParser().parseFromString(r, "text/html").body.firstChild, G4 = (r, e, t = 0) => {
  const A = CS(e);
  t >= r.children.length ? r.appendChild(A) : r.insertBefore(A, r.children[t]);
}, SS = (r) => document.getElementById(r), xS = (r) => document.querySelector(r), ES = (r) => [...document.querySelectorAll(r)], fh = (r, e) => {
  r.addEventListener("click", e), r.addEventListener("touchend", e);
};
const Cl = {
  BEFORE_APPLY: "before_apply",
  AFTER_APPLY: "after_apply",
  BEFORE_UNAPPLY: "before_unapply",
  AFTER_UNAPPLY: "after_unapply"
};
class Lo {
  /**
  * @returns {string}
  */
  getText() {
    return this.text;
  }
  /**
   * @param {module:history.HistoryEventHandler} handler
   * @param {callback} applyFunction
   * @returns {void}
  */
  apply(e, t) {
    e && e.handleHistoryEvent(Cl.BEFORE_APPLY, this), t(e), e && e.handleHistoryEvent(Cl.AFTER_APPLY, this);
  }
  /**
   * @param {module:history.HistoryEventHandler} handler
   * @param {callback} unapplyFunction
   * @returns {void}
  */
  unapply(e, t) {
    e && e.handleHistoryEvent(Cl.BEFORE_UNAPPLY, this), t(), e && e.handleHistoryEvent(Cl.AFTER_UNAPPLY, this);
  }
  /**
   * @returns {Element[]} Array with element associated with this command
   * This function needs to be surcharged if multiple elements are returned.
  */
  elements() {
    return [this.elem];
  }
  /**
    * @returns {string} String with element associated with this command
  */
  type() {
    return this.constructor.name;
  }
}
let FS = class extends Lo {
  /**
  * @param {Element} elem - The DOM element that was moved
  * @param {Element} oldNextSibling - The element's next sibling before it was moved
  * @param {Element} oldParent - The element's parent before it was moved
  * @param {string} [text] - An optional string visible to user related to this change
  */
  constructor(e, t, A, n) {
    super(), this.elem = e, this.text = n ? "Move " + e.tagName + " to " + n : "Move " + e.tagName, this.oldNextSibling = t, this.oldParent = A, this.newNextSibling = e.nextSibling, this.newParent = e.parentNode;
  }
  /**
   * Re-positions the element.
   * @param {module:history.HistoryEventHandler} handler
   * @fires module:history~Command#event:history
   * @returns {void}
  */
  apply(e) {
    super.apply(e, () => {
      this.elem = this.newParent.insertBefore(this.elem, this.newNextSibling);
    });
  }
  /**
   * Positions the element back to its original location.
   * @param {module:history.HistoryEventHandler} handler
   * @fires module:history~Command#event:history
   * @returns {void}
  */
  unapply(e) {
    super.unapply(e, () => {
      this.elem = this.oldParent.insertBefore(this.elem, this.oldNextSibling);
    });
  }
}, _S = class extends Lo {
  /**
   * @param {Element} elem - The newly added DOM element
   * @param {string} text - An optional string visible to user related to this change
  */
  constructor(e, t) {
    super(), this.elem = e, this.text = t || "Create " + e.tagName, this.parent = e.parentNode, this.nextSibling = this.elem.nextSibling;
  }
  /**
  * Re-inserts the new element.
  * @param {module:history.HistoryEventHandler} handler
  * @fires module:history~Command#event:history
  * @returns {void}
  */
  apply(e) {
    super.apply(e, () => {
      this.elem = this.parent.insertBefore(this.elem, this.nextSibling);
    });
  }
  /**
  * Removes the element.
  * @param {module:history.HistoryEventHandler} handler
  * @fires module:history~Command#event:history
  * @returns {void}
  */
  unapply(e) {
    super.unapply(e, () => {
      this.parent = this.elem.parentNode, this.elem.remove();
    });
  }
}, US = class extends Lo {
  /**
  * @param {Element} elem - The removed DOM element
  * @param {Node} oldNextSibling - The DOM element's nextSibling when it was in the DOM
  * @param {Element} oldParent - The DOM element's parent
  * @param {string} [text] - An optional string visible to user related to this change
  */
  constructor(e, t, A, n) {
    super(), this.elem = e, this.text = n || "Delete " + e.tagName, this.nextSibling = t, this.parent = A;
  }
  /**
  * Re-removes the new element.
  * @param {module:history.HistoryEventHandler} handler
  * @fires module:history~Command#event:history
  * @returns {void}
  */
  apply(e) {
    super.apply(e, () => {
      this.parent = this.elem.parentNode, this.elem.remove();
    });
  }
  /**
  * Re-adds the new element.
  * @param {module:history.HistoryEventHandler} handler
  * @fires module:history~Command#event:history
  * @returns {void}
  */
  unapply(e) {
    super.unapply(e, () => {
      this.nextSibling || console.error("Reference element was lost"), this.parent.insertBefore(this.elem, this.nextSibling);
    });
  }
}, No = class extends Lo {
  /**
  * @param {Element} elem - The DOM element that was changed
  * @param {module:history.CommandAttributes} attrs - Attributes to be changed with the values they had *before* the change
  * @param {string} text - An optional string visible to user related to this change
   */
  constructor(e, t, A) {
    super(), this.elem = e, this.text = A ? "Change " + e.tagName + " " + A : "Change " + e.tagName, this.newValues = {}, this.oldValues = t;
    for (const n in t)
      n === "#text" ? this.newValues[n] = e ? e.textContent : "" : n === "#href" ? this.newValues[n] = $i(e) : this.newValues[n] = e.getAttribute(n);
  }
  /**
  * Performs the stored change action.
  * @param {module:history.HistoryEventHandler} handler
  * @fires module:history~Command#event:history
  * @returns {void}
  */
  apply(e) {
    super.apply(e, () => {
      let t = !1;
      if (Object.entries(this.newValues).forEach(([A, n]) => {
        n ? A === "#text" ? this.elem.textContent = n : A === "#href" ? Rn(this.elem, n) : this.elem.setAttribute(A, n) : A === "#text" ? this.elem.textContent = "" : (this.elem.setAttribute(A, ""), this.elem.removeAttribute(A)), A === "transform" && (t = !0);
      }), !t) {
        const A = MA(this.elem);
        if (A) {
          const n = Nr(this.elem), i = n.x + n.width / 2, s = n.y + n.height / 2, a = ["rotate(", A, " ", i, ",", s, ")"].join("");
          a !== this.elem.getAttribute("transform") && this.elem.setAttribute("transform", a);
        }
      }
    });
  }
  /**
  * Reverses the stored change action.
  * @param {module:history.HistoryEventHandler} handler
  * @fires module:history~Command#event:history
  * @returns {void}
  */
  unapply(e) {
    super.unapply(e, () => {
      let t = !1;
      if (Object.entries(this.oldValues).forEach(([A, n]) => {
        n ? A === "#text" ? this.elem.textContent = n : A === "#href" ? Rn(this.elem, n) : this.elem.setAttribute(A, n) : A === "#text" ? this.elem.textContent = "" : this.elem.removeAttribute(A), A === "transform" && (t = !0);
      }), !t) {
        const A = MA(this.elem);
        if (A) {
          const n = Nr(this.elem), i = n.x + n.width / 2, s = n.y + n.height / 2, a = ["rotate(", A, " ", i, ",", s, ")"].join("");
          a !== this.elem.getAttribute("transform") && this.elem.setAttribute("transform", a);
        }
      }
    });
  }
}, su = class extends Lo {
  /**
  * @param {string} [text] - An optional string visible to user related to this change
  */
  constructor(e) {
    super(), this.text = e || "Batch Command", this.stack = [];
  }
  /**
  * Runs "apply" on all subcommands.
  * @param {module:history.HistoryEventHandler} handler
  * @fires module:history~Command#event:history
  * @returns {void}
  */
  apply(e) {
    super.apply(e, () => {
      this.stack.forEach((t) => {
        console.assert(t, "stack item should not be null"), t && t.apply(e);
      });
    });
  }
  /**
  * Runs "unapply" on all subcommands.
  * @param {module:history.HistoryEventHandler} handler
  * @fires module:history~Command#event:history
  * @returns {void}
  */
  unapply(e) {
    super.unapply(e, () => {
      [...this.stack].reverse().forEach((t) => {
        console.assert(t, "stack item should not be null"), t && t.unapply(e);
      });
    });
  }
  /**
  * Iterate through all our subcommands.
  * @returns {Element[]} All the elements we are changing
  */
  elements() {
    const e = [];
    let t = this.stack.length;
    for (; t--; ) {
      if (!this.stack[t]) continue;
      const A = this.stack[t].elements();
      let n = A.length;
      for (; n--; )
        e.includes(A[n]) || e.push(A[n]);
    }
    return e;
  }
  /**
  * Adds a given command to the history stack.
  * @param {Command} cmd - The undo command object to add
  * @returns {void}
  */
  addSubCommand(e) {
    console.assert(e !== null, "cmd should not be null"), this.stack.push(e);
  }
  /**
  * @returns {boolean} Indicates whether or not the batch command is empty
  */
  isEmpty() {
    return !this.stack.length;
  }
}, V4 = class {
  /**
  * @param {module:history.HistoryEventHandler} historyEventHandler
  */
  constructor(e) {
    this.handler_ = e || null, this.undoStackPointer = 0, this.undoStack = [], this.undoChangeStackPointer = -1, this.undoableChangeStack = [];
  }
  /**
  * Resets the undo stack, effectively clearing the undo/redo history.
  * @returns {void}
  */
  resetUndoStack() {
    this.undoStack = [], this.undoStackPointer = 0;
  }
  /**
  * @returns {Integer} Current size of the undo history stack
  */
  getUndoStackSize() {
    return this.undoStackPointer;
  }
  /**
  * @returns {Integer} Current size of the redo history stack
  */
  getRedoStackSize() {
    return this.undoStack.length - this.undoStackPointer;
  }
  /**
  * @returns {string} String associated with the next undo command
  */
  getNextUndoCommandText() {
    return this.undoStackPointer > 0 ? this.undoStack[this.undoStackPointer - 1].getText() : "";
  }
  /**
  * @returns {string} String associated with the next redo command
  */
  getNextRedoCommandText() {
    return this.undoStackPointer < this.undoStack.length ? this.undoStack[this.undoStackPointer].getText() : "";
  }
  /**
  * Performs an undo step.
  * @returns {void}
  */
  undo() {
    this.undoStackPointer > 0 && this.undoStack[--this.undoStackPointer].unapply(this.handler_);
  }
  /**
  * Performs a redo step.
  * @returns {void}
  */
  redo() {
    this.undoStackPointer < this.undoStack.length && this.undoStack.length > 0 && this.undoStack[this.undoStackPointer++].apply(this.handler_);
  }
  /**
  * Adds a command object to the undo history stack.
  * @param {Command} cmd - The command object to add
  * @returns {void}
  */
  addCommandToHistory(e) {
    this.undoStackPointer < this.undoStack.length && this.undoStack.length > 0 && (this.undoStack = this.undoStack.splice(0, this.undoStackPointer)), this.undoStack.push(e), this.undoStackPointer = this.undoStack.length;
  }
  /**
  * This function tells the canvas to remember the old values of the
  * `attrName` attribute for each element sent in.  The elements and values
  * are stored on a stack, so the next call to `finishUndoableChange()` will
  * pop the elements and old values off the stack, gets the current values
  * from the DOM and uses all of these to construct the undo-able command.
  * @param {string} attrName - The name of the attribute being changed
  * @param {Element[]} elems - Array of DOM elements being changed
  * @returns {void}
  */
  beginUndoableChange(e, t) {
    const A = ++this.undoChangeStackPointer;
    let n = t.length;
    const i = new Array(n), s = new Array(n);
    for (; n--; ) {
      const a = t[n];
      a && (s[n] = a, i[n] = a.getAttribute(e));
    }
    this.undoableChangeStack[A] = {
      attrName: e,
      oldValues: i,
      elements: s
    };
  }
  /**
  * This function returns a `BatchCommand` object which summarizes the
  * change since `beginUndoableChange` was called.  The command can then
  * be added to the command history.
  * @returns {BatchCommand} Batch command object with resulting changes
  */
  finishUndoableChange() {
    const e = this.undoChangeStackPointer--, t = this.undoableChangeStack[e], { attrName: A } = t, n = new su("Change " + A);
    let i = t.elements.length;
    for (; i--; ) {
      const s = t.elements[i];
      if (!s)
        continue;
      const a = {};
      a[A] = t.oldValues[i], a[A] !== s.getAttribute(A) && n.addSubCommand(new No(s, a, A));
    }
    return this.undoableChangeStack[e] = null, n;
  }
};
const Pa = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BatchCommand: su,
  ChangeElementCommand: No,
  Command: Lo,
  HistoryEventTypes: Cl,
  InsertElementCommand: _S,
  MoveElementCommand: FS,
  RemoveElementCommand: US,
  UndoManager: V4
}, Symbol.toStringTag, { value: "Module" }));
let AA = null;
const K4 = (r) => {
  AA = r;
}, zm = function(r, e) {
  return AA.getSegData()[r].map((n) => e[n]);
}, Ia = function(r, e) {
  const { path: t } = r;
  let A = {
    x: e ? e.x : r.item.x,
    y: e ? e.y : r.item.y
  };
  t.matrix && (A = zt(A.x, A.y, t.matrix));
  const n = AA.getZoom();
  return A.x *= n, A.y *= n, A;
}, IS = function(r, e) {
  const t = {
    x: r.x,
    y: r.y
  };
  e.matrix && (r = zt(t.x, t.y, e.imatrix), t.x = r.x, t.y = r.y);
  const A = AA.getZoom();
  return t.x /= A, t.y /= A, t;
}, Oa = function() {
  let r = Xt("pathpointgrip_container");
  if (!r) {
    const e = Xt("selectorParentGroup");
    r = document.createElementNS(nt.SVG, "g"), e.append(r), r.id = "pathpointgrip_container";
  }
  return r;
}, Wm = function(r, e, t) {
  const A = Oa();
  let n = Xt("pathpointgrip_" + r);
  if (!n) {
    n = document.createElementNS(nt.SVG, "circle");
    const i = {
      id: "pathpointgrip_" + r,
      display: "none",
      r: 4,
      fill: "#0FF",
      stroke: "#00F",
      "stroke-width": 2,
      cursor: "move",
      style: "pointer-events:all"
    }, s = AA.getUIStrings();
    "pathNodeTooltip" in s && (i["xlink:title"] = s.pathNodeTooltip), qt(n, i), A.append(n), document.getElementById("pathpointgrip_" + r)?.addEventListener("dblclick", () => {
      const o = AA.getPathObj();
      o && o.setSegType();
    });
  }
  return e && t && qt(n, {
    cx: e,
    cy: t,
    display: "inline"
  }), n;
}, Xm = function(r) {
  let e = Xt("ctrlpointgrip_" + r);
  if (e)
    return e;
  e = document.createElementNS(nt.SVG, "circle");
  const t = {
    id: "ctrlpointgrip_" + r,
    display: "none",
    r: 4,
    fill: "#0FF",
    stroke: "#55F",
    "stroke-width": 1,
    cursor: "move",
    style: "pointer-events:all"
  }, A = AA.getUIStrings();
  return "pathCtrlPtTooltip" in A && (t["xlink:title"] = A.pathCtrlPtTooltip), qt(e, t), Oa().append(e), e;
}, Ym = function(r) {
  let e = Xt("ctrlLine_" + r);
  return e || (e = document.createElementNS(nt.SVG, "line"), qt(e, {
    id: "ctrlLine_" + r,
    stroke: "#555",
    "stroke-width": 1,
    style: "pointer-events:none"
  }), Oa().append(e), e);
}, QS = function(r, e) {
  const { index: t } = r, A = Wm(t);
  if (e) {
    const n = Ia(r);
    qt(A, {
      cx: n.x,
      cy: n.y,
      display: "inline"
    });
  }
  return A;
}, zc = function(r) {
  const { item: e, index: t } = r;
  if (!("x1" in e) || !("x2" in e))
    return null;
  const A = {};
  Oa();
  const s = [AA.getPathObj().segs[t - 1].item, e];
  for (let a = 1; a < 3; a++) {
    const o = t + "c" + a, l = A["c" + a + "_line"] = Ym(o), u = Ia(r, { x: e["x" + a], y: e["y" + a] }), h = Ia(r, { x: s[a - 1].x, y: s[a - 1].y });
    qt(l, {
      x1: u.x,
      y1: u.y,
      x2: h.x,
      y2: h.y,
      display: "inline"
    }), A["c" + a + "_line"] = l;
    const f = A["c" + a] = Xm(o);
    qt(f, {
      cx: u.x,
      cy: u.y,
      display: "inline"
    }), A["c" + a] = f;
  }
  return A;
}, rn = function(r, e, t, A) {
  const n = AA.getPathObj(), i = A || n.elem, a = "createSVGPathSeg" + AA.getPathFuncs()[r], o = i[a](...t);
  i.pathSegList.replaceItem(o, e);
}, k0 = function(r, e) {
  const { index: t } = r;
  let A = Xt("segline_" + t);
  if (!A) {
    const n = Oa();
    A = document.createElementNS(nt.SVG, "path"), qt(A, {
      id: "segline_" + t,
      display: "none",
      fill: "none",
      stroke: "#0FF",
      "stroke-width": 2,
      style: "pointer-events:none",
      d: "M0,0 0,0"
    }), n.append(A);
  }
  if (e) {
    const { prev: n } = r;
    if (!n)
      return A.setAttribute("display", "none"), A;
    const i = Ia(n);
    rn(2, 0, [i.x, i.y], A);
    const s = zm(r.type, r.item);
    for (let a = 0; a < s.length; a += 2) {
      const o = Ia(r, { x: s[a], y: s[a + 1] });
      s[a] = o.x, s[a + 1] = o.y;
    }
    rn(r.type, 1, s, A);
  }
  return A;
};
class j4 {
  /**
  * @param {Integer} index
  * @param {SVGPathSeg} item
  * @todo Is `item` be more constrained here?
  */
  constructor(e, t) {
    this.selected = !1, this.index = e, this.item = t, this.type = t.pathSegType, this.ctrlpts = [], this.ptgrip = null, this.segsel = null;
  }
  /**
   * @param {boolean} y
   * @returns {void}
   */
  showCtrlPts(e) {
    for (const t in this.ctrlpts)
      ({}).hasOwnProperty.call(this.ctrlpts, t) && this.ctrlpts[t].setAttribute("display", e ? "inline" : "none");
  }
  /**
   * @param {boolean} y
   * @returns {void}
   */
  selectCtrls(e) {
    document.getElementById("ctrlpointgrip_" + this.index + "c1").setAttribute("fill", e ? "#0FF" : "#EEE"), document.getElementById("ctrlpointgrip_" + this.index + "c2").setAttribute("fill", e ? "#0FF" : "#EEE");
  }
  /**
   * @param {boolean} y
   * @returns {void}
   */
  show(e) {
    this.ptgrip && (this.ptgrip.setAttribute("display", e ? "inline" : "none"), this.segsel.setAttribute("display", e ? "inline" : "none"), this.showCtrlPts(e));
  }
  /**
   * @param {boolean} y
   * @returns {void}
   */
  select(e) {
    this.ptgrip && (this.ptgrip.setAttribute("stroke", e ? "#0FF" : "#00F"), this.segsel.setAttribute("display", e ? "inline" : "none"), this.ctrlpts && this.selectCtrls(e), this.selected = e);
  }
  /**
   * @returns {void}
   */
  addGrip() {
    this.ptgrip = QS(this, !0), this.ctrlpts = zc(this), this.segsel = k0(this, !0);
  }
  /**
   * @param {boolean} full
   * @returns {void}
   */
  update(e) {
    if (this.ptgrip) {
      const t = Ia(this);
      if (qt(this.ptgrip, {
        cx: t.x,
        cy: t.y
      }), k0(this, !0), this.ctrlpts) {
        if (e) {
          const A = AA.getPathObj();
          this.item = A.elem.pathSegList.getItem(this.index), this.type = this.item.pathSegType;
        }
        zc(this);
      }
    }
  }
  /**
   * @param {Integer} dx
   * @param {Integer} dy
   * @returns {void}
   */
  move(e, t) {
    const { item: A } = this, n = this.ctrlpts ? [
      A.x += e,
      A.y += t,
      A.x1,
      A.y1,
      A.x2 += e,
      A.y2 += t
    ] : [A.x += e, A.y += t];
    if (rn(
      this.type,
      this.index,
      // type 10 means ARC
      this.type === 10 ? zm(this.type, A) : n
    ), this.next?.ctrlpts) {
      const i = this.next.item, s = [
        i.x,
        i.y,
        i.x1 += e,
        i.y1 += t,
        i.x2,
        i.y2
      ];
      rn(this.next.type, this.next.index, s);
    }
    if (this.mate) {
      const { item: i } = this.mate, s = [i.x += e, i.y += t];
      rn(this.mate.type, this.mate.index, s);
    }
    this.update(!0), this.next && this.next.update(!0);
  }
  /**
   * @param {Integer} num
   * @returns {void}
   */
  setLinked(e) {
    let t, A, n;
    if (e === 2) {
      if (A = 1, t = this.next, !t)
        return;
      n = this.item;
    } else {
      if (A = 2, t = this.prev, !t)
        return;
      n = t.item;
    }
    const { item: i } = t;
    i["x" + A] = n.x + (n.x - this.item["x" + e]), i["y" + A] = n.y + (n.y - this.item["y" + e]);
    const s = [
      i.x,
      i.y,
      i.x1,
      i.y1,
      i.x2,
      i.y2
    ];
    rn(t.type, t.index, s), t.update(!0);
  }
  /**
   * @param {Integer} num
   * @param {Integer} dx
   * @param {Integer} dy
   * @returns {void}
   */
  moveCtrl(e, t, A) {
    const { item: n } = this;
    n["x" + e] += t, n["y" + e] += A;
    const i = [
      n.x,
      n.y,
      n.x1,
      n.y1,
      n.x2,
      n.y2
    ];
    rn(this.type, this.index, i), this.update(!0);
  }
  /**
   * @param {Integer} newType Possible values set during {@link module:path.init}
   * @param {ArgumentsArray} pts
   * @returns {void}
   */
  setType(e, t) {
    rn(e, this.index, t), this.type = e;
    const A = AA.getPathObj();
    this.item = A.elem.pathSegList.getItem(this.index), this.showCtrlPts(e === 6), this.ctrlpts = zc(this), this.update(!0);
  }
}
class Jm {
  /**
  * @param {SVGPathElement} elem
  * @throws {Error} If constructed without a path element
  */
  constructor(e) {
    if (!e || e.tagName !== "path")
      throw new Error("svgedit.path.Path constructed without a <path> element");
    this.elem = e, this.segs = [], this.selected_pts = [], AA.setPathObj(this), this.init();
  }
  setPathContext() {
    AA.setPathObj(this);
  }
  /**
  * Reset path data.
  * @returns {module:path.Path}
  */
  init() {
    const t = Oa().querySelectorAll("*");
    Array.prototype.forEach.call(t, function(a) {
      a.setAttribute("display", "none");
    });
    const A = this.elem.pathSegList, n = A.numberOfItems;
    this.segs = [], this.selected_pts = [], this.first_seg = null;
    for (let a = 0; a < n; a++) {
      const o = A.getItem(a), l = new j4(a, o);
      l.path = this, this.segs.push(l);
    }
    const { segs: i } = this;
    let s = null;
    for (let a = 0; a < n; a++) {
      const o = i[a], l = a + 1 >= n ? null : i[a + 1], u = a - 1 < 0 ? null : i[a - 1];
      if (o.type === 2) {
        if (u && u.type !== 1) {
          const h = i[s];
          h.next = i[s + 1], h.next.prev = h, h.addGrip();
        }
        s = a;
      } else if (l?.type === 1)
        o.next = i[s + 1], o.next.prev = o, o.mate = i[s], o.addGrip(), this.first_seg || (this.first_seg = o);
      else if (l)
        o.type !== 1 && (o.addGrip(), l && l.type !== 2 && (o.next = l, o.next.prev = o));
      else if (o.type !== 1) {
        const h = i[s];
        h.next = i[s + 1], h.next.prev = h, h.addGrip(), o.addGrip(), this.first_seg || (this.first_seg = i[s]);
      }
    }
    return this;
  }
  /**
  * @callback module:path.PathEachSegCallback
  * @this module:path.Segment
  * @param {Integer} i The index of the seg being iterated
  * @returns {boolean|void} Will stop execution of `eachSeg` if returns `false`
  */
  /**
  * @param {module:path.PathEachSegCallback} fn
  * @returns {void}
  */
  eachSeg(e) {
    const t = this.segs.length;
    for (let A = 0; A < t && e.call(this.segs[A], A) !== !1; A++)
      ;
  }
  /**
  * @param {Integer} index
  * @returns {void}
  */
  addSeg(e) {
    const t = this.segs[e];
    if (!t.prev)
      return;
    const { prev: A } = t;
    let n, i, s;
    switch (t.item.pathSegType) {
      case 4: {
        i = (t.item.x + A.item.x) / 2, s = (t.item.y + A.item.y) / 2, n = this.elem.createSVGPathSegLinetoAbs(i, s);
        break;
      }
      case 6: {
        const o = (A.item.x + t.item.x1) / 2, l = (t.item.x1 + t.item.x2) / 2, u = (t.item.x2 + t.item.x) / 2, h = (o + l) / 2, f = (l + u) / 2;
        i = (h + f) / 2;
        const c = (A.item.y + t.item.y1) / 2, p = (t.item.y1 + t.item.y2) / 2, g = (t.item.y2 + t.item.y) / 2, v = (c + p) / 2, w = (p + g) / 2;
        s = (v + w) / 2, n = this.elem.createSVGPathSegCurvetoCubicAbs(i, s, o, c, h, v);
        const B = [t.item.x, t.item.y, f, w, u, g];
        rn(t.type, e, B);
        break;
      }
    }
    this.elem.pathSegList.insertItemBefore(n, e);
  }
  /**
  * @param {Integer} index
  * @returns {void}
  */
  deleteSeg(e) {
    const t = this.segs[e], A = this.elem.pathSegList;
    t.show(!1);
    const { next: n } = t;
    if (t.mate) {
      const i = [n.item.x, n.item.y];
      rn(2, n.index, i), rn(4, t.index, i), A.removeItem(t.mate.index);
    } else if (t.prev)
      A.removeItem(e);
    else {
      const i = [n.item.x, n.item.y];
      rn(2, t.next.index, i), A.removeItem(e);
    }
  }
  /**
  * @param {Integer} index
  * @returns {void}
  */
  removePtFromSelection(e) {
    const t = this.selected_pts.indexOf(e);
    t !== -1 && (this.segs[e].select(!1), this.selected_pts.splice(t, 1));
  }
  /**
  * @returns {void}
  */
  clearSelection() {
    this.eachSeg(function() {
      this.select(!1);
    }), this.selected_pts = [];
  }
  /**
  * @returns {void}
  */
  storeD() {
    this.last_d = this.elem.getAttribute("d");
  }
  /**
  * @param {Integer} y
  * @returns {Path}
  */
  show(e) {
    return this.eachSeg(function() {
      this.show(e);
    }), e && this.selectPt(this.first_seg.index), this;
  }
  /**
  * Move selected points.
  * @param {Integer} dx
  * @param {Integer} dy
  * @returns {void}
  */
  movePts(e, t) {
    let A = this.selected_pts.length;
    for (; A--; )
      this.segs[this.selected_pts[A]].move(e, t);
  }
  /**
  * @param {Integer} dx
  * @param {Integer} dy
  * @returns {void}
  */
  moveCtrl(e, t) {
    const A = this.segs[this.selected_pts[0]];
    A.moveCtrl(this.dragctrl, e, t), AA.getLinkControlPts() && A.setLinked(this.dragctrl);
  }
  /**
  * @param {?Integer} newType See {@link https://www.w3.org/TR/SVG/single-page.html#paths-InterfaceSVGPathSeg}
  * @returns {void}
  */
  setSegType(e) {
    this.storeD();
    let t = this.selected_pts.length, A;
    for (; t--; ) {
      const i = this.selected_pts[t], s = this.segs[i], { prev: a } = s;
      if (!a)
        continue;
      e || (A = "Toggle Path Segment Type", e = s.type === 6 ? 4 : 6), e = Number(e);
      const o = s.item.x, l = s.item.y, u = a.item.x, h = a.item.y;
      let f;
      switch (e) {
        case 6: {
          if (s.olditem) {
            const c = s.olditem;
            f = [o, l, c.x1, c.y1, c.x2, c.y2];
          } else {
            const c = o - u, p = l - h, g = u + c / 3, v = h + p / 3, w = o - c / 3, B = l - p / 3;
            f = [o, l, g, v, w, B];
          }
          break;
        }
        case 4: {
          f = [o, l], s.olditem = s.item;
          break;
        }
      }
      s.setType(e, f);
    }
    AA.getPathObj().endChanges(A);
  }
  /**
  * @param {Integer} pt
  * @param {Integer} ctrlNum
  * @returns {void}
  */
  selectPt(e, t) {
    this.clearSelection(), e || this.eachSeg(function(A) {
      this.prev && (e = A);
    }), this.addPtsToSelection(e), t && (this.dragctrl = t, AA.getLinkControlPts() && this.segs[e].setLinked(t));
  }
  /**
  * Update position of all points.
  * @returns {Path}
  */
  update() {
    const { elem: e } = this;
    return MA(e) ? (this.matrix = Km(e), this.imatrix = this.matrix.inverse()) : (this.matrix = null, this.imatrix = null), this.eachSeg(function(t) {
      this.item = e.pathSegList.getItem(t), this.update();
    }), this;
  }
  /**
  * @param {string} text
  * @returns {void}
  */
  endChanges(e) {
    const t = new No(this.elem, { d: this.last_d }, e);
    AA.endChanges({ cmd: t, elem: this.elem });
  }
  /**
  * @param {Integer|Integer[]} indexes
  * @returns {void}
  */
  addPtsToSelection(e) {
    Array.isArray(e) || (e = [e]), e.forEach((i) => {
      this.segs[i].ptgrip && !this.selected_pts.includes(i) && i >= 0 && this.selected_pts.push(i);
    }), this.selected_pts.sort();
    let t = this.selected_pts.length;
    const A = [];
    for (A.length = t; t--; ) {
      const i = this.selected_pts[t], s = this.segs[i];
      s.select(!0), A[t] = s.ptgrip;
    }
    const n = Jm.subpathIsClosed(this.selected_pts[0]);
    AA.addPtsToSelection({ grips: A, closedSubpath: n });
  }
  // STATIC
  /**
  * @param {Integer} index
  * @returns {boolean}
  */
  static subpathIsClosed(e) {
    let t = !1;
    return AA.getPathObj().eachSeg(function(n) {
      return n <= e ? !0 : this.type === 2 ? !1 : this.type === 1 ? (t = !0, !1) : !0;
    }), t;
  }
}
let De = null, Me = null;
const q4 = (r) => {
  De = r;
}, z4 = function(r, e) {
  const { pathSegList: t } = r, A = t.numberOfItems;
  let n = 0, i = 0, s = "", a = null;
  for (let o = 0; o < A; ++o) {
    const l = t.getItem(o);
    let u = l.x || 0, h = l.y || 0, f = l.x1 || 0, c = l.y1 || 0, p = l.x2 || 0, g = l.y2 || 0, v = l.pathSegTypeAsLetter;
    switch (v) {
      case "z":
      // z,Z closepath (Z/z)
      case "Z":
        s += "z", a && !e && (n = a[0], i = a[1]);
        break;
      case "H":
        u -= n;
      // Fallthrough
      case "h":
        e ? (h = 0, n += u, v = "l") : (h = i, u += n, n = u, v = "L"), s += ua(v, [[u, h]]);
        break;
      case "V":
        h -= i;
      // Fallthrough
      case "v":
        e ? (u = 0, i += h, v = "l") : (u = n, h += i, i = h, v = "L"), s += ua(v, [[u, h]]);
        break;
      case "M":
      // absolute move (M)
      case "L":
      // absolute line (L)
      case "T":
        u -= n, h -= i;
      // Fallthrough
      case "l":
      // relative line (l)
      case "m":
      // relative move (m)
      case "t":
        e ? (n += u, i += h, v = v.toLowerCase()) : (u += n, h += i, n = u, i = h, v = v.toUpperCase()), (v === "m" || v === "M") && (a = [n, i]), s += ua(v, [[u, h]]);
        break;
      case "C":
        u -= n, f -= n, p -= n, h -= i, c -= i, g -= i;
      // Fallthrough
      case "c":
        e ? (n += u, i += h, v = "c") : (u += n, f += n, p += n, h += i, c += i, g += i, n = u, i = h, v = "C"), s += ua(v, [[f, c], [p, g], [u, h]]);
        break;
      case "Q":
        u -= n, f -= n, h -= i, c -= i;
      // Fallthrough
      case "q":
        e ? (n += u, i += h, v = "q") : (u += n, f += n, h += i, c += i, n = u, i = h, v = "Q"), s += ua(v, [[f, c], [u, h]]);
        break;
      case "A":
        u -= n, h -= i;
      // fallthrough
      case "a":
        e ? (n += u, i += h, v = "a") : (u += n, h += i, n = u, i = h, v = "A"), s += ua(v, [[l.r1, l.r2]], [
          l.angle,
          l.largeArcFlag ? 1 : 0,
          l.sweepFlag ? 1 : 0
        ], [u, h]);
        break;
      case "S":
        u -= n, p -= n, h -= i, g -= i;
      // Fallthrough
      case "s":
        e ? (n += u, i += h, v = "s") : (u += n, p += n, h += i, g += i, n = u, i = h, v = "S"), s += ua(v, [[p, g], [u, h]]);
        break;
    }
  }
  return s;
};
function ua(r, e, t, A) {
  e.forEach(function(i, s) {
    e[s] = yn(i);
  });
  let n = r + e.join(" ");
  return t && (n += " " + t.join(" ")), A && (n += " " + yn(A)), n;
}
const mi = /* @__PURE__ */ (function() {
  let r = !1, e, t, A = null, n = !1;
  return (
    /** @lends module:path.pathActions */
    {
      /**
      * @param {MouseEvent} evt
      * @param {Element} mouseTarget
      * @param {Float} startX
      * @param {Float} startY
      * @returns {boolean|void}
      */
      mouseDown(s, a, o, l) {
        let u;
        if (De.getCurrentMode() === "path") {
          let f = o, c = l;
          const p = De.getZoom();
          let g = f / p, v = c / p, w = Xt("path_stretch_line");
          e = [g, v], De.getGridSnapping() && (g = Ot(g), v = Ot(v), f = Ot(f), c = Ot(c)), w || (w = document.createElementNS(nt.SVG, "path"), qt(w, {
            id: "path_stretch_line",
            stroke: "#22C",
            "stroke-width": "0.5",
            fill: "none"
          }), Xt("selectorParentGroup").append(w)), w.setAttribute("display", "inline");
          let B = null, S;
          const C = De.getDrawnPath();
          if (C) {
            const E = C.pathSegList;
            let _ = E.numberOfItems;
            const I = 6 / p;
            let O = !1;
            for (; _; ) {
              _--;
              const D = E.getItem(_), R = D.x, J = D.y;
              if (g >= R - I && g <= R + I && v >= J - I && v <= J + I) {
                O = !0;
                break;
              }
            }
            u = De.getId(), De.removePath_(u);
            const U = Xt(u);
            let V, F;
            const P = E.numberOfItems;
            if (O) {
              if (_ <= 1 && P >= 2) {
                const D = E.getItem(0).x, R = E.getItem(0).y;
                F = w.pathSegList.getItem(1), V = F.pathSegType === 4 ? C.createSVGPathSegLinetoAbs(D, R) : C.createSVGPathSegCurvetoCubicAbs(D, R, F.x1 / p, F.y1 / p, D, R);
                const J = C.createSVGPathSegClosePath();
                E.appendItem(V), E.appendItem(J);
              } else if (P < 3)
                return B = !1, B;
              if (w.remove(), De.setDrawnPath(null), De.setStarted(!1), r) {
                Me.matrix && De.remapElement(U, {}, Me.matrix.inverse());
                const D = U.getAttribute("d"), R = Me.elem.getAttribute("d");
                return Me.elem.setAttribute("d", R + D), U.parentNode.removeChild(U), Me.matrix && De.recalcRotatedPath(), mi.toEditMode(Me.elem), Me.selectPt(), !1;
              }
            } else {
              if (!(De.getContainer() !== De.getMouseTarget(s) && De.getContainer().contains(
                De.getMouseTarget(s)
              )))
                return !1;
              const D = C.pathSegList.numberOfItems, R = C.pathSegList.getItem(D - 1), J = R.x, ie = R.y;
              s.shiftKey && ({ x: g, y: v } = O0(J, ie, g, v)), F = w.pathSegList.getItem(1), V = F.pathSegType === 4 ? C.createSVGPathSegLinetoAbs(De.round(g), De.round(v)) : C.createSVGPathSegCurvetoCubicAbs(
                De.round(g),
                De.round(v),
                F.x1 / p,
                F.y1 / p,
                F.x2 / p,
                F.y2 / p
              ), C.pathSegList.appendItem(V), g *= p, v *= p, w.setAttribute("d", ["M", g, v, g, v].join(" ")), S = D, r && (S += Me.segs.length), De.addPointGrip(S, g, v);
            }
          } else {
            const E = "M" + g + "," + v + " ";
            De.setDrawnPath(De.addSVGElementsFromJson({
              element: "path",
              curStyles: !0,
              attr: {
                d: E,
                id: De.getNextId(),
                opacity: De.getOpacity() / 2
              }
            })), w.setAttribute("d", ["M", f, c, f, c].join(" ")), S = r ? Me.segs.length : 0, De.addPointGrip(S, f, c);
          }
          return;
        }
        if (!Me)
          return;
        Me.storeD(), { id: u } = s.target;
        let h;
        if (u.substr(0, 14) === "pathpointgrip_") {
          h = Me.cur_pt = Number.parseInt(u.substr(14)), Me.dragging = [o, l];
          const f = Me.segs[h];
          s.shiftKey ? f.selected ? Me.removePtFromSelection(h) : Me.addPtsToSelection(h) : ((Me.selected_pts.length <= 1 || !f.selected) && Me.clearSelection(), Me.addPtsToSelection(h));
        } else if (u.startsWith("ctrlpointgrip_")) {
          Me.dragging = [o, l];
          const f = u.split("_")[1].split("c");
          h = Number(f[0]);
          const c = Number(f[1]);
          Me.selectPt(h, c);
        }
        if (!Me.dragging) {
          let f = De.getRubberBox();
          f || (f = De.setRubberBox(
            De.selectorManager.getRubberBandBox()
          ));
          const c = De.getZoom();
          qt(f, {
            x: o * c,
            y: l * c,
            width: 0,
            height: 0,
            display: "inline"
          });
        }
      },
      /**
      * @param {Float} mouseX
      * @param {Float} mouseY
      * @returns {void}
      */
      mouseMove(s, a) {
        const o = De.getZoom();
        n = !0;
        const l = De.getDrawnPath();
        if (De.getCurrentMode() === "path") {
          if (!l)
            return;
          const u = l.pathSegList, h = u.numberOfItems - 1;
          if (e) {
            const f = De.addCtrlGrip("1c1"), c = De.addCtrlGrip("0c2");
            f.setAttribute("cx", s), f.setAttribute("cy", a), f.setAttribute("display", "inline");
            const p = e[0], g = e[1], v = s / o, w = a / o, B = p + (p - v), S = g + (g - w);
            c.setAttribute("cx", B * o), c.setAttribute("cy", S * o), c.setAttribute("display", "inline");
            const C = De.getCtrlLine(1);
            if (qt(C, {
              x1: s,
              y1: a,
              x2: B * o,
              y2: S * o,
              display: "inline"
            }), h === 0)
              t = [s, a];
            else {
              const E = u.getItem(h - 1);
              let _ = E.x, I = E.y;
              E.pathSegType === 6 ? (_ += _ - E.x2, I += I - E.y2) : t && (_ = t[0] / o, I = t[1] / o), De.replacePathSeg(6, h, [p, g, _, I, B, S], l);
            }
          } else {
            const f = Xt("path_stretch_line");
            if (f) {
              const c = u.getItem(h);
              if (c.pathSegType === 6) {
                const p = c.x + (c.x - c.x2), g = c.y + (c.y - c.y2);
                De.replacePathSeg(
                  6,
                  1,
                  [s, a, p * o, g * o, s, a],
                  f
                );
              } else t ? De.replacePathSeg(6, 1, [s, a, t[0], t[1], s, a], f) : De.replacePathSeg(4, 1, [s, a], f);
            }
          }
          return;
        }
        if (Me.dragging) {
          const u = De.getPointFromGrip({
            x: Me.dragging[0],
            y: Me.dragging[1]
          }, Me), h = De.getPointFromGrip({
            x: s,
            y: a
          }, Me), f = h.x - u.x, c = h.y - u.y;
          Me.dragging = [s, a], Me.dragctrl ? Me.moveCtrl(f, c) : Me.movePts(f, c);
        } else
          Me.selected_pts = [], Me.eachSeg(function(u) {
            const h = this;
            if (!h.next && !h.prev)
              return;
            const f = De.getRubberBox(), c = Nr(f), p = De.getGripPt(h), g = {
              x: p.x,
              y: p.y,
              width: 0,
              height: 0
            }, v = gS(c, g);
            this.select(v), v && Me.selected_pts.push(h.index);
          });
      },
      /**
       * @typedef module:path.keepElement
       * @type {PlainObject}
       * @property {boolean} keep
       * @property {Element} element
       */
      /**
      * @param {Event} evt
      * @param {Element} element
      * @param {Float} _mouseX
      * @param {Float} _mouseY
      * @returns {module:path.keepElement|void}
      */
      mouseUp(s, a, o, l) {
        const u = De.getDrawnPath();
        if (De.getCurrentMode() === "path")
          return e = null, u || (a = Xt(De.getId()), De.setStarted(!1), t = null), {
            keep: !0,
            element: a
          };
        const h = De.getRubberBox();
        if (Me.dragging) {
          const f = Me.cur_pt;
          Me.dragging = !1, Me.dragctrl = !1, Me.update(), n && Me.endChanges("Move path point(s)"), !s.shiftKey && !n && Me.selectPt(f);
        } else h?.getAttribute("display") !== "none" ? (h.setAttribute("display", "none"), h.getAttribute("width") <= 2 && h.getAttribute("height") <= 2 && mi.toSelectMode(s.target)) : mi.toSelectMode(s.target);
        n = !1;
      },
      /**
      * @param {Element} element
      * @returns {void}
      */
      toEditMode(s) {
        Me = De.getPath_(s), De.setCurrentMode("pathedit"), De.clearSelection(), Me.setPathContext(), Me.show(!0).update(), Me.oldbbox = Nr(Me.elem), r = !1;
      },
      /**
      * @param {Element} elem
      * @fires module:svgcanvas.SvgCanvas#event:selected
      * @returns {void}
      */
      toSelectMode(s) {
        const a = s === Me.elem;
        De.setCurrentMode("select"), Me.setPathContext(), Me.show(!1), A = !1, De.clearSelection(), Me.matrix && De.recalcRotatedPath(), a && (De.call("selected", [s]), De.addToSelection([s], !0));
      },
      /**
      * @param {boolean} on
      * @returns {void}
      */
      addSubPath(s) {
        s ? (De.setCurrentMode("path"), r = !0) : (mi.clear(!0), mi.toEditMode(Me.elem));
      },
      /**
      * @param {Element} target
      * @returns {void}
      */
      select(s) {
        A === s ? (mi.toEditMode(s), De.setCurrentMode("pathedit")) : A = s;
      },
      /**
      * @fires module:svgcanvas.SvgCanvas#event:changed
      * @returns {void}
      */
      reorient() {
        const s = De.getSelectedElements()[0];
        if (!s || MA(s) === 0)
          return;
        const o = new su("Reorient path"), l = {
          d: s.getAttribute("d"),
          transform: s.getAttribute("transform")
        };
        o.addSubCommand(new No(s, l)), De.clearSelection(), this.resetOrientation(s), De.addCommandToHistory(o), De.getPath_(s).show(!1).matrix = null, this.clear(), De.addToSelection([s], !0), De.call("changed", De.getSelectedElements());
      },
      /**
      * @param {boolean} remove Not in use
      * @returns {void}
      */
      clear() {
        const s = De.getDrawnPath();
        if (A = null, s) {
          const a = Xt(De.getId()), o = Xt("path_stretch_line");
          o.parentNode.removeChild(o), a.parentNode.removeChild(a);
          const u = Xt("pathpointgrip_container").querySelectorAll("*");
          Array.prototype.forEach.call(u, function(h) {
            h.setAttribute("display", "none");
          }), t = null, De.setDrawnPath(null), De.setStarted(!1);
        } else De.getCurrentMode() === "pathedit" && this.toSelectMode();
        Me && Me.init().show(!1);
      },
      /**
      * @param {?(Element|SVGPathElement)} pth
      * @returns {false|void}
      */
      resetOrientation(s) {
        if (s?.nodeName !== "path")
          return !1;
        const a = yr(s), o = vr(a).matrix;
        a.clear(), s.removeAttribute("transform");
        const l = s.pathSegList, u = l.numberOfItems;
        for (let h = 0; h < u; ++h) {
          const f = l.getItem(h), c = f.pathSegType;
          if (c === 1)
            continue;
          const p = [];
          ["", 1, 2].forEach(function(g) {
            const v = f["x" + g], w = f["y" + g];
            if (v !== void 0 && w !== void 0) {
              const B = zt(v, w, o);
              p.splice(p.length, 0, B.x, B.y);
            }
          }), De.replacePathSeg(c, h, p, s);
        }
        De.reorientGrads(s, o);
      },
      /**
      * @returns {void}
      */
      zoomChange() {
        De.getCurrentMode() === "pathedit" && Me.update();
      },
      /**
      * @typedef {PlainObject} module:path.NodePoint
      * @property {Float} x
      * @property {Float} y
      * @property {Integer} type
      */
      /**
      * @returns {module:path.NodePoint}
      */
      getNodePoint() {
        const s = Me.selected_pts.length ? Me.selected_pts[0] : 1, a = Me.segs[s];
        return {
          x: a.item.x,
          y: a.item.y,
          type: a.type
        };
      },
      /**
      * @param {boolean} linkPoints
      * @returns {void}
      */
      linkControlPoints(s) {
        De.setLinkControlPoints(s);
      },
      /**
      * @returns {void}
      */
      clonePathNode() {
        Me.storeD();
        const s = Me.selected_pts;
        let a = s.length;
        const o = [];
        for (; a--; ) {
          const l = s[a];
          Me.addSeg(l), o.push(l + a), o.push(l + a + 1);
        }
        Me.init().addPtsToSelection(o), Me.endChanges("Clone path node(s)");
      },
      /**
      * @returns {void}
      */
      opencloseSubPath() {
        const s = Me.selected_pts;
        if (s.length !== 1)
          return;
        const { elem: a } = Me, o = a.pathSegList, l = s[0];
        let u = null, h = null;
        if (Me.eachSeg(function(w) {
          return this.type === 2 && w <= l && (h = this.item), w <= l ? !0 : this.type === 2 ? (u = w, !1) : this.type === 1 ? (u = !1, !1) : !0;
        }), u || (u = Me.segs.length - 1), u !== !1) {
          const w = a.createSVGPathSegLinetoAbs(h.x, h.y), B = a.createSVGPathSegClosePath();
          u === Me.segs.length - 1 ? (o.appendItem(w), o.appendItem(B)) : (o.insertItemBefore(B, u), o.insertItemBefore(w, u)), Me.init().selectPt(u + 1);
          return;
        }
        if (Me.segs[l].mate) {
          o.removeItem(l), o.removeItem(l), Me.init().selectPt(l - 1);
          return;
        }
        let c, p;
        for (let w = 0; w < o.numberOfItems; w++) {
          const B = o.getItem(w);
          if (B.pathSegType === 2)
            c = w;
          else if (w === l)
            o.removeItem(c);
          else if (B.pathSegType === 1 && l < w) {
            p = w - 1, o.removeItem(w);
            break;
          }
        }
        let g = l - c - 1;
        for (; g--; )
          o.insertItemBefore(o.getItem(c), p);
        const v = o.getItem(c);
        De.replacePathSeg(2, c, [v.x, v.y]), Me.init().selectPt(0);
      },
      /**
      * @returns {void}
      */
      deletePathNode() {
        if (!mi.canDeleteNodes)
          return;
        Me.storeD();
        const s = Me.selected_pts;
        let a = s.length;
        for (; a--; ) {
          const l = s[a];
          Me.deleteSeg(l);
        }
        const o = function() {
          const l = Me.elem.pathSegList;
          let u = l.numberOfItems;
          const h = function(f, c) {
            for (; c--; )
              l.removeItem(f);
          };
          if (u <= 1)
            return !0;
          for (; u--; ) {
            const f = l.getItem(u);
            if (f.pathSegType === 1) {
              const c = l.getItem(u - 1), p = l.getItem(u - 2);
              if (c.pathSegType === 2) {
                h(u - 1, 2), o();
                break;
              } else if (p.pathSegType === 2) {
                h(u - 2, 3), o();
                break;
              }
            } else if (f.pathSegType === 2 && u > 0) {
              const c = l.getItem(u - 1).pathSegType;
              if (c === 2) {
                h(u - 1, 1), o();
                break;
              } else if (c === 1 && l.numberOfItems - 1 === u) {
                h(u, 1), o();
                break;
              }
            }
          }
          return !1;
        };
        if (o(), Me.elem.pathSegList.numberOfItems <= 1) {
          mi.toSelectMode(Me.elem), De.canvas.deleteSelectedElements();
          return;
        }
        Me.init(), Me.clearSelection(), window.opera && Me.elem.setAttribute("d", Me.elem.getAttribute("d")), Me.endChanges("Delete path node(s)");
      },
      // Can't seem to use `@borrows` here, so using `@see`
      /**
      * Smooth polyline into path.
      * @function module:path.pathActions.smoothPolylineIntoPath
      * @see module:path~smoothPolylineIntoPath
      */
      smoothPolylineIntoPath: function(s) {
        let a;
        const { points: o } = s, l = o.numberOfItems;
        if (l >= 4) {
          let u = o.getItem(0), h = null, f = [];
          for (f.push(["M", u.x, ",", u.y, " C"].join("")), a = 1; a <= l - 4; a += 3) {
            let c = o.getItem(a);
            const p = o.getItem(a + 1), g = o.getItem(a + 2);
            if (h) {
              const v = De.smoothControlPoints(h, c, u);
              if (v?.length === 2) {
                const w = f[f.length - 1].split(",");
                w[2] = v[0].x, w[3] = v[0].y, f[f.length - 1] = w.join(","), c = v[1];
              }
            }
            f.push([c.x, c.y, p.x, p.y, g.x, g.y].join(",")), u = g, h = p;
          }
          for (f.push("L"); a < l; ) {
            const c = o.getItem(a);
            f.push([c.x, c.y].join(",")), a++;
          }
          f = f.join(" "), s = De.addSVGElementsFromJson({
            element: "path",
            curStyles: !0,
            attr: {
              id: De.getId(),
              d: f,
              fill: "none"
            }
          });
        }
        return s;
      },
      /* eslint-enable  */
      /**
      * @param {?Integer} v See {@link https://www.w3.org/TR/SVG/single-page.html#paths-InterfaceSVGPathSeg}
      * @returns {void}
      */
      setSegType(s) {
        Me?.setSegType(s);
      },
      /**
      * @param {string} attr
      * @param {Float} newValue
      * @returns {void}
      */
      moveNode(s, a) {
        const o = Me.selected_pts;
        if (!o.length)
          return;
        Me.storeD();
        const l = Me.segs[o[0]], u = { x: 0, y: 0 };
        u[s] = a - l.item[s], l.move(u.x, u.y), Me.endChanges("Move path point");
      },
      /**
      * @param {Element} elem
      * @returns {void}
      */
      fixEnd(s) {
        const a = s.pathSegList, o = a.numberOfItems;
        let l;
        for (let u = 0; u < o; ++u) {
          const h = a.getItem(u);
          if (h.pathSegType === 2 && (l = h), h.pathSegType === 1) {
            const f = a.getItem(u - 1);
            if (f.x !== l.x || f.y !== l.y) {
              const c = s.createSVGPathSegLinetoAbs(l.x, l.y);
              a.insertItemBefore(c, u), mi.fixEnd(s);
              break;
            }
          }
        }
      },
      // Can't seem to use `@borrows` here, so using `@see`
      /**
      * Convert a path to one with only absolute or relative values.
      * @function module:path.pathActions.convertPath
      * @see module:path.convertPath
      */
      convertPath: z4
    }
  );
})();
const W4 = {
  2: ["x", "y"],
  // PATHSEG_MOVETO_ABS
  4: ["x", "y"],
  // PATHSEG_LINETO_ABS
  6: ["x", "y", "x1", "y1", "x2", "y2"],
  // PATHSEG_CURVETO_CUBIC_ABS
  8: ["x", "y", "x1", "y1"],
  // PATHSEG_CURVETO_QUADRATIC_ABS
  10: ["x", "y", "r1", "r2", "angle", "largeArcFlag", "sweepFlag"],
  // PATHSEG_ARC_ABS
  12: ["x"],
  // PATHSEG_LINETO_HORIZONTAL_ABS
  14: ["y"],
  // PATHSEG_LINETO_VERTICAL_ABS
  16: ["x", "y", "x2", "y2"],
  // PATHSEG_CURVETO_CUBIC_SMOOTH_ABS
  18: ["x", "y"]
  // PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS
};
let _r;
const LS = {}, NS = (r) => {
  Object.assign(LS, r.ui);
};
let ac = [], TS = !0, zl = {};
const PS = (r) => {
  TS = r;
};
let Wl = null;
const OS = (r) => {
  _r = r, _r.replacePathSeg = rn, _r.addPointGrip = Wm, _r.removePath_ = $m, _r.getPath_ = HS, _r.addCtrlGrip = Xm, _r.getCtrlLine = Ym, _r.getGripPt = MS, _r.getPointFromGrip = IS, _r.setLinkControlPoints = PS, _r.reorientGrads = GS, _r.getSegData = () => W4, _r.getUIStrings = () => LS, _r.getPathObj = () => Wl, _r.setPathObj = (t) => {
    Wl = t;
  }, _r.getPathFuncs = () => ac, _r.getLinkControlPts = () => TS, ac = [0, "ClosePath"], [
    "Moveto",
    "Lineto",
    "CurvetoCubic",
    "CurvetoQuadratic",
    "Arc",
    "LinetoHorizontal",
    "LinetoVertical",
    "CurvetoCubicSmooth",
    "CurvetoQuadraticSmooth"
  ].forEach((t) => {
    ac.push(t + "Abs"), ac.push(t + "Rel");
  }), q4(_r), K4(_r);
}, X4 = zm, MS = Ia, Y4 = IS, J4 = Wm, $4 = Oa, Z4 = Xm, e_ = Ym, t_ = QS, r_ = zc, RS = rn, A_ = k0, kS = (r, e, t) => {
  const A = r.x - t.x, n = r.y - t.y, i = e.x - t.x, s = e.y - t.y;
  if ((A !== 0 || n !== 0) && (i !== 0 || s !== 0)) {
    const a = Math.sqrt(A * A + n * n), o = Math.sqrt(i * i + s * s), l = _r.getSvgRoot().createSVGPoint(), u = _r.getSvgRoot().createSVGPoint();
    let h = Math.atan2(n, A), f = Math.atan2(s, i);
    h < 0 && (h += 2 * Math.PI), f < 0 && (f += 2 * Math.PI);
    const c = Math.abs(h - f), p = Math.abs(Math.PI - c) / 2;
    let g, v;
    return h - f > 0 ? (g = c < Math.PI ? h + p : h - p, v = c < Math.PI ? f - p : f + p) : (g = c < Math.PI ? h - p : h + p, v = c < Math.PI ? f + p : f - p), l.x = a * Math.cos(g) + t.x, l.y = a * Math.sin(g) + t.y, u.x = o * Math.cos(v) + t.x, u.y = o * Math.sin(v) + t.y, [l, u];
  }
}, HS = (r) => {
  let e = zl[r.id];
  return e || (e = zl[r.id] = new Jm(r)), e;
}, $m = (r) => {
  r in zl && delete zl[r];
};
let mo, vo, Pl, Ol, wo;
const Kf = (r, e) => {
  let t = r - Pl, A = e - Ol, n = Math.sqrt(t * t + A * A), i = Math.atan2(A, t) + wo;
  return t = n * Math.cos(i) + Pl, A = n * Math.sin(i) + Ol, t -= mo, A -= vo, n = Math.sqrt(t * t + A * A), i = Math.atan2(A, t) - wo, {
    x: n * Math.cos(i) + mo,
    y: n * Math.sin(i) + vo
  };
}, n_ = () => {
  const r = Wl.elem;
  if (wo = MA(r, !0), !wo)
    return;
  const e = Wl.oldbbox;
  Pl = e.x + e.width / 2, Ol = e.y + e.height / 2;
  const t = Nr(r);
  mo = t.x + t.width / 2, vo = t.y + t.height / 2;
  const A = mo - Pl, n = vo - Ol, i = Math.sqrt(A * A + n * n), s = Math.atan2(n, A) + wo;
  mo = i * Math.cos(s) + Pl, vo = i * Math.sin(s) + Ol;
  const a = r.pathSegList;
  let o = a.numberOfItems;
  for (; o; ) {
    o -= 1;
    const h = a.getItem(o), f = h.pathSegType;
    if (f === 1)
      continue;
    const c = Kf(h.x, h.y), p = [c.x, c.y];
    if (h.x1 && h.x2) {
      const g = Kf(h.x1, h.y1), v = Kf(h.x2, h.y2);
      p.splice(p.length, 0, g.x, g.y, v.x, v.y);
    }
    RS(f, o, p);
  }
  Nr(r);
  const l = _r.getSvgRoot().createSVGTransform(), u = yr(r);
  l.setRotate(wo * 180 / Math.PI, mo, vo), u.replaceItem(l, 0);
}, DS = () => {
  zl = {};
}, GS = (r, e) => {
  const t = Nr(r);
  for (let A = 0; A < 2; A++) {
    const n = A === 0 ? "fill" : "stroke", i = r.getAttribute(n);
    if (i && i.startsWith("url(")) {
      const s = Ua(i);
      if (s.tagName === "linearGradient") {
        let a = s.getAttribute("x1") || 0, o = s.getAttribute("y1") || 0, l = s.getAttribute("x2") || 1, u = s.getAttribute("y2") || 0;
        a = t.width * a + t.x, o = t.height * o + t.y, l = t.width * l + t.x, u = t.height * u + t.y;
        const h = zt(a, o, e), f = zt(l, u, e), c = {
          x1: (h.x - t.x) / t.width,
          y1: (h.y - t.y) / t.height,
          x2: (f.x - t.x) / t.width,
          y2: (f.y - t.y) / t.height
        }, p = s.cloneNode(!0);
        for (const [g, v] of Object.entries(c))
          p.setAttribute(g, v);
        p.id = _r.getNextId(), Cn().append(p), r.setAttribute(n, "url(#" + p.id + ")");
      }
    }
  }
}, i_ = [
  0,
  "z",
  "M",
  "m",
  "L",
  "l",
  "C",
  "c",
  "Q",
  "q",
  "A",
  "a",
  "H",
  "h",
  "V",
  "v",
  "S",
  "s",
  "T",
  "t"
], s_ = (r, e) => {
  const { pathSegList: t } = r, A = t.numberOfItems;
  let n = 0, i = 0, s = "", a = null;
  for (let o = 0; o < A; ++o) {
    const l = t.getItem(o);
    let u = l.x || 0, h = l.y || 0, f = l.x1 || 0, c = l.y1 || 0, p = l.x2 || 0, g = l.y2 || 0;
    const v = l.pathSegType;
    let w = i_[v][e ? "toLowerCase" : "toUpperCase"]();
    switch (v) {
      case 1:
        s += "z", a && !e && (n = a[0], i = a[1]);
        break;
      case 12:
        u -= n;
      // Fallthrough
      case 13:
        e ? (h = 0, n += u, w = "l") : (h = i, u += n, n = u, w = "L"), s += ca(w, [[u, h]]);
        break;
      case 14:
        h -= i;
      // Fallthrough
      case 15:
        e ? (u = 0, i += h, w = "l") : (u = n, h += i, i = h, w = "L"), s += ca(w, [[u, h]]);
        break;
      case 2:
      // absolute move (M)
      case 4:
      // absolute line (L)
      case 18:
      // absolute smooth quad (T)
      case 10:
        u -= n, h -= i;
      // Fallthrough
      case 5:
      // relative line (l)
      case 3:
      // relative move (m)
      case 19:
        e ? (n += u, i += h) : (u += n, h += i, n = u, i = h), (v === 2 || v === 3) && (a = [n, i]), s += ca(w, [[u, h]]);
        break;
      case 6:
        u -= n, f -= n, p -= n, h -= i, c -= i, g -= i;
      // Fallthrough
      case 7:
        e ? (n += u, i += h) : (u += n, f += n, p += n, h += i, c += i, g += i, n = u, i = h), s += ca(w, [[f, c], [p, g], [u, h]]);
        break;
      case 8:
        u -= n, f -= n, h -= i, c -= i;
      // Fallthrough
      case 9:
        e ? (n += u, i += h) : (u += n, f += n, h += i, c += i, n = u, i = h), s += ca(w, [[f, c], [u, h]]);
        break;
      // Fallthrough
      case 11:
        e ? (n += u, i += h) : (u += n, h += i, n = u, i = h), s += ca(w, [[l.r1, l.r2]], [
          l.angle,
          l.largeArcFlag ? 1 : 0,
          l.sweepFlag ? 1 : 0
        ], [u, h]);
        break;
      case 16:
        u -= n, p -= n, h -= i, g -= i;
      // Fallthrough
      case 17:
        e ? (n += u, i += h) : (u += n, p += n, h += i, g += i, n = u, i = h), s += ca(w, [[p, g], [u, h]]);
        break;
    }
  }
  return s;
}, ca = (r, e, t, A) => {
  e.forEach((i, s) => {
    e[s] = yn(i);
  });
  let n = r + e.join(" ");
  return t && (n += " " + t.join(" ")), A && (n += " " + yn(A)), n;
}, a_ = mi, VS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  addCtrlGrip: Z4,
  addPointGrip: J4,
  clearData: DS,
  convertPath: s_,
  getControlPoints: r_,
  getCtrlLine: e_,
  getGripContainer: $4,
  getGripPt: MS,
  getPath_: HS,
  getPointFromGrip: Y4,
  getPointGrip: t_,
  getSegSelector: A_,
  init: OS,
  get path() {
    return Wl;
  },
  pathActions: a_,
  ptObjToArr: X4,
  recalcRotatedPath: n_,
  removePath_: $m,
  reorientGrads: GS,
  replacePathSeg: RS,
  setLinkControlPoints: PS,
  setUiStrings: NS,
  smoothControlPoints: kS
}, Symbol.toStringTag, { value: "Module" }));
class Bn {
  /**
  * @param {string} name - Layer name
  * @param {SVGGElement|null} group - An existing SVG group element or null.
  *     If group and no svgElem, use group for this layer.
  *     If group and svgElem, create a new group element and insert it in the DOM after group.
  *     If no group and svgElem, create a new group element and insert it in the DOM as the last layer.
  * @param {SVGGElement} [svgElem] - The SVG DOM element. If defined, use this to add
  *     a new layer to the document.
  */
  constructor(e, t, A) {
    if (this.name_ = e, this.group_ = A ? null : t, A) {
      const n = A.ownerDocument;
      this.group_ = n.createElementNS(nt.SVG, "g");
      const i = n.createElementNS(nt.SVG, "title");
      i.textContent = e, this.group_.append(i), t ? t.insertAdjacentElement("afterend", this.group_) : A.append(this.group_);
    }
    o_(this.group_), rs(this.group_, function(n) {
      n.setAttribute("style", "pointer-events:inherit");
    }), this.group_.setAttribute("style", A ? "pointer-events:all" : "pointer-events:none");
  }
  /**
   * Get the layer's name.
   * @returns {string} The layer name
   */
  getName() {
    return this.name_;
  }
  /**
   * Get the group element for this layer.
   * @returns {SVGGElement} The layer SVG group
   */
  getGroup() {
    return this.group_;
  }
  /**
   * Active this layer so it takes pointer events.
   * @returns {void}
   */
  activate() {
    this.group_.setAttribute("style", "pointer-events:all");
  }
  /**
   * Deactive this layer so it does NOT take pointer events.
   * @returns {void}
   */
  deactivate() {
    this.group_.setAttribute("style", "pointer-events:none");
  }
  /**
   * Set this layer visible or hidden based on 'visible' parameter.
   * @param {boolean} visible - If true, make visible; otherwise, hide it.
   * @returns {void}
   */
  setVisible(e) {
    const t = e === void 0 || e ? "inline" : "none";
    this.group_.getAttribute("display") !== t && this.group_.setAttribute("display", t);
  }
  /**
   * Is this layer visible?
   * @returns {boolean} True if visible.
   */
  isVisible() {
    return this.group_.getAttribute("display") !== "none";
  }
  /**
   * Get layer opacity.
   * @returns {Float} Opacity value.
   */
  getOpacity() {
    const e = this.group_.getAttribute("opacity");
    return e ? Number.parseFloat(e) : 1;
  }
  /**
   * Sets the opacity of this layer. If opacity is not a value between 0.0 and 1.0,
   * nothing happens.
   * @param {Float} opacity - A float value in the range 0.0-1.0
   * @returns {void}
   */
  setOpacity(e) {
    typeof e == "number" && e >= 0 && e <= 1 && this.group_.setAttribute("opacity", e);
  }
  /**
   * Append children to this layer.
   * @param {SVGGElement} children - The children to append to this layer.
   * @returns {void}
   */
  appendChildren(e) {
    for (const t of e)
      this.group_.append(t);
  }
  /**
  * @returns {SVGTitleElement|null}
  */
  getTitleElement() {
    const e = this.group_.childNodes.length;
    for (let t = 0; t < e; ++t) {
      const A = this.group_.childNodes.item(t);
      if (A?.tagName === "title")
        return A;
    }
    return null;
  }
  /**
   * Set the name of this layer.
   * @param {string} name - The new name.
   * @param {module:history.HistoryRecordingService} hrService - History recording service
   * @returns {string|null} The new name if changed; otherwise, null.
   */
  setName(e, t) {
    const A = this.name_;
    e = Tl(e);
    const n = this.getTitleElement();
    if (n) {
      for (; n.firstChild; )
        n.removeChild(n.firstChild);
      return n.textContent = e, this.name_ = e, t && t.changeElement(n, { "#text": A }), this.name_;
    }
    return null;
  }
  /**
   * Remove this layer's group from the DOM. No more functions on group can be called after this.
   * @returns {SVGGElement} The layer SVG group that was just removed.
   */
  removeGroup() {
    const e = this.group_;
    return this.group_.remove(), this.group_ = void 0, e;
  }
  /**
   * Test whether an element is a layer or not.
   * @param {SVGGElement} elem - The SVGGElement to test.
   * @returns {boolean} True if the element is a layer
   */
  static isLayer(e) {
    return e && e.tagName === "g" && Bn.CLASS_REGEX.test(e.getAttribute("class"));
  }
}
Bn.CLASS_NAME = "layer";
Bn.CLASS_REGEX = new RegExp("(\\s|^)" + Bn.CLASS_NAME + "(\\s|$)");
function o_(r) {
  const e = r.getAttribute("class");
  !e || !e.length ? r.setAttribute("class", Bn.CLASS_NAME) : Bn.CLASS_REGEX.test(e) || r.setAttribute("class", e + " " + Bn.CLASS_NAME);
}
class H0 {
  /**
  * @param {history.UndoManager|null} undoManager - The undo manager.
  *     A value of `null` is valid for cases where no history recording is required.
  *     See singleton: {@link module:history.HistoryRecordingService.HistoryRecordingService.NO_HISTORY}
  */
  constructor(e) {
    this.undoManager_ = e, this.currentBatchCommand_ = null, this.batchCommandStack_ = [];
  }
  /**
   * Start a batch command so multiple commands can recorded as a single history command.
   * Requires a corresponding call to endBatchCommand. Start and end commands can be nested.
   *
   * @param {string} text - Optional string describing the batch command.
   * @returns {module:history.HistoryRecordingService}
   */
  startBatchCommand(e) {
    return this.undoManager_ ? (this.currentBatchCommand_ = new su(e), this.batchCommandStack_.push(this.currentBatchCommand_), this) : this;
  }
  /**
   * End a batch command and add it to the history or a parent batch command.
   * @returns {module:history.HistoryRecordingService}
   */
  endBatchCommand() {
    if (!this.undoManager_)
      return this;
    if (this.currentBatchCommand_) {
      const e = this.currentBatchCommand_;
      this.batchCommandStack_.pop();
      const { length: t } = this.batchCommandStack_;
      this.currentBatchCommand_ = t ? this.batchCommandStack_[t - 1] : null, this.addCommand_(e);
    }
    return this;
  }
  /**
   * Add a `MoveElementCommand` to the history or current batch command.
   * @param {Element} elem - The DOM element that was moved
   * @param {Element} oldNextSibling - The element's next sibling before it was moved
   * @param {Element} oldParent - The element's parent before it was moved
   * @param {string} [text] - An optional string visible to user related to this change
   * @returns {module:history.HistoryRecordingService}
   */
  moveElement(e, t, A, n) {
    return this.undoManager_ ? (this.addCommand_(new FS(e, t, A, n)), this) : this;
  }
  /**
   * Add an `InsertElementCommand` to the history or current batch command.
   * @param {Element} elem - The DOM element that was added
   * @param {string} [text] - An optional string visible to user related to this change
   * @returns {module:history.HistoryRecordingService}
   */
  insertElement(e, t) {
    return this.undoManager_ ? (this.addCommand_(new _S(e, t)), this) : this;
  }
  /**
   * Add a `RemoveElementCommand` to the history or current batch command.
   * @param {Element} elem - The DOM element that was removed
   * @param {Element} oldNextSibling - The element's next sibling before it was removed
   * @param {Element} oldParent - The element's parent before it was removed
   * @param {string} [text] - An optional string visible to user related to this change
   * @returns {module:history.HistoryRecordingService}
   */
  removeElement(e, t, A, n) {
    return this.undoManager_ ? (this.addCommand_(new US(e, t, A, n)), this) : this;
  }
  /**
   * Add a `ChangeElementCommand` to the history or current batch command.
   * @param {Element} elem - The DOM element that was changed
   * @param {module:history.CommandAttributes} attrs - An object with the attributes to be changed and the values they had *before* the change
   * @param {string} [text] - An optional string visible to user related to this change
   * @returns {module:history.HistoryRecordingService}
   */
  changeElement(e, t, A) {
    return this.undoManager_ ? (this.addCommand_(new No(e, t, A)), this) : this;
  }
  /**
   * Private function to add a command to the history or current batch command.
   * @private
   * @param {Command} cmd
   * @returns {module:history.HistoryRecordingService|void}
   */
  addCommand_(e) {
    if (!this.undoManager_)
      return this;
    this.currentBatchCommand_ ? this.currentBatchCommand_.addSubCommand(e) : this.undoManager_.addCommandToHistory(e);
  }
}
H0.NO_HISTORY = new H0();
const KS = function(r, e) {
  const t = document.createElementNS(r.namespaceURI, r.nodeName);
  if (Object.values(r.attributes).forEach((A) => {
    t.setAttributeNS(A.namespaceURI, A.nodeName, A.value);
  }), t.removeAttribute("id"), t.id = e(), r.childNodes.forEach(function(A) {
    switch (A.nodeType) {
      case 1:
        t.append(KS(A, e));
        break;
      case 3:
        t.textContent = A.nodeValue;
        break;
    }
  }), r.dataset.gsvg)
    t.dataset.gsvg = t.firstChild;
  else if (r.dataset.symbol) {
    const A = r.dataset.symbol;
    t.dataset.ref = A, t.dataset.symbol = A;
  } else t.tagName === "image" && qm(t);
  return t;
};
const l_ = "a,circle,ellipse,foreignObject,g,image,line,path,polygon,polyline,rect,svg,text,tspan,use".split(
  ","
), ya = {
  LET_DOCUMENT_DECIDE: 0,
  ALWAYS_RANDOMIZE: 1,
  NEVER_RANDOMIZE: 2
};
let Ml = ya.LET_DOCUMENT_DECIDE, Wc = [];
function au(r) {
  return r || new H0(bt.undoMgr);
}
function u_(r) {
  const e = r.querySelector("title");
  return e ? e.textContent : "";
}
function c_(r) {
  return r.classList.contains("layer");
}
function jf(r) {
  let e = 1;
  for (; r.includes(`Layer ${e}`); )
    e++;
  return `Layer ${e}`;
}
class D0 {
  /**
   * @param {SVGSVGElement} svgElem - The SVG DOM Element that this JS object
   *     encapsulates.  If the svgElem has a se:nonce attribute on it, then
   *     IDs will use the nonce as they are generated.
   * @param {string} [optIdPrefix=svg_] - The ID prefix to use.
   * @throws {Error} If not initialized with an SVG element
   */
  constructor(e, t) {
    if (!e || !e.tagName || !e.namespaceURI || e.tagName !== "svg" || e.namespaceURI !== nt.SVG)
      throw new Error(
        "Error: svgedit.draw.Drawing instance initialized without a <svg> element"
      );
    this.svgElem_ = e, this.obj_num = 0, this.idPrefix = t || "svg_", this.releasedNums = [], this.all_layers = [], this.layer_map = {}, this.current_layer = null, this.nonce_ = "";
    const A = this.svgElem_.getAttributeNS(nt.SE, "nonce");
    A && Ml !== ya.NEVER_RANDOMIZE ? this.nonce_ = A : Ml === ya.ALWAYS_RANDOMIZE && this.setNonce(Math.floor(Math.random() * 100001));
  }
  /**
   * @param {string} id Element ID to retrieve
   * @returns {Element} SVG element within the root SVGSVGElement
   */
  getElem_(e) {
    return this.svgElem_.querySelector ? this.svgElem_.querySelector("#" + e) : this.svgElem_.querySelector("[id=" + e + "]");
  }
  /**
   * @returns {SVGSVGElement}
   */
  getSvgElem() {
    return this.svgElem_;
  }
  /**
   * @returns {!(string|Integer)} The previously set nonce
   */
  getNonce() {
    return this.nonce_;
  }
  /**
   * @param {!(string|Integer)} n The nonce to set
   * @returns {void}
   */
  setNonce(e) {
    this.svgElem_.setAttributeNS(nt.XMLNS, "xmlns:se", nt.SE), this.svgElem_.setAttributeNS(nt.SE, "se:nonce", e), this.nonce_ = e;
  }
  /**
   * Clears any previously set nonce.
   * @returns {void}
   */
  clearNonce() {
    this.nonce_ = "";
  }
  /**
   * Returns the latest object id as a string.
   * @returns {string} The latest object Id.
   */
  getId() {
    return this.nonce_ ? this.idPrefix + this.nonce_ + "_" + this.obj_num : this.idPrefix + this.obj_num;
  }
  /**
   * Returns the next object Id as a string.
   * @returns {string} The next object Id to use.
   */
  getNextId() {
    const e = this.obj_num;
    let t = !1;
    this.releasedNums.length > 0 ? (this.obj_num = this.releasedNums.pop(), t = !0) : this.obj_num++;
    let A = this.getId();
    for (; this.getElem_(A); )
      t && (this.obj_num = e, t = !1), this.obj_num++, A = this.getId();
    return t && (this.obj_num = e), A;
  }
  /**
   * Releases the object Id, letting it be used as the next id in getNextId().
   * This method DOES NOT remove any elements from the DOM, it is expected
   * that client code will do this.
   * @param {string} id - The id to release.
   * @returns {boolean} True if the id was valid to be released, false otherwise.
   */
  releaseId(e) {
    const t = this.idPrefix + (this.nonce_ ? this.nonce_ + "_" : "");
    if (typeof e != "string" || !e.startsWith(t))
      return !1;
    const A = Number.parseInt(e.substr(t.length));
    return typeof A != "number" || A <= 0 || this.releasedNums.includes(A) ? !1 : (this.releasedNums.push(A), !0);
  }
  /**
   * Returns the number of layers in the current drawing.
   * @returns {Integer} The number of layers in the current drawing.
   */
  getNumLayers() {
    return this.all_layers.length;
  }
  /**
   * Check if layer with given name already exists.
   * @param {string} name - The layer name to check
   * @returns {boolean}
   */
  hasLayer(e) {
    return this.layer_map[e] !== void 0;
  }
  /**
   * Returns the name of the ith layer. If the index is out of range, an empty string is returned.
   * @param {Integer} i - The zero-based index of the layer you are querying.
   * @returns {string} The name of the ith layer (or the empty string if none found)
   */
  getLayerName(e) {
    return e >= 0 && e < this.getNumLayers() ? this.all_layers[e].getName() : "";
  }
  /**
   * @returns {SVGGElement|null} The SVGGElement representing the current layer.
   */
  getCurrentLayer() {
    return this.current_layer ? this.current_layer.getGroup() : null;
  }
  /**
   * Get a layer by name.
   * @param {string} name
   * @returns {SVGGElement} The SVGGElement representing the named layer or null.
   */
  getLayerByName(e) {
    const t = this.layer_map[e];
    return t ? t.getGroup() : null;
  }
  /**
   * Returns the name of the currently selected layer. If an error occurs, an empty string
   * is returned.
   * @returns {string} The name of the currently active layer (or the empty string if none found).
   */
  getCurrentLayerName() {
    return this.current_layer ? this.current_layer.getName() : "";
  }
  /**
   * Set the current layer's name.
   * @param {string} name - The new name.
   * @param {module:history.HistoryRecordingService} hrService - History recording service
   * @returns {string|null} The new name if changed; otherwise, null.
   */
  setCurrentLayerName(e, t) {
    let A = null;
    if (this.current_layer) {
      const n = this.current_layer.getName();
      A = this.current_layer.setName(e, t), A && (delete this.layer_map[n], this.layer_map[A] = this.current_layer);
    }
    return A;
  }
  /**
   * Set the current layer's position.
   * @param {Integer} newpos - The zero-based index of the new position of the layer. Range should be 0 to layers-1
   * @returns {{title: SVGGElement, previousName: string}|null} If the name was changed, returns {title:SVGGElement, previousName:string}; otherwise null.
   */
  setCurrentLayerPosition(e) {
    const t = this.getNumLayers();
    if (!this.current_layer || e < 0 || e >= t)
      return null;
    const A = this.indexCurrentLayer();
    if (A === -1 || A === e)
      return null;
    const n = this.current_layer.getGroup(), i = n.nextSibling;
    let s = null;
    return e > A ? e < t - 1 && (s = this.all_layers[e + 1].getGroup()) : s = this.all_layers[e].getGroup(), this.svgElem_.insertBefore(n, s), this.identifyLayers(), this.setCurrentLayer(this.getLayerName(e)), {
      currentGroup: n,
      oldNextSibling: i
    };
  }
  /**
   * @param {module:history.HistoryRecordingService} hrService
   * @returns {void}
   */
  mergeLayer(e) {
    const t = this.current_layer.getGroup(), A = t.previousElementSibling;
    if (!A)
      return;
    e.startBatchCommand("Merge Layer");
    const n = t.nextSibling;
    for (e.removeElement(t, n, this.svgElem_); t.firstChild; ) {
      const s = t.firstChild;
      if (s.localName === "title") {
        e.removeElement(s, s.nextSibling, t), s.remove();
        continue;
      }
      const a = s.nextSibling;
      A.append(s), e.moveElement(s, a, t);
    }
    this.current_layer.removeGroup();
    const i = this.indexCurrentLayer();
    if (i > 0) {
      const s = this.current_layer.getName();
      this.current_layer = this.all_layers[i - 1], this.all_layers.splice(i, 1), delete this.layer_map[s];
    }
    e.endBatchCommand();
  }
  /**
   * @param {module:history.HistoryRecordingService} hrService
   * @returns {void}
   */
  mergeAllLayers(e) {
    for (this.current_layer = this.all_layers[this.all_layers.length - 1], e.startBatchCommand("Merge all Layers"); this.all_layers.length > 1; )
      this.mergeLayer(e);
    e.endBatchCommand();
  }
  /**
   * Sets the current layer. If the name is not a valid layer name, then this
   * function returns `false`. Otherwise it returns `true`. This is not an
   * undo-able action.
   * @param {string} name - The name of the layer you want to switch to.
   * @returns {boolean} `true` if the current layer was switched, otherwise `false`
   */
  setCurrentLayer(e) {
    const t = this.layer_map[e];
    return t ? (this.current_layer && this.current_layer.deactivate(), this.current_layer = t, this.current_layer.activate(), !0) : !1;
  }
  /**
   * Sets the current layer. If the name is not a valid layer name, then this
   * function returns `false`. Otherwise it returns `true`. This is not an
   * undo-able action.
   * @param {string} name - The name of the layer you want to switch to.
   * @returns {boolean} `true` if the current layer was switched, otherwise `false`
   */
  indexCurrentLayer() {
    return this.all_layers.indexOf(this.current_layer);
  }
  /**
   * Deletes the current layer from the drawing and then clears the selection.
   * This function then calls the 'changed' handler.  This is an undoable action.
   * @todo Does this actually call the 'changed' handler?
   * @returns {SVGGElement} The SVGGElement of the layer removed or null.
   */
  deleteCurrentLayer() {
    if (this.current_layer && this.getNumLayers() > 1) {
      const e = this.current_layer.removeGroup();
      return this.identifyLayers(), e;
    }
    return null;
  }
  /**
   * Updates layer system and sets the current layer to the
   * top-most layer (last `<g>` child of this drawing).
   * @returns {void}
   */
  identifyLayers() {
    this.all_layers = [], this.layer_map = {};
    const e = this.svgElem_.childNodes.length, t = [], A = [];
    let n = null, i = !1;
    for (let s = 0; s < e; ++s) {
      const a = this.svgElem_.childNodes.item(s);
      if (a?.nodeType === 1)
        if (a.tagName === "g")
          if (i = !0, c_(a)) {
            const o = u_(a);
            A.push(o), n = new Bn(o, a), this.all_layers.push(n), this.layer_map[o] = n;
          } else
            t.push(a);
        else l_.includes(a.nodeName) && t.push(a);
    }
    if (t.length > 0 || !i) {
      const s = jf(A);
      n = new Bn(s, null, this.svgElem_), n.appendChildren(t), this.all_layers.push(n), this.layer_map[s] = n;
    } else
      n.activate();
    this.current_layer = n;
  }
  /**
   * Creates a new top-level layer in the drawing with the given name and
   * makes it the current layer.
   * @param {string} name - The given name. If the layer name exists, a new name will be generated.
   * @param {module:history.HistoryRecordingService} hrService - History recording service
   * @returns {SVGGElement} The SVGGElement of the new layer, which is
   *     also the current layer of this drawing.
   */
  createLayer(e, t) {
    this.current_layer && this.current_layer.deactivate(), (e == null || e === "" || this.layer_map[e]) && (e = jf(Object.keys(this.layer_map)));
    const A = new Bn(e, null, this.svgElem_);
    return t && (t.startBatchCommand("Create Layer"), t.insertElement(A.getGroup()), t.endBatchCommand()), this.all_layers.push(A), this.layer_map[e] = A, this.current_layer = A, A.getGroup();
  }
  /**
   * Creates a copy of the current layer with the given name and makes it the current layer.
   * @param {string} name - The given name. If the layer name exists, a new name will be generated.
   * @param {module:history.HistoryRecordingService} hrService - History recording service
   * @returns {SVGGElement} The SVGGElement of the new layer, which is
   *     also the current layer of this drawing.
   */
  cloneLayer(e, t) {
    if (!this.current_layer)
      return null;
    this.current_layer.deactivate(), (e == null || e === "" || this.layer_map[e]) && (e = jf(Object.keys(this.layer_map)));
    const A = this.current_layer.getGroup(), n = new Bn(e, A, this.svgElem_), i = n.getGroup();
    [...A.childNodes].forEach((o) => {
      o.localName !== "title" && i.append(this.copyElem(o));
    }), t && (t.startBatchCommand("Duplicate Layer"), t.insertElement(i), t.endBatchCommand());
    const a = this.indexCurrentLayer();
    return a >= 0 ? this.all_layers.splice(a + 1, 0, n) : this.all_layers.push(n), this.layer_map[e] = n, this.current_layer = n, i;
  }
  /**
   * Returns whether the layer is visible.  If the layer name is not valid,
   * then this function returns `false`.
   * @param {string} layerName - The name of the layer which you want to query.
   * @returns {boolean} The visibility state of the layer, or `false` if the layer name was invalid.
   */
  getLayerVisibility(e) {
    const t = this.layer_map[e];
    return t ? t.isVisible() : !1;
  }
  /**
   * Sets the visibility of the layer. If the layer name is not valid, this
   * function returns `null`, otherwise it returns the `SVGElement` representing
   * the layer. This is an undo-able action.
   * @param {string} layerName - The name of the layer to change the visibility
   * @param {boolean} bVisible - Whether the layer should be visible
   * @returns {?SVGGElement} The SVGGElement representing the layer if the
   *   `layerName` was valid, otherwise `null`.
   */
  setLayerVisibility(e, t) {
    if (typeof t != "boolean")
      return null;
    const A = this.layer_map[e];
    return A ? (A.setVisible(t), A.getGroup()) : null;
  }
  /**
   * Returns the opacity of the given layer.  If the input name is not a layer, `null` is returned.
   * @param {string} layerName - name of the layer on which to get the opacity
   * @returns {?Float} The opacity value of the given layer.  This will be a value between 0.0 and 1.0, or `null`
   * if `layerName` is not a valid layer
   */
  getLayerOpacity(e) {
    const t = this.layer_map[e];
    return t ? t.getOpacity() : null;
  }
  /**
   * Sets the opacity of the given layer.  If the input name is not a layer,
   * nothing happens. If opacity is not a value between 0.0 and 1.0, then
   * nothing happens.
   * NOTE: this function exists solely to apply a highlighting/de-emphasis
   * effect to a layer. When it is possible for a user to affect the opacity
   * of a layer, we will need to allow this function to produce an undo-able
   * action.
   * @param {string} layerName - Name of the layer on which to set the opacity
   * @param {Float} opacity - A float value in the range 0.0-1.0
   * @returns {void}
   */
  setLayerOpacity(e, t) {
    if (typeof t != "number" || t < 0 || t > 1)
      return;
    const A = this.layer_map[e];
    A && A.setOpacity(t);
  }
  /**
   * Create a clone of an element, updating its ID and its children's IDs when needed.
   * @param {Element} el - DOM element to clone
   * @returns {Element}
   */
  copyElem(e) {
    const t = this;
    return KS(e, function() {
      return t.getNextId();
    });
  }
}
const O1 = function(r, e) {
  Ml = r === !1 ? ya.NEVER_RANDOMIZE : ya.ALWAYS_RANDOMIZE, Ml === ya.ALWAYS_RANDOMIZE && !e.getNonce() ? e.setNonce(Math.floor(Math.random() * 100001)) : Ml === ya.NEVER_RANDOMIZE && e.getNonce() && e.clearNonce();
};
let bt;
const h_ = (r) => {
  bt = r;
}, Rl = () => {
  Vs(), bt.getCurrentDrawing().identifyLayers();
}, f_ = () => bt.getCurrentDrawing().indexCurrentLayer(), d_ = (r, e) => {
  const t = bt.getCurrentDrawing().createLayer(r, au(e));
  bt.clearSelection(), bt.call("changed", [t]);
}, g_ = (r, e) => {
  const t = bt.getCurrentDrawing().cloneLayer(r, au(e));
  bt.clearSelection(), Vs(), bt.call("changed", [t]);
}, p_ = () => {
  const { BatchCommand: r, RemoveElementCommand: e } = bt.history;
  let t = bt.getCurrentDrawing().getCurrentLayer();
  const { nextSibling: A } = t, n = t.parentNode;
  if (t = bt.getCurrentDrawing().deleteCurrentLayer(), t) {
    const i = new r("Delete Layer");
    return i.addSubCommand(
      new e(t, A, n)
    ), bt.addCommandToHistory(i), bt.clearSelection(), bt.call("changed", [n]), !0;
  }
  return !1;
}, m_ = (r) => {
  const e = bt.getCurrentDrawing().setCurrentLayer(Tl(r));
  return e && bt.clearSelection(), e;
}, v_ = (r) => {
  const e = bt.getCurrentDrawing(), t = e.getCurrentLayer();
  return t && e.setCurrentLayerName(
    r,
    au()
  ) ? (bt.call("changed", [t]), !0) : !1;
}, w_ = (r) => {
  const { MoveElementCommand: e } = bt.history, A = bt.getCurrentDrawing().setCurrentLayerPosition(r);
  return A ? (bt.addCommandToHistory(
    new e(
      A.currentGroup,
      A.oldNextSibling,
      bt.getSvgContent()
    )
  ), !0) : !1;
}, y_ = (r, e) => {
  const { ChangeElementCommand: t } = bt.history, A = bt.getCurrentDrawing(), n = A.getLayerVisibility(r), i = A.setLayerVisibility(r, e);
  if (i) {
    const s = n ? "inline" : "none";
    bt.addCommandToHistory(
      new t(
        i,
        { display: s },
        "Layer Visibility"
      )
    );
  } else
    return !1;
  return i === A.getCurrentLayer() && (bt.clearSelection(), bt.pathActions.clear()), !0;
}, B_ = (r) => {
  const { BatchCommand: e, MoveElementCommand: t } = bt.history, n = bt.getCurrentDrawing().getLayerByName(r);
  if (!n)
    return !1;
  const i = new e("Move Elements to Layer"), s = bt.getSelectedElements();
  let a = s.length;
  for (; a--; ) {
    const o = s[a];
    if (!o)
      continue;
    const l = o.nextSibling, u = o.parentNode;
    n.append(o), i.addSubCommand(
      new t(o, l, u)
    );
  }
  return bt.addCommandToHistory(i), !0;
}, b_ = (r) => {
  bt.getCurrentDrawing().mergeLayer(au(r)), bt.clearSelection(), Vs(), bt.changeSvgContent();
}, C_ = (r) => {
  bt.getCurrentDrawing().mergeAllLayers(au(r)), bt.clearSelection(), Vs(), bt.changeSvgContent();
}, Vs = () => {
  const r = Wc.length, e = bt.getDataStorage();
  if (r) {
    for (let t = 0; t < r; t++) {
      const A = Wc[t], n = e.get(A, "orig_opac");
      n !== 1 ? A.setAttribute("opacity", n) : A.removeAttribute("opacity"), A.setAttribute("style", "pointer-events: inherit");
    }
    Wc = [], bt.clearSelection(!0), bt.call("contextset", null);
  }
  bt.setCurrentGroup(null);
}, jS = (r) => {
  const e = bt.getDataStorage();
  Vs(), typeof r == "string" && (r = Xt(r)), bt.setCurrentGroup(r);
  const t = U4(r, "#svgcontent"), A = [];
  t.forEach(function(n) {
    Array.prototype.filter.call(
      n.parentNode.children,
      function(s) {
        return s !== n;
      }
    ).forEach(function(s) {
      A.push(s);
    });
  }), A.forEach(function(n) {
    const i = n.getAttribute("opacity") || 1;
    e.put(n, "orig_opac", i), n.setAttribute("opacity", i * 0.33), n.setAttribute("style", "pointer-events: none"), Wc.push(n);
  }), bt.clearSelection(), bt.call("contextset", bt.getCurrentGroup());
}, {
  InsertElementCommand: S_,
  BatchCommand: x_
} = Pa;
let Qn = null;
const E_ = (r) => {
  Qn = r;
}, F_ = function(r, e, t) {
  let A = JSON.parse(sessionStorage.getItem(Qn.getClipboardID()));
  if (!A) return;
  let n = A.length;
  if (!n) return;
  const i = [], s = new x_("Paste elements"), a = {};
  function o(l) {
    l.attr?.id && (a[l.attr.id] = Qn.getNextId(), l.attr.id = a[l.attr.id]), l.children && l.children.forEach((u) => o(u));
  }
  for (A.forEach((l) => o(l)), Qn.runExtensions(
    "IDsUpdated",
    /** @type {module:svgcanvas.SvgCanvas#event:ext_IDsUpdated} */
    { elems: A, changes: a },
    !0
  ).forEach(function(l) {
    !l || !("remove" in l) || l.remove.forEach(function(u) {
      A = A.filter(function(h) {
        return h.attr.id !== u;
      });
    });
  }); n--; ) {
    const l = A[n];
    if (!l)
      continue;
    const u = Qn.addSVGElementsFromJson(l);
    i.push(u), s.addSubCommand(new S_(u)), Qn.restoreRefElements(u);
  }
  if (Qn.selectOnly(i), r !== "in_place") {
    let l, u;
    r ? r === "point" && (l = e, u = t) : (l = Qn.getLastClickPoint("x"), u = Qn.getLastClickPoint("y"));
    const h = Mn(i), f = l - (h.x + h.width / 2), c = u - (h.y + h.height / 2), p = [], g = [];
    i.forEach(function(w) {
      p.push(f), g.push(c);
    });
    const v = Qn.moveSelectedElements(p, g, !1);
    v && s.addSubCommand(v);
  }
  Qn.addCommandToHistory(s), Qn.call("changed", i);
}, oc = (r) => {
  r.preventDefault();
  const { changedTouches: e } = r, t = e[0];
  let A = "";
  switch (r.type) {
    case "touchstart":
      A = "mousedown";
      break;
    case "touchmove":
      A = "mousemove";
      break;
    case "touchend":
      A = "mouseup";
      break;
    default:
      return;
  }
  const { screenX: n, screenY: i, clientX: s, clientY: a } = t, o = new MouseEvent(A, {
    // Event interface
    bubbles: !0,
    cancelable: !0,
    // UIEvent interface
    view: window,
    detail: 1,
    // click count
    // MouseEvent interface (customized)
    screenX: n,
    screenY: i,
    clientX: s,
    clientY: a,
    // MouseEvent interface (defaults) - these could be removed
    ctrlKey: !1,
    altKey: !1,
    shiftKey: !1,
    metaKey: !1,
    button: 0,
    // main button (usually left)
    relatedTarget: null
  });
  e.length < 2 && t.target.dispatchEvent(o);
}, __ = (r) => {
  r.svgroot.addEventListener("touchstart", oc), r.svgroot.addEventListener("touchmove", oc), r.svgroot.addEventListener("touchend", oc), r.svgroot.addEventListener("touchcancel", oc);
};
const U_ = function(r, e) {
  return r.importNode(
    jm(
      `<svg id="svgroot" xmlns="${nt.SVG}" xlinkns="${nt.XLINK}" width="${e[0]}" 
        height="${e[1]}" x="${e[0]}" y="${e[1]}" overflow="visible">
        <defs>
          <filter id="canvashadow" filterUnits="objectBoundingBox">
            <feGaussianBlur in="SourceAlpha" stdDeviation="4" result="blur"/>
            <feOffset in="blur" dx="5" dy="5" result="offsetBlur"/>
            <feMerge>
              <feMergeNode in="offsetBlur"/>
              <feMergeNode in="SourceGraphic"/>
            </feMerge>
          </filter>
        </defs>
      </svg>`
    ).documentElement,
    !0
  );
};
const qf = "http://www.w3.org/2000/svg", { userAgent: Qh } = navigator, I_ = Qh.includes("AppleWebKit"), Q_ = Qh.includes("Gecko/"), L_ = Qh.includes("Chrome/");
Qh.includes("Macintosh");
const N_ = (function() {
  const r = document.createElementNS(qf, "svg"), e = document.createElementNS(qf, "svg");
  document.documentElement.append(r), e.setAttribute("x", 5), r.append(e);
  const t = document.createElementNS(qf, "text");
  t.textContent = "a", e.append(t);
  try {
    return t.getStartPositionOfChar(0).x === 0;
  } catch {
    return !1;
  } finally {
    r.remove();
  }
})(), qS = () => I_, Sa = () => Q_, T_ = () => L_, P_ = () => N_;
const {
  UndoManager: O_,
  HistoryEventTypes: M_
} = Pa;
let Zt = null;
const R_ = (r) => {
  Zt = r, r.undoMgr = k_();
}, k_ = () => new O_({
  /**
   * @param {string} eventType One of the HistoryEvent types
   * @param {module:history.HistoryCommand} cmd Fulfills the HistoryCommand interface
   * @fires module:undo.SvgCanvas#event:changed
   * @returns {void}
   */
  handleHistoryEvent(r, e) {
    const t = M_;
    if (r === t.BEFORE_UNAPPLY || r === t.BEFORE_APPLY)
      Zt.clearSelection();
    else if (r === t.AFTER_APPLY || r === t.AFTER_UNAPPLY) {
      const A = e.elements();
      Zt.pathActions.clear(), Zt.call("changed", A);
      const n = e.type(), i = r === t.AFTER_APPLY;
      if (n === "MoveElementCommand")
        (i ? e.newParent : e.oldParent) === Zt.getSvgContent() && Rl();
      else if (n === "InsertElementCommand" || n === "RemoveElementCommand")
        e.parent === Zt.getSvgContent() && Rl(), n === "InsertElementCommand" ? i && Zt.restoreRefElements(e.elem) : i || Zt.restoreRefElements(e.elem), e.elem?.tagName === "use" && Zt.setUseData(e.elem);
      else if (n === "ChangeElementCommand") {
        e.elem.tagName === "title" && e.elem.parentNode.parentNode === Zt.getSvgContent() && Rl();
        const s = i ? e.newValues : e.oldValues;
        if (s.stdDeviation && Zt.setBlurOffsets(e.elem.parentNode, s.stdDeviation), e.elem.tagName === "text") {
          const [a, o] = [
            e.newValues.x - e.oldValues.x,
            e.newValues.y - e.oldValues.y
          ], l = e.elem.children;
          for (let u = 0; u < l.length; u++) {
            let h = Number(l[u].getAttribute("x")), f = Number(l[u].getAttribute("y"));
            const c = r === t.AFTER_UNAPPLY;
            h = c ? h - a : h + a, f = c ? f - o : f + o, l[u].setAttribute("x", h), l[u].setAttribute("y", f);
          }
        }
      }
    }
  }
}), M1 = function(r) {
  if (!Sa())
    return r;
  const e = r.cloneNode(!0);
  return r.before(e), r.remove(), Zt.selectorManager.releaseSelector(r), Zt.setSelectedElements(0, e), Zt.selectorManager.requestSelector(e).showGrips(!0), e;
}, zS = (r, e, t) => {
  if (r === "id") {
    const a = t[0], o = a.id;
    o !== e && (Zt.clearSelection(), a.id = e, Zt.addToSelection([a], !0), Zt.call("elementRenamed", { elem: a, oldId: o, newId: e }));
    return;
  }
  const A = Zt.getSelectedElements(), n = Zt.getZoom();
  Zt.getCurrentMode() === "pathedit" && Zt.pathActions.moveNode(r, e), t = t ?? A;
  let i = t.length;
  const s = ["g", "polyline", "path"];
  for (; i--; ) {
    let a = t[i];
    if (!a)
      continue;
    if ((r === "x" || r === "y") && s.includes(a.tagName)) {
      const l = Mn([a]), u = r === "x" ? parseFloat(e) - l.x : 0, h = r === "y" ? parseFloat(e) - l.y : 0;
      Zt.moveSelectedElements(u * n, h * n, !0);
      continue;
    }
    let o = r === "#text" ? a.textContent : a.getAttribute(r);
    if (o || (o = ""), o !== String(e)) {
      r === "#text" ? (a.textContent = e, /rotate/.test(a.getAttribute("transform")) && (a = M1(a))) : r === "#href" ? Rn(a, e) : e ? a.setAttribute(r, isNaN(parseFloat(e)) ? e : parseFloat(e)) : typeof e == "number" ? a.setAttribute(r, e) : a.removeAttribute(r), Zt.getCurrentMode() === "textedit" && r !== "#text" && a.textContent.length && Zt.textActions.toSelectMode(a), Sa() && a.nodeName === "text" && /rotate/.test(a.getAttribute("transform")) && (String(e).startsWith("url") || ["font-size", "font-family", "x", "y"].includes(r) && a.textContent) && (a = M1(a)), A.includes(a) && setTimeout(function() {
        a.parentNode && Zt.selectorManager.requestSelector(a).resize();
      }, 0);
      const l = MA(a);
      if (l !== 0 && r !== "transform") {
        const u = yr(a);
        let h = u.numberOfItems;
        for (; h--; )
          if (u.getItem(h).type === 4) {
            u.removeItem(h);
            const c = Nr(a), p = zt(
              c.x + c.width / 2,
              c.y + c.height / 2,
              vr(u).matrix
            ), g = p.x, v = p.y, w = Zt.getSvgRoot().createSVGTransform();
            w.setRotate(l, g, v), u.insertItemBefore(w, h);
            break;
          }
      }
    }
  }
}, H_ = function(r, e, t) {
  const A = Zt.getSelectedElements();
  t = t || A, Zt.undoMgr.beginUndoableChange(r, t), zS(r, e, t);
  const n = Zt.undoMgr.finishUndoableChange();
  n.isEmpty() || Zt.undoMgr.addCommandToHistory(n);
};
const { BatchCommand: D_ } = Pa;
let gt = null;
const G_ = (r) => {
  gt = r, gt.getMouseTarget = j_, gt.clearSelection = V_, gt.addToSelection = K_, gt.getIntersectionList = W_, gt.runExtensions = q_, gt.groupSvgElem = X_, gt.prepareSvg = Y_, gt.recalculateAllSelectedDimensions = $_, gt.setRotationAngle = J_;
}, V_ = (r) => {
  gt.getSelectedElements().forEach((t) => {
    t && gt.selectorManager.releaseSelector(t);
  }), gt?.setEmptySelectedElements(), r || gt.call("selected", gt.getSelectedElements());
}, K_ = (r, e) => {
  const t = gt.getSelectedElements();
  if (!r.length)
    return;
  let A = 0;
  for (; A < t.length && t[A] !== null; )
    ++A;
  let n = r.length;
  for (; n--; ) {
    let i = r[n];
    if (!(!i || !i.getBBox) && (i.tagName === "a" && i.childNodes.length === 1 && (i = i.firstChild), !t.includes(i))) {
      t[A] = i, A++;
      const s = gt.selectorManager.requestSelector(i);
      t.length > 1 && s.showGrips(!1);
    }
  }
  if (t.length)
    for (gt.call("selected", t), t.length === 1 && gt.selectorManager.requestSelector(t[0]).showGrips(e), t.sort((i, s) => i && s && i.compareDocumentPosition ? 3 - (s.compareDocumentPosition(i) & 6) : i ? 0 : 1); !t[0]; )
      t.shift(0);
}, j_ = (r) => {
  if (!r)
    return null;
  let e = r.target;
  if (e.correspondingUseElement && (e = e.correspondingUseElement), [nt.MATH, nt.HTML].includes(e.namespaceURI) && e.id !== "svgcanvas") {
    for (; e.nodeName !== "foreignObject"; )
      if (e = e.parentNode, !e)
        return gt.getSvgRoot();
  }
  const t = gt.getCurrentDrawing().getCurrentLayer(), A = gt.getSvgRoot(), n = gt.getDOMContainer(), i = gt.getSvgContent();
  if ([A, n, i, t].includes(e))
    return gt.getSvgRoot();
  if (Au(e.parentNode, "#selectorParentGroup"))
    return gt.selectorManager.selectorParentGroup;
  for (; !e?.parentNode?.isSameNode(
    gt.getCurrentGroup() || t
  ); )
    e = e.parentNode;
  return e;
}, q_ = (r, e, t) => {
  let A = t ? [] : !1;
  for (const [n, i] of Object.entries(gt.getExtensions()))
    if (typeof e == "function" && (e = e(n)), i.eventBased) {
      const s = new CustomEvent("svgedit", {
        detail: {
          action: r,
          vars: e
        }
      });
      document.dispatchEvent(s);
    } else i[r] && (t ? A.push(i[r](e)) : A = i[r](e));
  return A;
}, z_ = (r) => {
  r || (r = gt.getSvgContent().children);
  const e = [], t = r.children;
  return Array.from(t).forEach((A) => {
    A.getBBox && e.push({ elem: A, bbox: Mn([A]) });
  }), e.reverse();
}, W_ = (r) => {
  const e = gt.getZoom();
  if (!gt.getRubberBox())
    return null;
  const t = gt.getCurrentGroup() || gt.getCurrentDrawing().getCurrentLayer();
  let A;
  if (r)
    A = gt.getSvgContent().createSVGRect(), A.x = r.x, A.y = r.y, A.width = r.width, A.height = r.height;
  else {
    A = Nr(gt.getRubberBox());
    const s = gt.getSvgContent().createSVGRect();
    ["x", "y", "width", "height", "top", "right", "bottom", "left"].forEach(
      (a) => {
        s[a] = A[a] / e;
      }
    ), A = s;
  }
  const n = [];
  gt.getCurBBoxes().length === 0 && gt.setCurBBoxes(z_(t));
  let i = gt.getCurBBoxes().length;
  for (; i--; ) {
    const s = gt.getCurBBoxes();
    A.width && s[i].bbox && gS(A, s[i].bbox) && n.push(s[i].elem);
  }
  return n;
}, X_ = (r) => {
  const e = gt.getDataStorage(), t = document.createElementNS(nt.SVG, "g");
  r.replaceWith(t), t.appendChild(r), e.put(t, "gsvg", r), t.id = gt.getNextId();
}, Y_ = (r) => {
  gt.sanitizeSvg(r.documentElement), [...r.getElementsByTagNameNS(nt.SVG, "path")].forEach((t) => {
    const A = gt.pathActions.convertPath(t);
    t.setAttribute("d", A), gt.pathActions.fixEnd(t);
  });
}, J_ = (r, e) => {
  const t = gt.getSelectedElements();
  r = Number.parseFloat(r);
  const A = t[0], n = A.getAttribute("transform"), i = Nr(A), s = i.x + i.width / 2, a = i.y + i.height / 2, o = yr(A);
  if (o.numberOfItems > 0 && o.getItem(0).type === 4 && o.removeItem(0), r !== 0) {
    const u = zt(
      s,
      a,
      vr(o).matrix
    ), h = gt.getSvgRoot().createSVGTransform();
    h.setRotate(r, u.x, u.y), o.numberOfItems ? o.insertItemBefore(h, 0) : o.appendItem(h);
  } else o.numberOfItems === 0 && A.removeAttribute("transform");
  if (!e) {
    let u = A.getAttribute("transform");
    if (u) {
      const h = u.split(/[ ,]+/), c = ((p) => Math.round(Number(p) + Number.EPSILON))(h[1]);
      u = `${h[0]} ${c} ${h[2]}`;
    }
    n ? A.setAttribute("transform", n) : A.removeAttribute("transform"), gt.changeSelectedAttribute(
      "transform",
      u,
      t
    ), gt.call("changed", t);
  }
  gt.selectorManager.requestSelector(
    t[0]
  ).resize(), gt.getSelector().updateGripCursors(r);
}, $_ = () => {
  const r = gt.getCurrentResizeMode() === "none" ? "position" : "size", e = new D_(r), t = gt.getSelectedElements();
  t.forEach((A) => {
    const n = gt.recalculateDimensions(A);
    n && e.addSubCommand(n);
  }), e.isEmpty() || (gt.addCommandToHistory(e), gt.call("changed", t));
};
let mr = null;
const Z_ = (r) => {
  mr = r;
}, eU = /* @__PURE__ */ (function() {
  let r, e, t, A, n, i = [], s, a, o, l, u;
  function h(C) {
    const E = e.value === "";
    if (e.focus(), !arguments.length)
      if (E)
        C = 0;
      else {
        if (e.selectionEnd !== e.selectionStart)
          return;
        C = e.selectionEnd;
      }
    const _ = i[C];
    E || e.setSelectionRange(C, C), t = Xt("text_cursor"), t || (t = document.createElementNS(nt.SVG, "line"), qt(t, {
      id: "text_cursor",
      stroke: "#333",
      "stroke-width": 1
    }), Xt("selectorParentGroup").append(t)), n || (n = setInterval(function() {
      const U = t.getAttribute("display") === "none";
      t.setAttribute("display", U ? "inline" : "none");
    }, 600));
    const I = w(_.x, s.y), O = w(_.x, s.y + s.height);
    qt(t, {
      x1: I.x,
      y1: I.y,
      x2: O.x,
      y2: O.y,
      visibility: "visible",
      display: "inline"
    }), A && A.setAttribute("d", "");
  }
  function f(C, E, _) {
    if (C === E) {
      h(E);
      return;
    }
    _ || e.setSelectionRange(C, E), A = Xt("text_selectblock"), A || (A = document.createElementNS(nt.SVG, "path"), qt(A, {
      id: "text_selectblock",
      fill: "green",
      opacity: 0.5,
      style: "pointer-events:none"
    }), Xt("selectorParentGroup").append(A));
    const I = i[C], O = i[E];
    t.setAttribute("visibility", "hidden");
    const U = w(I.x, s.y), V = w(I.x + (O.x - I.x), s.y), F = w(I.x, s.y + s.height), P = w(
      I.x + (O.x - I.x),
      s.y + s.height
    ), D = "M" + U.x + "," + U.y + " L" + V.x + "," + V.y + " " + P.x + "," + P.y + " " + F.x + "," + F.y + "z";
    qt(A, {
      d: D,
      display: "inline"
    });
  }
  function c(C, E) {
    const _ = mr.getSvgRoot().createSVGPoint();
    if (_.x = C, _.y = E, i.length === 1)
      return 0;
    let I = r.getCharNumAtPosition(_);
    I < 0 ? (I = i.length - 2, C <= i[0].x && (I = 0)) : I >= i.length - 2 && (I = i.length - 2);
    const O = i[I], U = O.x + O.width / 2;
    return C > U && I++, I;
  }
  function p(C, E) {
    h(c(C, E));
  }
  function g(C, E, _) {
    const I = e.selectionStart, O = c(C, E), U = Math.min(I, O), V = Math.max(I, O);
    f(U, V, !_);
  }
  function v(C, E) {
    const _ = {
      x: C,
      y: E
    }, I = mr.getZoom();
    if (_.x /= I, _.y /= I, a) {
      const O = zt(_.x, _.y, a.inverse());
      _.x = O.x, _.y = O.y;
    }
    return _;
  }
  function w(C, E) {
    const _ = {
      x: C,
      y: E
    };
    if (a) {
      const O = zt(_.x, _.y, a);
      _.x = O.x, _.y = O.y;
    }
    const I = mr.getZoom();
    return _.x *= I, _.y *= I, _;
  }
  function B(C) {
    f(0, r.textContent.length), C.target.removeEventListener("click", B);
  }
  function S(C) {
    if (!u || !r)
      return;
    const E = mr.getZoom(), _ = zt(C.pageX, C.pageY, mr.getrootSctm()), I = _.x * E, O = _.y * E, U = v(I, O), V = c(U.x, U.y), F = r.textContent, P = F.substr(0, V).replace(/[a-z\d]+$/i, "").length, D = F.substr(V).match(/^[a-z\d]+/i), R = (D ? D[0].length : 0) + V;
    f(P, R), mr.$click(C.target, B), setTimeout(function() {
      C.target.removeEventListener("click", B);
    }, 300);
  }
  return (
    /** @lends module:svgcanvas.SvgCanvas#textActions */
    {
      /**
       * @param {Element} target
       * @param {Float} x
       * @param {Float} y
       * @returns {void}
       */
      select(C, E, _) {
        r = C, mr.textActions.toEditMode(E, _);
      },
      /**
       * @param {Element} elem
       * @returns {void}
       */
      start(C) {
        r = C, mr.textActions.toEditMode();
      },
      /**
       * @param {external:MouseEvent} evt
       * @param {Element} mouseTarget
       * @param {Float} startX
       * @param {Float} startY
       * @returns {void}
       */
      mouseDown(C, E, _, I) {
        const O = v(_, I);
        e.focus(), p(O.x, O.y), o = _, l = I;
      },
      /**
       * @param {Float} mouseX
       * @param {Float} mouseY
       * @returns {void}
       */
      mouseMove(C, E) {
        const _ = v(C, E);
        g(_.x, _.y);
      },
      /**
       * @param {external:MouseEvent} evt
       * @param {Float} mouseX
       * @param {Float} mouseY
       * @returns {void}
       */
      mouseUp(C, E, _) {
        const I = v(E, _);
        g(I.x, I.y, !0), C.target !== r && E < o + 2 && E > o - 2 && _ < l + 2 && _ > l - 2 && mr.textActions.toSelectMode(!0);
      },
      /**
       * @function
       * @param {Integer} index
       * @returns {void}
       */
      setCursor: h,
      /**
       * @param {Float} x
       * @param {Float} y
       * @returns {void}
       */
      toEditMode(C, E) {
        if (u = !1, mr.setCurrentMode("textedit"), mr.selectorManager.requestSelector(r).showGrips(!1), mr.selectorManager.requestSelector(r), mr.textActions.init(), r.style.cursor = "text", !arguments.length)
          h();
        else {
          const _ = v(C, E);
          p(_.x, _.y);
        }
        setTimeout(function() {
          u = !0;
        }, 300);
      },
      /**
       * @param {boolean|Element} selectElem
       * @fires module:svgcanvas.SvgCanvas#event:selected
       * @returns {void}
       */
      toSelectMode(C) {
        mr.setCurrentMode("select"), clearInterval(n), n = null, A && A.setAttribute("display", "none"), t && t.setAttribute("visibility", "hidden"), r.style.cursor = "move", C && (mr.clearSelection(), r.style.cursor = "move", mr.call("selected", [r]), mr.addToSelection([r], !0)), r?.textContent.length || mr.deleteSelectedElements(), e.blur(), r = !1;
      },
      /**
       * @param {Element} elem
       * @returns {void}
       */
      setInputElem(C) {
        e = C;
      },
      /**
       * @returns {void}
       */
      clear() {
        mr.getCurrentMode() === "textedit" && mr.textActions.toSelectMode();
      },
      /**
       * @param {Element} _inputElem Not in use
       * @returns {void}
       */
      init(C) {
        if (!r)
          return;
        let E, _;
        r.parentNode || (r = mr.getSelectedElements()[0], mr.selectorManager.requestSelector(r).showGrips(!1));
        const O = r.textContent.length, U = r.getAttribute("transform");
        for (s = Nr(r), a = U ? Km(r) : null, i = [], i.length = O, e.focus(), r.removeEventListener("dblclick", S), r.addEventListener("dblclick", S), O || (_ = { x: s.x + s.width / 2, width: 0 }), E = 0; E < O; E++) {
          const V = r.getStartPositionOfChar(E);
          if (_ = r.getEndPositionOfChar(E), !P_()) {
            const F = mr.getZoom(), P = mr.contentW * F;
            V.x -= P, _.x -= P, V.x /= F, _.x /= F;
          }
          i[E] = {
            x: V.x,
            y: s.y,
            // start.y?
            width: _.x - V.x,
            height: s.height
          };
        }
        i.push({
          x: _.x,
          width: 0
        }), f(e.selectionStart, e.selectionEnd, !0);
      }
    }
  );
})();
const {
  InsertElementCommand: tU
} = Pa;
let N = null, Xc = !1;
const rU = (r) => {
  N = r, N.mouseDownEvent = oU, N.mouseMoveEvent = nU, N.dblClickEvent = aU, N.mouseUpEvent = sU, N.mouseOutEvent = iU, N.DOMMouseScrollEvent = lU;
}, R1 = (r) => {
  const e = { x: 0, y: 0 }, t = { x: N.getControllPoint2("x"), y: N.getControllPoint2("y") }, A = { x: N.getControllPoint1("x"), y: N.getControllPoint1("y") }, n = { x: N.getStart("x"), y: N.getStart("y") }, i = { x: N.getEnd("x"), y: N.getEnd("y") }, s = 1 / 6, a = r * r, o = a * r, l = [
    [-1, 3, -3, 1],
    [3, -6, 3, 0],
    [-3, 0, 3, 0],
    [1, 4, 1, 0]
  ];
  return e.x = s * ((t.x * l[0][0] + A.x * l[0][1] + n.x * l[0][2] + i.x * l[0][3]) * o + (t.x * l[1][0] + A.x * l[1][1] + n.x * l[1][2] + i.x * l[1][3]) * a + (t.x * l[2][0] + A.x * l[2][1] + n.x * l[2][2] + i.x * l[2][3]) * r + (t.x * l[3][0] + A.x * l[3][1] + n.x * l[3][2] + i.x * l[3][3])), e.y = s * ((t.y * l[0][0] + A.y * l[0][1] + n.y * l[0][2] + i.y * l[0][3]) * o + (t.y * l[1][0] + A.y * l[1][1] + n.y * l[1][2] + i.y * l[1][3]) * a + (t.y * l[2][0] + A.y * l[2][1] + n.y * l[2][2] + i.y * l[2][3]) * r + (t.y * l[3][0] + A.y * l[3][1] + n.y * l[3][2] + i.y * l[3][3])), {
    x: e.x,
    y: e.y
  };
}, AU = (r, e, t, A) => {
  const n = r.createSVGTransform();
  n.setTranslate(t, A);
  const i = yr(e);
  i.numberOfItems ? i.getItem(0).type === 2 ? i.replaceItem(n, 0) : i.insertItemBefore(n, 0) : i.appendItem(n);
}, nU = (r) => {
  if (!N.getStarted() || r.button === 1 || N.spaceKey)
    return;
  N.textActions.init(), r.preventDefault();
  const e = N.getSelectedElements(), t = N.getZoom(), A = N.getSvgRoot(), n = e[0];
  let i, s, a, o, l, u, h, f, c;
  const p = zt(r.clientX, r.clientY, N.getrootSctm()), g = p.x * t, v = p.y * t, w = Xt(N.getId());
  let B = g / t, S = B, C = v / t, E = C;
  N.getCurConfig().gridSnapping && (S = Ot(S), E = Ot(E));
  let _;
  switch (N.getCurrentMode()) {
    case "select": {
      if (n) {
        l = S - N.getStartX(), u = E - N.getStartY(), N.getCurConfig().gridSnapping && (l = Ot(l), u = Ot(u));
        const I = 4, O = Math.abs(l) > I || Math.abs(u) > I;
        Xc = Xc || O, Xc && (e.forEach((U) => {
          U && (AU(A, U, l, u), N.selectorManager.requestSelector(U).resize());
        }), N.call("transition", e));
      }
      break;
    }
    case "multiselect": {
      B *= t, C *= t, qt(N.getRubberBox(), {
        x: Math.min(N.getRStartX(), B),
        y: Math.min(N.getRStartY(), C),
        width: Math.abs(B - N.getRStartX()),
        height: Math.abs(C - N.getRStartY())
      });
      const I = e.slice(), O = [], U = N.getIntersectionList();
      for (h = U.length, i = 0; i < h; ++i) {
        const V = U[i];
        e.includes(V) || O.push(V);
        const F = I.indexOf(V);
        F !== -1 && I.splice(F, 1);
      }
      I.length > 0 && N.removeFromSelection(I), O.length > 0 && N.addToSelection(O);
      break;
    }
    case "resize": {
      _ = yr(n);
      const I = Qo(_);
      c = I ? N.getInitBbox() : Nr(n);
      let O = c.x, U = c.y, { width: V, height: F } = c;
      if (l = S - N.getStartX(), u = E - N.getStartY(), N.getCurConfig().gridSnapping && (l = Ot(l), u = Ot(u), F = Ot(F), V = Ot(V)), f = MA(n), f) {
        const ue = Math.sqrt(l * l + u * u), se = Math.atan2(u, l) - f * Math.PI / 180;
        l = ue * Math.cos(se), u = ue * Math.sin(se);
      }
      !N.getCurrentResizeMode().includes("n") && !N.getCurrentResizeMode().includes("s") && (u = 0), !N.getCurrentResizeMode().includes("e") && !N.getCurrentResizeMode().includes("w") && (l = 0);
      let P = 0, D = 0, R = F ? (F + u) / F : 1, J = V ? (V + l) / V : 1;
      N.getCurrentResizeMode().includes("n") && (R = F ? (F - u) / F : 1, D = F), N.getCurrentResizeMode().includes("w") && (J = V ? (V - l) / V : 1, P = V);
      const ie = A.createSVGTransform(), te = A.createSVGTransform(), $ = A.createSVGTransform();
      if (N.getCurConfig().gridSnapping && (O = Ot(O), P = Ot(P), U = Ot(U), D = Ot(D)), ie.setTranslate(-(O + P), -(U + D)), (n.tagName !== "image" && r.shiftKey || n.tagName === "image" && !r.shiftKey) && (J === 1 ? J = R : R = J), te.setScale(J, R), $.setTranslate(O + P, U + D), I) {
        const ue = f ? 1 : 0;
        _.replaceItem(ie, 2 + ue), _.replaceItem(te, 1 + ue), _.replaceItem($, Number(ue));
      } else {
        const ue = _.numberOfItems;
        _.replaceItem($, ue - 3), _.replaceItem(te, ue - 2), _.replaceItem(ie, ue - 1);
      }
      N.selectorManager.requestSelector(n).resize(), N.call("transition", e);
      break;
    }
    case "zoom": {
      B *= t, C *= t, qt(N.getRubberBox(), {
        x: Math.min(N.getRStartX() * t, B),
        y: Math.min(N.getRStartY() * t, C),
        width: Math.abs(B - N.getRStartX() * t),
        height: Math.abs(C - N.getRStartY() * t)
      });
      break;
    }
    case "text": {
      qt(w, {
        x: S,
        y: E
      });
      break;
    }
    case "line": {
      N.getCurConfig().gridSnapping && (S = Ot(S), E = Ot(E));
      let I = S, O = E;
      r.shiftKey && (s = O0(N.getStartX(), N.getStartY(), I, O), I = s.x, O = s.y), w.setAttribute("x2", I), w.setAttribute("y2", O);
      break;
    }
    case "foreignObject":
    // fall through
    case "square":
    case "rect":
    case "image": {
      const I = N.getCurrentMode() === "square" || N.getCurrentMode() === "image" && !r.shiftKey || N.getCurrentMode() !== "image" && r.shiftKey;
      let O = Math.abs(S - N.getStartX()), U = Math.abs(E - N.getStartY()), V, F;
      I ? (O = U = Math.max(O, U), V = N.getStartX() < S ? N.getStartX() : N.getStartX() - O, F = N.getStartY() < E ? N.getStartY() : N.getStartY() - U) : (V = Math.min(N.getStartX(), S), F = Math.min(N.getStartY(), E)), N.getCurConfig().gridSnapping && (O = Ot(O), U = Ot(U), V = Ot(V), F = Ot(F)), qt(w, {
        width: O,
        height: U,
        x: V,
        y: F
      });
      break;
    }
    case "circle": {
      a = Number(w.getAttribute("cx")), o = Number(w.getAttribute("cy"));
      let I = Math.sqrt((S - a) * (S - a) + (E - o) * (E - o));
      N.getCurConfig().gridSnapping && (I = Ot(I)), w.setAttribute("r", I);
      break;
    }
    case "ellipse": {
      a = Number(w.getAttribute("cx")), o = Number(w.getAttribute("cy")), N.getCurConfig().gridSnapping && (S = Ot(S), a = Ot(a), E = Ot(E), o = Ot(o)), w.setAttribute("rx", Math.abs(S - a));
      const I = Math.abs(r.shiftKey ? S - a : E - o);
      w.setAttribute("ry", I);
      break;
    }
    case "fhellipse":
    case "fhrect":
      N.setFreehand("minx", Math.min(B, N.getFreehand("minx"))), N.setFreehand("maxx", Math.max(B, N.getFreehand("maxx"))), N.setFreehand("miny", Math.min(C, N.getFreehand("miny"))), N.setFreehand("maxy", Math.max(C, N.getFreehand("maxy")));
    // Fallthrough
    case "fhpath": {
      if (N.setEnd("x", B), N.setEnd("y", C), N.getControllPoint2("x") && N.getControllPoint2("y")) {
        for (i = 0; i < N.getStepCount() - 1; i++)
          if (N.setParameter(i / N.getStepCount()), N.setNextParameter((i + 1) / N.getStepCount()), N.setbSpline(R1(N.getNextParameter())), N.setNextPos({ x: N.getbSpline("x"), y: N.getbSpline("y") }), N.setbSpline(R1(N.getParameter())), N.setSumDistance(
            N.getSumDistance() + Math.sqrt((N.getNextPos("x") - N.getbSpline("x")) * (N.getNextPos("x") - N.getbSpline("x")) + (N.getNextPos("y") - N.getbSpline("y")) * (N.getNextPos("y") - N.getbSpline("y")))
          ), N.getSumDistance() > N.getThreSholdDist()) {
            N.setSumDistance(N.getSumDistance() - N.getThreSholdDist());
            const I = N.getSvgContent().createSVGPoint();
            I.x = N.getbSpline("x"), I.y = N.getbSpline("y"), w.points.appendItem(I);
          }
      }
      N.setControllPoint2("x", N.getControllPoint1("x")), N.setControllPoint2("y", N.getControllPoint1("y")), N.setControllPoint1("x", N.getStart("x")), N.setControllPoint1("y", N.getStart("y")), N.setStart({ x: N.getEnd("x"), y: N.getEnd("y") });
      break;
    }
    case "path":
    // fall through
    case "pathedit": {
      if (S *= t, E *= t, N.getCurConfig().gridSnapping && (S = Ot(S), E = Ot(E), N.setStartX(Ot(N.getStartX())), N.setStartY(Ot(N.getStartY()))), r.shiftKey) {
        const { path: I } = VS;
        let O, U;
        I ? (O = I.dragging ? I.dragging[0] : N.getStartX(), U = I.dragging ? I.dragging[1] : N.getStartY()) : (O = N.getStartX(), U = N.getStartY()), s = O0(O, U, S, E), { x: S, y: E } = s;
      }
      N.getRubberBox()?.getAttribute("display") !== "none" && (B *= t, C *= t, qt(N.getRubberBox(), {
        x: Math.min(N.getRStartX() * t, B),
        y: Math.min(N.getRStartY() * t, C),
        width: Math.abs(B - N.getRStartX() * t),
        height: Math.abs(C - N.getRStartY() * t)
      })), N.pathActions.mouseMove(S, E);
      break;
    }
    case "textedit": {
      S *= t, E *= t, N.textActions.mouseMove(g, v);
      break;
    }
    case "rotate": {
      c = Nr(n), a = c.x + c.width / 2, o = c.y + c.height / 2;
      const I = Km(n), O = zt(a, o, I);
      a = O.x, o = O.y, f = (Math.atan2(o - E, a - S) * (180 / Math.PI) - 90) % 360, N.getCurConfig().gridSnapping && (f = Ot(f)), r.shiftKey && (f = Math.round(f / 45) * 45), N.setRotationAngle(f < -180 ? 360 + f : f, !0), N.call("transition", e);
      break;
    }
  }
  N.runExtensions(
    "mouseMove",
    /** @type {module:svgcanvas.SvgCanvas#event:ext_mouseMove} */
    {
      event: r,
      mouse_x: g,
      mouse_y: v,
      selected: n
    }
  );
}, iU = () => {
  const { $id: r } = N;
  if (N.getCurrentMode() !== "select" && N.getStarted()) {
    const e = new Event("mouseup");
    r("svgcanvas").dispatchEvent(e);
  }
}, sU = (r) => {
  if (r.preventDefault(), Xc = !1, r.button === 2 || !N.getStarted())
    return;
  N.textActions.init();
  const e = N.getSelectedElements(), t = N.getZoom(), A = N.getJustSelected();
  N.setJustSelected(null);
  const n = zt(r.clientX, r.clientY, N.getrootSctm()), i = n.x * t, s = n.y * t, a = i / t, o = s / t;
  let l = Xt(N.getId()), u = !1;
  const h = a, f = o;
  N.setStarted(!1);
  let c;
  switch (N.getCurrentMode()) {
    // intentionally fall-through to select here
    case "resize":
    case "multiselect":
      N.getRubberBox() && (N.getRubberBox().setAttribute("display", "none"), N.setCurBBoxes([])), N.setCurrentMode("select");
    // Fallthrough
    case "select":
      if (e[0]) {
        if (!e[1]) {
          const v = e[0];
          switch (v.tagName) {
            case "g":
            case "use":
            case "image":
            case "foreignObject":
              break;
            case "text":
              N.setCurText("font_size", v.getAttribute("font-size")), N.setCurText("font_family", v.getAttribute("font-family"));
            // fallthrough
            default:
              N.setCurProperties("fill", v.getAttribute("fill")), N.setCurProperties("fill_opacity", v.getAttribute("fill-opacity")), N.setCurProperties("stroke", v.getAttribute("stroke")), N.setCurProperties("stroke_opacity", v.getAttribute("stroke-opacity")), N.setCurProperties("stroke_width", v.getAttribute("stroke-width")), N.setCurProperties("stroke_dasharray", v.getAttribute("stroke-dasharray")), N.setCurProperties("stroke_linejoin", v.getAttribute("stroke-linejoin")), N.setCurProperties("stroke_linecap", v.getAttribute("stroke-linecap"));
          }
          N.selectorManager.requestSelector(v).showGrips(!0);
        }
        if (N.recalculateAllSelectedDimensions(), h !== N.getRStartX() || f !== N.getRStartY()) {
          const v = e.length;
          for (let w = 0; w < v && e[w]; ++w)
            N.selectorManager.requestSelector(e[w]).resize();
        } else
          c = r.target, e[0].nodeName === "path" && !e[1] ? N.pathActions.select(e[0]) : r.shiftKey && A !== c && N.removeFromSelection([c]);
        const g = e[0];
        g && (g.removeAttribute("style"), g.localName === "foreignObject" ? rs(g, (v) => {
          v.style.removeProperty("pointer-events");
        }) : rs(g, (v) => {
          v.removeAttribute("style");
        }));
      }
      return;
    case "zoom": {
      N.getRubberBox()?.setAttribute("display", "none");
      const g = r.shiftKey ? 0.5 : 2;
      N.call("zoomed", {
        x: Math.min(N.getRStartX(), h),
        y: Math.min(N.getRStartY(), f),
        width: Math.abs(h - N.getRStartX()),
        height: Math.abs(f - N.getRStartY()),
        factor: g
      });
      return;
    }
    case "fhpath": {
      N.setSumDistance(0), N.setControllPoint2("x", 0), N.setControllPoint2("y", 0), N.setControllPoint1("x", 0), N.setControllPoint1("y", 0), N.setStart({ x: 0, y: 0 }), N.setEnd("x", 0), N.setEnd("y", 0);
      const g = l.getAttribute("points"), v = g.indexOf(",");
      u = v >= 0 ? g.includes(",", v + 1) : g.includes(" ", g.indexOf(" ") + 1), u && (l = N.pathActions.smoothPolylineIntoPath(l));
      break;
    }
    case "line":
      {
        const g = l.getAttribute("x1"), v = l.getAttribute("y1"), w = l.getAttribute("x2"), B = l.getAttribute("y2");
        u = g !== w || v !== B;
      }
      break;
    case "foreignObject":
    case "square":
    case "rect":
    case "image":
      {
        const g = l.getAttribute("width"), v = l.getAttribute("height"), w = Number(g), B = Number(v);
        u = w >= 1 || B >= 1 || N.getCurrentMode() === "image";
      }
      break;
    case "circle":
      u = l.getAttribute("r") !== "0";
      break;
    case "ellipse":
      {
        const g = Number(l.getAttribute("rx")), v = Number(l.getAttribute("ry"));
        u = g || v;
      }
      break;
    case "fhellipse":
      N.getFreehand("maxx") - N.getFreehand("minx") > 0 && N.getFreehand("maxy") - N.getFreehand("miny") > 0 && (l = N.addSVGElementsFromJson({
        element: "ellipse",
        curStyles: !0,
        attr: {
          cx: (N.getFreehand("minx") + N.getFreehand("maxx")) / 2,
          cy: (N.getFreehand("miny") + N.getFreehand("maxy")) / 2,
          rx: (N.getFreehand("maxx") - N.getFreehand("minx")) / 2,
          ry: (N.getFreehand("maxy") - N.getFreehand("miny")) / 2,
          id: N.getId()
        }
      }), N.call("changed", [l]), u = !0);
      break;
    case "fhrect":
      N.getFreehand("maxx") - N.getFreehand("minx") > 0 && N.getFreehand("maxy") - N.getFreehand("miny") > 0 && (l = N.addSVGElementsFromJson({
        element: "rect",
        curStyles: !0,
        attr: {
          x: N.getFreehand("minx"),
          y: N.getFreehand("miny"),
          width: N.getFreehand("maxx") - N.getFreehand("minx"),
          height: N.getFreehand("maxy") - N.getFreehand("miny"),
          id: N.getId()
        }
      }), N.call("changed", [l]), u = !0);
      break;
    case "text":
      u = !0, N.selectOnly([l]), N.textActions.start(l);
      break;
    case "path": {
      l = null, N.setStarted(!0);
      const g = N.pathActions.mouseUp(r, l, i, s);
      ({ element: l } = g), { keep: u } = g;
      break;
    }
    case "pathedit":
      u = !0, l = null, N.pathActions.mouseUp(r);
      break;
    case "textedit":
      u = !1, l = null, N.textActions.mouseUp(r, i, s);
      break;
    case "rotate": {
      u = !0, l = null, N.setCurrentMode("select");
      const g = N.undoMgr.finishUndoableChange();
      g.isEmpty() || N.addCommandToHistory(g), N.recalculateAllSelectedDimensions(), N.call("changed", e);
      break;
    }
  }
  if (N.runExtensions("mouseUp", {
    event: r,
    mouse_x: i,
    mouse_y: s
  }, !0).forEach((g) => {
    g && (u = g.keep || u, { element: l } = g, N.setStarted(g.started || N.getStarted()));
  }), !u && l) {
    for (N.getCurrentDrawing().releaseId(N.getId()), l.remove(), l = null, c = r.target; c?.parentNode?.parentNode?.tagName === "g"; )
      c = c.parentNode;
    (N.getCurrentMode() !== "path" || !N.getDrawnPath()) && c && c.parentNode?.id !== "selectorParentGroup" && c.id !== "svgcanvas" && c.id !== "svgroot" && (N.setMode("select"), N.selectOnly([c], !0));
  } else if (l) {
    N.addedNew = !0;
    let g = 0.2, v;
    const w = N.getStyle(), B = N.getOpacAni();
    if (B.beginElement && Number.parseFloat(l.getAttribute("opacity")) !== w.opacity) {
      v = B.cloneNode(!0), v.setAttribute("to", w.opacity), v.setAttribute("dur", g), l.appendChild(v);
      try {
        v.beginElement();
      } catch {
      }
    } else
      g = 0;
    setTimeout(() => {
      v && v.remove(), l.setAttribute("opacity", w.opacity), l.setAttribute("style", "pointer-events:inherit"), Ih(l), N.getCurrentMode() === "path" ? N.pathActions.toEditMode(l) : N.getCurConfig().selectNew && (["circle", "ellipse", "square", "rect", "fhpath", "line", "fhellipse", "fhrect", "star", "polygon", "shapelib"].indexOf(N.getCurrentMode()) !== -1 && !r.altKey && N.setMode("select"), N.selectOnly([l], !0)), N.addCommandToHistory(new tU(l)), N.call("changed", [l]);
    }, g * 1e3);
  }
  N.setStartTransform(null);
}, aU = (r) => {
  const e = N.getSelectedElements(), A = r.target.parentNode;
  let n = N.getMouseTarget(r);
  const { tagName: i } = n;
  if (i === "text" && N.getCurrentMode() !== "textedit") {
    const s = zt(r.clientX, r.clientY, N.getrootSctm());
    N.textActions.select(n, s.x, s.y);
  }
  A !== N.getCurrentGroup() && ((i === "g" || i === "a") && MA(n) && (N.pushGroupProperties(n), n = e[0], N.clearSelection(!0)), N.getCurrentGroup() && Vs(), !(A.tagName !== "g" && A.tagName !== "a" || A === N.getCurrentDrawing().getCurrentLayer() || n === N.selectorManager.selectorParentGroup) && jS(n));
}, oU = (r) => {
  const e = N.getDataStorage(), t = N.getSelectedElements(), A = N.getZoom(), n = N.getStyle(), i = N.getSvgRoot(), { $id: s } = N;
  if (N.spaceKey || r.button === 1)
    return;
  const a = r.button === 2;
  r.altKey && N.cloneSelectedElements(0, 0), N.setRootSctm(s("svgcontent").querySelector("g").getScreenCTM().inverse());
  const o = zt(r.clientX, r.clientY, N.getrootSctm()), l = o.x * A, u = o.y * A;
  if (r.preventDefault(), a) {
    if (N.getCurrentMode() === "path")
      return;
    N.setCurrentMode("select"), N.setLastClickPoint(o);
  }
  let h = l / A, f = u / A, c = N.getMouseTarget(r);
  c.tagName === "a" && c.childNodes.length === 1 && (c = c.firstChild);
  const p = h;
  N.setStartX(h), N.setRStartX(h);
  const g = f;
  if (N.setStartY(f), N.setRStartY(f), N.getCurConfig().gridSnapping && (h = Ot(h), f = Ot(f), N.setStartX(Ot(N.getStartX())), N.setStartY(Ot(N.getStartY()))), c === N.selectorManager.selectorParentGroup && t[0]) {
    const B = r.target, S = e.get(B, "type");
    S === "rotate" ? N.setCurrentMode("rotate") : S === "resize" && (N.setCurrentMode("resize"), N.setCurrentResizeMode(e.get(B, "dir"))), c = t[0];
  }
  N.setStartTransform(c.getAttribute("transform"));
  const v = yr(c);
  if (v.numberOfItems > 1) {
    const B = v.getItem(0);
    v.removeItem(0), v.consolidate(), v.insertItemBefore(B, 0);
  }
  switch (N.getCurrentMode()) {
    case "select":
      if (N.setStarted(!0), N.setCurrentResizeMode("none"), a && N.setStarted(!1), c !== i) {
        if (t.includes(c) || (r.shiftKey || N.clearSelection(!0), N.addToSelection([c]), N.setJustSelected(c), N.pathActions.clear()), !a)
          for (const B of t) {
            if (!B)
              continue;
            const S = yr(B);
            S.numberOfItems ? S.insertItemBefore(i.createSVGTransform(), 0) : S.appendItem(i.createSVGTransform());
          }
      } else a || (N.clearSelection(), N.setCurrentMode("multiselect"), N.getRubberBox() || N.setRubberBox(N.selectorManager.getRubberBandBox()), N.setRStartX(N.getRStartX() * A), N.setRStartY(N.getRStartY() * A), qt(N.getRubberBox(), {
        x: N.getRStartX(),
        y: N.getRStartY(),
        width: 0,
        height: 0,
        display: "inline"
      }));
      break;
    case "zoom":
      N.setStarted(!0), N.getRubberBox() || N.setRubberBox(N.selectorManager.getRubberBandBox()), qt(N.getRubberBox(), {
        x: p * A,
        y: p * A,
        width: 0,
        height: 0,
        display: "inline"
      });
      break;
    case "resize": {
      N.setStarted(!0), N.setStartX(h), N.setStartY(f), N.setInitBbox(Nr(s("selectedBox0")));
      const B = {};
      for (const [C, E] of Object.entries(N.getInitBbox()))
        B[C] = E / A;
      N.setInitBbox(B);
      const S = MA(c) ? 1 : 0;
      Qo(v) ? (v.insertItemBefore(i.createSVGTransform(), S), v.insertItemBefore(i.createSVGTransform(), S), v.insertItemBefore(i.createSVGTransform(), S)) : (v.appendItem(i.createSVGTransform()), v.appendItem(i.createSVGTransform()), v.appendItem(i.createSVGTransform()));
      break;
    }
    case "fhellipse":
    case "fhrect":
    case "fhpath":
      N.setStart({ x: p, y: g }), N.setControllPoint1("x", 0), N.setControllPoint1("y", 0), N.setControllPoint2("x", 0), N.setControllPoint2("y", 0), N.setStarted(!0), N.setDAttr(p + "," + g + " "), N.addSVGElementsFromJson({
        element: "polyline",
        curStyles: !0,
        attr: {
          points: N.getDAttr(),
          id: N.getNextId(),
          fill: "none",
          opacity: n.opacity / 2,
          "stroke-linecap": "round",
          style: "pointer-events:none"
        }
      }), N.setFreehand("minx", p), N.setFreehand("maxx", p), N.setFreehand("miny", g), N.setFreehand("maxy", g);
      break;
    case "image": {
      N.setStarted(!0);
      const B = N.addSVGElementsFromJson({
        element: "image",
        attr: {
          x: h,
          y: f,
          width: 0,
          height: 0,
          id: N.getNextId(),
          opacity: n.opacity / 2,
          style: "pointer-events:inherit"
        }
      });
      Rn(B, N.getLastGoodImgUrl()), qm(B);
      break;
    }
    case "square":
    // TODO: once we create the rect, we lose information that this was a square
    // (for resizing purposes this could be important)
    // Fallthrough
    case "rect":
      N.setStarted(!0), N.setStartX(h), N.setStartY(f), N.addSVGElementsFromJson({
        element: "rect",
        curStyles: !0,
        attr: {
          x: h,
          y: f,
          width: 0,
          height: 0,
          id: N.getNextId(),
          opacity: n.opacity / 2
        }
      });
      break;
    case "line": {
      N.setStarted(!0);
      const B = Number(n.stroke_width) === 0 ? 1 : n.stroke_width;
      N.addSVGElementsFromJson({
        element: "line",
        curStyles: !0,
        attr: {
          x1: h,
          y1: f,
          x2: h,
          y2: f,
          id: N.getNextId(),
          stroke: n.stroke,
          "stroke-width": B,
          "stroke-dasharray": n.stroke_dasharray,
          "stroke-linejoin": n.stroke_linejoin,
          "stroke-linecap": n.stroke_linecap,
          "stroke-opacity": n.stroke_opacity,
          fill: "none",
          opacity: n.opacity / 2,
          style: "pointer-events:none"
        }
      });
      break;
    }
    case "circle":
      N.setStarted(!0), N.addSVGElementsFromJson({
        element: "circle",
        curStyles: !0,
        attr: {
          cx: h,
          cy: f,
          r: 0,
          id: N.getNextId(),
          opacity: n.opacity / 2
        }
      });
      break;
    case "ellipse":
      N.setStarted(!0), N.addSVGElementsFromJson({
        element: "ellipse",
        curStyles: !0,
        attr: {
          cx: h,
          cy: f,
          rx: 0,
          ry: 0,
          id: N.getNextId(),
          opacity: n.opacity / 2
        }
      });
      break;
    case "text":
      N.setStarted(!0), N.addSVGElementsFromJson({
        element: "text",
        curStyles: !0,
        attr: {
          x: h,
          y: f,
          id: N.getNextId(),
          fill: N.getCurText("fill"),
          "stroke-width": N.getCurText("stroke_width"),
          "font-size": N.getCurText("font_size"),
          "font-family": N.getCurText("font_family"),
          "text-anchor": "middle",
          "xml:space": "preserve",
          opacity: n.opacity
        }
      });
      break;
    case "path":
    // Fall through
    case "pathedit":
      N.setStartX(N.getStartX() * A), N.setStartY(N.getStartY() * A), N.pathActions.mouseDown(r, c, N.getStartX(), N.getStartY()), N.setStarted(!0);
      break;
    case "textedit":
      N.setStartX(N.getStartX() * A), N.setStartY(N.getStartY() * A), N.textActions.mouseDown(r, c, N.getStartX(), N.getStartY()), N.setStarted(!0);
      break;
    case "rotate":
      N.setStarted(!0), N.undoMgr.beginUndoableChange("transform", t);
      break;
  }
  N.runExtensions("mouseDown", {
    event: r,
    start_x: N.getStartX(),
    start_y: N.getStartY(),
    selectedElements: t
  }, !0).forEach((B) => {
    B?.started && N.setStarted(!0);
  });
}, lU = (r) => {
  const e = N.getZoom(), { $id: t } = N;
  if (!r.shiftKey)
    return;
  r.preventDefault(), N.setRootSctm(t("svgcontent").querySelector("g").getScreenCTM().inverse());
  const A = document.getElementById("workarea"), n = 15, i = N.getCurConfig().showRulers ? 16 : 0, s = zt(r.clientX, r.clientY, N.getrootSctm()), a = parseFloat(getComputedStyle(A, null).width.replace("px", "")), o = parseFloat(getComputedStyle(A, null).height.replace("px", "")), l = a - n - i, u = o - n - i, h = l * N.getrootSctm().a, f = u * N.getrootSctm().d, c = _4(A), p = c.left + i, g = c.top + i, v = r.wheelDelta ? r.wheelDelta : r.detail ? -r.detail : 0;
  if (!v)
    return;
  let w = Math.max(3 / 4, Math.min(4 / 3, v)), B, S;
  w > 1 ? (B = Math.ceil(l / h * w * 100) / 100, S = Math.ceil(u / f * w * 100) / 100) : (B = Math.floor(l / h * w * 100) / 100, S = Math.floor(u / f * w * 100) / 100);
  let C = Math.min(B, S);
  if (C = Math.min(10, Math.max(0.01, C)), C === e)
    return;
  w = C / e;
  const E = zt(p, g, N.getrootSctm()), _ = {
    x: s.x - (s.x - E.x) / w,
    y: s.y - (s.y - E.y) / w
  }, I = {
    x: _.x * C,
    y: _.y * C
  }, O = {
    x: I.x - i + a / 2,
    y: I.y - i + o / 2
  };
  N.setZoom(C), document.getElementById("zoom").value = (C * 100).toFixed(1), N.call("updateCanvas", { center: !1, newCtr: O }), N.call("zoomDone");
};
let Yc = null, G0 = null;
const uU = (r) => {
  Yc = r, G0 = r.getDOMDocument();
}, WS = (r) => {
  if (r.nodeType === 3) return r.nodeValue;
  const e = {
    element: r.tagName,
    // namespace: nsMap[data.namespaceURI],
    attr: {},
    children: []
  };
  for (let t = 0, A; A = r.attributes[t]; t++)
    e.attr[A.name] = A.value;
  for (let t = 0, A; A = r.childNodes[t]; t++)
    e.children[t] = WS(A);
  return e;
}, XS = (r) => {
  if (typeof r == "string") return G0.createTextNode(r);
  let e = Xt(r.attr.id);
  const t = Yc.getDrawing().getCurrentLayer();
  if (e && r.element !== e.tagName && (e.remove(), e = null), !e) {
    const n = r.namespace || nt.SVG;
    e = G0.createElementNS(n, r.element), t && (Yc.getCurrentGroup() || t).append(e);
  }
  const A = Yc.getCurShape();
  return r.curStyles && qt(e, {
    fill: A.fill,
    stroke: A.stroke,
    "stroke-width": A.stroke_width,
    "stroke-dasharray": A.stroke_dasharray,
    "stroke-linejoin": A.stroke_linejoin,
    "stroke-linecap": A.stroke_linecap,
    "stroke-opacity": A.stroke_opacity,
    "fill-opacity": A.fill_opacity,
    opacity: A.opacity / 2,
    style: "pointer-events:inherit"
  }), qt(e, r.attr), Ih(e), r.children && r.children.forEach((n) => {
    e.append(XS(n));
  }), e;
};
let le = null;
const cU = (r) => {
  le = r, le.getBold = EU, le.setBold = FU, le.getItalic = QU, le.setItalic = LU, le.hasTextDecoration = _U, le.addTextDecoration = UU, le.removeTextDecoration = IU, le.setTextAnchor = NU, le.setLetterSpacing = TU, le.setWordSpacing = PU, le.setTextLength = OU, le.setLengthAdjust = MU, le.getFontFamily = RU, le.setFontFamily = kU, le.setFontColor = HU, le.getFontColor = DU, le.getFontSize = GU, le.setFontSize = VU, le.getText = KU, le.setTextContent = jU, le.setImageURL = qU, le.setLinkURL = zU, le.setRectRadius = WU, le.makeHyperlink = XU, le.removeHyperlink = YU, le.setSegType = JU, le.setStrokeWidth = SU, le.getResolution = hU, le.getTitle = fU, le.setGroupTitle = dU, le.setStrokeAttr = xU, le.setBackground = $U, le.setDocumentTitle = gU, le.getEditorNS = mU, le.setResolution = pU, le.setBBoxZoom = vU, le.setCurrentZoom = wU, le.setColor = yU, le.setGradient = BU, le.setPaint = CU;
}, hU = () => {
  const r = le.getZoom(), e = le.getSvgContent().getAttribute("width") / r, t = le.getSvgContent().getAttribute("height") / r;
  return {
    w: e,
    h: t,
    zoom: r
  };
}, fU = (r) => {
  const e = le.getSelectedElements(), t = le.getDataStorage();
  if (r = r || e[0], !r)
    return;
  t.has(r, "gsvg") ? r = t.get(r, "gsvg") : t.has(r, "symbol") && (r = t.get(r, "symbol"));
  const A = r.childNodes;
  for (const n of A)
    if (n.nodeName === "title")
      return n.textContent;
  return "";
}, dU = (r) => {
  const {
    InsertElementCommand: e,
    RemoveElementCommand: t,
    ChangeElementCommand: A,
    BatchCommand: n
  } = le.history, i = le.getSelectedElements(), s = le.getDataStorage();
  let a = i[0];
  s.has(a, "gsvg") && (a = s.get(a, "gsvg"));
  const o = a.querySelectorAll("title"), l = new n("Set Label");
  let u;
  if (r.length === 0) {
    const h = o.nextSibling;
    l.addSubCommand(new t(o[0], h, a)), o.remove();
  } else o.length ? (u = o[0], l.addSubCommand(new A(u, { "#text": u.textContent })), u.textContent = r) : (u = le.getDOMDocument().createElementNS(nt.SVG, "title"), u.textContent = r, a.insertBefore(u, a.firstChild), l.addSubCommand(new e(u)));
  le.addCommandToHistory(l);
}, gU = (r) => {
  const { ChangeElementCommand: e, BatchCommand: t } = le.history, A = le.getSvgContent().childNodes;
  let n = !1, i = "";
  const s = new t("Change Image Title");
  for (const a of A)
    if (a.nodeName === "title") {
      n = a, i = n.textContent;
      break;
    }
  n || (n = le.getDOMDocument().createElementNS(nt.SVG, "title"), le.getSvgContent().insertBefore(n, le.getSvgContent().firstChild)), r.length ? n.textContent = r : n.remove(), s.addSubCommand(new e(n, { "#text": i })), le.addCommandToHistory(s);
}, pU = (r, e) => {
  const { ChangeElementCommand: t, BatchCommand: A } = le.history, n = le.getZoom(), i = le.getResolution(), { w: s, h: a } = i;
  let o;
  if (r === "fit") {
    const l = Mn();
    if (l) {
      o = new A("Fit Canvas to Content");
      const u = iu();
      le.addToSelection(u);
      const h = [], f = [];
      u.forEach((p, g) => {
        h.push(l.x * -1), f.push(l.y * -1);
      });
      const c = le.moveSelectedElements(h, f, !0);
      o.addSubCommand(c), le.clearSelection(), r = Math.round(l.width), e = Math.round(l.height);
    } else
      return !1;
  }
  return (r !== s || e !== a) && (o || (o = new A("Change Image Dimensions")), r = xA("width", r), e = xA("height", e), le.getSvgContent().setAttribute("width", r), le.getSvgContent().setAttribute("height", e), le.contentW = r, le.contentH = e, o.addSubCommand(new t(le.getSvgContent(), { width: s, height: a })), le.getSvgContent().setAttribute("viewBox", [0, 0, r / n, e / n].join(" ")), o.addSubCommand(new t(le.getSvgContent(), { viewBox: ["0 0", s, a].join(" ") })), le.addCommandToHistory(o), le.call("changed", [le.getSvgContent()])), !0;
}, mU = (r) => (r && le.getSvgContent().setAttribute("xmlns:se", nt.SE), nt.SE), vU = (r, e, t) => {
  const A = le.getZoom(), n = le.getSelectedElements();
  let i = 0.85, s;
  const a = (o) => {
    if (!o)
      return !1;
    const l = Math.round(e / o.width * 100 * i) / 100, u = Math.round(t / o.height * 100 * i) / 100, h = Math.min(l, u);
    return le.setZoom(h), { zoom: h, bbox: o };
  };
  if (typeof r == "object") {
    if (s = r, s.width === 0 || s.height === 0) {
      const o = s.zoom ? s.zoom : A * s.factor;
      return le.setZoom(o), { zoom: A, bbox: s };
    }
    return a(s);
  }
  switch (r) {
    case "selection": {
      if (!n[0])
        return;
      const o = n.map((l, u) => {
        if (l)
          return l;
      });
      s = Mn(o);
      break;
    }
    case "canvas": {
      const o = le.getResolution();
      i = 0.95, s = { width: o.w, height: o.h, x: 0, y: 0 };
      break;
    }
    case "content":
      s = Mn();
      break;
    case "layer":
      s = Mn(iu(le.getCurrentDrawing().getCurrentLayer()));
      break;
    default:
      return;
  }
  return a(s);
}, wU = (r) => {
  const e = le.getSelectedElements(), t = le.getResolution();
  le.getSvgContent().setAttribute("viewBox", "0 0 " + t.w / r + " " + t.h / r), le.setZoom(r), e.forEach((A) => {
    A && le.selectorManager.requestSelector(A).resize();
  }), le.pathActions.zoomChange(), le.runExtensions("zoomChanged", r);
}, yU = (r, e, t) => {
  const A = le.getSelectedElements();
  le.setCurShape(r, e), le.setCurProperties(r + "_paint", { type: "solidColor" });
  const n = [], i = (a) => {
    a.nodeName !== "g" && n.push(a);
  };
  let s = A.length;
  for (; s--; ) {
    const a = A[s];
    a && (a.tagName === "g" ? rs(a, i) : r === "fill" ? a.tagName !== "polyline" && a.tagName !== "line" && n.push(a) : n.push(a));
  }
  n.length > 0 && (t ? le.changeSelectedAttributeNoUndo(r, e, n) : (le.changeSelectedAttribute(r, e, n), le.call("changed", n)));
}, BU = (r) => {
  if (!le.getCurProperties(r + "_paint") || le.getCurProperties(r + "_paint").type === "solidColor")
    return;
  let t = le[r + "Grad"];
  const A = bU(t), n = Cn();
  A ? t = A : (t = le.getDOMDocument().importNode(t, !0), n.append(t), t.id = le.getNextId()), le.setColor(r, "url(#" + t.id + ")");
}, bU = (r) => {
  const t = Cn().querySelectorAll("linearGradient, radialGradient");
  let A = t.length;
  const n = ["r", "cx", "cy", "fx", "fy"];
  for (; A--; ) {
    const i = t[A];
    if (r.tagName === "linearGradient") {
      if (r.getAttribute("x1") !== i.getAttribute("x1") || r.getAttribute("y1") !== i.getAttribute("y1") || r.getAttribute("x2") !== i.getAttribute("x2") || r.getAttribute("y2") !== i.getAttribute("y2"))
        continue;
    } else {
      const l = {
        r: Number(r.getAttribute("r")),
        cx: Number(r.getAttribute("cx")),
        cy: Number(r.getAttribute("cy")),
        fx: Number(r.getAttribute("fx")),
        fy: Number(r.getAttribute("fy"))
      }, u = {
        r: Number(i.getAttribute("r")),
        cx: Number(i.getAttribute("cx")),
        cy: Number(i.getAttribute("cy")),
        fx: Number(i.getAttribute("fx")),
        fy: Number(i.getAttribute("fy"))
      };
      let h = !1;
      if (n.forEach((f) => {
        l[f] !== u[f] && (h = !0);
      }), h)
        continue;
    }
    const s = r.getElementsByTagNameNS(nt.SVG, "stop"), a = i.getElementsByTagNameNS(nt.SVG, "stop");
    if (s.length !== a.length)
      continue;
    let o = s.length;
    for (; o--; ) {
      const l = s[o], u = a[o];
      if (l.getAttribute("offset") !== u.getAttribute("offset") || l.getAttribute("stop-opacity") !== u.getAttribute("stop-opacity") || l.getAttribute("stop-color") !== u.getAttribute("stop-color"))
        break;
    }
    if (o === -1)
      return i;
  }
  return null;
}, CU = (r, e) => {
  const t = new uS(e);
  switch (le.setPaintOpacity(r, t.alpha / 100, !0), le.setCurProperties(r + "_paint", t), t.type) {
    case "solidColor":
      le.setColor(r, t.solidColor !== "none" ? "#" + t.solidColor : "none");
      break;
    case "linearGradient":
    case "radialGradient":
      le.setCanvas(r + "Grad", t[t.type]), le.setGradient(r);
      break;
  }
}, SU = (r) => {
  const e = le.getSelectedElements();
  if (r === 0 && ["line", "path"].includes(le.getMode())) {
    le.setStrokeWidth(1);
    return;
  }
  le.setCurProperties("stroke_width", r);
  const t = [], A = (i) => {
    i.nodeName !== "g" && t.push(i);
  };
  let n = e.length;
  for (; n--; ) {
    const i = e[n];
    i && (i.tagName === "g" ? rs(i, A) : t.push(i));
  }
  t.length > 0 && (le.changeSelectedAttribute("stroke-width", r, t), le.call("changed", e));
}, xU = (r, e) => {
  const t = le.getSelectedElements();
  le.setCurShape(r.replace("-", "_"), e);
  const A = [];
  let n = t.length;
  for (; n--; ) {
    const i = t[n];
    i && (i.tagName === "g" ? rs(i, (s) => {
      s.nodeName !== "g" && A.push(s);
    }) : A.push(i));
  }
  A.length > 0 && (le.changeSelectedAttribute(r, e, A), le.call("changed", t));
}, EU = () => le.getSelectedElements().filter((t) => t?.tagName === "text").every((t) => t.getAttribute("font-weight") === "bold"), FU = (r) => {
  const t = le.getSelectedElements().filter((A) => A?.tagName === "text");
  le.changeSelectedAttribute("font-weight", r ? "bold" : "normal", t), t.some((A) => A.textContent) || le.textActions.setCursor();
}, _U = (r) => le.getSelectedElements().filter((A) => A?.tagName === "text").every((A) => (A.getAttribute("text-decoration") || "").includes(r)), UU = (r) => {
  const { ChangeElementCommand: e, BatchCommand: t } = le.history, n = le.getSelectedElements().filter((s) => s?.tagName === "text"), i = new t();
  n.forEach((s) => {
    const a = s.getAttribute("text-decoration") || "";
    a.includes(r) || (i.addSubCommand(new e(s, { "text-decoration": a })), le.changeSelectedAttributeNoUndo("text-decoration", (a + " " + r).trim(), [s]));
  }), i.isEmpty() || le.undoMgr.addCommandToHistory(i), n.some((s) => s.textContent) || le.textActions.setCursor();
}, IU = (r) => {
  const { ChangeElementCommand: e, BatchCommand: t } = le.history, n = le.getSelectedElements().filter((s) => s?.tagName === "text"), i = new t();
  n.forEach((s) => {
    const a = s.getAttribute("text-decoration") || "";
    i.addSubCommand(new e(s, { "text-decoration": a })), le.changeSelectedAttributeNoUndo("text-decoration", a.replace(r, "").trim(), [s]);
  }), i.isEmpty() || le.undoMgr.addCommandToHistory(i), n.some((s) => s.textContent) || le.textActions.setCursor();
}, QU = () => le.getSelectedElements().filter((t) => t?.tagName === "text").every((t) => t.getAttribute("font-style") === "italic"), LU = (r) => {
  const t = le.getSelectedElements().filter((A) => A?.tagName === "text");
  le.changeSelectedAttribute("font-style", r ? "italic" : "normal", t), t.some((A) => A.textContent) || le.textActions.setCursor();
}, NU = (r) => {
  const t = le.getSelectedElements().filter((A) => A?.tagName === "text");
  le.changeSelectedAttribute("text-anchor", r, t);
}, TU = (r) => {
  const t = le.getSelectedElements().filter((A) => A?.tagName === "text");
  le.changeSelectedAttribute("letter-spacing", r, t), t.some((A) => A.textContent) || le.textActions.setCursor();
}, PU = (r) => {
  const t = le.getSelectedElements().filter((A) => A?.tagName === "text");
  le.changeSelectedAttribute("word-spacing", r, t), t.some((A) => A.textContent) || le.textActions.setCursor();
}, OU = (r) => {
  const t = le.getSelectedElements().filter((A) => A?.tagName === "text");
  le.changeSelectedAttribute("textLength", r, t), t.some((A) => A.textContent) || le.textActions.setCursor();
}, MU = (r) => {
  const t = le.getSelectedElements().filter((A) => A?.tagName === "text");
  le.changeSelectedAttribute("lengthAdjust", r, t), t.some((A) => A.textContent) || le.textActions.setCursor();
}, RU = () => le.getCurText("font_family"), kU = (r) => {
  const t = le.getSelectedElements().filter((A) => A?.tagName === "text");
  le.setCurText("font_family", r), le.changeSelectedAttribute("font-family", r, t), t.some((A) => A.textContent) || le.textActions.setCursor();
}, HU = (r) => {
  le.setCurText("fill", r), le.changeSelectedAttribute("fill", r);
}, DU = () => le.getCurText("fill"), GU = () => le.getCurText("font_size"), VU = (r) => {
  const e = le.getSelectedElements();
  le.setCurText("font_size", r), le.changeSelectedAttribute("font-size", r), e[0]?.textContent || le.textActions.setCursor();
}, KU = () => {
  const e = le.getSelectedElements()[0];
  return e ? e.textContent : "";
}, jU = (r) => {
  le.changeSelectedAttribute("#text", r), le.textActions.init(r), le.textActions.setCursor();
}, qU = (r) => {
  const { ChangeElementCommand: e, BatchCommand: t } = le.history, n = le.getSelectedElements()[0];
  if (!n)
    return;
  const i = {
    width: n.getAttribute("width"),
    height: n.getAttribute("height")
  }, s = !i.width || !i.height, a = $i(n);
  if (a === r && !s)
    return;
  const o = new t("Change Image URL");
  Rn(n, r), o.addSubCommand(new e(n, {
    "#href": a
  }));
  const l = new Image();
  l.onload = function() {
    const u = {
      width: n.getAttribute("width"),
      height: n.getAttribute("height")
    };
    n.setAttribute("width", this.width), n.setAttribute("height", this.height), le.selectorManager.requestSelector(n).resize(), o.addSubCommand(new e(n, u)), le.addCommandToHistory(o), le.call("changed", [n]);
  }, l.src = r;
}, zU = (r) => {
  const { ChangeElementCommand: e, BatchCommand: t } = le.history;
  let n = le.getSelectedElements()[0];
  if (!n)
    return;
  if (n.tagName !== "a") {
    const a = nu(n.parentNode, "a");
    if (a?.length)
      n = a[0];
    else
      return;
  }
  const i = $i(n);
  if (i === r)
    return;
  const s = new t("Change Link URL");
  Rn(n, r), s.addSubCommand(new e(n, {
    "#href": i
  })), le.addCommandToHistory(s);
}, WU = (r) => {
  const { ChangeElementCommand: e } = le.history, A = le.getSelectedElements()[0];
  if (A?.tagName === "rect") {
    const n = Number(A.getAttribute("rx"));
    n !== r && (A.setAttribute("rx", r), A.setAttribute("ry", r), le.addCommandToHistory(new e(A, { rx: n, ry: n }, "Radius")), le.call("changed", [A]));
  }
}, XU = (r) => {
  le.groupSelectedElements("a", r);
}, YU = () => {
  le.ungroupSelectedElement();
}, JU = (r) => {
  le.pathActions.setSegType(r);
}, $U = (r, e) => {
  const t = Xt("canvasBackground"), A = t.querySelector("rect");
  let n = Xt("background_image"), i = Xt("background_pattern");
  if (A.setAttribute("fill", r === "chessboard" ? "#fff" : r), r === "chessboard") {
    if (!i) {
      i = le.getDOMDocument().createElementNS(nt.SVG, "foreignObject"), le.assignAttributes(i, {
        id: "background_pattern",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMinYMin",
        style: "pointer-events:none"
      });
      const s = document.createElement("div");
      le.assignAttributes(s, {
        style: "pointer-events:none;width:100%;height:100%;background-image:url(data:image/gif;base64,R0lGODlhEAAQAIAAAP///9bW1iH5BAAAAAAALAAAAAAQABAAAAIfjG+gq4jM3IFLJgpswNly/XkcBpIiVaInlLJr9FZWAQA7);"
      }), i.append(s), t.append(i);
    }
  } else i && i.remove();
  e ? (n || (n = le.getDOMDocument().createElementNS(nt.SVG, "image"), le.assignAttributes(n, {
    id: "background_image",
    width: "100%",
    height: "100%",
    preserveAspectRatio: "xMinYMin",
    style: "pointer-events:none"
  })), Rn(n, e), t.append(n)) : n && n.remove();
};
let Sl = null;
const ZU = (r) => {
  Sl = r;
}, eI = [
  0,
  "z",
  "M",
  "m",
  "L",
  "l",
  "C",
  "c",
  "Q",
  "q",
  "A",
  "a",
  "H",
  "h",
  "V",
  "v",
  "S",
  "s",
  "T",
  "t"
], xl = (r, e, t) => {
  const A = (u, h) => zt(u, h, t), n = (u) => t.a * u, i = (u) => t.d * u, s = Sl.getGridSnapping() && r.parentNode.parentNode.localName === "svg", a = () => {
    s && Object.entries(e).forEach(([u, h]) => {
      e[u] = Ot(h);
    }), qt(r, e, 1e3, !0);
  }, o = Nr(r);
  ["fill", "stroke"].forEach((u) => {
    const h = r.getAttribute(u);
    if (h?.startsWith("url(") && (t.a < 0 || t.d < 0)) {
      const c = Ua(h).cloneNode(!0);
      if (t.a < 0) {
        const p = c.getAttribute("x1"), g = c.getAttribute("x2");
        c.setAttribute("x1", -(p - 1)), c.setAttribute("x2", -(g - 1));
      }
      if (t.d < 0) {
        const p = c.getAttribute("y1"), g = c.getAttribute("y2");
        c.setAttribute("y1", -(p - 1)), c.setAttribute("y2", -(g - 1));
      }
      c.id = Sl.getCurrentDrawing().getNextId(), Cn().append(c), r.setAttribute(u, "url(#" + c.id + ")");
    }
  });
  const l = r.tagName;
  if (l !== "use")
    switch (l) {
      case "foreignObject":
      case "rect":
      case "image": {
        if (l === "image" && (t.a < 0 || t.d < 0)) {
          const u = yr(r), h = Sl.getSvgRoot().createSVGTransform();
          h.setMatrix(wn(vr(u).matrix, t)), u.clear(), u.appendItem(h);
        } else {
          const u = A(e.x, e.y);
          e.width = n(e.width), e.height = i(e.height), e.x = u.x + Math.min(0, e.width), e.y = u.y + Math.min(0, e.height), e.width = Math.abs(e.width), e.height = Math.abs(e.height);
        }
        a();
        break;
      }
      case "ellipse": {
        const u = A(e.cx, e.cy);
        e.cx = u.x, e.cy = u.y, e.rx = Math.abs(n(e.rx)), e.ry = Math.abs(i(e.ry)), a();
        break;
      }
      case "circle": {
        const u = A(e.cx, e.cy);
        e.cx = u.x, e.cy = u.y;
        const h = Vm(o.x, o.y, o.width, o.height, t), f = h.tr.x - h.tl.x, c = h.bl.y - h.tl.y;
        e.r = Math.min(Math.abs(f / 2), Math.abs(c / 2)), a();
        break;
      }
      case "line": {
        const u = A(e.x1, e.y1), h = A(e.x2, e.y2);
        e.x1 = u.x, e.y1 = u.y, e.x2 = h.x, e.y2 = h.y, a();
        break;
      }
      case "text": {
        const u = A(e.x, e.y);
        e.x = u.x, e.y = u.y;
        let h = r.getAttribute("font-size");
        h || (h = window.getComputedStyle(r).fontSize);
        const f = parseFloat(h);
        isNaN(f) || (e["font-size"] = f * Math.abs(t.a)), a();
        const c = r.childNodes;
        for (let p = 0; p < c.length; p++) {
          const g = c[p];
          if (g.nodeType === 1 && g.tagName === "tspan") {
            const v = {}, w = g.hasAttribute("x"), B = g.hasAttribute("y");
            if (w) {
              const E = xA("x", g.getAttribute("x")), _ = A(E, e.y).x;
              v.x = _;
            }
            if (B) {
              const E = xA("y", g.getAttribute("y")), _ = A(e.x, E).y;
              v.y = _;
            }
            let S = g.getAttribute("font-size");
            S || (S = window.getComputedStyle(g).fontSize);
            const C = parseFloat(S);
            isNaN(C) || (v["font-size"] = C * Math.abs(t.a)), (w || B || v["font-size"]) && qt(g, v, 1e3, !0);
          }
        }
        break;
      }
      case "tspan": {
        const u = A(e.x, e.y);
        e.x = u.x, e.y = u.y;
        let h = r.getAttribute("font-size");
        h || (h = window.getComputedStyle(r).fontSize);
        const f = parseFloat(h);
        isNaN(f) || (e["font-size"] = f * Math.abs(t.a)), a();
        break;
      }
      case "g": {
        const h = Sl.getDataStorage().get(r, "gsvg");
        h && qt(h, e, 1e3, !0);
        break;
      }
      case "polyline":
      case "polygon": {
        e.points.forEach((h) => {
          const { x: f, y: c } = A(h.x, h.y);
          h.x = f, h.y = c;
        });
        const u = e.points.map((h) => `${h.x},${h.y}`).join(" ");
        r.setAttribute("points", u);
        break;
      }
      case "path": {
        const u = r.pathSegList, h = u.numberOfItems;
        e.d = [];
        for (let g = 0; g < h; ++g) {
          const v = u.getItem(g);
          e.d[g] = {
            type: v.pathSegType,
            x: v.x,
            y: v.y,
            x1: v.x1,
            y1: v.y1,
            x2: v.x2,
            y2: v.y2,
            r1: v.r1,
            r2: v.r2,
            angle: v.angle,
            largeArcFlag: v.largeArcFlag,
            sweepFlag: v.sweepFlag
          };
        }
        const f = e.d[0];
        let c;
        h > 0 && (c = A(f.x, f.y), e.d[0].x = c.x, e.d[0].y = c.y);
        for (let g = 1; g < h; ++g) {
          const v = e.d[g], { type: w } = v;
          if (w % 2 === 0) {
            const B = v.x !== void 0 ? v.x : c.x, S = v.y !== void 0 ? v.y : c.y, C = A(B, S), E = A(v.x1, v.y1), _ = A(v.x2, v.y2);
            v.x = C.x, v.y = C.y, v.x1 = E.x, v.y1 = E.y, v.x2 = _.x, v.y2 = _.y, v.r1 = n(v.r1), v.r2 = i(v.r2);
          } else
            v.x = n(v.x), v.y = i(v.y), v.x1 = n(v.x1), v.y1 = i(v.y1), v.x2 = n(v.x2), v.y2 = i(v.y2), v.r1 = n(v.r1), v.r2 = i(v.r2);
        }
        let p = "";
        e.d.forEach((g) => {
          const { type: v } = g;
          switch (p += eI[v], v) {
            case 13:
            // relative horizontal line (h)
            case 12:
              p += g.x + " ";
              break;
            case 15:
            // relative vertical line (v)
            case 14:
              p += g.y + " ";
              break;
            case 3:
            // relative move (m)
            case 5:
            // relative line (l)
            case 19:
            // relative smooth quad (t)
            case 2:
            // absolute move (M)
            case 4:
            // absolute line (L)
            case 18:
              p += g.x + "," + g.y + " ";
              break;
            case 7:
            // relative cubic (c)
            case 6:
              p += g.x1 + "," + g.y1 + " " + g.x2 + "," + g.y2 + " " + g.x + "," + g.y + " ";
              break;
            case 9:
            // relative quad (q)
            case 8:
              p += g.x1 + "," + g.y1 + " " + g.x + "," + g.y + " ";
              break;
            case 11:
            // relative elliptical arc (a)
            case 10:
              p += g.r1 + "," + g.r2 + " " + g.angle + " " + Number(g.largeArcFlag) + " " + Number(g.sweepFlag) + " " + g.x + "," + g.y + " ";
              break;
            case 17:
            // relative smooth cubic (s)
            case 16:
              p += g.x2 + "," + g.y2 + " " + g.x + "," + g.y + " ";
              break;
          }
        }), r.setAttribute("d", p.trim());
        break;
      }
    }
};
let Jc;
const tI = (r) => {
  Jc = r;
}, Qa = (r) => {
  if (!r) return null;
  const e = Jc.getSvgRoot(), t = Jc.getDataStorage(), A = yr(r);
  if (A?.numberOfItems > 0) {
    let h = A.numberOfItems;
    const f = h;
    for (; h--; ) {
      const c = A.getItem(h);
      if (c.type === SVGTransform.SVG_TRANSFORM_MATRIX) {
        if (dS(c.matrix)) {
          if (f === 1)
            return r.removeAttribute("transform"), null;
          A.removeItem(h);
        }
      } else (c.type === SVGTransform.SVG_TRANSFORM_ROTATE && c.angle === 0 || c.type === SVGTransform.SVG_TRANSFORM_TRANSLATE && c.matrix.e === 0 && c.matrix.f === 0) && A.removeItem(h);
    }
    if (A.numberOfItems === 1 && MA(r))
      return null;
  }
  if (!A || A.numberOfItems === 0)
    return r.removeAttribute("transform"), null;
  if (r.tagName === "use")
    return null;
  const n = new su("Transform");
  switch (r.tagName) {
    // Ignore these elements, as they can absorb the [M] transformation
    case "line":
    case "polyline":
    case "polygon":
    case "path":
      break;
    default:
      if (A.numberOfItems === 1 && A.getItem(0).type === SVGTransform.SVG_TRANSFORM_MATRIX || A.numberOfItems === 2 && A.getItem(0).type === SVGTransform.SVG_TRANSFORM_MATRIX && A.getItem(1).type === SVGTransform.SVG_TRANSFORM_ROTATE)
        return null;
  }
  const i = t.has(r, "gsvg") ? t.get(r, "gsvg") : void 0;
  let s = {}, a = null, o = [];
  switch (r.tagName) {
    case "line":
      o = ["x1", "y1", "x2", "y2"];
      break;
    case "circle":
      o = ["cx", "cy", "r"];
      break;
    case "ellipse":
      o = ["cx", "cy", "rx", "ry"];
      break;
    case "foreignObject":
    case "rect":
    case "image":
      o = ["width", "height", "x", "y"];
      break;
    case "text":
    case "tspan":
      o = ["x", "y"];
      break;
    case "polygon":
    case "polyline": {
      a = {}, a.points = r.getAttribute("points");
      const h = r.points, f = h.numberOfItems;
      s.points = new Array(f);
      for (let c = 0; c < f; ++c) {
        const p = h.getItem(c);
        s.points[c] = { x: p.x, y: p.y };
      }
      break;
    }
    case "path":
      a = {}, a.d = r.getAttribute("d"), s.d = r.getAttribute("d");
      break;
  }
  if (o.length ? o.forEach((h) => {
    s[h] = xA(h, r.getAttribute(h));
  }) : i && (s = {
    x: Number(i.getAttribute("x")) || 0,
    y: Number(i.getAttribute("y")) || 0
  }), !a) {
    a = ru({}, s);
    for (const [h, f] of Object.entries(a))
      a[h] = xA(h, f);
  }
  a.transform = Jc.getStartTransform() || "";
  let l, u;
  if (!(r.tagName === "g" && !i || r.tagName === "a")) {
    const h = Nr(r);
    if (!h && r.tagName !== "path") return null;
    let f, c = 0, p = 0;
    ["use", "image", "text", "tspan"].includes(r.tagName) && (c = xA("x", r.getAttribute("x") || "0"), p = xA("y", r.getAttribute("y") || "0"));
    const g = MA(r);
    if (g) {
      if (r.localName === "image") {
        const w = xA("x", r.getAttribute("x") || "0"), B = xA("y", r.getAttribute("y") || "0"), S = xA("width", r.getAttribute("width") || "0"), C = xA("height", r.getAttribute("height") || "0"), E = w + S / 2, _ = B + C / 2;
        l = { x: E, y: _ };
        const I = vr(A).matrix;
        u = zt(E, _, I);
      } else if (r.localName === "text") {
        const w = h.x + h.width / 2, B = h.y + h.height / 2;
        l = { x: w, y: B }, u = zt(w, B, vr(A).matrix);
      } else
        l = {
          x: h.x + h.width / 2 + c,
          y: h.y + h.height / 2 + p
        }, u = zt(
          h.x + h.width / 2 + c,
          h.y + h.height / 2 + p,
          vr(A).matrix
        );
      for (let w = 0; w < A.numberOfItems; ++w)
        if (A.getItem(w).type === SVGTransform.SVG_TRANSFORM_ROTATE) {
          A.removeItem(w);
          break;
        }
    }
    const v = A.numberOfItems;
    if (v >= 3 && A.getItem(v - 3).type === SVGTransform.SVG_TRANSFORM_TRANSLATE && A.getItem(v - 2).type === SVGTransform.SVG_TRANSFORM_SCALE && A.getItem(v - 1).type === SVGTransform.SVG_TRANSFORM_TRANSLATE) {
      if (f = vr(A, v - 3, v - 1).matrix, A.removeItem(v - 1), A.removeItem(v - 2), A.removeItem(v - 3), r.tagName === "use") {
        const w = vr(
          yr(r)
        ).matrix, B = wn(w, f);
        A.clear();
        const S = e.createSVGTransform();
        S.setMatrix(B), A.appendItem(S);
      } else
        xl(r, s, f);
      if (g) {
        const w = vr(A).matrix, B = e.createSVGTransform();
        B.setRotate(g, l.x, l.y);
        const S = B.matrix, C = e.createSVGTransform();
        C.setRotate(g, u.x, u.y);
        const E = C.matrix.inverse(), _ = w.inverse(), I = wn(
          _,
          E,
          S,
          w
        );
        xl(r, s, I), A.numberOfItems ? A.insertItemBefore(C, 0) : A.appendItem(C);
      }
    } else if ((v === 1 || v > 1 && A.getItem(1).type !== SVGTransform.SVG_TRANSFORM_SCALE) && A.getItem(0).type === SVGTransform.SVG_TRANSFORM_TRANSLATE) {
      const w = A.getItem(0).matrix, B = vr(A, 1).matrix, S = B.inverse();
      if (f = wn(
        S,
        w,
        B
      ), A.removeItem(0), r.tagName === "use") {
        const C = vr(
          yr(r)
        ).matrix, E = wn(C, f);
        A.clear();
        const _ = e.createSVGTransform();
        _.setMatrix(E), A.appendItem(_);
      } else
        xl(r, s, f);
      if (g) {
        Qo(A) || (u = {
          x: l.x + f.e,
          y: l.y + f.f
        });
        const C = e.createSVGTransform();
        C.setRotate(g, u.x, u.y), A.numberOfItems ? A.insertItemBefore(C, 0) : A.appendItem(C);
      }
    } else if (v === 1 && A.getItem(0).type === SVGTransform.SVG_TRANSFORM_MATRIX && !g)
      if (f = vr(A).matrix, A.clear(), r.tagName === "use") {
        const w = vr(
          yr(r)
        ).matrix, B = wn(w, f);
        A.clear();
        const S = e.createSVGTransform();
        S.setMatrix(B), A.appendItem(S);
      } else
        xl(r, s, f);
    else {
      if (g) {
        const w = e.createSVGTransform();
        w.setRotate(g, u.x, u.y), A.numberOfItems ? A.insertItemBefore(w, 0) : A.appendItem(w);
      }
      return A.numberOfItems === 0 && r.removeAttribute("transform"), null;
    }
  }
  return A.numberOfItems === 0 && r.removeAttribute("transform"), n.addSubCommand(new No(r, a)), n;
};
const {
  MoveElementCommand: ou,
  BatchCommand: Ks,
  InsertElementCommand: Zm,
  RemoveElementCommand: Xl,
  ChangeElementCommand: YS
} = Pa;
let Se = null;
const rI = (r) => {
  Se = r, Se.copySelectedElements = fI, Se.groupSelectedElements = dI, Se.pushGroupProperties = tv, Se.ungroupSelectedElement = gI, Se.moveToTopSelectedElement = AI, Se.moveToBottomSelectedElement = nI, Se.moveUpDownSelected = iI, Se.moveSelectedElements = ev, Se.cloneSelectedElements = sI, Se.alignSelectedElements = aI, Se.updateCanvas = pI, Se.cycleElement = mI, Se.deleteSelectedElements = cI, Se.flipSelectedElements = hI;
}, AI = () => {
  const [r] = Se.getSelectedElements();
  if (r) {
    const e = r, t = e.parentNode, A = e.nextSibling;
    e.parentNode.append(e), A !== e.nextSibling && (Se.addCommandToHistory(
      new ou(e, A, t, "top")
    ), Se.call("changed", [e]));
  }
}, nI = () => {
  const [r] = Se.getSelectedElements();
  if (r) {
    let e = r;
    const t = e.parentNode, A = e.nextSibling;
    let { firstChild: n } = e.parentNode;
    n.tagName === "title" && (n = n.nextSibling), n.tagName === "defs" && (n = n.nextSibling), e = e.parentNode.insertBefore(e, n), A !== e.nextSibling && (Se.addCommandToHistory(
      new ou(e, A, t, "bottom")
    ), Se.call("changed", [e]));
  }
}, iI = (r) => {
  const t = Se.getSelectedElements()[0];
  if (!t)
    return;
  Se.setCurBBoxes([]);
  let A, n;
  const i = Se.getIntersectionList(
    Mn([t])
  );
  if (r === "Down" && i.reverse(), Array.prototype.forEach.call(i, (l) => n ? (A === void 0 && (A = l), !1) : (l === t && (n = !0), !0)), !A)
    return;
  const s = t, a = s.parentNode, o = s.nextSibling;
  r === "Down" ? A.insertAdjacentElement("beforebegin", s) : A.insertAdjacentElement("afterend", s), o !== s.nextSibling && (Se.addCommandToHistory(
    new ou(s, o, a, "Move " + r)
  ), Se.call("changed", [s]));
}, ev = (r, e, t = !0) => {
  const A = Se.getSelectedElements(), n = Se.getZoom();
  Array.isArray(r) || (r /= n, e /= n);
  const i = new Ks("position");
  if (A.forEach((s, a) => {
    if (s) {
      const o = Se.getSvgRoot().createSVGTransform(), l = yr(s);
      Array.isArray(r) ? o.setTranslate(r[a], e[a]) : o.setTranslate(r, e), l.numberOfItems ? l.insertItemBefore(o, 0) : l.appendItem(o);
      const u = Qa(s);
      u && i.addSubCommand(u), Se.gettingSelectorManager().requestSelector(s).resize();
    }
  }), !i.isEmpty())
    return t && Se.addCommandToHistory(i), Se.call("changed", A), i;
}, sI = (r, e) => {
  const t = Se.getSelectedElements(), A = Se.getCurrentGroup();
  let n, i;
  const s = new Ks("Clone Elements"), a = t.length, o = (f) => {
    if (!f) return -1;
    let c = 0;
    do
      c++;
    while (f === f.previousElementSibling);
    return c;
  }, l = (f, c) => o(c) - o(f);
  for (t.sort(l), n = 0; n < a && (i = t[n], !!i); ++n)
    ;
  const u = t.slice(0, n);
  Se.clearSelection(!0);
  const h = Se.getDrawing();
  for (n = u.length; n--; )
    i = u[n] = h.copyElem(u[n]), (A || h.getCurrentLayer()).append(i), s.addSubCommand(new Zm(i));
  s.isEmpty() || (Se.addToSelection(u.reverse()), ev(r, e, !1), Se.addCommandToHistory(s));
}, aI = (r, e) => {
  const t = Se.getSelectedElements(), A = [], n = t.length;
  if (!n)
    return;
  let i = Number.MAX_VALUE, s = Number.MIN_VALUE, a = Number.MAX_VALUE, o = Number.MIN_VALUE;
  const l = (c) => ["l", "c", "r", "left", "center", "right"].includes(c), u = (c) => ["t", "m", "b", "top", "middle", "bottom"].includes(c);
  for (let c = 0; c < n && t[c]; ++c) {
    const p = t[c];
    A[c] = Mn([p]);
  }
  switch (["smallest", "largest"].includes(e) && ["dh", "distrib_horiz", "dv", "distrib_verti"].includes(r) && (e = "selected"), e) {
    case "smallest":
      if (l(r) || u(r)) {
        const p = A.slice().sort((g, v) => g.width - v.width)[0];
        i = p.x, a = p.y, s = p.x + p.width, o = p.y + p.height;
      }
      break;
    case "largest":
      if (l(r) || u(r)) {
        const p = A.slice().sort((g, v) => g.width - v.width)[A.length - 1];
        i = p.x, a = p.y, s = p.x + p.width, o = p.y + p.height;
      }
      break;
    case "page":
      i = 0, a = 0, s = Se.getContentW(), o = Se.getContentH();
      break;
    default:
      i = Math.min(...A.map((c) => c.x)), a = Math.min(...A.map((c) => c.y)), s = Math.max(...A.map((c) => c.x + c.width)), o = Math.max(...A.map((c) => c.y + c.height));
      break;
  }
  let h = [], f = [];
  ["dh", "distrib_horiz"].includes(r) ? [h, f] = oI(e, t, A, i, s, a, o) : ["dv", "distrib_verti"].includes(r) ? [h, f] = lI(e, t, A, i, s, a, o) : [h, f] = uI(r, t, A, i, s, a, o), ev(h, f);
}, oI = (r, e, t, A, n, i, s) => {
  const a = [], o = [];
  for (let p = 0; p < e.length; p++)
    o[p] = 0;
  const l = t.slice().sort((p, g) => {
    const v = p.x + p.width, w = g.x + g.width;
    return v === w ? 0 : v > w ? 1 : -1;
  });
  r === "page" && (l.unshift({ x: 0, y: 0, width: 0, height: s }), l.push({ x: n, y: 0, width: 0, height: s }));
  const u = n - A, h = l.map((p) => p.width).reduce((p, g) => p + g, 0), f = (u - h) / (l.length - 1), c = [];
  for (let p = 0; p < l.length; ++p) {
    if (c[p] = 0, p === 0)
      continue;
    const g = l[p].x;
    l[p].x = l[p - 1].x + l[p - 1].width + f, c[p] = l[p].x - g;
  }
  return l.forEach((p, g) => {
    const v = t.findIndex((w) => w === p);
    v !== -1 && (a[v] = c[g]);
  }), [a, o];
}, lI = (r, e, t, A, n, i, s) => {
  const a = [], o = [];
  for (let p = 0; p < e.length; p++)
    a[p] = 0;
  const l = t.slice().sort((p, g) => {
    const v = p.y + p.height, w = g.y + g.height;
    return v === w ? 0 : v > w ? 1 : -1;
  });
  r === "page" && (l.unshift({ x: 0, y: 0, width: n, height: 0 }), l.push({ x: 0, y: s, width: n, height: 0 }));
  const u = s - i, h = l.map((p) => p.height).reduce((p, g) => p + g, 0), f = (u - h) / (l.length - 1), c = [];
  for (let p = 0; p < l.length; ++p) {
    if (c[p] = 0, p === 0)
      continue;
    const g = l[p].y;
    l[p].y = l[p - 1].y + l[p - 1].height + f, c[p] = l[p].y - g;
  }
  return l.forEach((p, g) => {
    const v = t.findIndex((w) => w === p);
    v !== -1 && (o[v] = c[g]);
  }), [a, o];
}, uI = (r, e, t, A, n, i, s) => {
  const a = e.length, o = new Array(a), l = new Array(a);
  for (let u = 0; u < a && e[u]; ++u) {
    const h = t[u];
    switch (o[u] = 0, l[u] = 0, r) {
      case "l":
      // left (horizontal)
      case "left":
        o[u] = A - h.x;
        break;
      case "c":
      // center (horizontal)
      case "center":
        o[u] = (A + n) / 2 - (h.x + h.width / 2);
        break;
      case "r":
      // right (horizontal)
      case "right":
        o[u] = n - (h.x + h.width);
        break;
      case "t":
      // top (vertical)
      case "top":
        l[u] = i - h.y;
        break;
      case "m":
      // middle (vertical)
      case "middle":
        l[u] = (i + s) / 2 - (h.y + h.height / 2);
        break;
      case "b":
      // bottom (vertical)
      case "bottom":
        l[u] = s - (h.y + h.height);
        break;
    }
  }
  return [o, l];
}, cI = () => {
  const r = Se.getSelectedElements(), e = new Ks("Delete Elements"), t = [];
  r.forEach((A) => {
    if (A) {
      let n = A.parentNode, i = A;
      Se.gettingSelectorManager().releaseSelector(i), $m(i.id), n.tagName === "a" && n.childNodes.length === 1 && (i = n, n = n.parentNode);
      const { nextSibling: s } = i;
      i.remove();
      const a = i;
      t.push(A), e.addSubCommand(new Xl(a, s, n));
    }
  }), Se.setEmptySelectedElements(), e.isEmpty() || Se.addCommandToHistory(e), Se.call("changed", t), Se.clearSelection();
}, hI = (r, e) => {
  const t = Se.getSelectedElements(), A = new Ks("Flip Elements"), n = Se.getSvgRoot();
  t.forEach((i) => {
    if (!i) return;
    const s = Mn([i]);
    if (!s) return;
    const a = s.x + s.width / 2, o = s.y + s.height / 2, l = i.getAttribute("transform") || "", u = n.createSVGMatrix().translate(a, o).scaleNonUniform(r, e).translate(-a, -o), h = yr(i), f = wn(
      vr(h).matrix,
      u
    ), c = n.createSVGTransform();
    c.setMatrix(f), h.clear(), h.appendItem(c);
    const p = Se.getStartTransform ? Se.getStartTransform() : null;
    Se.setStartTransform && Se.setStartTransform(l);
    const g = Qa(i);
    Se.setStartTransform && Se.setStartTransform(p), g ? A.addSubCommand(g) : (i.getAttribute("transform") || "") !== l && A.addSubCommand(
      new YS(i, { transform: l })
    ), Se.gettingSelectorManager().requestSelector(i).resize();
  }), A.isEmpty() || (Se.addCommandToHistory(A), Se.call("changed", t.filter(Boolean)));
}, fI = () => {
  const r = Se.getSelectedElements(), e = JSON.stringify(
    r.map((A) => Se.getJsonFromSvgElements(A))
  );
  sessionStorage.setItem(Se.getClipboardID(), e), Se.flashStorage(), document.getElementById("se-cmenu_canvas").setAttribute("enablemenuitems", "#paste,#paste_in_place");
}, dI = (r, e) => {
  const t = Se.getSelectedElements();
  r || (r = "g");
  let A = "", n;
  switch (r) {
    case "a": {
      A = "Make hyperlink", n = e || "";
      break;
    }
    default: {
      r = "g", A = "Group Elements";
      break;
    }
  }
  const i = new Ks(A), s = Se.addSVGElementsFromJson({
    element: r,
    attr: {
      id: Se.getNextId()
    }
  });
  r === "a" && Rn(s, n), i.addSubCommand(new Zm(s));
  let a = t.length;
  for (; a--; ) {
    let o = t[a];
    if (!o)
      continue;
    o.parentNode.tagName === "a" && o.parentNode.childNodes.length === 1 && (o = o.parentNode);
    const l = o.nextSibling, u = o.parentNode;
    s.append(o), i.addSubCommand(
      new ou(o, l, u)
    );
  }
  i.isEmpty() || Se.addCommandToHistory(i), Se.selectOnly([s], !0);
}, tv = (r, e) => {
  const t = r.childNodes, A = t.length, n = r.getAttribute("transform"), i = yr(r), s = vr(i).matrix, a = new Ks("Push group properties"), o = MA(r), l = {
    filter: r.getAttribute("filter"),
    opacity: r.getAttribute("opacity")
  };
  let u, h, f;
  const c = Se.getDrawing();
  for (let p = 0; p < A; p++) {
    const g = t[p];
    if (g.nodeType !== 1)
      continue;
    if (l.opacity !== null && l.opacity !== 1) {
      const w = Math.round((g.getAttribute("opacity") || 1) * l.opacity * 100) / 100;
      Se.changeSelectedAttribute("opacity", w, [g]);
    }
    if (l.filter) {
      let w = Se.getBlur(g);
      const B = w;
      if (h || (h = Se.getBlur(r)), w ? w = Number(h) + Number(w) : w === 0 && (w = h), B)
        u = Ua(g.getAttribute("filter"));
      else if (!u)
        u = Ua(l.filter);
      else {
        u = c.copyElem(u), Cn().append(u);
        const E = R0(u)?.tagName === "feGaussianBlur" ? "blur" : "filter";
        u.id = g.id + "_" + E, Se.changeSelectedAttribute(
          "filter",
          "url(#" + u.id + ")",
          [g]
        );
      }
      const S = R0(u);
      w && (Se.changeSelectedAttribute("stdDeviation", w, [S]), Se.setBlurOffsets(u, w));
    }
    let v = yr(g);
    if (g.tagName.includes("Gradient") && (v = null), !!v && g.tagName !== "defs" && i.numberOfItems) {
      if (o && i.numberOfItems === 1) {
        const B = i.getItem(0).matrix;
        let S = Se.getSvgRoot().createSVGMatrix();
        const C = MA(g);
        C && (S = v.getItem(0).matrix);
        const E = Nr(g), _ = vr(v).matrix, I = zt(
          E.x + E.width / 2,
          E.y + E.height / 2,
          _
        ), O = o + C, U = Se.getSvgRoot().createSVGTransform();
        U.setRotate(O, I.x, I.y);
        const V = wn(B, S, U.matrix.inverse());
        if (C && v.removeItem(0), O && (v.numberOfItems ? v.insertItemBefore(U, 0) : v.appendItem(U)), V.e || V.f) {
          const F = Se.getSvgRoot().createSVGTransform();
          F.setTranslate(V.e, V.f), v.numberOfItems ? v.insertItemBefore(F, 0) : v.appendItem(F);
        }
      } else {
        const B = g.getAttribute("transform");
        f = {}, f.transform = B || "";
        const S = Se.getSvgRoot().createSVGTransform(), C = vr(v).matrix, E = C.inverse(), _ = wn(E, s, C);
        S.setMatrix(_), v.appendItem(S);
      }
      const w = Qa(g);
      w && a.addSubCommand(w);
    }
  }
  if (n && (f = {}, f.transform = n, r.setAttribute("transform", ""), r.removeAttribute("transform"), a.addSubCommand(new YS(r, f))), e && !a.isEmpty())
    return a;
}, k1 = (r) => {
  const e = Se.getSelectedElements();
  r || (r = e[0]);
  const t = r, A = new Ks();
  let n;
  const i = Se.getDataStorage();
  if (i.has(t, "gsvg")) {
    const s = r.firstChild, a = {
      x: Number(s.getAttribute("x")),
      y: Number(s.getAttribute("y"))
    }, o = r.firstChild.firstChild;
    o && (o.outerHTML = o.innerHTML), i.remove(r, "gsvg");
    const l = yr(r), u = Se.getSvgRoot().createSVGTransform();
    u.setTranslate(a.x, a.y), l.appendItem(u), Qa(r), Se.call("selected", [r]);
  } else if (i.has(t, "symbol")) {
    r = i.get(t, "symbol"), n = t.getAttribute("transform") || "";
    const s = {
      x: Number(t.getAttribute("x")),
      y: Number(t.getAttribute("y"))
    }, a = r.getAttribute("viewBox");
    if (a) {
      const w = a.split(/[ ,]+/);
      s.x -= Number(w[0]), s.y -= Number(w[1]);
    }
    n += " translate(" + (s.x || 0) + "," + (s.y || 0) + ")";
    const o = t.previousElementSibling;
    A.addSubCommand(
      new Xl(
        t,
        t.nextElementSibling,
        t.parentNode
      )
    ), t.remove();
    const u = Se.getSvgContent().querySelectorAll("use").length, h = Se.getDOMDocument().createElementNS(nt.SVG, "g"), f = r.childNodes;
    let c;
    for (c = 0; c < f.length; c++)
      h.append(f[c].cloneNode(!0));
    if (Sa()) {
      const B = Cn().querySelectorAll(
        "linearGradient,radialGradient,pattern"
      );
      for (let S = 0, C = B.length; C > S; S++)
        h.appendChild(B[S].cloneNode(!0));
    }
    n && h.setAttribute("transform", n);
    const p = r.parentNode;
    if (Se.uniquifyElems(h), Sa()) {
      const w = Cn(), B = h.querySelectorAll(
        "linearGradient,radialGradient,pattern"
      );
      for (let S = 0, C = B.length; C > S; S++)
        w.appendChild(B[S]);
    }
    if (h.id = Se.getNextId(), o.after(h), p) {
      if (!u) {
        const { nextSibling: w } = r;
        r.remove(), A.addSubCommand(
          new Xl(r, w, p)
        );
      }
      A.addSubCommand(new Zm(h));
    }
    Se.setUseData(h), Sa() ? Se.convertGradients(Cn()) : Se.convertGradients(h), k4(h, (w) => {
      try {
        Qa(w);
      } catch (B) {
        console.error(B);
      }
    });
    const g = h.querySelectorAll(Se.getVisElems());
    Array.prototype.forEach.call(g, (w) => {
      w.id || (w.id = Se.getNextId());
    }), Se.selectOnly([h]);
    const v = tv(h, !0);
    v && A.addSubCommand(v), Se.addCommandToHistory(A);
  } else
    console.warn("Unexpected element to ungroup:", r);
}, gI = () => {
  const r = Se.getSelectedElements(), e = Se.getDataStorage();
  let t = r[0];
  if (!t)
    return;
  if (e.has(t, "gsvg") || e.has(t, "symbol")) {
    k1(t);
    return;
  }
  if (t.tagName === "use") {
    const n = Xt($i(t).substr(1));
    e.put(t, "symbol", n), e.put(t, "ref", n), k1(t);
    return;
  }
  const A = nu(t.parentNode, "a");
  if (A?.length && (t = A[0]), t.tagName === "g" || t.tagName === "a") {
    const n = new Ks("Ungroup Elements"), i = tv(t, !0);
    i && n.addSubCommand(i);
    const s = t.parentNode, a = t.nextSibling, o = new Array(t.childNodes.length);
    let l = 0;
    for (; t.firstChild; ) {
      const h = t.firstChild, f = h.nextSibling, c = h.parentNode;
      if (h.tagName === "title") {
        const { nextSibling: p } = h;
        n.addSubCommand(
          new Xl(h, p, c)
        ), h.remove();
        continue;
      }
      o[l++] = s.insertBefore(h, a), n.addSubCommand(
        new ou(h, f, c)
      );
    }
    Se.clearSelection();
    const u = t.nextSibling;
    t.remove(), n.addSubCommand(new Xl(t, u, s)), n.isEmpty() || Se.addCommandToHistory(n), Se.addToSelection(o);
  }
}, pI = (r, e) => {
  Se.getSvgRoot().setAttribute("width", r), Se.getSvgRoot().setAttribute("height", e);
  const t = Se.getZoom(), A = document.getElementById("canvasBackground"), n = Number(Se.getSvgContent().getAttribute("x")), i = Number(Se.getSvgContent().getAttribute("y")), s = (r - Se.contentW * t) / 2, a = (e - Se.contentH * t) / 2;
  qt(Se.getSvgContent(), {
    width: Se.contentW * t,
    height: Se.contentH * t,
    x: s,
    y: a,
    viewBox: "0 0 " + Se.contentW + " " + Se.contentH
  }), qt(A, {
    width: Se.getSvgContent().getAttribute("width"),
    height: Se.getSvgContent().getAttribute("height"),
    x: s,
    y: a
  });
  const o = Xt("background_image");
  return o && qt(o, {
    width: "100%",
    height: "100%"
  }), Se.selectorManager.selectorParentGroup.setAttribute(
    "transform",
    "translate(" + s + "," + a + ")"
  ), Se.runExtensions(
    "canvasUpdated",
    /**
     * @type {module:svgcanvas.SvgCanvas#event:ext_canvasUpdated}
     */
    {
      new_x: s,
      new_y: a,
      old_x: n,
      old_y: i,
      d_x: s - n,
      d_y: a - i
    }
  ), { x: s, y: a, old_x: n, old_y: i, d_x: s - n, d_y: a - i };
}, mI = (r) => {
  const e = Se.getSelectedElements(), t = Se.getCurrentGroup();
  let A;
  const n = e[0];
  let i = !1;
  const s = iu(
    t || Se.getCurrentDrawing().getCurrentLayer()
  );
  if (s.length) {
    if (!n)
      A = r ? s.length - 1 : 0, i = s[A];
    else {
      let a = s.length;
      for (; a--; )
        if (s[a] === n) {
          A = r ? a - 1 : a + 1, A >= s.length ? A = 0 : A < 0 && (A = s.length - 1), i = s[A];
          break;
        }
    }
    Se.selectOnly([i], !0), Se.call("selected", e);
  }
};
let Nt = null;
const vI = (r) => {
  Nt = r;
}, wI = function(r) {
  const e = Nt.getSelectedElements();
  if (!Nt.getFilter()) {
    Nt.setBlur(r);
    return;
  }
  if (r === 0)
    Nt.changeSelectedAttributeNoUndo("filter", ""), Nt.setFilterHidden(!0);
  else {
    const t = e[0];
    Nt.getFilterHidden() && Nt.changeSelectedAttributeNoUndo("filter", "url(#" + t.id + "_blur)");
    const A = Nt.getFilter();
    Nt.changeSelectedAttributeNoUndo("stdDeviation", r, [A.firstChild]), Nt.setBlurOffsets(A, r);
  }
};
function H1() {
  const r = Nt.undoMgr.finishUndoableChange();
  Nt.getCurCommand().addSubCommand(r), Nt.addCommandToHistory(Nt.getCurCommand()), Nt.setCurCommand(null), Nt.setFilter(null);
}
const yI = function(r, e) {
  e > 3 ? Nt.assignAttributes(r, {
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, 100) : (r.removeAttribute("x"), r.removeAttribute("y"), r.removeAttribute("width"), r.removeAttribute("height"));
}, BI = function(r, e) {
  const {
    InsertElementCommand: t,
    ChangeElementCommand: A,
    BatchCommand: n
  } = Nt.history, i = Nt.getSelectedElements();
  if (Nt.getCurCommand()) {
    H1();
    return;
  }
  const s = i[0], a = s.id;
  Nt.setFilter(Nt.getElement(a + "_blur")), r -= 0;
  const o = new n();
  if (Nt.getFilter())
    r === 0 && Nt.setFilter(null);
  else {
    const h = Nt.addSVGElementsFromJson({
      element: "feGaussianBlur",
      attr: {
        in: "SourceGraphic",
        stdDeviation: r
      }
    });
    Nt.setFilter(Nt.addSVGElementsFromJson({
      element: "filter",
      attr: {
        id: a + "_blur"
      }
    })), Nt.getFilter().append(h), Nt.findDefs().append(Nt.getFilter()), o.addSubCommand(new t(Nt.getFilter()));
  }
  const l = { filter: s.getAttribute("filter") };
  if (r === 0) {
    s.removeAttribute("filter"), o.addSubCommand(new A(s, l));
    return;
  }
  Nt.changeSelectedAttribute("filter", "url(#" + a + "_blur)"), o.addSubCommand(new A(s, l)), Nt.setBlurOffsets(Nt.getFilter(), r);
  const u = Nt.getFilter();
  Nt.setCurCommand(o), Nt.undoMgr.beginUndoableChange("stdDeviation", [u ? u.firstChild : null]), e && (Nt.setBlurNoUndo(r), H1());
};
const bI = fS(), CI = ["class", "id", "display", "transform", "style"], kl = {
  // SVG Elements
  a: ["clip-path", "clip-rule", "fill", "fill-opacity", "fill-rule", "filter", "href", "mask", "opacity", "stroke", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "systemLanguage", "xlink:href", "xlink:title"],
  circle: ["clip-path", "clip-rule", "cx", "cy", "enable-background", "fill", "fill-opacity", "fill-rule", "filter", "mask", "opacity", "r", "requiredFeatures", "stroke", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "systemLanguage"],
  clipPath: ["clipPathUnits"],
  defs: [],
  desc: [],
  ellipse: ["clip-path", "clip-rule", "cx", "cy", "fill", "fill-opacity", "fill-rule", "filter", "mask", "opacity", "requiredFeatures", "rx", "ry", "stroke", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "systemLanguage"],
  feBlend: ["in", "in2"],
  feColorMatrix: ["in", "type", "value", "result", "values"],
  feComposite: ["in", "operator", "result", "in2"],
  feFlood: ["flood-color", "in", "result", "flood-opacity"],
  feGaussianBlur: ["color-interpolation-filters", "in", "requiredFeatures", "stdDeviation", "result"],
  feMerge: [],
  feMergeNode: ["in"],
  feMorphology: ["in", "operator", "radius"],
  feOffset: ["dx", "in", "dy", "result"],
  filter: ["color-interpolation-filters", "filterRes", "filterUnits", "height", "href", "primitiveUnits", "requiredFeatures", "width", "x", "xlink:href", "y"],
  foreignObject: ["font-size", "height", "opacity", "requiredFeatures", "width", "x", "y"],
  g: ["clip-path", "clip-rule", "fill", "fill-opacity", "fill-rule", "filter", "mask", "opacity", "requiredFeatures", "stroke", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "systemLanguage", "font-family", "font-size", "font-style", "font-weight", "text-anchor"],
  image: [
    "clip-path",
    "clip-rule",
    "filter",
    "height",
    "mask",
    "opacity",
    "preserveAspectRatio",
    "requiredFeatures",
    "systemLanguage",
    "viewBox",
    "width",
    "x",
    "href",
    "xlink:href",
    "xlink:title",
    "y"
  ],
  line: ["clip-path", "clip-rule", "fill", "fill-opacity", "fill-rule", "filter", "marker-end", "marker-mid", "marker-start", "mask", "opacity", "requiredFeatures", "stroke", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "systemLanguage", "x1", "x2", "y1", "y2"],
  linearGradient: ["gradientTransform", "gradientUnits", "requiredFeatures", "spreadMethod", "systemLanguage", "x1", "x2", "href", "xlink:href", "y1", "y2"],
  marker: ["markerHeight", "markerUnits", "markerWidth", "orient", "preserveAspectRatio", "refX", "refY", "se_type", "systemLanguage", "viewBox"],
  mask: ["height", "maskContentUnits", "maskUnits", "width", "x", "y"],
  metadata: [],
  path: ["clip-path", "clip-rule", "d", "enable-background", "fill", "fill-opacity", "fill-rule", "filter", "marker-end", "marker-mid", "marker-start", "mask", "opacity", "requiredFeatures", "stroke", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "systemLanguage"],
  pattern: ["height", "patternContentUnits", "patternTransform", "patternUnits", "requiredFeatures", "systemLanguage", "viewBox", "width", "x", "href", "xlink:href", "y"],
  polygon: ["clip-path", "clip-rule", "fill", "fill-opacity", "fill-rule", "filter", "marker-end", "marker-mid", "marker-start", "mask", "opacity", "points", "requiredFeatures", "stroke", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "systemLanguage", "sides", "shape", "edge", "point", "starRadiusMultiplier", "r", "radialshift", "r2", "orient", "cx", "cy"],
  polyline: ["clip-path", "clip-rule", "fill", "fill-opacity", "fill-rule", "filter", "marker-end", "marker-mid", "marker-start", "mask", "opacity", "points", "requiredFeatures", "stroke", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "systemLanguage", "se:connector"],
  radialGradient: ["cx", "cy", "fx", "fy", "gradientTransform", "gradientUnits", "r", "requiredFeatures", "spreadMethod", "systemLanguage", "href", "xlink:href"],
  rect: ["clip-path", "clip-rule", "fill", "fill-opacity", "fill-rule", "filter", "height", "mask", "opacity", "requiredFeatures", "rx", "ry", "stroke", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "systemLanguage", "width", "x", "y"],
  stop: ["offset", "requiredFeatures", "stop-opacity", "systemLanguage", "stop-color", "gradientUnits", "gradientTransform"],
  style: ["type"],
  svg: ["clip-path", "clip-rule", "enable-background", "filter", "height", "mask", "preserveAspectRatio", "requiredFeatures", "systemLanguage", "version", "viewBox", "width", "x", "xmlns", "xmlns:se", "xmlns:xlink", "xmlns:oi", "oi:animations", "y", "stroke-linejoin", "fill-rule", "aria-label", "stroke-width", "fill-rule", "xml:space"],
  switch: ["requiredFeatures", "systemLanguage"],
  symbol: ["fill", "fill-opacity", "fill-rule", "filter", "font-family", "font-size", "font-style", "font-weight", "opacity", "overflow", "preserveAspectRatio", "requiredFeatures", "stroke", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "systemLanguage", "viewBox", "width", "height"],
  text: ["clip-path", "clip-rule", "dominant-baseline", "fill", "fill-opacity", "fill-rule", "filter", "font-family", "font-size", "font-style", "font-weight", "mask", "opacity", "requiredFeatures", "stroke", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "systemLanguage", "text-anchor", "letter-spacing", "word-spacing", "text-decoration", "textLength", "lengthAdjust", "x", "xml:space", "y"],
  textPath: ["dominant-baseline", "href", "method", "requiredFeatures", "spacing", "startOffset", "systemLanguage", "xlink:href"],
  title: [],
  tspan: ["clip-path", "clip-rule", "dx", "dy", "dominant-baseline", "fill", "fill-opacity", "fill-rule", "filter", "font-family", "font-size", "font-style", "font-weight", "mask", "opacity", "requiredFeatures", "rotate", "stroke", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "systemLanguage", "text-anchor", "textLength", "x", "xml:space", "y"],
  use: ["clip-path", "clip-rule", "fill", "fill-opacity", "fill-rule", "filter", "height", "href", "mask", "stroke", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "width", "x", "xlink:href", "y", "overflow"],
  // Filter Primitives
  feComponentTransfer: ["in", "result"],
  feFuncR: ["type", "tableValues", "slope", "intercept", "amplitude", "exponent", "offset"],
  feFuncG: ["type", "tableValues", "slope", "intercept", "amplitude", "exponent", "offset"],
  feFuncB: ["type", "tableValues", "slope", "intercept", "amplitude", "exponent", "offset"],
  feFuncA: ["type", "tableValues", "slope", "intercept", "amplitude", "exponent", "offset"],
  feConvolveMatrix: ["in", "order", "kernelMatrix", "divisor", "bias", "targetX", "targetY", "edgeMode", "kernelUnitLength", "preserveAlpha"],
  feDiffuseLighting: ["in", "surfaceScale", "diffuseConstant", "kernelUnitLength", "lighting-color"],
  feSpecularLighting: ["in", "surfaceScale", "specularConstant", "specularExponent", "kernelUnitLength", "lighting-color"],
  feDisplacementMap: ["in", "in2", "scale", "xChannelSelector", "yChannelSelector"],
  feTurbulence: ["baseFrequency", "numOctaves", "result", "seed", "stitchTiles", "type"],
  feTile: ["in"],
  // MathML Elements
  annotation: ["encoding"],
  "annotation-xml": ["encoding"],
  maction: ["actiontype", "other", "selection"],
  math: ["xmlns"],
  menclose: ["notation"],
  merror: [],
  mfrac: ["linethickness"],
  mi: ["mathvariant"],
  mmultiscripts: [],
  mn: [],
  mo: ["fence", "lspace", "maxsize", "minsize", "rspace", "stretchy"],
  mover: [],
  mpadded: ["lspace", "width", "height", "depth", "voffset"],
  mphantom: [],
  mprescripts: [],
  mroot: [],
  mrow: ["href", "xlink:href", "xlink:type", "xmlns:xlink"],
  mspace: ["depth", "height", "width"],
  msqrt: [],
  mstyle: ["displaystyle", "mathbackground", "mathcolor", "mathvariant", "scriptlevel"],
  msub: [],
  msubsup: [],
  msup: [],
  mtable: ["align", "columnalign", "columnlines", "columnspacing", "displaystyle", "equalcolumns", "equalrows", "frame", "rowalign", "rowlines", "rowspacing", "width"],
  mtd: ["columnalign", "columnspan", "rowalign", "rowspan"],
  mtext: [],
  mtr: ["columnalign", "rowalign"],
  munder: [],
  munderover: [],
  none: [],
  semantics: [],
  // HTML Elements for use in a foreignObject
  div: [],
  p: [],
  li: [],
  pre: [],
  ol: [],
  ul: [],
  span: [],
  hr: [],
  br: [],
  h1: [],
  h2: [],
  h3: [],
  h4: [],
  h5: [],
  h6: []
};
Object.keys(kl).forEach((r) => {
  kl[r] = [...kl[r], ...CI];
});
const JS = {};
Object.entries(kl).forEach(([r, e]) => {
  const t = {};
  Object.entries(e).forEach(([A, n]) => {
    if (n.includes(":")) {
      const i = n.split(":");
      t[i[1]] = nt[i[0].toUpperCase()];
    } else
      t[n] = n === "xmlns" ? nt.XMLNS : null;
  }), JS[r] = t;
});
const V0 = (r) => {
  if (r.nodeType === 3 && (r.nodeValue = r.nodeValue.trim(), r.nodeValue.length || r.remove()), r.nodeType !== 1)
    return;
  const e = r.ownerDocument, t = r.parentNode;
  if (!e || !t)
    return;
  const A = kl[r.nodeName], n = JS[r.nodeName];
  if (typeof A < "u") {
    const i = [];
    let s = r.attributes.length;
    for (; s--; ) {
      const l = r.attributes.item(s), u = l.nodeName, h = l.localName, f = l.namespaceURI;
      if (f !== n[h] && f !== nt.XMLNS && !(f === nt.XMLNS && bI[l.value]) && !(h === "href" && A.includes("href")))
        if (u.startsWith("se:") || u.startsWith("oi:") || u.startsWith("data-")) {
          const p = u.startsWith("se:") ? nt.SE : u.startsWith("oi:") ? nt.OI : null;
          i.push([u, l.value, p]);
        } else
          console.warn(`sanitizeSvg: attribute ${u} in element ${r.nodeName} not in whitelist is removed: ${r.outerHTML}`), r.removeAttributeNS(f, h);
      if (u === "style") {
        const c = l.value.split(";");
        let p = c.length;
        for (; p--; ) {
          const [g, v] = c[p].split(":"), w = (g || "").trim(), B = (v || "").trim();
          A.includes(w) && r.setAttribute(w, B);
        }
        r.removeAttribute("style");
      }
    }
    const a = r.getAttributeNS(nt.XLINK, "href");
    a && (r.setAttribute("href", a), r.removeAttributeNS(nt.XLINK, "href")), Object.values(i).forEach(([l, u, h]) => {
      r.setAttributeNS(h, l, u);
    });
    const o = $i(r);
    if (o && [
      "filter",
      "linearGradient",
      "pattern",
      "radialGradient",
      "textPath",
      "use"
    ].includes(r.nodeName) && o[0] !== "#" && (Rn(r, ""), console.warn(`sanitizeSvg: attribute href in element ${r.nodeName} pointing to a non-local reference (${o}) is removed: ${r.outerHTML}`), r.removeAttributeNS(nt.XLINK, "href"), r.removeAttribute("href")), r.nodeName === "use" && !$i(r)) {
      console.warn(`sanitizeSvg: element ${r.nodeName} without a xlink:href or href is removed: ${r.outerHTML}`), r.remove();
      return;
    }
    if (r.nodeName === "use") {
      const l = Ua($i(r));
      if (l) {
        const u = l.getAttribute("viewBox"), h = u ? u.split(/[\s,]+/).map(Number) : null, f = Number(l.getAttribute("width")), c = Number(l.getAttribute("height"));
        if (!r.hasAttribute("width")) {
          const p = h?.[2] || f;
          p && r.setAttribute("width", p);
        }
        if (!r.hasAttribute("height")) {
          const p = h?.[3] || c;
          p && r.setAttribute("height", p);
        }
      }
    }
    for (["clip-path", "fill", "filter", "marker-end", "marker-mid", "marker-start", "mask", "stroke"].forEach((l) => {
      let u = r.getAttribute(l);
      u && (u = hh(u), u && u[0] !== "#" && (r.setAttribute(l, ""), console.warn(`sanitizeSvg: attribute ${l} in element ${r.nodeName} pointing to a non-local reference (${u}) is removed: ${r.outerHTML}`), r.removeAttribute(l)));
    }), s = r.childNodes.length; s--; )
      V0(r.childNodes.item(s));
  } else {
    console.warn(`sanitizeSvg: element ${r.nodeName} not supported is removed: ${r.outerHTML}`);
    const i = [];
    for (; r.hasChildNodes(); )
      i.push(t.insertBefore(r.firstChild, r));
    r.remove();
    let s = i.length;
    for (; s--; )
      V0(i[s]);
  }
};
function jt(r) {
  "@babel/helpers - typeof";
  return jt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, jt(r);
}
var ri = Uint8Array, bn = Uint16Array, rv = Int32Array, Av = new ri([
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1,
  1,
  1,
  1,
  2,
  2,
  2,
  2,
  3,
  3,
  3,
  3,
  4,
  4,
  4,
  4,
  5,
  5,
  5,
  5,
  0,
  /* unused */
  0,
  0,
  /* impossible */
  0
]), nv = new ri([
  0,
  0,
  0,
  0,
  1,
  1,
  2,
  2,
  3,
  3,
  4,
  4,
  5,
  5,
  6,
  6,
  7,
  7,
  8,
  8,
  9,
  9,
  10,
  10,
  11,
  11,
  12,
  12,
  13,
  13,
  /* unused */
  0,
  0
]), D1 = new ri([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), $S = function(r, e) {
  for (var t = new bn(31), A = 0; A < 31; ++A)
    t[A] = e += 1 << r[A - 1];
  for (var n = new rv(t[30]), A = 1; A < 30; ++A)
    for (var i = t[A]; i < t[A + 1]; ++i)
      n[i] = i - t[A] << 5 | A;
  return { b: t, r: n };
}, ZS = $S(Av, 2), SI = ZS.b, K0 = ZS.r;
SI[28] = 258, K0[258] = 28;
var xI = $S(nv, 0), G1 = xI.r, j0 = new bn(32768);
for (var wr = 0; wr < 32768; ++wr) {
  var Ss = (wr & 43690) >> 1 | (wr & 21845) << 1;
  Ss = (Ss & 52428) >> 2 | (Ss & 13107) << 2, Ss = (Ss & 61680) >> 4 | (Ss & 3855) << 4, j0[wr] = ((Ss & 65280) >> 8 | (Ss & 255) << 8) >> 1;
}
var Hl = (function(r, e, t) {
  for (var A = r.length, n = 0, i = new bn(e); n < A; ++n)
    r[n] && ++i[r[n] - 1];
  var s = new bn(e);
  for (n = 1; n < e; ++n)
    s[n] = s[n - 1] + i[n - 1] << 1;
  var a;
  if (t) {
    a = new bn(1 << e);
    var o = 15 - e;
    for (n = 0; n < A; ++n)
      if (r[n])
        for (var l = n << 4 | r[n], u = e - r[n], h = s[r[n] - 1]++ << u, f = h | (1 << u) - 1; h <= f; ++h)
          a[j0[h] >> o] = l;
  } else
    for (a = new bn(A), n = 0; n < A; ++n)
      r[n] && (a[n] = j0[s[r[n] - 1]++] >> 15 - r[n]);
  return a;
}), La = new ri(288);
for (var wr = 0; wr < 144; ++wr)
  La[wr] = 8;
for (var wr = 144; wr < 256; ++wr)
  La[wr] = 9;
for (var wr = 256; wr < 280; ++wr)
  La[wr] = 7;
for (var wr = 280; wr < 288; ++wr)
  La[wr] = 8;
var dh = new ri(32);
for (var wr = 0; wr < 32; ++wr)
  dh[wr] = 5;
var EI = /* @__PURE__ */ Hl(La, 9, 0), FI = /* @__PURE__ */ Hl(dh, 5, 0), e5 = function(r) {
  return (r + 7) / 8 | 0;
}, _I = function(r, e, t) {
  return (t == null || t > r.length) && (t = r.length), new ri(r.subarray(e, t));
}, Gi = function(r, e, t) {
  t <<= e & 7;
  var A = e / 8 | 0;
  r[A] |= t, r[A + 1] |= t >> 8;
}, ul = function(r, e, t) {
  t <<= e & 7;
  var A = e / 8 | 0;
  r[A] |= t, r[A + 1] |= t >> 8, r[A + 2] |= t >> 16;
}, zf = function(r, e) {
  for (var t = [], A = 0; A < r.length; ++A)
    r[A] && t.push({ s: A, f: r[A] });
  var n = t.length, i = t.slice();
  if (!n)
    return { t: r5, l: 0 };
  if (n == 1) {
    var s = new ri(t[0].s + 1);
    return s[t[0].s] = 1, { t: s, l: 1 };
  }
  t.sort(function(E, _) {
    return E.f - _.f;
  }), t.push({ s: -1, f: 25001 });
  var a = t[0], o = t[1], l = 0, u = 1, h = 2;
  for (t[0] = { s: -1, f: a.f + o.f, l: a, r: o }; u != n - 1; )
    a = t[t[l].f < t[h].f ? l++ : h++], o = t[l != u && t[l].f < t[h].f ? l++ : h++], t[u++] = { s: -1, f: a.f + o.f, l: a, r: o };
  for (var f = i[0].s, A = 1; A < n; ++A)
    i[A].s > f && (f = i[A].s);
  var c = new bn(f + 1), p = q0(t[u - 1], c, 0);
  if (p > e) {
    var A = 0, g = 0, v = p - e, w = 1 << v;
    for (i.sort(function(_, I) {
      return c[I.s] - c[_.s] || _.f - I.f;
    }); A < n; ++A) {
      var B = i[A].s;
      if (c[B] > e)
        g += w - (1 << p - c[B]), c[B] = e;
      else
        break;
    }
    for (g >>= v; g > 0; ) {
      var S = i[A].s;
      c[S] < e ? g -= 1 << e - c[S]++ - 1 : ++A;
    }
    for (; A >= 0 && g; --A) {
      var C = i[A].s;
      c[C] == e && (--c[C], ++g);
    }
    p = e;
  }
  return { t: new ri(c), l: p };
}, q0 = function(r, e, t) {
  return r.s == -1 ? Math.max(q0(r.l, e, t + 1), q0(r.r, e, t + 1)) : e[r.s] = t;
}, V1 = function(r) {
  for (var e = r.length; e && !r[--e]; )
    ;
  for (var t = new bn(++e), A = 0, n = r[0], i = 1, s = function(o) {
    t[A++] = o;
  }, a = 1; a <= e; ++a)
    if (r[a] == n && a != e)
      ++i;
    else {
      if (!n && i > 2) {
        for (; i > 138; i -= 138)
          s(32754);
        i > 2 && (s(i > 10 ? i - 11 << 5 | 28690 : i - 3 << 5 | 12305), i = 0);
      } else if (i > 3) {
        for (s(n), --i; i > 6; i -= 6)
          s(8304);
        i > 2 && (s(i - 3 << 5 | 8208), i = 0);
      }
      for (; i--; )
        s(n);
      i = 1, n = r[a];
    }
  return { c: t.subarray(0, A), n: e };
}, cl = function(r, e) {
  for (var t = 0, A = 0; A < e.length; ++A)
    t += r[A] * e[A];
  return t;
}, t5 = function(r, e, t) {
  var A = t.length, n = e5(e + 2);
  r[n] = A & 255, r[n + 1] = A >> 8, r[n + 2] = r[n] ^ 255, r[n + 3] = r[n + 1] ^ 255;
  for (var i = 0; i < A; ++i)
    r[n + i + 4] = t[i];
  return (n + 4 + A) * 8;
}, K1 = function(r, e, t, A, n, i, s, a, o, l, u) {
  Gi(e, u++, t), ++n[256];
  for (var h = zf(n, 15), f = h.t, c = h.l, p = zf(i, 15), g = p.t, v = p.l, w = V1(f), B = w.c, S = w.n, C = V1(g), E = C.c, _ = C.n, I = new bn(19), O = 0; O < B.length; ++O)
    ++I[B[O] & 31];
  for (var O = 0; O < E.length; ++O)
    ++I[E[O] & 31];
  for (var U = zf(I, 7), V = U.t, F = U.l, P = 19; P > 4 && !V[D1[P - 1]]; --P)
    ;
  var D = l + 5 << 3, R = cl(n, La) + cl(i, dh) + s, J = cl(n, f) + cl(i, g) + s + 14 + 3 * P + cl(I, V) + 2 * I[16] + 3 * I[17] + 7 * I[18];
  if (o >= 0 && D <= R && D <= J)
    return t5(e, u, r.subarray(o, o + l));
  var ie, te, $, re;
  if (Gi(e, u, 1 + (J < R)), u += 2, J < R) {
    ie = Hl(f, c, 0), te = f, $ = Hl(g, v, 0), re = g;
    var ue = Hl(V, F, 0);
    Gi(e, u, S - 257), Gi(e, u + 5, _ - 1), Gi(e, u + 10, P - 4), u += 14;
    for (var O = 0; O < P; ++O)
      Gi(e, u + 3 * O, V[D1[O]]);
    u += 3 * P;
    for (var se = [B, E], T = 0; T < 2; ++T)
      for (var G = se[T], O = 0; O < G.length; ++O) {
        var X = G[O] & 31;
        Gi(e, u, ue[X]), u += V[X], X > 15 && (Gi(e, u, G[O] >> 5 & 127), u += G[O] >> 12);
      }
  } else
    ie = EI, te = La, $ = FI, re = dh;
  for (var O = 0; O < a; ++O) {
    var Y = A[O];
    if (Y > 255) {
      var X = Y >> 18 & 31;
      ul(e, u, ie[X + 257]), u += te[X + 257], X > 7 && (Gi(e, u, Y >> 23 & 31), u += Av[X]);
      var ee = Y & 31;
      ul(e, u, $[ee]), u += re[ee], ee > 3 && (ul(e, u, Y >> 5 & 8191), u += nv[ee]);
    } else
      ul(e, u, ie[Y]), u += te[Y];
  }
  return ul(e, u, ie[256]), u + te[256];
}, UI = /* @__PURE__ */ new rv([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]), r5 = /* @__PURE__ */ new ri(0), II = function(r, e, t, A, n, i) {
  var s = i.z || r.length, a = new ri(A + s + 5 * (1 + Math.ceil(s / 7e3)) + n), o = a.subarray(A, a.length - n), l = i.l, u = (i.r || 0) & 7;
  if (e) {
    u && (o[0] = i.r >> 3);
    for (var h = UI[e - 1], f = h >> 13, c = h & 8191, p = (1 << t) - 1, g = i.p || new bn(32768), v = i.h || new bn(p + 1), w = Math.ceil(t / 3), B = 2 * w, S = function(Ge) {
      return (r[Ge] ^ r[Ge + 1] << w ^ r[Ge + 2] << B) & p;
    }, C = new rv(25e3), E = new bn(288), _ = new bn(32), I = 0, O = 0, U = i.i || 0, V = 0, F = i.w || 0, P = 0; U + 2 < s; ++U) {
      var D = S(U), R = U & 32767, J = v[D];
      if (g[R] = J, v[D] = R, F <= U) {
        var ie = s - U;
        if ((I > 7e3 || V > 24576) && (ie > 423 || !l)) {
          u = K1(r, o, 0, C, E, _, O, V, P, U - P, u), V = I = O = 0, P = U;
          for (var te = 0; te < 286; ++te)
            E[te] = 0;
          for (var te = 0; te < 30; ++te)
            _[te] = 0;
        }
        var $ = 2, re = 0, ue = c, se = R - J & 32767;
        if (ie > 2 && D == S(U - se))
          for (var T = Math.min(f, ie) - 1, G = Math.min(32767, U), X = Math.min(258, ie); se <= G && --ue && R != J; ) {
            if (r[U + $] == r[U + $ - se]) {
              for (var Y = 0; Y < X && r[U + Y] == r[U + Y - se]; ++Y)
                ;
              if (Y > $) {
                if ($ = Y, re = se, Y > T)
                  break;
                for (var ee = Math.min(se, Y - 2), oe = 0, te = 0; te < ee; ++te) {
                  var ge = U - se + te & 32767, pe = g[ge], me = ge - pe & 32767;
                  me > oe && (oe = me, J = ge);
                }
              }
            }
            R = J, J = g[R], se += R - J & 32767;
          }
        if (re) {
          C[V++] = 268435456 | K0[$] << 18 | G1[re];
          var Ee = K0[$] & 31, Ne = G1[re] & 31;
          O += Av[Ee] + nv[Ne], ++E[257 + Ee], ++_[Ne], F = U + $, ++I;
        } else
          C[V++] = r[U], ++E[r[U]];
      }
    }
    for (U = Math.max(U, F); U < s; ++U)
      C[V++] = r[U], ++E[r[U]];
    u = K1(r, o, l, C, E, _, O, V, P, U - P, u), l || (i.r = u & 7 | o[u / 8 | 0] << 3, u -= 7, i.h = v, i.p = g, i.i = U, i.w = F);
  } else {
    for (var U = i.w || 0; U < s + l; U += 65535) {
      var Te = U + 65535;
      Te >= s && (o[u / 8 | 0] = l, Te = s), u = t5(o, u + 1, r.subarray(U, Te));
    }
    i.i = s;
  }
  return _I(a, 0, A + e5(u) + n);
}, A5 = function() {
  var r = 1, e = 0;
  return {
    p: function(t) {
      for (var A = r, n = e, i = t.length | 0, s = 0; s != i; ) {
        for (var a = Math.min(s + 2655, i); s < a; ++s)
          n += A += t[s];
        A = (A & 65535) + 15 * (A >> 16), n = (n & 65535) + 15 * (n >> 16);
      }
      r = A, e = n;
    },
    d: function() {
      return r %= 65521, e %= 65521, (r & 255) << 24 | (r & 65280) << 8 | (e & 255) << 8 | e >> 8;
    }
  };
}, QI = function(r, e, t, A, n) {
  if (!n && (n = { l: 1 }, e.dictionary)) {
    var i = e.dictionary.subarray(-32768), s = new ri(i.length + r.length);
    s.set(i), s.set(r, i.length), r = s, n.w = i.length;
  }
  return II(r, e.level == null ? 6 : e.level, e.mem == null ? n.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(r.length))) * 1.5) : 20 : 12 + e.mem, t, A, n);
}, n5 = function(r, e, t) {
  for (; t; ++e)
    r[e] = t, t >>>= 8;
}, LI = function(r, e) {
  var t = e.level, A = t == 0 ? 0 : t < 6 ? 1 : t == 9 ? 3 : 2;
  if (r[0] = 120, r[1] = A << 6 | (e.dictionary && 32), r[1] |= 31 - (r[0] << 8 | r[1]) % 31, e.dictionary) {
    var n = A5();
    n.p(e.dictionary), n5(r, 2, n.d());
  }
};
function z0(r, e) {
  e || (e = {});
  var t = A5();
  t.p(r);
  var A = QI(r, e, e.dictionary ? 6 : 2, 4);
  return LI(A, e), n5(A, A.length - 4, t.d()), A;
}
var NI = typeof TextDecoder < "u" && /* @__PURE__ */ new TextDecoder(), TI = 0;
try {
  NI.decode(r5, { stream: !0 }), TI = 1;
} catch {
}
function PI(r) {
  if (Array.isArray(r)) return r;
}
function OI(r, e) {
  var t = r == null ? null : typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
  if (t != null) {
    var A, n, i, s, a = [], o = !0, l = !1;
    try {
      if (i = (t = t.call(r)).next, e !== 0) for (; !(o = (A = i.call(t)).done) && (a.push(A.value), a.length !== e); o = !0) ;
    } catch (u) {
      l = !0, n = u;
    } finally {
      try {
        if (!o && t.return != null && (s = t.return(), Object(s) !== s)) return;
      } finally {
        if (l) throw n;
      }
    }
    return a;
  }
}
function j1(r, e) {
  (e == null || e > r.length) && (e = r.length);
  for (var t = 0, A = Array(e); t < e; t++) A[t] = r[t];
  return A;
}
function MI(r, e) {
  if (r) {
    if (typeof r == "string") return j1(r, e);
    var t = {}.toString.call(r).slice(8, -1);
    return t === "Object" && r.constructor && (t = r.constructor.name), t === "Map" || t === "Set" ? Array.from(r) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? j1(r, e) : void 0;
  }
}
function RI() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function q1(r, e) {
  return PI(r) || OI(r, e) || MI(r, e) || RI();
}
function z1(r, e = "utf8") {
  return new TextDecoder(e).decode(r);
}
const kI = new TextEncoder();
function HI(r) {
  return kI.encode(r);
}
const DI = 1024 * 8, GI = (() => {
  const r = new Uint8Array(4), e = new Uint32Array(r.buffer);
  return !((e[0] = 1) & r[0]);
})(), Wf = {
  int8: globalThis.Int8Array,
  uint8: globalThis.Uint8Array,
  int16: globalThis.Int16Array,
  uint16: globalThis.Uint16Array,
  int32: globalThis.Int32Array,
  uint32: globalThis.Uint32Array,
  uint64: globalThis.BigUint64Array,
  int64: globalThis.BigInt64Array,
  float32: globalThis.Float32Array,
  float64: globalThis.Float64Array
};
class iv {
  /**
   * Reference to the internal ArrayBuffer object.
   */
  buffer;
  /**
   * Byte length of the internal ArrayBuffer.
   */
  byteLength;
  /**
   * Byte offset of the internal ArrayBuffer.
   */
  byteOffset;
  /**
   * Byte length of the internal ArrayBuffer.
   */
  length;
  /**
   * The current offset of the buffer's pointer.
   */
  offset;
  lastWrittenByte;
  littleEndian;
  _data;
  _mark;
  _marks;
  /**
   * Create a new IOBuffer.
   * @param data - The data to construct the IOBuffer with.
   * If data is a number, it will be the new buffer's length<br>
   * If data is `undefined`, the buffer will be initialized with a default length of 8Kb<br>
   * If data is an ArrayBuffer, SharedArrayBuffer, an ArrayBufferView (Typed Array), an IOBuffer instance,
   * or a Node.js Buffer, a view will be created over the underlying ArrayBuffer.
   * @param options - An object for the options.
   * @returns A new IOBuffer instance.
   */
  constructor(e = DI, t = {}) {
    let A = !1;
    typeof e == "number" ? e = new ArrayBuffer(e) : (A = !0, this.lastWrittenByte = e.byteLength);
    const n = t.offset ? t.offset >>> 0 : 0, i = e.byteLength - n;
    let s = n;
    (ArrayBuffer.isView(e) || e instanceof iv) && (e.byteLength !== e.buffer.byteLength && (s = e.byteOffset + n), e = e.buffer), A ? this.lastWrittenByte = i : this.lastWrittenByte = 0, this.buffer = e, this.length = i, this.byteLength = i, this.byteOffset = s, this.offset = 0, this.littleEndian = !0, this._data = new DataView(this.buffer, s, i), this._mark = 0, this._marks = [];
  }
  /**
   * Checks if the memory allocated to the buffer is sufficient to store more
   * bytes after the offset.
   * @param byteLength - The needed memory in bytes.
   * @returns `true` if there is sufficient space and `false` otherwise.
   */
  available(e = 1) {
    return this.offset + e <= this.length;
  }
  /**
   * Check if little-endian mode is used for reading and writing multi-byte
   * values.
   * @returns `true` if little-endian mode is used, `false` otherwise.
   */
  isLittleEndian() {
    return this.littleEndian;
  }
  /**
   * Set little-endian mode for reading and writing multi-byte values.
   * @returns This.
   */
  setLittleEndian() {
    return this.littleEndian = !0, this;
  }
  /**
   * Check if big-endian mode is used for reading and writing multi-byte values.
   * @returns `true` if big-endian mode is used, `false` otherwise.
   */
  isBigEndian() {
    return !this.littleEndian;
  }
  /**
   * Switches to big-endian mode for reading and writing multi-byte values.
   * @returns This.
   */
  setBigEndian() {
    return this.littleEndian = !1, this;
  }
  /**
   * Move the pointer n bytes forward.
   * @param n - Number of bytes to skip.
   * @returns This.
   */
  skip(e = 1) {
    return this.offset += e, this;
  }
  /**
   * Move the pointer n bytes backward.
   * @param n - Number of bytes to move back.
   * @returns This.
   */
  back(e = 1) {
    return this.offset -= e, this;
  }
  /**
   * Move the pointer to the given offset.
   * @param offset - The offset to move to.
   * @returns This.
   */
  seek(e) {
    return this.offset = e, this;
  }
  /**
   * Store the current pointer offset.
   * @see {@link IOBuffer#reset}
   * @returns This.
   */
  mark() {
    return this._mark = this.offset, this;
  }
  /**
   * Move the pointer back to the last pointer offset set by mark.
   * @see {@link IOBuffer#mark}
   * @returns This.
   */
  reset() {
    return this.offset = this._mark, this;
  }
  /**
   * Push the current pointer offset to the mark stack.
   * @see {@link IOBuffer#popMark}
   * @returns This.
   */
  pushMark() {
    return this._marks.push(this.offset), this;
  }
  /**
   * Pop the last pointer offset from the mark stack, and set the current
   * pointer offset to the popped value.
   * @see {@link IOBuffer#pushMark}
   * @returns This.
   */
  popMark() {
    const e = this._marks.pop();
    if (e === void 0)
      throw new Error("Mark stack empty");
    return this.seek(e), this;
  }
  /**
   * Move the pointer offset back to 0.
   * @returns This.
   */
  rewind() {
    return this.offset = 0, this;
  }
  /**
   * Make sure the buffer has sufficient memory to write a given byteLength at
   * the current pointer offset.
   * If the buffer's memory is insufficient, this method will create a new
   * buffer (a copy) with a length that is twice (byteLength + current offset).
   * @param byteLength - The needed memory in bytes.
   * @returns This.
   */
  ensureAvailable(e = 1) {
    if (!this.available(e)) {
      const A = (this.offset + e) * 2, n = new Uint8Array(A);
      n.set(new Uint8Array(this.buffer)), this.buffer = n.buffer, this.length = A, this.byteLength = A, this._data = new DataView(this.buffer);
    }
    return this;
  }
  /**
   * Read a byte and return false if the byte's value is 0, or true otherwise.
   * Moves pointer forward by one byte.
   * @returns The read boolean.
   */
  readBoolean() {
    return this.readUint8() !== 0;
  }
  /**
   * Read a signed 8-bit integer and move pointer forward by 1 byte.
   * @returns The read byte.
   */
  readInt8() {
    return this._data.getInt8(this.offset++);
  }
  /**
   * Read an unsigned 8-bit integer and move pointer forward by 1 byte.
   * @returns The read byte.
   */
  readUint8() {
    return this._data.getUint8(this.offset++);
  }
  /**
   * Alias for {@link IOBuffer#readUint8}.
   * @returns The read byte.
   */
  readByte() {
    return this.readUint8();
  }
  /**
   * Read `n` bytes and move pointer forward by `n` bytes.
   * @param n - Number of bytes to read.
   * @returns The read bytes.
   */
  readBytes(e = 1) {
    return this.readArray(e, "uint8");
  }
  /**
   * Creates an array of corresponding to the type `type` and size `size`.
   * For example type `uint8` will create a `Uint8Array`.
   * @param size - size of the resulting array
   * @param type - number type of elements to read
   * @returns The read array.
   */
  readArray(e, t) {
    const A = Wf[t].BYTES_PER_ELEMENT * e, n = this.byteOffset + this.offset, i = this.buffer.slice(n, n + A);
    if (this.littleEndian === GI && t !== "uint8" && t !== "int8") {
      const a = new Uint8Array(this.buffer.slice(n, n + A));
      a.reverse();
      const o = new Wf[t](a.buffer);
      return this.offset += A, o.reverse(), o;
    }
    const s = new Wf[t](i);
    return this.offset += A, s;
  }
  /**
   * Read a 16-bit signed integer and move pointer forward by 2 bytes.
   * @returns The read value.
   */
  readInt16() {
    const e = this._data.getInt16(this.offset, this.littleEndian);
    return this.offset += 2, e;
  }
  /**
   * Read a 16-bit unsigned integer and move pointer forward by 2 bytes.
   * @returns The read value.
   */
  readUint16() {
    const e = this._data.getUint16(this.offset, this.littleEndian);
    return this.offset += 2, e;
  }
  /**
   * Read a 32-bit signed integer and move pointer forward by 4 bytes.
   * @returns The read value.
   */
  readInt32() {
    const e = this._data.getInt32(this.offset, this.littleEndian);
    return this.offset += 4, e;
  }
  /**
   * Read a 32-bit unsigned integer and move pointer forward by 4 bytes.
   * @returns The read value.
   */
  readUint32() {
    const e = this._data.getUint32(this.offset, this.littleEndian);
    return this.offset += 4, e;
  }
  /**
   * Read a 32-bit floating number and move pointer forward by 4 bytes.
   * @returns The read value.
   */
  readFloat32() {
    const e = this._data.getFloat32(this.offset, this.littleEndian);
    return this.offset += 4, e;
  }
  /**
   * Read a 64-bit floating number and move pointer forward by 8 bytes.
   * @returns The read value.
   */
  readFloat64() {
    const e = this._data.getFloat64(this.offset, this.littleEndian);
    return this.offset += 8, e;
  }
  /**
   * Read a 64-bit signed integer number and move pointer forward by 8 bytes.
   * @returns The read value.
   */
  readBigInt64() {
    const e = this._data.getBigInt64(this.offset, this.littleEndian);
    return this.offset += 8, e;
  }
  /**
   * Read a 64-bit unsigned integer number and move pointer forward by 8 bytes.
   * @returns The read value.
   */
  readBigUint64() {
    const e = this._data.getBigUint64(this.offset, this.littleEndian);
    return this.offset += 8, e;
  }
  /**
   * Read a 1-byte ASCII character and move pointer forward by 1 byte.
   * @returns The read character.
   */
  readChar() {
    return String.fromCharCode(this.readInt8());
  }
  /**
   * Read `n` 1-byte ASCII characters and move pointer forward by `n` bytes.
   * @param n - Number of characters to read.
   * @returns The read characters.
   */
  readChars(e = 1) {
    let t = "";
    for (let A = 0; A < e; A++)
      t += this.readChar();
    return t;
  }
  /**
   * Read the next `n` bytes, return a UTF-8 decoded string and move pointer
   * forward by `n` bytes.
   * @param n - Number of bytes to read.
   * @returns The decoded string.
   */
  readUtf8(e = 1) {
    return z1(this.readBytes(e));
  }
  /**
   * Read the next `n` bytes, return a string decoded with `encoding` and move pointer
   * forward by `n` bytes.
   * If no encoding is passed, the function is equivalent to @see {@link IOBuffer#readUtf8}
   * @param n - Number of bytes to read.
   * @param encoding - The encoding to use. Default is 'utf8'.
   * @returns The decoded string.
   */
  decodeText(e = 1, t = "utf8") {
    return z1(this.readBytes(e), t);
  }
  /**
   * Write 0xff if the passed value is truthy, 0x00 otherwise and move pointer
   * forward by 1 byte.
   * @param value - The value to write.
   * @returns This.
   */
  writeBoolean(e) {
    return this.writeUint8(e ? 255 : 0), this;
  }
  /**
   * Write `value` as an 8-bit signed integer and move pointer forward by 1 byte.
   * @param value - The value to write.
   * @returns This.
   */
  writeInt8(e) {
    return this.ensureAvailable(1), this._data.setInt8(this.offset++, e), this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as an 8-bit unsigned integer and move pointer forward by 1
   * byte.
   * @param value - The value to write.
   * @returns This.
   */
  writeUint8(e) {
    return this.ensureAvailable(1), this._data.setUint8(this.offset++, e), this._updateLastWrittenByte(), this;
  }
  /**
   * An alias for {@link IOBuffer#writeUint8}.
   * @param value - The value to write.
   * @returns This.
   */
  writeByte(e) {
    return this.writeUint8(e);
  }
  /**
   * Write all elements of `bytes` as uint8 values and move pointer forward by
   * `bytes.length` bytes.
   * @param bytes - The array of bytes to write.
   * @returns This.
   */
  writeBytes(e) {
    this.ensureAvailable(e.length);
    for (let t = 0; t < e.length; t++)
      this._data.setUint8(this.offset++, e[t]);
    return this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as a 16-bit signed integer and move pointer forward by 2
   * bytes.
   * @param value - The value to write.
   * @returns This.
   */
  writeInt16(e) {
    return this.ensureAvailable(2), this._data.setInt16(this.offset, e, this.littleEndian), this.offset += 2, this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as a 16-bit unsigned integer and move pointer forward by 2
   * bytes.
   * @param value - The value to write.
   * @returns This.
   */
  writeUint16(e) {
    return this.ensureAvailable(2), this._data.setUint16(this.offset, e, this.littleEndian), this.offset += 2, this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as a 32-bit signed integer and move pointer forward by 4
   * bytes.
   * @param value - The value to write.
   * @returns This.
   */
  writeInt32(e) {
    return this.ensureAvailable(4), this._data.setInt32(this.offset, e, this.littleEndian), this.offset += 4, this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as a 32-bit unsigned integer and move pointer forward by 4
   * bytes.
   * @param value - The value to write.
   * @returns This.
   */
  writeUint32(e) {
    return this.ensureAvailable(4), this._data.setUint32(this.offset, e, this.littleEndian), this.offset += 4, this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as a 32-bit floating number and move pointer forward by 4
   * bytes.
   * @param value - The value to write.
   * @returns This.
   */
  writeFloat32(e) {
    return this.ensureAvailable(4), this._data.setFloat32(this.offset, e, this.littleEndian), this.offset += 4, this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as a 64-bit floating number and move pointer forward by 8
   * bytes.
   * @param value - The value to write.
   * @returns This.
   */
  writeFloat64(e) {
    return this.ensureAvailable(8), this._data.setFloat64(this.offset, e, this.littleEndian), this.offset += 8, this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as a 64-bit signed bigint and move pointer forward by 8
   * bytes.
   * @param value - The value to write.
   * @returns This.
   */
  writeBigInt64(e) {
    return this.ensureAvailable(8), this._data.setBigInt64(this.offset, e, this.littleEndian), this.offset += 8, this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as a 64-bit unsigned bigint and move pointer forward by 8
   * bytes.
   * @param value - The value to write.
   * @returns This.
   */
  writeBigUint64(e) {
    return this.ensureAvailable(8), this._data.setBigUint64(this.offset, e, this.littleEndian), this.offset += 8, this._updateLastWrittenByte(), this;
  }
  /**
   * Write the charCode of `str`'s first character as an 8-bit unsigned integer
   * and move pointer forward by 1 byte.
   * @param str - The character to write.
   * @returns This.
   */
  writeChar(e) {
    return this.writeUint8(e.charCodeAt(0));
  }
  /**
   * Write the charCodes of all `str`'s characters as 8-bit unsigned integers
   * and move pointer forward by `str.length` bytes.
   * @param str - The characters to write.
   * @returns This.
   */
  writeChars(e) {
    for (let t = 0; t < e.length; t++)
      this.writeUint8(e.charCodeAt(t));
    return this;
  }
  /**
   * UTF-8 encode and write `str` to the current pointer offset and move pointer
   * forward according to the encoded length.
   * @param str - The string to write.
   * @returns This.
   */
  writeUtf8(e) {
    return this.writeBytes(HI(e));
  }
  /**
   * Export a Uint8Array view of the internal buffer.
   * The view starts at the byte offset and its length
   * is calculated to stop at the last written byte or the original length.
   * @returns A new Uint8Array view.
   */
  toArray() {
    return new Uint8Array(this.buffer, this.byteOffset, this.lastWrittenByte);
  }
  /**
   *  Get the total number of bytes written so far, regardless of the current offset.
   * @returns - Total number of bytes.
   */
  getWrittenByteLength() {
    return this.lastWrittenByte - this.byteOffset;
  }
  /**
   * Update the last written byte offset
   * @private
   */
  _updateLastWrittenByte() {
    this.offset > this.lastWrittenByte && (this.lastWrittenByte = this.offset);
  }
}
function To(r) {
  let e = r.length;
  for (; --e >= 0; )
    r[e] = 0;
}
const VI = 3, KI = 258, i5 = 29, jI = 256, qI = jI + 1 + i5, s5 = 30, zI = 512, WI = new Array((qI + 2) * 2);
To(WI);
const XI = new Array(s5 * 2);
To(XI);
const YI = new Array(zI);
To(YI);
const JI = new Array(KI - VI + 1);
To(JI);
const $I = new Array(i5);
To($I);
const ZI = new Array(s5);
To(ZI);
const e3 = (r, e, t, A) => {
  let n = r & 65535 | 0, i = r >>> 16 & 65535 | 0, s = 0;
  for (; t !== 0; ) {
    s = t > 2e3 ? 2e3 : t, t -= s;
    do
      n = n + e[A++] | 0, i = i + n | 0;
    while (--s);
    n %= 65521, i %= 65521;
  }
  return n | i << 16 | 0;
};
var W0 = e3;
const t3 = () => {
  let r, e = [];
  for (var t = 0; t < 256; t++) {
    r = t;
    for (var A = 0; A < 8; A++)
      r = r & 1 ? 3988292384 ^ r >>> 1 : r >>> 1;
    e[t] = r;
  }
  return e;
}, r3 = new Uint32Array(t3()), A3 = (r, e, t, A) => {
  const n = r3, i = A + t;
  r ^= -1;
  for (let s = A; s < i; s++)
    r = r >>> 8 ^ n[(r ^ e[s]) & 255];
  return r ^ -1;
};
var gi = A3, X0 = {
  2: "need dictionary",
  /* Z_NEED_DICT       2  */
  1: "stream end",
  /* Z_STREAM_END      1  */
  0: "",
  /* Z_OK              0  */
  "-1": "file error",
  /* Z_ERRNO         (-1) */
  "-2": "stream error",
  /* Z_STREAM_ERROR  (-2) */
  "-3": "data error",
  /* Z_DATA_ERROR    (-3) */
  "-4": "insufficient memory",
  /* Z_MEM_ERROR     (-4) */
  "-5": "buffer error",
  /* Z_BUF_ERROR     (-5) */
  "-6": "incompatible version"
  /* Z_VERSION_ERROR (-6) */
}, a5 = {
  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH: 0,
  Z_FINISH: 4,
  Z_BLOCK: 5,
  Z_TREES: 6,
  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK: 0,
  Z_STREAM_END: 1,
  Z_NEED_DICT: 2,
  Z_STREAM_ERROR: -2,
  Z_DATA_ERROR: -3,
  Z_MEM_ERROR: -4,
  Z_BUF_ERROR: -5,
  /* The deflate compression method */
  Z_DEFLATED: 8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};
const n3 = (r, e) => Object.prototype.hasOwnProperty.call(r, e);
var i3 = function(r) {
  const e = Array.prototype.slice.call(arguments, 1);
  for (; e.length; ) {
    const t = e.shift();
    if (t) {
      if (typeof t != "object")
        throw new TypeError(t + "must be non-object");
      for (const A in t)
        n3(t, A) && (r[A] = t[A]);
    }
  }
  return r;
}, s3 = (r) => {
  let e = 0;
  for (let A = 0, n = r.length; A < n; A++)
    e += r[A].length;
  const t = new Uint8Array(e);
  for (let A = 0, n = 0, i = r.length; A < i; A++) {
    let s = r[A];
    t.set(s, n), n += s.length;
  }
  return t;
}, o5 = {
  assign: i3,
  flattenChunks: s3
};
let l5 = !0;
try {
  String.fromCharCode.apply(null, new Uint8Array(1));
} catch {
  l5 = !1;
}
const Yl = new Uint8Array(256);
for (let r = 0; r < 256; r++)
  Yl[r] = r >= 252 ? 6 : r >= 248 ? 5 : r >= 240 ? 4 : r >= 224 ? 3 : r >= 192 ? 2 : 1;
Yl[254] = Yl[254] = 1;
var a3 = (r) => {
  if (typeof TextEncoder == "function" && TextEncoder.prototype.encode)
    return new TextEncoder().encode(r);
  let e, t, A, n, i, s = r.length, a = 0;
  for (n = 0; n < s; n++)
    t = r.charCodeAt(n), (t & 64512) === 55296 && n + 1 < s && (A = r.charCodeAt(n + 1), (A & 64512) === 56320 && (t = 65536 + (t - 55296 << 10) + (A - 56320), n++)), a += t < 128 ? 1 : t < 2048 ? 2 : t < 65536 ? 3 : 4;
  for (e = new Uint8Array(a), i = 0, n = 0; i < a; n++)
    t = r.charCodeAt(n), (t & 64512) === 55296 && n + 1 < s && (A = r.charCodeAt(n + 1), (A & 64512) === 56320 && (t = 65536 + (t - 55296 << 10) + (A - 56320), n++)), t < 128 ? e[i++] = t : t < 2048 ? (e[i++] = 192 | t >>> 6, e[i++] = 128 | t & 63) : t < 65536 ? (e[i++] = 224 | t >>> 12, e[i++] = 128 | t >>> 6 & 63, e[i++] = 128 | t & 63) : (e[i++] = 240 | t >>> 18, e[i++] = 128 | t >>> 12 & 63, e[i++] = 128 | t >>> 6 & 63, e[i++] = 128 | t & 63);
  return e;
};
const o3 = (r, e) => {
  if (e < 65534 && r.subarray && l5)
    return String.fromCharCode.apply(null, r.length === e ? r : r.subarray(0, e));
  let t = "";
  for (let A = 0; A < e; A++)
    t += String.fromCharCode(r[A]);
  return t;
};
var l3 = (r, e) => {
  const t = e || r.length;
  if (typeof TextDecoder == "function" && TextDecoder.prototype.decode)
    return new TextDecoder().decode(r.subarray(0, e));
  let A, n;
  const i = new Array(t * 2);
  for (n = 0, A = 0; A < t; ) {
    let s = r[A++];
    if (s < 128) {
      i[n++] = s;
      continue;
    }
    let a = Yl[s];
    if (a > 4) {
      i[n++] = 65533, A += a - 1;
      continue;
    }
    for (s &= a === 2 ? 31 : a === 3 ? 15 : 7; a > 1 && A < t; )
      s = s << 6 | r[A++] & 63, a--;
    if (a > 1) {
      i[n++] = 65533;
      continue;
    }
    s < 65536 ? i[n++] = s : (s -= 65536, i[n++] = 55296 | s >> 10 & 1023, i[n++] = 56320 | s & 1023);
  }
  return o3(i, n);
}, u3 = (r, e) => {
  e = e || r.length, e > r.length && (e = r.length);
  let t = e - 1;
  for (; t >= 0 && (r[t] & 192) === 128; )
    t--;
  return t < 0 || t === 0 ? e : t + Yl[r[t]] > e ? t : e;
}, Y0 = {
  string2buf: a3,
  buf2string: l3,
  utf8border: u3
};
function c3() {
  this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
}
var h3 = c3;
const lc = 16209, f3 = 16191;
var d3 = function(e, t) {
  let A, n, i, s, a, o, l, u, h, f, c, p, g, v, w, B, S, C, E, _, I, O, U, V;
  const F = e.state;
  A = e.next_in, U = e.input, n = A + (e.avail_in - 5), i = e.next_out, V = e.output, s = i - (t - e.avail_out), a = i + (e.avail_out - 257), o = F.dmax, l = F.wsize, u = F.whave, h = F.wnext, f = F.window, c = F.hold, p = F.bits, g = F.lencode, v = F.distcode, w = (1 << F.lenbits) - 1, B = (1 << F.distbits) - 1;
  e:
    do {
      p < 15 && (c += U[A++] << p, p += 8, c += U[A++] << p, p += 8), S = g[c & w];
      t:
        for (; ; ) {
          if (C = S >>> 24, c >>>= C, p -= C, C = S >>> 16 & 255, C === 0)
            V[i++] = S & 65535;
          else if (C & 16) {
            E = S & 65535, C &= 15, C && (p < C && (c += U[A++] << p, p += 8), E += c & (1 << C) - 1, c >>>= C, p -= C), p < 15 && (c += U[A++] << p, p += 8, c += U[A++] << p, p += 8), S = v[c & B];
            r:
              for (; ; ) {
                if (C = S >>> 24, c >>>= C, p -= C, C = S >>> 16 & 255, C & 16) {
                  if (_ = S & 65535, C &= 15, p < C && (c += U[A++] << p, p += 8, p < C && (c += U[A++] << p, p += 8)), _ += c & (1 << C) - 1, _ > o) {
                    e.msg = "invalid distance too far back", F.mode = lc;
                    break e;
                  }
                  if (c >>>= C, p -= C, C = i - s, _ > C) {
                    if (C = _ - C, C > u && F.sane) {
                      e.msg = "invalid distance too far back", F.mode = lc;
                      break e;
                    }
                    if (I = 0, O = f, h === 0) {
                      if (I += l - C, C < E) {
                        E -= C;
                        do
                          V[i++] = f[I++];
                        while (--C);
                        I = i - _, O = V;
                      }
                    } else if (h < C) {
                      if (I += l + h - C, C -= h, C < E) {
                        E -= C;
                        do
                          V[i++] = f[I++];
                        while (--C);
                        if (I = 0, h < E) {
                          C = h, E -= C;
                          do
                            V[i++] = f[I++];
                          while (--C);
                          I = i - _, O = V;
                        }
                      }
                    } else if (I += h - C, C < E) {
                      E -= C;
                      do
                        V[i++] = f[I++];
                      while (--C);
                      I = i - _, O = V;
                    }
                    for (; E > 2; )
                      V[i++] = O[I++], V[i++] = O[I++], V[i++] = O[I++], E -= 3;
                    E && (V[i++] = O[I++], E > 1 && (V[i++] = O[I++]));
                  } else {
                    I = i - _;
                    do
                      V[i++] = V[I++], V[i++] = V[I++], V[i++] = V[I++], E -= 3;
                    while (E > 2);
                    E && (V[i++] = V[I++], E > 1 && (V[i++] = V[I++]));
                  }
                } else if ((C & 64) === 0) {
                  S = v[(S & 65535) + (c & (1 << C) - 1)];
                  continue r;
                } else {
                  e.msg = "invalid distance code", F.mode = lc;
                  break e;
                }
                break;
              }
          } else if ((C & 64) === 0) {
            S = g[(S & 65535) + (c & (1 << C) - 1)];
            continue t;
          } else if (C & 32) {
            F.mode = f3;
            break e;
          } else {
            e.msg = "invalid literal/length code", F.mode = lc;
            break e;
          }
          break;
        }
    } while (A < n && i < a);
  E = p >> 3, A -= E, p -= E << 3, c &= (1 << p) - 1, e.next_in = A, e.next_out = i, e.avail_in = A < n ? 5 + (n - A) : 5 - (A - n), e.avail_out = i < a ? 257 + (a - i) : 257 - (i - a), F.hold = c, F.bits = p;
};
const eo = 15, W1 = 852, X1 = 592, Y1 = 0, Xf = 1, J1 = 2, g3 = new Uint16Array([
  /* Length codes 257..285 base */
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  13,
  15,
  17,
  19,
  23,
  27,
  31,
  35,
  43,
  51,
  59,
  67,
  83,
  99,
  115,
  131,
  163,
  195,
  227,
  258,
  0,
  0
]), p3 = new Uint8Array([
  /* Length codes 257..285 extra */
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  17,
  17,
  17,
  17,
  18,
  18,
  18,
  18,
  19,
  19,
  19,
  19,
  20,
  20,
  20,
  20,
  21,
  21,
  21,
  21,
  16,
  72,
  78
]), m3 = new Uint16Array([
  /* Distance codes 0..29 base */
  1,
  2,
  3,
  4,
  5,
  7,
  9,
  13,
  17,
  25,
  33,
  49,
  65,
  97,
  129,
  193,
  257,
  385,
  513,
  769,
  1025,
  1537,
  2049,
  3073,
  4097,
  6145,
  8193,
  12289,
  16385,
  24577,
  0,
  0
]), v3 = new Uint8Array([
  /* Distance codes 0..29 extra */
  16,
  16,
  16,
  16,
  17,
  17,
  18,
  18,
  19,
  19,
  20,
  20,
  21,
  21,
  22,
  22,
  23,
  23,
  24,
  24,
  25,
  25,
  26,
  26,
  27,
  27,
  28,
  28,
  29,
  29,
  64,
  64
]), w3 = (r, e, t, A, n, i, s, a) => {
  const o = a.bits;
  let l = 0, u = 0, h = 0, f = 0, c = 0, p = 0, g = 0, v = 0, w = 0, B = 0, S, C, E, _, I, O = null, U;
  const V = new Uint16Array(eo + 1), F = new Uint16Array(eo + 1);
  let P = null, D, R, J;
  for (l = 0; l <= eo; l++)
    V[l] = 0;
  for (u = 0; u < A; u++)
    V[e[t + u]]++;
  for (c = o, f = eo; f >= 1 && V[f] === 0; f--)
    ;
  if (c > f && (c = f), f === 0)
    return n[i++] = 1 << 24 | 64 << 16 | 0, n[i++] = 1 << 24 | 64 << 16 | 0, a.bits = 1, 0;
  for (h = 1; h < f && V[h] === 0; h++)
    ;
  for (c < h && (c = h), v = 1, l = 1; l <= eo; l++)
    if (v <<= 1, v -= V[l], v < 0)
      return -1;
  if (v > 0 && (r === Y1 || f !== 1))
    return -1;
  for (F[1] = 0, l = 1; l < eo; l++)
    F[l + 1] = F[l] + V[l];
  for (u = 0; u < A; u++)
    e[t + u] !== 0 && (s[F[e[t + u]]++] = u);
  if (r === Y1 ? (O = P = s, U = 20) : r === Xf ? (O = g3, P = p3, U = 257) : (O = m3, P = v3, U = 0), B = 0, u = 0, l = h, I = i, p = c, g = 0, E = -1, w = 1 << c, _ = w - 1, r === Xf && w > W1 || r === J1 && w > X1)
    return 1;
  for (; ; ) {
    D = l - g, s[u] + 1 < U ? (R = 0, J = s[u]) : s[u] >= U ? (R = P[s[u] - U], J = O[s[u] - U]) : (R = 96, J = 0), S = 1 << l - g, C = 1 << p, h = C;
    do
      C -= S, n[I + (B >> g) + C] = D << 24 | R << 16 | J | 0;
    while (C !== 0);
    for (S = 1 << l - 1; B & S; )
      S >>= 1;
    if (S !== 0 ? (B &= S - 1, B += S) : B = 0, u++, --V[l] === 0) {
      if (l === f)
        break;
      l = e[t + s[u]];
    }
    if (l > c && (B & _) !== E) {
      for (g === 0 && (g = c), I += h, p = l - g, v = 1 << p; p + g < f && (v -= V[p + g], !(v <= 0)); )
        p++, v <<= 1;
      if (w += 1 << p, r === Xf && w > W1 || r === J1 && w > X1)
        return 1;
      E = B & _, n[E] = c << 24 | p << 16 | I - i | 0;
    }
  }
  return B !== 0 && (n[I + B] = l - g << 24 | 64 << 16 | 0), a.bits = c, 0;
};
var Dl = w3;
const y3 = 0, u5 = 1, c5 = 2, {
  Z_FINISH: $1,
  Z_BLOCK: B3,
  Z_TREES: uc,
  Z_OK: Na,
  Z_STREAM_END: b3,
  Z_NEED_DICT: C3,
  Z_STREAM_ERROR: kn,
  Z_DATA_ERROR: h5,
  Z_MEM_ERROR: f5,
  Z_BUF_ERROR: S3,
  Z_DEFLATED: Z1
} = a5, Lh = 16180, ew = 16181, tw = 16182, rw = 16183, Aw = 16184, nw = 16185, iw = 16186, sw = 16187, aw = 16188, ow = 16189, gh = 16190, Vi = 16191, Yf = 16192, lw = 16193, Jf = 16194, uw = 16195, cw = 16196, hw = 16197, fw = 16198, cc = 16199, hc = 16200, dw = 16201, gw = 16202, pw = 16203, mw = 16204, vw = 16205, $f = 16206, ww = 16207, yw = 16208, Br = 16209, d5 = 16210, g5 = 16211, x3 = 852, E3 = 592, F3 = 15, _3 = F3, Bw = (r) => (r >>> 24 & 255) + (r >>> 8 & 65280) + ((r & 65280) << 8) + ((r & 255) << 24);
function U3() {
  this.strm = null, this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new Uint16Array(320), this.work = new Uint16Array(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
}
const Ma = (r) => {
  if (!r)
    return 1;
  const e = r.state;
  return !e || e.strm !== r || e.mode < Lh || e.mode > g5 ? 1 : 0;
}, p5 = (r) => {
  if (Ma(r))
    return kn;
  const e = r.state;
  return r.total_in = r.total_out = e.total = 0, r.msg = "", e.wrap && (r.adler = e.wrap & 1), e.mode = Lh, e.last = 0, e.havedict = 0, e.flags = -1, e.dmax = 32768, e.head = null, e.hold = 0, e.bits = 0, e.lencode = e.lendyn = new Int32Array(x3), e.distcode = e.distdyn = new Int32Array(E3), e.sane = 1, e.back = -1, Na;
}, m5 = (r) => {
  if (Ma(r))
    return kn;
  const e = r.state;
  return e.wsize = 0, e.whave = 0, e.wnext = 0, p5(r);
}, v5 = (r, e) => {
  let t;
  if (Ma(r))
    return kn;
  const A = r.state;
  return e < 0 ? (t = 0, e = -e) : (t = (e >> 4) + 5, e < 48 && (e &= 15)), e && (e < 8 || e > 15) ? kn : (A.window !== null && A.wbits !== e && (A.window = null), A.wrap = t, A.wbits = e, m5(r));
}, w5 = (r, e) => {
  if (!r)
    return kn;
  const t = new U3();
  r.state = t, t.strm = r, t.window = null, t.mode = Lh;
  const A = v5(r, e);
  return A !== Na && (r.state = null), A;
}, I3 = (r) => w5(r, _3);
let bw = !0, Zf, ed;
const Q3 = (r) => {
  if (bw) {
    Zf = new Int32Array(512), ed = new Int32Array(32);
    let e = 0;
    for (; e < 144; )
      r.lens[e++] = 8;
    for (; e < 256; )
      r.lens[e++] = 9;
    for (; e < 280; )
      r.lens[e++] = 7;
    for (; e < 288; )
      r.lens[e++] = 8;
    for (Dl(u5, r.lens, 0, 288, Zf, 0, r.work, { bits: 9 }), e = 0; e < 32; )
      r.lens[e++] = 5;
    Dl(c5, r.lens, 0, 32, ed, 0, r.work, { bits: 5 }), bw = !1;
  }
  r.lencode = Zf, r.lenbits = 9, r.distcode = ed, r.distbits = 5;
}, y5 = (r, e, t, A) => {
  let n;
  const i = r.state;
  return i.window === null && (i.wsize = 1 << i.wbits, i.wnext = 0, i.whave = 0, i.window = new Uint8Array(i.wsize)), A >= i.wsize ? (i.window.set(e.subarray(t - i.wsize, t), 0), i.wnext = 0, i.whave = i.wsize) : (n = i.wsize - i.wnext, n > A && (n = A), i.window.set(e.subarray(t - A, t - A + n), i.wnext), A -= n, A ? (i.window.set(e.subarray(t - A, t), 0), i.wnext = A, i.whave = i.wsize) : (i.wnext += n, i.wnext === i.wsize && (i.wnext = 0), i.whave < i.wsize && (i.whave += n))), 0;
}, L3 = (r, e) => {
  let t, A, n, i, s, a, o, l, u, h, f, c, p, g, v = 0, w, B, S, C, E, _, I, O;
  const U = new Uint8Array(4);
  let V, F;
  const P = (
    /* permutation of code lengths */
    new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15])
  );
  if (Ma(r) || !r.output || !r.input && r.avail_in !== 0)
    return kn;
  t = r.state, t.mode === Vi && (t.mode = Yf), s = r.next_out, n = r.output, o = r.avail_out, i = r.next_in, A = r.input, a = r.avail_in, l = t.hold, u = t.bits, h = a, f = o, O = Na;
  e:
    for (; ; )
      switch (t.mode) {
        case Lh:
          if (t.wrap === 0) {
            t.mode = Yf;
            break;
          }
          for (; u < 16; ) {
            if (a === 0)
              break e;
            a--, l += A[i++] << u, u += 8;
          }
          if (t.wrap & 2 && l === 35615) {
            t.wbits === 0 && (t.wbits = 15), t.check = 0, U[0] = l & 255, U[1] = l >>> 8 & 255, t.check = gi(t.check, U, 2, 0), l = 0, u = 0, t.mode = ew;
            break;
          }
          if (t.head && (t.head.done = !1), !(t.wrap & 1) || /* check if zlib header allowed */
          (((l & 255) << 8) + (l >> 8)) % 31) {
            r.msg = "incorrect header check", t.mode = Br;
            break;
          }
          if ((l & 15) !== Z1) {
            r.msg = "unknown compression method", t.mode = Br;
            break;
          }
          if (l >>>= 4, u -= 4, I = (l & 15) + 8, t.wbits === 0 && (t.wbits = I), I > 15 || I > t.wbits) {
            r.msg = "invalid window size", t.mode = Br;
            break;
          }
          t.dmax = 1 << t.wbits, t.flags = 0, r.adler = t.check = 1, t.mode = l & 512 ? ow : Vi, l = 0, u = 0;
          break;
        case ew:
          for (; u < 16; ) {
            if (a === 0)
              break e;
            a--, l += A[i++] << u, u += 8;
          }
          if (t.flags = l, (t.flags & 255) !== Z1) {
            r.msg = "unknown compression method", t.mode = Br;
            break;
          }
          if (t.flags & 57344) {
            r.msg = "unknown header flags set", t.mode = Br;
            break;
          }
          t.head && (t.head.text = l >> 8 & 1), t.flags & 512 && t.wrap & 4 && (U[0] = l & 255, U[1] = l >>> 8 & 255, t.check = gi(t.check, U, 2, 0)), l = 0, u = 0, t.mode = tw;
        /* falls through */
        case tw:
          for (; u < 32; ) {
            if (a === 0)
              break e;
            a--, l += A[i++] << u, u += 8;
          }
          t.head && (t.head.time = l), t.flags & 512 && t.wrap & 4 && (U[0] = l & 255, U[1] = l >>> 8 & 255, U[2] = l >>> 16 & 255, U[3] = l >>> 24 & 255, t.check = gi(t.check, U, 4, 0)), l = 0, u = 0, t.mode = rw;
        /* falls through */
        case rw:
          for (; u < 16; ) {
            if (a === 0)
              break e;
            a--, l += A[i++] << u, u += 8;
          }
          t.head && (t.head.xflags = l & 255, t.head.os = l >> 8), t.flags & 512 && t.wrap & 4 && (U[0] = l & 255, U[1] = l >>> 8 & 255, t.check = gi(t.check, U, 2, 0)), l = 0, u = 0, t.mode = Aw;
        /* falls through */
        case Aw:
          if (t.flags & 1024) {
            for (; u < 16; ) {
              if (a === 0)
                break e;
              a--, l += A[i++] << u, u += 8;
            }
            t.length = l, t.head && (t.head.extra_len = l), t.flags & 512 && t.wrap & 4 && (U[0] = l & 255, U[1] = l >>> 8 & 255, t.check = gi(t.check, U, 2, 0)), l = 0, u = 0;
          } else t.head && (t.head.extra = null);
          t.mode = nw;
        /* falls through */
        case nw:
          if (t.flags & 1024 && (c = t.length, c > a && (c = a), c && (t.head && (I = t.head.extra_len - t.length, t.head.extra || (t.head.extra = new Uint8Array(t.head.extra_len)), t.head.extra.set(
            A.subarray(
              i,
              // extra field is limited to 65536 bytes
              // - no need for additional size check
              i + c
            ),
            /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
            I
          )), t.flags & 512 && t.wrap & 4 && (t.check = gi(t.check, A, c, i)), a -= c, i += c, t.length -= c), t.length))
            break e;
          t.length = 0, t.mode = iw;
        /* falls through */
        case iw:
          if (t.flags & 2048) {
            if (a === 0)
              break e;
            c = 0;
            do
              I = A[i + c++], t.head && I && t.length < 65536 && (t.head.name += String.fromCharCode(I));
            while (I && c < a);
            if (t.flags & 512 && t.wrap & 4 && (t.check = gi(t.check, A, c, i)), a -= c, i += c, I)
              break e;
          } else t.head && (t.head.name = null);
          t.length = 0, t.mode = sw;
        /* falls through */
        case sw:
          if (t.flags & 4096) {
            if (a === 0)
              break e;
            c = 0;
            do
              I = A[i + c++], t.head && I && t.length < 65536 && (t.head.comment += String.fromCharCode(I));
            while (I && c < a);
            if (t.flags & 512 && t.wrap & 4 && (t.check = gi(t.check, A, c, i)), a -= c, i += c, I)
              break e;
          } else t.head && (t.head.comment = null);
          t.mode = aw;
        /* falls through */
        case aw:
          if (t.flags & 512) {
            for (; u < 16; ) {
              if (a === 0)
                break e;
              a--, l += A[i++] << u, u += 8;
            }
            if (t.wrap & 4 && l !== (t.check & 65535)) {
              r.msg = "header crc mismatch", t.mode = Br;
              break;
            }
            l = 0, u = 0;
          }
          t.head && (t.head.hcrc = t.flags >> 9 & 1, t.head.done = !0), r.adler = t.check = 0, t.mode = Vi;
          break;
        case ow:
          for (; u < 32; ) {
            if (a === 0)
              break e;
            a--, l += A[i++] << u, u += 8;
          }
          r.adler = t.check = Bw(l), l = 0, u = 0, t.mode = gh;
        /* falls through */
        case gh:
          if (t.havedict === 0)
            return r.next_out = s, r.avail_out = o, r.next_in = i, r.avail_in = a, t.hold = l, t.bits = u, C3;
          r.adler = t.check = 1, t.mode = Vi;
        /* falls through */
        case Vi:
          if (e === B3 || e === uc)
            break e;
        /* falls through */
        case Yf:
          if (t.last) {
            l >>>= u & 7, u -= u & 7, t.mode = $f;
            break;
          }
          for (; u < 3; ) {
            if (a === 0)
              break e;
            a--, l += A[i++] << u, u += 8;
          }
          switch (t.last = l & 1, l >>>= 1, u -= 1, l & 3) {
            case 0:
              t.mode = lw;
              break;
            case 1:
              if (Q3(t), t.mode = cc, e === uc) {
                l >>>= 2, u -= 2;
                break e;
              }
              break;
            case 2:
              t.mode = cw;
              break;
            case 3:
              r.msg = "invalid block type", t.mode = Br;
          }
          l >>>= 2, u -= 2;
          break;
        case lw:
          for (l >>>= u & 7, u -= u & 7; u < 32; ) {
            if (a === 0)
              break e;
            a--, l += A[i++] << u, u += 8;
          }
          if ((l & 65535) !== (l >>> 16 ^ 65535)) {
            r.msg = "invalid stored block lengths", t.mode = Br;
            break;
          }
          if (t.length = l & 65535, l = 0, u = 0, t.mode = Jf, e === uc)
            break e;
        /* falls through */
        case Jf:
          t.mode = uw;
        /* falls through */
        case uw:
          if (c = t.length, c) {
            if (c > a && (c = a), c > o && (c = o), c === 0)
              break e;
            n.set(A.subarray(i, i + c), s), a -= c, i += c, o -= c, s += c, t.length -= c;
            break;
          }
          t.mode = Vi;
          break;
        case cw:
          for (; u < 14; ) {
            if (a === 0)
              break e;
            a--, l += A[i++] << u, u += 8;
          }
          if (t.nlen = (l & 31) + 257, l >>>= 5, u -= 5, t.ndist = (l & 31) + 1, l >>>= 5, u -= 5, t.ncode = (l & 15) + 4, l >>>= 4, u -= 4, t.nlen > 286 || t.ndist > 30) {
            r.msg = "too many length or distance symbols", t.mode = Br;
            break;
          }
          t.have = 0, t.mode = hw;
        /* falls through */
        case hw:
          for (; t.have < t.ncode; ) {
            for (; u < 3; ) {
              if (a === 0)
                break e;
              a--, l += A[i++] << u, u += 8;
            }
            t.lens[P[t.have++]] = l & 7, l >>>= 3, u -= 3;
          }
          for (; t.have < 19; )
            t.lens[P[t.have++]] = 0;
          if (t.lencode = t.lendyn, t.lenbits = 7, V = { bits: t.lenbits }, O = Dl(y3, t.lens, 0, 19, t.lencode, 0, t.work, V), t.lenbits = V.bits, O) {
            r.msg = "invalid code lengths set", t.mode = Br;
            break;
          }
          t.have = 0, t.mode = fw;
        /* falls through */
        case fw:
          for (; t.have < t.nlen + t.ndist; ) {
            for (; v = t.lencode[l & (1 << t.lenbits) - 1], w = v >>> 24, B = v >>> 16 & 255, S = v & 65535, !(w <= u); ) {
              if (a === 0)
                break e;
              a--, l += A[i++] << u, u += 8;
            }
            if (S < 16)
              l >>>= w, u -= w, t.lens[t.have++] = S;
            else {
              if (S === 16) {
                for (F = w + 2; u < F; ) {
                  if (a === 0)
                    break e;
                  a--, l += A[i++] << u, u += 8;
                }
                if (l >>>= w, u -= w, t.have === 0) {
                  r.msg = "invalid bit length repeat", t.mode = Br;
                  break;
                }
                I = t.lens[t.have - 1], c = 3 + (l & 3), l >>>= 2, u -= 2;
              } else if (S === 17) {
                for (F = w + 3; u < F; ) {
                  if (a === 0)
                    break e;
                  a--, l += A[i++] << u, u += 8;
                }
                l >>>= w, u -= w, I = 0, c = 3 + (l & 7), l >>>= 3, u -= 3;
              } else {
                for (F = w + 7; u < F; ) {
                  if (a === 0)
                    break e;
                  a--, l += A[i++] << u, u += 8;
                }
                l >>>= w, u -= w, I = 0, c = 11 + (l & 127), l >>>= 7, u -= 7;
              }
              if (t.have + c > t.nlen + t.ndist) {
                r.msg = "invalid bit length repeat", t.mode = Br;
                break;
              }
              for (; c--; )
                t.lens[t.have++] = I;
            }
          }
          if (t.mode === Br)
            break;
          if (t.lens[256] === 0) {
            r.msg = "invalid code -- missing end-of-block", t.mode = Br;
            break;
          }
          if (t.lenbits = 9, V = { bits: t.lenbits }, O = Dl(u5, t.lens, 0, t.nlen, t.lencode, 0, t.work, V), t.lenbits = V.bits, O) {
            r.msg = "invalid literal/lengths set", t.mode = Br;
            break;
          }
          if (t.distbits = 6, t.distcode = t.distdyn, V = { bits: t.distbits }, O = Dl(c5, t.lens, t.nlen, t.ndist, t.distcode, 0, t.work, V), t.distbits = V.bits, O) {
            r.msg = "invalid distances set", t.mode = Br;
            break;
          }
          if (t.mode = cc, e === uc)
            break e;
        /* falls through */
        case cc:
          t.mode = hc;
        /* falls through */
        case hc:
          if (a >= 6 && o >= 258) {
            r.next_out = s, r.avail_out = o, r.next_in = i, r.avail_in = a, t.hold = l, t.bits = u, d3(r, f), s = r.next_out, n = r.output, o = r.avail_out, i = r.next_in, A = r.input, a = r.avail_in, l = t.hold, u = t.bits, t.mode === Vi && (t.back = -1);
            break;
          }
          for (t.back = 0; v = t.lencode[l & (1 << t.lenbits) - 1], w = v >>> 24, B = v >>> 16 & 255, S = v & 65535, !(w <= u); ) {
            if (a === 0)
              break e;
            a--, l += A[i++] << u, u += 8;
          }
          if (B && (B & 240) === 0) {
            for (C = w, E = B, _ = S; v = t.lencode[_ + ((l & (1 << C + E) - 1) >> C)], w = v >>> 24, B = v >>> 16 & 255, S = v & 65535, !(C + w <= u); ) {
              if (a === 0)
                break e;
              a--, l += A[i++] << u, u += 8;
            }
            l >>>= C, u -= C, t.back += C;
          }
          if (l >>>= w, u -= w, t.back += w, t.length = S, B === 0) {
            t.mode = vw;
            break;
          }
          if (B & 32) {
            t.back = -1, t.mode = Vi;
            break;
          }
          if (B & 64) {
            r.msg = "invalid literal/length code", t.mode = Br;
            break;
          }
          t.extra = B & 15, t.mode = dw;
        /* falls through */
        case dw:
          if (t.extra) {
            for (F = t.extra; u < F; ) {
              if (a === 0)
                break e;
              a--, l += A[i++] << u, u += 8;
            }
            t.length += l & (1 << t.extra) - 1, l >>>= t.extra, u -= t.extra, t.back += t.extra;
          }
          t.was = t.length, t.mode = gw;
        /* falls through */
        case gw:
          for (; v = t.distcode[l & (1 << t.distbits) - 1], w = v >>> 24, B = v >>> 16 & 255, S = v & 65535, !(w <= u); ) {
            if (a === 0)
              break e;
            a--, l += A[i++] << u, u += 8;
          }
          if ((B & 240) === 0) {
            for (C = w, E = B, _ = S; v = t.distcode[_ + ((l & (1 << C + E) - 1) >> C)], w = v >>> 24, B = v >>> 16 & 255, S = v & 65535, !(C + w <= u); ) {
              if (a === 0)
                break e;
              a--, l += A[i++] << u, u += 8;
            }
            l >>>= C, u -= C, t.back += C;
          }
          if (l >>>= w, u -= w, t.back += w, B & 64) {
            r.msg = "invalid distance code", t.mode = Br;
            break;
          }
          t.offset = S, t.extra = B & 15, t.mode = pw;
        /* falls through */
        case pw:
          if (t.extra) {
            for (F = t.extra; u < F; ) {
              if (a === 0)
                break e;
              a--, l += A[i++] << u, u += 8;
            }
            t.offset += l & (1 << t.extra) - 1, l >>>= t.extra, u -= t.extra, t.back += t.extra;
          }
          if (t.offset > t.dmax) {
            r.msg = "invalid distance too far back", t.mode = Br;
            break;
          }
          t.mode = mw;
        /* falls through */
        case mw:
          if (o === 0)
            break e;
          if (c = f - o, t.offset > c) {
            if (c = t.offset - c, c > t.whave && t.sane) {
              r.msg = "invalid distance too far back", t.mode = Br;
              break;
            }
            c > t.wnext ? (c -= t.wnext, p = t.wsize - c) : p = t.wnext - c, c > t.length && (c = t.length), g = t.window;
          } else
            g = n, p = s - t.offset, c = t.length;
          c > o && (c = o), o -= c, t.length -= c;
          do
            n[s++] = g[p++];
          while (--c);
          t.length === 0 && (t.mode = hc);
          break;
        case vw:
          if (o === 0)
            break e;
          n[s++] = t.length, o--, t.mode = hc;
          break;
        case $f:
          if (t.wrap) {
            for (; u < 32; ) {
              if (a === 0)
                break e;
              a--, l |= A[i++] << u, u += 8;
            }
            if (f -= o, r.total_out += f, t.total += f, t.wrap & 4 && f && (r.adler = t.check = /*UPDATE_CHECK(state.check, put - _out, _out);*/
            t.flags ? gi(t.check, n, f, s - f) : W0(t.check, n, f, s - f)), f = o, t.wrap & 4 && (t.flags ? l : Bw(l)) !== t.check) {
              r.msg = "incorrect data check", t.mode = Br;
              break;
            }
            l = 0, u = 0;
          }
          t.mode = ww;
        /* falls through */
        case ww:
          if (t.wrap && t.flags) {
            for (; u < 32; ) {
              if (a === 0)
                break e;
              a--, l += A[i++] << u, u += 8;
            }
            if (t.wrap & 4 && l !== (t.total & 4294967295)) {
              r.msg = "incorrect length check", t.mode = Br;
              break;
            }
            l = 0, u = 0;
          }
          t.mode = yw;
        /* falls through */
        case yw:
          O = b3;
          break e;
        case Br:
          O = h5;
          break e;
        case d5:
          return f5;
        case g5:
        /* falls through */
        default:
          return kn;
      }
  return r.next_out = s, r.avail_out = o, r.next_in = i, r.avail_in = a, t.hold = l, t.bits = u, (t.wsize || f !== r.avail_out && t.mode < Br && (t.mode < $f || e !== $1)) && y5(r, r.output, r.next_out, f - r.avail_out), h -= r.avail_in, f -= r.avail_out, r.total_in += h, r.total_out += f, t.total += f, t.wrap & 4 && f && (r.adler = t.check = /*UPDATE_CHECK(state.check, strm.next_out - _out, _out);*/
  t.flags ? gi(t.check, n, f, r.next_out - f) : W0(t.check, n, f, r.next_out - f)), r.data_type = t.bits + (t.last ? 64 : 0) + (t.mode === Vi ? 128 : 0) + (t.mode === cc || t.mode === Jf ? 256 : 0), (h === 0 && f === 0 || e === $1) && O === Na && (O = S3), O;
}, N3 = (r) => {
  if (Ma(r))
    return kn;
  let e = r.state;
  return e.window && (e.window = null), r.state = null, Na;
}, T3 = (r, e) => {
  if (Ma(r))
    return kn;
  const t = r.state;
  return (t.wrap & 2) === 0 ? kn : (t.head = e, e.done = !1, Na);
}, P3 = (r, e) => {
  const t = e.length;
  let A, n, i;
  return Ma(r) || (A = r.state, A.wrap !== 0 && A.mode !== gh) ? kn : A.mode === gh && (n = 1, n = W0(n, e, t, 0), n !== A.check) ? h5 : (i = y5(r, e, t, t), i ? (A.mode = d5, f5) : (A.havedict = 1, Na));
};
var O3 = m5, M3 = v5, R3 = p5, k3 = I3, H3 = w5, D3 = L3, G3 = N3, V3 = T3, K3 = P3, j3 = "pako inflate (from Nodeca project)", Xi = {
  inflateReset: O3,
  inflateReset2: M3,
  inflateResetKeep: R3,
  inflateInit: k3,
  inflateInit2: H3,
  inflate: D3,
  inflateEnd: G3,
  inflateGetHeader: V3,
  inflateSetDictionary: K3,
  inflateInfo: j3
};
function q3() {
  this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
}
var z3 = q3;
const B5 = Object.prototype.toString, {
  Z_NO_FLUSH: W3,
  Z_FINISH: X3,
  Z_OK: Jl,
  Z_STREAM_END: td,
  Z_NEED_DICT: rd,
  Z_STREAM_ERROR: Y3,
  Z_DATA_ERROR: Cw,
  Z_MEM_ERROR: J3
} = a5;
function lu(r) {
  this.options = o5.assign({
    chunkSize: 1024 * 64,
    windowBits: 15,
    to: ""
  }, r || {});
  const e = this.options;
  e.raw && e.windowBits >= 0 && e.windowBits < 16 && (e.windowBits = -e.windowBits, e.windowBits === 0 && (e.windowBits = -15)), e.windowBits >= 0 && e.windowBits < 16 && !(r && r.windowBits) && (e.windowBits += 32), e.windowBits > 15 && e.windowBits < 48 && (e.windowBits & 15) === 0 && (e.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new h3(), this.strm.avail_out = 0;
  let t = Xi.inflateInit2(
    this.strm,
    e.windowBits
  );
  if (t !== Jl)
    throw new Error(X0[t]);
  if (this.header = new z3(), Xi.inflateGetHeader(this.strm, this.header), e.dictionary && (typeof e.dictionary == "string" ? e.dictionary = Y0.string2buf(e.dictionary) : B5.call(e.dictionary) === "[object ArrayBuffer]" && (e.dictionary = new Uint8Array(e.dictionary)), e.raw && (t = Xi.inflateSetDictionary(this.strm, e.dictionary), t !== Jl)))
    throw new Error(X0[t]);
}
lu.prototype.push = function(r, e) {
  const t = this.strm, A = this.options.chunkSize, n = this.options.dictionary;
  let i, s, a;
  if (this.ended) return !1;
  for (e === ~~e ? s = e : s = e === !0 ? X3 : W3, B5.call(r) === "[object ArrayBuffer]" ? t.input = new Uint8Array(r) : t.input = r, t.next_in = 0, t.avail_in = t.input.length; ; ) {
    for (t.avail_out === 0 && (t.output = new Uint8Array(A), t.next_out = 0, t.avail_out = A), i = Xi.inflate(t, s), i === rd && n && (i = Xi.inflateSetDictionary(t, n), i === Jl ? i = Xi.inflate(t, s) : i === Cw && (i = rd)); t.avail_in > 0 && i === td && t.state.wrap > 0 && r[t.next_in] !== 0; )
      Xi.inflateReset(t), i = Xi.inflate(t, s);
    switch (i) {
      case Y3:
      case Cw:
      case rd:
      case J3:
        return this.onEnd(i), this.ended = !0, !1;
    }
    if (a = t.avail_out, t.next_out && (t.avail_out === 0 || i === td))
      if (this.options.to === "string") {
        let o = Y0.utf8border(t.output, t.next_out), l = t.next_out - o, u = Y0.buf2string(t.output, o);
        t.next_out = l, t.avail_out = A - l, l && t.output.set(t.output.subarray(o, o + l), 0), this.onData(u);
      } else
        this.onData(t.output.length === t.next_out ? t.output : t.output.subarray(0, t.next_out));
    if (!(i === Jl && a === 0)) {
      if (i === td)
        return i = Xi.inflateEnd(this.strm), this.onEnd(i), this.ended = !0, !0;
      if (t.avail_in === 0) break;
    }
  }
  return !0;
};
lu.prototype.onData = function(r) {
  this.chunks.push(r);
};
lu.prototype.onEnd = function(r) {
  r === Jl && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = o5.flattenChunks(this.chunks)), this.chunks = [], this.err = r, this.msg = this.strm.msg;
};
function $3(r, e) {
  const t = new lu(e);
  if (t.push(r), t.err) throw t.msg || X0[t.err];
  return t.result;
}
var Z3 = lu, eQ = $3, tQ = {
  Inflate: Z3,
  inflate: eQ
};
const { Inflate: rQ, inflate: AQ } = tQ;
var Sw = rQ, nQ = AQ;
const b5 = [];
for (let r = 0; r < 256; r++) {
  let e = r;
  for (let t = 0; t < 8; t++)
    e & 1 ? e = 3988292384 ^ e >>> 1 : e = e >>> 1;
  b5[r] = e;
}
const xw = 4294967295;
function iQ(r, e, t) {
  let A = r;
  for (let n = 0; n < t; n++)
    A = b5[(A ^ e[n]) & 255] ^ A >>> 8;
  return A;
}
function sQ(r, e) {
  return (iQ(xw, r, e) ^ xw) >>> 0;
}
function Ew(r, e, t) {
  const A = r.readUint32(), n = sQ(new Uint8Array(r.buffer, r.byteOffset + r.offset - e - 4, e), e);
  if (n !== A)
    throw new Error(`CRC mismatch for chunk ${t}. Expected ${A}, found ${n}`);
}
function C5(r, e, t) {
  for (let A = 0; A < t; A++)
    e[A] = r[A];
}
function S5(r, e, t, A) {
  let n = 0;
  for (; n < A; n++)
    e[n] = r[n];
  for (; n < t; n++)
    e[n] = r[n] + e[n - A] & 255;
}
function x5(r, e, t, A) {
  let n = 0;
  if (t.length === 0)
    for (; n < A; n++)
      e[n] = r[n];
  else
    for (; n < A; n++)
      e[n] = r[n] + t[n] & 255;
}
function E5(r, e, t, A, n) {
  let i = 0;
  if (t.length === 0) {
    for (; i < n; i++)
      e[i] = r[i];
    for (; i < A; i++)
      e[i] = r[i] + (e[i - n] >> 1) & 255;
  } else {
    for (; i < n; i++)
      e[i] = r[i] + (t[i] >> 1) & 255;
    for (; i < A; i++)
      e[i] = r[i] + (e[i - n] + t[i] >> 1) & 255;
  }
}
function F5(r, e, t, A, n) {
  let i = 0;
  if (t.length === 0) {
    for (; i < n; i++)
      e[i] = r[i];
    for (; i < A; i++)
      e[i] = r[i] + e[i - n] & 255;
  } else {
    for (; i < n; i++)
      e[i] = r[i] + t[i] & 255;
    for (; i < A; i++)
      e[i] = r[i] + aQ(e[i - n], t[i], t[i - n]) & 255;
  }
}
function aQ(r, e, t) {
  const A = r + e - t, n = Math.abs(A - r), i = Math.abs(A - e), s = Math.abs(A - t);
  return n <= i && n <= s ? r : i <= s ? e : t;
}
function oQ(r, e, t, A, n, i) {
  switch (r) {
    case 0:
      C5(e, t, n);
      break;
    case 1:
      S5(e, t, n, i);
      break;
    case 2:
      x5(e, t, A, n);
      break;
    case 3:
      E5(e, t, A, n, i);
      break;
    case 4:
      F5(e, t, A, n, i);
      break;
    default:
      throw new Error(`Unsupported filter: ${r}`);
  }
}
const lQ = new Uint16Array([255]), uQ = new Uint8Array(lQ.buffer), cQ = uQ[0] === 255;
function hQ(r) {
  const { data: e, width: t, height: A, channels: n, depth: i } = r, s = [
    { x: 0, y: 0, xStep: 8, yStep: 8 },
    // Pass 1
    { x: 4, y: 0, xStep: 8, yStep: 8 },
    // Pass 2
    { x: 0, y: 4, xStep: 4, yStep: 8 },
    // Pass 3
    { x: 2, y: 0, xStep: 4, yStep: 4 },
    // Pass 4
    { x: 0, y: 2, xStep: 2, yStep: 4 },
    // Pass 5
    { x: 1, y: 0, xStep: 2, yStep: 2 },
    // Pass 6
    { x: 0, y: 1, xStep: 1, yStep: 2 }
    // Pass 7
  ], a = Math.ceil(i / 8) * n, o = new Uint8Array(A * t * a);
  let l = 0;
  for (let u = 0; u < 7; u++) {
    const h = s[u], f = Math.ceil((t - h.x) / h.xStep), c = Math.ceil((A - h.y) / h.yStep);
    if (f <= 0 || c <= 0)
      continue;
    const p = f * a, g = new Uint8Array(p);
    for (let v = 0; v < c; v++) {
      const w = e[l++], B = e.subarray(l, l + p);
      l += p;
      const S = new Uint8Array(p);
      oQ(w, B, S, g, p, a), g.set(S);
      for (let C = 0; C < f; C++) {
        const E = h.x + C * h.xStep, _ = h.y + v * h.yStep;
        if (!(E >= t || _ >= A))
          for (let I = 0; I < a; I++)
            o[(_ * t + E) * a + I] = S[C * a + I];
      }
    }
  }
  if (i === 16) {
    const u = new Uint16Array(o.buffer);
    if (cQ)
      for (let h = 0; h < u.length; h++)
        u[h] = fQ(u[h]);
    return u;
  } else
    return o;
}
function fQ(r) {
  return (r & 255) << 8 | r >> 8 & 255;
}
const dQ = new Uint16Array([255]), gQ = new Uint8Array(dQ.buffer), pQ = gQ[0] === 255, mQ = new Uint8Array(0);
function Fw(r) {
  const { data: e, width: t, height: A, channels: n, depth: i } = r, s = Math.ceil(i / 8) * n, a = Math.ceil(i / 8 * n * t), o = new Uint8Array(A * a);
  let l = mQ, u = 0, h, f;
  for (let c = 0; c < A; c++) {
    switch (h = e.subarray(u + 1, u + 1 + a), f = o.subarray(c * a, (c + 1) * a), e[u]) {
      case 0:
        C5(h, f, a);
        break;
      case 1:
        S5(h, f, a, s);
        break;
      case 2:
        x5(h, f, l, a);
        break;
      case 3:
        E5(h, f, l, a, s);
        break;
      case 4:
        F5(h, f, l, a, s);
        break;
      default:
        throw new Error(`Unsupported filter: ${e[u]}`);
    }
    l = f, u += a + 1;
  }
  if (i === 16) {
    const c = new Uint16Array(o.buffer);
    if (pQ)
      for (let p = 0; p < c.length; p++)
        c[p] = vQ(c[p]);
    return c;
  } else
    return o;
}
function vQ(r) {
  return (r & 255) << 8 | r >> 8 & 255;
}
const $c = Uint8Array.of(137, 80, 78, 71, 13, 10, 26, 10);
function _w(r) {
  if (!wQ(r.readBytes($c.length)))
    throw new Error("wrong PNG signature");
}
function wQ(r) {
  if (r.length < $c.length)
    return !1;
  for (let e = 0; e < $c.length; e++)
    if (r[e] !== $c[e])
      return !1;
  return !0;
}
const yQ = "tEXt", BQ = 0, _5 = new TextDecoder("latin1");
function bQ(r) {
  if (SQ(r), r.length === 0 || r.length > 79)
    throw new Error("keyword length must be between 1 and 79");
}
const CQ = /^[\u0000-\u00FF]*$/;
function SQ(r) {
  if (!CQ.test(r))
    throw new Error("invalid latin1 text");
}
function xQ(r, e, t) {
  const A = U5(e);
  r[A] = EQ(e, t - A.length - 1);
}
function U5(r) {
  for (r.mark(); r.readByte() !== BQ; )
    ;
  const e = r.offset;
  r.reset();
  const t = _5.decode(r.readBytes(e - r.offset - 1));
  return r.skip(1), bQ(t), t;
}
function EQ(r, e) {
  return _5.decode(r.readBytes(e));
}
const mn = {
  UNKNOWN: -1,
  GREYSCALE: 0,
  TRUECOLOUR: 2,
  INDEXED_COLOUR: 3,
  GREYSCALE_ALPHA: 4,
  TRUECOLOUR_ALPHA: 6
}, Ad = {
  UNKNOWN: -1,
  DEFLATE: 0
}, Uw = {
  UNKNOWN: -1,
  ADAPTIVE: 0
}, nd = {
  UNKNOWN: -1,
  NO_INTERLACE: 0,
  ADAM7: 1
}, fc = {
  NONE: 0,
  BACKGROUND: 1,
  PREVIOUS: 2
}, id = {
  SOURCE: 0,
  OVER: 1
};
class FQ extends iv {
  _checkCrc;
  _inflator;
  _png;
  _apng;
  _end;
  _hasPalette;
  _palette;
  _hasTransparency;
  _transparency;
  _compressionMethod;
  _filterMethod;
  _interlaceMethod;
  _colorType;
  _isAnimated;
  _numberOfFrames;
  _numberOfPlays;
  _frames;
  _writingDataChunks;
  constructor(e, t = {}) {
    super(e);
    const { checkCrc: A = !1 } = t;
    this._checkCrc = A, this._inflator = new Sw(), this._png = {
      width: -1,
      height: -1,
      channels: -1,
      data: new Uint8Array(0),
      depth: 1,
      text: {}
    }, this._apng = {
      width: -1,
      height: -1,
      channels: -1,
      depth: 1,
      numberOfFrames: 1,
      numberOfPlays: 0,
      text: {},
      frames: []
    }, this._end = !1, this._hasPalette = !1, this._palette = [], this._hasTransparency = !1, this._transparency = new Uint16Array(0), this._compressionMethod = Ad.UNKNOWN, this._filterMethod = Uw.UNKNOWN, this._interlaceMethod = nd.UNKNOWN, this._colorType = mn.UNKNOWN, this._isAnimated = !1, this._numberOfFrames = 1, this._numberOfPlays = 0, this._frames = [], this._writingDataChunks = !1, this.setBigEndian();
  }
  decode() {
    for (_w(this); !this._end; ) {
      const e = this.readUint32(), t = this.readChars(4);
      this.decodeChunk(e, t);
    }
    return this.decodeImage(), this._png;
  }
  decodeApng() {
    for (_w(this); !this._end; ) {
      const e = this.readUint32(), t = this.readChars(4);
      this.decodeApngChunk(e, t);
    }
    return this.decodeApngImage(), this._apng;
  }
  // https://www.w3.org/TR/PNG/#5Chunk-layout
  decodeChunk(e, t) {
    const A = this.offset;
    switch (t) {
      // 11.2 Critical chunks
      case "IHDR":
        this.decodeIHDR();
        break;
      case "PLTE":
        this.decodePLTE(e);
        break;
      case "IDAT":
        this.decodeIDAT(e);
        break;
      case "IEND":
        this._end = !0;
        break;
      // 11.3 Ancillary chunks
      case "tRNS":
        this.decodetRNS(e);
        break;
      case "iCCP":
        this.decodeiCCP(e);
        break;
      case yQ:
        xQ(this._png.text, this, e);
        break;
      case "pHYs":
        this.decodepHYs();
        break;
      default:
        this.skip(e);
        break;
    }
    if (this.offset - A !== e)
      throw new Error(`Length mismatch while decoding chunk ${t}`);
    this._checkCrc ? Ew(this, e + 4, t) : this.skip(4);
  }
  decodeApngChunk(e, t) {
    const A = this.offset;
    switch (t !== "fdAT" && t !== "IDAT" && this._writingDataChunks && this.pushDataToFrame(), t) {
      case "acTL":
        this.decodeACTL();
        break;
      case "fcTL":
        this.decodeFCTL();
        break;
      case "fdAT":
        this.decodeFDAT(e);
        break;
      default:
        this.decodeChunk(e, t), this.offset = A + e;
        break;
    }
    if (this.offset - A !== e)
      throw new Error(`Length mismatch while decoding chunk ${t}`);
    this._checkCrc ? Ew(this, e + 4, t) : this.skip(4);
  }
  // https://www.w3.org/TR/PNG/#11IHDR
  decodeIHDR() {
    const e = this._png;
    e.width = this.readUint32(), e.height = this.readUint32(), e.depth = _Q(this.readUint8());
    const t = this.readUint8();
    this._colorType = t;
    let A;
    switch (t) {
      case mn.GREYSCALE:
        A = 1;
        break;
      case mn.TRUECOLOUR:
        A = 3;
        break;
      case mn.INDEXED_COLOUR:
        A = 1;
        break;
      case mn.GREYSCALE_ALPHA:
        A = 2;
        break;
      case mn.TRUECOLOUR_ALPHA:
        A = 4;
        break;
      // Kept for exhaustiveness.
      // eslint-disable-next-line unicorn/no-useless-switch-case
      case mn.UNKNOWN:
      default:
        throw new Error(`Unknown color type: ${t}`);
    }
    if (this._png.channels = A, this._compressionMethod = this.readUint8(), this._compressionMethod !== Ad.DEFLATE)
      throw new Error(`Unsupported compression method: ${this._compressionMethod}`);
    this._filterMethod = this.readUint8(), this._interlaceMethod = this.readUint8();
  }
  decodeACTL() {
    this._numberOfFrames = this.readUint32(), this._numberOfPlays = this.readUint32(), this._isAnimated = !0;
  }
  decodeFCTL() {
    const e = {
      sequenceNumber: this.readUint32(),
      width: this.readUint32(),
      height: this.readUint32(),
      xOffset: this.readUint32(),
      yOffset: this.readUint32(),
      delayNumber: this.readUint16(),
      delayDenominator: this.readUint16(),
      disposeOp: this.readUint8(),
      blendOp: this.readUint8(),
      data: new Uint8Array(0)
    };
    this._frames.push(e);
  }
  // https://www.w3.org/TR/PNG/#11PLTE
  decodePLTE(e) {
    if (e % 3 !== 0)
      throw new RangeError(`PLTE field length must be a multiple of 3. Got ${e}`);
    const t = e / 3;
    this._hasPalette = !0;
    const A = [];
    this._palette = A;
    for (let n = 0; n < t; n++)
      A.push([this.readUint8(), this.readUint8(), this.readUint8()]);
  }
  // https://www.w3.org/TR/PNG/#11IDAT
  decodeIDAT(e) {
    this._writingDataChunks = !0;
    const t = e, A = this.offset + this.byteOffset;
    if (this._inflator.push(new Uint8Array(this.buffer, A, t)), this._inflator.err)
      throw new Error(`Error while decompressing the data: ${this._inflator.err}`);
    this.skip(e);
  }
  decodeFDAT(e) {
    this._writingDataChunks = !0;
    let t = e, A = this.offset + this.byteOffset;
    if (A += 4, t -= 4, this._inflator.push(new Uint8Array(this.buffer, A, t)), this._inflator.err)
      throw new Error(`Error while decompressing the data: ${this._inflator.err}`);
    this.skip(e);
  }
  // https://www.w3.org/TR/PNG/#11tRNS
  decodetRNS(e) {
    switch (this._colorType) {
      case mn.GREYSCALE:
      case mn.TRUECOLOUR: {
        if (e % 2 !== 0)
          throw new RangeError(`tRNS chunk length must be a multiple of 2. Got ${e}`);
        if (e / 2 > this._png.width * this._png.height)
          throw new Error(`tRNS chunk contains more alpha values than there are pixels (${e / 2} vs ${this._png.width * this._png.height})`);
        this._hasTransparency = !0, this._transparency = new Uint16Array(e / 2);
        for (let t = 0; t < e / 2; t++)
          this._transparency[t] = this.readUint16();
        break;
      }
      case mn.INDEXED_COLOUR: {
        if (e > this._palette.length)
          throw new Error(`tRNS chunk contains more alpha values than there are palette colors (${e} vs ${this._palette.length})`);
        let t = 0;
        for (; t < e; t++) {
          const A = this.readByte();
          this._palette[t].push(A);
        }
        for (; t < this._palette.length; t++)
          this._palette[t].push(255);
        break;
      }
      // Kept for exhaustiveness.
      /* eslint-disable unicorn/no-useless-switch-case */
      case mn.UNKNOWN:
      case mn.GREYSCALE_ALPHA:
      case mn.TRUECOLOUR_ALPHA:
      default:
        throw new Error(`tRNS chunk is not supported for color type ${this._colorType}`);
    }
  }
  // https://www.w3.org/TR/PNG/#11iCCP
  decodeiCCP(e) {
    const t = U5(this), A = this.readUint8();
    if (A !== Ad.DEFLATE)
      throw new Error(`Unsupported iCCP compression method: ${A}`);
    const n = this.readBytes(e - t.length - 2);
    this._png.iccEmbeddedProfile = {
      name: t,
      profile: nQ(n)
    };
  }
  // https://www.w3.org/TR/PNG/#11pHYs
  decodepHYs() {
    const e = this.readUint32(), t = this.readUint32(), A = this.readByte();
    this._png.resolution = { x: e, y: t, unit: A };
  }
  decodeApngImage() {
    this._apng.width = this._png.width, this._apng.height = this._png.height, this._apng.channels = this._png.channels, this._apng.depth = this._png.depth, this._apng.numberOfFrames = this._numberOfFrames, this._apng.numberOfPlays = this._numberOfPlays, this._apng.text = this._png.text, this._apng.resolution = this._png.resolution;
    for (let e = 0; e < this._numberOfFrames; e++) {
      const t = {
        sequenceNumber: this._frames[e].sequenceNumber,
        delayNumber: this._frames[e].delayNumber,
        delayDenominator: this._frames[e].delayDenominator,
        data: this._apng.depth === 8 ? new Uint8Array(this._apng.width * this._apng.height * this._apng.channels) : new Uint16Array(this._apng.width * this._apng.height * this._apng.channels)
      }, A = this._frames.at(e);
      if (A) {
        if (A.data = Fw({
          data: A.data,
          width: A.width,
          height: A.height,
          channels: this._apng.channels,
          depth: this._apng.depth
        }), this._hasPalette && (this._apng.palette = this._palette), this._hasTransparency && (this._apng.transparency = this._transparency), e === 0 || A.xOffset === 0 && A.yOffset === 0 && A.width === this._png.width && A.height === this._png.height)
          t.data = A.data;
        else {
          const n = this._apng.frames.at(e - 1);
          this.disposeFrame(A, n, t), this.addFrameDataToCanvas(t, A);
        }
        this._apng.frames.push(t);
      }
    }
    return this._apng;
  }
  disposeFrame(e, t, A) {
    switch (e.disposeOp) {
      case fc.NONE:
        break;
      case fc.BACKGROUND:
        for (let n = 0; n < this._png.height; n++)
          for (let i = 0; i < this._png.width; i++) {
            const s = (n * e.width + i) * this._png.channels;
            for (let a = 0; a < this._png.channels; a++)
              A.data[s + a] = 0;
          }
        break;
      case fc.PREVIOUS:
        A.data.set(t.data);
        break;
      default:
        throw new Error("Unknown disposeOp");
    }
  }
  addFrameDataToCanvas(e, t) {
    const A = 1 << this._png.depth, n = (i, s) => {
      const a = ((i + t.yOffset) * this._png.width + t.xOffset + s) * this._png.channels, o = (i * t.width + s) * this._png.channels;
      return { index: a, frameIndex: o };
    };
    switch (t.blendOp) {
      case id.SOURCE:
        for (let i = 0; i < t.height; i++)
          for (let s = 0; s < t.width; s++) {
            const { index: a, frameIndex: o } = n(i, s);
            for (let l = 0; l < this._png.channels; l++)
              e.data[a + l] = t.data[o + l];
          }
        break;
      // https://www.w3.org/TR/png-3/#13Alpha-channel-processing
      case id.OVER:
        for (let i = 0; i < t.height; i++)
          for (let s = 0; s < t.width; s++) {
            const { index: a, frameIndex: o } = n(i, s);
            for (let l = 0; l < this._png.channels; l++) {
              const u = t.data[o + this._png.channels - 1] / A, h = l % (this._png.channels - 1) === 0 ? 1 : t.data[o + l], f = Math.floor(u * h + (1 - u) * e.data[a + l]);
              e.data[a + l] += f;
            }
          }
        break;
      default:
        throw new Error("Unknown blendOp");
    }
  }
  decodeImage() {
    if (this._inflator.err)
      throw new Error(`Error while decompressing the data: ${this._inflator.err}`);
    const e = this._isAnimated ? (this._frames?.at(0)).data : this._inflator.result;
    if (this._filterMethod !== Uw.ADAPTIVE)
      throw new Error(`Filter method ${this._filterMethod} not supported`);
    if (this._interlaceMethod === nd.NO_INTERLACE)
      this._png.data = Fw({
        data: e,
        width: this._png.width,
        height: this._png.height,
        channels: this._png.channels,
        depth: this._png.depth
      });
    else if (this._interlaceMethod === nd.ADAM7)
      this._png.data = hQ({
        data: e,
        width: this._png.width,
        height: this._png.height,
        channels: this._png.channels,
        depth: this._png.depth
      });
    else
      throw new Error(`Interlace method ${this._interlaceMethod} not supported`);
    this._hasPalette && (this._png.palette = this._palette), this._hasTransparency && (this._png.transparency = this._transparency);
  }
  pushDataToFrame() {
    const e = this._inflator.result, t = this._frames.at(-1);
    t ? t.data = e : this._frames.push({
      sequenceNumber: 0,
      width: this._png.width,
      height: this._png.height,
      xOffset: 0,
      yOffset: 0,
      delayNumber: 0,
      delayDenominator: 0,
      disposeOp: fc.NONE,
      blendOp: id.SOURCE,
      data: e
    }), this._inflator = new Sw(), this._writingDataChunks = !1;
  }
}
function _Q(r) {
  if (r !== 1 && r !== 2 && r !== 4 && r !== 8 && r !== 16)
    throw new Error(`invalid bit depth: ${r}`);
  return r;
}
var Iw;
(function(r) {
  r[r.UNKNOWN = 0] = "UNKNOWN", r[r.METRE = 1] = "METRE";
})(Iw || (Iw = {}));
function UQ(r, e) {
  return new FQ(r, e).decode();
}
var Ct = /* @__PURE__ */ (function() {
  return typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : this;
})();
function sd() {
  Ct.console && typeof Ct.console.log == "function" && Ct.console.log.apply(Ct.console, arguments);
}
var or = { log: sd, warn: function(r) {
  Ct.console && (typeof Ct.console.warn == "function" ? Ct.console.warn.apply(Ct.console, arguments) : sd.call(null, arguments));
}, error: function(r) {
  Ct.console && (typeof Ct.console.error == "function" ? Ct.console.error.apply(Ct.console, arguments) : sd(r));
} };
function ad(r, e, t) {
  var A = new XMLHttpRequest();
  A.open("GET", r), A.responseType = "blob", A.onload = function() {
    ga(A.response, e, t);
  }, A.onerror = function() {
    or.error("could not download file");
  }, A.send();
}
function Qw(r) {
  var e = new XMLHttpRequest();
  e.open("HEAD", r, !1);
  try {
    e.send();
  } catch {
  }
  return e.status >= 200 && e.status <= 299;
}
function dc(r) {
  try {
    r.dispatchEvent(new MouseEvent("click"));
  } catch {
    var e = document.createEvent("MouseEvents");
    e.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), r.dispatchEvent(e);
  }
}
var ga = Ct.saveAs || ((typeof window > "u" ? "undefined" : jt(window)) !== "object" || window !== Ct ? function() {
} : typeof HTMLAnchorElement < "u" && "download" in HTMLAnchorElement.prototype ? function(r, e, t) {
  var A = Ct.URL || Ct.webkitURL, n = document.createElement("a");
  e = e || r.name || "download", n.download = e, n.rel = "noopener", typeof r == "string" ? (n.href = r, n.origin !== location.origin ? Qw(n.href) ? ad(r, e, t) : dc(n, n.target = "_blank") : dc(n)) : (n.href = A.createObjectURL(r), setTimeout(function() {
    A.revokeObjectURL(n.href);
  }, 4e4), setTimeout(function() {
    dc(n);
  }, 0));
} : "msSaveOrOpenBlob" in navigator ? function(r, e, t) {
  if (e = e || r.name || "download", typeof r == "string") if (Qw(r)) ad(r, e, t);
  else {
    var A = document.createElement("a");
    A.href = r, A.target = "_blank", setTimeout(function() {
      dc(A);
    });
  }
  else navigator.msSaveOrOpenBlob((function(n, i) {
    return i === void 0 ? i = { autoBom: !1 } : jt(i) !== "object" && (or.warn("Deprecated: Expected third argument to be a object"), i = { autoBom: !i }), i.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(n.type) ? new Blob(["\uFEFF", n], { type: n.type }) : n;
  })(r, t), e);
} : function(r, e, t, A) {
  if ((A = A || open("", "_blank")) && (A.document.title = A.document.body.innerText = "downloading..."), typeof r == "string") return ad(r, e, t);
  var n = r.type === "application/octet-stream", i = /constructor/i.test(Ct.HTMLElement) || Ct.safari, s = /CriOS\/[\d]+/.test(navigator.userAgent);
  if ((s || n && i) && (typeof FileReader > "u" ? "undefined" : jt(FileReader)) === "object") {
    var a = new FileReader();
    a.onloadend = function() {
      var u = a.result;
      u = s ? u : u.replace(/^data:[^;]*;/, "data:attachment/file;"), A ? A.location.href = u : location = u, A = null;
    }, a.readAsDataURL(r);
  } else {
    var o = Ct.URL || Ct.webkitURL, l = o.createObjectURL(r);
    A ? A.location = l : location.href = l, A = null, setTimeout(function() {
      o.revokeObjectURL(l);
    }, 4e4);
  }
});
function I5(r) {
  var e;
  r = r || "", this.ok = !1, r.charAt(0) == "#" && (r = r.substr(1, 6)), r = { aliceblue: "f0f8ff", antiquewhite: "faebd7", aqua: "00ffff", aquamarine: "7fffd4", azure: "f0ffff", beige: "f5f5dc", bisque: "ffe4c4", black: "000000", blanchedalmond: "ffebcd", blue: "0000ff", blueviolet: "8a2be2", brown: "a52a2a", burlywood: "deb887", cadetblue: "5f9ea0", chartreuse: "7fff00", chocolate: "d2691e", coral: "ff7f50", cornflowerblue: "6495ed", cornsilk: "fff8dc", crimson: "dc143c", cyan: "00ffff", darkblue: "00008b", darkcyan: "008b8b", darkgoldenrod: "b8860b", darkgray: "a9a9a9", darkgreen: "006400", darkkhaki: "bdb76b", darkmagenta: "8b008b", darkolivegreen: "556b2f", darkorange: "ff8c00", darkorchid: "9932cc", darkred: "8b0000", darksalmon: "e9967a", darkseagreen: "8fbc8f", darkslateblue: "483d8b", darkslategray: "2f4f4f", darkturquoise: "00ced1", darkviolet: "9400d3", deeppink: "ff1493", deepskyblue: "00bfff", dimgray: "696969", dodgerblue: "1e90ff", feldspar: "d19275", firebrick: "b22222", floralwhite: "fffaf0", forestgreen: "228b22", fuchsia: "ff00ff", gainsboro: "dcdcdc", ghostwhite: "f8f8ff", gold: "ffd700", goldenrod: "daa520", gray: "808080", green: "008000", greenyellow: "adff2f", honeydew: "f0fff0", hotpink: "ff69b4", indianred: "cd5c5c", indigo: "4b0082", ivory: "fffff0", khaki: "f0e68c", lavender: "e6e6fa", lavenderblush: "fff0f5", lawngreen: "7cfc00", lemonchiffon: "fffacd", lightblue: "add8e6", lightcoral: "f08080", lightcyan: "e0ffff", lightgoldenrodyellow: "fafad2", lightgrey: "d3d3d3", lightgreen: "90ee90", lightpink: "ffb6c1", lightsalmon: "ffa07a", lightseagreen: "20b2aa", lightskyblue: "87cefa", lightslateblue: "8470ff", lightslategray: "778899", lightsteelblue: "b0c4de", lightyellow: "ffffe0", lime: "00ff00", limegreen: "32cd32", linen: "faf0e6", magenta: "ff00ff", maroon: "800000", mediumaquamarine: "66cdaa", mediumblue: "0000cd", mediumorchid: "ba55d3", mediumpurple: "9370d8", mediumseagreen: "3cb371", mediumslateblue: "7b68ee", mediumspringgreen: "00fa9a", mediumturquoise: "48d1cc", mediumvioletred: "c71585", midnightblue: "191970", mintcream: "f5fffa", mistyrose: "ffe4e1", moccasin: "ffe4b5", navajowhite: "ffdead", navy: "000080", oldlace: "fdf5e6", olive: "808000", olivedrab: "6b8e23", orange: "ffa500", orangered: "ff4500", orchid: "da70d6", palegoldenrod: "eee8aa", palegreen: "98fb98", paleturquoise: "afeeee", palevioletred: "d87093", papayawhip: "ffefd5", peachpuff: "ffdab9", peru: "cd853f", pink: "ffc0cb", plum: "dda0dd", powderblue: "b0e0e6", purple: "800080", red: "ff0000", rosybrown: "bc8f8f", royalblue: "4169e1", saddlebrown: "8b4513", salmon: "fa8072", sandybrown: "f4a460", seagreen: "2e8b57", seashell: "fff5ee", sienna: "a0522d", silver: "c0c0c0", skyblue: "87ceeb", slateblue: "6a5acd", slategray: "708090", snow: "fffafa", springgreen: "00ff7f", steelblue: "4682b4", tan: "d2b48c", teal: "008080", thistle: "d8bfd8", tomato: "ff6347", turquoise: "40e0d0", violet: "ee82ee", violetred: "d02090", wheat: "f5deb3", white: "ffffff", whitesmoke: "f5f5f5", yellow: "ffff00", yellowgreen: "9acd32" }[r = (r = r.replace(/ /g, "")).toLowerCase()] || r;
  for (var t = [{ re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/, example: ["rgb(123, 234, 45)", "rgb(255,234,245)"], process: function(a) {
    return [parseInt(a[1]), parseInt(a[2]), parseInt(a[3])];
  } }, { re: /^(\w{2})(\w{2})(\w{2})$/, example: ["#00ff00", "336699"], process: function(a) {
    return [parseInt(a[1], 16), parseInt(a[2], 16), parseInt(a[3], 16)];
  } }, { re: /^(\w{1})(\w{1})(\w{1})$/, example: ["#fb0", "f0f"], process: function(a) {
    return [parseInt(a[1] + a[1], 16), parseInt(a[2] + a[2], 16), parseInt(a[3] + a[3], 16)];
  } }], A = 0; A < t.length; A++) {
    var n = t[A].re, i = t[A].process, s = n.exec(r);
    s && (e = i(s), this.r = e[0], this.g = e[1], this.b = e[2], this.ok = !0);
  }
  this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b, this.toRGB = function() {
    return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
  }, this.toHex = function() {
    var a = this.r.toString(16), o = this.g.toString(16), l = this.b.toString(16);
    return a.length == 1 && (a = "0" + a), o.length == 1 && (o = "0" + o), l.length == 1 && (l = "0" + l), "#" + a + o + l;
  };
}
var Zc = Ct.atob.bind(Ct), Lw = Ct.btoa.bind(Ct);
function od(r, e) {
  var t = r[0], A = r[1], n = r[2], i = r[3];
  t = IA(t, A, n, i, e[0], 7, -680876936), i = IA(i, t, A, n, e[1], 12, -389564586), n = IA(n, i, t, A, e[2], 17, 606105819), A = IA(A, n, i, t, e[3], 22, -1044525330), t = IA(t, A, n, i, e[4], 7, -176418897), i = IA(i, t, A, n, e[5], 12, 1200080426), n = IA(n, i, t, A, e[6], 17, -1473231341), A = IA(A, n, i, t, e[7], 22, -45705983), t = IA(t, A, n, i, e[8], 7, 1770035416), i = IA(i, t, A, n, e[9], 12, -1958414417), n = IA(n, i, t, A, e[10], 17, -42063), A = IA(A, n, i, t, e[11], 22, -1990404162), t = IA(t, A, n, i, e[12], 7, 1804603682), i = IA(i, t, A, n, e[13], 12, -40341101), n = IA(n, i, t, A, e[14], 17, -1502002290), t = QA(t, A = IA(A, n, i, t, e[15], 22, 1236535329), n, i, e[1], 5, -165796510), i = QA(i, t, A, n, e[6], 9, -1069501632), n = QA(n, i, t, A, e[11], 14, 643717713), A = QA(A, n, i, t, e[0], 20, -373897302), t = QA(t, A, n, i, e[5], 5, -701558691), i = QA(i, t, A, n, e[10], 9, 38016083), n = QA(n, i, t, A, e[15], 14, -660478335), A = QA(A, n, i, t, e[4], 20, -405537848), t = QA(t, A, n, i, e[9], 5, 568446438), i = QA(i, t, A, n, e[14], 9, -1019803690), n = QA(n, i, t, A, e[3], 14, -187363961), A = QA(A, n, i, t, e[8], 20, 1163531501), t = QA(t, A, n, i, e[13], 5, -1444681467), i = QA(i, t, A, n, e[2], 9, -51403784), n = QA(n, i, t, A, e[7], 14, 1735328473), t = LA(t, A = QA(A, n, i, t, e[12], 20, -1926607734), n, i, e[5], 4, -378558), i = LA(i, t, A, n, e[8], 11, -2022574463), n = LA(n, i, t, A, e[11], 16, 1839030562), A = LA(A, n, i, t, e[14], 23, -35309556), t = LA(t, A, n, i, e[1], 4, -1530992060), i = LA(i, t, A, n, e[4], 11, 1272893353), n = LA(n, i, t, A, e[7], 16, -155497632), A = LA(A, n, i, t, e[10], 23, -1094730640), t = LA(t, A, n, i, e[13], 4, 681279174), i = LA(i, t, A, n, e[0], 11, -358537222), n = LA(n, i, t, A, e[3], 16, -722521979), A = LA(A, n, i, t, e[6], 23, 76029189), t = LA(t, A, n, i, e[9], 4, -640364487), i = LA(i, t, A, n, e[12], 11, -421815835), n = LA(n, i, t, A, e[15], 16, 530742520), t = NA(t, A = LA(A, n, i, t, e[2], 23, -995338651), n, i, e[0], 6, -198630844), i = NA(i, t, A, n, e[7], 10, 1126891415), n = NA(n, i, t, A, e[14], 15, -1416354905), A = NA(A, n, i, t, e[5], 21, -57434055), t = NA(t, A, n, i, e[12], 6, 1700485571), i = NA(i, t, A, n, e[3], 10, -1894986606), n = NA(n, i, t, A, e[10], 15, -1051523), A = NA(A, n, i, t, e[1], 21, -2054922799), t = NA(t, A, n, i, e[8], 6, 1873313359), i = NA(i, t, A, n, e[15], 10, -30611744), n = NA(n, i, t, A, e[6], 15, -1560198380), A = NA(A, n, i, t, e[13], 21, 1309151649), t = NA(t, A, n, i, e[4], 6, -145523070), i = NA(i, t, A, n, e[11], 10, -1120210379), n = NA(n, i, t, A, e[2], 15, 718787259), A = NA(A, n, i, t, e[9], 21, -343485551), r[0] = Ns(t, r[0]), r[1] = Ns(A, r[1]), r[2] = Ns(n, r[2]), r[3] = Ns(i, r[3]);
}
function Nh(r, e, t, A, n, i) {
  return e = Ns(Ns(e, r), Ns(A, i)), Ns(e << n | e >>> 32 - n, t);
}
function IA(r, e, t, A, n, i, s) {
  return Nh(e & t | ~e & A, r, e, n, i, s);
}
function QA(r, e, t, A, n, i, s) {
  return Nh(e & A | t & ~A, r, e, n, i, s);
}
function LA(r, e, t, A, n, i, s) {
  return Nh(e ^ t ^ A, r, e, n, i, s);
}
function NA(r, e, t, A, n, i, s) {
  return Nh(t ^ (e | ~A), r, e, n, i, s);
}
function Q5(r) {
  var e, t = r.length, A = [1732584193, -271733879, -1732584194, 271733878];
  for (e = 64; e <= r.length; e += 64) od(A, IQ(r.substring(e - 64, e)));
  r = r.substring(e - 64);
  var n = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  for (e = 0; e < r.length; e++) n[e >> 2] |= r.charCodeAt(e) << (e % 4 << 3);
  if (n[e >> 2] |= 128 << (e % 4 << 3), e > 55) for (od(A, n), e = 0; e < 16; e++) n[e] = 0;
  return n[14] = 8 * t, od(A, n), A;
}
function IQ(r) {
  var e, t = [];
  for (e = 0; e < 64; e += 4) t[e >> 2] = r.charCodeAt(e) + (r.charCodeAt(e + 1) << 8) + (r.charCodeAt(e + 2) << 16) + (r.charCodeAt(e + 3) << 24);
  return t;
}
var Nw = "0123456789abcdef".split("");
function QQ(r) {
  for (var e = "", t = 0; t < 4; t++) e += Nw[r >> 8 * t + 4 & 15] + Nw[r >> 8 * t & 15];
  return e;
}
function LQ(r) {
  return String.fromCharCode(255 & r, (65280 & r) >> 8, (16711680 & r) >> 16, (4278190080 & r) >> 24);
}
function J0(r) {
  return Q5(r).map(LQ).join("");
}
var NQ = (function(r) {
  for (var e = 0; e < r.length; e++) r[e] = QQ(r[e]);
  return r.join("");
})(Q5("hello")) != "5d41402abc4b2a76b9719d911017c592";
function Ns(r, e) {
  if (NQ) {
    var t = (65535 & r) + (65535 & e);
    return (r >> 16) + (e >> 16) + (t >> 16) << 16 | 65535 & t;
  }
  return r + e & 4294967295;
}
function $0(r, e) {
  var t, A, n, i;
  if (r !== t) {
    for (var s = (n = r, i = 1 + (256 / r.length | 0), new Array(i + 1).join(n)), a = [], o = 0; o < 256; o++) a[o] = o;
    var l = 0;
    for (o = 0; o < 256; o++) {
      var u = a[o];
      l = (l + u + s.charCodeAt(o)) % 256, a[o] = a[l], a[l] = u;
    }
    t = r, A = a;
  } else a = A;
  var h = e.length, f = 0, c = 0, p = "";
  for (o = 0; o < h; o++) c = (c + (u = a[f = (f + 1) % 256])) % 256, a[f] = a[c], a[c] = u, s = a[(a[f] + a[c]) % 256], p += String.fromCharCode(e.charCodeAt(o) ^ s);
  return p;
}
var Tw = { print: 4, modify: 8, copy: 16, "annot-forms": 32 };
function co(r, e, t, A) {
  this.v = 1, this.r = 2;
  var n = 192;
  r.forEach(function(a) {
    if (Tw.perm !== void 0) throw new Error("Invalid permission: " + a);
    n += Tw[a];
  }), this.padding = "(¿N^NuAd\0NVÿú\b..\0¶Ðh>/\f©þdSiz";
  var i = (e + this.padding).substr(0, 32), s = (t + this.padding).substr(0, 32);
  this.O = this.processOwnerPassword(i, s), this.P = -(1 + (255 ^ n)), this.encryptionKey = J0(i + this.O + this.lsbFirstWord(this.P) + this.hexToBytes(A)).substr(0, 5), this.U = $0(this.encryptionKey, this.padding);
}
function ho(r) {
  if (/[^\u0000-\u00ff]/.test(r)) throw new Error("Invalid PDF Name Object: " + r + ", Only accept ASCII characters.");
  for (var e = "", t = r.length, A = 0; A < t; A++) {
    var n = r.charCodeAt(A);
    e += n < 33 || n === 35 || n === 37 || n === 40 || n === 41 || n === 47 || n === 60 || n === 62 || n === 91 || n === 93 || n === 123 || n === 125 || n > 126 ? "#" + ("0" + n.toString(16)).slice(-2) : r[A];
  }
  return e;
}
function Pw(r) {
  if (jt(r) !== "object") throw new Error("Invalid Context passed to initialize PubSub (jsPDF-module)");
  var e = {};
  this.subscribe = function(t, A, n) {
    if (n = n || !1, typeof t != "string" || typeof A != "function" || typeof n != "boolean") throw new Error("Invalid arguments passed to PubSub.subscribe (jsPDF-module)");
    e.hasOwnProperty(t) || (e[t] = {});
    var i = Math.random().toString(35);
    return e[t][i] = [A, !!n], i;
  }, this.unsubscribe = function(t) {
    for (var A in e) if (e[A][t]) return delete e[A][t], Object.keys(e[A]).length === 0 && delete e[A], !0;
    return !1;
  }, this.publish = function(t) {
    if (e.hasOwnProperty(t)) {
      var A = Array.prototype.slice.call(arguments, 1), n = [];
      for (var i in e[t]) {
        var s = e[t][i];
        try {
          s[0].apply(r, A);
        } catch (a) {
          Ct.console && or.error("jsPDF PubSub Error", a.message, a);
        }
        s[1] && n.push(i);
      }
      n.length && n.forEach(this.unsubscribe);
    }
  }, this.getTopics = function() {
    return e;
  };
}
function Ta(r) {
  if (!(this instanceof Ta)) return new Ta(r);
  var e = "opacity,stroke-opacity".split(",");
  for (var t in r) r.hasOwnProperty(t) && e.indexOf(t) >= 0 && (this[t] = r[t]);
  this.id = "", this.objectNumber = -1;
}
function L5(r, e) {
  this.gState = r, this.matrix = e, this.id = "", this.objectNumber = -1;
}
function Qs(r, e, t, A, n) {
  if (!(this instanceof Qs)) return new Qs(r, e, t, A, n);
  this.type = r === "axial" ? 2 : 3, this.coords = e, this.colors = t, L5.call(this, A, n);
}
function Ba(r, e, t, A, n) {
  if (!(this instanceof Ba)) return new Ba(r, e, t, A, n);
  this.boundingBox = r, this.xStep = e, this.yStep = t, this.stream = "", this.cloneIndex = 0, L5.call(this, A, n);
}
function ot(r) {
  var e, t = typeof arguments[0] == "string" ? arguments[0] : "p", A = arguments[1], n = arguments[2], i = arguments[3], s = [], a = 1, o = 16, l = "S", u = null;
  jt(r = r || {}) === "object" && (t = r.orientation, A = r.unit || A, n = r.format || n, i = r.compress || r.compressPdf || i, (u = r.encryption || null) !== null && (u.userPassword = u.userPassword || "", u.ownerPassword = u.ownerPassword || "", u.userPermissions = u.userPermissions || []), a = typeof r.userUnit == "number" ? Math.abs(r.userUnit) : 1, r.precision !== void 0 && (e = r.precision), r.floatPrecision !== void 0 && (o = r.floatPrecision), l = r.defaultPathOperation || "S"), s = r.filters || (i === !0 ? ["FlateEncode"] : s), A = A || "mm", t = ("" + (t || "P")).toLowerCase();
  var h = r.putOnlyUsedFonts || !1, f = {}, c = { internal: {}, __private__: {} };
  c.__private__.PubSub = Pw;
  var p = "1.3", g = c.__private__.getPdfVersion = function() {
    return p;
  };
  c.__private__.setPdfVersion = function(y) {
    p = y;
  };
  var v = { a0: [2383.94, 3370.39], a1: [1683.78, 2383.94], a2: [1190.55, 1683.78], a3: [841.89, 1190.55], a4: [595.28, 841.89], a5: [419.53, 595.28], a6: [297.64, 419.53], a7: [209.76, 297.64], a8: [147.4, 209.76], a9: [104.88, 147.4], a10: [73.7, 104.88], b0: [2834.65, 4008.19], b1: [2004.09, 2834.65], b2: [1417.32, 2004.09], b3: [1000.63, 1417.32], b4: [708.66, 1000.63], b5: [498.9, 708.66], b6: [354.33, 498.9], b7: [249.45, 354.33], b8: [175.75, 249.45], b9: [124.72, 175.75], b10: [87.87, 124.72], c0: [2599.37, 3676.54], c1: [1836.85, 2599.37], c2: [1298.27, 1836.85], c3: [918.43, 1298.27], c4: [649.13, 918.43], c5: [459.21, 649.13], c6: [323.15, 459.21], c7: [229.61, 323.15], c8: [161.57, 229.61], c9: [113.39, 161.57], c10: [79.37, 113.39], dl: [311.81, 623.62], letter: [612, 792], "government-letter": [576, 756], legal: [612, 1008], "junior-legal": [576, 360], ledger: [1224, 792], tabloid: [792, 1224], "credit-card": [153, 243] };
  c.__private__.getPageFormats = function() {
    return v;
  };
  var w = c.__private__.getPageFormat = function(y) {
    return v[y];
  };
  n = n || "a4";
  var B = "compat", S = "advanced", C = B;
  function E() {
    this.saveGraphicsState(), j(new vt(dt, 0, 0, -dt, 0, ea() * dt).toString() + " cm"), this.setFontSize(this.getFontSize() / dt), l = "n", C = S;
  }
  function _() {
    this.restoreGraphicsState(), l = "S", C = B;
  }
  var I = c.__private__.combineFontStyleAndFontWeight = function(y, Q) {
    if (y == "bold" && Q == "normal" || y == "bold" && Q == 400 || y == "normal" && Q == "italic" || y == "bold" && Q == "italic") throw new Error("Invalid Combination of fontweight and fontstyle");
    return Q && (y = Q == 400 || Q === "normal" ? y === "italic" ? "italic" : "normal" : Q != 700 && Q !== "bold" || y !== "normal" ? (Q == 700 ? "bold" : Q) + "" + y : "bold"), y;
  };
  c.advancedAPI = function(y) {
    var Q = C === B;
    return Q && E.call(this), typeof y != "function" || (y(this), Q && _.call(this)), this;
  }, c.compatAPI = function(y) {
    var Q = C === S;
    return Q && _.call(this), typeof y != "function" || (y(this), Q && E.call(this)), this;
  }, c.isAdvancedAPI = function() {
    return C === S;
  };
  var O, U = function(y) {
    if (C !== S) throw new Error(y + " is only available in 'advanced' API mode. You need to call advancedAPI() first.");
  }, V = c.roundToPrecision = c.__private__.roundToPrecision = function(y, Q) {
    var W = e || Q;
    if (isNaN(y) || isNaN(W)) throw new Error("Invalid argument passed to jsPDF.roundToPrecision");
    return y.toFixed(W).replace(/0+$/, "");
  };
  O = c.hpf = c.__private__.hpf = typeof o == "number" ? function(y) {
    if (isNaN(y)) throw new Error("Invalid argument passed to jsPDF.hpf");
    return V(y, o);
  } : o === "smart" ? function(y) {
    if (isNaN(y)) throw new Error("Invalid argument passed to jsPDF.hpf");
    return V(y, y > -1 && y < 1 ? 16 : 5);
  } : function(y) {
    if (isNaN(y)) throw new Error("Invalid argument passed to jsPDF.hpf");
    return V(y, 16);
  };
  var F = c.f2 = c.__private__.f2 = function(y) {
    if (isNaN(y)) throw new Error("Invalid argument passed to jsPDF.f2");
    return V(y, 2);
  }, P = c.__private__.f3 = function(y) {
    if (isNaN(y)) throw new Error("Invalid argument passed to jsPDF.f3");
    return V(y, 3);
  }, D = c.scale = c.__private__.scale = function(y) {
    if (isNaN(y)) throw new Error("Invalid argument passed to jsPDF.scale");
    return C === B ? y * dt : C === S ? y : void 0;
  }, R = function(y) {
    return D((function(Q) {
      return C === B ? ea() - Q : C === S ? Q : void 0;
    })(y));
  };
  c.__private__.setPrecision = c.setPrecision = function(y) {
    typeof parseInt(y, 10) == "number" && (e = parseInt(y, 10));
  };
  var J, ie = "00000000000000000000000000000000", te = c.__private__.getFileId = function() {
    return ie;
  }, $ = c.__private__.setFileId = function(y) {
    return ie = y !== void 0 && /^[a-fA-F0-9]{32}$/.test(y) ? y.toUpperCase() : ie.split("").map(function() {
      return "ABCDEF0123456789".charAt(Math.floor(16 * Math.random()));
    }).join(""), u !== null && (sA = new co(u.userPermissions, u.userPassword, u.ownerPassword, ie)), ie;
  };
  c.setFileId = function(y) {
    return $(y), this;
  }, c.getFileId = function() {
    return te();
  };
  var re = c.__private__.convertDateToPDFDate = function(y) {
    var Q = y.getTimezoneOffset(), W = Q < 0 ? "+" : "-", Z = Math.floor(Math.abs(Q / 60)), ce = Math.abs(Q % 60), Be = [W, X(Z), "'", X(ce), "'"].join("");
    return ["D:", y.getFullYear(), X(y.getMonth() + 1), X(y.getDate()), X(y.getHours()), X(y.getMinutes()), X(y.getSeconds()), Be].join("");
  }, ue = c.__private__.convertPDFDateToDate = function(y) {
    var Q = parseInt(y.substr(2, 4), 10), W = parseInt(y.substr(6, 2), 10) - 1, Z = parseInt(y.substr(8, 2), 10), ce = parseInt(y.substr(10, 2), 10), Be = parseInt(y.substr(12, 2), 10), Fe = parseInt(y.substr(14, 2), 10);
    return new Date(Q, W, Z, ce, Be, Fe, 0);
  }, se = c.__private__.setCreationDate = function(y) {
    var Q;
    if (y === void 0 && (y = /* @__PURE__ */ new Date()), y instanceof Date) Q = re(y);
    else {
      if (!/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|-0[0-9]|-1[0-1])'(0[0-9]|[1-5][0-9])'?$/.test(y)) throw new Error("Invalid argument passed to jsPDF.setCreationDate");
      Q = y;
    }
    return J = Q;
  }, T = c.__private__.getCreationDate = function(y) {
    var Q = J;
    return y === "jsDate" && (Q = ue(J)), Q;
  };
  c.setCreationDate = function(y) {
    return se(y), this;
  }, c.getCreationDate = function(y) {
    return T(y);
  };
  var G, X = c.__private__.padd2 = function(y) {
    return ("0" + parseInt(y)).slice(-2);
  }, Y = c.__private__.padd2Hex = function(y) {
    return ("00" + (y = y.toString())).substr(y.length);
  }, ee = 0, oe = [], ge = [], pe = 0, me = [], Ee = [], Ne = !1, Te = ge;
  c.__private__.setCustomOutputDestination = function(y) {
    Ne = !0, Te = y;
  };
  var Ge = function(y) {
    Ne || (Te = y);
  };
  c.__private__.resetCustomOutputDestination = function() {
    Ne = !1, Te = ge;
  };
  var j = c.__private__.out = function(y) {
    return y = y.toString(), pe += y.length + 1, Te.push(y), Te;
  }, Pe = c.__private__.write = function(y) {
    return j(arguments.length === 1 ? y.toString() : Array.prototype.join.call(arguments, " "));
  }, ft = c.__private__.getArrayBuffer = function(y) {
    for (var Q = y.length, W = new ArrayBuffer(Q), Z = new Uint8Array(W); Q--; ) Z[Q] = y.charCodeAt(Q);
    return W;
  }, et = [["Helvetica", "helvetica", "normal", "WinAnsiEncoding"], ["Helvetica-Bold", "helvetica", "bold", "WinAnsiEncoding"], ["Helvetica-Oblique", "helvetica", "italic", "WinAnsiEncoding"], ["Helvetica-BoldOblique", "helvetica", "bolditalic", "WinAnsiEncoding"], ["Courier", "courier", "normal", "WinAnsiEncoding"], ["Courier-Bold", "courier", "bold", "WinAnsiEncoding"], ["Courier-Oblique", "courier", "italic", "WinAnsiEncoding"], ["Courier-BoldOblique", "courier", "bolditalic", "WinAnsiEncoding"], ["Times-Roman", "times", "normal", "WinAnsiEncoding"], ["Times-Bold", "times", "bold", "WinAnsiEncoding"], ["Times-Italic", "times", "italic", "WinAnsiEncoding"], ["Times-BoldItalic", "times", "bolditalic", "WinAnsiEncoding"], ["ZapfDingbats", "zapfdingbats", "normal", null], ["Symbol", "symbol", "normal", null]];
  c.__private__.getStandardFonts = function() {
    return et;
  };
  var xe = r.fontSize || 16;
  c.__private__.setFontSize = c.setFontSize = function(y) {
    return xe = C === S ? y / dt : y, this;
  };
  var rt, ke = c.__private__.getFontSize = c.getFontSize = function() {
    return C === B ? xe : xe * dt;
  }, We = r.R2L || !1;
  c.__private__.setR2L = c.setR2L = function(y) {
    return We = y, this;
  }, c.__private__.getR2L = c.getR2L = function() {
    return We;
  };
  var ze, Ce = c.__private__.setZoomMode = function(y) {
    if (/^(?:\d+\.\d*|\d*\.\d+|\d+)%$/.test(y)) rt = y;
    else if (isNaN(y)) {
      if ([void 0, null, "fullwidth", "fullheight", "fullpage", "original"].indexOf(y) === -1) throw new Error('zoom must be Integer (e.g. 2), a percentage Value (e.g. 300%) or fullwidth, fullheight, fullpage, original. "' + y + '" is not recognized.');
      rt = y;
    } else rt = parseInt(y, 10);
  };
  c.__private__.getZoomMode = function() {
    return rt;
  };
  var Oe, Re = c.__private__.setPageMode = function(y) {
    if ([void 0, null, "UseNone", "UseOutlines", "UseThumbs", "FullScreen"].indexOf(y) == -1) throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "' + y + '" is not recognized.');
    ze = y;
  };
  c.__private__.getPageMode = function() {
    return ze;
  };
  var Ke = c.__private__.setLayoutMode = function(y) {
    if ([void 0, null, "continuous", "single", "twoleft", "tworight", "two"].indexOf(y) == -1) throw new Error('Layout mode must be one of continuous, single, twoleft, tworight. "' + y + '" is not recognized.');
    Oe = y;
  };
  c.__private__.getLayoutMode = function() {
    return Oe;
  }, c.__private__.setDisplayMode = c.setDisplayMode = function(y, Q, W) {
    return Ce(y), Ke(Q), Re(W), this;
  };
  var Xe = { title: "", subject: "", author: "", keywords: "", creator: "" };
  c.__private__.getDocumentProperty = function(y) {
    if (Object.keys(Xe).indexOf(y) === -1) throw new Error("Invalid argument passed to jsPDF.getDocumentProperty");
    return Xe[y];
  }, c.__private__.getDocumentProperties = function() {
    return Xe;
  }, c.__private__.setDocumentProperties = c.setProperties = c.setDocumentProperties = function(y) {
    for (var Q in Xe) Xe.hasOwnProperty(Q) && y[Q] && (Xe[Q] = y[Q]);
    return this;
  }, c.__private__.setDocumentProperty = function(y, Q) {
    if (Object.keys(Xe).indexOf(y) === -1) throw new Error("Invalid arguments passed to jsPDF.setDocumentProperty");
    return Xe[y] = Q;
  };
  var Ve, dt, je, Tt, Et, mt = {}, yt = {}, Gt = [], it = {}, Vt = {}, lt = {}, wt = {}, Yt = null, ut = 0, Bt = [], Kt = new Pw(c), cr = r.hotfixes || [], Sr = {}, Gn = {}, an = [], vt = function y(Q, W, Z, ce, Be, Fe) {
    if (!(this instanceof y)) return new y(Q, W, Z, ce, Be, Fe);
    isNaN(Q) && (Q = 1), isNaN(W) && (W = 0), isNaN(Z) && (Z = 0), isNaN(ce) && (ce = 1), isNaN(Be) && (Be = 0), isNaN(Fe) && (Fe = 0), this._matrix = [Q, W, Z, ce, Be, Fe];
  };
  Object.defineProperty(vt.prototype, "sx", { get: function() {
    return this._matrix[0];
  }, set: function(y) {
    this._matrix[0] = y;
  } }), Object.defineProperty(vt.prototype, "shy", { get: function() {
    return this._matrix[1];
  }, set: function(y) {
    this._matrix[1] = y;
  } }), Object.defineProperty(vt.prototype, "shx", { get: function() {
    return this._matrix[2];
  }, set: function(y) {
    this._matrix[2] = y;
  } }), Object.defineProperty(vt.prototype, "sy", { get: function() {
    return this._matrix[3];
  }, set: function(y) {
    this._matrix[3] = y;
  } }), Object.defineProperty(vt.prototype, "tx", { get: function() {
    return this._matrix[4];
  }, set: function(y) {
    this._matrix[4] = y;
  } }), Object.defineProperty(vt.prototype, "ty", { get: function() {
    return this._matrix[5];
  }, set: function(y) {
    this._matrix[5] = y;
  } }), Object.defineProperty(vt.prototype, "a", { get: function() {
    return this._matrix[0];
  }, set: function(y) {
    this._matrix[0] = y;
  } }), Object.defineProperty(vt.prototype, "b", { get: function() {
    return this._matrix[1];
  }, set: function(y) {
    this._matrix[1] = y;
  } }), Object.defineProperty(vt.prototype, "c", { get: function() {
    return this._matrix[2];
  }, set: function(y) {
    this._matrix[2] = y;
  } }), Object.defineProperty(vt.prototype, "d", { get: function() {
    return this._matrix[3];
  }, set: function(y) {
    this._matrix[3] = y;
  } }), Object.defineProperty(vt.prototype, "e", { get: function() {
    return this._matrix[4];
  }, set: function(y) {
    this._matrix[4] = y;
  } }), Object.defineProperty(vt.prototype, "f", { get: function() {
    return this._matrix[5];
  }, set: function(y) {
    this._matrix[5] = y;
  } }), Object.defineProperty(vt.prototype, "rotation", { get: function() {
    return Math.atan2(this.shx, this.sx);
  } }), Object.defineProperty(vt.prototype, "scaleX", { get: function() {
    return this.decompose().scale.sx;
  } }), Object.defineProperty(vt.prototype, "scaleY", { get: function() {
    return this.decompose().scale.sy;
  } }), Object.defineProperty(vt.prototype, "isIdentity", { get: function() {
    return this.sx === 1 && this.shy === 0 && this.shx === 0 && this.sy === 1 && this.tx === 0 && this.ty === 0;
  } }), vt.prototype.join = function(y) {
    return [this.sx, this.shy, this.shx, this.sy, this.tx, this.ty].map(O).join(y);
  }, vt.prototype.multiply = function(y) {
    var Q = y.sx * this.sx + y.shy * this.shx, W = y.sx * this.shy + y.shy * this.sy, Z = y.shx * this.sx + y.sy * this.shx, ce = y.shx * this.shy + y.sy * this.sy, Be = y.tx * this.sx + y.ty * this.shx + this.tx, Fe = y.tx * this.shy + y.ty * this.sy + this.ty;
    return new vt(Q, W, Z, ce, Be, Fe);
  }, vt.prototype.decompose = function() {
    var y = this.sx, Q = this.shy, W = this.shx, Z = this.sy, ce = this.tx, Be = this.ty, Fe = Math.sqrt(y * y + Q * Q), At = (y /= Fe) * W + (Q /= Fe) * Z;
    W -= y * At, Z -= Q * At;
    var ct = Math.sqrt(W * W + Z * Z);
    return At /= ct, y * (Z /= ct) < Q * (W /= ct) && (y = -y, Q = -Q, At = -At, Fe = -Fe), { scale: new vt(Fe, 0, 0, ct, 0, 0), translate: new vt(1, 0, 0, 1, ce, Be), rotate: new vt(y, Q, -Q, y, 0, 0), skew: new vt(1, 0, At, 1, 0, 0) };
  }, vt.prototype.toString = function(y) {
    return this.join(" ");
  }, vt.prototype.inversed = function() {
    var y = this.sx, Q = this.shy, W = this.shx, Z = this.sy, ce = this.tx, Be = this.ty, Fe = 1 / (y * Z - Q * W), At = Z * Fe, ct = -Q * Fe, St = -W * Fe, It = y * Fe;
    return new vt(At, ct, St, It, -At * ce - St * Be, -ct * ce - It * Be);
  }, vt.prototype.applyToPoint = function(y) {
    var Q = y.x * this.sx + y.y * this.shx + this.tx, W = y.x * this.shy + y.y * this.sy + this.ty;
    return new Qi(Q, W);
  }, vt.prototype.applyToRectangle = function(y) {
    var Q = this.applyToPoint(y), W = this.applyToPoint(new Qi(y.x + y.w, y.y + y.h));
    return new Ko(Q.x, Q.y, W.x - Q.x, W.y - Q.y);
  }, vt.prototype.clone = function() {
    var y = this.sx, Q = this.shy, W = this.shx, Z = this.sy, ce = this.tx, Be = this.ty;
    return new vt(y, Q, W, Z, ce, Be);
  }, c.Matrix = vt;
  var Sn = c.matrixMult = function(y, Q) {
    return Q.multiply(y);
  }, xn = new vt(1, 0, 0, 1, 0, 0);
  c.unitMatrix = c.identityMatrix = xn;
  var YA = function(y, Q) {
    if (!Vt[y]) {
      var W = (Q instanceof Qs ? "Sh" : "P") + (Object.keys(it).length + 1).toString(10);
      Q.id = W, Vt[y] = W, it[W] = Q, Kt.publish("addPattern", Q);
    }
  };
  c.ShadingPattern = Qs, c.TilingPattern = Ba, c.addShadingPattern = function(y, Q) {
    return U("addShadingPattern()"), YA(y, Q), this;
  }, c.beginTilingPattern = function(y) {
    U("beginTilingPattern()"), jo(y.boundingBox[0], y.boundingBox[1], y.boundingBox[2] - y.boundingBox[0], y.boundingBox[3] - y.boundingBox[1], y.matrix);
  }, c.endTilingPattern = function(y, Q) {
    U("endTilingPattern()"), Q.stream = Ee[G].join(`
`), YA(y, Q), Kt.publish("endTilingPattern", Q), an.pop().restore();
  };
  var xr, ir = c.__private__.newObject = function() {
    var y = Or();
    return Xr(y, !0), y;
  }, Or = c.__private__.newObjectDeferred = function() {
    return ee++, oe[ee] = function() {
      return pe;
    }, ee;
  }, Xr = function(y, Q) {
    return Q = typeof Q == "boolean" && Q, oe[y] = pe, Q && j(y + " 0 obj"), y;
  }, Vn = c.__private__.newAdditionalObject = function() {
    var y = { objId: Or(), content: "" };
    return me.push(y), y;
  }, Kn = Or(), Mr = Or(), on = c.__private__.decodeColorString = function(y) {
    var Q = y.split(" ");
    if (Q.length !== 2 || Q[1] !== "g" && Q[1] !== "G") Q.length !== 5 || Q[4] !== "k" && Q[4] !== "K" || (Q = [(1 - Q[0]) * (1 - Q[3]), (1 - Q[1]) * (1 - Q[3]), (1 - Q[2]) * (1 - Q[3]), "r"]);
    else {
      var W = parseFloat(Q[0]);
      Q = [W, W, W, "r"];
    }
    for (var Z = "#", ce = 0; ce < 3; ce++) Z += ("0" + Math.floor(255 * parseFloat(Q[ce])).toString(16)).slice(-2);
    return Z;
  }, JA = c.__private__.encodeColorString = function(y) {
    var Q;
    typeof y == "string" && (y = { ch1: y });
    var W = y.ch1, Z = y.ch2, ce = y.ch3, Be = y.ch4, Fe = y.pdfColorType === "draw" ? ["G", "RG", "K"] : ["g", "rg", "k"];
    if (typeof W == "string" && W.charAt(0) !== "#") {
      var At = new I5(W);
      if (At.ok) W = At.toHex();
      else if (!/^\d*\.?\d*$/.test(W)) throw new Error('Invalid color "' + W + '" passed to jsPDF.encodeColorString.');
    }
    if (typeof W == "string" && /^#[0-9A-Fa-f]{3}$/.test(W) && (W = "#" + W[1] + W[1] + W[2] + W[2] + W[3] + W[3]), typeof W == "string" && /^#[0-9A-Fa-f]{6}$/.test(W)) {
      var ct = parseInt(W.substr(1), 16);
      W = ct >> 16 & 255, Z = ct >> 8 & 255, ce = 255 & ct;
    }
    if (Z === void 0 || Be === void 0 && W === Z && Z === ce) Q = typeof W == "string" ? W + " " + Fe[0] : y.precision === 2 ? F(W / 255) + " " + Fe[0] : P(W / 255) + " " + Fe[0];
    else if (Be === void 0 || jt(Be) === "object") {
      if (Be && !isNaN(Be.a) && Be.a === 0) return ["1.", "1.", "1.", Fe[1]].join(" ");
      Q = typeof W == "string" ? [W, Z, ce, Fe[1]].join(" ") : y.precision === 2 ? [F(W / 255), F(Z / 255), F(ce / 255), Fe[1]].join(" ") : [P(W / 255), P(Z / 255), P(ce / 255), Fe[1]].join(" ");
    } else Q = typeof W == "string" ? [W, Z, ce, Be, Fe[2]].join(" ") : y.precision === 2 ? [F(W), F(Z), F(ce), F(Be), Fe[2]].join(" ") : [P(W), P(Z), P(ce), P(Be), Fe[2]].join(" ");
    return Q;
  }, $A = c.__private__.getFilters = function() {
    return s;
  }, RA = c.__private__.putStream = function(y) {
    var Q = (y = y || {}).data || "", W = y.filters || $A(), Z = y.alreadyAppliedFilters || [], ce = y.addLength1 || !1, Be = Q.length, Fe = y.objectId, At = function(aA) {
      return aA;
    };
    if (u !== null && Fe === void 0) throw new Error("ObjectId must be passed to putStream for file encryption");
    u !== null && (At = sA.encryptor(Fe, 0));
    var ct = {};
    W === !0 && (W = ["FlateEncode"]);
    var St = y.additionalKeyValues || [], It = (ct = ot.API.processDataByFilters !== void 0 ? ot.API.processDataByFilters(Q, W) : { data: Q, reverseChain: [] }).reverseChain + (Array.isArray(Z) ? Z.join(" ") : Z.toString());
    if (ct.data.length !== 0 && (St.push({ key: "Length", value: ct.data.length }), ce === !0 && St.push({ key: "Length1", value: Be })), It.length != 0) if (It.split("/").length - 1 == 1) St.push({ key: "Filter", value: It });
    else {
      St.push({ key: "Filter", value: "[" + It + "]" });
      for (var Ht = 0; Ht < St.length; Ht += 1) if (St[Ht].key === "DecodeParms") {
        for (var Fr = [], $r = 0; $r < ct.reverseChain.split("/").length - 1; $r += 1) Fr.push("null");
        Fr.push(St[Ht].value), St[Ht].value = "[" + Fr.join(" ") + "]";
      }
    }
    j("<<");
    for (var hr = 0; hr < St.length; hr++) j("/" + St[hr].key + " " + St[hr].value);
    j(">>"), ct.data.length !== 0 && (j("stream"), j(At(ct.data)), j("endstream"));
  }, Ei = c.__private__.putPage = function(y) {
    var Q = y.number, W = y.data, Z = y.objId, ce = y.contentsObjId;
    Xr(Z, !0), j("<</Type /Page"), j("/Parent " + y.rootDictionaryObjId + " 0 R"), j("/Resources " + y.resourceDictionaryObjId + " 0 R"), j("/MediaBox [" + parseFloat(O(y.mediaBox.bottomLeftX)) + " " + parseFloat(O(y.mediaBox.bottomLeftY)) + " " + O(y.mediaBox.topRightX) + " " + O(y.mediaBox.topRightY) + "]"), y.cropBox !== null && j("/CropBox [" + O(y.cropBox.bottomLeftX) + " " + O(y.cropBox.bottomLeftY) + " " + O(y.cropBox.topRightX) + " " + O(y.cropBox.topRightY) + "]"), y.bleedBox !== null && j("/BleedBox [" + O(y.bleedBox.bottomLeftX) + " " + O(y.bleedBox.bottomLeftY) + " " + O(y.bleedBox.topRightX) + " " + O(y.bleedBox.topRightY) + "]"), y.trimBox !== null && j("/TrimBox [" + O(y.trimBox.bottomLeftX) + " " + O(y.trimBox.bottomLeftY) + " " + O(y.trimBox.topRightX) + " " + O(y.trimBox.topRightY) + "]"), y.artBox !== null && j("/ArtBox [" + O(y.artBox.bottomLeftX) + " " + O(y.artBox.bottomLeftY) + " " + O(y.artBox.topRightX) + " " + O(y.artBox.topRightY) + "]"), typeof y.userUnit == "number" && y.userUnit !== 1 && j("/UserUnit " + y.userUnit), Kt.publish("putPage", { objId: Z, pageContext: Bt[Q], pageNumber: Q, page: W }), j("/Contents " + ce + " 0 R"), j(">>"), j("endobj");
    var Be = W.join(`
`);
    return C === S && (Be += `
Q`), Xr(ce, !0), RA({ data: Be, filters: $A(), objectId: ce }), j("endobj"), Z;
  }, $e = c.__private__.putPages = function() {
    var y, Q, W = [];
    for (y = 1; y <= ut; y++) Bt[y].objId = Or(), Bt[y].contentsObjId = Or();
    for (y = 1; y <= ut; y++) W.push(Ei({ number: y, data: Ee[y], objId: Bt[y].objId, contentsObjId: Bt[y].contentsObjId, mediaBox: Bt[y].mediaBox, cropBox: Bt[y].cropBox, bleedBox: Bt[y].bleedBox, trimBox: Bt[y].trimBox, artBox: Bt[y].artBox, userUnit: Bt[y].userUnit, rootDictionaryObjId: Kn, resourceDictionaryObjId: Mr }));
    Xr(Kn, !0), j("<</Type /Pages");
    var Z = "/Kids [";
    for (Q = 0; Q < ut; Q++) Z += W[Q] + " 0 R ";
    j(Z + "]"), j("/Count " + ut), j(">>"), j("endobj"), Kt.publish("postPutPages");
  }, ne = function(y) {
    Kt.publish("putFont", { font: y, out: j, newObject: ir, putStream: RA }), y.isAlreadyPutted !== !0 && (y.objectNumber = ir(), j("<<"), j("/Type /Font"), j("/BaseFont /" + ho(y.postScriptName)), j("/Subtype /Type1"), typeof y.encoding == "string" && j("/Encoding /" + y.encoding), j("/FirstChar 32"), j("/LastChar 255"), j(">>"), j("endobj"));
  }, Qe = function(y) {
    y.objectNumber = ir();
    var Q = [];
    Q.push({ key: "Type", value: "/XObject" }), Q.push({ key: "Subtype", value: "/Form" }), Q.push({ key: "BBox", value: "[" + [O(y.x), O(y.y), O(y.x + y.width), O(y.y + y.height)].join(" ") + "]" }), Q.push({ key: "Matrix", value: "[" + y.matrix.toString() + "]" });
    var W = y.pages[1].join(`
`);
    RA({ data: W, additionalKeyValues: Q, objectId: y.objectNumber }), j("endobj");
  }, Je = function(y, Q) {
    Q || (Q = 21);
    var W = ir(), Z = (function(Fe, At) {
      var ct, St = [], It = 1 / (At - 1);
      for (ct = 0; ct < 1; ct += It) St.push(ct);
      if (St.push(1), Fe[0].offset != 0) {
        var Ht = { offset: 0, color: Fe[0].color };
        Fe.unshift(Ht);
      }
      if (Fe[Fe.length - 1].offset != 1) {
        var Fr = { offset: 1, color: Fe[Fe.length - 1].color };
        Fe.push(Fr);
      }
      for (var $r = "", hr = 0, aA = 0; aA < St.length; aA++) {
        for (ct = St[aA]; ct > Fe[hr + 1].offset; ) hr++;
        var Zr = Fe[hr].offset, wA = (ct - Zr) / (Fe[hr + 1].offset - Zr), Ti = Fe[hr].color, qn = Fe[hr + 1].color;
        $r += Y(Math.round((1 - wA) * Ti[0] + wA * qn[0]).toString(16)) + Y(Math.round((1 - wA) * Ti[1] + wA * qn[1]).toString(16)) + Y(Math.round((1 - wA) * Ti[2] + wA * qn[2]).toString(16));
      }
      return $r.trim();
    })(y.colors, Q), ce = [];
    ce.push({ key: "FunctionType", value: "0" }), ce.push({ key: "Domain", value: "[0.0 1.0]" }), ce.push({ key: "Size", value: "[" + Q + "]" }), ce.push({ key: "BitsPerSample", value: "8" }), ce.push({ key: "Range", value: "[0.0 1.0 0.0 1.0 0.0 1.0]" }), ce.push({ key: "Decode", value: "[0.0 1.0 0.0 1.0 0.0 1.0]" }), RA({ data: Z, additionalKeyValues: ce, alreadyAppliedFilters: ["/ASCIIHexDecode"], objectId: W }), j("endobj"), y.objectNumber = ir(), j("<< /ShadingType " + y.type), j("/ColorSpace /DeviceRGB");
    var Be = "/Coords [" + O(parseFloat(y.coords[0])) + " " + O(parseFloat(y.coords[1])) + " ";
    y.type === 2 ? Be += O(parseFloat(y.coords[2])) + " " + O(parseFloat(y.coords[3])) : Be += O(parseFloat(y.coords[2])) + " " + O(parseFloat(y.coords[3])) + " " + O(parseFloat(y.coords[4])) + " " + O(parseFloat(y.coords[5])), j(Be += "]"), y.matrix && j("/Matrix [" + y.matrix.toString() + "]"), j("/Function " + W + " 0 R"), j("/Extend [true true]"), j(">>"), j("endobj");
  }, Wt = function(y, Q) {
    var W = Or(), Z = ir();
    Q.push({ resourcesOid: W, objectOid: Z }), y.objectNumber = Z;
    var ce = [];
    ce.push({ key: "Type", value: "/Pattern" }), ce.push({ key: "PatternType", value: "1" }), ce.push({ key: "PaintType", value: "1" }), ce.push({ key: "TilingType", value: "1" }), ce.push({ key: "BBox", value: "[" + y.boundingBox.map(O).join(" ") + "]" }), ce.push({ key: "XStep", value: O(y.xStep) }), ce.push({ key: "YStep", value: O(y.yStep) }), ce.push({ key: "Resources", value: W + " 0 R" }), y.matrix && ce.push({ key: "Matrix", value: "[" + y.matrix.toString() + "]" }), RA({ data: y.stream, additionalKeyValues: ce, objectId: y.objectNumber }), j("endobj");
  }, Yr = function(y) {
    for (var Q in y.objectNumber = ir(), j("<<"), y) switch (Q) {
      case "opacity":
        j("/ca " + F(y[Q]));
        break;
      case "stroke-opacity":
        j("/CA " + F(y[Q]));
    }
    j(">>"), j("endobj");
  }, Er = function(y) {
    Xr(y.resourcesOid, !0), j("<<"), j("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"), (function() {
      for (var Q in j("/Font <<"), mt) mt.hasOwnProperty(Q) && (h === !1 || h === !0 && f.hasOwnProperty(Q)) && j("/" + Q + " " + mt[Q].objectNumber + " 0 R");
      j(">>");
    })(), (function() {
      if (Object.keys(it).length > 0) {
        for (var Q in j("/Shading <<"), it) it.hasOwnProperty(Q) && it[Q] instanceof Qs && it[Q].objectNumber >= 0 && j("/" + Q + " " + it[Q].objectNumber + " 0 R");
        Kt.publish("putShadingPatternDict"), j(">>");
      }
    })(), (function(Q) {
      if (Object.keys(it).length > 0) {
        for (var W in j("/Pattern <<"), it) it.hasOwnProperty(W) && it[W] instanceof c.TilingPattern && it[W].objectNumber >= 0 && it[W].objectNumber < Q && j("/" + W + " " + it[W].objectNumber + " 0 R");
        Kt.publish("putTilingPatternDict"), j(">>");
      }
    })(y.objectOid), (function() {
      if (Object.keys(lt).length > 0) {
        var Q;
        for (Q in j("/ExtGState <<"), lt) lt.hasOwnProperty(Q) && lt[Q].objectNumber >= 0 && j("/" + Q + " " + lt[Q].objectNumber + " 0 R");
        Kt.publish("putGStateDict"), j(">>");
      }
    })(), (function() {
      for (var Q in j("/XObject <<"), Sr) Sr.hasOwnProperty(Q) && Sr[Q].objectNumber >= 0 && j("/" + Q + " " + Sr[Q].objectNumber + " 0 R");
      Kt.publish("putXobjectDict"), j(">>");
    })(), j(">>"), j("endobj");
  }, iA = function(y) {
    yt[y.fontName] = yt[y.fontName] || {}, yt[y.fontName][y.fontStyle] = y.id;
  }, kA = function(y, Q, W, Z, ce) {
    var Be = { id: "F" + (Object.keys(mt).length + 1).toString(10), postScriptName: y, fontName: Q, fontStyle: W, encoding: Z, isStandardFont: ce || !1, metadata: {} };
    return Kt.publish("addFont", { font: Be, instance: this }), mt[Be.id] = Be, iA(Be), Be.id;
  }, dA = c.__private__.pdfEscape = c.pdfEscape = function(y, Q) {
    return (function(W, Z) {
      var ce, Be, Fe, At, ct, St, It, Ht, Fr;
      if (Fe = (Z = Z || {}).sourceEncoding || "Unicode", ct = Z.outputEncoding, (Z.autoencode || ct) && mt[Ve].metadata && mt[Ve].metadata[Fe] && mt[Ve].metadata[Fe].encoding && (At = mt[Ve].metadata[Fe].encoding, !ct && mt[Ve].encoding && (ct = mt[Ve].encoding), !ct && At.codePages && (ct = At.codePages[0]), typeof ct == "string" && (ct = At[ct]), ct)) {
        for (It = !1, St = [], ce = 0, Be = W.length; ce < Be; ce++) (Ht = ct[W.charCodeAt(ce)]) ? St.push(String.fromCharCode(Ht)) : St.push(W[ce]), St[ce].charCodeAt(0) >> 8 && (It = !0);
        W = St.join("");
      }
      for (ce = W.length; It === void 0 && ce !== 0; ) W.charCodeAt(ce - 1) >> 8 && (It = !0), ce--;
      if (!It) return W;
      for (St = Z.noBOM ? [] : [254, 255], ce = 0, Be = W.length; ce < Be; ce++) {
        if ((Fr = (Ht = W.charCodeAt(ce)) >> 8) >> 8) throw new Error("Character at position " + ce + " of string '" + W + "' exceeds 16bits. Cannot be encoded into UCS-2 BE");
        St.push(Fr), St.push(Ht - (Fr << 8));
      }
      return String.fromCharCode.apply(void 0, St);
    })(y, Q).replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
  }, Rr = c.__private__.beginPage = function(y) {
    Ee[++ut] = [], Bt[ut] = { objId: 0, contentsObjId: 0, userUnit: Number(a), artBox: null, bleedBox: null, cropBox: null, trimBox: null, mediaBox: { bottomLeftX: 0, bottomLeftY: 0, topRightX: Number(y[0]), topRightY: Number(y[1]) } }, _u(ut), Ge(Ee[G]);
  }, Xs = function(y, Q) {
    var W, Z, ce;
    switch (t = Q || t, typeof y == "string" && (W = w(y.toLowerCase()), Array.isArray(W) && (Z = W[0], ce = W[1])), Array.isArray(y) && (Z = y[0] * dt, ce = y[1] * dt), isNaN(Z) && (Z = n[0], ce = n[1]), (Z > 14400 || ce > 14400) && (or.warn("A page in a PDF can not be wider or taller than 14400 userUnit. jsPDF limits the width/height to 14400"), Z = Math.min(14400, Z), ce = Math.min(14400, ce)), n = [Z, ce], t.substr(0, 1)) {
      case "l":
        ce > Z && (n = [ce, Z]);
        break;
      case "p":
        Z > ce && (n = [ce, Z]);
    }
    Rr(n), xt(Ho), j(qa), Go !== 0 && j(Go + " J"), Vo !== 0 && j(Vo + " j"), Kt.publish("addPage", { pageNumber: ut });
  }, os = function(y) {
    y > 0 && y <= ut && (Ee.splice(y, 1), Bt.splice(y, 1), ut--, G > ut && (G = ut), this.setPage(G));
  }, _u = function(y) {
    y > 0 && y <= ut && (G = y);
  }, Uu = c.__private__.getNumberOfPages = c.getNumberOfPages = function() {
    return Ee.length - 1;
  }, Iu = function(y, Q, W) {
    var Z, ce = void 0;
    return W = W || {}, y = y !== void 0 ? y : mt[Ve].fontName, Q = Q !== void 0 ? Q : mt[Ve].fontStyle, Z = y.toLowerCase(), yt[Z] !== void 0 && yt[Z][Q] !== void 0 ? ce = yt[Z][Q] : yt[y] !== void 0 && yt[y][Q] !== void 0 ? ce = yt[y][Q] : W.disableWarning === !1 && or.warn("Unable to look up font label for font '" + y + "', '" + Q + "'. Refer to getFontList() for available fonts."), ce || W.noFallback || (ce = yt.times[Q]) == null && (ce = yt.times.normal), ce;
  }, li = c.__private__.putInfo = function() {
    var y = ir(), Q = function(Z) {
      return Z;
    };
    for (var W in u !== null && (Q = sA.encryptor(y, 0)), j("<<"), j("/Producer (" + dA(Q("jsPDF " + ot.version)) + ")"), Xe) Xe.hasOwnProperty(W) && Xe[W] && j("/" + W.substr(0, 1).toUpperCase() + W.substr(1) + " (" + dA(Q(Xe[W])) + ")");
    j("/CreationDate (" + dA(Q(J)) + ")"), j(">>"), j("endobj");
  }, Va = c.__private__.putCatalog = function(y) {
    var Q = (y = y || {}).rootDictionaryObjId || Kn;
    switch (ir(), j("<<"), j("/Type /Catalog"), j("/Pages " + Q + " 0 R"), rt || (rt = "fullwidth"), rt) {
      case "fullwidth":
        j("/OpenAction [3 0 R /FitH null]");
        break;
      case "fullheight":
        j("/OpenAction [3 0 R /FitV null]");
        break;
      case "fullpage":
        j("/OpenAction [3 0 R /Fit]");
        break;
      case "original":
        j("/OpenAction [3 0 R /XYZ null null 1]");
        break;
      default:
        var W = "" + rt;
        W.substr(W.length - 1) === "%" && (rt = parseInt(rt) / 100), typeof rt == "number" && j("/OpenAction [3 0 R /XYZ null null " + F(rt) + "]");
    }
    switch (Oe || (Oe = "continuous"), Oe) {
      case "continuous":
        j("/PageLayout /OneColumn");
        break;
      case "single":
        j("/PageLayout /SinglePage");
        break;
      case "two":
      case "twoleft":
        j("/PageLayout /TwoColumnLeft");
        break;
      case "tworight":
        j("/PageLayout /TwoColumnRight");
    }
    ze && j("/PageMode /" + ze), Kt.publish("putCatalog"), j(">>"), j("endobj");
  }, cf = c.__private__.putTrailer = function() {
    j("trailer"), j("<<"), j("/Size " + (ee + 1)), j("/Root " + ee + " 0 R"), j("/Info " + (ee - 1) + " 0 R"), u !== null && j("/Encrypt " + sA.oid + " 0 R"), j("/ID [ <" + ie + "> <" + ie + "> ]"), j(">>");
  }, Jr = c.__private__.putHeader = function() {
    j("%PDF-" + p), j("%ºß¬à");
  }, Qu = c.__private__.putXRef = function() {
    var y = "0000000000";
    j("xref"), j("0 " + (ee + 1)), j("0000000000 65535 f ");
    for (var Q = 1; Q <= ee; Q++) typeof oe[Q] == "function" ? j((y + oe[Q]()).slice(-10) + " 00000 n ") : oe[Q] !== void 0 ? j((y + oe[Q]).slice(-10) + " 00000 n ") : j("0000000000 00000 n ");
  }, ui = c.__private__.buildDocument = function() {
    var y;
    ee = 0, pe = 0, ge = [], oe = [], me = [], Kn = Or(), Mr = Or(), Ge(ge), Kt.publish("buildDocument"), Jr(), $e(), (function() {
      Kt.publish("putAdditionalObjects");
      for (var W = 0; W < me.length; W++) {
        var Z = me[W];
        Xr(Z.objId, !0), j(Z.content), j("endobj");
      }
      Kt.publish("postPutAdditionalObjects");
    })(), y = [], (function() {
      for (var W in mt) mt.hasOwnProperty(W) && (h === !1 || h === !0 && f.hasOwnProperty(W)) && ne(mt[W]);
    })(), (function() {
      var W;
      for (W in lt) lt.hasOwnProperty(W) && Yr(lt[W]);
    })(), (function() {
      for (var W in Sr) Sr.hasOwnProperty(W) && Qe(Sr[W]);
    })(), (function(W) {
      var Z;
      for (Z in it) it.hasOwnProperty(Z) && (it[Z] instanceof Qs ? Je(it[Z]) : it[Z] instanceof Ba && Wt(it[Z], W));
    })(y), Kt.publish("putResources"), y.forEach(Er), Er({ resourcesOid: Mr, objectOid: Number.MAX_SAFE_INTEGER }), Kt.publish("postPutResources"), u !== null && (sA.oid = ir(), j("<<"), j("/Filter /Standard"), j("/V " + sA.v), j("/R " + sA.r), j("/U <" + sA.toHexString(sA.U) + ">"), j("/O <" + sA.toHexString(sA.O) + ">"), j("/P " + sA.P), j(">>"), j("endobj")), li(), Va();
    var Q = pe;
    return Qu(), cf(), j("startxref"), j("" + Q), j("%%EOF"), Ge(Ee[G]), ge.join(`
`);
  }, Ka = c.__private__.getBlob = function(y) {
    return new Blob([ft(y)], { type: "application/pdf" });
  }, Lu = c.output = c.__private__.output = (xr = function(y, Q) {
    switch (typeof (Q = Q || {}) == "string" ? Q = { filename: Q } : Q.filename = Q.filename || "generated.pdf", y) {
      case void 0:
        return ui();
      case "save":
        c.save(Q.filename);
        break;
      case "arraybuffer":
        return ft(ui());
      case "blob":
        return Ka(ui());
      case "bloburi":
      case "bloburl":
        if (Ct.URL !== void 0 && typeof Ct.URL.createObjectURL == "function") return Ct.URL && Ct.URL.createObjectURL(Ka(ui())) || void 0;
        or.warn("bloburl is not supported by your system, because URL.createObjectURL is not supported by your browser.");
        break;
      case "datauristring":
      case "dataurlstring":
        var W = "", Z = ui();
        try {
          W = Lw(Z);
        } catch {
          W = Lw(unescape(encodeURIComponent(Z)));
        }
        return "data:application/pdf;filename=" + Q.filename + ";base64," + W;
      case "pdfobjectnewwindow":
        if (Object.prototype.toString.call(Ct) === "[object Window]") {
          var ce = "https://cdnjs.cloudflare.com/ajax/libs/pdfobject/2.1.1/pdfobject.min.js", Be = ' integrity="sha512-4ze/a9/4jqu+tX9dfOqJYSvyYd5M6qum/3HpCLr+/Jqf0whc37VUbkpNGHR7/8pSnCFw47T1fmIpwBV7UySh3g==" crossorigin="anonymous"';
          Q.pdfObjectUrl && (ce = Q.pdfObjectUrl, Be = "");
          var Fe = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><script src="' + ce + '"' + Be + '><\/script><script >PDFObject.embed("' + this.output("dataurlstring") + '", ' + JSON.stringify(Q) + ");<\/script></body></html>", At = Ct.open();
          return At !== null && At.document.write(Fe), At;
        }
        throw new Error("The option pdfobjectnewwindow just works in a browser-environment.");
      case "pdfjsnewwindow":
        if (Object.prototype.toString.call(Ct) === "[object Window]") {
          var ct = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe id="pdfViewer" src="' + (Q.pdfJsUrl || "examples/PDF.js/web/viewer.html") + "?file=&downloadName=" + Q.filename + '" width="500px" height="400px" /></body></html>', St = Ct.open();
          if (St !== null) {
            St.document.write(ct);
            var It = this;
            St.document.documentElement.querySelector("#pdfViewer").onload = function() {
              St.document.title = Q.filename, St.document.documentElement.querySelector("#pdfViewer").contentWindow.PDFViewerApplication.open(It.output("bloburl"));
            };
          }
          return St;
        }
        throw new Error("The option pdfjsnewwindow just works in a browser-environment.");
      case "dataurlnewwindow":
        if (Object.prototype.toString.call(Ct) !== "[object Window]") throw new Error("The option dataurlnewwindow just works in a browser-environment.");
        var Ht = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe src="' + this.output("datauristring", Q) + '"></iframe></body></html>', Fr = Ct.open();
        if (Fr !== null && (Fr.document.write(Ht), Fr.document.title = Q.filename), Fr || typeof safari > "u") return Fr;
        break;
      case "datauri":
      case "dataurl":
        return Ct.document.location.href = this.output("datauristring", Q);
      default:
        return null;
    }
  }, xr.foo = function() {
    try {
      return xr.apply(this, arguments);
    } catch (W) {
      var y = W.stack || "";
      ~y.indexOf(" at ") && (y = y.split(" at ")[1]);
      var Q = "Error in function " + y.split(`
`)[0].split("<")[0] + ": " + W.message;
      if (!Ct.console) throw new Error(Q);
      Ct.console.error(Q, W), Ct.alert && alert(Q);
    }
  }, xr.foo.bar = xr, xr.foo), En = function(y) {
    return Array.isArray(cr) === !0 && cr.indexOf(y) > -1;
  };
  switch (A) {
    case "pt":
      dt = 1;
      break;
    case "mm":
      dt = 72 / 25.4;
      break;
    case "cm":
      dt = 72 / 2.54;
      break;
    case "in":
      dt = 72;
      break;
    case "px":
      dt = En("px_scaling") == 1 ? 0.75 : 96 / 72;
      break;
    case "pc":
    case "em":
      dt = 12;
      break;
    case "ex":
      dt = 6;
      break;
    default:
      if (typeof A != "number") throw new Error("Invalid unit: " + A);
      dt = A;
  }
  var sA = null;
  se(), $();
  var Fi = c.__private__.getPageInfo = c.getPageInfo = function(y) {
    if (isNaN(y) || y % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfo");
    return { objId: Bt[y].objId, pageNumber: y, pageContext: Bt[y] };
  }, Nu = c.__private__.getPageInfoByObjId = function(y) {
    if (isNaN(y) || y % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfoByObjId");
    for (var Q in Bt) if (Bt[Q].objId === y) break;
    return Fi(Q);
  }, hf = c.__private__.getCurrentPageInfo = c.getCurrentPageInfo = function() {
    return { objId: Bt[G].objId, pageNumber: G, pageContext: Bt[G] };
  };
  c.addPage = function() {
    return Xs.apply(this, arguments), this;
  }, c.setPage = function() {
    return _u.apply(this, arguments), Ge.call(this, Ee[G]), this;
  }, c.insertPage = function(y) {
    return this.addPage(), this.movePage(G, y), this;
  }, c.movePage = function(y, Q) {
    var W, Z;
    if (y > Q) {
      W = Ee[y], Z = Bt[y];
      for (var ce = y; ce > Q; ce--) Ee[ce] = Ee[ce - 1], Bt[ce] = Bt[ce - 1];
      Ee[Q] = W, Bt[Q] = Z, this.setPage(Q);
    } else if (y < Q) {
      W = Ee[y], Z = Bt[y];
      for (var Be = y; Be < Q; Be++) Ee[Be] = Ee[Be + 1], Bt[Be] = Bt[Be + 1];
      Ee[Q] = W, Bt[Q] = Z, this.setPage(Q);
    }
    return this;
  }, c.deletePage = function() {
    return os.apply(this, arguments), this;
  }, c.__private__.text = c.text = function(y, Q, W, Z, ce) {
    var Be, Fe, At, ct, St, It, Ht, Fr, $r, hr = (Z = Z || {}).scope || this;
    if (typeof y == "number" && typeof Q == "number" && (typeof W == "string" || Array.isArray(W))) {
      var aA = W;
      W = Q, Q = y, y = aA;
    }
    if (arguments[3] instanceof vt == 0 ? (At = arguments[4], ct = arguments[5], jt(Ht = arguments[3]) === "object" && Ht !== null || (typeof At == "string" && (ct = At, At = null), typeof Ht == "string" && (ct = Ht, Ht = null), typeof Ht == "number" && (At = Ht, Ht = null), Z = { flags: Ht, angle: At, align: ct })) : (U("The transform parameter of text() with a Matrix value"), $r = ce), isNaN(Q) || isNaN(W) || y == null) throw new Error("Invalid arguments passed to jsPDF.text");
    if (y.length === 0) return hr;
    var Zr, wA = "", Ti = typeof Z.lineHeightFactor == "number" ? Z.lineHeightFactor : Js, qn = hr.internal.scaleFactor;
    function Pi(Jt) {
      return Jt = Jt.split("	").join(Array(Z.TabLen || 9).join(" ")), dA(Jt, Ht);
    }
    function zo(Jt) {
      for (var sr, Hr = Jt.concat(), oA = [], Ri = Hr.length; Ri--; ) typeof (sr = Hr.shift()) == "string" ? oA.push(sr) : Array.isArray(Jt) && (sr.length === 1 || sr[1] === void 0 && sr[2] === void 0) ? oA.push(sr[0]) : oA.push([sr[0], sr[1], sr[2]]);
      return oA;
    }
    function Wa(Jt, sr) {
      var Hr;
      if (typeof Jt == "string") Hr = sr(Jt)[0];
      else if (Array.isArray(Jt)) {
        for (var oA, Ri, Al = Jt.concat(), Ja = [], Ku = Al.length; Ku--; ) typeof (oA = Al.shift()) == "string" ? Ja.push(sr(oA)[0]) : Array.isArray(oA) && typeof oA[0] == "string" && (Ri = sr(oA[0], oA[1], oA[2]), Ja.push([Ri[0], Ri[1], Ri[2]]));
        Hr = Ja;
      }
      return Hr;
    }
    var ls = !1, ta = !0;
    if (typeof y == "string") ls = !0;
    else if (Array.isArray(y)) {
      var ra = y.concat();
      Fe = [];
      for (var us, yA = ra.length; yA--; ) (typeof (us = ra.shift()) != "string" || Array.isArray(us) && typeof us[0] != "string") && (ta = !1);
      ls = ta;
    }
    if (ls === !1) throw new Error('Type of text must be string or Array. "' + y + '" is not recognized.');
    typeof y == "string" && (y = y.match(/[\r?\n]/) ? y.split(/\r\n|\r|\n/g) : [y]);
    var Aa = xe / hr.internal.scaleFactor, na = Aa * (Ti - 1);
    switch (Z.baseline) {
      case "bottom":
        W -= na;
        break;
      case "top":
        W += Aa - na;
        break;
      case "hanging":
        W += Aa - 2 * na;
        break;
      case "middle":
        W += Aa / 2 - na;
    }
    if ((It = Z.maxWidth || 0) > 0 && (typeof y == "string" ? y = hr.splitTextToSize(y, It) : Object.prototype.toString.call(y) === "[object Array]" && (y = y.reduce(function(Jt, sr) {
      return Jt.concat(hr.splitTextToSize(sr, It));
    }, []))), Be = { text: y, x: Q, y: W, options: Z, mutex: { pdfEscape: dA, activeFontKey: Ve, fonts: mt, activeFontSize: xe } }, Kt.publish("preProcessText", Be), y = Be.text, At = (Z = Be.options).angle, $r instanceof vt == 0 && At && typeof At == "number") {
      At *= Math.PI / 180, Z.rotationDirection === 0 && (At = -At), C === S && (At = -At);
      var Wo = Math.cos(At), Xo = Math.sin(At);
      $r = new vt(Wo, Xo, -Xo, Wo, 0, 0);
    } else At && At instanceof vt && ($r = At);
    C !== S || $r || ($r = xn), (St = Z.charSpace || Ii) !== void 0 && (wA += O(D(St)) + ` Tc
`, this.setCharSpace(this.getCharSpace() || 0)), (Fr = Z.horizontalScale) !== void 0 && (wA += O(100 * Fr) + ` Tz
`), Z.lang;
    var HA = -1, Oi = Z.renderingMode !== void 0 ? Z.renderingMode : Z.stroke, Xa = hr.internal.getCurrentPageInfo().pageContext;
    switch (Oi) {
      case 0:
      case !1:
      case "fill":
        HA = 0;
        break;
      case 1:
      case !0:
      case "stroke":
        HA = 1;
        break;
      case 2:
      case "fillThenStroke":
        HA = 2;
        break;
      case 3:
      case "invisible":
        HA = 3;
        break;
      case 4:
      case "fillAndAddForClipping":
        HA = 4;
        break;
      case 5:
      case "strokeAndAddPathForClipping":
        HA = 5;
        break;
      case 6:
      case "fillThenStrokeAndAddToPathForClipping":
        HA = 6;
        break;
      case 7:
      case "addToPathForClipping":
        HA = 7;
    }
    var Gu = Xa.usedRenderingMode !== void 0 ? Xa.usedRenderingMode : -1;
    HA !== -1 ? wA += HA + ` Tr
` : Gu !== -1 && (wA += `0 Tr
`), HA !== -1 && (Xa.usedRenderingMode = HA), ct = Z.align || "left";
    var Fn, ia = xe * Ti, Yo = hr.internal.pageSize.getWidth(), Jo = mt[Ve];
    St = Z.charSpace || Ii, It = Z.maxWidth || 0, Ht = Object.assign({ autoencode: !0, noBOM: !0 }, Z.flags);
    var cs = [], sa = function(Jt) {
      return hr.getStringUnitWidth(Jt, { font: Jo, charSpace: St, fontSize: xe, doKerning: !1 }) * xe / qn;
    };
    if (Object.prototype.toString.call(y) === "[object Array]") {
      var ln;
      Fe = zo(y), ct !== "left" && (Fn = Fe.map(sa));
      var un, hs = 0;
      if (ct === "right") {
        Q -= Fn[0], y = [], yA = Fe.length;
        for (var Mi = 0; Mi < yA; Mi++) Mi === 0 ? (un = _i(Q), ln = Ui(W)) : (un = D(hs - Fn[Mi]), ln = -ia), y.push([Fe[Mi], un, ln]), hs = Fn[Mi];
      } else if (ct === "center") {
        Q -= Fn[0] / 2, y = [], yA = Fe.length;
        for (var fs = 0; fs < yA; fs++) fs === 0 ? (un = _i(Q), ln = Ui(W)) : (un = D((hs - Fn[fs]) / 2), ln = -ia), y.push([Fe[fs], un, ln]), hs = Fn[fs];
      } else if (ct === "left") {
        y = [], yA = Fe.length;
        for (var $o = 0; $o < yA; $o++) y.push(Fe[$o]);
      } else if (ct === "justify" && Jo.encoding === "Identity-H") {
        y = [], yA = Fe.length, It = It !== 0 ? It : Yo;
        for (var Ya = 0, kr = 0; kr < yA; kr++) if (ln = kr === 0 ? Ui(W) : -ia, un = kr === 0 ? _i(Q) : Ya, kr < yA - 1) {
          var Vu = D((It - Fn[kr]) / (Fe[kr].split(" ").length - 1)), hi = Fe[kr].split(" ");
          y.push([hi[0] + " ", un, ln]), Ya = 0;
          for (var fi = 1; fi < hi.length; fi++) {
            var Zo = (sa(hi[fi - 1] + " " + hi[fi]) - sa(hi[fi])) * qn + Vu;
            fi == hi.length - 1 ? y.push([hi[fi], Zo, 0]) : y.push([hi[fi] + " ", Zo, 0]), Ya -= Zo;
          }
        } else y.push([Fe[kr], un, ln]);
        y.push(["", Ya, 0]);
      } else {
        if (ct !== "justify") throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');
        for (y = [], yA = Fe.length, It = It !== 0 ? It : Yo, kr = 0; kr < yA; kr++) {
          ln = kr === 0 ? Ui(W) : -ia, un = kr === 0 ? _i(Q) : 0;
          var el = Fe[kr].split(" ").length - 1, tl = el > 0 ? (It - Fn[kr]) / el : 0;
          kr < yA - 1 ? cs.push(O(D(tl))) : cs.push(0), y.push([Fe[kr], un, ln]);
        }
      }
    }
    (typeof Z.R2L == "boolean" ? Z.R2L : We) === !0 && (y = Wa(y, function(Jt, sr, Hr) {
      return [Jt.split("").reverse().join(""), sr, Hr];
    })), Be = { text: y, x: Q, y: W, options: Z, mutex: { pdfEscape: dA, activeFontKey: Ve, fonts: mt, activeFontSize: xe } }, Kt.publish("postProcessText", Be), y = Be.text, Zr = Be.mutex.isHex || !1;
    var rl = mt[Ve].encoding;
    rl !== "WinAnsiEncoding" && rl !== "StandardEncoding" || (y = Wa(y, function(Jt, sr, Hr) {
      return [Pi(Jt), sr, Hr];
    })), Fe = zo(y), y = [];
    for (var ds, gs, ps, aa = Array.isArray(Fe[0]) ? 1 : 0, ms = "", oa = function(Jt, sr, Hr) {
      var oA = "";
      return Hr instanceof vt ? (Hr = typeof Z.angle == "number" ? Sn(Hr, new vt(1, 0, 0, 1, Jt, sr)) : Sn(new vt(1, 0, 0, 1, Jt, sr), Hr), C === S && (Hr = Sn(new vt(1, 0, 0, -1, 0, 0), Hr)), oA = Hr.join(" ") + ` Tm
`) : oA = O(Jt) + " " + O(sr) + ` Td
`, oA;
    }, _n = 0; _n < Fe.length; _n++) {
      switch (ms = "", aa) {
        case 1:
          ps = (Zr ? "<" : "(") + Fe[_n][0] + (Zr ? ">" : ")"), ds = parseFloat(Fe[_n][1]), gs = parseFloat(Fe[_n][2]);
          break;
        case 0:
          ps = (Zr ? "<" : "(") + Fe[_n] + (Zr ? ">" : ")"), ds = _i(Q), gs = Ui(W);
      }
      cs !== void 0 && cs[_n] !== void 0 && (ms = cs[_n] + ` Tw
`), _n === 0 ? y.push(ms + oa(ds, gs, $r) + ps) : aa === 0 ? y.push(ms + ps) : aa === 1 && y.push(ms + oa(ds, gs, $r) + ps);
    }
    y = aa === 0 ? y.join(` Tj
T* `) : y.join(` Tj
`), y += ` Tj
`;
    var di = `BT
/`;
    return di += Ve + " " + xe + ` Tf
`, di += O(xe * Ti) + ` TL
`, di += $s + `
`, di += wA, di += y, j(di += "ET"), f[Ve] = !0, hr;
  };
  var ff = c.__private__.clip = c.clip = function(y) {
    return j(y === "evenodd" ? "W*" : "W"), this;
  };
  c.clipEvenOdd = function() {
    return ff("evenodd");
  }, c.__private__.discardPath = c.discardPath = function() {
    return j("n"), this;
  };
  var ci = c.__private__.isValidStyle = function(y) {
    var Q = !1;
    return [void 0, null, "S", "D", "F", "DF", "FD", "f", "f*", "B", "B*", "n"].indexOf(y) !== -1 && (Q = !0), Q;
  };
  c.__private__.setDefaultPathOperation = c.setDefaultPathOperation = function(y) {
    return ci(y) && (l = y), this;
  };
  var Tu = c.__private__.getStyle = c.getStyle = function(y) {
    var Q = l;
    switch (y) {
      case "D":
      case "S":
        Q = "S";
        break;
      case "F":
        Q = "f";
        break;
      case "FD":
      case "DF":
        Q = "B";
        break;
      case "f":
      case "f*":
      case "B":
      case "B*":
        Q = y;
    }
    return Q;
  }, Pu = c.close = function() {
    return j("h"), this;
  };
  c.stroke = function() {
    return j("S"), this;
  }, c.fill = function(y) {
    return ja("f", y), this;
  }, c.fillEvenOdd = function(y) {
    return ja("f*", y), this;
  }, c.fillStroke = function(y) {
    return ja("B", y), this;
  }, c.fillStrokeEvenOdd = function(y) {
    return ja("B*", y), this;
  };
  var ja = function(y, Q) {
    jt(Q) === "object" ? gf(Q, y) : j(y);
  }, Ys = function(y) {
    y === null || C === S && y === void 0 || (y = Tu(y), j(y));
  };
  function df(y, Q, W, Z, ce) {
    var Be = new Ba(Q || this.boundingBox, W || this.xStep, Z || this.yStep, this.gState, ce || this.matrix);
    Be.stream = this.stream;
    var Fe = y + "$$" + this.cloneIndex++ + "$$";
    return YA(Fe, Be), Be;
  }
  var gf = function(y, Q) {
    var W = Vt[y.key], Z = it[W];
    if (Z instanceof Qs) j("q"), j(pf(Q)), Z.gState && c.setGState(Z.gState), j(y.matrix.toString() + " cm"), j("/" + W + " sh"), j("Q");
    else if (Z instanceof Ba) {
      var ce = new vt(1, 0, 0, -1, 0, ea());
      y.matrix && (ce = ce.multiply(y.matrix || xn), W = df.call(Z, y.key, y.boundingBox, y.xStep, y.yStep, ce).id), j("q"), j("/Pattern cs"), j("/" + W + " scn"), Z.gState && c.setGState(Z.gState), j(Q), j("Q");
    }
  }, pf = function(y) {
    switch (y) {
      case "f":
      case "F":
      case "n":
        return "W n";
      case "f*":
        return "W* n";
      case "B":
      case "S":
        return "W S";
      case "B*":
        return "W* S";
    }
  }, ko = c.moveTo = function(y, Q) {
    return j(O(D(y)) + " " + O(R(Q)) + " m"), this;
  }, Ou = c.lineTo = function(y, Q) {
    return j(O(D(y)) + " " + O(R(Q)) + " l"), this;
  }, jn = c.curveTo = function(y, Q, W, Z, ce, Be) {
    return j([O(D(y)), O(R(Q)), O(D(W)), O(R(Z)), O(D(ce)), O(R(Be)), "c"].join(" ")), this;
  };
  c.__private__.line = c.line = function(y, Q, W, Z, ce) {
    if (isNaN(y) || isNaN(Q) || isNaN(W) || isNaN(Z) || !ci(ce)) throw new Error("Invalid arguments passed to jsPDF.line");
    return C === B ? this.lines([[W - y, Z - Q]], y, Q, [1, 1], ce || "S") : this.lines([[W - y, Z - Q]], y, Q, [1, 1]).stroke();
  }, c.__private__.lines = c.lines = function(y, Q, W, Z, ce, Be) {
    var Fe, At, ct, St, It, Ht, Fr, $r, hr, aA, Zr, wA;
    if (typeof y == "number" && (wA = W, W = Q, Q = y, y = wA), Z = Z || [1, 1], Be = Be || !1, isNaN(Q) || isNaN(W) || !Array.isArray(y) || !Array.isArray(Z) || !ci(ce) || typeof Be != "boolean") throw new Error("Invalid arguments passed to jsPDF.lines");
    for (ko(Q, W), Fe = Z[0], At = Z[1], St = y.length, aA = Q, Zr = W, ct = 0; ct < St; ct++) (It = y[ct]).length === 2 ? (aA = It[0] * Fe + aA, Zr = It[1] * At + Zr, Ou(aA, Zr)) : (Ht = It[0] * Fe + aA, Fr = It[1] * At + Zr, $r = It[2] * Fe + aA, hr = It[3] * At + Zr, aA = It[4] * Fe + aA, Zr = It[5] * At + Zr, jn(Ht, Fr, $r, hr, aA, Zr));
    return Be && Pu(), Ys(ce), this;
  }, c.path = function(y) {
    for (var Q = 0; Q < y.length; Q++) {
      var W = y[Q], Z = W.c;
      switch (W.op) {
        case "m":
          ko(Z[0], Z[1]);
          break;
        case "l":
          Ou(Z[0], Z[1]);
          break;
        case "c":
          jn.apply(this, Z);
          break;
        case "h":
          Pu();
      }
    }
    return this;
  }, c.__private__.rect = c.rect = function(y, Q, W, Z, ce) {
    if (isNaN(y) || isNaN(Q) || isNaN(W) || isNaN(Z) || !ci(ce)) throw new Error("Invalid arguments passed to jsPDF.rect");
    return C === B && (Z = -Z), j([O(D(y)), O(R(Q)), O(D(W)), O(D(Z)), "re"].join(" ")), Ys(ce), this;
  }, c.__private__.triangle = c.triangle = function(y, Q, W, Z, ce, Be, Fe) {
    if (isNaN(y) || isNaN(Q) || isNaN(W) || isNaN(Z) || isNaN(ce) || isNaN(Be) || !ci(Fe)) throw new Error("Invalid arguments passed to jsPDF.triangle");
    return this.lines([[W - y, Z - Q], [ce - W, Be - Z], [y - ce, Q - Be]], y, Q, [1, 1], Fe, !0), this;
  }, c.__private__.roundedRect = c.roundedRect = function(y, Q, W, Z, ce, Be, Fe) {
    if (isNaN(y) || isNaN(Q) || isNaN(W) || isNaN(Z) || isNaN(ce) || isNaN(Be) || !ci(Fe)) throw new Error("Invalid arguments passed to jsPDF.roundedRect");
    var At = 4 / 3 * (Math.SQRT2 - 1);
    return ce = Math.min(ce, 0.5 * W), Be = Math.min(Be, 0.5 * Z), this.lines([[W - 2 * ce, 0], [ce * At, 0, ce, Be - Be * At, ce, Be], [0, Z - 2 * Be], [0, Be * At, -ce * At, Be, -ce, Be], [2 * ce - W, 0], [-ce * At, 0, -ce, -Be * At, -ce, -Be], [0, 2 * Be - Z], [0, -Be * At, ce * At, -Be, ce, -Be]], y + ce, Q, [1, 1], Fe, !0), this;
  }, c.__private__.ellipse = c.ellipse = function(y, Q, W, Z, ce) {
    if (isNaN(y) || isNaN(Q) || isNaN(W) || isNaN(Z) || !ci(ce)) throw new Error("Invalid arguments passed to jsPDF.ellipse");
    var Be = 4 / 3 * (Math.SQRT2 - 1) * W, Fe = 4 / 3 * (Math.SQRT2 - 1) * Z;
    return ko(y + W, Q), jn(y + W, Q - Fe, y + Be, Q - Z, y, Q - Z), jn(y - Be, Q - Z, y - W, Q - Fe, y - W, Q), jn(y - W, Q + Fe, y - Be, Q + Z, y, Q + Z), jn(y + Be, Q + Z, y + W, Q + Fe, y + W, Q), Ys(ce), this;
  }, c.__private__.circle = c.circle = function(y, Q, W, Z) {
    if (isNaN(y) || isNaN(Q) || isNaN(W) || !ci(Z)) throw new Error("Invalid arguments passed to jsPDF.circle");
    return this.ellipse(y, Q, W, W, Z);
  }, c.setFont = function(y, Q, W) {
    return W && (Q = I(Q, W)), Ve = Iu(y, Q, { disableWarning: !1 }), this;
  };
  var mf = c.__private__.getFont = c.getFont = function() {
    return mt[Iu.apply(c, arguments)];
  };
  c.__private__.getFontList = c.getFontList = function() {
    var y, Q, W = {};
    for (y in yt) if (yt.hasOwnProperty(y)) for (Q in W[y] = [], yt[y]) yt[y].hasOwnProperty(Q) && W[y].push(Q);
    return W;
  }, c.addFont = function(y, Q, W, Z, ce) {
    var Be = ["StandardEncoding", "MacRomanEncoding", "Identity-H", "WinAnsiEncoding"];
    return arguments[3] && Be.indexOf(arguments[3]) !== -1 ? ce = arguments[3] : arguments[3] && Be.indexOf(arguments[3]) == -1 && (W = I(W, Z)), kA.call(this, y, Q, W, ce = ce || "Identity-H");
  };
  var Js, Ho = r.lineWidth || 0.200025, vf = c.__private__.getLineWidth = c.getLineWidth = function() {
    return Ho;
  }, xt = c.__private__.setLineWidth = c.setLineWidth = function(y) {
    return Ho = y, j(O(D(y)) + " w"), this;
  };
  c.__private__.setLineDash = ot.API.setLineDash = ot.API.setLineDashPattern = function(y, Q) {
    if (y = y || [], Q = Q || 0, isNaN(Q) || !Array.isArray(y)) throw new Error("Invalid arguments passed to jsPDF.setLineDash");
    return y = y.map(function(W) {
      return O(D(W));
    }).join(" "), Q = O(D(Q)), j("[" + y + "] " + Q + " d"), this;
  };
  var wf = c.__private__.getLineHeight = c.getLineHeight = function() {
    return xe * Js;
  };
  c.__private__.getLineHeight = c.getLineHeight = function() {
    return xe * Js;
  };
  var yf = c.__private__.setLineHeightFactor = c.setLineHeightFactor = function(y) {
    return typeof (y = y || 1.15) == "number" && (Js = y), this;
  }, Bf = c.__private__.getLineHeightFactor = c.getLineHeightFactor = function() {
    return Js;
  };
  yf(r.lineHeight);
  var _i = c.__private__.getHorizontalCoordinate = function(y) {
    return D(y);
  }, Ui = c.__private__.getVerticalCoordinate = function(y) {
    return C === S ? y : Bt[G].mediaBox.topRightY - Bt[G].mediaBox.bottomLeftY - D(y);
  }, bf = c.__private__.getHorizontalCoordinateString = c.getHorizontalCoordinateString = function(y) {
    return O(_i(y));
  }, Cf = c.__private__.getVerticalCoordinateString = c.getVerticalCoordinateString = function(y) {
    return O(Ui(y));
  }, qa = r.strokeColor || "0 G";
  c.__private__.getStrokeColor = c.getDrawColor = function() {
    return on(qa);
  }, c.__private__.setStrokeColor = c.setDrawColor = function(y, Q, W, Z) {
    return qa = JA({ ch1: y, ch2: Q, ch3: W, ch4: Z, pdfColorType: "draw", precision: 2 }), j(qa), this;
  };
  var Do = r.fillColor || "0 g";
  c.__private__.getFillColor = c.getFillColor = function() {
    return on(Do);
  }, c.__private__.setFillColor = c.setFillColor = function(y, Q, W, Z) {
    return Do = JA({ ch1: y, ch2: Q, ch3: W, ch4: Z, pdfColorType: "fill", precision: 2 }), j(Do), this;
  };
  var $s = r.textColor || "0 g", Sf = c.__private__.getTextColor = c.getTextColor = function() {
    return on($s);
  };
  c.__private__.setTextColor = c.setTextColor = function(y, Q, W, Z) {
    return $s = JA({ ch1: y, ch2: Q, ch3: W, ch4: Z, pdfColorType: "text", precision: 3 }), this;
  };
  var Ii = r.charSpace, xf = c.__private__.getCharSpace = c.getCharSpace = function() {
    return parseFloat(Ii || 0);
  };
  c.__private__.setCharSpace = c.setCharSpace = function(y) {
    if (isNaN(y)) throw new Error("Invalid argument passed to jsPDF.setCharSpace");
    return Ii = y, this;
  };
  var Go = 0;
  c.CapJoinStyles = { 0: 0, butt: 0, but: 0, miter: 0, 1: 1, round: 1, rounded: 1, circle: 1, 2: 2, projecting: 2, project: 2, square: 2, bevel: 2 }, c.__private__.setLineCap = c.setLineCap = function(y) {
    var Q = c.CapJoinStyles[y];
    if (Q === void 0) throw new Error("Line cap style of '" + y + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
    return Go = Q, j(Q + " J"), this;
  };
  var Vo = 0;
  c.__private__.setLineJoin = c.setLineJoin = function(y) {
    var Q = c.CapJoinStyles[y];
    if (Q === void 0) throw new Error("Line join style of '" + y + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
    return Vo = Q, j(Q + " j"), this;
  }, c.__private__.setLineMiterLimit = c.__private__.setMiterLimit = c.setLineMiterLimit = c.setMiterLimit = function(y) {
    if (y = y || 0, isNaN(y)) throw new Error("Invalid argument passed to jsPDF.setLineMiterLimit");
    return j(O(D(y)) + " M"), this;
  }, c.GState = Ta, c.setGState = function(y) {
    (y = typeof y == "string" ? lt[wt[y]] : Mu(null, y)).equals(Yt) || (j("/" + y.id + " gs"), Yt = y);
  };
  var Mu = function(y, Q) {
    if (!y || !wt[y]) {
      var W = !1;
      for (var Z in lt) if (lt.hasOwnProperty(Z) && lt[Z].equals(Q)) {
        W = !0;
        break;
      }
      if (W) Q = lt[Z];
      else {
        var ce = "GS" + (Object.keys(lt).length + 1).toString(10);
        lt[ce] = Q, Q.id = ce;
      }
      return y && (wt[y] = Q.id), Kt.publish("addGState", Q), Q;
    }
  };
  c.addGState = function(y, Q) {
    return Mu(y, Q), this;
  }, c.saveGraphicsState = function() {
    return j("q"), Gt.push({ key: Ve, size: xe, color: $s }), this;
  }, c.restoreGraphicsState = function() {
    j("Q");
    var y = Gt.pop();
    return Ve = y.key, xe = y.size, $s = y.color, Yt = null, this;
  }, c.setCurrentTransformationMatrix = function(y) {
    return j(y.toString() + " cm"), this;
  }, c.comment = function(y) {
    return j("#" + y), this;
  };
  var Qi = function(y, Q) {
    var W = y || 0;
    Object.defineProperty(this, "x", { enumerable: !0, get: function() {
      return W;
    }, set: function(Be) {
      isNaN(Be) || (W = parseFloat(Be));
    } });
    var Z = Q || 0;
    Object.defineProperty(this, "y", { enumerable: !0, get: function() {
      return Z;
    }, set: function(Be) {
      isNaN(Be) || (Z = parseFloat(Be));
    } });
    var ce = "pt";
    return Object.defineProperty(this, "type", { enumerable: !0, get: function() {
      return ce;
    }, set: function(Be) {
      ce = Be.toString();
    } }), this;
  }, Ko = function(y, Q, W, Z) {
    Qi.call(this, y, Q), this.type = "rect";
    var ce = W || 0;
    Object.defineProperty(this, "w", { enumerable: !0, get: function() {
      return ce;
    }, set: function(Fe) {
      isNaN(Fe) || (ce = parseFloat(Fe));
    } });
    var Be = Z || 0;
    return Object.defineProperty(this, "h", { enumerable: !0, get: function() {
      return Be;
    }, set: function(Fe) {
      isNaN(Fe) || (Be = parseFloat(Fe));
    } }), this;
  }, za = function() {
    this.page = ut, this.currentPage = G, this.pages = Ee.slice(0), this.pagesContext = Bt.slice(0), this.x = je, this.y = Tt, this.matrix = Et, this.width = qo(G), this.height = ku(G), this.outputDestination = Te, this.id = "", this.objectNumber = -1;
  };
  za.prototype.restore = function() {
    ut = this.page, G = this.currentPage, Bt = this.pagesContext, Ee = this.pages, je = this.x, Tt = this.y, Et = this.matrix, Ru(G, this.width), Li(G, this.height), Te = this.outputDestination;
  };
  var jo = function(y, Q, W, Z, ce) {
    an.push(new za()), ut = G = 0, Ee = [], je = y, Tt = Q, Et = ce, Rr([W, Z]);
  };
  for (var Zs in c.beginFormObject = function(y, Q, W, Z, ce) {
    return jo(y, Q, W, Z, ce), this;
  }, c.endFormObject = function(y) {
    return (function(Q) {
      if (Gn[Q]) an.pop().restore();
      else {
        var W = new za(), Z = "Xo" + (Object.keys(Sr).length + 1).toString(10);
        W.id = Z, Gn[Q] = Z, Sr[Z] = W, Kt.publish("addFormObject", W), an.pop().restore();
      }
    })(y), this;
  }, c.doFormObject = function(y, Q) {
    var W = Sr[Gn[y]];
    return j("q"), j(Q.toString() + " cm"), j("/" + W.id + " Do"), j("Q"), this;
  }, c.getFormObject = function(y) {
    var Q = Sr[Gn[y]];
    return { x: Q.x, y: Q.y, width: Q.width, height: Q.height, matrix: Q.matrix };
  }, c.save = function(y, Q) {
    return y = y || "generated.pdf", (Q = Q || {}).returnPromise = Q.returnPromise || !1, Q.returnPromise === !1 ? (ga(Ka(ui()), y), typeof ga.unload == "function" && Ct.setTimeout && setTimeout(ga.unload, 911), this) : new Promise(function(W, Z) {
      try {
        var ce = ga(Ka(ui()), y);
        typeof ga.unload == "function" && Ct.setTimeout && setTimeout(ga.unload, 911), W(ce);
      } catch (Be) {
        Z(Be.message);
      }
    });
  }, ot.API) ot.API.hasOwnProperty(Zs) && (Zs === "events" && ot.API.events.length ? (function(y, Q) {
    var W, Z, ce;
    for (ce = Q.length - 1; ce !== -1; ce--) W = Q[ce][0], Z = Q[ce][1], y.subscribe.apply(y, [W].concat(typeof Z == "function" ? [Z] : Z));
  })(Kt, ot.API.events) : c[Zs] = ot.API[Zs]);
  function qo(y) {
    return Bt[y].mediaBox.topRightX - Bt[y].mediaBox.bottomLeftX;
  }
  function Ru(y, Q) {
    Bt[y].mediaBox.topRightX = Q + Bt[y].mediaBox.bottomLeftX;
  }
  function ku(y) {
    return Bt[y].mediaBox.topRightY - Bt[y].mediaBox.bottomLeftY;
  }
  function Li(y, Q) {
    Bt[y].mediaBox.topRightY = Q + Bt[y].mediaBox.bottomLeftY;
  }
  var Ni = c.getPageWidth = function(y) {
    return qo(y = y || G) / dt;
  }, Hu = c.setPageWidth = function(y, Q) {
    Ru(y, Q * dt);
  }, ea = c.getPageHeight = function(y) {
    return ku(y = y || G) / dt;
  }, Du = c.setPageHeight = function(y, Q) {
    Li(y, Q * dt);
  };
  return c.internal = { pdfEscape: dA, getStyle: Tu, getFont: mf, getFontSize: ke, getCharSpace: xf, getTextColor: Sf, getLineHeight: wf, getLineHeightFactor: Bf, getLineWidth: vf, write: Pe, getHorizontalCoordinate: _i, getVerticalCoordinate: Ui, getCoordinateString: bf, getVerticalCoordinateString: Cf, collections: {}, newObject: ir, newAdditionalObject: Vn, newObjectDeferred: Or, newObjectDeferredBegin: Xr, getFilters: $A, putStream: RA, events: Kt, scaleFactor: dt, pageSize: { getWidth: function() {
    return Ni(G);
  }, setWidth: function(y) {
    Hu(G, y);
  }, getHeight: function() {
    return ea(G);
  }, setHeight: function(y) {
    Du(G, y);
  } }, encryptionOptions: u, encryption: sA, getEncryptor: function(y) {
    return u !== null ? sA.encryptor(y, 0) : function(Q) {
      return Q;
    };
  }, output: Lu, getNumberOfPages: Uu, get pages() {
    return Ee;
  }, out: j, f2: F, f3: P, getPageInfo: Fi, getPageInfoByObjId: Nu, getCurrentPageInfo: hf, getPDFVersion: g, Point: Qi, Rectangle: Ko, Matrix: vt, hasHotfix: En }, Object.defineProperty(c.internal.pageSize, "width", { get: function() {
    return Ni(G);
  }, set: function(y) {
    Hu(G, y);
  }, enumerable: !0, configurable: !0 }), Object.defineProperty(c.internal.pageSize, "height", { get: function() {
    return ea(G);
  }, set: function(y) {
    Du(G, y);
  }, enumerable: !0, configurable: !0 }), (function(y) {
    for (var Q = 0, W = et.length; Q < W; Q++) {
      var Z = kA.call(this, y[Q][0], y[Q][1], y[Q][2], et[Q][3], !0);
      h === !1 && (f[Z] = !0);
      var ce = y[Q][0].split("-");
      iA({ id: Z, fontName: ce[0], fontStyle: ce[1] || "" });
    }
    Kt.publish("addFonts", { fonts: mt, dictionary: yt });
  }).call(c, et), Ve = "F1", Xs(n, t), Kt.publish("initialized"), c;
}
co.prototype.lsbFirstWord = function(r) {
  return String.fromCharCode(255 & r, r >> 8 & 255, r >> 16 & 255, r >> 24 & 255);
}, co.prototype.toHexString = function(r) {
  return r.split("").map(function(e) {
    return ("0" + (255 & e.charCodeAt(0)).toString(16)).slice(-2);
  }).join("");
}, co.prototype.hexToBytes = function(r) {
  for (var e = [], t = 0; t < r.length; t += 2) e.push(String.fromCharCode(parseInt(r.substr(t, 2), 16)));
  return e.join("");
}, co.prototype.processOwnerPassword = function(r, e) {
  return $0(J0(e).substr(0, 5), r);
}, co.prototype.encryptor = function(r, e) {
  var t = J0(this.encryptionKey + String.fromCharCode(255 & r, r >> 8 & 255, r >> 16 & 255, 255 & e, e >> 8 & 255)).substr(0, 10);
  return function(A) {
    return $0(t, A);
  };
}, Ta.prototype.equals = function(r) {
  var e, t = "id,objectNumber,equals";
  if (!r || jt(r) !== jt(this)) return !1;
  var A = 0;
  for (e in this) if (!(t.indexOf(e) >= 0)) {
    if (this.hasOwnProperty(e) && !r.hasOwnProperty(e) || this[e] !== r[e]) return !1;
    A++;
  }
  for (e in r) r.hasOwnProperty(e) && t.indexOf(e) < 0 && A--;
  return A === 0;
}, ot.API = { events: [] }, ot.version = "3.0.4";
var Qr = ot.API, sv = 1, Ra = function(r) {
  return r.replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
}, to = function(r) {
  return r.replace(/\\\\/g, "\\").replace(/\\\(/g, "(").replace(/\\\)/g, ")");
}, Ft = function(r) {
  return r.toFixed(2);
}, xs = function(r) {
  return r.toFixed(5);
};
Qr.__acroform__ = {};
var nn = function(r, e) {
  r.prototype = Object.create(e.prototype), r.prototype.constructor = r;
}, Ow = function(r) {
  return r * sv;
}, vi = function(r) {
  var e = new T5(), t = tt.internal.getHeight(r) || 0, A = tt.internal.getWidth(r) || 0;
  return e.BBox = [0, 0, Number(Ft(A)), Number(Ft(t))], e;
}, TQ = Qr.__acroform__.setBit = function(r, e) {
  if (r = r || 0, e = e || 0, isNaN(r) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBit");
  return r | 1 << e;
}, PQ = Qr.__acroform__.clearBit = function(r, e) {
  if (r = r || 0, e = e || 0, isNaN(r) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBit");
  return r & ~(1 << e);
}, OQ = Qr.__acroform__.getBit = function(r, e) {
  if (isNaN(r) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBit");
  return r & 1 << e ? 1 : 0;
}, jr = Qr.__acroform__.getBitForPdf = function(r, e) {
  if (isNaN(r) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBitForPdf");
  return OQ(r, e - 1);
}, qr = Qr.__acroform__.setBitForPdf = function(r, e) {
  if (isNaN(r) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBitForPdf");
  return TQ(r, e - 1);
}, zr = Qr.__acroform__.clearBitForPdf = function(r, e) {
  if (isNaN(r) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBitForPdf");
  return PQ(r, e - 1);
}, MQ = Qr.__acroform__.calculateCoordinates = function(r, e) {
  var t = e.internal.getHorizontalCoordinate, A = e.internal.getVerticalCoordinate, n = r[0], i = r[1], s = r[2], a = r[3], o = {};
  return o.lowerLeft_X = t(n) || 0, o.lowerLeft_Y = A(i + a) || 0, o.upperRight_X = t(n + s) || 0, o.upperRight_Y = A(i) || 0, [Number(Ft(o.lowerLeft_X)), Number(Ft(o.lowerLeft_Y)), Number(Ft(o.upperRight_X)), Number(Ft(o.upperRight_Y))];
}, RQ = function(r) {
  if (r.appearanceStreamContent) return r.appearanceStreamContent;
  if (r.V || r.DV) {
    var e = [], t = r._V || r.DV, A = Z0(r, t), n = r.scope.internal.getFont(r.fontName, r.fontStyle).id;
    e.push("/Tx BMC"), e.push("q"), e.push("BT"), e.push(r.scope.__private__.encodeColorString(r.color)), e.push("/" + n + " " + Ft(A.fontSize) + " Tf"), e.push("1 0 0 1 0 0 Tm"), e.push(A.text), e.push("ET"), e.push("Q"), e.push("EMC");
    var i = vi(r);
    return i.scope = r.scope, i.stream = e.join(`
`), i;
  }
}, Z0 = function(r, e) {
  var t = r.fontSize === 0 ? r.maxFontSize : r.fontSize, A = { text: "", fontSize: "" }, n = (e = (e = e.substr(0, 1) == "(" ? e.substr(1) : e).substr(e.length - 1) == ")" ? e.substr(0, e.length - 1) : e).split(" ");
  n = r.multiline ? n.map(function(F) {
    return F.split(`
`);
  }) : n.map(function(F) {
    return [F];
  });
  var i = t, s = tt.internal.getHeight(r) || 0;
  s = s < 0 ? -s : s;
  var a = tt.internal.getWidth(r) || 0;
  a = a < 0 ? -a : a;
  var o = function(F, P, D) {
    if (F + 1 < n.length) {
      var R = P + " " + n[F + 1][0];
      return gc(R, r, D).width <= a - 4;
    }
    return !1;
  };
  i++;
  e: for (; i > 0; ) {
    e = "", i--;
    var l, u, h = gc("3", r, i).height, f = r.multiline ? s - i : (s - h) / 2, c = f += 2, p = 0, g = 0, v = 0;
    if (i <= 0) {
      e = `(...) Tj
`, e += "% Width of Text: " + gc(e, r, i = 12).width + ", FieldWidth:" + a + `
`;
      break;
    }
    for (var w = "", B = 0, S = 0; S < n.length; S++) if (n.hasOwnProperty(S)) {
      var C = !1;
      if (n[S].length !== 1 && v !== n[S].length - 1) {
        if ((h + 2) * (B + 2) + 2 > s) continue e;
        w += n[S][v], C = !0, g = S, S--;
      } else {
        w = (w += n[S][v] + " ").substr(w.length - 1) == " " ? w.substr(0, w.length - 1) : w;
        var E = parseInt(S), _ = o(E, w, i), I = S >= n.length - 1;
        if (_ && !I) {
          w += " ", v = 0;
          continue;
        }
        if (_ || I) {
          if (I) g = E;
          else if (r.multiline && (h + 2) * (B + 2) + 2 > s) continue e;
        } else {
          if (!r.multiline || (h + 2) * (B + 2) + 2 > s) continue e;
          g = E;
        }
      }
      for (var O = "", U = p; U <= g; U++) {
        var V = n[U];
        if (r.multiline) {
          if (U === g) {
            O += V[v] + " ", v = (v + 1) % V.length;
            continue;
          }
          if (U === p) {
            O += V[V.length - 1] + " ";
            continue;
          }
        }
        O += V[0] + " ";
      }
      switch (O = O.substr(O.length - 1) == " " ? O.substr(0, O.length - 1) : O, u = gc(O, r, i).width, r.textAlign) {
        case "right":
          l = a - u - 2;
          break;
        case "center":
          l = (a - u) / 2;
          break;
        default:
          l = 2;
      }
      e += Ft(l) + " " + Ft(c) + ` Td
`, e += "(" + Ra(O) + `) Tj
`, e += -Ft(l) + ` 0 Td
`, c = -(i + 2), u = 0, p = C ? g : g + 1, B++, w = "";
    }
    break;
  }
  return A.text = e, A.fontSize = i, A;
}, gc = function(r, e, t) {
  var A = e.scope.internal.getFont(e.fontName, e.fontStyle), n = e.scope.getStringUnitWidth(r, { font: A, fontSize: parseFloat(t), charSpace: 0 }) * parseFloat(t);
  return { height: e.scope.getStringUnitWidth("3", { font: A, fontSize: parseFloat(t), charSpace: 0 }) * parseFloat(t) * 1.5, width: n };
}, kQ = { fields: [], xForms: [], acroFormDictionaryRoot: null, printedOut: !1, internal: null, isInitialized: !1 }, HQ = function(r, e) {
  var t = { type: "reference", object: r };
  e.internal.getPageInfo(r.page).pageContext.annotations.find(function(A) {
    return A.type === t.type && A.object === t.object;
  }) === void 0 && e.internal.getPageInfo(r.page).pageContext.annotations.push(t);
}, DQ = function(r, e) {
  if (e.scope = r, r.internal !== void 0 && (r.internal.acroformPlugin === void 0 || r.internal.acroformPlugin.isInitialized === !1)) {
    if (Ai.FieldNum = 0, r.internal.acroformPlugin = JSON.parse(JSON.stringify(kQ)), r.internal.acroformPlugin.acroFormDictionaryRoot) throw new Error("Exception while creating AcroformDictionary");
    sv = r.internal.scaleFactor, r.internal.acroformPlugin.acroFormDictionaryRoot = new P5(), r.internal.acroformPlugin.acroFormDictionaryRoot.scope = r, r.internal.acroformPlugin.acroFormDictionaryRoot._eventID = r.internal.events.subscribe("postPutResources", function() {
      (function(t) {
        t.internal.events.unsubscribe(t.internal.acroformPlugin.acroFormDictionaryRoot._eventID), delete t.internal.acroformPlugin.acroFormDictionaryRoot._eventID, t.internal.acroformPlugin.printedOut = !0;
      })(r);
    }), r.internal.events.subscribe("buildDocument", function() {
      (function(t) {
        t.internal.acroformPlugin.acroFormDictionaryRoot.objId = void 0;
        var A = t.internal.acroformPlugin.acroFormDictionaryRoot.Fields;
        for (var n in A) if (A.hasOwnProperty(n)) {
          var i = A[n];
          i.objId = void 0, i.hasAnnotation && HQ(i, t);
        }
      })(r);
    }), r.internal.events.subscribe("putCatalog", function() {
      (function(t) {
        if (t.internal.acroformPlugin.acroFormDictionaryRoot === void 0) throw new Error("putCatalogCallback: Root missing.");
        t.internal.write("/AcroForm " + t.internal.acroformPlugin.acroFormDictionaryRoot.objId + " 0 R");
      })(r);
    }), r.internal.events.subscribe("postPutPages", function(t) {
      (function(A, n) {
        var i = !A;
        for (var s in A || (n.internal.newObjectDeferredBegin(n.internal.acroformPlugin.acroFormDictionaryRoot.objId, !0), n.internal.acroformPlugin.acroFormDictionaryRoot.putStream()), A = A || n.internal.acroformPlugin.acroFormDictionaryRoot.Kids) if (A.hasOwnProperty(s)) {
          var a = A[s], o = [], l = a.Rect;
          if (a.Rect && (a.Rect = MQ(a.Rect, n)), n.internal.newObjectDeferredBegin(a.objId, !0), a.DA = tt.createDefaultAppearanceStream(a), jt(a) === "object" && typeof a.getKeyValueListForStream == "function" && (o = a.getKeyValueListForStream()), a.Rect = l, a.hasAppearanceStream && !a.appearanceStreamContent) {
            var u = RQ(a);
            o.push({ key: "AP", value: "<</N " + u + ">>" }), n.internal.acroformPlugin.xForms.push(u);
          }
          if (a.appearanceStreamContent) {
            var h = "";
            for (var f in a.appearanceStreamContent) if (a.appearanceStreamContent.hasOwnProperty(f)) {
              var c = a.appearanceStreamContent[f];
              if (h += "/" + f + " ", h += "<<", Object.keys(c).length >= 1 || Array.isArray(c)) {
                for (var s in c) if (c.hasOwnProperty(s)) {
                  var p = c[s];
                  typeof p == "function" && (p = p.call(n, a)), h += "/" + s + " " + p + " ", n.internal.acroformPlugin.xForms.indexOf(p) >= 0 || n.internal.acroformPlugin.xForms.push(p);
                }
              } else typeof (p = c) == "function" && (p = p.call(n, a)), h += "/" + s + " " + p, n.internal.acroformPlugin.xForms.indexOf(p) >= 0 || n.internal.acroformPlugin.xForms.push(p);
              h += ">>";
            }
            o.push({ key: "AP", value: `<<
` + h + ">>" });
          }
          n.internal.putStream({ additionalKeyValues: o, objectId: a.objId }), n.internal.out("endobj");
        }
        i && (function(g, v) {
          for (var w in g) if (g.hasOwnProperty(w)) {
            var B = w, S = g[w];
            v.internal.newObjectDeferredBegin(S.objId, !0), jt(S) === "object" && typeof S.putStream == "function" && S.putStream(), delete g[B];
          }
        })(n.internal.acroformPlugin.xForms, n);
      })(t, r);
    }), r.internal.acroformPlugin.isInitialized = !0;
  }
}, N5 = Qr.__acroform__.arrayToPdfArray = function(r, e, t) {
  var A = function(s) {
    return s;
  };
  if (Array.isArray(r)) {
    for (var n = "[", i = 0; i < r.length; i++) switch (i !== 0 && (n += " "), jt(r[i])) {
      case "boolean":
      case "number":
      case "object":
        n += r[i].toString();
        break;
      case "string":
        r[i].substr(0, 1) !== "/" ? (e !== void 0 && t && (A = t.internal.getEncryptor(e)), n += "(" + Ra(A(r[i].toString())) + ")") : n += r[i].toString();
    }
    return n + "]";
  }
  throw new Error("Invalid argument passed to jsPDF.__acroform__.arrayToPdfArray");
}, ld = function(r, e, t) {
  var A = function(n) {
    return n;
  };
  return e !== void 0 && t && (A = t.internal.getEncryptor(e)), (r = r || "").toString(), "(" + Ra(A(r)) + ")";
}, yi = function() {
  this._objId = void 0, this._scope = void 0, Object.defineProperty(this, "objId", { get: function() {
    if (this._objId === void 0) {
      if (this.scope === void 0) return;
      this._objId = this.scope.internal.newObjectDeferred();
    }
    return this._objId;
  }, set: function(r) {
    this._objId = r;
  } }), Object.defineProperty(this, "scope", { value: this._scope, writable: !0 });
};
yi.prototype.toString = function() {
  return this.objId + " 0 R";
}, yi.prototype.putStream = function() {
  var r = this.getKeyValueListForStream();
  this.scope.internal.putStream({ data: this.stream, additionalKeyValues: r, objectId: this.objId }), this.scope.internal.out("endobj");
}, yi.prototype.getKeyValueListForStream = function() {
  var r = [], e = Object.getOwnPropertyNames(this).filter(function(i) {
    return i != "content" && i != "appearanceStreamContent" && i != "scope" && i != "objId" && i.substring(0, 1) != "_";
  });
  for (var t in e) if (Object.getOwnPropertyDescriptor(this, e[t]).configurable === !1) {
    var A = e[t], n = this[A];
    n && (Array.isArray(n) ? r.push({ key: A, value: N5(n, this.objId, this.scope) }) : n instanceof yi ? (n.scope = this.scope, r.push({ key: A, value: n.objId + " 0 R" })) : typeof n != "function" && r.push({ key: A, value: n }));
  }
  return r;
};
var T5 = function() {
  yi.call(this), Object.defineProperty(this, "Type", { value: "/XObject", configurable: !1, writable: !0 }), Object.defineProperty(this, "Subtype", { value: "/Form", configurable: !1, writable: !0 }), Object.defineProperty(this, "FormType", { value: 1, configurable: !1, writable: !0 });
  var r, e = [];
  Object.defineProperty(this, "BBox", { configurable: !1, get: function() {
    return e;
  }, set: function(t) {
    e = t;
  } }), Object.defineProperty(this, "Resources", { value: "2 0 R", configurable: !1, writable: !0 }), Object.defineProperty(this, "stream", { enumerable: !1, configurable: !0, set: function(t) {
    r = t.trim();
  }, get: function() {
    return r || null;
  } });
};
nn(T5, yi);
var P5 = function() {
  yi.call(this);
  var r, e = [];
  Object.defineProperty(this, "Kids", { enumerable: !1, configurable: !0, get: function() {
    return e.length > 0 ? e : void 0;
  } }), Object.defineProperty(this, "Fields", { enumerable: !1, configurable: !1, get: function() {
    return e;
  } }), Object.defineProperty(this, "DA", { enumerable: !1, configurable: !1, get: function() {
    if (r) {
      var t = function(A) {
        return A;
      };
      return this.scope && (t = this.scope.internal.getEncryptor(this.objId)), "(" + Ra(t(r)) + ")";
    }
  }, set: function(t) {
    r = t;
  } });
};
nn(P5, yi);
var Ai = function r() {
  yi.call(this);
  var e = 4;
  Object.defineProperty(this, "F", { enumerable: !1, configurable: !1, get: function() {
    return e;
  }, set: function(w) {
    if (isNaN(w)) throw new Error('Invalid value "' + w + '" for attribute F supplied.');
    e = w;
  } }), Object.defineProperty(this, "showWhenPrinted", { enumerable: !0, configurable: !0, get: function() {
    return !!jr(e, 3);
  }, set: function(w) {
    w ? this.F = qr(e, 3) : this.F = zr(e, 3);
  } });
  var t = 0;
  Object.defineProperty(this, "Ff", { enumerable: !1, configurable: !1, get: function() {
    return t;
  }, set: function(w) {
    if (isNaN(w)) throw new Error('Invalid value "' + w + '" for attribute Ff supplied.');
    t = w;
  } });
  var A = [];
  Object.defineProperty(this, "Rect", { enumerable: !1, configurable: !1, get: function() {
    if (A.length !== 0) return A;
  }, set: function(w) {
    A = w !== void 0 ? w : [];
  } }), Object.defineProperty(this, "x", { enumerable: !0, configurable: !0, get: function() {
    return !A || isNaN(A[0]) ? 0 : A[0];
  }, set: function(w) {
    A[0] = w;
  } }), Object.defineProperty(this, "y", { enumerable: !0, configurable: !0, get: function() {
    return !A || isNaN(A[1]) ? 0 : A[1];
  }, set: function(w) {
    A[1] = w;
  } }), Object.defineProperty(this, "width", { enumerable: !0, configurable: !0, get: function() {
    return !A || isNaN(A[2]) ? 0 : A[2];
  }, set: function(w) {
    A[2] = w;
  } }), Object.defineProperty(this, "height", { enumerable: !0, configurable: !0, get: function() {
    return !A || isNaN(A[3]) ? 0 : A[3];
  }, set: function(w) {
    A[3] = w;
  } });
  var n = "";
  Object.defineProperty(this, "FT", { enumerable: !0, configurable: !1, get: function() {
    return n;
  }, set: function(w) {
    switch (w) {
      case "/Btn":
      case "/Tx":
      case "/Ch":
      case "/Sig":
        n = w;
        break;
      default:
        throw new Error('Invalid value "' + w + '" for attribute FT supplied.');
    }
  } });
  var i = null;
  Object.defineProperty(this, "T", { enumerable: !0, configurable: !1, get: function() {
    if (!i || i.length < 1) {
      if (this instanceof ph) return;
      i = "FieldObject" + r.FieldNum++;
    }
    var w = function(B) {
      return B;
    };
    return this.scope && (w = this.scope.internal.getEncryptor(this.objId)), "(" + Ra(w(i)) + ")";
  }, set: function(w) {
    i = w.toString();
  } }), Object.defineProperty(this, "fieldName", { configurable: !0, enumerable: !0, get: function() {
    return i;
  }, set: function(w) {
    i = w;
  } });
  var s = "helvetica";
  Object.defineProperty(this, "fontName", { enumerable: !0, configurable: !0, get: function() {
    return s;
  }, set: function(w) {
    s = w;
  } });
  var a = "normal";
  Object.defineProperty(this, "fontStyle", { enumerable: !0, configurable: !0, get: function() {
    return a;
  }, set: function(w) {
    a = w;
  } });
  var o = 0;
  Object.defineProperty(this, "fontSize", { enumerable: !0, configurable: !0, get: function() {
    return o;
  }, set: function(w) {
    o = w;
  } });
  var l = void 0;
  Object.defineProperty(this, "maxFontSize", { enumerable: !0, configurable: !0, get: function() {
    return l === void 0 ? 50 / sv : l;
  }, set: function(w) {
    l = w;
  } });
  var u = "black";
  Object.defineProperty(this, "color", { enumerable: !0, configurable: !0, get: function() {
    return u;
  }, set: function(w) {
    u = w;
  } });
  var h = "/F1 0 Tf 0 g";
  Object.defineProperty(this, "DA", { enumerable: !0, configurable: !1, get: function() {
    if (!(!h || this instanceof ph || this instanceof xa)) return ld(h, this.objId, this.scope);
  }, set: function(w) {
    w = w.toString(), h = w;
  } });
  var f = null;
  Object.defineProperty(this, "DV", { enumerable: !1, configurable: !1, get: function() {
    if (f) return this instanceof mA == 0 ? ld(f, this.objId, this.scope) : f;
  }, set: function(w) {
    w = w.toString(), f = this instanceof mA == 0 ? w.substr(0, 1) === "(" ? to(w.substr(1, w.length - 2)) : to(w) : w;
  } }), Object.defineProperty(this, "defaultValue", { enumerable: !0, configurable: !0, get: function() {
    return this instanceof mA == 1 ? to(f.substr(1, f.length - 1)) : f;
  }, set: function(w) {
    w = w.toString(), f = this instanceof mA == 1 ? "/" + w : w;
  } });
  var c = null;
  Object.defineProperty(this, "_V", { enumerable: !1, configurable: !1, get: function() {
    if (c) return c;
  }, set: function(w) {
    this.V = w;
  } }), Object.defineProperty(this, "V", { enumerable: !1, configurable: !1, get: function() {
    if (c) return this instanceof mA == 0 ? ld(c, this.objId, this.scope) : c;
  }, set: function(w) {
    w = w.toString(), c = this instanceof mA == 0 ? w.substr(0, 1) === "(" ? to(w.substr(1, w.length - 2)) : to(w) : w;
  } }), Object.defineProperty(this, "value", { enumerable: !0, configurable: !0, get: function() {
    return this instanceof mA == 1 ? to(c.substr(1, c.length - 1)) : c;
  }, set: function(w) {
    w = w.toString(), c = this instanceof mA == 1 ? "/" + w : w;
  } }), Object.defineProperty(this, "hasAnnotation", { enumerable: !0, configurable: !0, get: function() {
    return this.Rect;
  } }), Object.defineProperty(this, "Type", { enumerable: !0, configurable: !1, get: function() {
    return this.hasAnnotation ? "/Annot" : null;
  } }), Object.defineProperty(this, "Subtype", { enumerable: !0, configurable: !1, get: function() {
    return this.hasAnnotation ? "/Widget" : null;
  } });
  var p, g = !1;
  Object.defineProperty(this, "hasAppearanceStream", { enumerable: !0, configurable: !0, get: function() {
    return g;
  }, set: function(w) {
    w = !!w, g = w;
  } }), Object.defineProperty(this, "page", { enumerable: !0, configurable: !0, get: function() {
    if (p) return p;
  }, set: function(w) {
    p = w;
  } }), Object.defineProperty(this, "readOnly", { enumerable: !0, configurable: !0, get: function() {
    return !!jr(this.Ff, 1);
  }, set: function(w) {
    w ? this.Ff = qr(this.Ff, 1) : this.Ff = zr(this.Ff, 1);
  } }), Object.defineProperty(this, "required", { enumerable: !0, configurable: !0, get: function() {
    return !!jr(this.Ff, 2);
  }, set: function(w) {
    w ? this.Ff = qr(this.Ff, 2) : this.Ff = zr(this.Ff, 2);
  } }), Object.defineProperty(this, "noExport", { enumerable: !0, configurable: !0, get: function() {
    return !!jr(this.Ff, 3);
  }, set: function(w) {
    w ? this.Ff = qr(this.Ff, 3) : this.Ff = zr(this.Ff, 3);
  } });
  var v = null;
  Object.defineProperty(this, "Q", { enumerable: !0, configurable: !1, get: function() {
    if (v !== null) return v;
  }, set: function(w) {
    if ([0, 1, 2].indexOf(w) === -1) throw new Error('Invalid value "' + w + '" for attribute Q supplied.');
    v = w;
  } }), Object.defineProperty(this, "textAlign", { get: function() {
    var w;
    switch (v) {
      case 0:
      default:
        w = "left";
        break;
      case 1:
        w = "center";
        break;
      case 2:
        w = "right";
    }
    return w;
  }, configurable: !0, enumerable: !0, set: function(w) {
    switch (w) {
      case "right":
      case 2:
        v = 2;
        break;
      case "center":
      case 1:
        v = 1;
        break;
      default:
        v = 0;
    }
  } });
};
nn(Ai, yi);
var Bo = function() {
  Ai.call(this), this.FT = "/Ch", this.V = "()", this.fontName = "zapfdingbats";
  var r = 0;
  Object.defineProperty(this, "TI", { enumerable: !0, configurable: !1, get: function() {
    return r;
  }, set: function(t) {
    r = t;
  } }), Object.defineProperty(this, "topIndex", { enumerable: !0, configurable: !0, get: function() {
    return r;
  }, set: function(t) {
    r = t;
  } });
  var e = [];
  Object.defineProperty(this, "Opt", { enumerable: !0, configurable: !1, get: function() {
    return N5(e, this.objId, this.scope);
  }, set: function(t) {
    var A, n;
    n = [], typeof (A = t) == "string" && (n = (function(i, s, a) {
      a || (a = 1);
      for (var o, l = []; o = s.exec(i); ) l.push(o[a]);
      return l;
    })(A, /\((.*?)\)/g)), e = n;
  } }), this.getOptions = function() {
    return e;
  }, this.setOptions = function(t) {
    e = t, this.sort && e.sort();
  }, this.addOption = function(t) {
    t = (t = t || "").toString(), e.push(t), this.sort && e.sort();
  }, this.removeOption = function(t, A) {
    for (A = A || !1, t = (t = t || "").toString(); e.indexOf(t) !== -1 && (e.splice(e.indexOf(t), 1), A !== !1); ) ;
  }, Object.defineProperty(this, "combo", { enumerable: !0, configurable: !0, get: function() {
    return !!jr(this.Ff, 18);
  }, set: function(t) {
    t ? this.Ff = qr(this.Ff, 18) : this.Ff = zr(this.Ff, 18);
  } }), Object.defineProperty(this, "edit", { enumerable: !0, configurable: !0, get: function() {
    return !!jr(this.Ff, 19);
  }, set: function(t) {
    this.combo === !0 && (t ? this.Ff = qr(this.Ff, 19) : this.Ff = zr(this.Ff, 19));
  } }), Object.defineProperty(this, "sort", { enumerable: !0, configurable: !0, get: function() {
    return !!jr(this.Ff, 20);
  }, set: function(t) {
    t ? (this.Ff = qr(this.Ff, 20), e.sort()) : this.Ff = zr(this.Ff, 20);
  } }), Object.defineProperty(this, "multiSelect", { enumerable: !0, configurable: !0, get: function() {
    return !!jr(this.Ff, 22);
  }, set: function(t) {
    t ? this.Ff = qr(this.Ff, 22) : this.Ff = zr(this.Ff, 22);
  } }), Object.defineProperty(this, "doNotSpellCheck", { enumerable: !0, configurable: !0, get: function() {
    return !!jr(this.Ff, 23);
  }, set: function(t) {
    t ? this.Ff = qr(this.Ff, 23) : this.Ff = zr(this.Ff, 23);
  } }), Object.defineProperty(this, "commitOnSelChange", { enumerable: !0, configurable: !0, get: function() {
    return !!jr(this.Ff, 27);
  }, set: function(t) {
    t ? this.Ff = qr(this.Ff, 27) : this.Ff = zr(this.Ff, 27);
  } }), this.hasAppearanceStream = !1;
};
nn(Bo, Ai);
var bo = function() {
  Bo.call(this), this.fontName = "helvetica", this.combo = !1;
};
nn(bo, Bo);
var Co = function() {
  bo.call(this), this.combo = !0;
};
nn(Co, bo);
var eh = function() {
  Co.call(this), this.edit = !0;
};
nn(eh, Co);
var mA = function() {
  Ai.call(this), this.FT = "/Btn", Object.defineProperty(this, "noToggleToOff", { enumerable: !0, configurable: !0, get: function() {
    return !!jr(this.Ff, 15);
  }, set: function(t) {
    t ? this.Ff = qr(this.Ff, 15) : this.Ff = zr(this.Ff, 15);
  } }), Object.defineProperty(this, "radio", { enumerable: !0, configurable: !0, get: function() {
    return !!jr(this.Ff, 16);
  }, set: function(t) {
    t ? this.Ff = qr(this.Ff, 16) : this.Ff = zr(this.Ff, 16);
  } }), Object.defineProperty(this, "pushButton", { enumerable: !0, configurable: !0, get: function() {
    return !!jr(this.Ff, 17);
  }, set: function(t) {
    t ? this.Ff = qr(this.Ff, 17) : this.Ff = zr(this.Ff, 17);
  } }), Object.defineProperty(this, "radioIsUnison", { enumerable: !0, configurable: !0, get: function() {
    return !!jr(this.Ff, 26);
  }, set: function(t) {
    t ? this.Ff = qr(this.Ff, 26) : this.Ff = zr(this.Ff, 26);
  } });
  var r, e = {};
  Object.defineProperty(this, "MK", { enumerable: !1, configurable: !1, get: function() {
    var t = function(i) {
      return i;
    };
    if (this.scope && (t = this.scope.internal.getEncryptor(this.objId)), Object.keys(e).length !== 0) {
      var A, n = [];
      for (A in n.push("<<"), e) n.push("/" + A + " (" + Ra(t(e[A])) + ")");
      return n.push(">>"), n.join(`
`);
    }
  }, set: function(t) {
    jt(t) === "object" && (e = t);
  } }), Object.defineProperty(this, "caption", { enumerable: !0, configurable: !0, get: function() {
    return e.CA || "";
  }, set: function(t) {
    typeof t == "string" && (e.CA = t);
  } }), Object.defineProperty(this, "AS", { enumerable: !1, configurable: !1, get: function() {
    return r;
  }, set: function(t) {
    r = t;
  } }), Object.defineProperty(this, "appearanceState", { enumerable: !0, configurable: !0, get: function() {
    return r.substr(1, r.length - 1);
  }, set: function(t) {
    r = "/" + t;
  } });
};
nn(mA, Ai);
var th = function() {
  mA.call(this), this.pushButton = !0;
};
nn(th, mA);
var So = function() {
  mA.call(this), this.radio = !0, this.pushButton = !1;
  var r = [];
  Object.defineProperty(this, "Kids", { enumerable: !0, configurable: !1, get: function() {
    return r;
  }, set: function(e) {
    r = e !== void 0 ? e : [];
  } });
};
nn(So, mA);
var ph = function() {
  var r, e;
  Ai.call(this), Object.defineProperty(this, "Parent", { enumerable: !1, configurable: !1, get: function() {
    return r;
  }, set: function(n) {
    r = n;
  } }), Object.defineProperty(this, "optionName", { enumerable: !1, configurable: !0, get: function() {
    return e;
  }, set: function(n) {
    e = n;
  } });
  var t, A = {};
  Object.defineProperty(this, "MK", { enumerable: !1, configurable: !1, get: function() {
    var n = function(a) {
      return a;
    };
    this.scope && (n = this.scope.internal.getEncryptor(this.objId));
    var i, s = [];
    for (i in s.push("<<"), A) s.push("/" + i + " (" + Ra(n(A[i])) + ")");
    return s.push(">>"), s.join(`
`);
  }, set: function(n) {
    jt(n) === "object" && (A = n);
  } }), Object.defineProperty(this, "caption", { enumerable: !0, configurable: !0, get: function() {
    return A.CA || "";
  }, set: function(n) {
    typeof n == "string" && (A.CA = n);
  } }), Object.defineProperty(this, "AS", { enumerable: !1, configurable: !1, get: function() {
    return t;
  }, set: function(n) {
    t = n;
  } }), Object.defineProperty(this, "appearanceState", { enumerable: !0, configurable: !0, get: function() {
    return t.substr(1, t.length - 1);
  }, set: function(n) {
    t = "/" + n;
  } }), this.caption = "l", this.appearanceState = "Off", this._AppearanceType = tt.RadioButton.Circle, this.appearanceStreamContent = this._AppearanceType.createAppearanceStream(this.optionName);
};
nn(ph, Ai), So.prototype.setAppearance = function(r) {
  if (!("createAppearanceStream" in r) || !("getCA" in r)) throw new Error("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");
  for (var e in this.Kids) if (this.Kids.hasOwnProperty(e)) {
    var t = this.Kids[e];
    t.appearanceStreamContent = r.createAppearanceStream(t.optionName), t.caption = r.getCA();
  }
}, So.prototype.createOption = function(r) {
  var e = new ph();
  return e.Parent = this, e.optionName = r, this.Kids.push(e), GQ.call(this.scope, e), e;
};
var rh = function() {
  mA.call(this), this.fontName = "zapfdingbats", this.caption = "3", this.appearanceState = "On", this.value = "On", this.textAlign = "center", this.appearanceStreamContent = tt.CheckBox.createAppearanceStream();
};
nn(rh, mA);
var xa = function() {
  Ai.call(this), this.FT = "/Tx", Object.defineProperty(this, "multiline", { enumerable: !0, configurable: !0, get: function() {
    return !!jr(this.Ff, 13);
  }, set: function(e) {
    e ? this.Ff = qr(this.Ff, 13) : this.Ff = zr(this.Ff, 13);
  } }), Object.defineProperty(this, "fileSelect", { enumerable: !0, configurable: !0, get: function() {
    return !!jr(this.Ff, 21);
  }, set: function(e) {
    e ? this.Ff = qr(this.Ff, 21) : this.Ff = zr(this.Ff, 21);
  } }), Object.defineProperty(this, "doNotSpellCheck", { enumerable: !0, configurable: !0, get: function() {
    return !!jr(this.Ff, 23);
  }, set: function(e) {
    e ? this.Ff = qr(this.Ff, 23) : this.Ff = zr(this.Ff, 23);
  } }), Object.defineProperty(this, "doNotScroll", { enumerable: !0, configurable: !0, get: function() {
    return !!jr(this.Ff, 24);
  }, set: function(e) {
    e ? this.Ff = qr(this.Ff, 24) : this.Ff = zr(this.Ff, 24);
  } }), Object.defineProperty(this, "comb", { enumerable: !0, configurable: !0, get: function() {
    return !!jr(this.Ff, 25);
  }, set: function(e) {
    e ? this.Ff = qr(this.Ff, 25) : this.Ff = zr(this.Ff, 25);
  } }), Object.defineProperty(this, "richText", { enumerable: !0, configurable: !0, get: function() {
    return !!jr(this.Ff, 26);
  }, set: function(e) {
    e ? this.Ff = qr(this.Ff, 26) : this.Ff = zr(this.Ff, 26);
  } });
  var r = null;
  Object.defineProperty(this, "MaxLen", { enumerable: !0, configurable: !1, get: function() {
    return r;
  }, set: function(e) {
    r = e;
  } }), Object.defineProperty(this, "maxLength", { enumerable: !0, configurable: !0, get: function() {
    return r;
  }, set: function(e) {
    Number.isInteger(e) && (r = e);
  } }), Object.defineProperty(this, "hasAppearanceStream", { enumerable: !0, configurable: !0, get: function() {
    return this.V || this.DV;
  } });
};
nn(xa, Ai);
var Ah = function() {
  xa.call(this), Object.defineProperty(this, "password", { enumerable: !0, configurable: !0, get: function() {
    return !!jr(this.Ff, 14);
  }, set: function(r) {
    r ? this.Ff = qr(this.Ff, 14) : this.Ff = zr(this.Ff, 14);
  } }), this.password = !0;
};
nn(Ah, xa);
var tt = { CheckBox: { createAppearanceStream: function() {
  return { N: { On: tt.CheckBox.YesNormal }, D: { On: tt.CheckBox.YesPushDown, Off: tt.CheckBox.OffPushDown } };
}, YesPushDown: function(r) {
  var e = vi(r);
  e.scope = r.scope;
  var t = [], A = r.scope.internal.getFont(r.fontName, r.fontStyle).id, n = r.scope.__private__.encodeColorString(r.color), i = Z0(r, r.caption);
  return t.push("0.749023 g"), t.push("0 0 " + Ft(tt.internal.getWidth(r)) + " " + Ft(tt.internal.getHeight(r)) + " re"), t.push("f"), t.push("BMC"), t.push("q"), t.push("0 0 1 rg"), t.push("/" + A + " " + Ft(i.fontSize) + " Tf " + n), t.push("BT"), t.push(i.text), t.push("ET"), t.push("Q"), t.push("EMC"), e.stream = t.join(`
`), e;
}, YesNormal: function(r) {
  var e = vi(r);
  e.scope = r.scope;
  var t = r.scope.internal.getFont(r.fontName, r.fontStyle).id, A = r.scope.__private__.encodeColorString(r.color), n = [], i = tt.internal.getHeight(r), s = tt.internal.getWidth(r), a = Z0(r, r.caption);
  return n.push("1 g"), n.push("0 0 " + Ft(s) + " " + Ft(i) + " re"), n.push("f"), n.push("q"), n.push("0 0 1 rg"), n.push("0 0 " + Ft(s - 1) + " " + Ft(i - 1) + " re"), n.push("W"), n.push("n"), n.push("0 g"), n.push("BT"), n.push("/" + t + " " + Ft(a.fontSize) + " Tf " + A), n.push(a.text), n.push("ET"), n.push("Q"), e.stream = n.join(`
`), e;
}, OffPushDown: function(r) {
  var e = vi(r);
  e.scope = r.scope;
  var t = [];
  return t.push("0.749023 g"), t.push("0 0 " + Ft(tt.internal.getWidth(r)) + " " + Ft(tt.internal.getHeight(r)) + " re"), t.push("f"), e.stream = t.join(`
`), e;
} }, RadioButton: { Circle: { createAppearanceStream: function(r) {
  var e = { D: { Off: tt.RadioButton.Circle.OffPushDown }, N: {} };
  return e.N[r] = tt.RadioButton.Circle.YesNormal, e.D[r] = tt.RadioButton.Circle.YesPushDown, e;
}, getCA: function() {
  return "l";
}, YesNormal: function(r) {
  var e = vi(r);
  e.scope = r.scope;
  var t = [], A = tt.internal.getWidth(r) <= tt.internal.getHeight(r) ? tt.internal.getWidth(r) / 4 : tt.internal.getHeight(r) / 4;
  A = Number((0.9 * A).toFixed(5));
  var n = tt.internal.Bezier_C, i = Number((A * n).toFixed(5));
  return t.push("q"), t.push("1 0 0 1 " + xs(tt.internal.getWidth(r) / 2) + " " + xs(tt.internal.getHeight(r) / 2) + " cm"), t.push(A + " 0 m"), t.push(A + " " + i + " " + i + " " + A + " 0 " + A + " c"), t.push("-" + i + " " + A + " -" + A + " " + i + " -" + A + " 0 c"), t.push("-" + A + " -" + i + " -" + i + " -" + A + " 0 -" + A + " c"), t.push(i + " -" + A + " " + A + " -" + i + " " + A + " 0 c"), t.push("f"), t.push("Q"), e.stream = t.join(`
`), e;
}, YesPushDown: function(r) {
  var e = vi(r);
  e.scope = r.scope;
  var t = [], A = tt.internal.getWidth(r) <= tt.internal.getHeight(r) ? tt.internal.getWidth(r) / 4 : tt.internal.getHeight(r) / 4;
  A = Number((0.9 * A).toFixed(5));
  var n = Number((2 * A).toFixed(5)), i = Number((n * tt.internal.Bezier_C).toFixed(5)), s = Number((A * tt.internal.Bezier_C).toFixed(5));
  return t.push("0.749023 g"), t.push("q"), t.push("1 0 0 1 " + xs(tt.internal.getWidth(r) / 2) + " " + xs(tt.internal.getHeight(r) / 2) + " cm"), t.push(n + " 0 m"), t.push(n + " " + i + " " + i + " " + n + " 0 " + n + " c"), t.push("-" + i + " " + n + " -" + n + " " + i + " -" + n + " 0 c"), t.push("-" + n + " -" + i + " -" + i + " -" + n + " 0 -" + n + " c"), t.push(i + " -" + n + " " + n + " -" + i + " " + n + " 0 c"), t.push("f"), t.push("Q"), t.push("0 g"), t.push("q"), t.push("1 0 0 1 " + xs(tt.internal.getWidth(r) / 2) + " " + xs(tt.internal.getHeight(r) / 2) + " cm"), t.push(A + " 0 m"), t.push(A + " " + s + " " + s + " " + A + " 0 " + A + " c"), t.push("-" + s + " " + A + " -" + A + " " + s + " -" + A + " 0 c"), t.push("-" + A + " -" + s + " -" + s + " -" + A + " 0 -" + A + " c"), t.push(s + " -" + A + " " + A + " -" + s + " " + A + " 0 c"), t.push("f"), t.push("Q"), e.stream = t.join(`
`), e;
}, OffPushDown: function(r) {
  var e = vi(r);
  e.scope = r.scope;
  var t = [], A = tt.internal.getWidth(r) <= tt.internal.getHeight(r) ? tt.internal.getWidth(r) / 4 : tt.internal.getHeight(r) / 4;
  A = Number((0.9 * A).toFixed(5));
  var n = Number((2 * A).toFixed(5)), i = Number((n * tt.internal.Bezier_C).toFixed(5));
  return t.push("0.749023 g"), t.push("q"), t.push("1 0 0 1 " + xs(tt.internal.getWidth(r) / 2) + " " + xs(tt.internal.getHeight(r) / 2) + " cm"), t.push(n + " 0 m"), t.push(n + " " + i + " " + i + " " + n + " 0 " + n + " c"), t.push("-" + i + " " + n + " -" + n + " " + i + " -" + n + " 0 c"), t.push("-" + n + " -" + i + " -" + i + " -" + n + " 0 -" + n + " c"), t.push(i + " -" + n + " " + n + " -" + i + " " + n + " 0 c"), t.push("f"), t.push("Q"), e.stream = t.join(`
`), e;
} }, Cross: { createAppearanceStream: function(r) {
  var e = { D: { Off: tt.RadioButton.Cross.OffPushDown }, N: {} };
  return e.N[r] = tt.RadioButton.Cross.YesNormal, e.D[r] = tt.RadioButton.Cross.YesPushDown, e;
}, getCA: function() {
  return "8";
}, YesNormal: function(r) {
  var e = vi(r);
  e.scope = r.scope;
  var t = [], A = tt.internal.calculateCross(r);
  return t.push("q"), t.push("1 1 " + Ft(tt.internal.getWidth(r) - 2) + " " + Ft(tt.internal.getHeight(r) - 2) + " re"), t.push("W"), t.push("n"), t.push(Ft(A.x1.x) + " " + Ft(A.x1.y) + " m"), t.push(Ft(A.x2.x) + " " + Ft(A.x2.y) + " l"), t.push(Ft(A.x4.x) + " " + Ft(A.x4.y) + " m"), t.push(Ft(A.x3.x) + " " + Ft(A.x3.y) + " l"), t.push("s"), t.push("Q"), e.stream = t.join(`
`), e;
}, YesPushDown: function(r) {
  var e = vi(r);
  e.scope = r.scope;
  var t = tt.internal.calculateCross(r), A = [];
  return A.push("0.749023 g"), A.push("0 0 " + Ft(tt.internal.getWidth(r)) + " " + Ft(tt.internal.getHeight(r)) + " re"), A.push("f"), A.push("q"), A.push("1 1 " + Ft(tt.internal.getWidth(r) - 2) + " " + Ft(tt.internal.getHeight(r) - 2) + " re"), A.push("W"), A.push("n"), A.push(Ft(t.x1.x) + " " + Ft(t.x1.y) + " m"), A.push(Ft(t.x2.x) + " " + Ft(t.x2.y) + " l"), A.push(Ft(t.x4.x) + " " + Ft(t.x4.y) + " m"), A.push(Ft(t.x3.x) + " " + Ft(t.x3.y) + " l"), A.push("s"), A.push("Q"), e.stream = A.join(`
`), e;
}, OffPushDown: function(r) {
  var e = vi(r);
  e.scope = r.scope;
  var t = [];
  return t.push("0.749023 g"), t.push("0 0 " + Ft(tt.internal.getWidth(r)) + " " + Ft(tt.internal.getHeight(r)) + " re"), t.push("f"), e.stream = t.join(`
`), e;
} } }, createDefaultAppearanceStream: function(r) {
  var e = r.scope.internal.getFont(r.fontName, r.fontStyle).id, t = r.scope.__private__.encodeColorString(r.color);
  return "/" + e + " " + r.fontSize + " Tf " + t;
} };
tt.internal = { Bezier_C: 0.551915024494, calculateCross: function(r) {
  var e = tt.internal.getWidth(r), t = tt.internal.getHeight(r), A = Math.min(e, t);
  return { x1: { x: (e - A) / 2, y: (t - A) / 2 + A }, x2: { x: (e - A) / 2 + A, y: (t - A) / 2 }, x3: { x: (e - A) / 2, y: (t - A) / 2 }, x4: { x: (e - A) / 2 + A, y: (t - A) / 2 + A } };
} }, tt.internal.getWidth = function(r) {
  var e = 0;
  return jt(r) === "object" && (e = Ow(r.Rect[2])), e;
}, tt.internal.getHeight = function(r) {
  var e = 0;
  return jt(r) === "object" && (e = Ow(r.Rect[3])), e;
};
var GQ = Qr.addField = function(r) {
  if (DQ(this, r), !(r instanceof Ai)) throw new Error("Invalid argument passed to jsPDF.addField.");
  var e;
  return (e = r).scope.internal.acroformPlugin.printedOut && (e.scope.internal.acroformPlugin.printedOut = !1, e.scope.internal.acroformPlugin.acroFormDictionaryRoot = null), e.scope.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(e), r.page = r.scope.internal.getCurrentPageInfo().pageNumber, this;
};
Qr.AcroFormChoiceField = Bo, Qr.AcroFormListBox = bo, Qr.AcroFormComboBox = Co, Qr.AcroFormEditBox = eh, Qr.AcroFormButton = mA, Qr.AcroFormPushButton = th, Qr.AcroFormRadioButton = So, Qr.AcroFormCheckBox = rh, Qr.AcroFormTextField = xa, Qr.AcroFormPasswordField = Ah, Qr.AcroFormAppearance = tt, Qr.AcroForm = { ChoiceField: Bo, ListBox: bo, ComboBox: Co, EditBox: eh, Button: mA, PushButton: th, RadioButton: So, CheckBox: rh, TextField: xa, PasswordField: Ah, Appearance: tt }, ot.AcroForm = { ChoiceField: Bo, ListBox: bo, ComboBox: Co, EditBox: eh, Button: mA, PushButton: th, RadioButton: So, CheckBox: rh, TextField: xa, PasswordField: Ah, Appearance: tt };
ot.AcroForm;
function O5(r) {
  return r.reduce(function(e, t, A) {
    return e[t] = A, e;
  }, {});
}
(function(r) {
  var e = "addImage_";
  r.__addimage__ = {};
  var t = "UNKNOWN", A = { PNG: [[137, 80, 78, 71]], TIFF: [[77, 77, 0, 42], [73, 73, 42, 0]], JPEG: [[255, 216, 255, 224, void 0, void 0, 74, 70, 73, 70, 0], [255, 216, 255, 225, void 0, void 0, 69, 120, 105, 102, 0, 0], [255, 216, 255, 219], [255, 216, 255, 238]], JPEG2000: [[0, 0, 0, 12, 106, 80, 32, 32]], GIF87a: [[71, 73, 70, 56, 55, 97]], GIF89a: [[71, 73, 70, 56, 57, 97]], WEBP: [[82, 73, 70, 70, void 0, void 0, void 0, void 0, 87, 69, 66, 80]], BMP: [[66, 77], [66, 65], [67, 73], [67, 80], [73, 67], [80, 84]] }, n = r.__addimage__.getImageFileTypeByImageData = function(F, P) {
    var D, R, J, ie, te, $ = t;
    if ((P = P || t) === "RGBA" || F.data !== void 0 && F.data instanceof Uint8ClampedArray && "height" in F && "width" in F) return "RGBA";
    if (_(F)) for (te in A) for (J = A[te], D = 0; D < J.length; D += 1) {
      for (ie = !0, R = 0; R < J[D].length; R += 1) if (J[D][R] !== void 0 && J[D][R] !== F[R]) {
        ie = !1;
        break;
      }
      if (ie === !0) {
        $ = te;
        break;
      }
    }
    else for (te in A) for (J = A[te], D = 0; D < J.length; D += 1) {
      for (ie = !0, R = 0; R < J[D].length; R += 1) if (J[D][R] !== void 0 && J[D][R] !== F.charCodeAt(R)) {
        ie = !1;
        break;
      }
      if (ie === !0) {
        $ = te;
        break;
      }
    }
    return $ === t && P !== t && ($ = P), $;
  }, i = function F(P) {
    for (var D = this.internal.write, R = this.internal.putStream, J = (0, this.internal.getFilters)(); J.indexOf("FlateEncode") !== -1; ) J.splice(J.indexOf("FlateEncode"), 1);
    P.objectId = this.internal.newObject();
    var ie = [];
    if (ie.push({ key: "Type", value: "/XObject" }), ie.push({ key: "Subtype", value: "/Image" }), ie.push({ key: "Width", value: P.width }), ie.push({ key: "Height", value: P.height }), P.colorSpace === w.INDEXED ? ie.push({ key: "ColorSpace", value: "[/Indexed /DeviceRGB " + (P.palette.length / 3 - 1) + " " + ("sMask" in P && P.sMask !== void 0 ? P.objectId + 2 : P.objectId + 1) + " 0 R]" }) : (ie.push({ key: "ColorSpace", value: "/" + P.colorSpace }), P.colorSpace === w.DEVICE_CMYK && ie.push({ key: "Decode", value: "[1 0 1 0 1 0 1 0]" })), ie.push({ key: "BitsPerComponent", value: P.bitsPerComponent }), "decodeParameters" in P && P.decodeParameters !== void 0 && ie.push({ key: "DecodeParms", value: "<<" + P.decodeParameters + ">>" }), "transparency" in P && Array.isArray(P.transparency) && P.transparency.length > 0) {
      for (var te = "", $ = 0, re = P.transparency.length; $ < re; $++) te += P.transparency[$] + " " + P.transparency[$] + " ";
      ie.push({ key: "Mask", value: "[" + te + "]" });
    }
    P.sMask !== void 0 && ie.push({ key: "SMask", value: P.objectId + 1 + " 0 R" });
    var ue = P.filter !== void 0 ? ["/" + P.filter] : void 0;
    if (R({ data: P.data, additionalKeyValues: ie, alreadyAppliedFilters: ue, objectId: P.objectId }), D("endobj"), "sMask" in P && P.sMask !== void 0) {
      var se, T = (se = P.sMaskBitsPerComponent) !== null && se !== void 0 ? se : P.bitsPerComponent, G = { width: P.width, height: P.height, colorSpace: "DeviceGray", bitsPerComponent: T, data: P.sMask };
      "filter" in P && (G.decodeParameters = "/Predictor ".concat(P.predictor, " /Colors 1 /BitsPerComponent ").concat(T, " /Columns ").concat(P.width), G.filter = P.filter), F.call(this, G);
    }
    if (P.colorSpace === w.INDEXED) {
      var X = this.internal.newObject();
      R({ data: O(new Uint8Array(P.palette)), objectId: X }), D("endobj");
    }
  }, s = function() {
    var F = this.internal.collections[e + "images"];
    for (var P in F) i.call(this, F[P]);
  }, a = function() {
    var F, P = this.internal.collections[e + "images"], D = this.internal.write;
    for (var R in P) D("/I" + (F = P[R]).index, F.objectId, "0", "R");
  }, o = function() {
    this.internal.collections[e + "images"] || (this.internal.collections[e + "images"] = {}, this.internal.events.subscribe("putResources", s), this.internal.events.subscribe("putXobjectDict", a));
  }, l = function() {
    var F = this.internal.collections[e + "images"];
    return o.call(this), F;
  }, u = function() {
    return Object.keys(this.internal.collections[e + "images"]).length;
  }, h = function(F) {
    return typeof r["process" + F.toUpperCase()] == "function";
  }, f = function(F) {
    return jt(F) === "object" && F.nodeType === 1;
  }, c = function(F, P) {
    if (F.nodeName === "IMG" && F.hasAttribute("src")) {
      var D = "" + F.getAttribute("src");
      if (D.indexOf("data:image/") === 0) return Zc(unescape(D).split("base64,").pop());
      var R = r.loadFile(D, !0);
      if (R !== void 0) return R;
    }
    if (F.nodeName === "CANVAS") {
      if (F.width === 0 || F.height === 0) throw new Error("Given canvas must have data. Canvas width: " + F.width + ", height: " + F.height);
      var J;
      switch (P) {
        case "PNG":
          J = "image/png";
          break;
        case "WEBP":
          J = "image/webp";
          break;
        default:
          J = "image/jpeg";
      }
      return Zc(F.toDataURL(J, 1).split("base64,").pop());
    }
  }, p = function(F) {
    var P = this.internal.collections[e + "images"];
    if (P) {
      for (var D in P) if (F === P[D].alias) return P[D];
    }
  }, g = function(F, P, D) {
    return F || P || (F = -96, P = -96), F < 0 && (F = -1 * D.width * 72 / F / this.internal.scaleFactor), P < 0 && (P = -1 * D.height * 72 / P / this.internal.scaleFactor), F === 0 && (F = P * D.width / D.height), P === 0 && (P = F * D.height / D.width), [F, P];
  }, v = function(F, P, D, R, J, ie) {
    var te = g.call(this, D, R, J), $ = this.internal.getCoordinateString, re = this.internal.getVerticalCoordinateString, ue = l.call(this);
    if (D = te[0], R = te[1], ue[J.index] = J, ie) {
      ie *= Math.PI / 180;
      var se = Math.cos(ie), T = Math.sin(ie), G = function(Y) {
        return Y.toFixed(4);
      }, X = [G(se), G(T), G(-1 * T), G(se), 0, 0, "cm"];
    }
    this.internal.write("q"), ie ? (this.internal.write([1, "0", "0", 1, $(F), re(P + R), "cm"].join(" ")), this.internal.write(X.join(" ")), this.internal.write([$(D), "0", "0", $(R), "0", "0", "cm"].join(" "))) : this.internal.write([$(D), "0", "0", $(R), $(F), re(P + R), "cm"].join(" ")), this.isAdvancedAPI() && this.internal.write([1, 0, 0, -1, 0, 0, "cm"].join(" ")), this.internal.write("/I" + J.index + " Do"), this.internal.write("Q");
  }, w = r.color_spaces = { DEVICE_RGB: "DeviceRGB", DEVICE_GRAY: "DeviceGray", DEVICE_CMYK: "DeviceCMYK", CAL_GREY: "CalGray", CAL_RGB: "CalRGB", LAB: "Lab", ICC_BASED: "ICCBased", INDEXED: "Indexed", PATTERN: "Pattern", SEPARATION: "Separation", DEVICE_N: "DeviceN" };
  r.decode = { DCT_DECODE: "DCTDecode", FLATE_DECODE: "FlateDecode", LZW_DECODE: "LZWDecode", JPX_DECODE: "JPXDecode", JBIG2_DECODE: "JBIG2Decode", ASCII85_DECODE: "ASCII85Decode", ASCII_HEX_DECODE: "ASCIIHexDecode", RUN_LENGTH_DECODE: "RunLengthDecode", CCITT_FAX_DECODE: "CCITTFaxDecode" };
  var B = r.image_compression = { NONE: "NONE", FAST: "FAST", MEDIUM: "MEDIUM", SLOW: "SLOW" }, S = r.__addimage__.sHashCode = function(F) {
    var P, D, R = 0;
    if (typeof F == "string") for (D = F.length, P = 0; P < D; P++) R = (R << 5) - R + F.charCodeAt(P), R |= 0;
    else if (_(F)) for (D = F.byteLength / 2, P = 0; P < D; P++) R = (R << 5) - R + F[P], R |= 0;
    return R;
  }, C = r.__addimage__.validateStringAsBase64 = function(F) {
    (F = F || "").toString().trim();
    var P = !0;
    return F.length === 0 && (P = !1), F.length % 4 != 0 && (P = !1), /^[A-Za-z0-9+/]+$/.test(F.substr(0, F.length - 2)) === !1 && (P = !1), /^[A-Za-z0-9/][A-Za-z0-9+/]|[A-Za-z0-9+/]=|==$/.test(F.substr(-2)) === !1 && (P = !1), P;
  }, E = r.__addimage__.extractImageFromDataUrl = function(F) {
    if (F == null || !(F = F.trim()).startsWith("data:")) return null;
    var P = F.indexOf(",");
    return P < 0 ? null : F.substring(0, P).trim().endsWith("base64") ? F.substring(P + 1) : null;
  };
  r.__addimage__.isArrayBuffer = function(F) {
    return F instanceof ArrayBuffer;
  };
  var _ = r.__addimage__.isArrayBufferView = function(F) {
    return F instanceof Int8Array || F instanceof Uint8Array || F instanceof Uint8ClampedArray || F instanceof Int16Array || F instanceof Uint16Array || F instanceof Int32Array || F instanceof Uint32Array || F instanceof Float32Array || F instanceof Float64Array;
  }, I = r.__addimage__.binaryStringToUint8Array = function(F) {
    for (var P = F.length, D = new Uint8Array(P), R = 0; R < P; R++) D[R] = F.charCodeAt(R);
    return D;
  }, O = r.__addimage__.arrayBufferToBinaryString = function(F) {
    for (var P = "", D = _(F) ? F : new Uint8Array(F), R = 0; R < D.length; R += 8192) P += String.fromCharCode.apply(null, D.subarray(R, R + 8192));
    return P;
  };
  r.addImage = function() {
    var F, P, D, R, J, ie, te, $, re;
    if (typeof arguments[1] == "number" ? (P = t, D = arguments[1], R = arguments[2], J = arguments[3], ie = arguments[4], te = arguments[5], $ = arguments[6], re = arguments[7]) : (P = arguments[1], D = arguments[2], R = arguments[3], J = arguments[4], ie = arguments[5], te = arguments[6], $ = arguments[7], re = arguments[8]), jt(F = arguments[0]) === "object" && !f(F) && "imageData" in F) {
      var ue = F;
      F = ue.imageData, P = ue.format || P || t, D = ue.x || D || 0, R = ue.y || R || 0, J = ue.w || ue.width || J, ie = ue.h || ue.height || ie, te = ue.alias || te, $ = ue.compression || $, re = ue.rotation || ue.angle || re;
    }
    var se = this.internal.getFilters();
    if ($ === void 0 && se.indexOf("FlateEncode") !== -1 && ($ = "SLOW"), isNaN(D) || isNaN(R)) throw new Error("Invalid coordinates passed to jsPDF.addImage");
    o.call(this);
    var T = U.call(this, F, P, te, $);
    return v.call(this, D, R, J, ie, T, re), this;
  };
  var U = function(F, P, D, R) {
    var J, ie, te;
    if (typeof F == "string" && n(F) === t) {
      F = unescape(F);
      var $ = V(F, !1);
      ($ !== "" || ($ = r.loadFile(F, !0)) !== void 0) && (F = $);
    }
    if (f(F) && (F = c(F, P)), P = n(F, P), !h(P)) throw new Error("addImage does not support files of type '" + P + "', please ensure that a plugin for '" + P + "' support is added.");
    if (((te = D) == null || te.length === 0) && (D = (function(re) {
      return typeof re == "string" || _(re) ? S(re) : _(re.data) ? S(re.data) : null;
    })(F)), (J = p.call(this, D)) || (F instanceof Uint8Array || P === "RGBA" || (ie = F, F = I(F)), J = this["process" + P.toUpperCase()](F, u.call(this), D, (function(re) {
      return re && typeof re == "string" && (re = re.toUpperCase()), re in r.image_compression ? re : B.NONE;
    })(R), ie)), !J) throw new Error("An unknown error occurred whilst processing the image.");
    return J;
  }, V = r.__addimage__.convertBase64ToBinaryString = function(F, P) {
    P = typeof P != "boolean" || P;
    var D, R = "";
    if (typeof F == "string") {
      var J;
      D = (J = E(F)) !== null && J !== void 0 ? J : F;
      try {
        R = Zc(D);
      } catch (ie) {
        if (P) throw C(D) ? new Error("atob-Error in jsPDF.convertBase64ToBinaryString " + ie.message) : new Error("Supplied Data is not a valid base64-String jsPDF.convertBase64ToBinaryString ");
      }
    }
    return R;
  };
  r.getImageProperties = function(F) {
    var P, D, R = "";
    if (f(F) && (F = c(F)), typeof F == "string" && n(F) === t && ((R = V(F, !1)) === "" && (R = r.loadFile(F) || ""), F = R), D = n(F), !h(D)) throw new Error("addImage does not support files of type '" + D + "', please ensure that a plugin for '" + D + "' support is added.");
    if (F instanceof Uint8Array || (F = I(F)), !(P = this["process" + D.toUpperCase()](F))) throw new Error("An unknown error occurred whilst processing the image");
    return P.fileType = D, P;
  };
})(ot.API), /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(r) {
  var e = function(t) {
    if (t !== void 0 && t != "") return !0;
  };
  ot.API.events.push(["addPage", function(t) {
    this.internal.getPageInfo(t.pageNumber).pageContext.annotations = [];
  }]), r.events.push(["putPage", function(t) {
    for (var A, n, i, s = this.internal.getCoordinateString, a = this.internal.getVerticalCoordinateString, o = this.internal.getPageInfoByObjId(t.objId), l = t.pageContext.annotations, u = !1, h = 0; h < l.length && !u; h++) switch ((A = l[h]).type) {
      case "link":
        (e(A.options.url) || e(A.options.pageNumber)) && (u = !0);
        break;
      case "reference":
      case "text":
      case "freetext":
        u = !0;
    }
    if (u != 0) {
      this.internal.write("/Annots [");
      for (var f = 0; f < l.length; f++) {
        A = l[f];
        var c = this.internal.pdfEscape, p = this.internal.getEncryptor(t.objId);
        switch (A.type) {
          case "reference":
            this.internal.write(" " + A.object.objId + " 0 R ");
            break;
          case "text":
            var g = this.internal.newAdditionalObject(), v = this.internal.newAdditionalObject(), w = this.internal.getEncryptor(g.objId), B = A.title || "Note";
            i = "<</Type /Annot /Subtype /Text " + (n = "/Rect [" + s(A.bounds.x) + " " + a(A.bounds.y + A.bounds.h) + " " + s(A.bounds.x + A.bounds.w) + " " + a(A.bounds.y) + "] ") + "/Contents (" + c(w(A.contents)) + ")", i += " /Popup " + v.objId + " 0 R", i += " /P " + o.objId + " 0 R", i += " /T (" + c(w(B)) + ") >>", g.content = i;
            var S = g.objId + " 0 R";
            i = "<</Type /Annot /Subtype /Popup " + (n = "/Rect [" + s(A.bounds.x + 30) + " " + a(A.bounds.y + A.bounds.h) + " " + s(A.bounds.x + A.bounds.w + 30) + " " + a(A.bounds.y) + "] ") + " /Parent " + S, A.open && (i += " /Open true"), i += " >>", v.content = i, this.internal.write(g.objId, "0 R", v.objId, "0 R");
            break;
          case "freetext":
            n = "/Rect [" + s(A.bounds.x) + " " + a(A.bounds.y) + " " + s(A.bounds.x + A.bounds.w) + " " + a(A.bounds.y + A.bounds.h) + "] ";
            var C = A.color || "#000000";
            i = "<</Type /Annot /Subtype /FreeText " + n + "/Contents (" + c(p(A.contents)) + ")", i += " /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#" + C + ")", i += " /Border [0 0 0]", i += " >>", this.internal.write(i);
            break;
          case "link":
            if (A.options.name) {
              var E = this.annotations._nameMap[A.options.name];
              A.options.pageNumber = E.page, A.options.top = E.y;
            } else A.options.top || (A.options.top = 0);
            if (n = "/Rect [" + A.finalBounds.x + " " + A.finalBounds.y + " " + A.finalBounds.w + " " + A.finalBounds.h + "] ", i = "", A.options.url) i = "<</Type /Annot /Subtype /Link " + n + "/Border [0 0 0] /A <</S /URI /URI (" + c(p(A.options.url)) + ") >>";
            else if (A.options.pageNumber) switch (i = "<</Type /Annot /Subtype /Link " + n + "/Border [0 0 0] /Dest [" + this.internal.getPageInfo(A.options.pageNumber).objId + " 0 R", A.options.magFactor = A.options.magFactor || "XYZ", A.options.magFactor) {
              case "Fit":
                i += " /Fit]";
                break;
              case "FitH":
                i += " /FitH " + A.options.top + "]";
                break;
              case "FitV":
                A.options.left = A.options.left || 0, i += " /FitV " + A.options.left + "]";
                break;
              default:
                var _ = a(A.options.top);
                A.options.left = A.options.left || 0, A.options.zoom === void 0 && (A.options.zoom = 0), i += " /XYZ " + A.options.left + " " + _ + " " + A.options.zoom + "]";
            }
            i != "" && (i += " >>", this.internal.write(i));
        }
      }
      this.internal.write("]");
    }
  }]), r.createAnnotation = function(t) {
    var A = this.internal.getCurrentPageInfo();
    switch (t.type) {
      case "link":
        this.link(t.bounds.x, t.bounds.y, t.bounds.w, t.bounds.h, t);
        break;
      case "text":
      case "freetext":
        A.pageContext.annotations.push(t);
    }
  }, r.link = function(t, A, n, i, s) {
    var a = this.internal.getCurrentPageInfo(), o = this.internal.getCoordinateString, l = this.internal.getVerticalCoordinateString;
    a.pageContext.annotations.push({ finalBounds: { x: o(t), y: l(A), w: o(t + n), h: l(A + i) }, options: s, type: "link" });
  }, r.textWithLink = function(t, A, n, i) {
    var s, a, o = this.getTextWidth(t), l = this.internal.getLineHeight() / this.internal.scaleFactor;
    if (i.maxWidth !== void 0) {
      a = i.maxWidth;
      var u = this.splitTextToSize(t, a).length;
      s = Math.ceil(l * u);
    } else a = o, s = l;
    return this.text(t, A, n, i), n += 0.2 * l, i.align === "center" && (A -= o / 2), i.align === "right" && (A -= o), this.link(A, n - l, a, s, i), o;
  }, r.getTextWidth = function(t) {
    var A = this.internal.getFontSize();
    return this.getStringUnitWidth(t) * A / this.internal.scaleFactor;
  };
})(ot.API), /**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(r) {
  var e = { 1569: [65152], 1570: [65153, 65154], 1571: [65155, 65156], 1572: [65157, 65158], 1573: [65159, 65160], 1574: [65161, 65162, 65163, 65164], 1575: [65165, 65166], 1576: [65167, 65168, 65169, 65170], 1577: [65171, 65172], 1578: [65173, 65174, 65175, 65176], 1579: [65177, 65178, 65179, 65180], 1580: [65181, 65182, 65183, 65184], 1581: [65185, 65186, 65187, 65188], 1582: [65189, 65190, 65191, 65192], 1583: [65193, 65194], 1584: [65195, 65196], 1585: [65197, 65198], 1586: [65199, 65200], 1587: [65201, 65202, 65203, 65204], 1588: [65205, 65206, 65207, 65208], 1589: [65209, 65210, 65211, 65212], 1590: [65213, 65214, 65215, 65216], 1591: [65217, 65218, 65219, 65220], 1592: [65221, 65222, 65223, 65224], 1593: [65225, 65226, 65227, 65228], 1594: [65229, 65230, 65231, 65232], 1601: [65233, 65234, 65235, 65236], 1602: [65237, 65238, 65239, 65240], 1603: [65241, 65242, 65243, 65244], 1604: [65245, 65246, 65247, 65248], 1605: [65249, 65250, 65251, 65252], 1606: [65253, 65254, 65255, 65256], 1607: [65257, 65258, 65259, 65260], 1608: [65261, 65262], 1609: [65263, 65264, 64488, 64489], 1610: [65265, 65266, 65267, 65268], 1649: [64336, 64337], 1655: [64477], 1657: [64358, 64359, 64360, 64361], 1658: [64350, 64351, 64352, 64353], 1659: [64338, 64339, 64340, 64341], 1662: [64342, 64343, 64344, 64345], 1663: [64354, 64355, 64356, 64357], 1664: [64346, 64347, 64348, 64349], 1667: [64374, 64375, 64376, 64377], 1668: [64370, 64371, 64372, 64373], 1670: [64378, 64379, 64380, 64381], 1671: [64382, 64383, 64384, 64385], 1672: [64392, 64393], 1676: [64388, 64389], 1677: [64386, 64387], 1678: [64390, 64391], 1681: [64396, 64397], 1688: [64394, 64395], 1700: [64362, 64363, 64364, 64365], 1702: [64366, 64367, 64368, 64369], 1705: [64398, 64399, 64400, 64401], 1709: [64467, 64468, 64469, 64470], 1711: [64402, 64403, 64404, 64405], 1713: [64410, 64411, 64412, 64413], 1715: [64406, 64407, 64408, 64409], 1722: [64414, 64415], 1723: [64416, 64417, 64418, 64419], 1726: [64426, 64427, 64428, 64429], 1728: [64420, 64421], 1729: [64422, 64423, 64424, 64425], 1733: [64480, 64481], 1734: [64473, 64474], 1735: [64471, 64472], 1736: [64475, 64476], 1737: [64482, 64483], 1739: [64478, 64479], 1740: [64508, 64509, 64510, 64511], 1744: [64484, 64485, 64486, 64487], 1746: [64430, 64431], 1747: [64432, 64433] }, t = { 65247: { 65154: 65269, 65156: 65271, 65160: 65273, 65166: 65275 }, 65248: { 65154: 65270, 65156: 65272, 65160: 65274, 65166: 65276 }, 65165: { 65247: { 65248: { 65258: 65010 } } }, 1617: { 1612: 64606, 1613: 64607, 1614: 64608, 1615: 64609, 1616: 64610 } }, A = { 1612: 64606, 1613: 64607, 1614: 64608, 1615: 64609, 1616: 64610 }, n = [1570, 1571, 1573, 1575];
  r.__arabicParser__ = {};
  var i = r.__arabicParser__.isInArabicSubstitutionA = function(g) {
    return e[g.charCodeAt(0)] !== void 0;
  }, s = r.__arabicParser__.isArabicLetter = function(g) {
    return typeof g == "string" && /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(g);
  }, a = r.__arabicParser__.isArabicEndLetter = function(g) {
    return s(g) && i(g) && e[g.charCodeAt(0)].length <= 2;
  }, o = r.__arabicParser__.isArabicAlfLetter = function(g) {
    return s(g) && n.indexOf(g.charCodeAt(0)) >= 0;
  };
  r.__arabicParser__.arabicLetterHasIsolatedForm = function(g) {
    return s(g) && i(g) && e[g.charCodeAt(0)].length >= 1;
  };
  var l = r.__arabicParser__.arabicLetterHasFinalForm = function(g) {
    return s(g) && i(g) && e[g.charCodeAt(0)].length >= 2;
  };
  r.__arabicParser__.arabicLetterHasInitialForm = function(g) {
    return s(g) && i(g) && e[g.charCodeAt(0)].length >= 3;
  };
  var u = r.__arabicParser__.arabicLetterHasMedialForm = function(g) {
    return s(g) && i(g) && e[g.charCodeAt(0)].length == 4;
  }, h = r.__arabicParser__.resolveLigatures = function(g) {
    var v = 0, w = t, B = "", S = 0;
    for (v = 0; v < g.length; v += 1) w[g.charCodeAt(v)] !== void 0 ? (S++, typeof (w = w[g.charCodeAt(v)]) == "number" && (B += String.fromCharCode(w), w = t, S = 0), v === g.length - 1 && (w = t, B += g.charAt(v - (S - 1)), v -= S - 1, S = 0)) : (w = t, B += g.charAt(v - S), v -= S, S = 0);
    return B;
  };
  r.__arabicParser__.isArabicDiacritic = function(g) {
    return g !== void 0 && A[g.charCodeAt(0)] !== void 0;
  };
  var f = r.__arabicParser__.getCorrectForm = function(g, v, w) {
    return s(g) ? i(g) === !1 ? -1 : !l(g) || !s(v) && !s(w) || !s(w) && a(v) || a(g) && !s(v) || a(g) && o(v) || a(g) && a(v) ? 0 : u(g) && s(v) && !a(v) && s(w) && l(w) ? 3 : a(g) || !s(w) ? 1 : 2 : -1;
  }, c = function(g) {
    var v = 0, w = 0, B = 0, S = "", C = "", E = "", _ = (g = g || "").split("\\s+"), I = [];
    for (v = 0; v < _.length; v += 1) {
      for (I.push(""), w = 0; w < _[v].length; w += 1) S = _[v][w], C = _[v][w - 1], E = _[v][w + 1], s(S) ? (B = f(S, C, E), I[v] += B !== -1 ? String.fromCharCode(e[S.charCodeAt(0)][B]) : S) : I[v] += S;
      I[v] = h(I[v]);
    }
    return I.join(" ");
  }, p = r.__arabicParser__.processArabic = r.processArabic = function() {
    var g, v = typeof arguments[0] == "string" ? arguments[0] : arguments[0].text, w = [];
    if (Array.isArray(v)) {
      var B = 0;
      for (w = [], B = 0; B < v.length; B += 1) Array.isArray(v[B]) ? w.push([c(v[B][0]), v[B][1], v[B][2]]) : w.push([c(v[B])]);
      g = w;
    } else g = c(v);
    return typeof arguments[0] == "string" ? g : (arguments[0].text = g, arguments[0]);
  };
  r.events.push(["preProcessText", p]);
})(ot.API), ot.API.autoPrint = function(r) {
  var e;
  return (r = r || {}).variant = r.variant || "non-conform", r.variant === "javascript" ? this.addJS("print({});") : (this.internal.events.subscribe("postPutResources", function() {
    e = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /Named"), this.internal.out("/Type /Action"), this.internal.out("/N /Print"), this.internal.out(">>"), this.internal.out("endobj");
  }), this.internal.events.subscribe("putCatalog", function() {
    this.internal.out("/OpenAction " + e + " 0 R");
  })), this;
}, /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(r) {
  var e = function() {
    var t = void 0;
    Object.defineProperty(this, "pdf", { get: function() {
      return t;
    }, set: function(a) {
      t = a;
    } });
    var A = 150;
    Object.defineProperty(this, "width", { get: function() {
      return A;
    }, set: function(a) {
      A = isNaN(a) || Number.isInteger(a) === !1 || a < 0 ? 150 : a, this.getContext("2d").pageWrapXEnabled && (this.getContext("2d").pageWrapX = A + 1);
    } });
    var n = 300;
    Object.defineProperty(this, "height", { get: function() {
      return n;
    }, set: function(a) {
      n = isNaN(a) || Number.isInteger(a) === !1 || a < 0 ? 300 : a, this.getContext("2d").pageWrapYEnabled && (this.getContext("2d").pageWrapY = n + 1);
    } });
    var i = [];
    Object.defineProperty(this, "childNodes", { get: function() {
      return i;
    }, set: function(a) {
      i = a;
    } });
    var s = {};
    Object.defineProperty(this, "style", { get: function() {
      return s;
    }, set: function(a) {
      s = a;
    } }), Object.defineProperty(this, "parentNode", {});
  };
  e.prototype.getContext = function(t, A) {
    var n;
    if ((t = t || "2d") !== "2d") return null;
    for (n in A) this.pdf.context2d.hasOwnProperty(n) && (this.pdf.context2d[n] = A[n]);
    return this.pdf.context2d._canvas = this, this.pdf.context2d;
  }, e.prototype.toDataURL = function() {
    throw new Error("toDataURL is not implemented.");
  }, r.events.push(["initialized", function() {
    this.canvas = new e(), this.canvas.pdf = this;
  }]);
})(ot.API), (function(r) {
  var e = { left: 0, top: 0, bottom: 0, right: 0 }, t = !1, A = function() {
    this.internal.__cell__ === void 0 && (this.internal.__cell__ = {}, this.internal.__cell__.padding = 3, this.internal.__cell__.headerFunction = void 0, this.internal.__cell__.margins = Object.assign({}, e), this.internal.__cell__.margins.width = this.getPageWidth(), n.call(this));
  }, n = function() {
    this.internal.__cell__.lastCell = new i(), this.internal.__cell__.pages = 1;
  }, i = function() {
    var o = arguments[0];
    Object.defineProperty(this, "x", { enumerable: !0, get: function() {
      return o;
    }, set: function(g) {
      o = g;
    } });
    var l = arguments[1];
    Object.defineProperty(this, "y", { enumerable: !0, get: function() {
      return l;
    }, set: function(g) {
      l = g;
    } });
    var u = arguments[2];
    Object.defineProperty(this, "width", { enumerable: !0, get: function() {
      return u;
    }, set: function(g) {
      u = g;
    } });
    var h = arguments[3];
    Object.defineProperty(this, "height", { enumerable: !0, get: function() {
      return h;
    }, set: function(g) {
      h = g;
    } });
    var f = arguments[4];
    Object.defineProperty(this, "text", { enumerable: !0, get: function() {
      return f;
    }, set: function(g) {
      f = g;
    } });
    var c = arguments[5];
    Object.defineProperty(this, "lineNumber", { enumerable: !0, get: function() {
      return c;
    }, set: function(g) {
      c = g;
    } });
    var p = arguments[6];
    return Object.defineProperty(this, "align", { enumerable: !0, get: function() {
      return p;
    }, set: function(g) {
      p = g;
    } }), this;
  };
  i.prototype.clone = function() {
    return new i(this.x, this.y, this.width, this.height, this.text, this.lineNumber, this.align);
  }, i.prototype.toArray = function() {
    return [this.x, this.y, this.width, this.height, this.text, this.lineNumber, this.align];
  }, r.setHeaderFunction = function(o) {
    return A.call(this), this.internal.__cell__.headerFunction = typeof o == "function" ? o : void 0, this;
  }, r.getTextDimensions = function(o, l) {
    A.call(this);
    var u = (l = l || {}).fontSize || this.getFontSize(), h = l.font || this.getFont(), f = l.scaleFactor || this.internal.scaleFactor, c = 0, p = 0, g = 0, v = this;
    if (!Array.isArray(o) && typeof o != "string") {
      if (typeof o != "number") throw new Error("getTextDimensions expects text-parameter to be of type String or type Number or an Array of Strings.");
      o = String(o);
    }
    var w = l.maxWidth;
    w > 0 ? typeof o == "string" ? o = this.splitTextToSize(o, w) : Object.prototype.toString.call(o) === "[object Array]" && (o = o.reduce(function(S, C) {
      return S.concat(v.splitTextToSize(C, w));
    }, [])) : o = Array.isArray(o) ? o : [o];
    for (var B = 0; B < o.length; B++) c < (g = this.getStringUnitWidth(o[B], { font: h }) * u) && (c = g);
    return c !== 0 && (p = o.length), { w: c /= f, h: Math.max((p * u * this.getLineHeightFactor() - u * (this.getLineHeightFactor() - 1)) / f, 0) };
  }, r.cellAddPage = function() {
    A.call(this), this.addPage();
    var o = this.internal.__cell__.margins || e;
    return this.internal.__cell__.lastCell = new i(o.left, o.top, void 0, void 0), this.internal.__cell__.pages += 1, this;
  };
  var s = r.cell = function() {
    var o;
    o = arguments[0] instanceof i ? arguments[0] : new i(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6]), A.call(this);
    var l = this.internal.__cell__.lastCell, u = this.internal.__cell__.padding, h = this.internal.__cell__.margins || e, f = this.internal.__cell__.tableHeaderRow, c = this.internal.__cell__.printHeaders;
    return l.lineNumber !== void 0 && (l.lineNumber === o.lineNumber ? (o.x = (l.x || 0) + (l.width || 0), o.y = l.y || 0) : l.y + l.height + o.height + h.bottom > this.getPageHeight() ? (this.cellAddPage(), o.y = h.top, c && f && (this.printHeaderRow(o.lineNumber, !0), o.y += f[0].height)) : o.y = l.y + l.height || o.y), o.text[0] !== void 0 && (this.rect(o.x, o.y, o.width, o.height, t === !0 ? "FD" : void 0), o.align === "right" ? this.text(o.text, o.x + o.width - u, o.y + u, { align: "right", baseline: "top" }) : o.align === "center" ? this.text(o.text, o.x + o.width / 2, o.y + u, { align: "center", baseline: "top", maxWidth: o.width - u - u }) : this.text(o.text, o.x + u, o.y + u, { align: "left", baseline: "top", maxWidth: o.width - u - u })), this.internal.__cell__.lastCell = o, this;
  };
  r.table = function(o, l, u, h, f) {
    if (A.call(this), !u) throw new Error("No data for PDF table.");
    var c, p, g, v, w = [], B = [], S = [], C = {}, E = {}, _ = [], I = [], O = (f = f || {}).autoSize || !1, U = f.printHeaders !== !1, V = f.css && f.css["font-size"] !== void 0 ? 16 * f.css["font-size"] : f.fontSize || 12, F = f.margins || Object.assign({ width: this.getPageWidth() }, e), P = typeof f.padding == "number" ? f.padding : 3, D = f.headerBackgroundColor || "#c8c8c8", R = f.headerTextColor || "#000";
    if (n.call(this), this.internal.__cell__.printHeaders = U, this.internal.__cell__.margins = F, this.internal.__cell__.table_font_size = V, this.internal.__cell__.padding = P, this.internal.__cell__.headerBackgroundColor = D, this.internal.__cell__.headerTextColor = R, this.setFontSize(V), h == null) B = w = Object.keys(u[0]), S = w.map(function() {
      return "left";
    });
    else if (Array.isArray(h) && jt(h[0]) === "object") for (w = h.map(function(ue) {
      return ue.name;
    }), B = h.map(function(ue) {
      return ue.prompt || ue.name || "";
    }), S = h.map(function(ue) {
      return ue.align || "left";
    }), c = 0; c < h.length; c += 1) E[h[c].name] = 0.7499990551181103 * h[c].width;
    else Array.isArray(h) && typeof h[0] == "string" && (B = w = h, S = w.map(function() {
      return "left";
    }));
    if (O || Array.isArray(h) && typeof h[0] == "string") for (c = 0; c < w.length; c += 1) {
      for (C[v = w[c]] = u.map(function(ue) {
        return ue[v];
      }), this.setFont(void 0, "bold"), _.push(this.getTextDimensions(B[c], { fontSize: this.internal.__cell__.table_font_size, scaleFactor: this.internal.scaleFactor }).w), p = C[v], this.setFont(void 0, "normal"), g = 0; g < p.length; g += 1) _.push(this.getTextDimensions(p[g], { fontSize: this.internal.__cell__.table_font_size, scaleFactor: this.internal.scaleFactor }).w);
      E[v] = Math.max.apply(null, _) + P + P, _ = [];
    }
    if (U) {
      var J = {};
      for (c = 0; c < w.length; c += 1) J[w[c]] = {}, J[w[c]].text = B[c], J[w[c]].align = S[c];
      var ie = a.call(this, J, E);
      I = w.map(function(ue) {
        return new i(o, l, E[ue], ie, J[ue].text, void 0, J[ue].align);
      }), this.setTableHeaderRow(I), this.printHeaderRow(1, !1);
    }
    var te = h.reduce(function(ue, se) {
      return ue[se.name] = se.align, ue;
    }, {});
    for (c = 0; c < u.length; c += 1) {
      "rowStart" in f && f.rowStart instanceof Function && f.rowStart({ row: c, data: u[c] }, this);
      var $ = a.call(this, u[c], E);
      for (g = 0; g < w.length; g += 1) {
        var re = u[c][w[g]];
        "cellStart" in f && f.cellStart instanceof Function && f.cellStart({ row: c, col: g, data: re }, this), s.call(this, new i(o, l, E[w[g]], $, re, c + 2, te[w[g]]));
      }
    }
    return this.internal.__cell__.table_x = o, this.internal.__cell__.table_y = l, this;
  };
  var a = function(o, l) {
    var u = this.internal.__cell__.padding, h = this.internal.__cell__.table_font_size, f = this.internal.scaleFactor;
    return Object.keys(o).map(function(c) {
      var p = o[c];
      return this.splitTextToSize(p.hasOwnProperty("text") ? p.text : p, l[c] - u - u);
    }, this).map(function(c) {
      return this.getLineHeightFactor() * c.length * h / f + u + u;
    }, this).reduce(function(c, p) {
      return Math.max(c, p);
    }, 0);
  };
  r.setTableHeaderRow = function(o) {
    A.call(this), this.internal.__cell__.tableHeaderRow = o;
  }, r.printHeaderRow = function(o, l) {
    if (A.call(this), !this.internal.__cell__.tableHeaderRow) throw new Error("Property tableHeaderRow does not exist.");
    var u;
    if (t = !0, typeof this.internal.__cell__.headerFunction == "function") {
      var h = this.internal.__cell__.headerFunction(this, this.internal.__cell__.pages);
      this.internal.__cell__.lastCell = new i(h[0], h[1], h[2], h[3], void 0, -1);
    }
    this.setFont(void 0, "bold");
    for (var f = [], c = 0; c < this.internal.__cell__.tableHeaderRow.length; c += 1) {
      u = this.internal.__cell__.tableHeaderRow[c].clone(), l && (u.y = this.internal.__cell__.margins.top || 0, f.push(u)), u.lineNumber = o;
      var p = this.getTextColor();
      this.setTextColor(this.internal.__cell__.headerTextColor), this.setFillColor(this.internal.__cell__.headerBackgroundColor), s.call(this, u), this.setTextColor(p);
    }
    f.length > 0 && this.setTableHeaderRow(f), this.setFont(void 0, "normal"), t = !1;
  };
})(ot.API);
var M5 = { italic: ["italic", "oblique", "normal"], oblique: ["oblique", "italic", "normal"], normal: ["normal", "oblique", "italic"] }, R5 = ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded"], em = O5(R5), k5 = [100, 200, 300, 400, 500, 600, 700, 800, 900], VQ = O5(k5);
function ud(r) {
  var e = r.family.replace(/"|'/g, "").toLowerCase(), t = (function(i) {
    return M5[i = i || "normal"] ? i : "normal";
  })(r.style), A = (function(i) {
    return i ? typeof i == "number" ? i >= 100 && i <= 900 && i % 100 == 0 ? i : 400 : /^\d00$/.test(i) ? parseInt(i) : i === "bold" ? 700 : 400 : 400;
  })(r.weight), n = (function(i) {
    return typeof em[i = i || "normal"] == "number" ? i : "normal";
  })(r.stretch);
  return { family: e, style: t, weight: A, stretch: n, src: r.src || [], ref: r.ref || { name: e, style: [n, t, A].join(" ") } };
}
function Mw(r, e, t, A) {
  var n;
  for (n = t; n >= 0 && n < e.length; n += A) if (r[e[n]]) return r[e[n]];
  for (n = t; n >= 0 && n < e.length; n -= A) if (r[e[n]]) return r[e[n]];
}
var KQ = { "sans-serif": "helvetica", fixed: "courier", monospace: "courier", terminal: "courier", cursive: "times", fantasy: "times", serif: "times" }, Rw = { caption: "times", icon: "times", menu: "times", "message-box": "times", "small-caption": "times", "status-bar": "times" };
function kw(r) {
  return [r.stretch, r.style, r.weight, r.family].join(" ");
}
function Hw(r) {
  return r.trimLeft();
}
function jQ(r, e) {
  for (var t = 0; t < r.length; ) {
    if (r.charAt(t) === e) return [r.substring(0, t), r.substring(t + 1)];
    t += 1;
  }
  return null;
}
function qQ(r) {
  var e = r.match(/^(-[a-z_]|[a-z_])[a-z0-9_-]*/i);
  return e === null ? null : [e[0], r.substring(e[0].length)];
}
var pc, Dw, Gw, ro, mc, Vw, Kw, jw, cd = ["times"];
function qw(r, e, t, A, n) {
  var i = 4, s = Ww;
  switch (n) {
    case ot.API.image_compression.FAST:
      i = 1, s = zw;
      break;
    case ot.API.image_compression.MEDIUM:
      i = 6, s = Xw;
      break;
    case ot.API.image_compression.SLOW:
      i = 9, s = Yw;
  }
  r = (function(o, l, u, h) {
    for (var f, c = o.length / l, p = new Uint8Array(o.length + c), g = [zQ, zw, Ww, Xw, Yw], v = 0; v < c; v += 1) {
      var w = v * l, B = o.subarray(w, w + l);
      if (h) p.set(h(B, u, f), w + v);
      else {
        for (var S = g.length, C = [], E = 0; E < S; E += 1) C[E] = g[E](B, u, f);
        var _ = XQ(C.concat());
        p.set(C[_], w + v);
      }
      f = B;
    }
    return p;
  })(r, e, Math.ceil(t * A / 8), s);
  var a = z0(r, { level: i });
  return ot.API.__addimage__.arrayBufferToBinaryString(a);
}
function zQ(r) {
  var e = Array.apply([], r);
  return e.unshift(0), e;
}
function zw(r, e) {
  var t = r.length, A = [];
  A[0] = 1;
  for (var n = 0; n < t; n += 1) {
    var i = r[n - e] || 0;
    A[n + 1] = r[n] - i + 256 & 255;
  }
  return A;
}
function Ww(r, e, t) {
  var A = r.length, n = [];
  n[0] = 2;
  for (var i = 0; i < A; i += 1) {
    var s = t && t[i] || 0;
    n[i + 1] = r[i] - s + 256 & 255;
  }
  return n;
}
function Xw(r, e, t) {
  var A = r.length, n = [];
  n[0] = 3;
  for (var i = 0; i < A; i += 1) {
    var s = r[i - e] || 0, a = t && t[i] || 0;
    n[i + 1] = r[i] + 256 - (s + a >>> 1) & 255;
  }
  return n;
}
function Yw(r, e, t) {
  var A = r.length, n = [];
  n[0] = 4;
  for (var i = 0; i < A; i += 1) {
    var s = WQ(r[i - e] || 0, t && t[i] || 0, t && t[i - e] || 0);
    n[i + 1] = r[i] - s + 256 & 255;
  }
  return n;
}
function WQ(r, e, t) {
  if (r === e && e === t) return r;
  var A = Math.abs(e - t), n = Math.abs(r - t), i = Math.abs(r + e - t - t);
  return A <= n && A <= i ? r : n <= i ? e : t;
}
function XQ(r) {
  var e = r.map(function(t) {
    return t.reduce(function(A, n) {
      return A + Math.abs(n);
    }, 0);
  });
  return e.indexOf(Math.min.apply(null, e));
}
function hd(r, e, t) {
  var A = e * t, n = Math.floor(A / 8), i = 16 - (A - 8 * n + t), s = (1 << t) - 1;
  return H5(r, n) >> i & s;
}
function Jw(r, e, t, A) {
  var n = t * A, i = Math.floor(n / 8), s = 16 - (n - 8 * i + A), a = (1 << A) - 1, o = (e & a) << s;
  (function(l, u, h) {
    if (u + 1 < l.byteLength) l.setUint16(u, h, !1);
    else {
      var f = h >> 8 & 255;
      l.setUint8(u, f);
    }
  })(r, i, H5(r, i) & ~(a << s) & 65535 | o);
}
function H5(r, e) {
  return e + 1 < r.byteLength ? r.getUint16(e, !1) : r.getUint8(e) << 8;
}
function YQ(r) {
  var e = 0;
  if (r[e++] !== 71 || r[e++] !== 73 || r[e++] !== 70 || r[e++] !== 56 || (r[e++] + 1 & 253) != 56 || r[e++] !== 97) throw new Error("Invalid GIF 87a/89a header.");
  var t = r[e++] | r[e++] << 8, A = r[e++] | r[e++] << 8, n = r[e++], i = n >> 7, s = 1 << 1 + (7 & n);
  r[e++], r[e++];
  var a = null, o = null;
  i && (a = e, o = s, e += 3 * s);
  var l = !0, u = [], h = 0, f = null, c = 0, p = null;
  for (this.width = t, this.height = A; l && e < r.length; ) switch (r[e++]) {
    case 33:
      switch (r[e++]) {
        case 255:
          if (r[e] !== 11 || r[e + 1] == 78 && r[e + 2] == 69 && r[e + 3] == 84 && r[e + 4] == 83 && r[e + 5] == 67 && r[e + 6] == 65 && r[e + 7] == 80 && r[e + 8] == 69 && r[e + 9] == 50 && r[e + 10] == 46 && r[e + 11] == 48 && r[e + 12] == 3 && r[e + 13] == 1 && r[e + 16] == 0) e += 14, p = r[e++] | r[e++] << 8, e++;
          else for (e += 12; ; ) {
            if (!((F = r[e++]) >= 0)) throw Error("Invalid block size");
            if (F === 0) break;
            e += F;
          }
          break;
        case 249:
          if (r[e++] !== 4 || r[e + 4] !== 0) throw new Error("Invalid graphics extension block.");
          var g = r[e++];
          h = r[e++] | r[e++] << 8, f = r[e++], 1 & g || (f = null), c = g >> 2 & 7, e++;
          break;
        case 254:
          for (; ; ) {
            if (!((F = r[e++]) >= 0)) throw Error("Invalid block size");
            if (F === 0) break;
            e += F;
          }
          break;
        default:
          throw new Error("Unknown graphic control label: 0x" + r[e - 1].toString(16));
      }
      break;
    case 44:
      var v = r[e++] | r[e++] << 8, w = r[e++] | r[e++] << 8, B = r[e++] | r[e++] << 8, S = r[e++] | r[e++] << 8, C = r[e++], E = C >> 6 & 1, _ = 1 << 1 + (7 & C), I = a, O = o, U = !1;
      C >> 7 && (U = !0, I = e, O = _, e += 3 * _);
      var V = e;
      for (e++; ; ) {
        var F;
        if (!((F = r[e++]) >= 0)) throw Error("Invalid block size");
        if (F === 0) break;
        e += F;
      }
      u.push({ x: v, y: w, width: B, height: S, has_local_palette: U, palette_offset: I, palette_size: O, data_offset: V, data_length: e - V, transparent_index: f, interlaced: !!E, delay: h, disposal: c });
      break;
    case 59:
      l = !1;
      break;
    default:
      throw new Error("Unknown gif block: 0x" + r[e - 1].toString(16));
  }
  this.numFrames = function() {
    return u.length;
  }, this.loopCount = function() {
    return p;
  }, this.frameInfo = function(P) {
    if (P < 0 || P >= u.length) throw new Error("Frame index out of range.");
    return u[P];
  }, this.decodeAndBlitFrameBGRA = function(P, D) {
    var R = this.frameInfo(P), J = R.width * R.height, ie = new Uint8Array(J);
    $w(r, R.data_offset, ie, J);
    var te = R.palette_offset, $ = R.transparent_index;
    $ === null && ($ = 256);
    var re = R.width, ue = t - re, se = re, T = 4 * (R.y * t + R.x), G = 4 * ((R.y + R.height) * t + R.x), X = T, Y = 4 * ue;
    R.interlaced === !0 && (Y += 4 * t * 7);
    for (var ee = 8, oe = 0, ge = ie.length; oe < ge; ++oe) {
      var pe = ie[oe];
      if (se === 0 && (se = re, (X += Y) >= G && (Y = 4 * ue + 4 * t * (ee - 1), X = T + (re + ue) * (ee << 1), ee >>= 1)), pe === $) X += 4;
      else {
        var me = r[te + 3 * pe], Ee = r[te + 3 * pe + 1], Ne = r[te + 3 * pe + 2];
        D[X++] = Ne, D[X++] = Ee, D[X++] = me, D[X++] = 255;
      }
      --se;
    }
  }, this.decodeAndBlitFrameRGBA = function(P, D) {
    var R = this.frameInfo(P), J = R.width * R.height, ie = new Uint8Array(J);
    $w(r, R.data_offset, ie, J);
    var te = R.palette_offset, $ = R.transparent_index;
    $ === null && ($ = 256);
    var re = R.width, ue = t - re, se = re, T = 4 * (R.y * t + R.x), G = 4 * ((R.y + R.height) * t + R.x), X = T, Y = 4 * ue;
    R.interlaced === !0 && (Y += 4 * t * 7);
    for (var ee = 8, oe = 0, ge = ie.length; oe < ge; ++oe) {
      var pe = ie[oe];
      if (se === 0 && (se = re, (X += Y) >= G && (Y = 4 * ue + 4 * t * (ee - 1), X = T + (re + ue) * (ee << 1), ee >>= 1)), pe === $) X += 4;
      else {
        var me = r[te + 3 * pe], Ee = r[te + 3 * pe + 1], Ne = r[te + 3 * pe + 2];
        D[X++] = me, D[X++] = Ee, D[X++] = Ne, D[X++] = 255;
      }
      --se;
    }
  };
}
function $w(r, e, t, A) {
  for (var n = r[e++], i = 1 << n, s = i + 1, a = s + 1, o = n + 1, l = (1 << o) - 1, u = 0, h = 0, f = 0, c = r[e++], p = new Int32Array(4096), g = null; ; ) {
    for (; u < 16 && c !== 0; ) h |= r[e++] << u, u += 8, c === 1 ? c = r[e++] : --c;
    if (u < o) break;
    var v = h & l;
    if (h >>= o, u -= o, v !== i) {
      if (v === s) break;
      for (var w = v < a ? v : g, B = 0, S = w; S > i; ) S = p[S] >> 8, ++B;
      var C = S;
      if (f + B + (w !== v ? 1 : 0) > A) return void or.log("Warning, gif stream longer than expected.");
      t[f++] = C;
      var E = f += B;
      for (w !== v && (t[f++] = C), S = w; B--; ) S = p[S], t[--E] = 255 & S, S >>= 8;
      g !== null && a < 4096 && (p[a++] = g << 8 | C, a >= l + 1 && o < 12 && (++o, l = l << 1 | 1)), g = v;
    } else a = s + 1, l = (1 << (o = n + 1)) - 1, g = null;
  }
  return f !== A && or.log("Warning, gif stream shorter than expected."), t;
}
function fd(r) {
  var e, t, A, n, i, s = Math.floor, a = new Array(64), o = new Array(64), l = new Array(64), u = new Array(64), h = new Array(65535), f = new Array(65535), c = new Array(64), p = new Array(64), g = [], v = 0, w = 7, B = new Array(64), S = new Array(64), C = new Array(64), E = new Array(256), _ = new Array(2048), I = [0, 1, 5, 6, 14, 15, 27, 28, 2, 4, 7, 13, 16, 26, 29, 42, 3, 8, 12, 17, 25, 30, 41, 43, 9, 11, 18, 24, 31, 40, 44, 53, 10, 19, 23, 32, 39, 45, 52, 54, 20, 22, 33, 38, 46, 51, 55, 60, 21, 34, 37, 47, 50, 56, 59, 61, 35, 36, 48, 49, 57, 58, 62, 63], O = [0, 0, 1, 5, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0], U = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], V = [0, 0, 2, 1, 3, 3, 2, 4, 3, 5, 5, 4, 4, 0, 0, 1, 125], F = [1, 2, 3, 0, 4, 17, 5, 18, 33, 49, 65, 6, 19, 81, 97, 7, 34, 113, 20, 50, 129, 145, 161, 8, 35, 66, 177, 193, 21, 82, 209, 240, 36, 51, 98, 114, 130, 9, 10, 22, 23, 24, 25, 26, 37, 38, 39, 40, 41, 42, 52, 53, 54, 55, 56, 57, 58, 67, 68, 69, 70, 71, 72, 73, 74, 83, 84, 85, 86, 87, 88, 89, 90, 99, 100, 101, 102, 103, 104, 105, 106, 115, 116, 117, 118, 119, 120, 121, 122, 131, 132, 133, 134, 135, 136, 137, 138, 146, 147, 148, 149, 150, 151, 152, 153, 154, 162, 163, 164, 165, 166, 167, 168, 169, 170, 178, 179, 180, 181, 182, 183, 184, 185, 186, 194, 195, 196, 197, 198, 199, 200, 201, 202, 210, 211, 212, 213, 214, 215, 216, 217, 218, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250], P = [0, 0, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0], D = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], R = [0, 0, 2, 1, 2, 4, 4, 3, 4, 7, 5, 4, 4, 0, 1, 2, 119], J = [0, 1, 2, 3, 17, 4, 5, 33, 49, 6, 18, 65, 81, 7, 97, 113, 19, 34, 50, 129, 8, 20, 66, 145, 161, 177, 193, 9, 35, 51, 82, 240, 21, 98, 114, 209, 10, 22, 36, 52, 225, 37, 241, 23, 24, 25, 26, 38, 39, 40, 41, 42, 53, 54, 55, 56, 57, 58, 67, 68, 69, 70, 71, 72, 73, 74, 83, 84, 85, 86, 87, 88, 89, 90, 99, 100, 101, 102, 103, 104, 105, 106, 115, 116, 117, 118, 119, 120, 121, 122, 130, 131, 132, 133, 134, 135, 136, 137, 138, 146, 147, 148, 149, 150, 151, 152, 153, 154, 162, 163, 164, 165, 166, 167, 168, 169, 170, 178, 179, 180, 181, 182, 183, 184, 185, 186, 194, 195, 196, 197, 198, 199, 200, 201, 202, 210, 211, 212, 213, 214, 215, 216, 217, 218, 226, 227, 228, 229, 230, 231, 232, 233, 234, 242, 243, 244, 245, 246, 247, 248, 249, 250];
  function ie(T, G) {
    for (var X = 0, Y = 0, ee = new Array(), oe = 1; oe <= 16; oe++) {
      for (var ge = 1; ge <= T[oe]; ge++) ee[G[Y]] = [], ee[G[Y]][0] = X, ee[G[Y]][1] = oe, Y++, X++;
      X *= 2;
    }
    return ee;
  }
  function te(T) {
    for (var G = T[0], X = T[1] - 1; X >= 0; ) G & 1 << X && (v |= 1 << w), X--, --w < 0 && (v == 255 ? ($(255), $(0)) : $(v), w = 7, v = 0);
  }
  function $(T) {
    g.push(T);
  }
  function re(T) {
    $(T >> 8 & 255), $(255 & T);
  }
  function ue(T, G, X, Y, ee) {
    for (var oe, ge = ee[0], pe = ee[240], me = (function(xe, rt) {
      var ke, We, ze, Ce, Oe, Re, Ke, Xe, Ve, dt, je = 0;
      for (Ve = 0; Ve < 8; ++Ve) {
        ke = xe[je], We = xe[je + 1], ze = xe[je + 2], Ce = xe[je + 3], Oe = xe[je + 4], Re = xe[je + 5], Ke = xe[je + 6];
        var Tt = ke + (Xe = xe[je + 7]), Et = ke - Xe, mt = We + Ke, yt = We - Ke, Gt = ze + Re, it = ze - Re, Vt = Ce + Oe, lt = Ce - Oe, wt = Tt + Vt, Yt = Tt - Vt, ut = mt + Gt, Bt = mt - Gt;
        xe[je] = wt + ut, xe[je + 4] = wt - ut;
        var Kt = 0.707106781 * (Bt + Yt);
        xe[je + 2] = Yt + Kt, xe[je + 6] = Yt - Kt;
        var cr = 0.382683433 * ((wt = lt + it) - (Bt = yt + Et)), Sr = 0.5411961 * wt + cr, Gn = 1.306562965 * Bt + cr, an = 0.707106781 * (ut = it + yt), vt = Et + an, Sn = Et - an;
        xe[je + 5] = Sn + Sr, xe[je + 3] = Sn - Sr, xe[je + 1] = vt + Gn, xe[je + 7] = vt - Gn, je += 8;
      }
      for (je = 0, Ve = 0; Ve < 8; ++Ve) {
        ke = xe[je], We = xe[je + 8], ze = xe[je + 16], Ce = xe[je + 24], Oe = xe[je + 32], Re = xe[je + 40], Ke = xe[je + 48];
        var xn = ke + (Xe = xe[je + 56]), YA = ke - Xe, xr = We + Ke, ir = We - Ke, Or = ze + Re, Xr = ze - Re, Vn = Ce + Oe, Kn = Ce - Oe, Mr = xn + Vn, on = xn - Vn, JA = xr + Or, $A = xr - Or;
        xe[je] = Mr + JA, xe[je + 32] = Mr - JA;
        var RA = 0.707106781 * ($A + on);
        xe[je + 16] = on + RA, xe[je + 48] = on - RA;
        var Ei = 0.382683433 * ((Mr = Kn + Xr) - ($A = ir + YA)), $e = 0.5411961 * Mr + Ei, ne = 1.306562965 * $A + Ei, Qe = 0.707106781 * (JA = Xr + ir), Je = YA + Qe, Wt = YA - Qe;
        xe[je + 40] = Wt + $e, xe[je + 24] = Wt - $e, xe[je + 8] = Je + ne, xe[je + 56] = Je - ne, je++;
      }
      for (Ve = 0; Ve < 64; ++Ve) dt = xe[Ve] * rt[Ve], c[Ve] = dt > 0 ? dt + 0.5 | 0 : dt - 0.5 | 0;
      return c;
    })(T, G), Ee = 0; Ee < 64; ++Ee) p[I[Ee]] = me[Ee];
    var Ne = p[0] - X;
    X = p[0], Ne == 0 ? te(Y[0]) : (te(Y[f[oe = 32767 + Ne]]), te(h[oe]));
    for (var Te = 63; Te > 0 && p[Te] == 0; ) Te--;
    if (Te == 0) return te(ge), X;
    for (var Ge, j = 1; j <= Te; ) {
      for (var Pe = j; p[j] == 0 && j <= Te; ) ++j;
      var ft = j - Pe;
      if (ft >= 16) {
        Ge = ft >> 4;
        for (var et = 1; et <= Ge; ++et) te(pe);
        ft &= 15;
      }
      oe = 32767 + p[j], te(ee[(ft << 4) + f[oe]]), te(h[oe]), j++;
    }
    return Te != 63 && te(ge), X;
  }
  function se(T) {
    T = Math.min(Math.max(T, 1), 100), i != T && ((function(G) {
      for (var X = [16, 11, 10, 16, 24, 40, 51, 61, 12, 12, 14, 19, 26, 58, 60, 55, 14, 13, 16, 24, 40, 57, 69, 56, 14, 17, 22, 29, 51, 87, 80, 62, 18, 22, 37, 56, 68, 109, 103, 77, 24, 35, 55, 64, 81, 104, 113, 92, 49, 64, 78, 87, 103, 121, 120, 101, 72, 92, 95, 98, 112, 100, 103, 99], Y = 0; Y < 64; Y++) {
        var ee = s((X[Y] * G + 50) / 100);
        ee = Math.min(Math.max(ee, 1), 255), a[I[Y]] = ee;
      }
      for (var oe = [17, 18, 24, 47, 99, 99, 99, 99, 18, 21, 26, 66, 99, 99, 99, 99, 24, 26, 56, 99, 99, 99, 99, 99, 47, 66, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99], ge = 0; ge < 64; ge++) {
        var pe = s((oe[ge] * G + 50) / 100);
        pe = Math.min(Math.max(pe, 1), 255), o[I[ge]] = pe;
      }
      for (var me = [1, 1.387039845, 1.306562965, 1.175875602, 1, 0.785694958, 0.5411961, 0.275899379], Ee = 0, Ne = 0; Ne < 8; Ne++) for (var Te = 0; Te < 8; Te++) l[Ee] = 1 / (a[I[Ee]] * me[Ne] * me[Te] * 8), u[Ee] = 1 / (o[I[Ee]] * me[Ne] * me[Te] * 8), Ee++;
    })(T < 50 ? Math.floor(5e3 / T) : Math.floor(200 - 2 * T)), i = T);
  }
  this.encode = function(T, G) {
    G && se(G), g = new Array(), v = 0, w = 7, re(65496), re(65504), re(16), $(74), $(70), $(73), $(70), $(0), $(1), $(1), $(0), re(1), re(1), $(0), $(0), (function() {
      re(65499), re(132), $(0);
      for (var We = 0; We < 64; We++) $(a[We]);
      $(1);
      for (var ze = 0; ze < 64; ze++) $(o[ze]);
    })(), (function(We, ze) {
      re(65472), re(17), $(8), re(ze), re(We), $(3), $(1), $(17), $(0), $(2), $(17), $(1), $(3), $(17), $(1);
    })(T.width, T.height), (function() {
      re(65476), re(418), $(0);
      for (var We = 0; We < 16; We++) $(O[We + 1]);
      for (var ze = 0; ze <= 11; ze++) $(U[ze]);
      $(16);
      for (var Ce = 0; Ce < 16; Ce++) $(V[Ce + 1]);
      for (var Oe = 0; Oe <= 161; Oe++) $(F[Oe]);
      $(1);
      for (var Re = 0; Re < 16; Re++) $(P[Re + 1]);
      for (var Ke = 0; Ke <= 11; Ke++) $(D[Ke]);
      $(17);
      for (var Xe = 0; Xe < 16; Xe++) $(R[Xe + 1]);
      for (var Ve = 0; Ve <= 161; Ve++) $(J[Ve]);
    })(), re(65498), re(12), $(3), $(1), $(0), $(2), $(17), $(3), $(17), $(0), $(63), $(0);
    var X = 0, Y = 0, ee = 0;
    v = 0, w = 7, this.encode.displayName = "_encode_";
    for (var oe, ge, pe, me, Ee, Ne, Te, Ge, j, Pe = T.data, ft = T.width, et = T.height, xe = 4 * ft, rt = 0; rt < et; ) {
      for (oe = 0; oe < xe; ) {
        for (Ee = xe * rt + oe, Te = -1, Ge = 0, j = 0; j < 64; j++) Ne = Ee + (Ge = j >> 3) * xe + (Te = 4 * (7 & j)), rt + Ge >= et && (Ne -= xe * (rt + 1 + Ge - et)), oe + Te >= xe && (Ne -= oe + Te - xe + 4), ge = Pe[Ne++], pe = Pe[Ne++], me = Pe[Ne++], B[j] = (_[ge] + _[pe + 256 | 0] + _[me + 512 | 0] >> 16) - 128, S[j] = (_[ge + 768 | 0] + _[pe + 1024 | 0] + _[me + 1280 | 0] >> 16) - 128, C[j] = (_[ge + 1280 | 0] + _[pe + 1536 | 0] + _[me + 1792 | 0] >> 16) - 128;
        X = ue(B, l, X, e, A), Y = ue(S, u, Y, t, n), ee = ue(C, u, ee, t, n), oe += 32;
      }
      rt += 8;
    }
    if (w >= 0) {
      var ke = [];
      ke[1] = w + 1, ke[0] = (1 << w + 1) - 1, te(ke);
    }
    return re(65497), new Uint8Array(g);
  }, r = r || 50, (function() {
    for (var T = String.fromCharCode, G = 0; G < 256; G++) E[G] = T(G);
  })(), e = ie(O, U), t = ie(P, D), A = ie(V, F), n = ie(R, J), (function() {
    for (var T = 1, G = 2, X = 1; X <= 15; X++) {
      for (var Y = T; Y < G; Y++) f[32767 + Y] = X, h[32767 + Y] = [], h[32767 + Y][1] = X, h[32767 + Y][0] = Y;
      for (var ee = -(G - 1); ee <= -T; ee++) f[32767 + ee] = X, h[32767 + ee] = [], h[32767 + ee][1] = X, h[32767 + ee][0] = G - 1 + ee;
      T <<= 1, G <<= 1;
    }
  })(), (function() {
    for (var T = 0; T < 256; T++) _[T] = 19595 * T, _[T + 256 | 0] = 38470 * T, _[T + 512 | 0] = 7471 * T + 32768, _[T + 768 | 0] = -11059 * T, _[T + 1024 | 0] = -21709 * T, _[T + 1280 | 0] = 32768 * T + 8421375, _[T + 1536 | 0] = -27439 * T, _[T + 1792 | 0] = -5329 * T;
  })(), se(r);
}
function Yn(r, e) {
  if (this.pos = 0, this.buffer = r, this.datav = new DataView(r.buffer), this.is_with_alpha = !!e, this.bottom_up = !0, this.flag = String.fromCharCode(this.buffer[0]) + String.fromCharCode(this.buffer[1]), this.pos += 2, ["BM", "BA", "CI", "CP", "IC", "PT"].indexOf(this.flag) === -1) throw new Error("Invalid BMP File");
  this.parseHeader(), this.parseBGR();
}
function Zw(r) {
  function e(U) {
    if (!U) throw Error("assert :P");
  }
  function t(U, V, F) {
    for (var P = 0; 4 > P; P++) if (U[V + P] != F.charCodeAt(P)) return !0;
    return !1;
  }
  function A(U, V, F, P, D) {
    for (var R = 0; R < D; R++) U[V + R] = F[P + R];
  }
  function n(U, V, F, P) {
    for (var D = 0; D < P; D++) U[V + D] = F;
  }
  function i(U) {
    return new Int32Array(U);
  }
  function s(U, V) {
    for (var F = [], P = 0; P < U; P++) F.push(new V());
    return F;
  }
  function a(U, V) {
    var F = [];
    return (function P(D, R, J) {
      for (var ie = J[R], te = 0; te < ie && (D.push(J.length > R + 1 ? [] : new V()), !(J.length < R + 1)); te++) P(D[te], R + 1, J);
    })(F, 0, U), F;
  }
  var o = function() {
    var U = this;
    function V(d, m) {
      for (var b = 1 << m - 1 >>> 0; d & b; ) b >>>= 1;
      return b ? (d & b - 1) + b : d;
    }
    function F(d, m, b, x, L) {
      e(!(x % b));
      do
        d[m + (x -= b)] = L;
      while (0 < x);
    }
    function P(d, m, b, x, L) {
      if (e(2328 >= L), 512 >= L) var M = i(512);
      else if ((M = i(L)) == null) return 0;
      return (function(k, H, K, q, Ae, de) {
        var z, ae, he = H, ve = 1 << K, fe = i(16), ye = i(16);
        for (e(Ae != 0), e(q != null), e(k != null), e(0 < K), ae = 0; ae < Ae; ++ae) {
          if (15 < q[ae]) return 0;
          ++fe[q[ae]];
        }
        if (fe[0] == Ae) return 0;
        for (ye[1] = 0, z = 1; 15 > z; ++z) {
          if (fe[z] > 1 << z) return 0;
          ye[z + 1] = ye[z] + fe[z];
        }
        for (ae = 0; ae < Ae; ++ae) z = q[ae], 0 < q[ae] && (de[ye[z]++] = ae);
        if (ye[15] == 1) return (q = new D()).g = 0, q.value = de[0], F(k, he, 1, ve, q), ve;
        var be, Ie = -1, _e = ve - 1, ht = 0, Ze = 1, Qt = 1, st = 1 << K;
        for (ae = 0, z = 1, Ae = 2; z <= K; ++z, Ae <<= 1) {
          if (Ze += Qt <<= 1, 0 > (Qt -= fe[z])) return 0;
          for (; 0 < fe[z]; --fe[z]) (q = new D()).g = z, q.value = de[ae++], F(k, he + ht, Ae, st, q), ht = V(ht, z);
        }
        for (z = K + 1, Ae = 2; 15 >= z; ++z, Ae <<= 1) {
          if (Ze += Qt <<= 1, 0 > (Qt -= fe[z])) return 0;
          for (; 0 < fe[z]; --fe[z]) {
            if (q = new D(), (ht & _e) != Ie) {
              for (he += st, be = 1 << (Ie = z) - K; 15 > Ie && !(0 >= (be -= fe[Ie])); ) ++Ie, be <<= 1;
              ve += st = 1 << (be = Ie - K), k[H + (Ie = ht & _e)].g = be + K, k[H + Ie].value = he - H - Ie;
            }
            q.g = z - K, q.value = de[ae++], F(k, he + (ht >> K), Ae, st, q), ht = V(ht, z);
          }
        }
        return Ze != 2 * ye[15] - 1 ? 0 : ve;
      })(d, m, b, x, L, M);
    }
    function D() {
      this.value = this.g = 0;
    }
    function R() {
      this.value = this.g = 0;
    }
    function J() {
      this.G = s(5, D), this.H = i(5), this.jc = this.Qb = this.qb = this.nd = 0, this.pd = s(sa, R);
    }
    function ie(d, m, b, x) {
      e(d != null), e(m != null), e(2147483648 > x), d.Ca = 254, d.I = 0, d.b = -8, d.Ka = 0, d.oa = m, d.pa = b, d.Jd = m, d.Yc = b + x, d.Zc = 4 <= x ? b + x - 4 + 1 : b, ge(d);
    }
    function te(d, m) {
      for (var b = 0; 0 < m--; ) b |= me(d, 128) << m;
      return b;
    }
    function $(d, m) {
      var b = te(d, m);
      return pe(d) ? -b : b;
    }
    function re(d, m, b, x) {
      var L, M = 0;
      for (e(d != null), e(m != null), e(4294967288 > x), d.Sb = x, d.Ra = 0, d.u = 0, d.h = 0, 4 < x && (x = 4), L = 0; L < x; ++L) M += m[b + L] << 8 * L;
      d.Ra = M, d.bb = x, d.oa = m, d.pa = b;
    }
    function ue(d) {
      for (; 8 <= d.u && d.bb < d.Sb; ) d.Ra >>>= 8, d.Ra += d.oa[d.pa + d.bb] << hs - 8 >>> 0, ++d.bb, d.u -= 8;
      Y(d) && (d.h = 1, d.u = 0);
    }
    function se(d, m) {
      if (e(0 <= m), !d.h && m <= un) {
        var b = X(d) & ln[m];
        return d.u += m, ue(d), b;
      }
      return d.h = 1, d.u = 0;
    }
    function T() {
      this.b = this.Ca = this.I = 0, this.oa = [], this.pa = 0, this.Jd = [], this.Yc = 0, this.Zc = [], this.Ka = 0;
    }
    function G() {
      this.Ra = 0, this.oa = [], this.h = this.u = this.bb = this.Sb = this.pa = 0;
    }
    function X(d) {
      return d.Ra >>> (d.u & hs - 1) >>> 0;
    }
    function Y(d) {
      return e(d.bb <= d.Sb), d.h || d.bb == d.Sb && d.u > hs;
    }
    function ee(d, m) {
      d.u = m, d.h = Y(d);
    }
    function oe(d) {
      d.u >= Mi && (e(d.u >= Mi), ue(d));
    }
    function ge(d) {
      e(d != null && d.oa != null), d.pa < d.Zc ? (d.I = (d.oa[d.pa++] | d.I << 8) >>> 0, d.b += 8) : (e(d != null && d.oa != null), d.pa < d.Yc ? (d.b += 8, d.I = d.oa[d.pa++] | d.I << 8) : d.Ka ? d.b = 0 : (d.I <<= 8, d.b += 8, d.Ka = 1));
    }
    function pe(d) {
      return te(d, 1);
    }
    function me(d, m) {
      var b = d.Ca;
      0 > d.b && ge(d);
      var x = d.b, L = b * m >>> 8, M = (d.I >>> x > L) + 0;
      for (M ? (b -= L, d.I -= L + 1 << x >>> 0) : b = L + 1, x = b, L = 0; 256 <= x; ) L += 8, x >>= 8;
      return x = 7 ^ L + fs[x], d.b -= x, d.Ca = (b << x) - 1, M;
    }
    function Ee(d, m, b) {
      d[m + 0] = b >> 24 & 255, d[m + 1] = b >> 16 & 255, d[m + 2] = b >> 8 & 255, d[m + 3] = 255 & b;
    }
    function Ne(d, m) {
      return d[m + 0] | d[m + 1] << 8;
    }
    function Te(d, m) {
      return Ne(d, m) | d[m + 2] << 16;
    }
    function Ge(d, m) {
      return Ne(d, m) | Ne(d, m + 2) << 16;
    }
    function j(d, m) {
      var b = 1 << m;
      return e(d != null), e(0 < m), d.X = i(b), d.X == null ? 0 : (d.Mb = 32 - m, d.Xa = m, 1);
    }
    function Pe(d, m) {
      e(d != null), e(m != null), e(d.Xa == m.Xa), A(m.X, 0, d.X, 0, 1 << m.Xa);
    }
    function ft() {
      this.X = [], this.Xa = this.Mb = 0;
    }
    function et(d, m, b, x) {
      e(b != null), e(x != null);
      var L = b[0], M = x[0];
      return L == 0 && (L = (d * M + m / 2) / m), M == 0 && (M = (m * L + d / 2) / d), 0 >= L || 0 >= M ? 0 : (b[0] = L, x[0] = M, 1);
    }
    function xe(d, m) {
      return d + (1 << m) - 1 >>> m;
    }
    function rt(d, m) {
      return ((4278255360 & d) + (4278255360 & m) >>> 0 & 4278255360) + ((16711935 & d) + (16711935 & m) >>> 0 & 16711935) >>> 0;
    }
    function ke(d, m) {
      U[m] = function(b, x, L, M, k, H, K) {
        var q;
        for (q = 0; q < k; ++q) {
          var Ae = U[d](H[K + q - 1], L, M + q);
          H[K + q] = rt(b[x + q], Ae);
        }
      };
    }
    function We() {
      this.ud = this.hd = this.jd = 0;
    }
    function ze(d, m) {
      return ((4278124286 & (d ^ m)) >>> 1) + (d & m) >>> 0;
    }
    function Ce(d) {
      return 0 <= d && 256 > d ? d : 0 > d ? 0 : 255 < d ? 255 : void 0;
    }
    function Oe(d, m) {
      return Ce(d + (d - m + 0.5 >> 1));
    }
    function Re(d, m, b) {
      return Math.abs(m - b) - Math.abs(d - b);
    }
    function Ke(d, m, b, x, L, M, k) {
      for (x = M[k - 1], b = 0; b < L; ++b) M[k + b] = x = rt(d[m + b], x);
    }
    function Xe(d, m, b, x, L) {
      var M;
      for (M = 0; M < b; ++M) {
        var k = d[m + M], H = k >> 8 & 255, K = 16711935 & (K = (K = 16711935 & k) + ((H << 16) + H));
        x[L + M] = (4278255360 & k) + K >>> 0;
      }
    }
    function Ve(d, m) {
      m.jd = 255 & d, m.hd = d >> 8 & 255, m.ud = d >> 16 & 255;
    }
    function dt(d, m, b, x, L, M) {
      var k;
      for (k = 0; k < x; ++k) {
        var H = m[b + k], K = H >>> 8, q = H, Ae = 255 & (Ae = (Ae = H >>> 16) + ((d.jd << 24 >> 24) * (K << 24 >> 24) >>> 5));
        q = 255 & (q = (q += (d.hd << 24 >> 24) * (K << 24 >> 24) >>> 5) + ((d.ud << 24 >> 24) * (Ae << 24 >> 24) >>> 5)), L[M + k] = (4278255360 & H) + (Ae << 16) + q;
      }
    }
    function je(d, m, b, x, L) {
      U[m] = function(M, k, H, K, q, Ae, de, z, ae) {
        for (K = de; K < z; ++K) for (de = 0; de < ae; ++de) q[Ae++] = L(H[x(M[k++])]);
      }, U[d] = function(M, k, H, K, q, Ae, de) {
        var z = 8 >> M.b, ae = M.Ea, he = M.K[0], ve = M.w;
        if (8 > z) for (M = (1 << M.b) - 1, ve = (1 << z) - 1; k < H; ++k) {
          var fe, ye = 0;
          for (fe = 0; fe < ae; ++fe) fe & M || (ye = x(K[q++])), Ae[de++] = L(he[ye & ve]), ye >>= z;
        }
        else U["VP8LMapColor" + b](K, q, he, ve, Ae, de, k, H, ae);
      };
    }
    function Tt(d, m, b, x, L) {
      for (b = m + b; m < b; ) {
        var M = d[m++];
        x[L++] = M >> 16 & 255, x[L++] = M >> 8 & 255, x[L++] = 255 & M;
      }
    }
    function Et(d, m, b, x, L) {
      for (b = m + b; m < b; ) {
        var M = d[m++];
        x[L++] = M >> 16 & 255, x[L++] = M >> 8 & 255, x[L++] = 255 & M, x[L++] = M >> 24 & 255;
      }
    }
    function mt(d, m, b, x, L) {
      for (b = m + b; m < b; ) {
        var M = (k = d[m++]) >> 16 & 240 | k >> 12 & 15, k = 240 & k | k >> 28 & 15;
        x[L++] = M, x[L++] = k;
      }
    }
    function yt(d, m, b, x, L) {
      for (b = m + b; m < b; ) {
        var M = (k = d[m++]) >> 16 & 248 | k >> 13 & 7, k = k >> 5 & 224 | k >> 3 & 31;
        x[L++] = M, x[L++] = k;
      }
    }
    function Gt(d, m, b, x, L) {
      for (b = m + b; m < b; ) {
        var M = d[m++];
        x[L++] = 255 & M, x[L++] = M >> 8 & 255, x[L++] = M >> 16 & 255;
      }
    }
    function it(d, m, b, x, L, M) {
      if (M == 0) for (b = m + b; m < b; ) Ee(x, ((M = d[m++])[0] >> 24 | M[1] >> 8 & 65280 | M[2] << 8 & 16711680 | M[3] << 24) >>> 0), L += 32;
      else A(x, L, d, m, b);
    }
    function Vt(d, m) {
      U[m][0] = U[d + "0"], U[m][1] = U[d + "1"], U[m][2] = U[d + "2"], U[m][3] = U[d + "3"], U[m][4] = U[d + "4"], U[m][5] = U[d + "5"], U[m][6] = U[d + "6"], U[m][7] = U[d + "7"], U[m][8] = U[d + "8"], U[m][9] = U[d + "9"], U[m][10] = U[d + "10"], U[m][11] = U[d + "11"], U[m][12] = U[d + "12"], U[m][13] = U[d + "13"], U[m][14] = U[d + "0"], U[m][15] = U[d + "0"];
    }
    function lt(d) {
      return d == _f || d == Uf || d == Yu || d == If;
    }
    function wt() {
      this.eb = [], this.size = this.A = this.fb = 0;
    }
    function Yt() {
      this.y = [], this.f = [], this.ea = [], this.F = [], this.Tc = this.Ed = this.Cd = this.Fd = this.lb = this.Db = this.Ab = this.fa = this.J = this.W = this.N = this.O = 0;
    }
    function ut() {
      this.Rd = this.height = this.width = this.S = 0, this.f = {}, this.f.RGBA = new wt(), this.f.kb = new Yt(), this.sd = null;
    }
    function Bt() {
      this.width = [0], this.height = [0], this.Pd = [0], this.Qd = [0], this.format = [0];
    }
    function Kt() {
      this.Id = this.fd = this.Md = this.hb = this.ib = this.da = this.bd = this.cd = this.j = this.v = this.Da = this.Sd = this.ob = 0;
    }
    function cr(d) {
      return alert("todo:WebPSamplerProcessPlane"), d.T;
    }
    function Sr(d, m) {
      var b = d.T, x = m.ba.f.RGBA, L = x.eb, M = x.fb + d.ka * x.A, k = In[m.ba.S], H = d.y, K = d.O, q = d.f, Ae = d.N, de = d.ea, z = d.W, ae = m.cc, he = m.dc, ve = m.Mc, fe = m.Nc, ye = d.ka, be = d.ka + d.T, Ie = d.U, _e = Ie + 1 >> 1;
      for (ye == 0 ? k(H, K, null, null, q, Ae, de, z, q, Ae, de, z, L, M, null, null, Ie) : (k(m.ec, m.fc, H, K, ae, he, ve, fe, q, Ae, de, z, L, M - x.A, L, M, Ie), ++b); ye + 2 < be; ye += 2) ae = q, he = Ae, ve = de, fe = z, Ae += d.Rc, z += d.Rc, M += 2 * x.A, k(H, (K += 2 * d.fa) - d.fa, H, K, ae, he, ve, fe, q, Ae, de, z, L, M - x.A, L, M, Ie);
      return K += d.fa, d.j + be < d.o ? (A(m.ec, m.fc, H, K, Ie), A(m.cc, m.dc, q, Ae, _e), A(m.Mc, m.Nc, de, z, _e), b--) : 1 & be || k(H, K, null, null, q, Ae, de, z, q, Ae, de, z, L, M + x.A, null, null, Ie), b;
    }
    function Gn(d, m, b) {
      var x = d.F, L = [d.J];
      if (x != null) {
        var M = d.U, k = m.ba.S, H = k == Xu || k == Yu;
        m = m.ba.f.RGBA;
        var K = [0], q = d.ka;
        K[0] = d.T, d.Kb && (q == 0 ? --K[0] : (--q, L[0] -= d.width), d.j + d.ka + d.T == d.o && (K[0] = d.o - d.j - q));
        var Ae = m.eb;
        q = m.fb + q * m.A, d = A1(x, L[0], d.width, M, K, Ae, q + (H ? 0 : 3), m.A), e(b == K), d && lt(k) && nl(Ae, q, H, M, K, m.A);
      }
      return 0;
    }
    function an(d) {
      var m = d.ma, b = m.ba.S, x = 11 > b, L = b == zu || b == Wu || b == Xu || b == Ff || b == 12 || lt(b);
      if (m.memory = null, m.Ib = null, m.Jb = null, m.Nd = null, !Yo(m.Oa, d, L ? 11 : 12)) return 0;
      if (L && lt(b) && zo(), d.da) alert("todo:use_scaling");
      else {
        if (x) {
          if (m.Ib = cr, d.Kb) {
            if (b = d.U + 1 >> 1, m.memory = i(d.U + 2 * b), m.memory == null) return 0;
            m.ec = m.memory, m.fc = 0, m.cc = m.ec, m.dc = m.fc + d.U, m.Mc = m.cc, m.Nc = m.dc + b, m.Ib = Sr, zo();
          }
        } else alert("todo:EmitYUV");
        L && (m.Jb = Gn, x && qn());
      }
      if (x && !w1) {
        for (d = 0; 256 > d; ++d) i4[d] = 89858 * (d - 128) + $u >> Ju, o4[d] = -22014 * (d - 128) + $u, a4[d] = -45773 * (d - 128), s4[d] = 113618 * (d - 128) + $u >> Ju;
        for (d = sl; d < Nf; ++d) m = 76283 * (d - 16) + $u >> Ju, l4[d - sl] = li(m, 255), u4[d - sl] = li(m + 8 >> 4, 15);
        w1 = 1;
      }
      return 1;
    }
    function vt(d) {
      var m = d.ma, b = d.U, x = d.T;
      return e(!(1 & d.ka)), 0 >= b || 0 >= x ? 0 : (b = m.Ib(d, m), m.Jb != null && m.Jb(d, m, b), m.Dc += b, 1);
    }
    function Sn(d) {
      d.ma.memory = null;
    }
    function xn(d, m, b, x) {
      return se(d, 8) != 47 ? 0 : (m[0] = se(d, 14) + 1, b[0] = se(d, 14) + 1, x[0] = se(d, 1), se(d, 3) != 0 ? 0 : !d.h);
    }
    function YA(d, m) {
      if (4 > d) return d + 1;
      var b = d - 2 >> 1;
      return (2 + (1 & d) << b) + se(m, b) + 1;
    }
    function xr(d, m) {
      return 120 < m ? m - 120 : 1 <= (b = ((b = jF[m - 1]) >> 4) * d + (8 - (15 & b))) ? b : 1;
      var b;
    }
    function ir(d, m, b) {
      var x = X(b), L = d[m += 255 & x].g - 8;
      return 0 < L && (ee(b, b.u + 8), x = X(b), m += d[m].value, m += x & (1 << L) - 1), ee(b, b.u + d[m].g), d[m].value;
    }
    function Or(d, m, b) {
      return b.g += d.g, b.value += d.value << m >>> 0, e(8 >= b.g), d.g;
    }
    function Xr(d, m, b) {
      var x = d.xc;
      return e((m = x == 0 ? 0 : d.vc[d.md * (b >> x) + (m >> x)]) < d.Wb), d.Ya[m];
    }
    function Vn(d, m, b, x) {
      var L = d.ab, M = d.c * m, k = d.C;
      m = k + m;
      var H = b, K = x;
      for (x = d.Ta, b = d.Ua; 0 < L--; ) {
        var q = d.gc[L], Ae = k, de = m, z = H, ae = K, he = (K = x, H = b, q.Ea);
        switch (e(Ae < de), e(de <= q.nc), q.hc) {
          case 2:
            kr(z, ae, (de - Ae) * he, K, H);
            break;
          case 0:
            var ve = Ae, fe = de, ye = K, be = H, Ie = (st = q).Ea;
            ve == 0 && ($o(z, ae, null, null, 1, ye, be), Ke(z, ae + 1, 0, 0, Ie - 1, ye, be + 1), ae += Ie, be += Ie, ++ve);
            for (var _e = 1 << st.b, ht = _e - 1, Ze = xe(Ie, st.b), Qt = st.K, st = st.w + (ve >> st.b) * Ze; ve < fe; ) {
              var Rt = Qt, lA = st, Lt = 1;
              for (Ya(z, ae, ye, be - Ie, 1, ye, be); Lt < Ie; ) {
                var at = (Lt & ~ht) + _e;
                at > Ie && (at = Ie), (0, el[Rt[lA++] >> 8 & 15])(z, ae + +Lt, ye, be + Lt - Ie, at - Lt, ye, be + Lt), Lt = at;
              }
              ae += Ie, be += Ie, ++ve & ht || (st += Ze);
            }
            de != q.nc && A(K, H - he, K, H + (de - Ae - 1) * he, he);
            break;
          case 1:
            for (he = z, fe = ae, Ie = (z = q.Ea) - (be = z & ~(ye = (ae = 1 << q.b) - 1)), ve = xe(z, q.b), _e = q.K, q = q.w + (Ae >> q.b) * ve; Ae < de; ) {
              for (ht = _e, Ze = q, Qt = new We(), st = fe + be, Rt = fe + z; fe < st; ) Ve(ht[Ze++], Qt), tl(Qt, he, fe, ae, K, H), fe += ae, H += ae;
              fe < Rt && (Ve(ht[Ze++], Qt), tl(Qt, he, fe, Ie, K, H), fe += Ie, H += Ie), ++Ae & ye || (q += ve);
            }
            break;
          case 3:
            if (z == K && ae == H && 0 < q.b) {
              for (fe = K, z = he = H + (de - Ae) * he - (be = (de - Ae) * xe(q.Ea, q.b)), ae = K, ye = H, ve = [], be = (Ie = be) - 1; 0 <= be; --be) ve[be] = ae[ye + be];
              for (be = Ie - 1; 0 <= be; --be) fe[z + be] = ve[be];
              Vu(q, Ae, de, K, he, K, H);
            } else Vu(q, Ae, de, z, ae, K, H);
        }
        H = x, K = b;
      }
      K != b && A(x, b, H, K, M);
    }
    function Kn(d, m) {
      var b = d.V, x = d.Ba + d.c * d.C, L = m - d.C;
      if (e(m <= d.l.o), e(16 >= L), 0 < L) {
        var M = d.l, k = d.Ta, H = d.Ua, K = M.width;
        if (Vn(d, L, b, x), L = H = [H], e((b = d.C) < (x = m)), e(M.v < M.va), x > M.o && (x = M.o), b < M.j) {
          var q = M.j - b;
          b = M.j, L[0] += q * K;
        }
        if (b >= x ? b = 0 : (L[0] += 4 * M.v, M.ka = b - M.j, M.U = M.va - M.v, M.T = x - b, b = 1), b) {
          if (H = H[0], 11 > (b = d.ca).S) {
            var Ae = b.f.RGBA, de = (x = b.S, L = M.U, M = M.T, q = Ae.eb, Ae.A), z = M;
            for (Ae = Ae.fb + d.Ma * Ae.A; 0 < z--; ) {
              var ae = k, he = H, ve = L, fe = q, ye = Ae;
              switch (x) {
                case qu:
                  rl(ae, he, ve, fe, ye);
                  break;
                case zu:
                  ds(ae, he, ve, fe, ye);
                  break;
                case _f:
                  ds(ae, he, ve, fe, ye), nl(fe, ye, 0, ve, 1, 0);
                  break;
                case u1:
                  aa(ae, he, ve, fe, ye);
                  break;
                case Wu:
                  it(ae, he, ve, fe, ye, 1);
                  break;
                case Uf:
                  it(ae, he, ve, fe, ye, 1), nl(fe, ye, 0, ve, 1, 0);
                  break;
                case Xu:
                  it(ae, he, ve, fe, ye, 0);
                  break;
                case Yu:
                  it(ae, he, ve, fe, ye, 0), nl(fe, ye, 1, ve, 1, 0);
                  break;
                case Ff:
                  gs(ae, he, ve, fe, ye);
                  break;
                case If:
                  gs(ae, he, ve, fe, ye), r1(fe, ye, ve, 1, 0);
                  break;
                case c1:
                  ps(ae, he, ve, fe, ye);
                  break;
                default:
                  e(0);
              }
              H += K, Ae += de;
            }
            d.Ma += M;
          } else alert("todo:EmitRescaledRowsYUVA");
          e(d.Ma <= b.height);
        }
      }
      d.C = m, e(d.C <= d.i);
    }
    function Mr(d) {
      var m;
      if (0 < d.ua) return 0;
      for (m = 0; m < d.Wb; ++m) {
        var b = d.Ya[m].G, x = d.Ya[m].H;
        if (0 < b[1][x[1] + 0].g || 0 < b[2][x[2] + 0].g || 0 < b[3][x[3] + 0].g) return 0;
      }
      return 1;
    }
    function on(d, m, b, x, L, M) {
      if (d.Z != 0) {
        var k = d.qd, H = d.rd;
        for (e(ws[d.Z] != null); m < b; ++m) ws[d.Z](k, H, x, L, x, L, M), k = x, H = L, L += M;
        d.qd = k, d.rd = H;
      }
    }
    function JA(d, m) {
      var b = d.l.ma, x = b.Z == 0 || b.Z == 1 ? d.l.j : d.C;
      if (x = d.C < x ? x : d.C, e(m <= d.l.o), m > x) {
        var L = d.l.width, M = b.ca, k = b.tb + L * x, H = d.V, K = d.Ba + d.c * x, q = d.gc;
        e(d.ab == 1), e(q[0].hc == 3), fi(q[0], x, m, H, K, M, k), on(b, x, m, M, k, L);
      }
      d.C = d.Ma = m;
    }
    function $A(d, m, b, x, L, M, k) {
      var H = d.$ / x, K = d.$ % x, q = d.m, Ae = d.s, de = b + d.$, z = de;
      L = b + x * L;
      var ae = b + x * M, he = 280 + Ae.ua, ve = d.Pb ? H : 16777216, fe = 0 < Ae.ua ? Ae.Wa : null, ye = Ae.wc, be = de < ae ? Xr(Ae, K, H) : null;
      e(d.C < M), e(ae <= L);
      var Ie = !1;
      e: for (; ; ) {
        for (; Ie || de < ae; ) {
          var _e = 0;
          if (H >= ve) {
            var ht = de - b;
            e((ve = d).Pb), ve.wd = ve.m, ve.xd = ht, 0 < ve.s.ua && Pe(ve.s.Wa, ve.s.vb), ve = H + zF;
          }
          if (K & ye || (be = Xr(Ae, K, H)), e(be != null), be.Qb && (m[de] = be.qb, Ie = !0), !Ie) if (oe(q), be.jc) {
            _e = q, ht = m;
            var Ze = de, Qt = be.pd[X(_e) & sa - 1];
            e(be.jc), 256 > Qt.g ? (ee(_e, _e.u + Qt.g), ht[Ze] = Qt.value, _e = 0) : (ee(_e, _e.u + Qt.g - 256), e(256 <= Qt.value), _e = Qt.value), _e == 0 && (Ie = !0);
          } else _e = ir(be.G[0], be.H[0], q);
          if (q.h) break;
          if (Ie || 256 > _e) {
            if (!Ie) if (be.nd) m[de] = (be.qb | _e << 8) >>> 0;
            else {
              if (oe(q), Ie = ir(be.G[1], be.H[1], q), oe(q), ht = ir(be.G[2], be.H[2], q), Ze = ir(be.G[3], be.H[3], q), q.h) break;
              m[de] = (Ze << 24 | Ie << 16 | _e << 8 | ht) >>> 0;
            }
            if (Ie = !1, ++de, ++K >= x && (K = 0, ++H, k != null && H <= M && !(H % 16) && k(d, H), fe != null)) for (; z < de; ) _e = m[z++], fe.X[(506832829 * _e & 4294967295) >>> fe.Mb] = _e;
          } else if (280 > _e) {
            if (_e = YA(_e - 256, q), ht = ir(be.G[4], be.H[4], q), oe(q), ht = xr(x, ht = YA(ht, q)), q.h) break;
            if (de - b < ht || L - de < _e) break e;
            for (Ze = 0; Ze < _e; ++Ze) m[de + Ze] = m[de + Ze - ht];
            for (de += _e, K += _e; K >= x; ) K -= x, ++H, k != null && H <= M && !(H % 16) && k(d, H);
            if (e(de <= L), K & ye && (be = Xr(Ae, K, H)), fe != null) for (; z < de; ) _e = m[z++], fe.X[(506832829 * _e & 4294967295) >>> fe.Mb] = _e;
          } else {
            if (!(_e < he)) break e;
            for (Ie = _e - 280, e(fe != null); z < de; ) _e = m[z++], fe.X[(506832829 * _e & 4294967295) >>> fe.Mb] = _e;
            _e = de, e(!(Ie >>> (ht = fe).Xa)), m[_e] = ht.X[Ie], Ie = !0;
          }
          Ie || e(q.h == Y(q));
        }
        if (d.Pb && q.h && de < L) e(d.m.h), d.a = 5, d.m = d.wd, d.$ = d.xd, 0 < d.s.ua && Pe(d.s.vb, d.s.Wa);
        else {
          if (q.h) break e;
          k?.(d, H > M ? M : H), d.a = 0, d.$ = de - b;
        }
        return 1;
      }
      return d.a = 3, 0;
    }
    function RA(d) {
      e(d != null), d.vc = null, d.yc = null, d.Ya = null;
      var m = d.Wa;
      m != null && (m.X = null), d.vb = null, e(d != null);
    }
    function Ei() {
      var d = new St();
      return d == null ? null : (d.a = 0, d.xb = d1, Vt("Predictor", "VP8LPredictors"), Vt("Predictor", "VP8LPredictors_C"), Vt("PredictorAdd", "VP8LPredictorsAdd"), Vt("PredictorAdd", "VP8LPredictorsAdd_C"), kr = Xe, tl = dt, rl = Tt, ds = Et, gs = mt, ps = yt, aa = Gt, U.VP8LMapColor32b = hi, U.VP8LMapColor8b = Zo, d);
    }
    function $e(d, m, b, x, L) {
      var M = 1, k = [d], H = [m], K = x.m, q = x.s, Ae = null, de = 0;
      e: for (; ; ) {
        if (b) for (; M && se(K, 1); ) {
          var z = k, ae = H, he = x, ve = 1, fe = he.m, ye = he.gc[he.ab], be = se(fe, 2);
          if (he.Oc & 1 << be) M = 0;
          else {
            switch (he.Oc |= 1 << be, ye.hc = be, ye.Ea = z[0], ye.nc = ae[0], ye.K = [null], ++he.ab, e(4 >= he.ab), be) {
              case 0:
              case 1:
                ye.b = se(fe, 3) + 2, ve = $e(xe(ye.Ea, ye.b), xe(ye.nc, ye.b), 0, he, ye.K), ye.K = ye.K[0];
                break;
              case 3:
                var Ie, _e = se(fe, 8) + 1, ht = 16 < _e ? 0 : 4 < _e ? 1 : 2 < _e ? 2 : 3;
                if (z[0] = xe(ye.Ea, ht), ye.b = ht, Ie = ve = $e(_e, 1, 0, he, ye.K)) {
                  var Ze, Qt = _e, st = ye, Rt = 1 << (8 >> st.b), lA = i(Rt);
                  if (lA == null) Ie = 0;
                  else {
                    var Lt = st.K[0], at = st.w;
                    for (lA[0] = st.K[0][0], Ze = 1; Ze < 1 * Qt; ++Ze) lA[Ze] = rt(Lt[at + Ze], lA[Ze - 1]);
                    for (; Ze < 4 * Rt; ++Ze) lA[Ze] = 0;
                    st.K[0] = null, st.K[0] = lA, Ie = 1;
                  }
                }
                ve = Ie;
                break;
              case 2:
                break;
              default:
                e(0);
            }
            M = ve;
          }
        }
        if (k = k[0], H = H[0], M && se(K, 1) && !(M = 1 <= (de = se(K, 4)) && 11 >= de)) {
          x.a = 3;
          break e;
        }
        var He;
        if (He = M) t: {
          var Dr, _t, kt, pr = x, BA = k, DA = H, Ur = de, UA = b, GA = pr.m, uA = pr.s, Dt = [null], tr = 1, Ir = 0, rr = qF[Ur];
          r: for (; ; ) {
            if (UA && se(GA, 1)) {
              var bA = se(GA, 3) + 2, Wn = xe(BA, bA), Gr = xe(DA, bA), ZA = Wn * Gr;
              if (!$e(Wn, Gr, 0, pr, Dt)) break r;
              for (Dt = Dt[0], uA.xc = bA, Dr = 0; Dr < ZA; ++Dr) {
                var ar = Dt[Dr] >> 8 & 65535;
                Dt[Dr] = ar, ar >= tr && (tr = ar + 1);
              }
            }
            if (GA.h) break r;
            for (_t = 0; 5 > _t; ++_t) {
              var cA = h1[_t];
              !_t && 0 < Ur && (cA += 1 << Ur), Ir < cA && (Ir = cA);
            }
            var hn = s(tr * rr, D), VA = tr, fn = s(VA, J);
            if (fn == null) var dn = null;
            else e(65536 >= VA), dn = fn;
            var en = i(Ir);
            if (dn == null || en == null || hn == null) {
              pr.a = 1;
              break r;
            }
            var gn = hn;
            for (Dr = kt = 0; Dr < tr; ++Dr) {
              var fr = dn[Dr], pn = fr.G, Xn = fr.H, la = 0, Hi = 1, CA = 0;
              for (_t = 0; 5 > _t; ++_t) {
                cA = h1[_t], pn[_t] = gn, Xn[_t] = kt, !_t && 0 < Ur && (cA += 1 << Ur);
                n: {
                  var ec, Tf = cA, tc = pr, al = en, f4 = gn, d4 = kt, Pf = 0, ys = tc.m, g4 = se(ys, 1);
                  if (n(al, 0, 0, Tf), g4) {
                    var p4 = se(ys, 1) + 1, m4 = se(ys, 1), b1 = se(ys, m4 == 0 ? 1 : 8);
                    al[b1] = 1, p4 == 2 && (al[b1 = se(ys, 8)] = 1);
                    var rc = 1;
                  } else {
                    var C1 = i(19), S1 = se(ys, 4) + 4;
                    if (19 < S1) {
                      tc.a = 3;
                      var Ac = 0;
                      break n;
                    }
                    for (ec = 0; ec < S1; ++ec) C1[KF[ec]] = se(ys, 3);
                    var Of = void 0, ol = void 0, x1 = tc, v4 = C1, nc = Tf, E1 = al, Mf = 0, Bs = x1.m, F1 = 8, _1 = s(128, D);
                    A: for (; P(_1, 0, 7, v4, 19); ) {
                      if (se(Bs, 1)) {
                        var w4 = 2 + 2 * se(Bs, 3);
                        if ((Of = 2 + se(Bs, w4)) > nc) break A;
                      } else Of = nc;
                      for (ol = 0; ol < nc && Of--; ) {
                        oe(Bs);
                        var U1 = _1[0 + (127 & X(Bs))];
                        ee(Bs, Bs.u + U1.g);
                        var $a = U1.value;
                        if (16 > $a) E1[ol++] = $a, $a != 0 && (F1 = $a);
                        else {
                          var y4 = $a == 16, I1 = $a - 16, B4 = GF[I1], Q1 = se(Bs, DF[I1]) + B4;
                          if (ol + Q1 > nc) break A;
                          for (var b4 = y4 ? F1 : 0; 0 < Q1--; ) E1[ol++] = b4;
                        }
                      }
                      Mf = 1;
                      break A;
                    }
                    Mf || (x1.a = 3), rc = Mf;
                  }
                  (rc = rc && !ys.h) && (Pf = P(f4, d4, 8, al, Tf)), rc && Pf != 0 ? Ac = Pf : (tc.a = 3, Ac = 0);
                }
                if (Ac == 0) break r;
                if (Hi && VF[_t] == 1 && (Hi = gn[kt].g == 0), la += gn[kt].g, kt += Ac, 3 >= _t) {
                  var ll, Rf = en[0];
                  for (ll = 1; ll < cA; ++ll) en[ll] > Rf && (Rf = en[ll]);
                  CA += Rf;
                }
              }
              if (fr.nd = Hi, fr.Qb = 0, Hi && (fr.qb = (pn[3][Xn[3] + 0].value << 24 | pn[1][Xn[1] + 0].value << 16 | pn[2][Xn[2] + 0].value) >>> 0, la == 0 && 256 > pn[0][Xn[0] + 0].value && (fr.Qb = 1, fr.qb += pn[0][Xn[0] + 0].value << 8)), fr.jc = !fr.Qb && 6 > CA, fr.jc) {
                var ic, Di = fr;
                for (ic = 0; ic < sa; ++ic) {
                  var bs = ic, Cs = Di.pd[bs], sc = Di.G[0][Di.H[0] + bs];
                  256 <= sc.value ? (Cs.g = sc.g + 256, Cs.value = sc.value) : (Cs.g = 0, Cs.value = 0, bs >>= Or(sc, 8, Cs), bs >>= Or(Di.G[1][Di.H[1] + bs], 16, Cs), bs >>= Or(Di.G[2][Di.H[2] + bs], 0, Cs), Or(Di.G[3][Di.H[3] + bs], 24, Cs));
                }
              }
            }
            uA.vc = Dt, uA.Wb = tr, uA.Ya = dn, uA.yc = hn, He = 1;
            break t;
          }
          He = 0;
        }
        if (!(M = He)) {
          x.a = 3;
          break e;
        }
        if (0 < de) {
          if (q.ua = 1 << de, !j(q.Wa, de)) {
            x.a = 1, M = 0;
            break e;
          }
        } else q.ua = 0;
        var kf = x, L1 = k, C4 = H, Hf = kf.s, Df = Hf.xc;
        if (kf.c = L1, kf.i = C4, Hf.md = xe(L1, Df), Hf.wc = Df == 0 ? -1 : (1 << Df) - 1, b) {
          x.xb = e4;
          break e;
        }
        if ((Ae = i(k * H)) == null) {
          x.a = 1, M = 0;
          break e;
        }
        M = (M = $A(x, Ae, 0, k, H, H, null)) && !K.h;
        break e;
      }
      return M ? (L != null ? L[0] = Ae : (e(Ae == null), e(b)), x.$ = 0, b || RA(q)) : RA(q), M;
    }
    function ne(d, m) {
      var b = d.c * d.i, x = b + m + 16 * m;
      return e(d.c <= m), d.V = i(x), d.V == null ? (d.Ta = null, d.Ua = 0, d.a = 1, 0) : (d.Ta = d.V, d.Ua = d.Ba + b + m, 1);
    }
    function Qe(d, m) {
      var b = d.C, x = m - b, L = d.V, M = d.Ba + d.c * b;
      for (e(m <= d.l.o); 0 < x; ) {
        var k = 16 < x ? 16 : x, H = d.l.ma, K = d.l.width, q = K * k, Ae = H.ca, de = H.tb + K * b, z = d.Ta, ae = d.Ua;
        Vn(d, k, L, M), n1(z, ae, Ae, de, q), on(H, b, b + k, Ae, de, K), x -= k, L += k * d.c, b += k;
      }
      e(b == m), d.C = d.Ma = m;
    }
    function Je() {
      this.ub = this.yd = this.td = this.Rb = 0;
    }
    function Wt() {
      this.Kd = this.Ld = this.Ud = this.Td = this.i = this.c = 0;
    }
    function Yr() {
      this.Fb = this.Bb = this.Cb = 0, this.Zb = i(4), this.Lb = i(4);
    }
    function Er() {
      this.Yb = (function() {
        var d = [];
        return (function m(b, x, L) {
          for (var M = L[x], k = 0; k < M && (b.push(L.length > x + 1 ? [] : 0), !(L.length < x + 1)); k++) m(b[k], x + 1, L);
        })(d, 0, [3, 11]), d;
      })();
    }
    function iA() {
      this.jb = i(3), this.Wc = a([4, 8], Er), this.Xc = a([4, 17], Er);
    }
    function kA() {
      this.Pc = this.wb = this.Tb = this.zd = 0, this.vd = new i(4), this.od = new i(4);
    }
    function dA() {
      this.ld = this.La = this.dd = this.tc = 0;
    }
    function Rr() {
      this.Na = this.la = 0;
    }
    function Xs() {
      this.Sc = [0, 0], this.Eb = [0, 0], this.Qc = [0, 0], this.ia = this.lc = 0;
    }
    function os() {
      this.ad = i(384), this.Za = 0, this.Ob = i(16), this.$b = this.Ad = this.ia = this.Gc = this.Hc = this.Dd = 0;
    }
    function _u() {
      this.uc = this.M = this.Nb = 0, this.wa = Array(new dA()), this.Y = 0, this.ya = Array(new os()), this.aa = 0, this.l = new Va();
    }
    function Uu() {
      this.y = i(16), this.f = i(8), this.ea = i(8);
    }
    function Iu() {
      this.cb = this.a = 0, this.sc = "", this.m = new T(), this.Od = new Je(), this.Kc = new Wt(), this.ed = new kA(), this.Qa = new Yr(), this.Ic = this.$c = this.Aa = 0, this.D = new _u(), this.Xb = this.Va = this.Hb = this.zb = this.yb = this.Ub = this.za = 0, this.Jc = s(8, T), this.ia = 0, this.pb = s(4, Xs), this.Pa = new iA(), this.Bd = this.kc = 0, this.Ac = [], this.Bc = 0, this.zc = [0, 0, 0, 0], this.Gd = Array(new Uu()), this.Hd = 0, this.rb = Array(new Rr()), this.sb = 0, this.wa = Array(new dA()), this.Y = 0, this.oc = [], this.pc = 0, this.sa = [], this.ta = 0, this.qa = [], this.ra = 0, this.Ha = [], this.B = this.R = this.Ia = 0, this.Ec = [], this.M = this.ja = this.Vb = this.Fc = 0, this.ya = Array(new os()), this.L = this.aa = 0, this.gd = a([4, 2], dA), this.ga = null, this.Fa = [], this.Cc = this.qc = this.P = 0, this.Gb = [], this.Uc = 0, this.mb = [], this.nb = 0, this.rc = [], this.Ga = this.Vc = 0;
    }
    function li(d, m) {
      return 0 > d ? 0 : d > m ? m : d;
    }
    function Va() {
      this.T = this.U = this.ka = this.height = this.width = 0, this.y = [], this.f = [], this.ea = [], this.Rc = this.fa = this.W = this.N = this.O = 0, this.ma = "void", this.put = "VP8IoPutHook", this.ac = "VP8IoSetupHook", this.bc = "VP8IoTeardownHook", this.ha = this.Kb = 0, this.data = [], this.hb = this.ib = this.da = this.o = this.j = this.va = this.v = this.Da = this.ob = this.w = 0, this.F = [], this.J = 0;
    }
    function cf() {
      var d = new Iu();
      return d != null && (d.a = 0, d.sc = "OK", d.cb = 0, d.Xb = 0, il || (il = Ka)), d;
    }
    function Jr(d, m, b) {
      return d.a == 0 && (d.a = m, d.sc = b, d.cb = 0), 0;
    }
    function Qu(d, m, b) {
      return 3 <= b && d[m + 0] == 157 && d[m + 1] == 1 && d[m + 2] == 42;
    }
    function ui(d, m) {
      if (d == null) return 0;
      if (d.a = 0, d.sc = "OK", m == null) return Jr(d, 2, "null VP8Io passed to VP8GetHeaders()");
      var b = m.data, x = m.w, L = m.ha;
      if (4 > L) return Jr(d, 7, "Truncated header.");
      var M = b[x + 0] | b[x + 1] << 8 | b[x + 2] << 16, k = d.Od;
      if (k.Rb = !(1 & M), k.td = M >> 1 & 7, k.yd = M >> 4 & 1, k.ub = M >> 5, 3 < k.td) return Jr(d, 3, "Incorrect keyframe parameters.");
      if (!k.yd) return Jr(d, 4, "Frame not displayable.");
      x += 3, L -= 3;
      var H = d.Kc;
      if (k.Rb) {
        if (7 > L) return Jr(d, 7, "cannot parse picture header");
        if (!Qu(b, x, L)) return Jr(d, 3, "Bad code word");
        H.c = 16383 & (b[x + 4] << 8 | b[x + 3]), H.Td = b[x + 4] >> 6, H.i = 16383 & (b[x + 6] << 8 | b[x + 5]), H.Ud = b[x + 6] >> 6, x += 7, L -= 7, d.za = H.c + 15 >> 4, d.Ub = H.i + 15 >> 4, m.width = H.c, m.height = H.i, m.Da = 0, m.j = 0, m.v = 0, m.va = m.width, m.o = m.height, m.da = 0, m.ib = m.width, m.hb = m.height, m.U = m.width, m.T = m.height, n((M = d.Pa).jb, 0, 255, M.jb.length), e((M = d.Qa) != null), M.Cb = 0, M.Bb = 0, M.Fb = 1, n(M.Zb, 0, 0, M.Zb.length), n(M.Lb, 0, 0, M.Lb);
      }
      if (k.ub > L) return Jr(d, 7, "bad partition length");
      ie(M = d.m, b, x, k.ub), x += k.ub, L -= k.ub, k.Rb && (H.Ld = pe(M), H.Kd = pe(M)), H = d.Qa;
      var K, q = d.Pa;
      if (e(M != null), e(H != null), H.Cb = pe(M), H.Cb) {
        if (H.Bb = pe(M), pe(M)) {
          for (H.Fb = pe(M), K = 0; 4 > K; ++K) H.Zb[K] = pe(M) ? $(M, 7) : 0;
          for (K = 0; 4 > K; ++K) H.Lb[K] = pe(M) ? $(M, 6) : 0;
        }
        if (H.Bb) for (K = 0; 3 > K; ++K) q.jb[K] = pe(M) ? te(M, 8) : 255;
      } else H.Bb = 0;
      if (M.Ka) return Jr(d, 3, "cannot parse segment header");
      if ((H = d.ed).zd = pe(M), H.Tb = te(M, 6), H.wb = te(M, 3), H.Pc = pe(M), H.Pc && pe(M)) {
        for (q = 0; 4 > q; ++q) pe(M) && (H.vd[q] = $(M, 6));
        for (q = 0; 4 > q; ++q) pe(M) && (H.od[q] = $(M, 6));
      }
      if (d.L = H.Tb == 0 ? 0 : H.zd ? 1 : 2, M.Ka) return Jr(d, 3, "cannot parse filter header");
      var Ae = L;
      if (L = K = x, x = K + Ae, H = Ae, d.Xb = (1 << te(d.m, 2)) - 1, Ae < 3 * (q = d.Xb)) b = 7;
      else {
        for (K += 3 * q, H -= 3 * q, Ae = 0; Ae < q; ++Ae) {
          var de = b[L + 0] | b[L + 1] << 8 | b[L + 2] << 16;
          de > H && (de = H), ie(d.Jc[+Ae], b, K, de), K += de, H -= de, L += 3;
        }
        ie(d.Jc[+q], b, K, H), b = K < x ? 0 : 5;
      }
      if (b != 0) return Jr(d, b, "cannot parse partitions");
      for (b = te(K = d.m, 7), L = pe(K) ? $(K, 4) : 0, x = pe(K) ? $(K, 4) : 0, H = pe(K) ? $(K, 4) : 0, q = pe(K) ? $(K, 4) : 0, K = pe(K) ? $(K, 4) : 0, Ae = d.Qa, de = 0; 4 > de; ++de) {
        if (Ae.Cb) {
          var z = Ae.Zb[de];
          Ae.Fb || (z += b);
        } else {
          if (0 < de) {
            d.pb[de] = d.pb[0];
            continue;
          }
          z = b;
        }
        var ae = d.pb[de];
        ae.Sc[0] = Qf[li(z + L, 127)], ae.Sc[1] = Lf[li(z + 0, 127)], ae.Eb[0] = 2 * Qf[li(z + x, 127)], ae.Eb[1] = 101581 * Lf[li(z + H, 127)] >> 16, 8 > ae.Eb[1] && (ae.Eb[1] = 8), ae.Qc[0] = Qf[li(z + q, 117)], ae.Qc[1] = Lf[li(z + K, 127)], ae.lc = z + K;
      }
      if (!k.Rb) return Jr(d, 4, "Not a key frame.");
      for (pe(M), k = d.Pa, b = 0; 4 > b; ++b) {
        for (L = 0; 8 > L; ++L) for (x = 0; 3 > x; ++x) for (H = 0; 11 > H; ++H) q = me(M, $F[b][L][x][H]) ? te(M, 8) : YF[b][L][x][H], k.Wc[b][L].Yb[x][H] = q;
        for (L = 0; 17 > L; ++L) k.Xc[b][L] = k.Wc[b][ZF[L]];
      }
      return d.kc = pe(M), d.kc && (d.Bd = te(M, 8)), d.cb = 1;
    }
    function Ka(d, m, b, x, L, M, k) {
      var H = m[L].Yb[b];
      for (b = 0; 16 > L; ++L) {
        if (!me(d, H[b + 0])) return L;
        for (; !me(d, H[b + 1]); ) if (H = m[++L].Yb[0], b = 0, L == 16) return 16;
        var K = m[L + 1].Yb;
        if (me(d, H[b + 2])) {
          var q = d, Ae = 0;
          if (me(q, (z = H)[(de = b) + 3])) if (me(q, z[de + 6])) {
            for (H = 0, de = 2 * (Ae = me(q, z[de + 8])) + (z = me(q, z[de + 9 + Ae])), Ae = 0, z = WF[de]; z[H]; ++H) Ae += Ae + me(q, z[H]);
            Ae += 3 + (8 << de);
          } else me(q, z[de + 7]) ? (Ae = 7 + 2 * me(q, 165), Ae += me(q, 145)) : Ae = 5 + me(q, 159);
          else Ae = me(q, z[de + 4]) ? 3 + me(q, z[de + 5]) : 2;
          H = K[2];
        } else Ae = 1, H = K[1];
        K = k + XF[L], 0 > (q = d).b && ge(q);
        var de, z = q.b, ae = (de = q.Ca >> 1) - (q.I >> z) >> 31;
        --q.b, q.Ca += ae, q.Ca |= 1, q.I -= (de + 1 & ae) << z, M[K] = ((Ae ^ ae) - ae) * x[(0 < L) + 0];
      }
      return 16;
    }
    function Lu(d) {
      var m = d.rb[d.sb - 1];
      m.la = 0, m.Na = 0, n(d.zc, 0, 0, d.zc.length), d.ja = 0;
    }
    function En(d, m, b, x, L) {
      L = d[m + b + 32 * x] + (L >> 3), d[m + b + 32 * x] = -256 & L ? 0 > L ? 0 : 255 : L;
    }
    function sA(d, m, b, x, L, M) {
      En(d, m, 0, b, x + L), En(d, m, 1, b, x + M), En(d, m, 2, b, x - M), En(d, m, 3, b, x - L);
    }
    function Fi(d) {
      return (20091 * d >> 16) + d;
    }
    function Nu(d, m, b, x) {
      var L, M = 0, k = i(16);
      for (L = 0; 4 > L; ++L) {
        var H = d[m + 0] + d[m + 8], K = d[m + 0] - d[m + 8], q = (35468 * d[m + 4] >> 16) - Fi(d[m + 12]), Ae = Fi(d[m + 4]) + (35468 * d[m + 12] >> 16);
        k[M + 0] = H + Ae, k[M + 1] = K + q, k[M + 2] = K - q, k[M + 3] = H - Ae, M += 4, m++;
      }
      for (L = M = 0; 4 > L; ++L) H = (d = k[M + 0] + 4) + k[M + 8], K = d - k[M + 8], q = (35468 * k[M + 4] >> 16) - Fi(k[M + 12]), En(b, x, 0, 0, H + (Ae = Fi(k[M + 4]) + (35468 * k[M + 12] >> 16))), En(b, x, 1, 0, K + q), En(b, x, 2, 0, K - q), En(b, x, 3, 0, H - Ae), M++, x += 32;
    }
    function hf(d, m, b, x) {
      var L = d[m + 0] + 4, M = 35468 * d[m + 4] >> 16, k = Fi(d[m + 4]), H = 35468 * d[m + 1] >> 16;
      sA(b, x, 0, L + k, d = Fi(d[m + 1]), H), sA(b, x, 1, L + M, d, H), sA(b, x, 2, L - M, d, H), sA(b, x, 3, L - k, d, H);
    }
    function ff(d, m, b, x, L) {
      Nu(d, m, b, x), L && Nu(d, m + 16, b, x + 4);
    }
    function ci(d, m, b, x) {
      oa(d, m + 0, b, x, 1), oa(d, m + 32, b, x + 128, 1);
    }
    function Tu(d, m, b, x) {
      var L;
      for (d = d[m + 0] + 4, L = 0; 4 > L; ++L) for (m = 0; 4 > m; ++m) En(b, x, m, L, d);
    }
    function Pu(d, m, b, x) {
      d[m + 0] && Jt(d, m + 0, b, x), d[m + 16] && Jt(d, m + 16, b, x + 4), d[m + 32] && Jt(d, m + 32, b, x + 128), d[m + 48] && Jt(d, m + 48, b, x + 128 + 4);
    }
    function ja(d, m, b, x) {
      var L, M = i(16);
      for (L = 0; 4 > L; ++L) {
        var k = d[m + 0 + L] + d[m + 12 + L], H = d[m + 4 + L] + d[m + 8 + L], K = d[m + 4 + L] - d[m + 8 + L], q = d[m + 0 + L] - d[m + 12 + L];
        M[0 + L] = k + H, M[8 + L] = k - H, M[4 + L] = q + K, M[12 + L] = q - K;
      }
      for (L = 0; 4 > L; ++L) k = (d = M[0 + 4 * L] + 3) + M[3 + 4 * L], H = M[1 + 4 * L] + M[2 + 4 * L], K = M[1 + 4 * L] - M[2 + 4 * L], q = d - M[3 + 4 * L], b[x + 0] = k + H >> 3, b[x + 16] = q + K >> 3, b[x + 32] = k - H >> 3, b[x + 48] = q - K >> 3, x += 64;
    }
    function Ys(d, m, b) {
      var x, L = m - 32, M = cn, k = 255 - d[L - 1];
      for (x = 0; x < b; ++x) {
        var H, K = M, q = k + d[m - 1];
        for (H = 0; H < b; ++H) d[m + H] = K[q + d[L + H]];
        m += 32;
      }
    }
    function df(d, m) {
      Ys(d, m, 4);
    }
    function gf(d, m) {
      Ys(d, m, 8);
    }
    function pf(d, m) {
      Ys(d, m, 16);
    }
    function ko(d, m) {
      var b;
      for (b = 0; 16 > b; ++b) A(d, m + 32 * b, d, m - 32, 16);
    }
    function Ou(d, m) {
      var b;
      for (b = 16; 0 < b; --b) n(d, m, d[m - 1], 16), m += 32;
    }
    function jn(d, m, b) {
      var x;
      for (x = 0; 16 > x; ++x) n(m, b + 32 * x, d, 16);
    }
    function mf(d, m) {
      var b, x = 16;
      for (b = 0; 16 > b; ++b) x += d[m - 1 + 32 * b] + d[m + b - 32];
      jn(x >> 5, d, m);
    }
    function Js(d, m) {
      var b, x = 8;
      for (b = 0; 16 > b; ++b) x += d[m - 1 + 32 * b];
      jn(x >> 4, d, m);
    }
    function Ho(d, m) {
      var b, x = 8;
      for (b = 0; 16 > b; ++b) x += d[m + b - 32];
      jn(x >> 4, d, m);
    }
    function vf(d, m) {
      jn(128, d, m);
    }
    function xt(d, m, b) {
      return d + 2 * m + b + 2 >> 2;
    }
    function wf(d, m) {
      var b, x = m - 32;
      for (x = new Uint8Array([xt(d[x - 1], d[x + 0], d[x + 1]), xt(d[x + 0], d[x + 1], d[x + 2]), xt(d[x + 1], d[x + 2], d[x + 3]), xt(d[x + 2], d[x + 3], d[x + 4])]), b = 0; 4 > b; ++b) A(d, m + 32 * b, x, 0, x.length);
    }
    function yf(d, m) {
      var b = d[m - 1], x = d[m - 1 + 32], L = d[m - 1 + 64], M = d[m - 1 + 96];
      Ee(d, m + 0, 16843009 * xt(d[m - 1 - 32], b, x)), Ee(d, m + 32, 16843009 * xt(b, x, L)), Ee(d, m + 64, 16843009 * xt(x, L, M)), Ee(d, m + 96, 16843009 * xt(L, M, M));
    }
    function Bf(d, m) {
      var b, x = 4;
      for (b = 0; 4 > b; ++b) x += d[m + b - 32] + d[m - 1 + 32 * b];
      for (x >>= 3, b = 0; 4 > b; ++b) n(d, m + 32 * b, x, 4);
    }
    function _i(d, m) {
      var b = d[m - 1 + 0], x = d[m - 1 + 32], L = d[m - 1 + 64], M = d[m - 1 - 32], k = d[m + 0 - 32], H = d[m + 1 - 32], K = d[m + 2 - 32], q = d[m + 3 - 32];
      d[m + 0 + 96] = xt(x, L, d[m - 1 + 96]), d[m + 1 + 96] = d[m + 0 + 64] = xt(b, x, L), d[m + 2 + 96] = d[m + 1 + 64] = d[m + 0 + 32] = xt(M, b, x), d[m + 3 + 96] = d[m + 2 + 64] = d[m + 1 + 32] = d[m + 0 + 0] = xt(k, M, b), d[m + 3 + 64] = d[m + 2 + 32] = d[m + 1 + 0] = xt(H, k, M), d[m + 3 + 32] = d[m + 2 + 0] = xt(K, H, k), d[m + 3 + 0] = xt(q, K, H);
    }
    function Ui(d, m) {
      var b = d[m + 1 - 32], x = d[m + 2 - 32], L = d[m + 3 - 32], M = d[m + 4 - 32], k = d[m + 5 - 32], H = d[m + 6 - 32], K = d[m + 7 - 32];
      d[m + 0 + 0] = xt(d[m + 0 - 32], b, x), d[m + 1 + 0] = d[m + 0 + 32] = xt(b, x, L), d[m + 2 + 0] = d[m + 1 + 32] = d[m + 0 + 64] = xt(x, L, M), d[m + 3 + 0] = d[m + 2 + 32] = d[m + 1 + 64] = d[m + 0 + 96] = xt(L, M, k), d[m + 3 + 32] = d[m + 2 + 64] = d[m + 1 + 96] = xt(M, k, H), d[m + 3 + 64] = d[m + 2 + 96] = xt(k, H, K), d[m + 3 + 96] = xt(H, K, K);
    }
    function bf(d, m) {
      var b = d[m - 1 + 0], x = d[m - 1 + 32], L = d[m - 1 + 64], M = d[m - 1 - 32], k = d[m + 0 - 32], H = d[m + 1 - 32], K = d[m + 2 - 32], q = d[m + 3 - 32];
      d[m + 0 + 0] = d[m + 1 + 64] = M + k + 1 >> 1, d[m + 1 + 0] = d[m + 2 + 64] = k + H + 1 >> 1, d[m + 2 + 0] = d[m + 3 + 64] = H + K + 1 >> 1, d[m + 3 + 0] = K + q + 1 >> 1, d[m + 0 + 96] = xt(L, x, b), d[m + 0 + 64] = xt(x, b, M), d[m + 0 + 32] = d[m + 1 + 96] = xt(b, M, k), d[m + 1 + 32] = d[m + 2 + 96] = xt(M, k, H), d[m + 2 + 32] = d[m + 3 + 96] = xt(k, H, K), d[m + 3 + 32] = xt(H, K, q);
    }
    function Cf(d, m) {
      var b = d[m + 0 - 32], x = d[m + 1 - 32], L = d[m + 2 - 32], M = d[m + 3 - 32], k = d[m + 4 - 32], H = d[m + 5 - 32], K = d[m + 6 - 32], q = d[m + 7 - 32];
      d[m + 0 + 0] = b + x + 1 >> 1, d[m + 1 + 0] = d[m + 0 + 64] = x + L + 1 >> 1, d[m + 2 + 0] = d[m + 1 + 64] = L + M + 1 >> 1, d[m + 3 + 0] = d[m + 2 + 64] = M + k + 1 >> 1, d[m + 0 + 32] = xt(b, x, L), d[m + 1 + 32] = d[m + 0 + 96] = xt(x, L, M), d[m + 2 + 32] = d[m + 1 + 96] = xt(L, M, k), d[m + 3 + 32] = d[m + 2 + 96] = xt(M, k, H), d[m + 3 + 64] = xt(k, H, K), d[m + 3 + 96] = xt(H, K, q);
    }
    function qa(d, m) {
      var b = d[m - 1 + 0], x = d[m - 1 + 32], L = d[m - 1 + 64], M = d[m - 1 + 96];
      d[m + 0 + 0] = b + x + 1 >> 1, d[m + 2 + 0] = d[m + 0 + 32] = x + L + 1 >> 1, d[m + 2 + 32] = d[m + 0 + 64] = L + M + 1 >> 1, d[m + 1 + 0] = xt(b, x, L), d[m + 3 + 0] = d[m + 1 + 32] = xt(x, L, M), d[m + 3 + 32] = d[m + 1 + 64] = xt(L, M, M), d[m + 3 + 64] = d[m + 2 + 64] = d[m + 0 + 96] = d[m + 1 + 96] = d[m + 2 + 96] = d[m + 3 + 96] = M;
    }
    function Do(d, m) {
      var b = d[m - 1 + 0], x = d[m - 1 + 32], L = d[m - 1 + 64], M = d[m - 1 + 96], k = d[m - 1 - 32], H = d[m + 0 - 32], K = d[m + 1 - 32], q = d[m + 2 - 32];
      d[m + 0 + 0] = d[m + 2 + 32] = b + k + 1 >> 1, d[m + 0 + 32] = d[m + 2 + 64] = x + b + 1 >> 1, d[m + 0 + 64] = d[m + 2 + 96] = L + x + 1 >> 1, d[m + 0 + 96] = M + L + 1 >> 1, d[m + 3 + 0] = xt(H, K, q), d[m + 2 + 0] = xt(k, H, K), d[m + 1 + 0] = d[m + 3 + 32] = xt(b, k, H), d[m + 1 + 32] = d[m + 3 + 64] = xt(x, b, k), d[m + 1 + 64] = d[m + 3 + 96] = xt(L, x, b), d[m + 1 + 96] = xt(M, L, x);
    }
    function $s(d, m) {
      var b;
      for (b = 0; 8 > b; ++b) A(d, m + 32 * b, d, m - 32, 8);
    }
    function Sf(d, m) {
      var b;
      for (b = 0; 8 > b; ++b) n(d, m, d[m - 1], 8), m += 32;
    }
    function Ii(d, m, b) {
      var x;
      for (x = 0; 8 > x; ++x) n(m, b + 32 * x, d, 8);
    }
    function xf(d, m) {
      var b, x = 8;
      for (b = 0; 8 > b; ++b) x += d[m + b - 32] + d[m - 1 + 32 * b];
      Ii(x >> 4, d, m);
    }
    function Go(d, m) {
      var b, x = 4;
      for (b = 0; 8 > b; ++b) x += d[m + b - 32];
      Ii(x >> 3, d, m);
    }
    function Vo(d, m) {
      var b, x = 4;
      for (b = 0; 8 > b; ++b) x += d[m - 1 + 32 * b];
      Ii(x >> 3, d, m);
    }
    function Mu(d, m) {
      Ii(128, d, m);
    }
    function Qi(d, m, b) {
      var x = d[m - b], L = d[m + 0], M = 3 * (L - x) + Ef[1020 + d[m - 2 * b] - d[m + b]], k = ju[112 + (M + 4 >> 3)];
      d[m - b] = cn[255 + x + ju[112 + (M + 3 >> 3)]], d[m + 0] = cn[255 + L - k];
    }
    function Ko(d, m, b, x) {
      var L = d[m + 0], M = d[m + b];
      return Un[255 + d[m - 2 * b] - d[m - b]] > x || Un[255 + M - L] > x;
    }
    function za(d, m, b, x) {
      return 4 * Un[255 + d[m - b] - d[m + 0]] + Un[255 + d[m - 2 * b] - d[m + b]] <= x;
    }
    function jo(d, m, b, x, L) {
      var M = d[m - 3 * b], k = d[m - 2 * b], H = d[m - b], K = d[m + 0], q = d[m + b], Ae = d[m + 2 * b], de = d[m + 3 * b];
      return 4 * Un[255 + H - K] + Un[255 + k - q] > x ? 0 : Un[255 + d[m - 4 * b] - M] <= L && Un[255 + M - k] <= L && Un[255 + k - H] <= L && Un[255 + de - Ae] <= L && Un[255 + Ae - q] <= L && Un[255 + q - K] <= L;
    }
    function Zs(d, m, b, x) {
      var L = 2 * x + 1;
      for (x = 0; 16 > x; ++x) za(d, m + x, b, L) && Qi(d, m + x, b);
    }
    function qo(d, m, b, x) {
      var L = 2 * x + 1;
      for (x = 0; 16 > x; ++x) za(d, m + x * b, 1, L) && Qi(d, m + x * b, 1);
    }
    function Ru(d, m, b, x) {
      var L;
      for (L = 3; 0 < L; --L) Zs(d, m += 4 * b, b, x);
    }
    function ku(d, m, b, x) {
      var L;
      for (L = 3; 0 < L; --L) qo(d, m += 4, b, x);
    }
    function Li(d, m, b, x, L, M, k, H) {
      for (M = 2 * M + 1; 0 < L--; ) {
        if (jo(d, m, b, M, k)) if (Ko(d, m, b, H)) Qi(d, m, b);
        else {
          var K = d, q = m, Ae = b, de = K[q - 2 * Ae], z = K[q - Ae], ae = K[q + 0], he = K[q + Ae], ve = K[q + 2 * Ae], fe = 27 * (be = Ef[1020 + 3 * (ae - z) + Ef[1020 + de - he]]) + 63 >> 7, ye = 18 * be + 63 >> 7, be = 9 * be + 63 >> 7;
          K[q - 3 * Ae] = cn[255 + K[q - 3 * Ae] + be], K[q - 2 * Ae] = cn[255 + de + ye], K[q - Ae] = cn[255 + z + fe], K[q + 0] = cn[255 + ae - fe], K[q + Ae] = cn[255 + he - ye], K[q + 2 * Ae] = cn[255 + ve - be];
        }
        m += x;
      }
    }
    function Ni(d, m, b, x, L, M, k, H) {
      for (M = 2 * M + 1; 0 < L--; ) {
        if (jo(d, m, b, M, k)) if (Ko(d, m, b, H)) Qi(d, m, b);
        else {
          var K = d, q = m, Ae = b, de = K[q - Ae], z = K[q + 0], ae = K[q + Ae], he = ju[112 + (4 + (ve = 3 * (z - de)) >> 3)], ve = ju[112 + (ve + 3 >> 3)], fe = he + 1 >> 1;
          K[q - 2 * Ae] = cn[255 + K[q - 2 * Ae] + fe], K[q - Ae] = cn[255 + de + ve], K[q + 0] = cn[255 + z - he], K[q + Ae] = cn[255 + ae - fe];
        }
        m += x;
      }
    }
    function Hu(d, m, b, x, L, M) {
      Li(d, m, b, 1, 16, x, L, M);
    }
    function ea(d, m, b, x, L, M) {
      Li(d, m, 1, b, 16, x, L, M);
    }
    function Du(d, m, b, x, L, M) {
      var k;
      for (k = 3; 0 < k; --k) Ni(d, m += 4 * b, b, 1, 16, x, L, M);
    }
    function y(d, m, b, x, L, M) {
      var k;
      for (k = 3; 0 < k; --k) Ni(d, m += 4, 1, b, 16, x, L, M);
    }
    function Q(d, m, b, x, L, M, k, H) {
      Li(d, m, L, 1, 8, M, k, H), Li(b, x, L, 1, 8, M, k, H);
    }
    function W(d, m, b, x, L, M, k, H) {
      Li(d, m, 1, L, 8, M, k, H), Li(b, x, 1, L, 8, M, k, H);
    }
    function Z(d, m, b, x, L, M, k, H) {
      Ni(d, m + 4 * L, L, 1, 8, M, k, H), Ni(b, x + 4 * L, L, 1, 8, M, k, H);
    }
    function ce(d, m, b, x, L, M, k, H) {
      Ni(d, m + 4, 1, L, 8, M, k, H), Ni(b, x + 4, 1, L, 8, M, k, H);
    }
    function Be() {
      this.ba = new ut(), this.ec = [], this.cc = [], this.Mc = [], this.Dc = this.Nc = this.dc = this.fc = 0, this.Oa = new Kt(), this.memory = 0, this.Ib = "OutputFunc", this.Jb = "OutputAlphaFunc", this.Nd = "OutputRowFunc";
    }
    function Fe() {
      this.data = [], this.offset = this.kd = this.ha = this.w = 0, this.na = [], this.xa = this.gb = this.Ja = this.Sa = this.P = 0;
    }
    function At() {
      this.nc = this.Ea = this.b = this.hc = 0, this.K = [], this.w = 0;
    }
    function ct() {
      this.ua = 0, this.Wa = new ft(), this.vb = new ft(), this.md = this.xc = this.wc = 0, this.vc = [], this.Wb = 0, this.Ya = new J(), this.yc = new D();
    }
    function St() {
      this.xb = this.a = 0, this.l = new Va(), this.ca = new ut(), this.V = [], this.Ba = 0, this.Ta = [], this.Ua = 0, this.m = new G(), this.Pb = 0, this.wd = new G(), this.Ma = this.$ = this.C = this.i = this.c = this.xd = 0, this.s = new ct(), this.ab = 0, this.gc = s(4, At), this.Oc = 0;
    }
    function It() {
      this.Lc = this.Z = this.$a = this.i = this.c = 0, this.l = new Va(), this.ic = 0, this.ca = [], this.tb = 0, this.qd = null, this.rd = 0;
    }
    function Ht(d, m, b, x, L, M, k) {
      for (d = d == null ? 0 : d[m + 0], m = 0; m < k; ++m) L[M + m] = d + b[x + m] & 255, d = L[M + m];
    }
    function Fr(d, m, b, x, L, M, k) {
      var H;
      if (d == null) Ht(null, null, b, x, L, M, k);
      else for (H = 0; H < k; ++H) L[M + H] = d[m + H] + b[x + H] & 255;
    }
    function $r(d, m, b, x, L, M, k) {
      if (d == null) Ht(null, null, b, x, L, M, k);
      else {
        var H, K = d[m + 0], q = K, Ae = K;
        for (H = 0; H < k; ++H) q = Ae + (K = d[m + H]) - q, Ae = b[x + H] + (-256 & q ? 0 > q ? 0 : 255 : q) & 255, q = K, L[M + H] = Ae;
      }
    }
    function hr(d, m, b, x) {
      var L = m.width, M = m.o;
      if (e(d != null && m != null), 0 > b || 0 >= x || b + x > M) return null;
      if (!d.Cc) {
        if (d.ga == null) {
          var k;
          if (d.ga = new It(), (k = d.ga == null) || (k = m.width * m.o, e(d.Gb.length == 0), d.Gb = i(k), d.Uc = 0, d.Gb == null ? k = 0 : (d.mb = d.Gb, d.nb = d.Uc, d.rc = null, k = 1), k = !k), !k) {
            k = d.ga;
            var H = d.Fa, K = d.P, q = d.qc, Ae = d.mb, de = d.nb, z = K + 1, ae = q - 1, he = k.l;
            if (e(H != null && Ae != null && m != null), ws[0] = null, ws[1] = Ht, ws[2] = Fr, ws[3] = $r, k.ca = Ae, k.tb = de, k.c = m.width, k.i = m.height, e(0 < k.c && 0 < k.i), 1 >= q) m = 0;
            else if (k.$a = 3 & H[K + 0], k.Z = H[K + 0] >> 2 & 3, k.Lc = H[K + 0] >> 4 & 3, K = H[K + 0] >> 6 & 3, 0 > k.$a || 1 < k.$a || 4 <= k.Z || 1 < k.Lc || K) m = 0;
            else if (he.put = vt, he.ac = an, he.bc = Sn, he.ma = k, he.width = m.width, he.height = m.height, he.Da = m.Da, he.v = m.v, he.va = m.va, he.j = m.j, he.o = m.o, k.$a) e: {
              e(k.$a == 1), m = Ei();
              t: for (; ; ) {
                if (m == null) {
                  m = 0;
                  break e;
                }
                if (e(k != null), k.mc = m, m.c = k.c, m.i = k.i, m.l = k.l, m.l.ma = k, m.l.width = k.c, m.l.height = k.i, m.a = 0, re(m.m, H, z, ae), !$e(k.c, k.i, 1, m, null) || (m.ab == 1 && m.gc[0].hc == 3 && Mr(m.s) ? (k.ic = 1, H = m.c * m.i, m.Ta = null, m.Ua = 0, m.V = i(H), m.Ba = 0, m.V == null ? (m.a = 1, m = 0) : m = 1) : (k.ic = 0, m = ne(m, k.c)), !m)) break t;
                m = 1;
                break e;
              }
              k.mc = null, m = 0;
            }
            else m = ae >= k.c * k.i;
            k = !m;
          }
          if (k) return null;
          d.ga.Lc != 1 ? d.Ga = 0 : x = M - b;
        }
        e(d.ga != null), e(b + x <= M);
        e: {
          if (m = (H = d.ga).c, M = H.l.o, H.$a == 0) {
            if (z = d.rc, ae = d.Vc, he = d.Fa, K = d.P + 1 + b * m, q = d.mb, Ae = d.nb + b * m, e(K <= d.P + d.qc), H.Z != 0) for (e(ws[H.Z] != null), k = 0; k < x; ++k) ws[H.Z](z, ae, he, K, q, Ae, m), z = q, ae = Ae, Ae += m, K += m;
            else for (k = 0; k < x; ++k) A(q, Ae, he, K, m), z = q, ae = Ae, Ae += m, K += m;
            d.rc = z, d.Vc = ae;
          } else {
            if (e(H.mc != null), m = b + x, e((k = H.mc) != null), e(m <= k.i), k.C >= m) m = 1;
            else if (H.ic || qn(), H.ic) {
              H = k.V, z = k.Ba, ae = k.c;
              var ve = k.i, fe = (he = 1, K = k.$ / ae, q = k.$ % ae, Ae = k.m, de = k.s, k.$), ye = ae * ve, be = ae * m, Ie = de.wc, _e = fe < be ? Xr(de, q, K) : null;
              e(fe <= ye), e(m <= ve), e(Mr(de));
              t: for (; ; ) {
                for (; !Ae.h && fe < be; ) {
                  if (q & Ie || (_e = Xr(de, q, K)), e(_e != null), oe(Ae), 256 > (ve = ir(_e.G[0], _e.H[0], Ae))) H[z + fe] = ve, ++fe, ++q >= ae && (q = 0, ++K <= m && !(K % 16) && JA(k, K));
                  else {
                    if (!(280 > ve)) {
                      he = 0;
                      break t;
                    }
                    ve = YA(ve - 256, Ae);
                    var ht, Ze = ir(_e.G[4], _e.H[4], Ae);
                    if (oe(Ae), !(fe >= (Ze = xr(ae, Ze = YA(Ze, Ae))) && ye - fe >= ve)) {
                      he = 0;
                      break t;
                    }
                    for (ht = 0; ht < ve; ++ht) H[z + fe + ht] = H[z + fe + ht - Ze];
                    for (fe += ve, q += ve; q >= ae; ) q -= ae, ++K <= m && !(K % 16) && JA(k, K);
                    fe < be && q & Ie && (_e = Xr(de, q, K));
                  }
                  e(Ae.h == Y(Ae));
                }
                JA(k, K > m ? m : K);
                break t;
              }
              !he || Ae.h && fe < ye ? (he = 0, k.a = Ae.h ? 5 : 3) : k.$ = fe, m = he;
            } else m = $A(k, k.V, k.Ba, k.c, k.i, m, Qe);
            if (!m) {
              x = 0;
              break e;
            }
          }
          b + x >= M && (d.Cc = 1), x = 1;
        }
        if (!x) return null;
        if (d.Cc && ((x = d.ga) != null && (x.mc = null), d.ga = null, 0 < d.Ga)) return alert("todo:WebPDequantizeLevels"), null;
      }
      return d.nb + b * L;
    }
    function aA(d, m, b, x, L, M) {
      for (; 0 < L--; ) {
        var k, H = d, K = m + (b ? 1 : 0), q = d, Ae = m + (b ? 0 : 3);
        for (k = 0; k < x; ++k) {
          var de = q[Ae + 4 * k];
          de != 255 && (de *= 32897, H[K + 4 * k + 0] = H[K + 4 * k + 0] * de >> 23, H[K + 4 * k + 1] = H[K + 4 * k + 1] * de >> 23, H[K + 4 * k + 2] = H[K + 4 * k + 2] * de >> 23);
        }
        m += M;
      }
    }
    function Zr(d, m, b, x, L) {
      for (; 0 < x--; ) {
        var M;
        for (M = 0; M < b; ++M) {
          var k = d[m + 2 * M + 0], H = 15 & (q = d[m + 2 * M + 1]), K = 4369 * H, q = (240 & q | q >> 4) * K >> 16;
          d[m + 2 * M + 0] = (240 & k | k >> 4) * K >> 16 & 240 | (15 & k | k << 4) * K >> 16 >> 4 & 15, d[m + 2 * M + 1] = 240 & q | H;
        }
        m += L;
      }
    }
    function wA(d, m, b, x, L, M, k, H) {
      var K, q, Ae = 255;
      for (q = 0; q < L; ++q) {
        for (K = 0; K < x; ++K) {
          var de = d[m + K];
          M[k + 4 * K] = de, Ae &= de;
        }
        m += b, k += H;
      }
      return Ae != 255;
    }
    function Ti(d, m, b, x, L) {
      var M;
      for (M = 0; M < L; ++M) b[x + M] = d[m + M] >> 8;
    }
    function qn() {
      nl = aA, r1 = Zr, A1 = wA, n1 = Ti;
    }
    function Pi(d, m, b) {
      U[d] = function(x, L, M, k, H, K, q, Ae, de, z, ae, he, ve, fe, ye, be, Ie) {
        var _e, ht = Ie - 1 >> 1, Ze = H[K + 0] | q[Ae + 0] << 16, Qt = de[z + 0] | ae[he + 0] << 16;
        e(x != null);
        var st = 3 * Ze + Qt + 131074 >> 2;
        for (m(x[L + 0], 255 & st, st >> 16, ve, fe), M != null && (st = 3 * Qt + Ze + 131074 >> 2, m(M[k + 0], 255 & st, st >> 16, ye, be)), _e = 1; _e <= ht; ++_e) {
          var Rt = H[K + _e] | q[Ae + _e] << 16, lA = de[z + _e] | ae[he + _e] << 16, Lt = Ze + Rt + Qt + lA + 524296, at = Lt + 2 * (Rt + Qt) >> 3;
          st = at + Ze >> 1, Ze = (Lt = Lt + 2 * (Ze + lA) >> 3) + Rt >> 1, m(x[L + 2 * _e - 1], 255 & st, st >> 16, ve, fe + (2 * _e - 1) * b), m(x[L + 2 * _e - 0], 255 & Ze, Ze >> 16, ve, fe + (2 * _e - 0) * b), M != null && (st = Lt + Qt >> 1, Ze = at + lA >> 1, m(M[k + 2 * _e - 1], 255 & st, st >> 16, ye, be + (2 * _e - 1) * b), m(M[k + 2 * _e + 0], 255 & Ze, Ze >> 16, ye, be + (2 * _e + 0) * b)), Ze = Rt, Qt = lA;
        }
        1 & Ie || (st = 3 * Ze + Qt + 131074 >> 2, m(x[L + Ie - 1], 255 & st, st >> 16, ve, fe + (Ie - 1) * b), M != null && (st = 3 * Qt + Ze + 131074 >> 2, m(M[k + Ie - 1], 255 & st, st >> 16, ye, be + (Ie - 1) * b)));
      };
    }
    function zo() {
      In[qu] = t4, In[zu] = g1, In[u1] = r4, In[Wu] = p1, In[Xu] = m1, In[Ff] = v1, In[c1] = A4, In[_f] = g1, In[Uf] = p1, In[Yu] = m1, In[If] = v1;
    }
    function Wa(d) {
      return d & -16384 ? 0 > d ? 0 : 255 : d >> n4;
    }
    function ls(d, m) {
      return Wa((19077 * d >> 8) + (26149 * m >> 8) - 14234);
    }
    function ta(d, m, b) {
      return Wa((19077 * d >> 8) - (6419 * m >> 8) - (13320 * b >> 8) + 8708);
    }
    function ra(d, m) {
      return Wa((19077 * d >> 8) + (33050 * m >> 8) - 17685);
    }
    function us(d, m, b, x, L) {
      x[L + 0] = ls(d, b), x[L + 1] = ta(d, m, b), x[L + 2] = ra(d, m);
    }
    function yA(d, m, b, x, L) {
      x[L + 0] = ra(d, m), x[L + 1] = ta(d, m, b), x[L + 2] = ls(d, b);
    }
    function Aa(d, m, b, x, L) {
      var M = ta(d, m, b);
      m = M << 3 & 224 | ra(d, m) >> 3, x[L + 0] = 248 & ls(d, b) | M >> 5, x[L + 1] = m;
    }
    function na(d, m, b, x, L) {
      var M = 240 & ra(d, m) | 15;
      x[L + 0] = 240 & ls(d, b) | ta(d, m, b) >> 4, x[L + 1] = M;
    }
    function Wo(d, m, b, x, L) {
      x[L + 0] = 255, us(d, m, b, x, L + 1);
    }
    function Xo(d, m, b, x, L) {
      yA(d, m, b, x, L), x[L + 3] = 255;
    }
    function HA(d, m, b, x, L) {
      us(d, m, b, x, L), x[L + 3] = 255;
    }
    function Oi(d, m, b) {
      U[d] = function(x, L, M, k, H, K, q, Ae, de) {
        for (var z = Ae + (-2 & de) * b; Ae != z; ) m(x[L + 0], M[k + 0], H[K + 0], q, Ae), m(x[L + 1], M[k + 0], H[K + 0], q, Ae + b), L += 2, ++k, ++K, Ae += 2 * b;
        1 & de && m(x[L + 0], M[k + 0], H[K + 0], q, Ae);
      };
    }
    function Xa(d, m, b) {
      return b == 0 ? d == 0 ? m == 0 ? 6 : 5 : m == 0 ? 4 : 0 : b;
    }
    function Gu(d, m, b, x, L) {
      switch (d >>> 30) {
        case 3:
          oa(m, b, x, L, 0);
          break;
        case 2:
          _n(m, b, x, L);
          break;
        case 1:
          Jt(m, b, x, L);
      }
    }
    function Fn(d, m) {
      var b, x, L = m.M, M = m.Nb, k = d.oc, H = d.pc + 40, K = d.oc, q = d.pc + 584, Ae = d.oc, de = d.pc + 600;
      for (b = 0; 16 > b; ++b) k[H + 32 * b - 1] = 129;
      for (b = 0; 8 > b; ++b) K[q + 32 * b - 1] = 129, Ae[de + 32 * b - 1] = 129;
      for (0 < L ? k[H - 1 - 32] = K[q - 1 - 32] = Ae[de - 1 - 32] = 129 : (n(k, H - 32 - 1, 127, 21), n(K, q - 32 - 1, 127, 9), n(Ae, de - 32 - 1, 127, 9)), x = 0; x < d.za; ++x) {
        var z = m.ya[m.aa + x];
        if (0 < x) {
          for (b = -1; 16 > b; ++b) A(k, H + 32 * b - 4, k, H + 32 * b + 12, 4);
          for (b = -1; 8 > b; ++b) A(K, q + 32 * b - 4, K, q + 32 * b + 4, 4), A(Ae, de + 32 * b - 4, Ae, de + 32 * b + 4, 4);
        }
        var ae = d.Gd, he = d.Hd + x, ve = z.ad, fe = z.Hc;
        if (0 < L && (A(k, H - 32, ae[he].y, 0, 16), A(K, q - 32, ae[he].f, 0, 8), A(Ae, de - 32, ae[he].ea, 0, 8)), z.Za) {
          var ye = k, be = H - 32 + 16;
          for (0 < L && (x >= d.za - 1 ? n(ye, be, ae[he].y[15], 4) : A(ye, be, ae[he + 1].y, 0, 4)), b = 0; 4 > b; b++) ye[be + 128 + b] = ye[be + 256 + b] = ye[be + 384 + b] = ye[be + 0 + b];
          for (b = 0; 16 > b; ++b, fe <<= 2) ye = k, be = H + y1[b], zn[z.Ob[b]](ye, be), Gu(fe, ve, 16 * +b, ye, be);
        } else if (ye = Xa(x, L, z.Ob[0]), vs[ye](k, H), fe != 0) for (b = 0; 16 > b; ++b, fe <<= 2) Gu(fe, ve, 16 * +b, k, H + y1[b]);
        for (b = z.Gc, ye = Xa(x, L, z.Dd), ki[ye](K, q), ki[ye](Ae, de), fe = ve, ye = K, be = q, 255 & (z = 0 | b) && (170 & z ? di(fe, 256, ye, be) : sr(fe, 256, ye, be)), z = Ae, fe = de, 255 & (b >>= 8) && (170 & b ? di(ve, 320, z, fe) : sr(ve, 320, z, fe)), L < d.Ub - 1 && (A(ae[he].y, 0, k, H + 480, 16), A(ae[he].f, 0, K, q + 224, 8), A(ae[he].ea, 0, Ae, de + 224, 8)), b = 8 * M * d.B, ae = d.sa, he = d.ta + 16 * x + 16 * M * d.R, ve = d.qa, z = d.ra + 8 * x + b, fe = d.Ha, ye = d.Ia + 8 * x + b, b = 0; 16 > b; ++b) A(ae, he + b * d.R, k, H + 32 * b, 16);
        for (b = 0; 8 > b; ++b) A(ve, z + b * d.B, K, q + 32 * b, 8), A(fe, ye + b * d.B, Ae, de + 32 * b, 8);
      }
    }
    function ia(d, m, b, x, L, M, k, H, K) {
      var q = [0], Ae = [0], de = 0, z = K != null ? K.kd : 0, ae = K ?? new Fe();
      if (d == null || 12 > b) return 7;
      ae.data = d, ae.w = m, ae.ha = b, m = [m], b = [b], ae.gb = [ae.gb];
      e: {
        var he = m, ve = b, fe = ae.gb;
        if (e(d != null), e(ve != null), e(fe != null), fe[0] = 0, 12 <= ve[0] && !t(d, he[0], "RIFF")) {
          if (t(d, he[0] + 8, "WEBP")) {
            fe = 3;
            break e;
          }
          var ye = Ge(d, he[0] + 4);
          if (12 > ye || 4294967286 < ye) {
            fe = 3;
            break e;
          }
          if (z && ye > ve[0] - 8) {
            fe = 7;
            break e;
          }
          fe[0] = ye, he[0] += 12, ve[0] -= 12;
        }
        fe = 0;
      }
      if (fe != 0) return fe;
      for (ye = 0 < ae.gb[0], b = b[0]; ; ) {
        e: {
          var be = d;
          ve = m, fe = b;
          var Ie = q, _e = Ae, ht = he = [0];
          if ((st = de = [de])[0] = 0, 8 > fe[0]) fe = 7;
          else {
            if (!t(be, ve[0], "VP8X")) {
              if (Ge(be, ve[0] + 4) != 10) {
                fe = 3;
                break e;
              }
              if (18 > fe[0]) {
                fe = 7;
                break e;
              }
              var Ze = Ge(be, ve[0] + 8), Qt = 1 + Te(be, ve[0] + 12);
              if (2147483648 <= Qt * (be = 1 + Te(be, ve[0] + 15))) {
                fe = 3;
                break e;
              }
              ht != null && (ht[0] = Ze), Ie != null && (Ie[0] = Qt), _e != null && (_e[0] = be), ve[0] += 18, fe[0] -= 18, st[0] = 1;
            }
            fe = 0;
          }
        }
        if (de = de[0], he = he[0], fe != 0) return fe;
        if (ve = !!(2 & he), !ye && de) return 3;
        if (M != null && (M[0] = !!(16 & he)), k != null && (k[0] = ve), H != null && (H[0] = 0), k = q[0], he = Ae[0], de && ve && K == null) {
          fe = 0;
          break;
        }
        if (4 > b) {
          fe = 7;
          break;
        }
        if (ye && de || !ye && !de && !t(d, m[0], "ALPH")) {
          b = [b], ae.na = [ae.na], ae.P = [ae.P], ae.Sa = [ae.Sa];
          e: {
            Ze = d, fe = m, ye = b;
            var st = ae.gb;
            Ie = ae.na, _e = ae.P, ht = ae.Sa, Qt = 22, e(Ze != null), e(ye != null), be = fe[0];
            var Rt = ye[0];
            for (e(Ie != null), e(ht != null), Ie[0] = null, _e[0] = null, ht[0] = 0; ; ) {
              if (fe[0] = be, ye[0] = Rt, 8 > Rt) {
                fe = 7;
                break e;
              }
              var lA = Ge(Ze, be + 4);
              if (4294967286 < lA) {
                fe = 3;
                break e;
              }
              var Lt = 8 + lA + 1 & -2;
              if (Qt += Lt, 0 < st && Qt > st) {
                fe = 3;
                break e;
              }
              if (!t(Ze, be, "VP8 ") || !t(Ze, be, "VP8L")) {
                fe = 0;
                break e;
              }
              if (Rt[0] < Lt) {
                fe = 7;
                break e;
              }
              t(Ze, be, "ALPH") || (Ie[0] = Ze, _e[0] = be + 8, ht[0] = lA), be += Lt, Rt -= Lt;
            }
          }
          if (b = b[0], ae.na = ae.na[0], ae.P = ae.P[0], ae.Sa = ae.Sa[0], fe != 0) break;
        }
        b = [b], ae.Ja = [ae.Ja], ae.xa = [ae.xa];
        e: if (st = d, fe = m, ye = b, Ie = ae.gb[0], _e = ae.Ja, ht = ae.xa, Ze = fe[0], be = !t(st, Ze, "VP8 "), Qt = !t(st, Ze, "VP8L"), e(st != null), e(ye != null), e(_e != null), e(ht != null), 8 > ye[0]) fe = 7;
        else {
          if (be || Qt) {
            if (st = Ge(st, Ze + 4), 12 <= Ie && st > Ie - 12) {
              fe = 3;
              break e;
            }
            if (z && st > ye[0] - 8) {
              fe = 7;
              break e;
            }
            _e[0] = st, fe[0] += 8, ye[0] -= 8, ht[0] = Qt;
          } else ht[0] = 5 <= ye[0] && st[Ze + 0] == 47 && !(st[Ze + 4] >> 5), _e[0] = ye[0];
          fe = 0;
        }
        if (b = b[0], ae.Ja = ae.Ja[0], ae.xa = ae.xa[0], m = m[0], fe != 0) break;
        if (4294967286 < ae.Ja) return 3;
        if (H == null || ve || (H[0] = ae.xa ? 2 : 1), k = [k], he = [he], ae.xa) {
          if (5 > b) {
            fe = 7;
            break;
          }
          H = k, z = he, ve = M, d == null || 5 > b ? d = 0 : 5 <= b && d[m + 0] == 47 && !(d[m + 4] >> 5) ? (ye = [0], st = [0], Ie = [0], re(_e = new G(), d, m, b), xn(_e, ye, st, Ie) ? (H != null && (H[0] = ye[0]), z != null && (z[0] = st[0]), ve != null && (ve[0] = Ie[0]), d = 1) : d = 0) : d = 0;
        } else {
          if (10 > b) {
            fe = 7;
            break;
          }
          H = he, d == null || 10 > b || !Qu(d, m + 3, b - 3) ? d = 0 : (z = d[m + 0] | d[m + 1] << 8 | d[m + 2] << 16, ve = 16383 & (d[m + 7] << 8 | d[m + 6]), d = 16383 & (d[m + 9] << 8 | d[m + 8]), 1 & z || 3 < (z >> 1 & 7) || !(z >> 4 & 1) || z >> 5 >= ae.Ja || !ve || !d ? d = 0 : (k && (k[0] = ve), H && (H[0] = d), d = 1));
        }
        if (!d || (k = k[0], he = he[0], de && (q[0] != k || Ae[0] != he))) return 3;
        K != null && (K[0] = ae, K.offset = m - K.w, e(4294967286 > m - K.w), e(K.offset == K.ha - b));
        break;
      }
      return fe == 0 || fe == 7 && de && K == null ? (M != null && (M[0] |= ae.na != null && 0 < ae.na.length), x != null && (x[0] = k), L != null && (L[0] = he), 0) : fe;
    }
    function Yo(d, m, b) {
      var x = m.width, L = m.height, M = 0, k = 0, H = x, K = L;
      if (m.Da = d != null && 0 < d.Da, m.Da && (H = d.cd, K = d.bd, M = d.v, k = d.j, 11 > b || (M &= -2, k &= -2), 0 > M || 0 > k || 0 >= H || 0 >= K || M + H > x || k + K > L)) return 0;
      if (m.v = M, m.j = k, m.va = M + H, m.o = k + K, m.U = H, m.T = K, m.da = d != null && 0 < d.da, m.da) {
        if (!et(H, K, b = [d.ib], M = [d.hb])) return 0;
        m.ib = b[0], m.hb = M[0];
      }
      return m.ob = d != null && d.ob, m.Kb = d == null || !d.Sd, m.da && (m.ob = m.ib < 3 * x / 4 && m.hb < 3 * L / 4, m.Kb = 0), 1;
    }
    function Jo(d) {
      if (d == null) return 2;
      if (11 > d.S) {
        var m = d.f.RGBA;
        m.fb += (d.height - 1) * m.A, m.A = -m.A;
      } else m = d.f.kb, d = d.height, m.O += (d - 1) * m.fa, m.fa = -m.fa, m.N += (d - 1 >> 1) * m.Ab, m.Ab = -m.Ab, m.W += (d - 1 >> 1) * m.Db, m.Db = -m.Db, m.F != null && (m.J += (d - 1) * m.lb, m.lb = -m.lb);
      return 0;
    }
    function cs(d, m, b, x) {
      if (x == null || 0 >= d || 0 >= m) return 2;
      if (b != null) {
        if (b.Da) {
          var L = b.cd, M = b.bd, k = -2 & b.v, H = -2 & b.j;
          if (0 > k || 0 > H || 0 >= L || 0 >= M || k + L > d || H + M > m) return 2;
          d = L, m = M;
        }
        if (b.da) {
          if (!et(d, m, L = [b.ib], M = [b.hb])) return 2;
          d = L[0], m = M[0];
        }
      }
      x.width = d, x.height = m;
      e: {
        var K = x.width, q = x.height;
        if (d = x.S, 0 >= K || 0 >= q || !(d >= qu && 13 > d)) d = 2;
        else {
          if (0 >= x.Rd && x.sd == null) {
            k = M = L = m = 0;
            var Ae = (H = K * B1[d]) * q;
            if (11 > d || (M = (q + 1) / 2 * (m = (K + 1) / 2), d == 12 && (k = (L = K) * q)), (q = i(Ae + 2 * M + k)) == null) {
              d = 1;
              break e;
            }
            x.sd = q, 11 > d ? ((K = x.f.RGBA).eb = q, K.fb = 0, K.A = H, K.size = Ae) : ((K = x.f.kb).y = q, K.O = 0, K.fa = H, K.Fd = Ae, K.f = q, K.N = 0 + Ae, K.Ab = m, K.Cd = M, K.ea = q, K.W = 0 + Ae + M, K.Db = m, K.Ed = M, d == 12 && (K.F = q, K.J = 0 + Ae + 2 * M), K.Tc = k, K.lb = L);
          }
          if (m = 1, L = x.S, M = x.width, k = x.height, L >= qu && 13 > L) if (11 > L) d = x.f.RGBA, m &= (H = Math.abs(d.A)) * (k - 1) + M <= d.size, m &= H >= M * B1[L], m &= d.eb != null;
          else {
            d = x.f.kb, H = (M + 1) / 2, Ae = (k + 1) / 2, K = Math.abs(d.fa), q = Math.abs(d.Ab);
            var de = Math.abs(d.Db), z = Math.abs(d.lb), ae = z * (k - 1) + M;
            m &= K * (k - 1) + M <= d.Fd, m &= q * (Ae - 1) + H <= d.Cd, m = (m &= de * (Ae - 1) + H <= d.Ed) & K >= M & q >= H & de >= H, m &= d.y != null, m &= d.f != null, m &= d.ea != null, L == 12 && (m &= z >= M, m &= ae <= d.Tc, m &= d.F != null);
          }
          else m = 0;
          d = m ? 0 : 2;
        }
      }
      return d != 0 || b != null && b.fd && (d = Jo(x)), d;
    }
    var sa = 64, ln = [0, 1, 3, 7, 15, 31, 63, 127, 255, 511, 1023, 2047, 4095, 8191, 16383, 32767, 65535, 131071, 262143, 524287, 1048575, 2097151, 4194303, 8388607, 16777215], un = 24, hs = 32, Mi = 8, fs = [0, 0, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7];
    ke("Predictor0", "PredictorAdd0"), U.Predictor0 = function() {
      return 4278190080;
    }, U.Predictor1 = function(d) {
      return d;
    }, U.Predictor2 = function(d, m, b) {
      return m[b + 0];
    }, U.Predictor3 = function(d, m, b) {
      return m[b + 1];
    }, U.Predictor4 = function(d, m, b) {
      return m[b - 1];
    }, U.Predictor5 = function(d, m, b) {
      return ze(ze(d, m[b + 1]), m[b + 0]);
    }, U.Predictor6 = function(d, m, b) {
      return ze(d, m[b - 1]);
    }, U.Predictor7 = function(d, m, b) {
      return ze(d, m[b + 0]);
    }, U.Predictor8 = function(d, m, b) {
      return ze(m[b - 1], m[b + 0]);
    }, U.Predictor9 = function(d, m, b) {
      return ze(m[b + 0], m[b + 1]);
    }, U.Predictor10 = function(d, m, b) {
      return ze(ze(d, m[b - 1]), ze(m[b + 0], m[b + 1]));
    }, U.Predictor11 = function(d, m, b) {
      var x = m[b + 0];
      return 0 >= Re(x >> 24 & 255, d >> 24 & 255, (m = m[b - 1]) >> 24 & 255) + Re(x >> 16 & 255, d >> 16 & 255, m >> 16 & 255) + Re(x >> 8 & 255, d >> 8 & 255, m >> 8 & 255) + Re(255 & x, 255 & d, 255 & m) ? x : d;
    }, U.Predictor12 = function(d, m, b) {
      var x = m[b + 0];
      return (Ce((d >> 24 & 255) + (x >> 24 & 255) - ((m = m[b - 1]) >> 24 & 255)) << 24 | Ce((d >> 16 & 255) + (x >> 16 & 255) - (m >> 16 & 255)) << 16 | Ce((d >> 8 & 255) + (x >> 8 & 255) - (m >> 8 & 255)) << 8 | Ce((255 & d) + (255 & x) - (255 & m))) >>> 0;
    }, U.Predictor13 = function(d, m, b) {
      var x = m[b - 1];
      return (Oe((d = ze(d, m[b + 0])) >> 24 & 255, x >> 24 & 255) << 24 | Oe(d >> 16 & 255, x >> 16 & 255) << 16 | Oe(d >> 8 & 255, x >> 8 & 255) << 8 | Oe(255 & d, 255 & x)) >>> 0;
    };
    var $o = U.PredictorAdd0;
    U.PredictorAdd1 = Ke, ke("Predictor2", "PredictorAdd2"), ke("Predictor3", "PredictorAdd3"), ke("Predictor4", "PredictorAdd4"), ke("Predictor5", "PredictorAdd5"), ke("Predictor6", "PredictorAdd6"), ke("Predictor7", "PredictorAdd7"), ke("Predictor8", "PredictorAdd8"), ke("Predictor9", "PredictorAdd9"), ke("Predictor10", "PredictorAdd10"), ke("Predictor11", "PredictorAdd11"), ke("Predictor12", "PredictorAdd12"), ke("Predictor13", "PredictorAdd13");
    var Ya = U.PredictorAdd2;
    je("ColorIndexInverseTransform", "MapARGB", "32b", function(d) {
      return d >> 8 & 255;
    }, function(d) {
      return d;
    }), je("VP8LColorIndexInverseTransformAlpha", "MapAlpha", "8b", function(d) {
      return d;
    }, function(d) {
      return d >> 8 & 255;
    });
    var kr, Vu = U.ColorIndexInverseTransform, hi = U.MapARGB, fi = U.VP8LColorIndexInverseTransformAlpha, Zo = U.MapAlpha, el = U.VP8LPredictorsAdd = [];
    el.length = 16, (U.VP8LPredictors = []).length = 16, (U.VP8LPredictorsAdd_C = []).length = 16, (U.VP8LPredictors_C = []).length = 16;
    var tl, rl, ds, gs, ps, aa, ms, oa, _n, di, Jt, sr, Hr, oA, Ri, Al, Ja, Ku, Yv, Jv, $v, Zv, e1, t1, nl, r1, A1, n1, i1 = i(511), s1 = i(2041), a1 = i(225), o1 = i(767), l1 = 0, Ef = s1, ju = a1, cn = o1, Un = i1, qu = 0, zu = 1, u1 = 2, Wu = 3, Xu = 4, Ff = 5, c1 = 6, _f = 7, Uf = 8, Yu = 9, If = 10, DF = [2, 3, 7], GF = [3, 3, 11], h1 = [280, 256, 256, 256, 40], VF = [0, 1, 1, 1, 0], KF = [17, 18, 0, 1, 2, 3, 4, 5, 16, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], jF = [24, 7, 23, 25, 40, 6, 39, 41, 22, 26, 38, 42, 56, 5, 55, 57, 21, 27, 54, 58, 37, 43, 72, 4, 71, 73, 20, 28, 53, 59, 70, 74, 36, 44, 88, 69, 75, 52, 60, 3, 87, 89, 19, 29, 86, 90, 35, 45, 68, 76, 85, 91, 51, 61, 104, 2, 103, 105, 18, 30, 102, 106, 34, 46, 84, 92, 67, 77, 101, 107, 50, 62, 120, 1, 119, 121, 83, 93, 17, 31, 100, 108, 66, 78, 118, 122, 33, 47, 117, 123, 49, 63, 99, 109, 82, 94, 0, 116, 124, 65, 79, 16, 32, 98, 110, 48, 115, 125, 81, 95, 64, 114, 126, 97, 111, 80, 113, 127, 96, 112], qF = [2954, 2956, 2958, 2962, 2970, 2986, 3018, 3082, 3212, 3468, 3980, 5004], zF = 8, Qf = [4, 5, 6, 7, 8, 9, 10, 10, 11, 12, 13, 14, 15, 16, 17, 17, 18, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 25, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 91, 93, 95, 96, 98, 100, 101, 102, 104, 106, 108, 110, 112, 114, 116, 118, 122, 124, 126, 128, 130, 132, 134, 136, 138, 140, 143, 145, 148, 151, 154, 157], Lf = [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 60, 62, 64, 66, 68, 70, 72, 74, 76, 78, 80, 82, 84, 86, 88, 90, 92, 94, 96, 98, 100, 102, 104, 106, 108, 110, 112, 114, 116, 119, 122, 125, 128, 131, 134, 137, 140, 143, 146, 149, 152, 155, 158, 161, 164, 167, 170, 173, 177, 181, 185, 189, 193, 197, 201, 205, 209, 213, 217, 221, 225, 229, 234, 239, 245, 249, 254, 259, 264, 269, 274, 279, 284], il = null, WF = [[173, 148, 140, 0], [176, 155, 140, 135, 0], [180, 157, 141, 134, 130, 0], [254, 254, 243, 230, 196, 177, 153, 140, 133, 130, 129, 0]], XF = [0, 1, 4, 8, 5, 2, 3, 6, 9, 12, 13, 10, 7, 11, 14, 15], f1 = [-0, 1, -1, 2, -2, 3, 4, 6, -3, 5, -4, -5, -6, 7, -7, 8, -8, -9], YF = [[[[128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128]], [[253, 136, 254, 255, 228, 219, 128, 128, 128, 128, 128], [189, 129, 242, 255, 227, 213, 255, 219, 128, 128, 128], [106, 126, 227, 252, 214, 209, 255, 255, 128, 128, 128]], [[1, 98, 248, 255, 236, 226, 255, 255, 128, 128, 128], [181, 133, 238, 254, 221, 234, 255, 154, 128, 128, 128], [78, 134, 202, 247, 198, 180, 255, 219, 128, 128, 128]], [[1, 185, 249, 255, 243, 255, 128, 128, 128, 128, 128], [184, 150, 247, 255, 236, 224, 128, 128, 128, 128, 128], [77, 110, 216, 255, 236, 230, 128, 128, 128, 128, 128]], [[1, 101, 251, 255, 241, 255, 128, 128, 128, 128, 128], [170, 139, 241, 252, 236, 209, 255, 255, 128, 128, 128], [37, 116, 196, 243, 228, 255, 255, 255, 128, 128, 128]], [[1, 204, 254, 255, 245, 255, 128, 128, 128, 128, 128], [207, 160, 250, 255, 238, 128, 128, 128, 128, 128, 128], [102, 103, 231, 255, 211, 171, 128, 128, 128, 128, 128]], [[1, 152, 252, 255, 240, 255, 128, 128, 128, 128, 128], [177, 135, 243, 255, 234, 225, 128, 128, 128, 128, 128], [80, 129, 211, 255, 194, 224, 128, 128, 128, 128, 128]], [[1, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [246, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [255, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128]]], [[[198, 35, 237, 223, 193, 187, 162, 160, 145, 155, 62], [131, 45, 198, 221, 172, 176, 220, 157, 252, 221, 1], [68, 47, 146, 208, 149, 167, 221, 162, 255, 223, 128]], [[1, 149, 241, 255, 221, 224, 255, 255, 128, 128, 128], [184, 141, 234, 253, 222, 220, 255, 199, 128, 128, 128], [81, 99, 181, 242, 176, 190, 249, 202, 255, 255, 128]], [[1, 129, 232, 253, 214, 197, 242, 196, 255, 255, 128], [99, 121, 210, 250, 201, 198, 255, 202, 128, 128, 128], [23, 91, 163, 242, 170, 187, 247, 210, 255, 255, 128]], [[1, 200, 246, 255, 234, 255, 128, 128, 128, 128, 128], [109, 178, 241, 255, 231, 245, 255, 255, 128, 128, 128], [44, 130, 201, 253, 205, 192, 255, 255, 128, 128, 128]], [[1, 132, 239, 251, 219, 209, 255, 165, 128, 128, 128], [94, 136, 225, 251, 218, 190, 255, 255, 128, 128, 128], [22, 100, 174, 245, 186, 161, 255, 199, 128, 128, 128]], [[1, 182, 249, 255, 232, 235, 128, 128, 128, 128, 128], [124, 143, 241, 255, 227, 234, 128, 128, 128, 128, 128], [35, 77, 181, 251, 193, 211, 255, 205, 128, 128, 128]], [[1, 157, 247, 255, 236, 231, 255, 255, 128, 128, 128], [121, 141, 235, 255, 225, 227, 255, 255, 128, 128, 128], [45, 99, 188, 251, 195, 217, 255, 224, 128, 128, 128]], [[1, 1, 251, 255, 213, 255, 128, 128, 128, 128, 128], [203, 1, 248, 255, 255, 128, 128, 128, 128, 128, 128], [137, 1, 177, 255, 224, 255, 128, 128, 128, 128, 128]]], [[[253, 9, 248, 251, 207, 208, 255, 192, 128, 128, 128], [175, 13, 224, 243, 193, 185, 249, 198, 255, 255, 128], [73, 17, 171, 221, 161, 179, 236, 167, 255, 234, 128]], [[1, 95, 247, 253, 212, 183, 255, 255, 128, 128, 128], [239, 90, 244, 250, 211, 209, 255, 255, 128, 128, 128], [155, 77, 195, 248, 188, 195, 255, 255, 128, 128, 128]], [[1, 24, 239, 251, 218, 219, 255, 205, 128, 128, 128], [201, 51, 219, 255, 196, 186, 128, 128, 128, 128, 128], [69, 46, 190, 239, 201, 218, 255, 228, 128, 128, 128]], [[1, 191, 251, 255, 255, 128, 128, 128, 128, 128, 128], [223, 165, 249, 255, 213, 255, 128, 128, 128, 128, 128], [141, 124, 248, 255, 255, 128, 128, 128, 128, 128, 128]], [[1, 16, 248, 255, 255, 128, 128, 128, 128, 128, 128], [190, 36, 230, 255, 236, 255, 128, 128, 128, 128, 128], [149, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128]], [[1, 226, 255, 128, 128, 128, 128, 128, 128, 128, 128], [247, 192, 255, 128, 128, 128, 128, 128, 128, 128, 128], [240, 128, 255, 128, 128, 128, 128, 128, 128, 128, 128]], [[1, 134, 252, 255, 255, 128, 128, 128, 128, 128, 128], [213, 62, 250, 255, 255, 128, 128, 128, 128, 128, 128], [55, 93, 255, 128, 128, 128, 128, 128, 128, 128, 128]], [[128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128]]], [[[202, 24, 213, 235, 186, 191, 220, 160, 240, 175, 255], [126, 38, 182, 232, 169, 184, 228, 174, 255, 187, 128], [61, 46, 138, 219, 151, 178, 240, 170, 255, 216, 128]], [[1, 112, 230, 250, 199, 191, 247, 159, 255, 255, 128], [166, 109, 228, 252, 211, 215, 255, 174, 128, 128, 128], [39, 77, 162, 232, 172, 180, 245, 178, 255, 255, 128]], [[1, 52, 220, 246, 198, 199, 249, 220, 255, 255, 128], [124, 74, 191, 243, 183, 193, 250, 221, 255, 255, 128], [24, 71, 130, 219, 154, 170, 243, 182, 255, 255, 128]], [[1, 182, 225, 249, 219, 240, 255, 224, 128, 128, 128], [149, 150, 226, 252, 216, 205, 255, 171, 128, 128, 128], [28, 108, 170, 242, 183, 194, 254, 223, 255, 255, 128]], [[1, 81, 230, 252, 204, 203, 255, 192, 128, 128, 128], [123, 102, 209, 247, 188, 196, 255, 233, 128, 128, 128], [20, 95, 153, 243, 164, 173, 255, 203, 128, 128, 128]], [[1, 222, 248, 255, 216, 213, 128, 128, 128, 128, 128], [168, 175, 246, 252, 235, 205, 255, 255, 128, 128, 128], [47, 116, 215, 255, 211, 212, 255, 255, 128, 128, 128]], [[1, 121, 236, 253, 212, 214, 255, 255, 128, 128, 128], [141, 84, 213, 252, 201, 202, 255, 219, 128, 128, 128], [42, 80, 160, 240, 162, 185, 255, 205, 128, 128, 128]], [[1, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [244, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [238, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128]]]], JF = [[[231, 120, 48, 89, 115, 113, 120, 152, 112], [152, 179, 64, 126, 170, 118, 46, 70, 95], [175, 69, 143, 80, 85, 82, 72, 155, 103], [56, 58, 10, 171, 218, 189, 17, 13, 152], [114, 26, 17, 163, 44, 195, 21, 10, 173], [121, 24, 80, 195, 26, 62, 44, 64, 85], [144, 71, 10, 38, 171, 213, 144, 34, 26], [170, 46, 55, 19, 136, 160, 33, 206, 71], [63, 20, 8, 114, 114, 208, 12, 9, 226], [81, 40, 11, 96, 182, 84, 29, 16, 36]], [[134, 183, 89, 137, 98, 101, 106, 165, 148], [72, 187, 100, 130, 157, 111, 32, 75, 80], [66, 102, 167, 99, 74, 62, 40, 234, 128], [41, 53, 9, 178, 241, 141, 26, 8, 107], [74, 43, 26, 146, 73, 166, 49, 23, 157], [65, 38, 105, 160, 51, 52, 31, 115, 128], [104, 79, 12, 27, 217, 255, 87, 17, 7], [87, 68, 71, 44, 114, 51, 15, 186, 23], [47, 41, 14, 110, 182, 183, 21, 17, 194], [66, 45, 25, 102, 197, 189, 23, 18, 22]], [[88, 88, 147, 150, 42, 46, 45, 196, 205], [43, 97, 183, 117, 85, 38, 35, 179, 61], [39, 53, 200, 87, 26, 21, 43, 232, 171], [56, 34, 51, 104, 114, 102, 29, 93, 77], [39, 28, 85, 171, 58, 165, 90, 98, 64], [34, 22, 116, 206, 23, 34, 43, 166, 73], [107, 54, 32, 26, 51, 1, 81, 43, 31], [68, 25, 106, 22, 64, 171, 36, 225, 114], [34, 19, 21, 102, 132, 188, 16, 76, 124], [62, 18, 78, 95, 85, 57, 50, 48, 51]], [[193, 101, 35, 159, 215, 111, 89, 46, 111], [60, 148, 31, 172, 219, 228, 21, 18, 111], [112, 113, 77, 85, 179, 255, 38, 120, 114], [40, 42, 1, 196, 245, 209, 10, 25, 109], [88, 43, 29, 140, 166, 213, 37, 43, 154], [61, 63, 30, 155, 67, 45, 68, 1, 209], [100, 80, 8, 43, 154, 1, 51, 26, 71], [142, 78, 78, 16, 255, 128, 34, 197, 171], [41, 40, 5, 102, 211, 183, 4, 1, 221], [51, 50, 17, 168, 209, 192, 23, 25, 82]], [[138, 31, 36, 171, 27, 166, 38, 44, 229], [67, 87, 58, 169, 82, 115, 26, 59, 179], [63, 59, 90, 180, 59, 166, 93, 73, 154], [40, 40, 21, 116, 143, 209, 34, 39, 175], [47, 15, 16, 183, 34, 223, 49, 45, 183], [46, 17, 33, 183, 6, 98, 15, 32, 183], [57, 46, 22, 24, 128, 1, 54, 17, 37], [65, 32, 73, 115, 28, 128, 23, 128, 205], [40, 3, 9, 115, 51, 192, 18, 6, 223], [87, 37, 9, 115, 59, 77, 64, 21, 47]], [[104, 55, 44, 218, 9, 54, 53, 130, 226], [64, 90, 70, 205, 40, 41, 23, 26, 57], [54, 57, 112, 184, 5, 41, 38, 166, 213], [30, 34, 26, 133, 152, 116, 10, 32, 134], [39, 19, 53, 221, 26, 114, 32, 73, 255], [31, 9, 65, 234, 2, 15, 1, 118, 73], [75, 32, 12, 51, 192, 255, 160, 43, 51], [88, 31, 35, 67, 102, 85, 55, 186, 85], [56, 21, 23, 111, 59, 205, 45, 37, 192], [55, 38, 70, 124, 73, 102, 1, 34, 98]], [[125, 98, 42, 88, 104, 85, 117, 175, 82], [95, 84, 53, 89, 128, 100, 113, 101, 45], [75, 79, 123, 47, 51, 128, 81, 171, 1], [57, 17, 5, 71, 102, 57, 53, 41, 49], [38, 33, 13, 121, 57, 73, 26, 1, 85], [41, 10, 67, 138, 77, 110, 90, 47, 114], [115, 21, 2, 10, 102, 255, 166, 23, 6], [101, 29, 16, 10, 85, 128, 101, 196, 26], [57, 18, 10, 102, 102, 213, 34, 20, 43], [117, 20, 15, 36, 163, 128, 68, 1, 26]], [[102, 61, 71, 37, 34, 53, 31, 243, 192], [69, 60, 71, 38, 73, 119, 28, 222, 37], [68, 45, 128, 34, 1, 47, 11, 245, 171], [62, 17, 19, 70, 146, 85, 55, 62, 70], [37, 43, 37, 154, 100, 163, 85, 160, 1], [63, 9, 92, 136, 28, 64, 32, 201, 85], [75, 15, 9, 9, 64, 255, 184, 119, 16], [86, 6, 28, 5, 64, 255, 25, 248, 1], [56, 8, 17, 132, 137, 255, 55, 116, 128], [58, 15, 20, 82, 135, 57, 26, 121, 40]], [[164, 50, 31, 137, 154, 133, 25, 35, 218], [51, 103, 44, 131, 131, 123, 31, 6, 158], [86, 40, 64, 135, 148, 224, 45, 183, 128], [22, 26, 17, 131, 240, 154, 14, 1, 209], [45, 16, 21, 91, 64, 222, 7, 1, 197], [56, 21, 39, 155, 60, 138, 23, 102, 213], [83, 12, 13, 54, 192, 255, 68, 47, 28], [85, 26, 85, 85, 128, 128, 32, 146, 171], [18, 11, 7, 63, 144, 171, 4, 4, 246], [35, 27, 10, 146, 174, 171, 12, 26, 128]], [[190, 80, 35, 99, 180, 80, 126, 54, 45], [85, 126, 47, 87, 176, 51, 41, 20, 32], [101, 75, 128, 139, 118, 146, 116, 128, 85], [56, 41, 15, 176, 236, 85, 37, 9, 62], [71, 30, 17, 119, 118, 255, 17, 18, 138], [101, 38, 60, 138, 55, 70, 43, 26, 142], [146, 36, 19, 30, 171, 255, 97, 27, 20], [138, 45, 61, 62, 219, 1, 81, 188, 64], [32, 41, 20, 117, 151, 142, 20, 21, 163], [112, 19, 12, 61, 195, 128, 48, 4, 24]]], $F = [[[[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[176, 246, 255, 255, 255, 255, 255, 255, 255, 255, 255], [223, 241, 252, 255, 255, 255, 255, 255, 255, 255, 255], [249, 253, 253, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 244, 252, 255, 255, 255, 255, 255, 255, 255, 255], [234, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [253, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 246, 254, 255, 255, 255, 255, 255, 255, 255, 255], [239, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 248, 254, 255, 255, 255, 255, 255, 255, 255, 255], [251, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [251, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 253, 255, 254, 255, 255, 255, 255, 255, 255], [250, 255, 254, 255, 254, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]], [[[217, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [225, 252, 241, 253, 255, 255, 254, 255, 255, 255, 255], [234, 250, 241, 250, 253, 255, 253, 254, 255, 255, 255]], [[255, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [223, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [238, 253, 254, 254, 255, 255, 255, 255, 255, 255, 255]], [[255, 248, 254, 255, 255, 255, 255, 255, 255, 255, 255], [249, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 255, 255, 255, 255, 255, 255, 255, 255, 255], [247, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [252, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [253, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 253, 255, 255, 255, 255, 255, 255, 255, 255], [250, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]], [[[186, 251, 250, 255, 255, 255, 255, 255, 255, 255, 255], [234, 251, 244, 254, 255, 255, 255, 255, 255, 255, 255], [251, 251, 243, 253, 254, 255, 254, 255, 255, 255, 255]], [[255, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [236, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [251, 253, 253, 254, 254, 255, 255, 255, 255, 255, 255]], [[255, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [254, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]], [[[248, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [250, 254, 252, 254, 255, 255, 255, 255, 255, 255, 255], [248, 254, 249, 253, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 253, 255, 255, 255, 255, 255, 255, 255, 255], [246, 253, 253, 255, 255, 255, 255, 255, 255, 255, 255], [252, 254, 251, 254, 254, 255, 255, 255, 255, 255, 255]], [[255, 254, 252, 255, 255, 255, 255, 255, 255, 255, 255], [248, 254, 253, 255, 255, 255, 255, 255, 255, 255, 255], [253, 255, 254, 254, 255, 255, 255, 255, 255, 255, 255]], [[255, 251, 254, 255, 255, 255, 255, 255, 255, 255, 255], [245, 251, 254, 255, 255, 255, 255, 255, 255, 255, 255], [253, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 251, 253, 255, 255, 255, 255, 255, 255, 255, 255], [252, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 252, 255, 255, 255, 255, 255, 255, 255, 255, 255], [249, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 253, 255, 255, 255, 255, 255, 255, 255, 255], [250, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]]], ZF = [0, 1, 2, 3, 6, 4, 5, 6, 6, 6, 6, 6, 6, 6, 6, 7, 0], vs = [], zn = [], ki = [], e4 = 1, d1 = 2, ws = [], In = [];
    Pi("UpsampleRgbLinePair", us, 3), Pi("UpsampleBgrLinePair", yA, 3), Pi("UpsampleRgbaLinePair", HA, 4), Pi("UpsampleBgraLinePair", Xo, 4), Pi("UpsampleArgbLinePair", Wo, 4), Pi("UpsampleRgba4444LinePair", na, 2), Pi("UpsampleRgb565LinePair", Aa, 2);
    var t4 = U.UpsampleRgbLinePair, r4 = U.UpsampleBgrLinePair, g1 = U.UpsampleRgbaLinePair, p1 = U.UpsampleBgraLinePair, m1 = U.UpsampleArgbLinePair, v1 = U.UpsampleRgba4444LinePair, A4 = U.UpsampleRgb565LinePair, Ju = 16, $u = 1 << Ju - 1, sl = -227, Nf = 482, n4 = 6, w1 = 0, i4 = i(256), s4 = i(256), a4 = i(256), o4 = i(256), l4 = i(Nf - sl), u4 = i(Nf - sl);
    Oi("YuvToRgbRow", us, 3), Oi("YuvToBgrRow", yA, 3), Oi("YuvToRgbaRow", HA, 4), Oi("YuvToBgraRow", Xo, 4), Oi("YuvToArgbRow", Wo, 4), Oi("YuvToRgba4444Row", na, 2), Oi("YuvToRgb565Row", Aa, 2);
    var y1 = [0, 4, 8, 12, 128, 132, 136, 140, 256, 260, 264, 268, 384, 388, 392, 396], Zu = [0, 2, 8], c4 = [8, 7, 6, 4, 4, 2, 2, 2, 1, 1, 1, 1], h4 = 1;
    this.WebPDecodeRGBA = function(d, m, b, x, L) {
      var M = zu, k = new Be(), H = new ut();
      k.ba = H, H.S = M, H.width = [H.width], H.height = [H.height];
      var K = H.width, q = H.height, Ae = new Bt();
      if (Ae == null || d == null) var de = 2;
      else e(Ae != null), de = ia(d, m, b, Ae.width, Ae.height, Ae.Pd, Ae.Qd, Ae.format, null);
      if (de != 0 ? K = 0 : (K != null && (K[0] = Ae.width[0]), q != null && (q[0] = Ae.height[0]), K = 1), K) {
        H.width = H.width[0], H.height = H.height[0], x != null && (x[0] = H.width), L != null && (L[0] = H.height);
        e: {
          if (x = new Va(), (L = new Fe()).data = d, L.w = m, L.ha = b, L.kd = 1, m = [0], e(L != null), ((d = ia(L.data, L.w, L.ha, null, null, null, m, null, L)) == 0 || d == 7) && m[0] && (d = 4), (m = d) == 0) {
            if (e(k != null), x.data = L.data, x.w = L.w + L.offset, x.ha = L.ha - L.offset, x.put = vt, x.ac = an, x.bc = Sn, x.ma = k, L.xa) {
              if ((d = Ei()) == null) {
                k = 1;
                break e;
              }
              if ((function(z, ae) {
                var he = [0], ve = [0], fe = [0];
                t: for (; ; ) {
                  if (z == null) return 0;
                  if (ae == null) return z.a = 2, 0;
                  if (z.l = ae, z.a = 0, re(z.m, ae.data, ae.w, ae.ha), !xn(z.m, he, ve, fe)) {
                    z.a = 3;
                    break t;
                  }
                  if (z.xb = d1, ae.width = he[0], ae.height = ve[0], !$e(he[0], ve[0], 1, z, null)) break t;
                  return 1;
                }
                return e(z.a != 0), 0;
              })(d, x)) {
                if (x = (m = cs(x.width, x.height, k.Oa, k.ba)) == 0) {
                  t: {
                    x = d;
                    r: for (; ; ) {
                      if (x == null) {
                        x = 0;
                        break t;
                      }
                      if (e(x.s.yc != null), e(x.s.Ya != null), e(0 < x.s.Wb), e((b = x.l) != null), e((L = b.ma) != null), x.xb != 0) {
                        if (x.ca = L.ba, x.tb = L.tb, e(x.ca != null), !Yo(L.Oa, b, Wu)) {
                          x.a = 2;
                          break r;
                        }
                        if (!ne(x, b.width) || b.da) break r;
                        if ((b.da || lt(x.ca.S)) && qn(), 11 > x.ca.S || (alert("todo:WebPInitConvertARGBToYUV"), x.ca.f.kb.F != null && qn()), x.Pb && 0 < x.s.ua && x.s.vb.X == null && !j(x.s.vb, x.s.Wa.Xa)) {
                          x.a = 1;
                          break r;
                        }
                        x.xb = 0;
                      }
                      if (!$A(x, x.V, x.Ba, x.c, x.i, b.o, Kn)) break r;
                      L.Dc = x.Ma, x = 1;
                      break t;
                    }
                    e(x.a != 0), x = 0;
                  }
                  x = !x;
                }
                x && (m = d.a);
              } else m = d.a;
            } else {
              if ((d = new cf()) == null) {
                k = 1;
                break e;
              }
              if (d.Fa = L.na, d.P = L.P, d.qc = L.Sa, ui(d, x)) {
                if ((m = cs(x.width, x.height, k.Oa, k.ba)) == 0) {
                  if (d.Aa = 0, b = k.Oa, e((L = d) != null), b != null) {
                    if (0 < (K = 0 > (K = b.Md) ? 0 : 100 < K ? 255 : 255 * K / 100)) {
                      for (q = Ae = 0; 4 > q; ++q) 12 > (de = L.pb[q]).lc && (de.ia = K * c4[0 > de.lc ? 0 : de.lc] >> 3), Ae |= de.ia;
                      Ae && (alert("todo:VP8InitRandom"), L.ia = 1);
                    }
                    L.Ga = b.Id, 100 < L.Ga ? L.Ga = 100 : 0 > L.Ga && (L.Ga = 0);
                  }
                  (function(z, ae) {
                    if (z == null) return 0;
                    if (ae == null) return Jr(z, 2, "NULL VP8Io parameter in VP8Decode().");
                    if (!z.cb && !ui(z, ae)) return 0;
                    if (e(z.cb), ae.ac == null || ae.ac(ae)) {
                      ae.ob && (z.L = 0);
                      var he = Zu[z.L];
                      if (z.L == 2 ? (z.yb = 0, z.zb = 0) : (z.yb = ae.v - he >> 4, z.zb = ae.j - he >> 4, 0 > z.yb && (z.yb = 0), 0 > z.zb && (z.zb = 0)), z.Va = ae.o + 15 + he >> 4, z.Hb = ae.va + 15 + he >> 4, z.Hb > z.za && (z.Hb = z.za), z.Va > z.Ub && (z.Va = z.Ub), 0 < z.L) {
                        var ve = z.ed;
                        for (he = 0; 4 > he; ++he) {
                          var fe;
                          if (z.Qa.Cb) {
                            var ye = z.Qa.Lb[he];
                            z.Qa.Fb || (ye += ve.Tb);
                          } else ye = ve.Tb;
                          for (fe = 0; 1 >= fe; ++fe) {
                            var be = z.gd[he][fe], Ie = ye;
                            if (ve.Pc && (Ie += ve.vd[0], fe && (Ie += ve.od[0])), 0 < (Ie = 0 > Ie ? 0 : 63 < Ie ? 63 : Ie)) {
                              var _e = Ie;
                              0 < ve.wb && (_e = 4 < ve.wb ? _e >> 2 : _e >> 1) > 9 - ve.wb && (_e = 9 - ve.wb), 1 > _e && (_e = 1), be.dd = _e, be.tc = 2 * Ie + _e, be.ld = 40 <= Ie ? 2 : 15 <= Ie ? 1 : 0;
                            } else be.tc = 0;
                            be.La = fe;
                          }
                        }
                      }
                      he = 0;
                    } else Jr(z, 6, "Frame setup failed"), he = z.a;
                    if (he = he == 0) {
                      if (he) {
                        z.$c = 0, 0 < z.Aa || (z.Ic = h4);
                        t: {
                          he = z.Ic, ve = 4 * (_e = z.za);
                          var ht = 32 * _e, Ze = _e + 1, Qt = 0 < z.L ? _e * (0 < z.Aa ? 2 : 1) : 0, st = (z.Aa == 2 ? 2 : 1) * _e;
                          if ((be = ve + 832 + (fe = 3 * (16 * he + Zu[z.L]) / 2 * ht) + (ye = z.Fa != null && 0 < z.Fa.length ? z.Kc.c * z.Kc.i : 0)) != be) he = 0;
                          else {
                            if (be > z.Vb) {
                              if (z.Vb = 0, z.Ec = i(be), z.Fc = 0, z.Ec == null) {
                                he = Jr(z, 1, "no memory during frame initialization.");
                                break t;
                              }
                              z.Vb = be;
                            }
                            be = z.Ec, Ie = z.Fc, z.Ac = be, z.Bc = Ie, Ie += ve, z.Gd = s(ht, Uu), z.Hd = 0, z.rb = s(Ze + 1, Rr), z.sb = 1, z.wa = Qt ? s(Qt, dA) : null, z.Y = 0, z.D.Nb = 0, z.D.wa = z.wa, z.D.Y = z.Y, 0 < z.Aa && (z.D.Y += _e), e(!0), z.oc = be, z.pc = Ie, Ie += 832, z.ya = s(st, os), z.aa = 0, z.D.ya = z.ya, z.D.aa = z.aa, z.Aa == 2 && (z.D.aa += _e), z.R = 16 * _e, z.B = 8 * _e, _e = (ht = Zu[z.L]) * z.R, ht = ht / 2 * z.B, z.sa = be, z.ta = Ie + _e, z.qa = z.sa, z.ra = z.ta + 16 * he * z.R + ht, z.Ha = z.qa, z.Ia = z.ra + 8 * he * z.B + ht, z.$c = 0, Ie += fe, z.mb = ye ? be : null, z.nb = ye ? Ie : null, e(Ie + ye <= z.Fc + z.Vb), Lu(z), n(z.Ac, z.Bc, 0, ve), he = 1;
                          }
                        }
                        if (he) {
                          if (ae.ka = 0, ae.y = z.sa, ae.O = z.ta, ae.f = z.qa, ae.N = z.ra, ae.ea = z.Ha, ae.Vd = z.Ia, ae.fa = z.R, ae.Rc = z.B, ae.F = null, ae.J = 0, !l1) {
                            for (he = -255; 255 >= he; ++he) i1[255 + he] = 0 > he ? -he : he;
                            for (he = -1020; 1020 >= he; ++he) s1[1020 + he] = -128 > he ? -128 : 127 < he ? 127 : he;
                            for (he = -112; 112 >= he; ++he) a1[112 + he] = -16 > he ? -16 : 15 < he ? 15 : he;
                            for (he = -255; 510 >= he; ++he) o1[255 + he] = 0 > he ? 0 : 255 < he ? 255 : he;
                            l1 = 1;
                          }
                          ms = ja, oa = ff, di = ci, Jt = Tu, sr = Pu, _n = hf, Hr = Hu, oA = ea, Ri = Q, Al = W, Ja = Du, Ku = y, Yv = Z, Jv = ce, $v = Zs, Zv = qo, e1 = Ru, t1 = ku, zn[0] = Bf, zn[1] = df, zn[2] = wf, zn[3] = yf, zn[4] = _i, zn[5] = bf, zn[6] = Ui, zn[7] = Cf, zn[8] = Do, zn[9] = qa, vs[0] = mf, vs[1] = pf, vs[2] = ko, vs[3] = Ou, vs[4] = Js, vs[5] = Ho, vs[6] = vf, ki[0] = xf, ki[1] = gf, ki[2] = $s, ki[3] = Sf, ki[4] = Vo, ki[5] = Go, ki[6] = Mu, he = 1;
                        } else he = 0;
                      }
                      he && (he = (function(Rt, lA) {
                        for (Rt.M = 0; Rt.M < Rt.Va; ++Rt.M) {
                          var Lt, at = Rt.Jc[Rt.M & Rt.Xb], He = Rt.m, Dr = Rt;
                          for (Lt = 0; Lt < Dr.za; ++Lt) {
                            var _t = He, kt = Dr, pr = kt.Ac, BA = kt.Bc + 4 * Lt, DA = kt.zc, Ur = kt.ya[kt.aa + Lt];
                            if (kt.Qa.Bb ? Ur.$b = me(_t, kt.Pa.jb[0]) ? 2 + me(_t, kt.Pa.jb[2]) : me(_t, kt.Pa.jb[1]) : Ur.$b = 0, kt.kc && (Ur.Ad = me(_t, kt.Bd)), Ur.Za = !me(_t, 145) + 0, Ur.Za) {
                              var UA = Ur.Ob, GA = 0;
                              for (kt = 0; 4 > kt; ++kt) {
                                var uA, Dt = DA[0 + kt];
                                for (uA = 0; 4 > uA; ++uA) {
                                  Dt = JF[pr[BA + uA]][Dt];
                                  for (var tr = f1[me(_t, Dt[0])]; 0 < tr; ) tr = f1[2 * tr + me(_t, Dt[tr])];
                                  Dt = -tr, pr[BA + uA] = Dt;
                                }
                                A(UA, GA, pr, BA, 4), GA += 4, DA[0 + kt] = Dt;
                              }
                            } else Dt = me(_t, 156) ? me(_t, 128) ? 1 : 3 : me(_t, 163) ? 2 : 0, Ur.Ob[0] = Dt, n(pr, BA, Dt, 4), n(DA, 0, Dt, 4);
                            Ur.Dd = me(_t, 142) ? me(_t, 114) ? me(_t, 183) ? 1 : 3 : 2 : 0;
                          }
                          if (Dr.m.Ka) return Jr(Rt, 7, "Premature end-of-partition0 encountered.");
                          for (; Rt.ja < Rt.za; ++Rt.ja) {
                            if (Dr = at, _t = (He = Rt).rb[He.sb - 1], pr = He.rb[He.sb + He.ja], Lt = He.ya[He.aa + He.ja], BA = He.kc ? Lt.Ad : 0) _t.la = pr.la = 0, Lt.Za || (_t.Na = pr.Na = 0), Lt.Hc = 0, Lt.Gc = 0, Lt.ia = 0;
                            else {
                              var Ir, rr;
                              if (_t = pr, pr = Dr, BA = He.Pa.Xc, DA = He.ya[He.aa + He.ja], Ur = He.pb[DA.$b], kt = DA.ad, UA = 0, GA = He.rb[He.sb - 1], Dt = uA = 0, n(kt, UA, 0, 384), DA.Za) var bA = 0, Wn = BA[3];
                              else {
                                tr = i(16);
                                var Gr = _t.Na + GA.Na;
                                if (Gr = il(pr, BA[1], Gr, Ur.Eb, 0, tr, 0), _t.Na = GA.Na = (0 < Gr) + 0, 1 < Gr) ms(tr, 0, kt, UA);
                                else {
                                  var ZA = tr[0] + 3 >> 3;
                                  for (tr = 0; 256 > tr; tr += 16) kt[UA + tr] = ZA;
                                }
                                bA = 1, Wn = BA[0];
                              }
                              var ar = 15 & _t.la, cA = 15 & GA.la;
                              for (tr = 0; 4 > tr; ++tr) {
                                var hn = 1 & cA;
                                for (ZA = rr = 0; 4 > ZA; ++ZA) ar = ar >> 1 | (hn = (Gr = il(pr, Wn, Gr = hn + (1 & ar), Ur.Sc, bA, kt, UA)) > bA) << 7, rr = rr << 2 | (3 < Gr ? 3 : 1 < Gr ? 2 : kt[UA + 0] != 0), UA += 16;
                                ar >>= 4, cA = cA >> 1 | hn << 7, uA = (uA << 8 | rr) >>> 0;
                              }
                              for (Wn = ar, bA = cA >> 4, Ir = 0; 4 > Ir; Ir += 2) {
                                for (rr = 0, ar = _t.la >> 4 + Ir, cA = GA.la >> 4 + Ir, tr = 0; 2 > tr; ++tr) {
                                  for (hn = 1 & cA, ZA = 0; 2 > ZA; ++ZA) Gr = hn + (1 & ar), ar = ar >> 1 | (hn = 0 < (Gr = il(pr, BA[2], Gr, Ur.Qc, 0, kt, UA))) << 3, rr = rr << 2 | (3 < Gr ? 3 : 1 < Gr ? 2 : kt[UA + 0] != 0), UA += 16;
                                  ar >>= 2, cA = cA >> 1 | hn << 5;
                                }
                                Dt |= rr << 4 * Ir, Wn |= ar << 4 << Ir, bA |= (240 & cA) << Ir;
                              }
                              _t.la = Wn, GA.la = bA, DA.Hc = uA, DA.Gc = Dt, DA.ia = 43690 & Dt ? 0 : Ur.ia, BA = !(uA | Dt);
                            }
                            if (0 < He.L && (He.wa[He.Y + He.ja] = He.gd[Lt.$b][Lt.Za], He.wa[He.Y + He.ja].La |= !BA), Dr.Ka) return Jr(Rt, 7, "Premature end-of-file encountered.");
                          }
                          if (Lu(Rt), He = lA, Dr = 1, Lt = (at = Rt).D, _t = 0 < at.L && at.M >= at.zb && at.M <= at.Va, at.Aa == 0) t: {
                            if (Lt.M = at.M, Lt.uc = _t, Fn(at, Lt), Dr = 1, Lt = (rr = at.D).Nb, _t = (Dt = Zu[at.L]) * at.R, pr = Dt / 2 * at.B, tr = 16 * Lt * at.R, ZA = 8 * Lt * at.B, BA = at.sa, DA = at.ta - _t + tr, Ur = at.qa, kt = at.ra - pr + ZA, UA = at.Ha, GA = at.Ia - pr + ZA, cA = (ar = rr.M) == 0, uA = ar >= at.Va - 1, at.Aa == 2 && Fn(at, rr), rr.uc) for (hn = (Gr = at).D.M, e(Gr.D.uc), rr = Gr.yb; rr < Gr.Hb; ++rr) {
                              bA = rr, Wn = hn;
                              var VA = (fn = (CA = Gr).D).Nb;
                              Ir = CA.R;
                              var fn = fn.wa[fn.Y + bA], dn = CA.sa, en = CA.ta + 16 * VA * Ir + 16 * bA, gn = fn.dd, fr = fn.tc;
                              if (fr != 0) if (e(3 <= fr), CA.L == 1) 0 < bA && Zv(dn, en, Ir, fr + 4), fn.La && t1(dn, en, Ir, fr), 0 < Wn && $v(dn, en, Ir, fr + 4), fn.La && e1(dn, en, Ir, fr);
                              else {
                                var pn = CA.B, Xn = CA.qa, la = CA.ra + 8 * VA * pn + 8 * bA, Hi = CA.Ha, CA = CA.Ia + 8 * VA * pn + 8 * bA;
                                VA = fn.ld, 0 < bA && (oA(dn, en, Ir, fr + 4, gn, VA), Al(Xn, la, Hi, CA, pn, fr + 4, gn, VA)), fn.La && (Ku(dn, en, Ir, fr, gn, VA), Jv(Xn, la, Hi, CA, pn, fr, gn, VA)), 0 < Wn && (Hr(dn, en, Ir, fr + 4, gn, VA), Ri(Xn, la, Hi, CA, pn, fr + 4, gn, VA)), fn.La && (Ja(dn, en, Ir, fr, gn, VA), Yv(Xn, la, Hi, CA, pn, fr, gn, VA));
                              }
                            }
                            if (at.ia && alert("todo:DitherRow"), He.put != null) {
                              if (rr = 16 * ar, ar = 16 * (ar + 1), cA ? (He.y = at.sa, He.O = at.ta + tr, He.f = at.qa, He.N = at.ra + ZA, He.ea = at.Ha, He.W = at.Ia + ZA) : (rr -= Dt, He.y = BA, He.O = DA, He.f = Ur, He.N = kt, He.ea = UA, He.W = GA), uA || (ar -= Dt), ar > He.o && (ar = He.o), He.F = null, He.J = null, at.Fa != null && 0 < at.Fa.length && rr < ar && (He.J = hr(at, He, rr, ar - rr), He.F = at.mb, He.F == null && He.F.length == 0)) {
                                Dr = Jr(at, 3, "Could not decode alpha data.");
                                break t;
                              }
                              rr < He.j && (Dt = He.j - rr, rr = He.j, e(!(1 & Dt)), He.O += at.R * Dt, He.N += at.B * (Dt >> 1), He.W += at.B * (Dt >> 1), He.F != null && (He.J += He.width * Dt)), rr < ar && (He.O += He.v, He.N += He.v >> 1, He.W += He.v >> 1, He.F != null && (He.J += He.v), He.ka = rr - He.j, He.U = He.va - He.v, He.T = ar - rr, Dr = He.put(He));
                            }
                            Lt + 1 != at.Ic || uA || (A(at.sa, at.ta - _t, BA, DA + 16 * at.R, _t), A(at.qa, at.ra - pr, Ur, kt + 8 * at.B, pr), A(at.Ha, at.Ia - pr, UA, GA + 8 * at.B, pr));
                          }
                          if (!Dr) return Jr(Rt, 6, "Output aborted.");
                        }
                        return 1;
                      })(z, ae)), ae.bc != null && ae.bc(ae), he &= 1;
                    }
                    return he ? (z.cb = 0, he) : 0;
                  })(d, x) || (m = d.a);
                }
              } else m = d.a;
            }
            m == 0 && k.Oa != null && k.Oa.fd && (m = Jo(k.ba));
          }
          k = m;
        }
        M = k != 0 ? null : 11 > M ? H.f.RGBA.eb : H.f.kb.y;
      } else M = null;
      return M;
    };
    var B1 = [3, 4, 3, 4, 4, 2, 2, 4, 4, 4, 2, 1, 1];
  };
  function l(U, V) {
    for (var F = "", P = 0; P < 4; P++) F += String.fromCharCode(U[V++]);
    return F;
  }
  function u(U, V) {
    return U[V + 0] | U[V + 1] << 8;
  }
  function h(U, V) {
    return (U[V + 0] | U[V + 1] << 8 | U[V + 2] << 16) >>> 0;
  }
  function f(U, V) {
    return (U[V + 0] | U[V + 1] << 8 | U[V + 2] << 16 | U[V + 3] << 24) >>> 0;
  }
  new o();
  var c = [0], p = [0], g = [], v = new o(), w = r, B = (function(U, V) {
    var F = {}, P = 0, D = !1, R = 0, J = 0;
    if (F.frames = [], !/** @license
       * Copyright (c) 2017 Dominik Homberger
      Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
      The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
      THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
      https://webpjs.appspot.com
      WebPRiffParser dominikhlbg@gmail.com
      */
    (function(T, G) {
      for (var X = 0; X < 4; X++) if (T[G + X] != "RIFF".charCodeAt(X)) return !0;
      return !1;
    })(U, V)) {
      for (f(U, V += 4), V += 8; V < U.length; ) {
        var ie = l(U, V), te = f(U, V += 4);
        V += 4;
        var $ = te + (1 & te);
        switch (ie) {
          case "VP8 ":
          case "VP8L":
            F.frames[P] === void 0 && (F.frames[P] = {}), (se = F.frames[P]).src_off = D ? J : V - 8, se.src_size = R + te + 8, P++, D && (D = !1, R = 0, J = 0);
            break;
          case "VP8X":
            (se = F.header = {}).feature_flags = U[V];
            var re = V + 4;
            se.canvas_width = 1 + h(U, re), re += 3, se.canvas_height = 1 + h(U, re), re += 3;
            break;
          case "ALPH":
            D = !0, R = $ + 8, J = V - 8;
            break;
          case "ANIM":
            (se = F.header).bgcolor = f(U, V), re = V + 4, se.loop_count = u(U, re), re += 2;
            break;
          case "ANMF":
            var ue, se;
            (se = F.frames[P] = {}).offset_x = 2 * h(U, V), V += 3, se.offset_y = 2 * h(U, V), V += 3, se.width = 1 + h(U, V), V += 3, se.height = 1 + h(U, V), V += 3, se.duration = h(U, V), V += 3, ue = U[V++], se.dispose = 1 & ue, se.blend = ue >> 1 & 1;
        }
        ie != "ANMF" && (V += $);
      }
      return F;
    }
  })(w, 0);
  B.response = w, B.rgbaoutput = !0, B.dataurl = !1;
  var S = B.header ? B.header : null, C = B.frames ? B.frames : null;
  if (S) {
    S.loop_counter = S.loop_count, c = [S.canvas_height], p = [S.canvas_width];
    for (var E = 0; E < C.length && C[E].blend != 0; E++) ;
  }
  var _ = C[0], I = v.WebPDecodeRGBA(w, _.src_off, _.src_size, p, c);
  _.rgba = I, _.imgwidth = p[0], _.imgheight = c[0];
  for (var O = 0; O < p[0] * c[0] * 4; O++) g[O] = I[O];
  return this.width = p, this.height = c, this.data = g, this;
}
(function(r) {
  var e, t, A, n, i, s, a, o, l, u = function(T) {
    return T = T || {}, this.isStrokeTransparent = T.isStrokeTransparent || !1, this.strokeOpacity = T.strokeOpacity || 1, this.strokeStyle = T.strokeStyle || "#000000", this.fillStyle = T.fillStyle || "#000000", this.isFillTransparent = T.isFillTransparent || !1, this.fillOpacity = T.fillOpacity || 1, this.font = T.font || "10px sans-serif", this.textBaseline = T.textBaseline || "alphabetic", this.textAlign = T.textAlign || "left", this.lineWidth = T.lineWidth || 1, this.lineJoin = T.lineJoin || "miter", this.lineCap = T.lineCap || "butt", this.path = T.path || [], this.transform = T.transform !== void 0 ? T.transform.clone() : new o(), this.globalCompositeOperation = T.globalCompositeOperation || "normal", this.globalAlpha = T.globalAlpha || 1, this.clip_path = T.clip_path || [], this.currentPoint = T.currentPoint || new s(), this.miterLimit = T.miterLimit || 10, this.lastPoint = T.lastPoint || new s(), this.lineDashOffset = T.lineDashOffset || 0, this.lineDash = T.lineDash || [], this.margin = T.margin || [0, 0, 0, 0], this.prevPageLastElemOffset = T.prevPageLastElemOffset || 0, this.ignoreClearRect = typeof T.ignoreClearRect != "boolean" || T.ignoreClearRect, this;
  };
  r.events.push(["initialized", function() {
    this.context2d = new h(this), e = this.internal.f2, t = this.internal.getCoordinateString, A = this.internal.getVerticalCoordinateString, n = this.internal.getHorizontalCoordinate, i = this.internal.getVerticalCoordinate, s = this.internal.Point, a = this.internal.Rectangle, o = this.internal.Matrix, l = new u();
  }]);
  var h = function(T) {
    Object.defineProperty(this, "canvas", { get: function() {
      return { parentNode: !1, style: !1 };
    } });
    var G = T;
    Object.defineProperty(this, "pdf", { get: function() {
      return G;
    } });
    var X = !1;
    Object.defineProperty(this, "pageWrapXEnabled", { get: function() {
      return X;
    }, set: function(j) {
      X = !!j;
    } });
    var Y = !1;
    Object.defineProperty(this, "pageWrapYEnabled", { get: function() {
      return Y;
    }, set: function(j) {
      Y = !!j;
    } });
    var ee = 0;
    Object.defineProperty(this, "posX", { get: function() {
      return ee;
    }, set: function(j) {
      isNaN(j) || (ee = j);
    } });
    var oe = 0;
    Object.defineProperty(this, "posY", { get: function() {
      return oe;
    }, set: function(j) {
      isNaN(j) || (oe = j);
    } }), Object.defineProperty(this, "margin", { get: function() {
      return l.margin;
    }, set: function(j) {
      var Pe;
      typeof j == "number" ? Pe = [j, j, j, j] : ((Pe = new Array(4))[0] = j[0], Pe[1] = j.length >= 2 ? j[1] : Pe[0], Pe[2] = j.length >= 3 ? j[2] : Pe[0], Pe[3] = j.length >= 4 ? j[3] : Pe[1]), l.margin = Pe;
    } });
    var ge = !1;
    Object.defineProperty(this, "autoPaging", { get: function() {
      return ge;
    }, set: function(j) {
      ge = j;
    } });
    var pe = 0;
    Object.defineProperty(this, "lastBreak", { get: function() {
      return pe;
    }, set: function(j) {
      pe = j;
    } });
    var me = [];
    Object.defineProperty(this, "pageBreaks", { get: function() {
      return me;
    }, set: function(j) {
      me = j;
    } }), Object.defineProperty(this, "ctx", { get: function() {
      return l;
    }, set: function(j) {
      j instanceof u && (l = j);
    } }), Object.defineProperty(this, "path", { get: function() {
      return l.path;
    }, set: function(j) {
      l.path = j;
    } });
    var Ee = [];
    Object.defineProperty(this, "ctxStack", { get: function() {
      return Ee;
    }, set: function(j) {
      Ee = j;
    } }), Object.defineProperty(this, "fillStyle", { get: function() {
      return this.ctx.fillStyle;
    }, set: function(j) {
      var Pe;
      Pe = f(j), this.ctx.fillStyle = Pe.style, this.ctx.isFillTransparent = Pe.a === 0, this.ctx.fillOpacity = Pe.a, this.pdf.setFillColor(Pe.r, Pe.g, Pe.b, { a: Pe.a }), this.pdf.setTextColor(Pe.r, Pe.g, Pe.b, { a: Pe.a });
    } }), Object.defineProperty(this, "strokeStyle", { get: function() {
      return this.ctx.strokeStyle;
    }, set: function(j) {
      var Pe = f(j);
      this.ctx.strokeStyle = Pe.style, this.ctx.isStrokeTransparent = Pe.a === 0, this.ctx.strokeOpacity = Pe.a, Pe.a === 0 ? this.pdf.setDrawColor(255, 255, 255) : (Pe.a, this.pdf.setDrawColor(Pe.r, Pe.g, Pe.b));
    } }), Object.defineProperty(this, "lineCap", { get: function() {
      return this.ctx.lineCap;
    }, set: function(j) {
      ["butt", "round", "square"].indexOf(j) !== -1 && (this.ctx.lineCap = j, this.pdf.setLineCap(j));
    } }), Object.defineProperty(this, "lineWidth", { get: function() {
      return this.ctx.lineWidth;
    }, set: function(j) {
      isNaN(j) || (this.ctx.lineWidth = j, this.pdf.setLineWidth(j));
    } }), Object.defineProperty(this, "lineJoin", { get: function() {
      return this.ctx.lineJoin;
    }, set: function(j) {
      ["bevel", "round", "miter"].indexOf(j) !== -1 && (this.ctx.lineJoin = j, this.pdf.setLineJoin(j));
    } }), Object.defineProperty(this, "miterLimit", { get: function() {
      return this.ctx.miterLimit;
    }, set: function(j) {
      isNaN(j) || (this.ctx.miterLimit = j, this.pdf.setMiterLimit(j));
    } }), Object.defineProperty(this, "textBaseline", { get: function() {
      return this.ctx.textBaseline;
    }, set: function(j) {
      this.ctx.textBaseline = j;
    } }), Object.defineProperty(this, "textAlign", { get: function() {
      return this.ctx.textAlign;
    }, set: function(j) {
      ["right", "end", "center", "left", "start"].indexOf(j) !== -1 && (this.ctx.textAlign = j);
    } });
    var Ne = null, Te = null, Ge = null;
    Object.defineProperty(this, "fontFaces", { get: function() {
      return Ge;
    }, set: function(j) {
      Ne = null, Te = null, Ge = j;
    } }), Object.defineProperty(this, "font", { get: function() {
      return this.ctx.font;
    }, set: function(j) {
      var Pe;
      if (this.ctx.font = j, (Pe = /^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-_,\"\'\sa-z0-9]+?)\s*$/i.exec(j)) !== null) {
        var ft = Pe[1];
        Pe[2];
        var et = Pe[3], xe = Pe[4];
        Pe[5];
        var rt = Pe[6], ke = /^([.\d]+)((?:%|in|[cem]m|ex|p[ctx]))$/i.exec(xe)[2];
        xe = Math.floor(ke === "px" ? parseFloat(xe) * this.pdf.internal.scaleFactor : ke === "em" ? parseFloat(xe) * this.pdf.getFontSize() : parseFloat(xe) * this.pdf.internal.scaleFactor), this.pdf.setFontSize(xe);
        var We = (function(je) {
          var Tt, Et, mt = [], yt = je.trim();
          if (yt === "") return cd;
          if (yt in Rw) return [Rw[yt]];
          for (; yt !== ""; ) {
            switch (Et = null, Tt = (yt = Hw(yt)).charAt(0)) {
              case '"':
              case "'":
                Et = jQ(yt.substring(1), Tt);
                break;
              default:
                Et = qQ(yt);
            }
            if (Et === null || (mt.push(Et[0]), (yt = Hw(Et[1])) !== "" && yt.charAt(0) !== ",")) return cd;
            yt = yt.replace(/^,/, "");
          }
          return mt;
        })(rt);
        if (this.fontFaces) {
          var ze = (function(je, Tt) {
            var Et = je.getFontList(), mt = JSON.stringify(Et);
            if (Ne === null || Te !== mt) {
              var yt = (function(Gt) {
                var it = [];
                return Object.keys(Gt).forEach(function(Vt) {
                  Gt[Vt].forEach(function(lt) {
                    var wt = null;
                    switch (lt) {
                      case "bold":
                        wt = { family: Vt, weight: "bold" };
                        break;
                      case "italic":
                        wt = { family: Vt, style: "italic" };
                        break;
                      case "bolditalic":
                        wt = { family: Vt, weight: "bold", style: "italic" };
                        break;
                      case "":
                      case "normal":
                        wt = { family: Vt };
                    }
                    wt !== null && (wt.ref = { name: Vt, style: lt }, it.push(wt));
                  });
                }), it;
              })(Et);
              Ne = (function(Gt) {
                for (var it = {}, Vt = 0; Vt < Gt.length; ++Vt) {
                  var lt = ud(Gt[Vt]), wt = lt.family, Yt = lt.stretch, ut = lt.style, Bt = lt.weight;
                  it[wt] = it[wt] || {}, it[wt][Yt] = it[wt][Yt] || {}, it[wt][Yt][ut] = it[wt][Yt][ut] || {}, it[wt][Yt][ut][Bt] = lt;
                }
                return it;
              })(yt.concat(Tt)), Te = mt;
            }
            return Ne;
          })(this.pdf, this.fontFaces), Ce = We.map(function(je) {
            return { family: je, stretch: "normal", weight: et, style: ft };
          }), Oe = (function(je, Tt, Et) {
            for (var mt = (Et = Et || {}).defaultFontFamily || "times", yt = Object.assign({}, KQ, Et.genericFontFamilies || {}), Gt = null, it = null, Vt = 0; Vt < Tt.length; ++Vt) if (yt[(Gt = ud(Tt[Vt])).family] && (Gt.family = yt[Gt.family]), je.hasOwnProperty(Gt.family)) {
              it = je[Gt.family];
              break;
            }
            if (!(it = it || je[mt])) throw new Error("Could not find a font-family for the rule '" + kw(Gt) + "' and default family '" + mt + "'.");
            if (it = (function(lt, wt) {
              if (wt[lt]) return wt[lt];
              var Yt = em[lt], ut = Yt <= em.normal ? -1 : 1, Bt = Mw(wt, R5, Yt, ut);
              if (!Bt) throw new Error("Could not find a matching font-stretch value for " + lt);
              return Bt;
            })(Gt.stretch, it), it = (function(lt, wt) {
              if (wt[lt]) return wt[lt];
              for (var Yt = M5[lt], ut = 0; ut < Yt.length; ++ut) if (wt[Yt[ut]]) return wt[Yt[ut]];
              throw new Error("Could not find a matching font-style for " + lt);
            })(Gt.style, it), !(it = (function(lt, wt) {
              if (wt[lt]) return wt[lt];
              if (lt === 400 && wt[500]) return wt[500];
              if (lt === 500 && wt[400]) return wt[400];
              var Yt = VQ[lt], ut = Mw(wt, k5, Yt, lt < 400 ? -1 : 1);
              if (!ut) throw new Error("Could not find a matching font-weight for value " + lt);
              return ut;
            })(Gt.weight, it))) throw new Error("Failed to resolve a font for the rule '" + kw(Gt) + "'.");
            return it;
          })(ze, Ce);
          this.pdf.setFont(Oe.ref.name, Oe.ref.style);
        } else {
          var Re = "";
          (et === "bold" || parseInt(et, 10) >= 700 || ft === "bold") && (Re = "bold"), ft === "italic" && (Re += "italic"), Re.length === 0 && (Re = "normal");
          for (var Ke = "", Xe = { arial: "Helvetica", Arial: "Helvetica", verdana: "Helvetica", Verdana: "Helvetica", helvetica: "Helvetica", Helvetica: "Helvetica", "sans-serif": "Helvetica", fixed: "Courier", monospace: "Courier", terminal: "Courier", cursive: "Times", fantasy: "Times", serif: "Times" }, Ve = 0; Ve < We.length; Ve++) {
            if (this.pdf.internal.getFont(We[Ve], Re, { noFallback: !0, disableWarning: !0 }) !== void 0) {
              Ke = We[Ve];
              break;
            }
            if (Re === "bolditalic" && this.pdf.internal.getFont(We[Ve], "bold", { noFallback: !0, disableWarning: !0 }) !== void 0) Ke = We[Ve], Re = "bold";
            else if (this.pdf.internal.getFont(We[Ve], "normal", { noFallback: !0, disableWarning: !0 }) !== void 0) {
              Ke = We[Ve], Re = "normal";
              break;
            }
          }
          if (Ke === "") {
            for (var dt = 0; dt < We.length; dt++) if (Xe[We[dt]]) {
              Ke = Xe[We[dt]];
              break;
            }
          }
          Ke = Ke === "" ? "Times" : Ke, this.pdf.setFont(Ke, Re);
        }
      }
    } }), Object.defineProperty(this, "globalCompositeOperation", { get: function() {
      return this.ctx.globalCompositeOperation;
    }, set: function(j) {
      this.ctx.globalCompositeOperation = j;
    } }), Object.defineProperty(this, "globalAlpha", { get: function() {
      return this.ctx.globalAlpha;
    }, set: function(j) {
      this.ctx.globalAlpha = j;
    } }), Object.defineProperty(this, "lineDashOffset", { get: function() {
      return this.ctx.lineDashOffset;
    }, set: function(j) {
      this.ctx.lineDashOffset = j, se.call(this);
    } }), Object.defineProperty(this, "lineDash", { get: function() {
      return this.ctx.lineDash;
    }, set: function(j) {
      this.ctx.lineDash = j, se.call(this);
    } }), Object.defineProperty(this, "ignoreClearRect", { get: function() {
      return this.ctx.ignoreClearRect;
    }, set: function(j) {
      this.ctx.ignoreClearRect = !!j;
    } });
  };
  h.prototype.setLineDash = function(T) {
    this.lineDash = T;
  }, h.prototype.getLineDash = function() {
    return this.lineDash.length % 2 ? this.lineDash.concat(this.lineDash) : this.lineDash.slice();
  }, h.prototype.fill = function() {
    C.call(this, "fill", !1);
  }, h.prototype.stroke = function() {
    C.call(this, "stroke", !1);
  }, h.prototype.beginPath = function() {
    this.path = [{ type: "begin" }];
  }, h.prototype.moveTo = function(T, G) {
    if (isNaN(T) || isNaN(G)) throw or.error("jsPDF.context2d.moveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.moveTo");
    var X = this.ctx.transform.applyToPoint(new s(T, G));
    this.path.push({ type: "mt", x: X.x, y: X.y }), this.ctx.lastPoint = new s(T, G);
  }, h.prototype.closePath = function() {
    var T = new s(0, 0), G = 0;
    for (G = this.path.length - 1; G !== -1; G--) if (this.path[G].type === "begin" && jt(this.path[G + 1]) === "object" && typeof this.path[G + 1].x == "number") {
      T = new s(this.path[G + 1].x, this.path[G + 1].y);
      break;
    }
    this.path.push({ type: "close" }), this.ctx.lastPoint = new s(T.x, T.y);
  }, h.prototype.lineTo = function(T, G) {
    if (isNaN(T) || isNaN(G)) throw or.error("jsPDF.context2d.lineTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.lineTo");
    var X = this.ctx.transform.applyToPoint(new s(T, G));
    this.path.push({ type: "lt", x: X.x, y: X.y }), this.ctx.lastPoint = new s(X.x, X.y);
  }, h.prototype.clip = function() {
    this.ctx.clip_path = JSON.parse(JSON.stringify(this.path)), C.call(this, null, !0);
  }, h.prototype.quadraticCurveTo = function(T, G, X, Y) {
    if (isNaN(X) || isNaN(Y) || isNaN(T) || isNaN(G)) throw or.error("jsPDF.context2d.quadraticCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.quadraticCurveTo");
    var ee = this.ctx.transform.applyToPoint(new s(X, Y)), oe = this.ctx.transform.applyToPoint(new s(T, G));
    this.path.push({ type: "qct", x1: oe.x, y1: oe.y, x: ee.x, y: ee.y }), this.ctx.lastPoint = new s(ee.x, ee.y);
  }, h.prototype.bezierCurveTo = function(T, G, X, Y, ee, oe) {
    if (isNaN(ee) || isNaN(oe) || isNaN(T) || isNaN(G) || isNaN(X) || isNaN(Y)) throw or.error("jsPDF.context2d.bezierCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.bezierCurveTo");
    var ge = this.ctx.transform.applyToPoint(new s(ee, oe)), pe = this.ctx.transform.applyToPoint(new s(T, G)), me = this.ctx.transform.applyToPoint(new s(X, Y));
    this.path.push({ type: "bct", x1: pe.x, y1: pe.y, x2: me.x, y2: me.y, x: ge.x, y: ge.y }), this.ctx.lastPoint = new s(ge.x, ge.y);
  }, h.prototype.arc = function(T, G, X, Y, ee, oe) {
    if (isNaN(T) || isNaN(G) || isNaN(X) || isNaN(Y) || isNaN(ee)) throw or.error("jsPDF.context2d.arc: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.arc");
    if (oe = !!oe, !this.ctx.transform.isIdentity) {
      var ge = this.ctx.transform.applyToPoint(new s(T, G));
      T = ge.x, G = ge.y;
      var pe = this.ctx.transform.applyToPoint(new s(0, X)), me = this.ctx.transform.applyToPoint(new s(0, 0));
      X = Math.sqrt(Math.pow(pe.x - me.x, 2) + Math.pow(pe.y - me.y, 2));
    }
    Math.abs(ee - Y) >= 2 * Math.PI && (Y = 0, ee = 2 * Math.PI), this.path.push({ type: "arc", x: T, y: G, radius: X, startAngle: Y, endAngle: ee, counterclockwise: oe });
  }, h.prototype.arcTo = function(T, G, X, Y, ee) {
    throw new Error("arcTo not implemented.");
  }, h.prototype.rect = function(T, G, X, Y) {
    if (isNaN(T) || isNaN(G) || isNaN(X) || isNaN(Y)) throw or.error("jsPDF.context2d.rect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rect");
    this.moveTo(T, G), this.lineTo(T + X, G), this.lineTo(T + X, G + Y), this.lineTo(T, G + Y), this.lineTo(T, G), this.lineTo(T + X, G), this.lineTo(T, G);
  }, h.prototype.fillRect = function(T, G, X, Y) {
    if (isNaN(T) || isNaN(G) || isNaN(X) || isNaN(Y)) throw or.error("jsPDF.context2d.fillRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillRect");
    if (!c.call(this)) {
      var ee = {};
      this.lineCap !== "butt" && (ee.lineCap = this.lineCap, this.lineCap = "butt"), this.lineJoin !== "miter" && (ee.lineJoin = this.lineJoin, this.lineJoin = "miter"), this.beginPath(), this.rect(T, G, X, Y), this.fill(), ee.hasOwnProperty("lineCap") && (this.lineCap = ee.lineCap), ee.hasOwnProperty("lineJoin") && (this.lineJoin = ee.lineJoin);
    }
  }, h.prototype.strokeRect = function(T, G, X, Y) {
    if (isNaN(T) || isNaN(G) || isNaN(X) || isNaN(Y)) throw or.error("jsPDF.context2d.strokeRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeRect");
    p.call(this) || (this.beginPath(), this.rect(T, G, X, Y), this.stroke());
  }, h.prototype.clearRect = function(T, G, X, Y) {
    if (isNaN(T) || isNaN(G) || isNaN(X) || isNaN(Y)) throw or.error("jsPDF.context2d.clearRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.clearRect");
    this.ignoreClearRect || (this.fillStyle = "#ffffff", this.fillRect(T, G, X, Y));
  }, h.prototype.save = function(T) {
    T = typeof T != "boolean" || T;
    for (var G = this.pdf.internal.getCurrentPageInfo().pageNumber, X = 0; X < this.pdf.internal.getNumberOfPages(); X++) this.pdf.setPage(X + 1), this.pdf.internal.out("q");
    if (this.pdf.setPage(G), T) {
      this.ctx.fontSize = this.pdf.internal.getFontSize();
      var Y = new u(this.ctx);
      this.ctxStack.push(this.ctx), this.ctx = Y;
    }
  }, h.prototype.restore = function(T) {
    T = typeof T != "boolean" || T;
    for (var G = this.pdf.internal.getCurrentPageInfo().pageNumber, X = 0; X < this.pdf.internal.getNumberOfPages(); X++) this.pdf.setPage(X + 1), this.pdf.internal.out("Q");
    this.pdf.setPage(G), T && this.ctxStack.length !== 0 && (this.ctx = this.ctxStack.pop(), this.fillStyle = this.ctx.fillStyle, this.strokeStyle = this.ctx.strokeStyle, this.font = this.ctx.font, this.lineCap = this.ctx.lineCap, this.lineWidth = this.ctx.lineWidth, this.lineJoin = this.ctx.lineJoin, this.lineDash = this.ctx.lineDash, this.lineDashOffset = this.ctx.lineDashOffset);
  }, h.prototype.toDataURL = function() {
    throw new Error("toDataUrl not implemented.");
  };
  var f = function(T) {
    var G, X, Y, ee;
    if (T.isCanvasGradient === !0 && (T = T.getColor()), !T) return { r: 0, g: 0, b: 0, a: 0, style: T };
    if (/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/.test(T)) G = 0, X = 0, Y = 0, ee = 0;
    else {
      var oe = /rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec(T);
      if (oe !== null) G = parseInt(oe[1]), X = parseInt(oe[2]), Y = parseInt(oe[3]), ee = 1;
      else if ((oe = /rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*\)/.exec(T)) !== null) G = parseInt(oe[1]), X = parseInt(oe[2]), Y = parseInt(oe[3]), ee = parseFloat(oe[4]);
      else {
        if (ee = 1, typeof T == "string" && T.charAt(0) !== "#") {
          var ge = new I5(T);
          T = ge.ok ? ge.toHex() : "#000000";
        }
        T.length === 4 ? (G = T.substring(1, 2), G += G, X = T.substring(2, 3), X += X, Y = T.substring(3, 4), Y += Y) : (G = T.substring(1, 3), X = T.substring(3, 5), Y = T.substring(5, 7)), G = parseInt(G, 16), X = parseInt(X, 16), Y = parseInt(Y, 16);
      }
    }
    return { r: G, g: X, b: Y, a: ee, style: T };
  }, c = function() {
    return this.ctx.isFillTransparent || this.globalAlpha == 0;
  }, p = function() {
    return !!(this.ctx.isStrokeTransparent || this.globalAlpha == 0);
  };
  h.prototype.fillText = function(T, G, X, Y) {
    if (isNaN(G) || isNaN(X) || typeof T != "string") throw or.error("jsPDF.context2d.fillText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillText");
    if (Y = isNaN(Y) ? void 0 : Y, !c.call(this)) {
      var ee = $(this.ctx.transform.rotation), oe = this.ctx.transform.scaleX;
      P.call(this, { text: T, x: G, y: X, scale: oe, angle: ee, align: this.textAlign, maxWidth: Y });
    }
  }, h.prototype.strokeText = function(T, G, X, Y) {
    if (isNaN(G) || isNaN(X) || typeof T != "string") throw or.error("jsPDF.context2d.strokeText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeText");
    if (!p.call(this)) {
      Y = isNaN(Y) ? void 0 : Y;
      var ee = $(this.ctx.transform.rotation), oe = this.ctx.transform.scaleX;
      P.call(this, { text: T, x: G, y: X, scale: oe, renderingMode: "stroke", angle: ee, align: this.textAlign, maxWidth: Y });
    }
  }, h.prototype.measureText = function(T) {
    if (typeof T != "string") throw or.error("jsPDF.context2d.measureText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.measureText");
    var G = this.pdf, X = this.pdf.internal.scaleFactor, Y = G.internal.getFontSize(), ee = G.getStringUnitWidth(T) * Y / G.internal.scaleFactor;
    return new function(oe) {
      var ge = (oe = oe || {}).width || 0;
      return Object.defineProperty(this, "width", { get: function() {
        return ge;
      } }), this;
    }({ width: ee *= Math.round(96 * X / 72 * 1e4) / 1e4 });
  }, h.prototype.scale = function(T, G) {
    if (isNaN(T) || isNaN(G)) throw or.error("jsPDF.context2d.scale: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.scale");
    var X = new o(T, 0, 0, G, 0, 0);
    this.ctx.transform = this.ctx.transform.multiply(X);
  }, h.prototype.rotate = function(T) {
    if (isNaN(T)) throw or.error("jsPDF.context2d.rotate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rotate");
    var G = new o(Math.cos(T), Math.sin(T), -Math.sin(T), Math.cos(T), 0, 0);
    this.ctx.transform = this.ctx.transform.multiply(G);
  }, h.prototype.translate = function(T, G) {
    if (isNaN(T) || isNaN(G)) throw or.error("jsPDF.context2d.translate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.translate");
    var X = new o(1, 0, 0, 1, T, G);
    this.ctx.transform = this.ctx.transform.multiply(X);
  }, h.prototype.transform = function(T, G, X, Y, ee, oe) {
    if (isNaN(T) || isNaN(G) || isNaN(X) || isNaN(Y) || isNaN(ee) || isNaN(oe)) throw or.error("jsPDF.context2d.transform: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.transform");
    var ge = new o(T, G, X, Y, ee, oe);
    this.ctx.transform = this.ctx.transform.multiply(ge);
  }, h.prototype.setTransform = function(T, G, X, Y, ee, oe) {
    T = isNaN(T) ? 1 : T, G = isNaN(G) ? 0 : G, X = isNaN(X) ? 0 : X, Y = isNaN(Y) ? 1 : Y, ee = isNaN(ee) ? 0 : ee, oe = isNaN(oe) ? 0 : oe, this.ctx.transform = new o(T, G, X, Y, ee, oe);
  };
  var g = function() {
    return this.margin[0] > 0 || this.margin[1] > 0 || this.margin[2] > 0 || this.margin[3] > 0;
  };
  h.prototype.drawImage = function(T, G, X, Y, ee, oe, ge, pe, me) {
    var Ee = this.pdf.getImageProperties(T), Ne = 1, Te = 1, Ge = 1, j = 1;
    Y !== void 0 && pe !== void 0 && (Ge = pe / Y, j = me / ee, Ne = Ee.width / Y * pe / Y, Te = Ee.height / ee * me / ee), oe === void 0 && (oe = G, ge = X, G = 0, X = 0), Y !== void 0 && pe === void 0 && (pe = Y, me = ee), Y === void 0 && pe === void 0 && (pe = Ee.width, me = Ee.height);
    var Pe = this.ctx.transform.decompose(), ft = $(Pe.rotate.shx), et = new o(), xe = (et = (et = (et = et.multiply(Pe.translate)).multiply(Pe.skew)).multiply(Pe.scale)).applyToRectangle(new a(oe - G * Ge, ge - X * j, Y * Ne, ee * Te));
    if (this.autoPaging) {
      for (var rt, ke = v.call(this, xe), We = [], ze = 0; ze < ke.length; ze += 1) We.indexOf(ke[ze]) === -1 && We.push(ke[ze]);
      S(We);
      for (var Ce = We[0], Oe = We[We.length - 1], Re = Ce; Re < Oe + 1; Re++) {
        this.pdf.setPage(Re);
        var Ke = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], Xe = Re === 1 ? this.posY + this.margin[0] : this.margin[0], Ve = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], dt = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], je = Re === 1 ? 0 : Ve + (Re - 2) * dt;
        if (this.ctx.clip_path.length !== 0) {
          var Tt = this.path;
          rt = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = B(rt, this.posX + this.margin[3], -je + Xe + this.ctx.prevPageLastElemOffset), E.call(this, "fill", !0), this.path = Tt;
        }
        var Et = JSON.parse(JSON.stringify(xe));
        Et = B([Et], this.posX + this.margin[3], -je + Xe + this.ctx.prevPageLastElemOffset)[0];
        var mt = (Re > Ce || Re < Oe) && g.call(this);
        mt && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], Ke, dt, null).clip().discardPath()), this.pdf.addImage(T, "JPEG", Et.x, Et.y, Et.w, Et.h, null, null, ft), mt && this.pdf.restoreGraphicsState();
      }
    } else this.pdf.addImage(T, "JPEG", xe.x, xe.y, xe.w, xe.h, null, null, ft);
  };
  var v = function(T, G, X) {
    var Y = [];
    G = G || this.pdf.internal.pageSize.width, X = X || this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2];
    var ee = this.posY + this.ctx.prevPageLastElemOffset;
    switch (T.type) {
      default:
      case "mt":
      case "lt":
        Y.push(Math.floor((T.y + ee) / X) + 1);
        break;
      case "arc":
        Y.push(Math.floor((T.y + ee - T.radius) / X) + 1), Y.push(Math.floor((T.y + ee + T.radius) / X) + 1);
        break;
      case "qct":
        var oe = re(this.ctx.lastPoint.x, this.ctx.lastPoint.y, T.x1, T.y1, T.x, T.y);
        Y.push(Math.floor((oe.y + ee) / X) + 1), Y.push(Math.floor((oe.y + oe.h + ee) / X) + 1);
        break;
      case "bct":
        var ge = ue(this.ctx.lastPoint.x, this.ctx.lastPoint.y, T.x1, T.y1, T.x2, T.y2, T.x, T.y);
        Y.push(Math.floor((ge.y + ee) / X) + 1), Y.push(Math.floor((ge.y + ge.h + ee) / X) + 1);
        break;
      case "rect":
        Y.push(Math.floor((T.y + ee) / X) + 1), Y.push(Math.floor((T.y + T.h + ee) / X) + 1);
    }
    for (var pe = 0; pe < Y.length; pe += 1) for (; this.pdf.internal.getNumberOfPages() < Y[pe]; ) w.call(this);
    return Y;
  }, w = function() {
    var T = this.fillStyle, G = this.strokeStyle, X = this.font, Y = this.lineCap, ee = this.lineWidth, oe = this.lineJoin;
    this.pdf.addPage(), this.fillStyle = T, this.strokeStyle = G, this.font = X, this.lineCap = Y, this.lineWidth = ee, this.lineJoin = oe;
  }, B = function(T, G, X) {
    for (var Y = 0; Y < T.length; Y++) switch (T[Y].type) {
      case "bct":
        T[Y].x2 += G, T[Y].y2 += X;
      case "qct":
        T[Y].x1 += G, T[Y].y1 += X;
      default:
        T[Y].x += G, T[Y].y += X;
    }
    return T;
  }, S = function(T) {
    return T.sort(function(G, X) {
      return G - X;
    });
  }, C = function(T, G) {
    var X = this.fillStyle, Y = this.strokeStyle, ee = this.lineCap, oe = this.lineWidth, ge = Math.abs(oe * this.ctx.transform.scaleX), pe = this.lineJoin;
    if (this.autoPaging) {
      for (var me, Ee, Ne = JSON.parse(JSON.stringify(this.path)), Te = JSON.parse(JSON.stringify(this.path)), Ge = [], j = 0; j < Te.length; j++) if (Te[j].x !== void 0) for (var Pe = v.call(this, Te[j]), ft = 0; ft < Pe.length; ft += 1) Ge.indexOf(Pe[ft]) === -1 && Ge.push(Pe[ft]);
      for (var et = 0; et < Ge.length; et++) for (; this.pdf.internal.getNumberOfPages() < Ge[et]; ) w.call(this);
      S(Ge);
      for (var xe = Ge[0], rt = Ge[Ge.length - 1], ke = xe; ke < rt + 1; ke++) {
        this.pdf.setPage(ke), this.fillStyle = X, this.strokeStyle = Y, this.lineCap = ee, this.lineWidth = ge, this.lineJoin = pe;
        var We = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], ze = ke === 1 ? this.posY + this.margin[0] : this.margin[0], Ce = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], Oe = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], Re = ke === 1 ? 0 : Ce + (ke - 2) * Oe;
        if (this.ctx.clip_path.length !== 0) {
          var Ke = this.path;
          me = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = B(me, this.posX + this.margin[3], -Re + ze + this.ctx.prevPageLastElemOffset), E.call(this, T, !0), this.path = Ke;
        }
        if (Ee = JSON.parse(JSON.stringify(Ne)), this.path = B(Ee, this.posX + this.margin[3], -Re + ze + this.ctx.prevPageLastElemOffset), G === !1 || ke === 0) {
          var Xe = (ke > xe || ke < rt) && g.call(this);
          Xe && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], We, Oe, null).clip().discardPath()), E.call(this, T, G), Xe && this.pdf.restoreGraphicsState();
        }
        this.lineWidth = oe;
      }
      this.path = Ne;
    } else this.lineWidth = ge, E.call(this, T, G), this.lineWidth = oe;
  }, E = function(T, G) {
    if ((T !== "stroke" || G || !p.call(this)) && (T === "stroke" || G || !c.call(this))) {
      for (var X, Y, ee = [], oe = this.path, ge = 0; ge < oe.length; ge++) {
        var pe = oe[ge];
        switch (pe.type) {
          case "begin":
            ee.push({ begin: !0 });
            break;
          case "close":
            ee.push({ close: !0 });
            break;
          case "mt":
            ee.push({ start: pe, deltas: [], abs: [] });
            break;
          case "lt":
            var me = ee.length;
            if (oe[ge - 1] && !isNaN(oe[ge - 1].x) && (X = [pe.x - oe[ge - 1].x, pe.y - oe[ge - 1].y], me > 0)) {
              for (; me >= 0; me--) if (ee[me - 1].close !== !0 && ee[me - 1].begin !== !0) {
                ee[me - 1].deltas.push(X), ee[me - 1].abs.push(pe);
                break;
              }
            }
            break;
          case "bct":
            X = [pe.x1 - oe[ge - 1].x, pe.y1 - oe[ge - 1].y, pe.x2 - oe[ge - 1].x, pe.y2 - oe[ge - 1].y, pe.x - oe[ge - 1].x, pe.y - oe[ge - 1].y], ee[ee.length - 1].deltas.push(X);
            break;
          case "qct":
            var Ee = oe[ge - 1].x + 2 / 3 * (pe.x1 - oe[ge - 1].x), Ne = oe[ge - 1].y + 2 / 3 * (pe.y1 - oe[ge - 1].y), Te = pe.x + 2 / 3 * (pe.x1 - pe.x), Ge = pe.y + 2 / 3 * (pe.y1 - pe.y), j = pe.x, Pe = pe.y;
            X = [Ee - oe[ge - 1].x, Ne - oe[ge - 1].y, Te - oe[ge - 1].x, Ge - oe[ge - 1].y, j - oe[ge - 1].x, Pe - oe[ge - 1].y], ee[ee.length - 1].deltas.push(X);
            break;
          case "arc":
            ee.push({ deltas: [], abs: [], arc: !0 }), Array.isArray(ee[ee.length - 1].abs) && ee[ee.length - 1].abs.push(pe);
        }
      }
      Y = G ? null : T === "stroke" ? "stroke" : "fill";
      for (var ft = !1, et = 0; et < ee.length; et++) if (ee[et].arc) for (var xe = ee[et].abs, rt = 0; rt < xe.length; rt++) {
        var ke = xe[rt];
        ke.type === "arc" ? O.call(this, ke.x, ke.y, ke.radius, ke.startAngle, ke.endAngle, ke.counterclockwise, void 0, G, !ft) : D.call(this, ke.x, ke.y), ft = !0;
      }
      else if (ee[et].close === !0) this.pdf.internal.out("h"), ft = !1;
      else if (ee[et].begin !== !0) {
        var We = ee[et].start.x, ze = ee[et].start.y;
        R.call(this, ee[et].deltas, We, ze), ft = !0;
      }
      Y && U.call(this, Y), G && V.call(this);
    }
  }, _ = function(T) {
    var G = this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor, X = G * (this.pdf.internal.getLineHeightFactor() - 1);
    switch (this.ctx.textBaseline) {
      case "bottom":
        return T - X;
      case "top":
        return T + G - X;
      case "hanging":
        return T + G - 2 * X;
      case "middle":
        return T + G / 2 - X;
      default:
        return T;
    }
  }, I = function(T) {
    return T + this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor * (this.pdf.internal.getLineHeightFactor() - 1);
  };
  h.prototype.createLinearGradient = function() {
    var T = function() {
    };
    return T.colorStops = [], T.addColorStop = function(G, X) {
      this.colorStops.push([G, X]);
    }, T.getColor = function() {
      return this.colorStops.length === 0 ? "#000000" : this.colorStops[0][1];
    }, T.isCanvasGradient = !0, T;
  }, h.prototype.createPattern = function() {
    return this.createLinearGradient();
  }, h.prototype.createRadialGradient = function() {
    return this.createLinearGradient();
  };
  var O = function(T, G, X, Y, ee, oe, ge, pe, me) {
    for (var Ee = ie.call(this, X, Y, ee, oe), Ne = 0; Ne < Ee.length; Ne++) {
      var Te = Ee[Ne];
      Ne === 0 && (me ? F.call(this, Te.x1 + T, Te.y1 + G) : D.call(this, Te.x1 + T, Te.y1 + G)), J.call(this, T, G, Te.x2, Te.y2, Te.x3, Te.y3, Te.x4, Te.y4);
    }
    pe ? V.call(this) : U.call(this, ge);
  }, U = function(T) {
    switch (T) {
      case "stroke":
        this.pdf.internal.out("S");
        break;
      case "fill":
        this.pdf.internal.out("f");
    }
  }, V = function() {
    this.pdf.clip(), this.pdf.discardPath();
  }, F = function(T, G) {
    this.pdf.internal.out(t(T) + " " + A(G) + " m");
  }, P = function(T) {
    var G;
    switch (T.align) {
      case "right":
      case "end":
        G = "right";
        break;
      case "center":
        G = "center";
        break;
      default:
        G = "left";
    }
    var X, Y, ee, oe = this.pdf.getTextDimensions(T.text), ge = _.call(this, T.y), pe = I.call(this, ge) - oe.h, me = this.ctx.transform.applyToPoint(new s(T.x, ge));
    if (this.autoPaging) {
      var Ee = this.ctx.transform.decompose(), Ne = new o();
      Ne = (Ne = (Ne = Ne.multiply(Ee.translate)).multiply(Ee.skew)).multiply(Ee.scale);
      for (var Te = this.ctx.transform.applyToRectangle(new a(T.x, ge, oe.w, oe.h)), Ge = Ne.applyToRectangle(new a(T.x, pe, oe.w, oe.h)), j = v.call(this, Ge), Pe = [], ft = 0; ft < j.length; ft += 1) Pe.indexOf(j[ft]) === -1 && Pe.push(j[ft]);
      S(Pe);
      for (var et = Pe[0], xe = Pe[Pe.length - 1], rt = et; rt < xe + 1; rt++) {
        this.pdf.setPage(rt);
        var ke = rt === 1 ? this.posY + this.margin[0] : this.margin[0], We = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], ze = this.pdf.internal.pageSize.height - this.margin[2], Ce = ze - this.margin[0], Oe = this.pdf.internal.pageSize.width - this.margin[1], Re = Oe - this.margin[3], Ke = rt === 1 ? 0 : We + (rt - 2) * Ce;
        if (this.ctx.clip_path.length !== 0) {
          var Xe = this.path;
          X = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = B(X, this.posX + this.margin[3], -1 * Ke + ke), E.call(this, "fill", !0), this.path = Xe;
        }
        var Ve = B([JSON.parse(JSON.stringify(Ge))], this.posX + this.margin[3], -Ke + ke + this.ctx.prevPageLastElemOffset)[0];
        T.scale >= 0.01 && (Y = this.pdf.internal.getFontSize(), this.pdf.setFontSize(Y * T.scale), ee = this.lineWidth, this.lineWidth = ee * T.scale);
        var dt = this.autoPaging !== "text";
        if (dt || Ve.y + Ve.h <= ze) {
          if (dt || Ve.y >= ke && Ve.x <= Oe) {
            var je = dt ? T.text : this.pdf.splitTextToSize(T.text, T.maxWidth || Oe - Ve.x)[0], Tt = B([JSON.parse(JSON.stringify(Te))], this.posX + this.margin[3], -Ke + ke + this.ctx.prevPageLastElemOffset)[0], Et = dt && (rt > et || rt < xe) && g.call(this);
            Et && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], Re, Ce, null).clip().discardPath()), this.pdf.text(je, Tt.x, Tt.y, { angle: T.angle, align: G, renderingMode: T.renderingMode }), Et && this.pdf.restoreGraphicsState();
          }
        } else Ve.y < ze && (this.ctx.prevPageLastElemOffset += ze - Ve.y);
        T.scale >= 0.01 && (this.pdf.setFontSize(Y), this.lineWidth = ee);
      }
    } else T.scale >= 0.01 && (Y = this.pdf.internal.getFontSize(), this.pdf.setFontSize(Y * T.scale), ee = this.lineWidth, this.lineWidth = ee * T.scale), this.pdf.text(T.text, me.x + this.posX, me.y + this.posY, { angle: T.angle, align: G, renderingMode: T.renderingMode, maxWidth: T.maxWidth }), T.scale >= 0.01 && (this.pdf.setFontSize(Y), this.lineWidth = ee);
  }, D = function(T, G, X, Y) {
    X = X || 0, Y = Y || 0, this.pdf.internal.out(t(T + X) + " " + A(G + Y) + " l");
  }, R = function(T, G, X) {
    return this.pdf.lines(T, G, X, null, null);
  }, J = function(T, G, X, Y, ee, oe, ge, pe) {
    this.pdf.internal.out([e(n(X + T)), e(i(Y + G)), e(n(ee + T)), e(i(oe + G)), e(n(ge + T)), e(i(pe + G)), "c"].join(" "));
  }, ie = function(T, G, X, Y) {
    for (var ee = 2 * Math.PI, oe = Math.PI / 2; G > X; ) G -= ee;
    var ge = Math.abs(X - G);
    ge < ee && Y && (ge = ee - ge);
    for (var pe = [], me = Y ? -1 : 1, Ee = G; ge > 1e-5; ) {
      var Ne = Ee + me * Math.min(ge, oe);
      pe.push(te.call(this, T, Ee, Ne)), ge -= Math.abs(Ne - Ee), Ee = Ne;
    }
    return pe;
  }, te = function(T, G, X) {
    var Y = (X - G) / 2, ee = T * Math.cos(Y), oe = T * Math.sin(Y), ge = ee, pe = -oe, me = ge * ge + pe * pe, Ee = me + ge * ee + pe * oe, Ne = 4 / 3 * (Math.sqrt(2 * me * Ee) - Ee) / (ge * oe - pe * ee), Te = ge - Ne * pe, Ge = pe + Ne * ge, j = Te, Pe = -Ge, ft = Y + G, et = Math.cos(ft), xe = Math.sin(ft);
    return { x1: T * Math.cos(G), y1: T * Math.sin(G), x2: Te * et - Ge * xe, y2: Te * xe + Ge * et, x3: j * et - Pe * xe, y3: j * xe + Pe * et, x4: T * Math.cos(X), y4: T * Math.sin(X) };
  }, $ = function(T) {
    return 180 * T / Math.PI;
  }, re = function(T, G, X, Y, ee, oe) {
    var ge = T + 0.5 * (X - T), pe = G + 0.5 * (Y - G), me = ee + 0.5 * (X - ee), Ee = oe + 0.5 * (Y - oe), Ne = Math.min(T, ee, ge, me), Te = Math.max(T, ee, ge, me), Ge = Math.min(G, oe, pe, Ee), j = Math.max(G, oe, pe, Ee);
    return new a(Ne, Ge, Te - Ne, j - Ge);
  }, ue = function(T, G, X, Y, ee, oe, ge, pe) {
    var me, Ee, Ne, Te, Ge, j, Pe, ft, et, xe, rt, ke, We, ze, Ce = X - T, Oe = Y - G, Re = ee - X, Ke = oe - Y, Xe = ge - ee, Ve = pe - oe;
    for (Ee = 0; Ee < 41; Ee++) et = (Pe = (Ne = T + (me = Ee / 40) * Ce) + me * ((Ge = X + me * Re) - Ne)) + me * (Ge + me * (ee + me * Xe - Ge) - Pe), xe = (ft = (Te = G + me * Oe) + me * ((j = Y + me * Ke) - Te)) + me * (j + me * (oe + me * Ve - j) - ft), Ee == 0 ? (rt = et, ke = xe, We = et, ze = xe) : (rt = Math.min(rt, et), ke = Math.min(ke, xe), We = Math.max(We, et), ze = Math.max(ze, xe));
    return new a(Math.round(rt), Math.round(ke), Math.round(We - rt), Math.round(ze - ke));
  }, se = function() {
    if (this.prevLineDash || this.ctx.lineDash.length || this.ctx.lineDashOffset) {
      var T, G, X = (T = this.ctx.lineDash, G = this.ctx.lineDashOffset, JSON.stringify({ lineDash: T, lineDashOffset: G }));
      this.prevLineDash !== X && (this.pdf.setLineDash(this.ctx.lineDash, this.ctx.lineDashOffset), this.prevLineDash = X);
    }
  };
})(ot.API), /**
 * @license
 * jsPDF filters PlugIn
 * Copyright (c) 2014 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(r) {
  var e = function(s) {
    var a, o, l, u, h, f, c, p, g, v;
    for (o = [], l = 0, u = (s += a = "\0\0\0\0".slice(s.length % 4 || 4)).length; u > l; l += 4) (h = (s.charCodeAt(l) << 24) + (s.charCodeAt(l + 1) << 16) + (s.charCodeAt(l + 2) << 8) + s.charCodeAt(l + 3)) !== 0 ? (f = (h = ((h = ((h = ((h = (h - (v = h % 85)) / 85) - (g = h % 85)) / 85) - (p = h % 85)) / 85) - (c = h % 85)) / 85) % 85, o.push(f + 33, c + 33, p + 33, g + 33, v + 33)) : o.push(122);
    return (function(w, B) {
      for (var S = B; S > 0; S--) w.pop();
    })(o, a.length), String.fromCharCode.apply(String, o) + "~>";
  }, t = function(s) {
    var a, o, l, u, h, f = String, c = "length", p = 255, g = "charCodeAt", v = "slice", w = "replace";
    for (s[v](-2), s = s[v](0, -2)[w](/\s/g, "")[w]("z", "!!!!!"), l = [], u = 0, h = (s += a = "uuuuu"[v](s[c] % 5 || 5))[c]; h > u; u += 5) o = 52200625 * (s[g](u) - 33) + 614125 * (s[g](u + 1) - 33) + 7225 * (s[g](u + 2) - 33) + 85 * (s[g](u + 3) - 33) + (s[g](u + 4) - 33), l.push(p & o >> 24, p & o >> 16, p & o >> 8, p & o);
    return (function(B, S) {
      for (var C = S; C > 0; C--) B.pop();
    })(l, a[c]), f.fromCharCode.apply(f, l);
  }, A = function(s) {
    return s.split("").map(function(a) {
      return ("0" + a.charCodeAt().toString(16)).slice(-2);
    }).join("") + ">";
  }, n = function(s) {
    var a = new RegExp(/^([0-9A-Fa-f]{2})+$/);
    if ((s = s.replace(/\s/g, "")).indexOf(">") !== -1 && (s = s.substr(0, s.indexOf(">"))), s.length % 2 && (s += "0"), a.test(s) === !1) return "";
    for (var o = "", l = 0; l < s.length; l += 2) o += String.fromCharCode("0x" + (s[l] + s[l + 1]));
    return o;
  }, i = function(s) {
    for (var a = new Uint8Array(s.length), o = s.length; o--; ) a[o] = s.charCodeAt(o);
    return (a = z0(a)).reduce(function(l, u) {
      return l + String.fromCharCode(u);
    }, "");
  };
  r.processDataByFilters = function(s, a) {
    var o = 0, l = s || "", u = [];
    for (typeof (a = a || []) == "string" && (a = [a]), o = 0; o < a.length; o += 1) switch (a[o]) {
      case "ASCII85Decode":
      case "/ASCII85Decode":
        l = t(l), u.push("/ASCII85Encode");
        break;
      case "ASCII85Encode":
      case "/ASCII85Encode":
        l = e(l), u.push("/ASCII85Decode");
        break;
      case "ASCIIHexDecode":
      case "/ASCIIHexDecode":
        l = n(l), u.push("/ASCIIHexEncode");
        break;
      case "ASCIIHexEncode":
      case "/ASCIIHexEncode":
        l = A(l), u.push("/ASCIIHexDecode");
        break;
      case "FlateEncode":
      case "/FlateEncode":
        l = i(l), u.push("/FlateDecode");
        break;
      default:
        throw new Error('The filter: "' + a[o] + '" is not implemented');
    }
    return { data: l, reverseChain: u.reverse().join(" ") };
  };
})(ot.API), /**
 * @license
 * jsPDF fileloading PlugIn
 * Copyright (c) 2018 Aras Abbasi (aras.abbasi@gmail.com)
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(r) {
  r.loadFile = function(e, t, A) {
    return (function(n, i, s) {
      i = i !== !1, s = typeof s == "function" ? s : function() {
      };
      var a = void 0;
      try {
        a = (function(o, l, u) {
          var h = new XMLHttpRequest(), f = 0, c = function(p) {
            var g = p.length, v = [], w = String.fromCharCode;
            for (f = 0; f < g; f += 1) v.push(w(255 & p.charCodeAt(f)));
            return v.join("");
          };
          if (h.open("GET", o, !l), h.overrideMimeType("text/plain; charset=x-user-defined"), l === !1 && (h.onload = function() {
            h.status === 200 ? u(c(this.responseText)) : u(void 0);
          }), h.send(null), l && h.status === 200) return c(h.responseText);
        })(n, i, s);
      } catch {
      }
      return a;
    })(e, t, A);
  }, r.loadImageFile = r.loadFile;
})(ot.API), (function(r) {
  function e() {
    return (Ct.html2canvas ? Promise.resolve(Ct.html2canvas) : Promise.resolve().then(() => jR)).catch(function(a) {
      return Promise.reject(new Error("Could not load html2canvas: " + a));
    }).then(function(a) {
      return a.default ? a.default : a;
    });
  }
  function t() {
    return (Ct.DOMPurify ? Promise.resolve(Ct.DOMPurify) : Promise.resolve().then(() => dk)).catch(function(a) {
      return Promise.reject(new Error("Could not load dompurify: " + a));
    }).then(function(a) {
      return a.default ? a.default : a;
    });
  }
  var A = function(a) {
    var o = jt(a);
    return o === "undefined" ? "undefined" : o === "string" || a instanceof String ? "string" : o === "number" || a instanceof Number ? "number" : o === "function" || a instanceof Function ? "function" : a && a.constructor === Array ? "array" : a && a.nodeType === 1 ? "element" : o === "object" ? "object" : "unknown";
  }, n = function(a, o) {
    var l = document.createElement(a);
    for (var u in o.className && (l.className = o.className), o.innerHTML && o.dompurify && (l.innerHTML = o.dompurify.sanitize(o.innerHTML)), o.style) l.style[u] = o.style[u];
    return l;
  }, i = function a(o, l) {
    for (var u = o.nodeType === 3 ? document.createTextNode(o.nodeValue) : o.cloneNode(!1), h = o.firstChild; h; h = h.nextSibling) l !== !0 && h.nodeType === 1 && h.nodeName === "SCRIPT" || u.appendChild(a(h, l));
    return o.nodeType === 1 && (o.nodeName === "CANVAS" ? (u.width = o.width, u.height = o.height, u.getContext("2d").drawImage(o, 0, 0)) : o.nodeName !== "TEXTAREA" && o.nodeName !== "SELECT" || (u.value = o.value), u.addEventListener("load", function() {
      u.scrollTop = o.scrollTop, u.scrollLeft = o.scrollLeft;
    }, !0)), u;
  }, s = function a(o) {
    var l = Object.assign(a.convert(Promise.resolve()), JSON.parse(JSON.stringify(a.template))), u = a.convert(Promise.resolve(), l);
    return (u = u.setProgress(1, a, 1, [a])).set(o);
  };
  (s.prototype = Object.create(Promise.prototype)).constructor = s, s.convert = function(a, o) {
    return a.__proto__ = o || s.prototype, a;
  }, s.template = { prop: { src: null, container: null, overlay: null, canvas: null, img: null, pdf: null, pageSize: null, callback: function() {
  } }, progress: { val: 0, state: null, n: 0, stack: [] }, opt: { filename: "file.pdf", margin: [0, 0, 0, 0], enableLinks: !0, x: 0, y: 0, html2canvas: {}, jsPDF: {}, backgroundColor: "transparent" } }, s.prototype.from = function(a, o) {
    return this.then(function() {
      switch (o = o || (function(l) {
        switch (A(l)) {
          case "string":
            return "string";
          case "element":
            return l.nodeName.toLowerCase() === "canvas" ? "canvas" : "element";
          default:
            return "unknown";
        }
      })(a), o) {
        case "string":
          return this.then(t).then(function(l) {
            return this.set({ src: n("div", { innerHTML: a, dompurify: l }) });
          });
        case "element":
          return this.set({ src: a });
        case "canvas":
          return this.set({ canvas: a });
        case "img":
          return this.set({ img: a });
        default:
          return this.error("Unknown source type.");
      }
    });
  }, s.prototype.to = function(a) {
    switch (a) {
      case "container":
        return this.toContainer();
      case "canvas":
        return this.toCanvas();
      case "img":
        return this.toImg();
      case "pdf":
        return this.toPdf();
      default:
        return this.error("Invalid target.");
    }
  }, s.prototype.toContainer = function() {
    return this.thenList([function() {
      return this.prop.src || this.error("Cannot duplicate - no source HTML.");
    }, function() {
      return this.prop.pageSize || this.setPageSize();
    }]).then(function() {
      var a = { position: "relative", display: "inline-block", width: (typeof this.opt.width != "number" || isNaN(this.opt.width) || typeof this.opt.windowWidth != "number" || isNaN(this.opt.windowWidth) ? Math.max(this.prop.src.clientWidth, this.prop.src.scrollWidth, this.prop.src.offsetWidth) : this.opt.windowWidth) + "px", left: 0, right: 0, top: 0, margin: "auto", backgroundColor: this.opt.backgroundColor }, o = i(this.prop.src, this.opt.html2canvas.javascriptEnabled);
      o.tagName === "BODY" && (a.height = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) + "px"), this.prop.overlay = n("div", { className: "html2pdf__overlay", style: { position: "fixed", overflow: "hidden", zIndex: 1e3, left: "-100000px", right: 0, bottom: 0, top: 0 } }), this.prop.container = n("div", { className: "html2pdf__container", style: a }), this.prop.container.appendChild(o), this.prop.container.firstChild.appendChild(n("div", { style: { clear: "both", border: "0 none transparent", margin: 0, padding: 0, height: 0 } })), this.prop.container.style.float = "none", this.prop.overlay.appendChild(this.prop.container), document.body.appendChild(this.prop.overlay), this.prop.container.firstChild.style.position = "relative", this.prop.container.height = Math.max(this.prop.container.firstChild.clientHeight, this.prop.container.firstChild.scrollHeight, this.prop.container.firstChild.offsetHeight) + "px";
    });
  }, s.prototype.toCanvas = function() {
    var a = [function() {
      return document.body.contains(this.prop.container) || this.toContainer();
    }];
    return this.thenList(a).then(e).then(function(o) {
      var l = Object.assign({}, this.opt.html2canvas);
      return delete l.onrendered, o(this.prop.container, l);
    }).then(function(o) {
      (this.opt.html2canvas.onrendered || function() {
      })(o), this.prop.canvas = o, document.body.removeChild(this.prop.overlay);
    });
  }, s.prototype.toContext2d = function() {
    var a = [function() {
      return document.body.contains(this.prop.container) || this.toContainer();
    }];
    return this.thenList(a).then(e).then(function(o) {
      var l = this.opt.jsPDF, u = this.opt.fontFaces, h = typeof this.opt.width != "number" || isNaN(this.opt.width) || typeof this.opt.windowWidth != "number" || isNaN(this.opt.windowWidth) ? 1 : this.opt.width / this.opt.windowWidth, f = Object.assign({ async: !0, allowTaint: !0, scale: h, scrollX: this.opt.scrollX || 0, scrollY: this.opt.scrollY || 0, backgroundColor: "#ffffff", imageTimeout: 15e3, logging: !0, proxy: null, removeContainer: !0, foreignObjectRendering: !1, useCORS: !1 }, this.opt.html2canvas);
      if (delete f.onrendered, l.context2d.autoPaging = this.opt.autoPaging === void 0 || this.opt.autoPaging, l.context2d.posX = this.opt.x, l.context2d.posY = this.opt.y, l.context2d.margin = this.opt.margin, l.context2d.fontFaces = u, u) for (var c = 0; c < u.length; ++c) {
        var p = u[c], g = p.src.find(function(v) {
          return v.format === "truetype";
        });
        g && l.addFont(g.url, p.ref.name, p.ref.style);
      }
      return f.windowHeight = f.windowHeight || 0, f.windowHeight = f.windowHeight == 0 ? Math.max(this.prop.container.clientHeight, this.prop.container.scrollHeight, this.prop.container.offsetHeight) : f.windowHeight, l.context2d.save(!0), o(this.prop.container, f);
    }).then(function(o) {
      this.opt.jsPDF.context2d.restore(!0), (this.opt.html2canvas.onrendered || function() {
      })(o), this.prop.canvas = o, document.body.removeChild(this.prop.overlay);
    });
  }, s.prototype.toImg = function() {
    return this.thenList([function() {
      return this.prop.canvas || this.toCanvas();
    }]).then(function() {
      var a = this.prop.canvas.toDataURL("image/" + this.opt.image.type, this.opt.image.quality);
      this.prop.img = document.createElement("img"), this.prop.img.src = a;
    });
  }, s.prototype.toPdf = function() {
    return this.thenList([function() {
      return this.toContext2d();
    }]).then(function() {
      this.prop.pdf = this.prop.pdf || this.opt.jsPDF;
    });
  }, s.prototype.output = function(a, o, l) {
    return (l = l || "pdf").toLowerCase() === "img" || l.toLowerCase() === "image" ? this.outputImg(a, o) : this.outputPdf(a, o);
  }, s.prototype.outputPdf = function(a, o) {
    return this.thenList([function() {
      return this.prop.pdf || this.toPdf();
    }]).then(function() {
      return this.prop.pdf.output(a, o);
    });
  }, s.prototype.outputImg = function(a) {
    return this.thenList([function() {
      return this.prop.img || this.toImg();
    }]).then(function() {
      switch (a) {
        case void 0:
        case "img":
          return this.prop.img;
        case "datauristring":
        case "dataurlstring":
          return this.prop.img.src;
        case "datauri":
        case "dataurl":
          return document.location.href = this.prop.img.src;
        default:
          throw 'Image output type "' + a + '" is not supported.';
      }
    });
  }, s.prototype.save = function(a) {
    return this.thenList([function() {
      return this.prop.pdf || this.toPdf();
    }]).set(a ? { filename: a } : null).then(function() {
      this.prop.pdf.save(this.opt.filename);
    });
  }, s.prototype.doCallback = function() {
    return this.thenList([function() {
      return this.prop.pdf || this.toPdf();
    }]).then(function() {
      this.prop.callback(this.prop.pdf);
    });
  }, s.prototype.set = function(a) {
    if (A(a) !== "object") return this;
    var o = Object.keys(a || {}).map(function(l) {
      if (l in s.template.prop) return function() {
        this.prop[l] = a[l];
      };
      switch (l) {
        case "margin":
          return this.setMargin.bind(this, a.margin);
        case "jsPDF":
          return function() {
            return this.opt.jsPDF = a.jsPDF, this.setPageSize();
          };
        case "pageSize":
          return this.setPageSize.bind(this, a.pageSize);
        default:
          return function() {
            this.opt[l] = a[l];
          };
      }
    }, this);
    return this.then(function() {
      return this.thenList(o);
    });
  }, s.prototype.get = function(a, o) {
    return this.then(function() {
      var l = a in s.template.prop ? this.prop[a] : this.opt[a];
      return o ? o(l) : l;
    });
  }, s.prototype.setMargin = function(a) {
    return this.then(function() {
      switch (A(a)) {
        case "number":
          a = [a, a, a, a];
        case "array":
          if (a.length === 2 && (a = [a[0], a[1], a[0], a[1]]), a.length === 4) break;
        default:
          return this.error("Invalid margin array.");
      }
      this.opt.margin = a;
    }).then(this.setPageSize);
  }, s.prototype.setPageSize = function(a) {
    function o(l, u) {
      return Math.floor(l * u / 72 * 96);
    }
    return this.then(function() {
      (a = a || ot.getPageSize(this.opt.jsPDF)).hasOwnProperty("inner") || (a.inner = { width: a.width - this.opt.margin[1] - this.opt.margin[3], height: a.height - this.opt.margin[0] - this.opt.margin[2] }, a.inner.px = { width: o(a.inner.width, a.k), height: o(a.inner.height, a.k) }, a.inner.ratio = a.inner.height / a.inner.width), this.prop.pageSize = a;
    });
  }, s.prototype.setProgress = function(a, o, l, u) {
    return a != null && (this.progress.val = a), o != null && (this.progress.state = o), l != null && (this.progress.n = l), u != null && (this.progress.stack = u), this.progress.ratio = this.progress.val / this.progress.state, this;
  }, s.prototype.updateProgress = function(a, o, l, u) {
    return this.setProgress(a ? this.progress.val + a : null, o || null, l ? this.progress.n + l : null, u ? this.progress.stack.concat(u) : null);
  }, s.prototype.then = function(a, o) {
    var l = this;
    return this.thenCore(a, o, function(u, h) {
      return l.updateProgress(null, null, 1, [u]), Promise.prototype.then.call(this, function(f) {
        return l.updateProgress(null, u), f;
      }).then(u, h).then(function(f) {
        return l.updateProgress(1), f;
      });
    });
  }, s.prototype.thenCore = function(a, o, l) {
    l = l || Promise.prototype.then;
    var u = this;
    a && (a = a.bind(u)), o && (o = o.bind(u));
    var h = Promise.toString().indexOf("[native code]") !== -1 && Promise.name === "Promise" ? u : s.convert(Object.assign({}, u), Promise.prototype), f = l.call(h, a, o);
    return s.convert(f, u.__proto__);
  }, s.prototype.thenExternal = function(a, o) {
    return Promise.prototype.then.call(this, a, o);
  }, s.prototype.thenList = function(a) {
    var o = this;
    return a.forEach(function(l) {
      o = o.thenCore(l);
    }), o;
  }, s.prototype.catch = function(a) {
    a && (a = a.bind(this));
    var o = Promise.prototype.catch.call(this, a);
    return s.convert(o, this);
  }, s.prototype.catchExternal = function(a) {
    return Promise.prototype.catch.call(this, a);
  }, s.prototype.error = function(a) {
    return this.then(function() {
      throw new Error(a);
    });
  }, s.prototype.using = s.prototype.set, s.prototype.saveAs = s.prototype.save, s.prototype.export = s.prototype.output, s.prototype.run = s.prototype.then, ot.getPageSize = function(a, o, l) {
    if (jt(a) === "object") {
      var u = a;
      a = u.orientation, o = u.unit || o, l = u.format || l;
    }
    o = o || "mm", l = l || "a4", a = ("" + (a || "P")).toLowerCase();
    var h, f = ("" + l).toLowerCase(), c = { a0: [2383.94, 3370.39], a1: [1683.78, 2383.94], a2: [1190.55, 1683.78], a3: [841.89, 1190.55], a4: [595.28, 841.89], a5: [419.53, 595.28], a6: [297.64, 419.53], a7: [209.76, 297.64], a8: [147.4, 209.76], a9: [104.88, 147.4], a10: [73.7, 104.88], b0: [2834.65, 4008.19], b1: [2004.09, 2834.65], b2: [1417.32, 2004.09], b3: [1000.63, 1417.32], b4: [708.66, 1000.63], b5: [498.9, 708.66], b6: [354.33, 498.9], b7: [249.45, 354.33], b8: [175.75, 249.45], b9: [124.72, 175.75], b10: [87.87, 124.72], c0: [2599.37, 3676.54], c1: [1836.85, 2599.37], c2: [1298.27, 1836.85], c3: [918.43, 1298.27], c4: [649.13, 918.43], c5: [459.21, 649.13], c6: [323.15, 459.21], c7: [229.61, 323.15], c8: [161.57, 229.61], c9: [113.39, 161.57], c10: [79.37, 113.39], dl: [311.81, 623.62], letter: [612, 792], "government-letter": [576, 756], legal: [612, 1008], "junior-legal": [576, 360], ledger: [1224, 792], tabloid: [792, 1224], "credit-card": [153, 243] };
    switch (o) {
      case "pt":
        h = 1;
        break;
      case "mm":
        h = 72 / 25.4;
        break;
      case "cm":
        h = 72 / 2.54;
        break;
      case "in":
        h = 72;
        break;
      case "px":
        h = 0.75;
        break;
      case "pc":
      case "em":
        h = 12;
        break;
      case "ex":
        h = 6;
        break;
      default:
        throw "Invalid unit: " + o;
    }
    var p, g = 0, v = 0;
    if (c.hasOwnProperty(f)) g = c[f][1] / h, v = c[f][0] / h;
    else try {
      g = l[1], v = l[0];
    } catch {
      throw new Error("Invalid format: " + l);
    }
    if (a === "p" || a === "portrait") a = "p", v > g && (p = v, v = g, g = p);
    else {
      if (a !== "l" && a !== "landscape") throw "Invalid orientation: " + a;
      a = "l", g > v && (p = v, v = g, g = p);
    }
    return { width: v, height: g, unit: o, k: h, orientation: a };
  }, r.html = function(a, o) {
    (o = o || {}).callback = o.callback || function() {
    }, o.html2canvas = o.html2canvas || {}, o.html2canvas.canvas = o.html2canvas.canvas || this.canvas, o.jsPDF = o.jsPDF || this, o.fontFaces = o.fontFaces ? o.fontFaces.map(ud) : null;
    var l = new s(o);
    return o.worker ? l : l.from(a).doCallback();
  };
})(ot.API), ot.API.addJS = function(r) {
  return Gw = r, this.internal.events.subscribe("postPutResources", function() {
    pc = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/Names [(EmbeddedJS) " + (pc + 1) + " 0 R]"), this.internal.out(">>"), this.internal.out("endobj"), Dw = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /JavaScript"), this.internal.out("/JS (" + Gw + ")"), this.internal.out(">>"), this.internal.out("endobj");
  }), this.internal.events.subscribe("putCatalog", function() {
    pc !== void 0 && Dw !== void 0 && this.internal.out("/Names <</JavaScript " + pc + " 0 R>>");
  }), this;
}, /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(r) {
  var e;
  r.events.push(["postPutResources", function() {
    var t = this, A = /^(\d+) 0 obj$/;
    if (this.outline.root.children.length > 0) for (var n = t.outline.render().split(/\r\n/), i = 0; i < n.length; i++) {
      var s = n[i], a = A.exec(s);
      if (a != null) {
        var o = a[1];
        t.internal.newObjectDeferredBegin(o, !1);
      }
      t.internal.write(s);
    }
    if (this.outline.createNamedDestinations) {
      var l = this.internal.pages.length, u = [];
      for (i = 0; i < l; i++) {
        var h = t.internal.newObject();
        u.push(h);
        var f = t.internal.getPageInfo(i + 1);
        t.internal.write("<< /D[" + f.objId + " 0 R /XYZ null null null]>> endobj");
      }
      var c = t.internal.newObject();
      for (t.internal.write("<< /Names [ "), i = 0; i < u.length; i++) t.internal.write("(page_" + (i + 1) + ")" + u[i] + " 0 R");
      t.internal.write(" ] >>", "endobj"), e = t.internal.newObject(), t.internal.write("<< /Dests " + c + " 0 R"), t.internal.write(">>", "endobj");
    }
  }]), r.events.push(["putCatalog", function() {
    var t = this;
    t.outline.root.children.length > 0 && (t.internal.write("/Outlines", this.outline.makeRef(this.outline.root)), this.outline.createNamedDestinations && t.internal.write("/Names " + e + " 0 R"));
  }]), r.events.push(["initialized", function() {
    var t = this;
    t.outline = { createNamedDestinations: !1, root: { children: [] } }, t.outline.add = function(A, n, i) {
      var s = { title: n, options: i, children: [] };
      return A == null && (A = this.root), A.children.push(s), s;
    }, t.outline.render = function() {
      return this.ctx = {}, this.ctx.val = "", this.ctx.pdf = t, this.genIds_r(this.root), this.renderRoot(this.root), this.renderItems(this.root), this.ctx.val;
    }, t.outline.genIds_r = function(A) {
      A.id = t.internal.newObjectDeferred();
      for (var n = 0; n < A.children.length; n++) this.genIds_r(A.children[n]);
    }, t.outline.renderRoot = function(A) {
      this.objStart(A), this.line("/Type /Outlines"), A.children.length > 0 && (this.line("/First " + this.makeRef(A.children[0])), this.line("/Last " + this.makeRef(A.children[A.children.length - 1]))), this.line("/Count " + this.count_r({ count: 0 }, A)), this.objEnd();
    }, t.outline.renderItems = function(A) {
      for (var n = this.ctx.pdf.internal.getVerticalCoordinateString, i = 0; i < A.children.length; i++) {
        var s = A.children[i];
        this.objStart(s), this.line("/Title " + this.makeString(s.title)), this.line("/Parent " + this.makeRef(A)), i > 0 && this.line("/Prev " + this.makeRef(A.children[i - 1])), i < A.children.length - 1 && this.line("/Next " + this.makeRef(A.children[i + 1])), s.children.length > 0 && (this.line("/First " + this.makeRef(s.children[0])), this.line("/Last " + this.makeRef(s.children[s.children.length - 1])));
        var a = this.count = this.count_r({ count: 0 }, s);
        if (a > 0 && this.line("/Count " + a), s.options && s.options.pageNumber) {
          var o = t.internal.getPageInfo(s.options.pageNumber);
          this.line("/Dest [" + o.objId + " 0 R /XYZ 0 " + n(0) + " 0]");
        }
        this.objEnd();
      }
      for (var l = 0; l < A.children.length; l++) this.renderItems(A.children[l]);
    }, t.outline.line = function(A) {
      this.ctx.val += A + `\r
`;
    }, t.outline.makeRef = function(A) {
      return A.id + " 0 R";
    }, t.outline.makeString = function(A) {
      return "(" + t.internal.pdfEscape(A) + ")";
    }, t.outline.objStart = function(A) {
      this.ctx.val += `\r
` + A.id + ` 0 obj\r
<<\r
`;
    }, t.outline.objEnd = function() {
      this.ctx.val += `>> \r
endobj\r
`;
    }, t.outline.count_r = function(A, n) {
      for (var i = 0; i < n.children.length; i++) A.count++, this.count_r(A, n.children[i]);
      return A.count;
    };
  }]);
})(ot.API), /**
 * @license
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(r) {
  var e = [192, 193, 194, 195, 196, 197, 198, 199];
  r.processJPEG = function(t, A, n, i, s, a) {
    var o, l = this.decode.DCT_DECODE, u = null;
    if (typeof t == "string" || this.__addimage__.isArrayBuffer(t) || this.__addimage__.isArrayBufferView(t)) {
      switch (t = s || t, t = this.__addimage__.isArrayBuffer(t) ? new Uint8Array(t) : t, o = (function(h) {
        for (var f, c = 256 * h.charCodeAt(4) + h.charCodeAt(5), p = h.length, g = { width: 0, height: 0, numcomponents: 1 }, v = 4; v < p; v += 2) {
          if (v += c, e.indexOf(h.charCodeAt(v + 1)) !== -1) {
            f = 256 * h.charCodeAt(v + 5) + h.charCodeAt(v + 6), g = { width: 256 * h.charCodeAt(v + 7) + h.charCodeAt(v + 8), height: f, numcomponents: h.charCodeAt(v + 9) };
            break;
          }
          c = 256 * h.charCodeAt(v + 2) + h.charCodeAt(v + 3);
        }
        return g;
      })(t = this.__addimage__.isArrayBufferView(t) ? this.__addimage__.arrayBufferToBinaryString(t) : t), o.numcomponents) {
        case 1:
          a = this.color_spaces.DEVICE_GRAY;
          break;
        case 4:
          a = this.color_spaces.DEVICE_CMYK;
          break;
        case 3:
          a = this.color_spaces.DEVICE_RGB;
      }
      u = { data: t, width: o.width, height: o.height, colorSpace: a, bitsPerComponent: 8, filter: l, index: A, alias: n };
    }
    return u;
  };
})(ot.API), ot.API.processPNG = function(r, e, t, A) {
  if (this.__addimage__.isArrayBuffer(r) && (r = new Uint8Array(r)), this.__addimage__.isArrayBufferView(r)) {
    var n, i = UQ(r, { checkCrc: !0 }), s = i.width, a = i.height, o = i.channels, l = i.palette, u = i.depth;
    n = l && o === 1 ? (function(O) {
      for (var U = O.width, V = O.height, F = O.data, P = O.palette, D = O.depth, R = !1, J = [], ie = [], te = void 0, $ = !1, re = 0, ue = 0; ue < P.length; ue++) {
        var se = q1(P[ue], 4), T = se[0], G = se[1], X = se[2], Y = se[3];
        J.push(T, G, X), Y != null && (Y === 0 ? (re++, ie.length < 1 && ie.push(ue)) : Y < 255 && ($ = !0));
      }
      if ($ || re > 1) {
        R = !0, ie = void 0;
        var ee = U * V;
        te = new Uint8Array(ee);
        for (var oe = new DataView(F.buffer), ge = 0; ge < ee; ge++) {
          var pe = hd(oe, ge, D), me = q1(P[pe], 4)[3];
          te[ge] = me;
        }
      } else re === 0 && (ie = void 0);
      return { colorSpace: "Indexed", colorsPerPixel: 1, sMaskBitsPerComponent: R ? 8 : void 0, colorBytes: F, alphaBytes: te, needSMask: R, palette: J, mask: ie };
    })(i) : o === 2 || o === 4 ? (function(O) {
      for (var U = O.data, V = O.width, F = O.height, P = O.channels, D = O.depth, R = P === 2 ? "DeviceGray" : "DeviceRGB", J = P - 1, ie = V * F, te = J, $ = ie * te, re = 1 * ie, ue = Math.ceil($ * D / 8), se = Math.ceil(re * D / 8), T = new Uint8Array(ue), G = new Uint8Array(se), X = new DataView(U.buffer), Y = new DataView(T.buffer), ee = new DataView(G.buffer), oe = !1, ge = 0; ge < ie; ge++) {
        for (var pe = ge * P, me = 0; me < te; me++) Jw(Y, hd(X, pe + me, D), ge * te + me, D);
        var Ee = hd(X, pe + te, D);
        Ee < (1 << D) - 1 && (oe = !0), Jw(ee, Ee, 1 * ge, D);
      }
      return { colorSpace: R, colorsPerPixel: J, sMaskBitsPerComponent: oe ? D : void 0, colorBytes: T, alphaBytes: G, needSMask: oe };
    })(i) : (function(O) {
      var U = O.data, V = O.channels === 1 ? "DeviceGray" : "DeviceRGB";
      return { colorSpace: V, colorsPerPixel: V === "DeviceGray" ? 1 : 3, colorBytes: U instanceof Uint16Array ? (function(F) {
        for (var P = F.length, D = new Uint8Array(2 * P), R = new DataView(D.buffer, D.byteOffset, D.byteLength), J = 0; J < P; J++) R.setUint16(2 * J, F[J], !1);
        return D;
      })(U) : U, needSMask: !1 };
    })(i);
    var h, f, c, p = n, g = p.colorSpace, v = p.colorsPerPixel, w = p.sMaskBitsPerComponent, B = p.colorBytes, S = p.alphaBytes, C = p.needSMask, E = p.palette, _ = p.mask, I = null;
    return A !== ot.API.image_compression.NONE && typeof z0 == "function" ? (I = (function(O) {
      var U;
      switch (O) {
        case ot.API.image_compression.FAST:
          U = 11;
          break;
        case ot.API.image_compression.MEDIUM:
          U = 13;
          break;
        case ot.API.image_compression.SLOW:
          U = 14;
          break;
        default:
          U = 12;
      }
      return U;
    })(A), h = this.decode.FLATE_DECODE, f = "/Predictor ".concat(I, " /Colors ").concat(v, " /BitsPerComponent ").concat(u, " /Columns ").concat(s), r = qw(B, Math.ceil(s * v * u / 8), v, u, A), C && (c = qw(S, Math.ceil(s * w / 8), 1, w, A))) : (h = void 0, f = void 0, r = B, C && (c = S)), (this.__addimage__.isArrayBuffer(r) || this.__addimage__.isArrayBufferView(r)) && (r = this.__addimage__.arrayBufferToBinaryString(r)), (c && this.__addimage__.isArrayBuffer(c) || this.__addimage__.isArrayBufferView(c)) && (c = this.__addimage__.arrayBufferToBinaryString(c)), { alias: t, data: r, index: e, filter: h, decodeParameters: f, transparency: _, palette: E, sMask: c, predictor: I, width: s, height: a, bitsPerComponent: u, sMaskBitsPerComponent: w, colorSpace: g };
  }
}, (function(r) {
  r.processGIF89A = function(e, t, A, n) {
    var i = new YQ(e), s = i.width, a = i.height, o = [];
    i.decodeAndBlitFrameRGBA(0, o);
    var l = { data: o, width: s, height: a }, u = new fd(100).encode(l, 100);
    return r.processJPEG.call(this, u, t, A, n);
  }, r.processGIF87A = r.processGIF89A;
})(ot.API), Yn.prototype.parseHeader = function() {
  if (this.fileSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.reserved = this.datav.getUint32(this.pos, !0), this.pos += 4, this.offset = this.datav.getUint32(this.pos, !0), this.pos += 4, this.headerSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.width = this.datav.getUint32(this.pos, !0), this.pos += 4, this.height = this.datav.getInt32(this.pos, !0), this.pos += 4, this.planes = this.datav.getUint16(this.pos, !0), this.pos += 2, this.bitPP = this.datav.getUint16(this.pos, !0), this.pos += 2, this.compress = this.datav.getUint32(this.pos, !0), this.pos += 4, this.rawSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.hr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.vr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.colors = this.datav.getUint32(this.pos, !0), this.pos += 4, this.importantColors = this.datav.getUint32(this.pos, !0), this.pos += 4, this.bitPP === 16 && this.is_with_alpha && (this.bitPP = 15), this.bitPP < 15) {
    var r = this.colors === 0 ? 1 << this.bitPP : this.colors;
    this.palette = new Array(r);
    for (var e = 0; e < r; e++) {
      var t = this.datav.getUint8(this.pos++, !0), A = this.datav.getUint8(this.pos++, !0), n = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0);
      this.palette[e] = { red: n, green: A, blue: t, quad: i };
    }
  }
  this.height < 0 && (this.height *= -1, this.bottom_up = !1);
}, Yn.prototype.parseBGR = function() {
  this.pos = this.offset;
  try {
    var r = "bit" + this.bitPP, e = this.width * this.height * 4;
    this.data = new Uint8Array(e), this[r]();
  } catch (t) {
    or.log("bit decode error:" + t);
  }
}, Yn.prototype.bit1 = function() {
  var r, e = Math.ceil(this.width / 8), t = e % 4;
  for (r = this.height - 1; r >= 0; r--) {
    for (var A = this.bottom_up ? r : this.height - 1 - r, n = 0; n < e; n++) for (var i = this.datav.getUint8(this.pos++, !0), s = A * this.width * 4 + 8 * n * 4, a = 0; a < 8 && 8 * n + a < this.width; a++) {
      var o = this.palette[i >> 7 - a & 1];
      this.data[s + 4 * a] = o.blue, this.data[s + 4 * a + 1] = o.green, this.data[s + 4 * a + 2] = o.red, this.data[s + 4 * a + 3] = 255;
    }
    t !== 0 && (this.pos += 4 - t);
  }
}, Yn.prototype.bit4 = function() {
  for (var r = Math.ceil(this.width / 2), e = r % 4, t = this.height - 1; t >= 0; t--) {
    for (var A = this.bottom_up ? t : this.height - 1 - t, n = 0; n < r; n++) {
      var i = this.datav.getUint8(this.pos++, !0), s = A * this.width * 4 + 2 * n * 4, a = i >> 4, o = 15 & i, l = this.palette[a];
      if (this.data[s] = l.blue, this.data[s + 1] = l.green, this.data[s + 2] = l.red, this.data[s + 3] = 255, 2 * n + 1 >= this.width) break;
      l = this.palette[o], this.data[s + 4] = l.blue, this.data[s + 4 + 1] = l.green, this.data[s + 4 + 2] = l.red, this.data[s + 4 + 3] = 255;
    }
    e !== 0 && (this.pos += 4 - e);
  }
}, Yn.prototype.bit8 = function() {
  for (var r = this.width % 4, e = this.height - 1; e >= 0; e--) {
    for (var t = this.bottom_up ? e : this.height - 1 - e, A = 0; A < this.width; A++) {
      var n = this.datav.getUint8(this.pos++, !0), i = t * this.width * 4 + 4 * A;
      if (n < this.palette.length) {
        var s = this.palette[n];
        this.data[i] = s.red, this.data[i + 1] = s.green, this.data[i + 2] = s.blue, this.data[i + 3] = 255;
      } else this.data[i] = 255, this.data[i + 1] = 255, this.data[i + 2] = 255, this.data[i + 3] = 255;
    }
    r !== 0 && (this.pos += 4 - r);
  }
}, Yn.prototype.bit15 = function() {
  for (var r = this.width % 3, e = parseInt("11111", 2), t = this.height - 1; t >= 0; t--) {
    for (var A = this.bottom_up ? t : this.height - 1 - t, n = 0; n < this.width; n++) {
      var i = this.datav.getUint16(this.pos, !0);
      this.pos += 2;
      var s = (i & e) / e * 255 | 0, a = (i >> 5 & e) / e * 255 | 0, o = (i >> 10 & e) / e * 255 | 0, l = i >> 15 ? 255 : 0, u = A * this.width * 4 + 4 * n;
      this.data[u] = o, this.data[u + 1] = a, this.data[u + 2] = s, this.data[u + 3] = l;
    }
    this.pos += r;
  }
}, Yn.prototype.bit16 = function() {
  for (var r = this.width % 3, e = parseInt("11111", 2), t = parseInt("111111", 2), A = this.height - 1; A >= 0; A--) {
    for (var n = this.bottom_up ? A : this.height - 1 - A, i = 0; i < this.width; i++) {
      var s = this.datav.getUint16(this.pos, !0);
      this.pos += 2;
      var a = (s & e) / e * 255 | 0, o = (s >> 5 & t) / t * 255 | 0, l = (s >> 11) / e * 255 | 0, u = n * this.width * 4 + 4 * i;
      this.data[u] = l, this.data[u + 1] = o, this.data[u + 2] = a, this.data[u + 3] = 255;
    }
    this.pos += r;
  }
}, Yn.prototype.bit24 = function() {
  for (var r = this.height - 1; r >= 0; r--) {
    for (var e = this.bottom_up ? r : this.height - 1 - r, t = 0; t < this.width; t++) {
      var A = this.datav.getUint8(this.pos++, !0), n = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), s = e * this.width * 4 + 4 * t;
      this.data[s] = i, this.data[s + 1] = n, this.data[s + 2] = A, this.data[s + 3] = 255;
    }
    this.pos += this.width % 4;
  }
}, Yn.prototype.bit32 = function() {
  for (var r = this.height - 1; r >= 0; r--) for (var e = this.bottom_up ? r : this.height - 1 - r, t = 0; t < this.width; t++) {
    var A = this.datav.getUint8(this.pos++, !0), n = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), s = this.datav.getUint8(this.pos++, !0), a = e * this.width * 4 + 4 * t;
    this.data[a] = i, this.data[a + 1] = n, this.data[a + 2] = A, this.data[a + 3] = s;
  }
}, Yn.prototype.getData = function() {
  return this.data;
}, /**
 * @license
 * Copyright (c) 2018 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(r) {
  r.processBMP = function(e, t, A, n) {
    var i = new Yn(e, !1), s = i.width, a = i.height, o = { data: i.getData(), width: s, height: a }, l = new fd(100).encode(o, 100);
    return r.processJPEG.call(this, l, t, A, n);
  };
})(ot.API), Zw.prototype.getData = function() {
  return this.data;
}, /**
 * @license
 * Copyright (c) 2019 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(r) {
  r.processWEBP = function(e, t, A, n) {
    var i = new Zw(e), s = i.width, a = i.height, o = { data: i.getData(), width: s, height: a }, l = new fd(100).encode(o, 100);
    return r.processJPEG.call(this, l, t, A, n);
  };
})(ot.API), ot.API.processRGBA = function(r, e, t) {
  for (var A = r.data, n = A.length, i = new Uint8Array(n / 4 * 3), s = new Uint8Array(n / 4), a = 0, o = 0, l = 0; l < n; l += 4) {
    var u = A[l], h = A[l + 1], f = A[l + 2], c = A[l + 3];
    i[a++] = u, i[a++] = h, i[a++] = f, s[o++] = c;
  }
  var p = this.__addimage__.arrayBufferToBinaryString(i);
  return { alpha: this.__addimage__.arrayBufferToBinaryString(s), data: p, index: e, alias: t, colorSpace: "DeviceRGB", bitsPerComponent: 8, width: r.width, height: r.height };
}, ot.API.setLanguage = function(r) {
  return this.internal.languageSettings === void 0 && (this.internal.languageSettings = {}, this.internal.languageSettings.isSubscribed = !1), { af: "Afrikaans", sq: "Albanian", ar: "Arabic (Standard)", "ar-DZ": "Arabic (Algeria)", "ar-BH": "Arabic (Bahrain)", "ar-EG": "Arabic (Egypt)", "ar-IQ": "Arabic (Iraq)", "ar-JO": "Arabic (Jordan)", "ar-KW": "Arabic (Kuwait)", "ar-LB": "Arabic (Lebanon)", "ar-LY": "Arabic (Libya)", "ar-MA": "Arabic (Morocco)", "ar-OM": "Arabic (Oman)", "ar-QA": "Arabic (Qatar)", "ar-SA": "Arabic (Saudi Arabia)", "ar-SY": "Arabic (Syria)", "ar-TN": "Arabic (Tunisia)", "ar-AE": "Arabic (U.A.E.)", "ar-YE": "Arabic (Yemen)", an: "Aragonese", hy: "Armenian", as: "Assamese", ast: "Asturian", az: "Azerbaijani", eu: "Basque", be: "Belarusian", bn: "Bengali", bs: "Bosnian", br: "Breton", bg: "Bulgarian", my: "Burmese", ca: "Catalan", ch: "Chamorro", ce: "Chechen", zh: "Chinese", "zh-HK": "Chinese (Hong Kong)", "zh-CN": "Chinese (PRC)", "zh-SG": "Chinese (Singapore)", "zh-TW": "Chinese (Taiwan)", cv: "Chuvash", co: "Corsican", cr: "Cree", hr: "Croatian", cs: "Czech", da: "Danish", nl: "Dutch (Standard)", "nl-BE": "Dutch (Belgian)", en: "English", "en-AU": "English (Australia)", "en-BZ": "English (Belize)", "en-CA": "English (Canada)", "en-IE": "English (Ireland)", "en-JM": "English (Jamaica)", "en-NZ": "English (New Zealand)", "en-PH": "English (Philippines)", "en-ZA": "English (South Africa)", "en-TT": "English (Trinidad & Tobago)", "en-GB": "English (United Kingdom)", "en-US": "English (United States)", "en-ZW": "English (Zimbabwe)", eo: "Esperanto", et: "Estonian", fo: "Faeroese", fj: "Fijian", fi: "Finnish", fr: "French (Standard)", "fr-BE": "French (Belgium)", "fr-CA": "French (Canada)", "fr-FR": "French (France)", "fr-LU": "French (Luxembourg)", "fr-MC": "French (Monaco)", "fr-CH": "French (Switzerland)", fy: "Frisian", fur: "Friulian", gd: "Gaelic (Scots)", "gd-IE": "Gaelic (Irish)", gl: "Galacian", ka: "Georgian", de: "German (Standard)", "de-AT": "German (Austria)", "de-DE": "German (Germany)", "de-LI": "German (Liechtenstein)", "de-LU": "German (Luxembourg)", "de-CH": "German (Switzerland)", el: "Greek", gu: "Gujurati", ht: "Haitian", he: "Hebrew", hi: "Hindi", hu: "Hungarian", is: "Icelandic", id: "Indonesian", iu: "Inuktitut", ga: "Irish", it: "Italian (Standard)", "it-CH": "Italian (Switzerland)", ja: "Japanese", kn: "Kannada", ks: "Kashmiri", kk: "Kazakh", km: "Khmer", ky: "Kirghiz", tlh: "Klingon", ko: "Korean", "ko-KP": "Korean (North Korea)", "ko-KR": "Korean (South Korea)", la: "Latin", lv: "Latvian", lt: "Lithuanian", lb: "Luxembourgish", mk: "North Macedonia", ms: "Malay", ml: "Malayalam", mt: "Maltese", mi: "Maori", mr: "Marathi", mo: "Moldavian", nv: "Navajo", ng: "Ndonga", ne: "Nepali", no: "Norwegian", nb: "Norwegian (Bokmal)", nn: "Norwegian (Nynorsk)", oc: "Occitan", or: "Oriya", om: "Oromo", fa: "Persian", "fa-IR": "Persian/Iran", pl: "Polish", pt: "Portuguese", "pt-BR": "Portuguese (Brazil)", pa: "Punjabi", "pa-IN": "Punjabi (India)", "pa-PK": "Punjabi (Pakistan)", qu: "Quechua", rm: "Rhaeto-Romanic", ro: "Romanian", "ro-MO": "Romanian (Moldavia)", ru: "Russian", "ru-MO": "Russian (Moldavia)", sz: "Sami (Lappish)", sg: "Sango", sa: "Sanskrit", sc: "Sardinian", sd: "Sindhi", si: "Singhalese", sr: "Serbian", sk: "Slovak", sl: "Slovenian", so: "Somani", sb: "Sorbian", es: "Spanish", "es-AR": "Spanish (Argentina)", "es-BO": "Spanish (Bolivia)", "es-CL": "Spanish (Chile)", "es-CO": "Spanish (Colombia)", "es-CR": "Spanish (Costa Rica)", "es-DO": "Spanish (Dominican Republic)", "es-EC": "Spanish (Ecuador)", "es-SV": "Spanish (El Salvador)", "es-GT": "Spanish (Guatemala)", "es-HN": "Spanish (Honduras)", "es-MX": "Spanish (Mexico)", "es-NI": "Spanish (Nicaragua)", "es-PA": "Spanish (Panama)", "es-PY": "Spanish (Paraguay)", "es-PE": "Spanish (Peru)", "es-PR": "Spanish (Puerto Rico)", "es-ES": "Spanish (Spain)", "es-UY": "Spanish (Uruguay)", "es-VE": "Spanish (Venezuela)", sx: "Sutu", sw: "Swahili", sv: "Swedish", "sv-FI": "Swedish (Finland)", "sv-SV": "Swedish (Sweden)", ta: "Tamil", tt: "Tatar", te: "Teluga", th: "Thai", tig: "Tigre", ts: "Tsonga", tn: "Tswana", tr: "Turkish", tk: "Turkmen", uk: "Ukrainian", hsb: "Upper Sorbian", ur: "Urdu", ve: "Venda", vi: "Vietnamese", vo: "Volapuk", wa: "Walloon", cy: "Welsh", xh: "Xhosa", ji: "Yiddish", zu: "Zulu" }[r] !== void 0 && (this.internal.languageSettings.languageCode = r, this.internal.languageSettings.isSubscribed === !1 && (this.internal.events.subscribe("putCatalog", function() {
    this.internal.write("/Lang (" + this.internal.languageSettings.languageCode + ")");
  }), this.internal.languageSettings.isSubscribed = !0)), this;
}, ro = ot.API, mc = ro.getCharWidthsArray = function(r, e) {
  var t, A, n = (e = e || {}).font || this.internal.getFont(), i = e.fontSize || this.internal.getFontSize(), s = e.charSpace || this.internal.getCharSpace(), a = e.widths ? e.widths : n.metadata.Unicode.widths, o = a.fof ? a.fof : 1, l = e.kerning ? e.kerning : n.metadata.Unicode.kerning, u = l.fof ? l.fof : 1, h = e.doKerning !== !1, f = 0, c = r.length, p = 0, g = a[0] || o, v = [];
  for (t = 0; t < c; t++) A = r.charCodeAt(t), typeof n.metadata.widthOfString == "function" ? v.push((n.metadata.widthOfGlyph(n.metadata.characterToGlyph(A)) + s * (1e3 / i) || 0) / 1e3) : (f = h && jt(l[A]) === "object" && !isNaN(parseInt(l[A][p], 10)) ? l[A][p] / u : 0, v.push((a[A] || g) / o + f)), p = A;
  return v;
}, Vw = ro.getStringUnitWidth = function(r, e) {
  var t = (e = e || {}).fontSize || this.internal.getFontSize(), A = e.font || this.internal.getFont(), n = e.charSpace || this.internal.getCharSpace();
  return ro.processArabic && (r = ro.processArabic(r)), typeof A.metadata.widthOfString == "function" ? A.metadata.widthOfString(r, t, n) / t : mc.apply(this, arguments).reduce(function(i, s) {
    return i + s;
  }, 0);
}, Kw = function(r, e, t, A) {
  for (var n = [], i = 0, s = r.length, a = 0; i !== s && a + e[i] < t; ) a += e[i], i++;
  n.push(r.slice(0, i));
  var o = i;
  for (a = 0; i !== s; ) a + e[i] > A && (n.push(r.slice(o, i)), a = 0, o = i), a += e[i], i++;
  return o !== i && n.push(r.slice(o, i)), n;
}, jw = function(r, e, t) {
  t || (t = {});
  var A, n, i, s, a, o, l, u = [], h = [u], f = t.textIndent || 0, c = 0, p = 0, g = r.split(" "), v = mc.apply(this, [" ", t])[0];
  if (o = t.lineIndent === -1 ? g[0].length + 2 : t.lineIndent || 0) {
    var w = Array(o).join(" "), B = [];
    g.map(function(C) {
      (C = C.split(/\s*\n/)).length > 1 ? B = B.concat(C.map(function(E, _) {
        return (_ && E.length ? `
` : "") + E;
      })) : B.push(C[0]);
    }), g = B, o = Vw.apply(this, [w, t]);
  }
  for (i = 0, s = g.length; i < s; i++) {
    var S = 0;
    if (A = g[i], o && A[0] == `
` && (A = A.substr(1), S = 1), f + c + (p = (n = mc.apply(this, [A, t])).reduce(function(C, E) {
      return C + E;
    }, 0)) > e || S) {
      if (p > e) {
        for (a = Kw.apply(this, [A, n, e - (f + c), e]), u.push(a.shift()), u = [a.pop()]; a.length; ) h.push([a.shift()]);
        p = n.slice(A.length - (u[0] ? u[0].length : 0)).reduce(function(C, E) {
          return C + E;
        }, 0);
      } else u = [A];
      h.push(u), f = p + o, c = v;
    } else u.push(A), f += c + p, c = v;
  }
  return l = o ? function(C, E) {
    return (E ? w : "") + C.join(" ");
  } : function(C) {
    return C.join(" ");
  }, h.map(l);
}, ro.splitTextToSize = function(r, e, t) {
  var A, n = (t = t || {}).fontSize || this.internal.getFontSize(), i = (function(u) {
    if (u.widths && u.kerning) return { widths: u.widths, kerning: u.kerning };
    var h = this.internal.getFont(u.fontName, u.fontStyle), f = "Unicode";
    return h.metadata[f] ? { widths: h.metadata[f].widths || { 0: 1 }, kerning: h.metadata[f].kerning || {} } : { font: h.metadata, fontSize: this.internal.getFontSize(), charSpace: this.internal.getCharSpace() };
  }).call(this, t);
  A = Array.isArray(r) ? r : String(r).split(/\r?\n/);
  var s = 1 * this.internal.scaleFactor * e / n;
  i.textIndent = t.textIndent ? 1 * t.textIndent * this.internal.scaleFactor / n : 0, i.lineIndent = t.lineIndent;
  var a, o, l = [];
  for (a = 0, o = A.length; a < o; a++) l = l.concat(jw.apply(this, [A[a], s, i]));
  return l;
}, (function(r) {
  r.__fontmetrics__ = r.__fontmetrics__ || {};
  for (var e = "0123456789abcdef", t = "klmnopqrstuvwxyz", A = {}, n = {}, i = 0; i < 16; i++) A[t[i]] = e[i], n[e[i]] = t[i];
  var s = function(f) {
    return "0x" + parseInt(f, 10).toString(16);
  }, a = r.__fontmetrics__.compress = function(f) {
    var c, p, g, v, w = ["{"];
    for (var B in f) {
      if (c = f[B], isNaN(parseInt(B, 10)) ? p = "'" + B + "'" : (B = parseInt(B, 10), p = (p = s(B).slice(2)).slice(0, -1) + n[p.slice(-1)]), typeof c == "number") c < 0 ? (g = s(c).slice(3), v = "-") : (g = s(c).slice(2), v = ""), g = v + g.slice(0, -1) + n[g.slice(-1)];
      else {
        if (jt(c) !== "object") throw new Error("Don't know what to do with value type " + jt(c) + ".");
        g = a(c);
      }
      w.push(p + g);
    }
    return w.push("}"), w.join("");
  }, o = r.__fontmetrics__.uncompress = function(f) {
    if (typeof f != "string") throw new Error("Invalid argument passed to uncompress.");
    for (var c, p, g, v, w = {}, B = 1, S = w, C = [], E = "", _ = "", I = f.length - 1, O = 1; O < I; O += 1) (v = f[O]) == "'" ? c ? (g = c.join(""), c = void 0) : c = [] : c ? c.push(v) : v == "{" ? (C.push([S, g]), S = {}, g = void 0) : v == "}" ? ((p = C.pop())[0][p[1]] = S, g = void 0, S = p[0]) : v == "-" ? B = -1 : g === void 0 ? A.hasOwnProperty(v) ? (E += A[v], g = parseInt(E, 16) * B, B = 1, E = "") : E += v : A.hasOwnProperty(v) ? (_ += A[v], S[g] = parseInt(_, 16) * B, B = 1, g = void 0, _ = "") : _ += v;
    return w;
  }, l = { codePages: ["WinAnsiEncoding"], WinAnsiEncoding: o("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}") }, u = { Unicode: { Courier: l, "Courier-Bold": l, "Courier-BoldOblique": l, "Courier-Oblique": l, Helvetica: l, "Helvetica-Bold": l, "Helvetica-BoldOblique": l, "Helvetica-Oblique": l, "Times-Roman": l, "Times-Bold": l, "Times-BoldItalic": l, "Times-Italic": l } }, h = { Unicode: { "Courier-Oblique": o("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"), "Times-BoldItalic": o("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"), "Helvetica-Bold": o("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"), Courier: o("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"), "Courier-BoldOblique": o("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"), "Times-Bold": o("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"), Symbol: o("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"), Helvetica: o("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"), "Helvetica-BoldOblique": o("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"), ZapfDingbats: o("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"), "Courier-Bold": o("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"), "Times-Italic": o("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"), "Times-Roman": o("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"), "Helvetica-Oblique": o("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}") } };
  r.events.push(["addFont", function(f) {
    var c = f.font, p = h.Unicode[c.postScriptName];
    p && (c.metadata.Unicode = {}, c.metadata.Unicode.widths = p.widths, c.metadata.Unicode.kerning = p.kerning);
    var g = u.Unicode[c.postScriptName];
    g && (c.metadata.Unicode.encoding = g, c.encoding = g.codePages[0]);
  }]);
})(ot.API), /**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(r) {
  var e = function(t) {
    for (var A = t.length, n = new Uint8Array(A), i = 0; i < A; i++) n[i] = t.charCodeAt(i);
    return n;
  };
  r.API.events.push(["addFont", function(t) {
    var A = void 0, n = t.font, i = t.instance;
    if (!n.isStandardFont) {
      if (i === void 0) throw new Error("Font does not exist in vFS, import fonts or remove declaration doc.addFont('" + n.postScriptName + "').");
      if (typeof (A = i.existsFileInVFS(n.postScriptName) === !1 ? i.loadFile(n.postScriptName) : i.getFileFromVFS(n.postScriptName)) != "string") throw new Error("Font is not stored as string-data in vFS, import fonts or remove declaration doc.addFont('" + n.postScriptName + "').");
      (function(s, a) {
        a = /^\x00\x01\x00\x00/.test(a) ? e(a) : e(Zc(a)), s.metadata = r.API.TTFFont.open(a), s.metadata.Unicode = s.metadata.Unicode || { encoding: {}, kerning: {}, widths: [] }, s.metadata.glyIdsUsed = [0];
      })(n, A);
    }
  }]);
})(ot), ot.API.addSvgAsImage = function(r, e, t, A, n, i, s, a) {
  if (isNaN(e) || isNaN(t)) throw or.error("jsPDF.addSvgAsImage: Invalid coordinates", arguments), new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");
  if (isNaN(A) || isNaN(n)) throw or.error("jsPDF.addSvgAsImage: Invalid measurements", arguments), new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");
  var o = document.createElement("canvas");
  o.width = A, o.height = n;
  var l = o.getContext("2d");
  l.fillStyle = "#fff", l.fillRect(0, 0, o.width, o.height);
  var u = { ignoreMouse: !0, ignoreAnimation: !0, ignoreDimensions: !0 }, h = this;
  return (Ct.canvg ? Promise.resolve(Ct.canvg) : Promise.resolve().then(() => B8)).catch(function(f) {
    return Promise.reject(new Error("Could not load canvg: " + f));
  }).then(function(f) {
    return f.default ? f.default : f;
  }).then(function(f) {
    return f.fromString(l, r, u);
  }, function() {
    return Promise.reject(new Error("Could not load canvg."));
  }).then(function(f) {
    return f.render(u);
  }).then(function() {
    h.addImage(o.toDataURL("image/jpeg", 1), e, t, A, n, s, a);
  });
}, ot.API.putTotalPages = function(r) {
  var e, t = 0;
  parseInt(this.internal.getFont().id.substr(1), 10) < 15 ? (e = new RegExp(r, "g"), t = this.internal.getNumberOfPages()) : (e = new RegExp(this.pdfEscape16(r, this.internal.getFont()), "g"), t = this.pdfEscape16(this.internal.getNumberOfPages() + "", this.internal.getFont()));
  for (var A = 1; A <= this.internal.getNumberOfPages(); A++) for (var n = 0; n < this.internal.pages[A].length; n++) this.internal.pages[A][n] = this.internal.pages[A][n].replace(e, t);
  return this;
}, ot.API.viewerPreferences = function(r, e) {
  var t;
  r = r || {}, e = e || !1;
  var A, n, i, s = { HideToolbar: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, HideMenubar: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, HideWindowUI: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, FitWindow: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, CenterWindow: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, DisplayDocTitle: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.4 }, NonFullScreenPageMode: { defaultValue: "UseNone", value: "UseNone", type: "name", explicitSet: !1, valueSet: ["UseNone", "UseOutlines", "UseThumbs", "UseOC"], pdfVersion: 1.3 }, Direction: { defaultValue: "L2R", value: "L2R", type: "name", explicitSet: !1, valueSet: ["L2R", "R2L"], pdfVersion: 1.3 }, ViewArea: { defaultValue: "CropBox", value: "CropBox", type: "name", explicitSet: !1, valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"], pdfVersion: 1.4 }, ViewClip: { defaultValue: "CropBox", value: "CropBox", type: "name", explicitSet: !1, valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"], pdfVersion: 1.4 }, PrintArea: { defaultValue: "CropBox", value: "CropBox", type: "name", explicitSet: !1, valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"], pdfVersion: 1.4 }, PrintClip: { defaultValue: "CropBox", value: "CropBox", type: "name", explicitSet: !1, valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"], pdfVersion: 1.4 }, PrintScaling: { defaultValue: "AppDefault", value: "AppDefault", type: "name", explicitSet: !1, valueSet: ["AppDefault", "None"], pdfVersion: 1.6 }, Duplex: { defaultValue: "", value: "none", type: "name", explicitSet: !1, valueSet: ["Simplex", "DuplexFlipShortEdge", "DuplexFlipLongEdge", "none"], pdfVersion: 1.7 }, PickTrayByPDFSize: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.7 }, PrintPageRange: { defaultValue: "", value: "", type: "array", explicitSet: !1, valueSet: null, pdfVersion: 1.7 }, NumCopies: { defaultValue: 1, value: 1, type: "integer", explicitSet: !1, valueSet: null, pdfVersion: 1.7 } }, a = Object.keys(s), o = [], l = 0, u = 0, h = 0;
  function f(p, g) {
    var v, w = !1;
    for (v = 0; v < p.length; v += 1) p[v] === g && (w = !0);
    return w;
  }
  if (this.internal.viewerpreferences === void 0 && (this.internal.viewerpreferences = {}, this.internal.viewerpreferences.configuration = JSON.parse(JSON.stringify(s)), this.internal.viewerpreferences.isSubscribed = !1), t = this.internal.viewerpreferences.configuration, r === "reset" || e === !0) {
    var c = a.length;
    for (h = 0; h < c; h += 1) t[a[h]].value = t[a[h]].defaultValue, t[a[h]].explicitSet = !1;
  }
  if (jt(r) === "object") {
    for (n in r) if (i = r[n], f(a, n) && i !== void 0) {
      if (t[n].type === "boolean" && typeof i == "boolean") t[n].value = i;
      else if (t[n].type === "name" && f(t[n].valueSet, i)) t[n].value = i;
      else if (t[n].type === "integer" && Number.isInteger(i)) t[n].value = i;
      else if (t[n].type === "array") {
        for (l = 0; l < i.length; l += 1) if (A = !0, i[l].length === 1 && typeof i[l][0] == "number") o.push(String(i[l] - 1));
        else if (i[l].length > 1) {
          for (u = 0; u < i[l].length; u += 1) typeof i[l][u] != "number" && (A = !1);
          A === !0 && o.push([i[l][0] - 1, i[l][1] - 1].join(" "));
        }
        t[n].value = "[" + o.join(" ") + "]";
      } else t[n].value = t[n].defaultValue;
      t[n].explicitSet = !0;
    }
  }
  return this.internal.viewerpreferences.isSubscribed === !1 && (this.internal.events.subscribe("putCatalog", function() {
    var p, g = [];
    for (p in t) t[p].explicitSet === !0 && (t[p].type === "name" ? g.push("/" + p + " /" + t[p].value) : g.push("/" + p + " " + t[p].value));
    g.length !== 0 && this.internal.write(`/ViewerPreferences
<<
` + g.join(`
`) + `
>>`);
  }), this.internal.viewerpreferences.isSubscribed = !0), this.internal.viewerpreferences.configuration = t, this;
}, /** ====================================================================
 * @license
 * jsPDF XMP metadata plugin
 * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */
(function(r) {
  var e = function() {
    var A = '<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="' + this.internal.__metadata__.namespaceuri + '"><jspdf:metadata>', n = unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')), i = unescape(encodeURIComponent(A)), s = unescape(encodeURIComponent(this.internal.__metadata__.metadata)), a = unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")), o = unescape(encodeURIComponent("</x:xmpmeta>")), l = i.length + s.length + a.length + n.length + o.length;
    this.internal.__metadata__.metadata_object_number = this.internal.newObject(), this.internal.write("<< /Type /Metadata /Subtype /XML /Length " + l + " >>"), this.internal.write("stream"), this.internal.write(n + i + s + a + o), this.internal.write("endstream"), this.internal.write("endobj");
  }, t = function() {
    this.internal.__metadata__.metadata_object_number && this.internal.write("/Metadata " + this.internal.__metadata__.metadata_object_number + " 0 R");
  };
  r.addMetadata = function(A, n) {
    return this.internal.__metadata__ === void 0 && (this.internal.__metadata__ = { metadata: A, namespaceuri: n || "http://jspdf.default.namespaceuri/" }, this.internal.events.subscribe("putCatalog", t), this.internal.events.subscribe("postPutResources", e)), this;
  };
})(ot.API), (function(r) {
  var e = r.API, t = e.pdfEscape16 = function(i, s) {
    for (var a, o = s.metadata.Unicode.widths, l = ["", "0", "00", "000", "0000"], u = [""], h = 0, f = i.length; h < f; ++h) {
      if (a = s.metadata.characterToGlyph(i.charCodeAt(h)), s.metadata.glyIdsUsed.push(a), s.metadata.toUnicode[a] = i.charCodeAt(h), o.indexOf(a) == -1 && (o.push(a), o.push([parseInt(s.metadata.widthOfGlyph(a), 10)])), a == "0") return u.join("");
      a = a.toString(16), u.push(l[4 - a.length], a);
    }
    return u.join("");
  }, A = function(i) {
    var s, a, o, l, u, h, f;
    for (u = `/CIDInit /ProcSet findresource begin
12 dict begin
begincmap
/CIDSystemInfo <<
  /Registry (Adobe)
  /Ordering (UCS)
  /Supplement 0
>> def
/CMapName /Adobe-Identity-UCS def
/CMapType 2 def
1 begincodespacerange
<0000><ffff>
endcodespacerange`, o = [], h = 0, f = (a = Object.keys(i).sort(function(c, p) {
      return c - p;
    })).length; h < f; h++) s = a[h], o.length >= 100 && (u += `
` + o.length + ` beginbfchar
` + o.join(`
`) + `
endbfchar`, o = []), i[s] !== void 0 && i[s] !== null && typeof i[s].toString == "function" && (l = ("0000" + i[s].toString(16)).slice(-4), s = ("0000" + (+s).toString(16)).slice(-4), o.push("<" + s + "><" + l + ">"));
    return o.length && (u += `
` + o.length + ` beginbfchar
` + o.join(`
`) + `
endbfchar
`), u + `endcmap
CMapName currentdict /CMap defineresource pop
end
end`;
  };
  e.events.push(["putFont", function(i) {
    (function(s) {
      var a = s.font, o = s.out, l = s.newObject, u = s.putStream;
      if (a.metadata instanceof r.API.TTFFont && a.encoding === "Identity-H") {
        for (var h = a.metadata.Unicode.widths, f = a.metadata.subset.encode(a.metadata.glyIdsUsed, 1), c = "", p = 0; p < f.length; p++) c += String.fromCharCode(f[p]);
        var g = l();
        u({ data: c, addLength1: !0, objectId: g }), o("endobj");
        var v = l();
        u({ data: A(a.metadata.toUnicode), addLength1: !0, objectId: v }), o("endobj");
        var w = l();
        o("<<"), o("/Type /FontDescriptor"), o("/FontName /" + ho(a.fontName)), o("/FontFile2 " + g + " 0 R"), o("/FontBBox " + r.API.PDFObject.convert(a.metadata.bbox)), o("/Flags " + a.metadata.flags), o("/StemV " + a.metadata.stemV), o("/ItalicAngle " + a.metadata.italicAngle), o("/Ascent " + a.metadata.ascender), o("/Descent " + a.metadata.decender), o("/CapHeight " + a.metadata.capHeight), o(">>"), o("endobj");
        var B = l();
        o("<<"), o("/Type /Font"), o("/BaseFont /" + ho(a.fontName)), o("/FontDescriptor " + w + " 0 R"), o("/W " + r.API.PDFObject.convert(h)), o("/CIDToGIDMap /Identity"), o("/DW 1000"), o("/Subtype /CIDFontType2"), o("/CIDSystemInfo"), o("<<"), o("/Supplement 0"), o("/Registry (Adobe)"), o("/Ordering (" + a.encoding + ")"), o(">>"), o(">>"), o("endobj"), a.objectNumber = l(), o("<<"), o("/Type /Font"), o("/Subtype /Type0"), o("/ToUnicode " + v + " 0 R"), o("/BaseFont /" + ho(a.fontName)), o("/Encoding /" + a.encoding), o("/DescendantFonts [" + B + " 0 R]"), o(">>"), o("endobj"), a.isAlreadyPutted = !0;
      }
    })(i);
  }]), e.events.push(["putFont", function(i) {
    (function(s) {
      var a = s.font, o = s.out, l = s.newObject, u = s.putStream;
      if (a.metadata instanceof r.API.TTFFont && a.encoding === "WinAnsiEncoding") {
        for (var h = a.metadata.rawData, f = "", c = 0; c < h.length; c++) f += String.fromCharCode(h[c]);
        var p = l();
        u({ data: f, addLength1: !0, objectId: p }), o("endobj");
        var g = l();
        u({ data: A(a.metadata.toUnicode), addLength1: !0, objectId: g }), o("endobj");
        var v = l();
        o("<<"), o("/Descent " + a.metadata.decender), o("/CapHeight " + a.metadata.capHeight), o("/StemV " + a.metadata.stemV), o("/Type /FontDescriptor"), o("/FontFile2 " + p + " 0 R"), o("/Flags 96"), o("/FontBBox " + r.API.PDFObject.convert(a.metadata.bbox)), o("/FontName /" + ho(a.fontName)), o("/ItalicAngle " + a.metadata.italicAngle), o("/Ascent " + a.metadata.ascender), o(">>"), o("endobj"), a.objectNumber = l();
        for (var w = 0; w < a.metadata.hmtx.widths.length; w++) a.metadata.hmtx.widths[w] = parseInt(a.metadata.hmtx.widths[w] * (1e3 / a.metadata.head.unitsPerEm));
        o("<</Subtype/TrueType/Type/Font/ToUnicode " + g + " 0 R/BaseFont/" + ho(a.fontName) + "/FontDescriptor " + v + " 0 R/Encoding/" + a.encoding + " /FirstChar 29 /LastChar 255 /Widths " + r.API.PDFObject.convert(a.metadata.hmtx.widths) + ">>"), o("endobj"), a.isAlreadyPutted = !0;
      }
    })(i);
  }]);
  var n = function(i) {
    var s, a = i.text || "", o = i.x, l = i.y, u = i.options || {}, h = i.mutex || {}, f = h.pdfEscape, c = h.activeFontKey, p = h.fonts, g = c, v = "", w = 0, B = "", S = p[g].encoding;
    if (p[g].encoding !== "Identity-H") return { text: a, x: o, y: l, options: u, mutex: h };
    for (B = a, g = c, Array.isArray(a) && (B = a[0]), w = 0; w < B.length; w += 1) p[g].metadata.hasOwnProperty("cmap") && (s = p[g].metadata.cmap.unicode.codeMap[B[w].charCodeAt(0)]), s || B[w].charCodeAt(0) < 256 && p[g].metadata.hasOwnProperty("Unicode") ? v += B[w] : v += "";
    var C = "";
    return parseInt(g.slice(1)) < 14 || S === "WinAnsiEncoding" ? C = f(v, g).split("").map(function(E) {
      return E.charCodeAt(0).toString(16);
    }).join("") : S === "Identity-H" && (C = t(v, p[g])), h.isHex = !0, { text: C, x: o, y: l, options: u, mutex: h };
  };
  e.events.push(["postProcessText", function(i) {
    var s = i.text || "", a = [], o = { text: s, x: i.x, y: i.y, options: i.options, mutex: i.mutex };
    if (Array.isArray(s)) {
      var l = 0;
      for (l = 0; l < s.length; l += 1) Array.isArray(s[l]) && s[l].length === 3 ? a.push([n(Object.assign({}, o, { text: s[l][0] })).text, s[l][1], s[l][2]]) : a.push(n(Object.assign({}, o, { text: s[l] })).text);
      i.text = a;
    } else i.text = n(Object.assign({}, o, { text: s })).text;
  }]);
})(ot), /**
 * @license
 * jsPDF virtual FileSystem functionality
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(r) {
  var e = function() {
    return this.internal.vFS === void 0 && (this.internal.vFS = {}), !0;
  };
  r.existsFileInVFS = function(t) {
    return e.call(this), this.internal.vFS[t] !== void 0;
  }, r.addFileToVFS = function(t, A) {
    return e.call(this), this.internal.vFS[t] = A, this;
  }, r.getFileFromVFS = function(t) {
    return e.call(this), this.internal.vFS[t] !== void 0 ? this.internal.vFS[t] : null;
  };
})(ot.API), /**
 * @license
 * Unicode Bidi Engine based on the work of Alex Shensis (@asthensis)
 * MIT License
 */
(function(r) {
  r.__bidiEngine__ = r.prototype.__bidiEngine__ = function(A) {
    var n, i, s, a, o, l, u, h = e, f = [[0, 3, 0, 1, 0, 0, 0], [0, 3, 0, 1, 2, 2, 0], [0, 3, 0, 17, 2, 0, 1], [0, 3, 5, 5, 4, 1, 0], [0, 3, 21, 21, 4, 0, 1], [0, 3, 5, 5, 4, 2, 0]], c = [[2, 0, 1, 1, 0, 1, 0], [2, 0, 1, 1, 0, 2, 0], [2, 0, 2, 1, 3, 2, 0], [2, 0, 2, 33, 3, 1, 1]], p = { L: 0, R: 1, EN: 2, AN: 3, N: 4, B: 5, S: 6 }, g = { 0: 0, 5: 1, 6: 2, 7: 3, 32: 4, 251: 5, 254: 6, 255: 7 }, v = ["(", ")", "(", "<", ">", "<", "[", "]", "[", "{", "}", "{", "«", "»", "«", "‹", "›", "‹", "⁅", "⁆", "⁅", "⁽", "⁾", "⁽", "₍", "₎", "₍", "≤", "≥", "≤", "〈", "〉", "〈", "﹙", "﹚", "﹙", "﹛", "﹜", "﹛", "﹝", "﹞", "﹝", "﹤", "﹥", "﹤"], w = new RegExp(/^([1-4|9]|1[0-9]|2[0-9]|3[0168]|4[04589]|5[012]|7[78]|159|16[0-9]|17[0-2]|21[569]|22[03489]|250)$/), B = !1, S = 0;
    this.__bidiEngine__ = {};
    var C = function(F) {
      var P = F.charCodeAt(), D = P >> 8, R = g[D];
      return R !== void 0 ? h[256 * R + (255 & P)] : D === 252 || D === 253 ? "AL" : w.test(D) ? "L" : D === 8 ? "R" : "N";
    }, E = function(F) {
      for (var P, D = 0; D < F.length; D++) {
        if ((P = C(F.charAt(D))) === "L") return !1;
        if (P === "R") return !0;
      }
      return !1;
    }, _ = function(F, P, D, R) {
      var J, ie, te, $, re = P[R];
      switch (re) {
        case "L":
        case "R":
        case "LRE":
        case "RLE":
        case "LRO":
        case "RLO":
        case "PDF":
          B = !1;
          break;
        case "N":
        case "AN":
          break;
        case "EN":
          B && (re = "AN");
          break;
        case "AL":
          B = !0, re = "R";
          break;
        case "WS":
        case "BN":
          re = "N";
          break;
        case "CS":
          R < 1 || R + 1 >= P.length || (J = D[R - 1]) !== "EN" && J !== "AN" || (ie = P[R + 1]) !== "EN" && ie !== "AN" ? re = "N" : B && (ie = "AN"), re = ie === J ? ie : "N";
          break;
        case "ES":
          re = (J = R > 0 ? D[R - 1] : "B") === "EN" && R + 1 < P.length && P[R + 1] === "EN" ? "EN" : "N";
          break;
        case "ET":
          if (R > 0 && D[R - 1] === "EN") {
            re = "EN";
            break;
          }
          if (B) {
            re = "N";
            break;
          }
          for (te = R + 1, $ = P.length; te < $ && P[te] === "ET"; ) te++;
          re = te < $ && P[te] === "EN" ? "EN" : "N";
          break;
        case "NSM":
          if (s && !a) {
            for ($ = P.length, te = R + 1; te < $ && P[te] === "NSM"; ) te++;
            if (te < $) {
              var ue = F[R], se = ue >= 1425 && ue <= 2303 || ue === 64286;
              if (J = P[te], se && (J === "R" || J === "AL")) {
                re = "R";
                break;
              }
            }
          }
          re = R < 1 || (J = P[R - 1]) === "B" ? "N" : D[R - 1];
          break;
        case "B":
          B = !1, n = !0, re = S;
          break;
        case "S":
          i = !0, re = "N";
      }
      return re;
    }, I = function(F, P, D) {
      var R = F.split("");
      return D && O(R, D, { hiLevel: S }), R.reverse(), P && P.reverse(), R.join("");
    }, O = function(F, P, D) {
      var R, J, ie, te, $, re = -1, ue = F.length, se = 0, T = [], G = S ? c : f, X = [];
      for (B = !1, n = !1, i = !1, J = 0; J < ue; J++) X[J] = C(F[J]);
      for (ie = 0; ie < ue; ie++) {
        if ($ = se, T[ie] = _(F, X, T, ie), R = 240 & (se = G[$][p[T[ie]]]), se &= 15, P[ie] = te = G[se][5], R > 0) if (R === 16) {
          for (J = re; J < ie; J++) P[J] = 1;
          re = -1;
        } else re = -1;
        if (G[se][6]) re === -1 && (re = ie);
        else if (re > -1) {
          for (J = re; J < ie; J++) P[J] = te;
          re = -1;
        }
        X[ie] === "B" && (P[ie] = 0), D.hiLevel |= te;
      }
      i && (function(Y, ee, oe) {
        for (var ge = 0; ge < oe; ge++) if (Y[ge] === "S") {
          ee[ge] = S;
          for (var pe = ge - 1; pe >= 0 && Y[pe] === "WS"; pe--) ee[pe] = S;
        }
      })(X, P, ue);
    }, U = function(F, P, D, R, J) {
      if (!(J.hiLevel < F)) {
        if (F === 1 && S === 1 && !n) return P.reverse(), void (D && D.reverse());
        for (var ie, te, $, re, ue = P.length, se = 0; se < ue; ) {
          if (R[se] >= F) {
            for ($ = se + 1; $ < ue && R[$] >= F; ) $++;
            for (re = se, te = $ - 1; re < te; re++, te--) ie = P[re], P[re] = P[te], P[te] = ie, D && (ie = D[re], D[re] = D[te], D[te] = ie);
            se = $;
          }
          se++;
        }
      }
    }, V = function(F, P, D) {
      var R = F.split(""), J = { hiLevel: S };
      return D || (D = []), O(R, D, J), (function(ie, te, $) {
        if ($.hiLevel !== 0 && u) for (var re, ue = 0; ue < ie.length; ue++) te[ue] === 1 && (re = v.indexOf(ie[ue])) >= 0 && (ie[ue] = v[re + 1]);
      })(R, D, J), U(2, R, P, D, J), U(1, R, P, D, J), R.join("");
    };
    return this.__bidiEngine__.doBidiReorder = function(F, P, D) {
      if ((function(J, ie) {
        if (ie) for (var te = 0; te < J.length; te++) ie[te] = te;
        a === void 0 && (a = E(J)), l === void 0 && (l = E(J));
      })(F, P), s || !o || l) if (s && o && a ^ l) S = a ? 1 : 0, F = I(F, P, D);
      else if (!s && o && l) S = a ? 1 : 0, F = V(F, P, D), F = I(F, P);
      else if (!s || a || o || l) {
        if (s && !o && a ^ l) F = I(F, P), a ? (S = 0, F = V(F, P, D)) : (S = 1, F = V(F, P, D), F = I(F, P));
        else if (s && a && !o && l) S = 1, F = V(F, P, D), F = I(F, P);
        else if (!s && !o && a ^ l) {
          var R = u;
          a ? (S = 1, F = V(F, P, D), S = 0, u = !1, F = V(F, P, D), u = R) : (S = 0, F = V(F, P, D), F = I(F, P), S = 1, u = !1, F = V(F, P, D), u = R, F = I(F, P));
        }
      } else S = 0, F = V(F, P, D);
      else S = a ? 1 : 0, F = V(F, P, D);
      return F;
    }, this.__bidiEngine__.setOptions = function(F) {
      F && (s = F.isInputVisual, o = F.isOutputVisual, a = F.isInputRtl, l = F.isOutputRtl, u = F.isSymmetricSwapping);
    }, this.__bidiEngine__.setOptions(A), this.__bidiEngine__;
  };
  var e = ["BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "S", "B", "S", "WS", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "B", "B", "B", "S", "WS", "N", "N", "ET", "ET", "ET", "N", "N", "N", "N", "N", "ES", "CS", "ES", "CS", "CS", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "CS", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "BN", "BN", "BN", "BN", "BN", "BN", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "CS", "N", "ET", "ET", "ET", "ET", "N", "N", "N", "N", "L", "N", "N", "BN", "N", "N", "ET", "ET", "EN", "EN", "N", "L", "N", "N", "N", "EN", "L", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "N", "N", "N", "N", "N", "ET", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "R", "NSM", "R", "NSM", "NSM", "R", "NSM", "NSM", "R", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "N", "N", "N", "N", "N", "R", "R", "R", "R", "R", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "AN", "AN", "AN", "AN", "AN", "AN", "N", "N", "AL", "ET", "ET", "AL", "CS", "AL", "N", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "ET", "AN", "AN", "AL", "AL", "AL", "NSM", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "NSM", "NSM", "N", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "N", "AL", "AL", "NSM", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "R", "R", "N", "N", "N", "N", "R", "N", "N", "N", "N", "N", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "BN", "BN", "BN", "L", "R", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "WS", "B", "LRE", "RLE", "PDF", "LRO", "RLO", "CS", "ET", "ET", "ET", "ET", "ET", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "CS", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "WS", "BN", "BN", "BN", "BN", "BN", "N", "LRI", "RLI", "FSI", "PDI", "BN", "BN", "BN", "BN", "BN", "BN", "EN", "L", "N", "N", "EN", "EN", "EN", "EN", "EN", "EN", "ES", "ES", "N", "N", "N", "L", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "ES", "ES", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "R", "NSM", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "ES", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "N", "R", "R", "R", "R", "R", "N", "R", "N", "R", "R", "N", "R", "R", "N", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "CS", "N", "CS", "N", "N", "CS", "N", "N", "N", "N", "N", "N", "N", "N", "N", "ET", "N", "N", "ES", "ES", "N", "N", "N", "N", "N", "ET", "ET", "N", "N", "N", "N", "N", "AL", "AL", "AL", "AL", "AL", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "N", "N", "BN", "N", "N", "N", "ET", "ET", "ET", "N", "N", "N", "N", "N", "ES", "CS", "ES", "CS", "CS", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "CS", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "N", "N", "N", "ET", "ET", "N", "N", "N", "ET", "ET", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N"], t = new r.__bidiEngine__({ isInputVisual: !0 });
  r.API.events.push(["postProcessText", function(A) {
    var n = A.text;
    A.x, A.y;
    var i = A.options || {};
    A.mutex, i.lang;
    var s = [];
    if (i.isInputVisual = typeof i.isInputVisual != "boolean" || i.isInputVisual, t.setOptions(i), Object.prototype.toString.call(n) === "[object Array]") {
      var a = 0;
      for (s = [], a = 0; a < n.length; a += 1) Object.prototype.toString.call(n[a]) === "[object Array]" ? s.push([t.doBidiReorder(n[a][0]), n[a][1], n[a][2]]) : s.push([t.doBidiReorder(n[a])]);
      A.text = s;
    } else A.text = t.doBidiReorder(n);
    t.setOptions({ isInputVisual: !0 });
  }]);
})(ot), ot.API.TTFFont = (function() {
  function r(e) {
    var t;
    if (this.rawData = e, t = this.contents = new ks(e), this.contents.pos = 4, t.readString(4) === "ttcf") throw new Error("TTCF not supported.");
    t.pos = 0, this.parse(), this.subset = new cL(this), this.registerTTF();
  }
  return r.open = function(e) {
    return new r(e);
  }, r.prototype.parse = function() {
    return this.directory = new JQ(this.contents), this.head = new ZQ(this), this.name = new nL(this), this.cmap = new D5(this), this.toUnicode = {}, this.hhea = new eL(this), this.maxp = new iL(this), this.hmtx = new sL(this), this.post = new rL(this), this.os2 = new tL(this), this.loca = new uL(this), this.glyf = new aL(this), this.ascender = this.os2.exists && this.os2.ascender || this.hhea.ascender, this.decender = this.os2.exists && this.os2.decender || this.hhea.decender, this.lineGap = this.os2.exists && this.os2.lineGap || this.hhea.lineGap, this.bbox = [this.head.xMin, this.head.yMin, this.head.xMax, this.head.yMax];
  }, r.prototype.registerTTF = function() {
    var e, t, A, n, i;
    if (this.scaleFactor = 1e3 / this.head.unitsPerEm, this.bbox = (function() {
      var s, a, o, l;
      for (l = [], s = 0, a = (o = this.bbox).length; s < a; s++) e = o[s], l.push(Math.round(e * this.scaleFactor));
      return l;
    }).call(this), this.stemV = 0, this.post.exists ? (A = 255 & (n = this.post.italic_angle), 32768 & (t = n >> 16) && (t = -(1 + (65535 ^ t))), this.italicAngle = +(t + "." + A)) : this.italicAngle = 0, this.ascender = Math.round(this.ascender * this.scaleFactor), this.decender = Math.round(this.decender * this.scaleFactor), this.lineGap = Math.round(this.lineGap * this.scaleFactor), this.capHeight = this.os2.exists && this.os2.capHeight || this.ascender, this.xHeight = this.os2.exists && this.os2.xHeight || 0, this.familyClass = (this.os2.exists && this.os2.familyClass || 0) >> 8, this.isSerif = (i = this.familyClass) === 1 || i === 2 || i === 3 || i === 4 || i === 5 || i === 7, this.isScript = this.familyClass === 10, this.flags = 0, this.post.isFixedPitch && (this.flags |= 1), this.isSerif && (this.flags |= 2), this.isScript && (this.flags |= 8), this.italicAngle !== 0 && (this.flags |= 64), this.flags |= 32, !this.cmap.unicode) throw new Error("No unicode cmap for font");
  }, r.prototype.characterToGlyph = function(e) {
    var t;
    return ((t = this.cmap.unicode) != null ? t.codeMap[e] : void 0) || 0;
  }, r.prototype.widthOfGlyph = function(e) {
    var t;
    return t = 1e3 / this.head.unitsPerEm, this.hmtx.forGlyph(e).advance * t;
  }, r.prototype.widthOfString = function(e, t, A) {
    var n, i, s, a;
    for (s = 0, i = 0, a = (e = "" + e).length; 0 <= a ? i < a : i > a; i = 0 <= a ? ++i : --i) n = e.charCodeAt(i), s += this.widthOfGlyph(this.characterToGlyph(n)) + A * (1e3 / t) || 0;
    return s * (t / 1e3);
  }, r.prototype.lineHeight = function(e, t) {
    var A;
    return t == null && (t = !1), A = t ? this.lineGap : 0, (this.ascender + A - this.decender) / 1e3 * e;
  }, r;
})();
var ni, ks = (function() {
  function r(e) {
    this.data = e ?? [], this.pos = 0, this.length = this.data.length;
  }
  return r.prototype.readByte = function() {
    return this.data[this.pos++];
  }, r.prototype.writeByte = function(e) {
    return this.data[this.pos++] = e;
  }, r.prototype.readUInt32 = function() {
    return 16777216 * this.readByte() + (this.readByte() << 16) + (this.readByte() << 8) + this.readByte();
  }, r.prototype.writeUInt32 = function(e) {
    return this.writeByte(e >>> 24 & 255), this.writeByte(e >> 16 & 255), this.writeByte(e >> 8 & 255), this.writeByte(255 & e);
  }, r.prototype.readInt32 = function() {
    var e;
    return (e = this.readUInt32()) >= 2147483648 ? e - 4294967296 : e;
  }, r.prototype.writeInt32 = function(e) {
    return e < 0 && (e += 4294967296), this.writeUInt32(e);
  }, r.prototype.readUInt16 = function() {
    return this.readByte() << 8 | this.readByte();
  }, r.prototype.writeUInt16 = function(e) {
    return this.writeByte(e >> 8 & 255), this.writeByte(255 & e);
  }, r.prototype.readInt16 = function() {
    var e;
    return (e = this.readUInt16()) >= 32768 ? e - 65536 : e;
  }, r.prototype.writeInt16 = function(e) {
    return e < 0 && (e += 65536), this.writeUInt16(e);
  }, r.prototype.readString = function(e) {
    var t, A;
    for (A = [], t = 0; 0 <= e ? t < e : t > e; t = 0 <= e ? ++t : --t) A[t] = String.fromCharCode(this.readByte());
    return A.join("");
  }, r.prototype.writeString = function(e) {
    var t, A, n;
    for (n = [], t = 0, A = e.length; 0 <= A ? t < A : t > A; t = 0 <= A ? ++t : --t) n.push(this.writeByte(e.charCodeAt(t)));
    return n;
  }, r.prototype.readShort = function() {
    return this.readInt16();
  }, r.prototype.writeShort = function(e) {
    return this.writeInt16(e);
  }, r.prototype.readLongLong = function() {
    var e, t, A, n, i, s, a, o;
    return e = this.readByte(), t = this.readByte(), A = this.readByte(), n = this.readByte(), i = this.readByte(), s = this.readByte(), a = this.readByte(), o = this.readByte(), 128 & e ? -1 * (72057594037927940 * (255 ^ e) + 281474976710656 * (255 ^ t) + 1099511627776 * (255 ^ A) + 4294967296 * (255 ^ n) + 16777216 * (255 ^ i) + 65536 * (255 ^ s) + 256 * (255 ^ a) + (255 ^ o) + 1) : 72057594037927940 * e + 281474976710656 * t + 1099511627776 * A + 4294967296 * n + 16777216 * i + 65536 * s + 256 * a + o;
  }, r.prototype.writeLongLong = function(e) {
    var t, A;
    return t = Math.floor(e / 4294967296), A = 4294967295 & e, this.writeByte(t >> 24 & 255), this.writeByte(t >> 16 & 255), this.writeByte(t >> 8 & 255), this.writeByte(255 & t), this.writeByte(A >> 24 & 255), this.writeByte(A >> 16 & 255), this.writeByte(A >> 8 & 255), this.writeByte(255 & A);
  }, r.prototype.readInt = function() {
    return this.readInt32();
  }, r.prototype.writeInt = function(e) {
    return this.writeInt32(e);
  }, r.prototype.read = function(e) {
    var t, A;
    for (t = [], A = 0; 0 <= e ? A < e : A > e; A = 0 <= e ? ++A : --A) t.push(this.readByte());
    return t;
  }, r.prototype.write = function(e) {
    var t, A, n, i;
    for (i = [], A = 0, n = e.length; A < n; A++) t = e[A], i.push(this.writeByte(t));
    return i;
  }, r;
})(), JQ = (function() {
  var r;
  function e(t) {
    var A, n, i;
    for (this.scalarType = t.readInt(), this.tableCount = t.readShort(), this.searchRange = t.readShort(), this.entrySelector = t.readShort(), this.rangeShift = t.readShort(), this.tables = {}, n = 0, i = this.tableCount; 0 <= i ? n < i : n > i; n = 0 <= i ? ++n : --n) A = { tag: t.readString(4), checksum: t.readInt(), offset: t.readInt(), length: t.readInt() }, this.tables[A.tag] = A;
  }
  return e.prototype.encode = function(t) {
    var A, n, i, s, a, o, l, u, h, f, c, p, g;
    for (g in c = Object.keys(t).length, o = Math.log(2), h = 16 * Math.floor(Math.log(c) / o), s = Math.floor(h / o), u = 16 * c - h, (n = new ks()).writeInt(this.scalarType), n.writeShort(c), n.writeShort(h), n.writeShort(s), n.writeShort(u), i = 16 * c, l = n.pos + i, a = null, p = [], t) for (f = t[g], n.writeString(g), n.writeInt(r(f)), n.writeInt(l), n.writeInt(f.length), p = p.concat(f), g === "head" && (a = l), l += f.length; l % 4; ) p.push(0), l++;
    return n.write(p), A = 2981146554 - r(n.data), n.pos = a + 8, n.writeUInt32(A), n.data;
  }, r = function(t) {
    var A, n, i, s;
    for (t = G5.call(t); t.length % 4; ) t.push(0);
    for (i = new ks(t), n = 0, A = 0, s = t.length; A < s; A = A += 4) n += i.readUInt32();
    return 4294967295 & n;
  }, e;
})(), $Q = {}.hasOwnProperty, Bi = function(r, e) {
  for (var t in e) $Q.call(e, t) && (r[t] = e[t]);
  function A() {
    this.constructor = r;
  }
  return A.prototype = e.prototype, r.prototype = new A(), r.__super__ = e.prototype, r;
};
ni = (function() {
  function r(e) {
    var t;
    this.file = e, t = this.file.directory.tables[this.tag], this.exists = !!t, t && (this.offset = t.offset, this.length = t.length, this.parse(this.file.contents));
  }
  return r.prototype.parse = function() {
  }, r.prototype.encode = function() {
  }, r.prototype.raw = function() {
    return this.exists ? (this.file.contents.pos = this.offset, this.file.contents.read(this.length)) : null;
  }, r;
})();
var ZQ = (function() {
  function r() {
    return r.__super__.constructor.apply(this, arguments);
  }
  return Bi(r, ni), r.prototype.tag = "head", r.prototype.parse = function(e) {
    return e.pos = this.offset, this.version = e.readInt(), this.revision = e.readInt(), this.checkSumAdjustment = e.readInt(), this.magicNumber = e.readInt(), this.flags = e.readShort(), this.unitsPerEm = e.readShort(), this.created = e.readLongLong(), this.modified = e.readLongLong(), this.xMin = e.readShort(), this.yMin = e.readShort(), this.xMax = e.readShort(), this.yMax = e.readShort(), this.macStyle = e.readShort(), this.lowestRecPPEM = e.readShort(), this.fontDirectionHint = e.readShort(), this.indexToLocFormat = e.readShort(), this.glyphDataFormat = e.readShort();
  }, r.prototype.encode = function(e) {
    var t;
    return (t = new ks()).writeInt(this.version), t.writeInt(this.revision), t.writeInt(this.checkSumAdjustment), t.writeInt(this.magicNumber), t.writeShort(this.flags), t.writeShort(this.unitsPerEm), t.writeLongLong(this.created), t.writeLongLong(this.modified), t.writeShort(this.xMin), t.writeShort(this.yMin), t.writeShort(this.xMax), t.writeShort(this.yMax), t.writeShort(this.macStyle), t.writeShort(this.lowestRecPPEM), t.writeShort(this.fontDirectionHint), t.writeShort(e), t.writeShort(this.glyphDataFormat), t.data;
  }, r;
})(), ey = (function() {
  function r(e, t) {
    var A, n, i, s, a, o, l, u, h, f, c, p, g, v, w, B, S;
    switch (this.platformID = e.readUInt16(), this.encodingID = e.readShort(), this.offset = t + e.readInt(), h = e.pos, e.pos = this.offset, this.format = e.readUInt16(), this.length = e.readUInt16(), this.language = e.readUInt16(), this.isUnicode = this.platformID === 3 && this.encodingID === 1 && this.format === 4 || this.platformID === 0 && this.format === 4, this.codeMap = {}, this.format) {
      case 0:
        for (o = 0; o < 256; ++o) this.codeMap[o] = e.readByte();
        break;
      case 4:
        for (c = e.readUInt16(), f = c / 2, e.pos += 6, i = (function() {
          var C, E;
          for (E = [], o = C = 0; 0 <= f ? C < f : C > f; o = 0 <= f ? ++C : --C) E.push(e.readUInt16());
          return E;
        })(), e.pos += 2, g = (function() {
          var C, E;
          for (E = [], o = C = 0; 0 <= f ? C < f : C > f; o = 0 <= f ? ++C : --C) E.push(e.readUInt16());
          return E;
        })(), l = (function() {
          var C, E;
          for (E = [], o = C = 0; 0 <= f ? C < f : C > f; o = 0 <= f ? ++C : --C) E.push(e.readUInt16());
          return E;
        })(), u = (function() {
          var C, E;
          for (E = [], o = C = 0; 0 <= f ? C < f : C > f; o = 0 <= f ? ++C : --C) E.push(e.readUInt16());
          return E;
        })(), n = (this.length - e.pos + this.offset) / 2, a = (function() {
          var C, E;
          for (E = [], o = C = 0; 0 <= n ? C < n : C > n; o = 0 <= n ? ++C : --C) E.push(e.readUInt16());
          return E;
        })(), o = w = 0, S = i.length; w < S; o = ++w) for (v = i[o], A = B = p = g[o]; p <= v ? B <= v : B >= v; A = p <= v ? ++B : --B) u[o] === 0 ? s = A + l[o] : (s = a[u[o] / 2 + (A - p) - (f - o)] || 0) !== 0 && (s += l[o]), this.codeMap[A] = 65535 & s;
    }
    e.pos = h;
  }
  return r.encode = function(e, t) {
    var A, n, i, s, a, o, l, u, h, f, c, p, g, v, w, B, S, C, E, _, I, O, U, V, F, P, D, R, J, ie, te, $, re, ue, se, T, G, X, Y, ee, oe, ge, pe, me, Ee, Ne;
    switch (R = new ks(), s = Object.keys(e).sort(function(Te, Ge) {
      return Te - Ge;
    }), t) {
      case "macroman":
        for (g = 0, v = (function() {
          var Te = [];
          for (p = 0; p < 256; ++p) Te.push(0);
          return Te;
        })(), B = { 0: 0 }, i = {}, J = 0, re = s.length; J < re; J++) B[pe = e[n = s[J]]] == null && (B[pe] = ++g), i[n] = { old: e[n], new: B[e[n]] }, v[n] = B[e[n]];
        return R.writeUInt16(1), R.writeUInt16(0), R.writeUInt32(12), R.writeUInt16(0), R.writeUInt16(262), R.writeUInt16(0), R.write(v), { charMap: i, subtable: R.data, maxGlyphID: g + 1 };
      case "unicode":
        for (P = [], h = [], S = 0, B = {}, A = {}, w = l = null, ie = 0, ue = s.length; ie < ue; ie++) B[E = e[n = s[ie]]] == null && (B[E] = ++S), A[n] = { old: E, new: B[E] }, a = B[E] - n, w != null && a === l || (w && h.push(w), P.push(n), l = a), w = n;
        for (w && h.push(w), h.push(65535), P.push(65535), V = 2 * (U = P.length), O = 2 * Math.pow(Math.log(U) / Math.LN2, 2), f = Math.log(O / 2) / Math.LN2, I = 2 * U - O, o = [], _ = [], c = [], p = te = 0, se = P.length; te < se; p = ++te) {
          if (F = P[p], u = h[p], F === 65535) {
            o.push(0), _.push(0);
            break;
          }
          if (F - (D = A[F].new) >= 32768) for (o.push(0), _.push(2 * (c.length + U - p)), n = $ = F; F <= u ? $ <= u : $ >= u; n = F <= u ? ++$ : --$) c.push(A[n].new);
          else o.push(D - F), _.push(0);
        }
        for (R.writeUInt16(3), R.writeUInt16(1), R.writeUInt32(12), R.writeUInt16(4), R.writeUInt16(16 + 8 * U + 2 * c.length), R.writeUInt16(0), R.writeUInt16(V), R.writeUInt16(O), R.writeUInt16(f), R.writeUInt16(I), oe = 0, T = h.length; oe < T; oe++) n = h[oe], R.writeUInt16(n);
        for (R.writeUInt16(0), ge = 0, G = P.length; ge < G; ge++) n = P[ge], R.writeUInt16(n);
        for (me = 0, X = o.length; me < X; me++) a = o[me], R.writeUInt16(a);
        for (Ee = 0, Y = _.length; Ee < Y; Ee++) C = _[Ee], R.writeUInt16(C);
        for (Ne = 0, ee = c.length; Ne < ee; Ne++) g = c[Ne], R.writeUInt16(g);
        return { charMap: A, subtable: R.data, maxGlyphID: S + 1 };
    }
  }, r;
})(), D5 = (function() {
  function r() {
    return r.__super__.constructor.apply(this, arguments);
  }
  return Bi(r, ni), r.prototype.tag = "cmap", r.prototype.parse = function(e) {
    var t, A, n;
    for (e.pos = this.offset, this.version = e.readUInt16(), n = e.readUInt16(), this.tables = [], this.unicode = null, A = 0; 0 <= n ? A < n : A > n; A = 0 <= n ? ++A : --A) t = new ey(e, this.offset), this.tables.push(t), t.isUnicode && this.unicode == null && (this.unicode = t);
    return !0;
  }, r.encode = function(e, t) {
    var A, n;
    return t == null && (t = "macroman"), A = ey.encode(e, t), (n = new ks()).writeUInt16(0), n.writeUInt16(1), A.table = n.data.concat(A.subtable), A;
  }, r;
})(), eL = (function() {
  function r() {
    return r.__super__.constructor.apply(this, arguments);
  }
  return Bi(r, ni), r.prototype.tag = "hhea", r.prototype.parse = function(e) {
    return e.pos = this.offset, this.version = e.readInt(), this.ascender = e.readShort(), this.decender = e.readShort(), this.lineGap = e.readShort(), this.advanceWidthMax = e.readShort(), this.minLeftSideBearing = e.readShort(), this.minRightSideBearing = e.readShort(), this.xMaxExtent = e.readShort(), this.caretSlopeRise = e.readShort(), this.caretSlopeRun = e.readShort(), this.caretOffset = e.readShort(), e.pos += 8, this.metricDataFormat = e.readShort(), this.numberOfMetrics = e.readUInt16();
  }, r;
})(), tL = (function() {
  function r() {
    return r.__super__.constructor.apply(this, arguments);
  }
  return Bi(r, ni), r.prototype.tag = "OS/2", r.prototype.parse = function(e) {
    if (e.pos = this.offset, this.version = e.readUInt16(), this.averageCharWidth = e.readShort(), this.weightClass = e.readUInt16(), this.widthClass = e.readUInt16(), this.type = e.readShort(), this.ySubscriptXSize = e.readShort(), this.ySubscriptYSize = e.readShort(), this.ySubscriptXOffset = e.readShort(), this.ySubscriptYOffset = e.readShort(), this.ySuperscriptXSize = e.readShort(), this.ySuperscriptYSize = e.readShort(), this.ySuperscriptXOffset = e.readShort(), this.ySuperscriptYOffset = e.readShort(), this.yStrikeoutSize = e.readShort(), this.yStrikeoutPosition = e.readShort(), this.familyClass = e.readShort(), this.panose = (function() {
      var t, A;
      for (A = [], t = 0; t < 10; ++t) A.push(e.readByte());
      return A;
    })(), this.charRange = (function() {
      var t, A;
      for (A = [], t = 0; t < 4; ++t) A.push(e.readInt());
      return A;
    })(), this.vendorID = e.readString(4), this.selection = e.readShort(), this.firstCharIndex = e.readShort(), this.lastCharIndex = e.readShort(), this.version > 0 && (this.ascent = e.readShort(), this.descent = e.readShort(), this.lineGap = e.readShort(), this.winAscent = e.readShort(), this.winDescent = e.readShort(), this.codePageRange = (function() {
      var t, A;
      for (A = [], t = 0; t < 2; t = ++t) A.push(e.readInt());
      return A;
    })(), this.version > 1)) return this.xHeight = e.readShort(), this.capHeight = e.readShort(), this.defaultChar = e.readShort(), this.breakChar = e.readShort(), this.maxContext = e.readShort();
  }, r;
})(), rL = (function() {
  function r() {
    return r.__super__.constructor.apply(this, arguments);
  }
  return Bi(r, ni), r.prototype.tag = "post", r.prototype.parse = function(e) {
    var t, A, n;
    switch (e.pos = this.offset, this.format = e.readInt(), this.italicAngle = e.readInt(), this.underlinePosition = e.readShort(), this.underlineThickness = e.readShort(), this.isFixedPitch = e.readInt(), this.minMemType42 = e.readInt(), this.maxMemType42 = e.readInt(), this.minMemType1 = e.readInt(), this.maxMemType1 = e.readInt(), this.format) {
      case 65536:
      case 196608:
        break;
      case 131072:
        var i;
        for (A = e.readUInt16(), this.glyphNameIndex = [], i = 0; 0 <= A ? i < A : i > A; i = 0 <= A ? ++i : --i) this.glyphNameIndex.push(e.readUInt16());
        for (this.names = [], n = []; e.pos < this.offset + this.length; ) t = e.readByte(), n.push(this.names.push(e.readString(t)));
        return n;
      case 151552:
        return A = e.readUInt16(), this.offsets = e.read(A);
      case 262144:
        return this.map = (function() {
          var s, a, o;
          for (o = [], i = s = 0, a = this.file.maxp.numGlyphs; 0 <= a ? s < a : s > a; i = 0 <= a ? ++s : --s) o.push(e.readUInt32());
          return o;
        }).call(this);
    }
  }, r;
})(), AL = function(r, e) {
  this.raw = r, this.length = r.length, this.platformID = e.platformID, this.encodingID = e.encodingID, this.languageID = e.languageID;
}, nL = (function() {
  function r() {
    return r.__super__.constructor.apply(this, arguments);
  }
  return Bi(r, ni), r.prototype.tag = "name", r.prototype.parse = function(e) {
    var t, A, n, i, s, a, o, l, u, h, f;
    for (e.pos = this.offset, e.readShort(), t = e.readShort(), a = e.readShort(), A = [], i = 0; 0 <= t ? i < t : i > t; i = 0 <= t ? ++i : --i) A.push({ platformID: e.readShort(), encodingID: e.readShort(), languageID: e.readShort(), nameID: e.readShort(), length: e.readShort(), offset: this.offset + a + e.readShort() });
    for (o = {}, i = u = 0, h = A.length; u < h; i = ++u) n = A[i], e.pos = n.offset, l = e.readString(n.length), s = new AL(l, n), o[f = n.nameID] == null && (o[f] = []), o[n.nameID].push(s);
    this.strings = o, this.copyright = o[0], this.fontFamily = o[1], this.fontSubfamily = o[2], this.uniqueSubfamily = o[3], this.fontName = o[4], this.version = o[5];
    try {
      this.postscriptName = o[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
    } catch {
      this.postscriptName = o[4][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
    }
    return this.trademark = o[7], this.manufacturer = o[8], this.designer = o[9], this.description = o[10], this.vendorUrl = o[11], this.designerUrl = o[12], this.license = o[13], this.licenseUrl = o[14], this.preferredFamily = o[15], this.preferredSubfamily = o[17], this.compatibleFull = o[18], this.sampleText = o[19];
  }, r;
})(), iL = (function() {
  function r() {
    return r.__super__.constructor.apply(this, arguments);
  }
  return Bi(r, ni), r.prototype.tag = "maxp", r.prototype.parse = function(e) {
    return e.pos = this.offset, this.version = e.readInt(), this.numGlyphs = e.readUInt16(), this.maxPoints = e.readUInt16(), this.maxContours = e.readUInt16(), this.maxCompositePoints = e.readUInt16(), this.maxComponentContours = e.readUInt16(), this.maxZones = e.readUInt16(), this.maxTwilightPoints = e.readUInt16(), this.maxStorage = e.readUInt16(), this.maxFunctionDefs = e.readUInt16(), this.maxInstructionDefs = e.readUInt16(), this.maxStackElements = e.readUInt16(), this.maxSizeOfInstructions = e.readUInt16(), this.maxComponentElements = e.readUInt16(), this.maxComponentDepth = e.readUInt16();
  }, r;
})(), sL = (function() {
  function r() {
    return r.__super__.constructor.apply(this, arguments);
  }
  return Bi(r, ni), r.prototype.tag = "hmtx", r.prototype.parse = function(e) {
    var t, A, n, i, s, a, o;
    for (e.pos = this.offset, this.metrics = [], t = 0, a = this.file.hhea.numberOfMetrics; 0 <= a ? t < a : t > a; t = 0 <= a ? ++t : --t) this.metrics.push({ advance: e.readUInt16(), lsb: e.readInt16() });
    for (n = this.file.maxp.numGlyphs - this.file.hhea.numberOfMetrics, this.leftSideBearings = (function() {
      var l, u;
      for (u = [], t = l = 0; 0 <= n ? l < n : l > n; t = 0 <= n ? ++l : --l) u.push(e.readInt16());
      return u;
    })(), this.widths = (function() {
      var l, u, h, f;
      for (f = [], l = 0, u = (h = this.metrics).length; l < u; l++) i = h[l], f.push(i.advance);
      return f;
    }).call(this), A = this.widths[this.widths.length - 1], o = [], t = s = 0; 0 <= n ? s < n : s > n; t = 0 <= n ? ++s : --s) o.push(this.widths.push(A));
    return o;
  }, r.prototype.forGlyph = function(e) {
    return e in this.metrics ? this.metrics[e] : { advance: this.metrics[this.metrics.length - 1].advance, lsb: this.leftSideBearings[e - this.metrics.length] };
  }, r;
})(), G5 = [].slice, aL = (function() {
  function r() {
    return r.__super__.constructor.apply(this, arguments);
  }
  return Bi(r, ni), r.prototype.tag = "glyf", r.prototype.parse = function() {
    return this.cache = {};
  }, r.prototype.glyphFor = function(e) {
    var t, A, n, i, s, a, o, l, u, h;
    return e in this.cache ? this.cache[e] : (i = this.file.loca, t = this.file.contents, A = i.indexOf(e), (n = i.lengthOf(e)) === 0 ? this.cache[e] = null : (t.pos = this.offset + A, s = (a = new ks(t.read(n))).readShort(), l = a.readShort(), h = a.readShort(), o = a.readShort(), u = a.readShort(), this.cache[e] = s === -1 ? new lL(a, l, h, o, u) : new oL(a, s, l, h, o, u), this.cache[e]));
  }, r.prototype.encode = function(e, t, A) {
    var n, i, s, a, o;
    for (s = [], i = [], a = 0, o = t.length; a < o; a++) n = e[t[a]], i.push(s.length), n && (s = s.concat(n.encode(A)));
    return i.push(s.length), { table: s, offsets: i };
  }, r;
})(), oL = (function() {
  function r(e, t, A, n, i, s) {
    this.raw = e, this.numberOfContours = t, this.xMin = A, this.yMin = n, this.xMax = i, this.yMax = s, this.compound = !1;
  }
  return r.prototype.encode = function() {
    return this.raw.data;
  }, r;
})(), lL = (function() {
  function r(e, t, A, n, i) {
    var s, a;
    for (this.raw = e, this.xMin = t, this.yMin = A, this.xMax = n, this.yMax = i, this.compound = !0, this.glyphIDs = [], this.glyphOffsets = [], s = this.raw; a = s.readShort(), this.glyphOffsets.push(s.pos), this.glyphIDs.push(s.readUInt16()), 32 & a; ) s.pos += 1 & a ? 4 : 2, 128 & a ? s.pos += 8 : 64 & a ? s.pos += 4 : 8 & a && (s.pos += 2);
  }
  return r.prototype.encode = function() {
    var e, t, A;
    for (t = new ks(G5.call(this.raw.data)), e = 0, A = this.glyphIDs.length; e < A; ++e) t.pos = this.glyphOffsets[e];
    return t.data;
  }, r;
})(), uL = (function() {
  function r() {
    return r.__super__.constructor.apply(this, arguments);
  }
  return Bi(r, ni), r.prototype.tag = "loca", r.prototype.parse = function(e) {
    var t, A;
    return e.pos = this.offset, t = this.file.head.indexToLocFormat, this.offsets = t === 0 ? (function() {
      var n, i;
      for (i = [], A = 0, n = this.length; A < n; A += 2) i.push(2 * e.readUInt16());
      return i;
    }).call(this) : (function() {
      var n, i;
      for (i = [], A = 0, n = this.length; A < n; A += 4) i.push(e.readUInt32());
      return i;
    }).call(this);
  }, r.prototype.indexOf = function(e) {
    return this.offsets[e];
  }, r.prototype.lengthOf = function(e) {
    return this.offsets[e + 1] - this.offsets[e];
  }, r.prototype.encode = function(e, t) {
    for (var A = new Uint32Array(this.offsets.length), n = 0, i = 0, s = 0; s < A.length; ++s) if (A[s] = n, i < t.length && t[i] == s) {
      ++i, A[s] = n;
      var a = this.offsets[s], o = this.offsets[s + 1] - a;
      o > 0 && (n += o);
    }
    for (var l = new Array(4 * A.length), u = 0; u < A.length; ++u) l[4 * u + 3] = 255 & A[u], l[4 * u + 2] = (65280 & A[u]) >> 8, l[4 * u + 1] = (16711680 & A[u]) >> 16, l[4 * u] = (4278190080 & A[u]) >> 24;
    return l;
  }, r;
})(), cL = (function() {
  function r(e) {
    this.font = e, this.subset = {}, this.unicodes = {}, this.next = 33;
  }
  return r.prototype.generateCmap = function() {
    var e, t, A, n, i;
    for (t in n = this.font.cmap.tables[0].codeMap, e = {}, i = this.subset) A = i[t], e[t] = n[A];
    return e;
  }, r.prototype.glyphsFor = function(e) {
    var t, A, n, i, s, a, o;
    for (n = {}, s = 0, a = e.length; s < a; s++) n[i = e[s]] = this.font.glyf.glyphFor(i);
    for (i in t = [], n) (A = n[i]) != null && A.compound && t.push.apply(t, A.glyphIDs);
    if (t.length > 0) for (i in o = this.glyphsFor(t)) A = o[i], n[i] = A;
    return n;
  }, r.prototype.encode = function(e, t) {
    var A, n, i, s, a, o, l, u, h, f, c, p, g, v, w;
    for (n in A = D5.encode(this.generateCmap(), "unicode"), s = this.glyphsFor(e), c = { 0: 0 }, w = A.charMap) c[(o = w[n]).old] = o.new;
    for (p in f = A.maxGlyphID, s) p in c || (c[p] = f++);
    return u = (function(B) {
      var S, C;
      for (S in C = {}, B) C[B[S]] = S;
      return C;
    })(c), h = Object.keys(u).sort(function(B, S) {
      return B - S;
    }), g = (function() {
      var B, S, C;
      for (C = [], B = 0, S = h.length; B < S; B++) a = h[B], C.push(u[a]);
      return C;
    })(), i = this.font.glyf.encode(s, g, c), l = this.font.loca.encode(i.offsets, g), v = { cmap: this.font.cmap.raw(), glyf: i.table, loca: l, hmtx: this.font.hmtx.raw(), hhea: this.font.hhea.raw(), maxp: this.font.maxp.raw(), post: this.font.post.raw(), name: this.font.name.raw(), head: this.font.head.encode(t) }, this.font.os2.exists && (v["OS/2"] = this.font.os2.raw()), this.font.directory.encode(v);
  }, r;
})();
ot.API.PDFObject = (function() {
  var r;
  function e() {
  }
  return r = function(t, A) {
    return (Array(A + 1).join("0") + t).slice(-A);
  }, e.convert = function(t) {
    var A, n, i, s;
    if (Array.isArray(t)) return "[" + (function() {
      var a, o, l;
      for (l = [], a = 0, o = t.length; a < o; a++) A = t[a], l.push(e.convert(A));
      return l;
    })().join(" ") + "]";
    if (typeof t == "string") return "/" + t;
    if (t?.isString) return "(" + t + ")";
    if (t instanceof Date) return "(D:" + r(t.getUTCFullYear(), 4) + r(t.getUTCMonth(), 2) + r(t.getUTCDate(), 2) + r(t.getUTCHours(), 2) + r(t.getUTCMinutes(), 2) + r(t.getUTCSeconds(), 2) + "Z)";
    if ({}.toString.call(t) === "[object Object]") {
      for (n in i = ["<<"], t) s = t[n], i.push("/" + n + " " + e.convert(s));
      return i.push(">>"), i.join(`
`);
    }
    return "" + t;
  }, e;
})();
var tm = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function uu(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var dd, ty;
function hL() {
  if (ty) return dd;
  ty = 1;
  var r = {}, e = r.hasOwnProperty, t = function(o, l) {
    if (!o)
      return l;
    var u = {};
    for (var h in l)
      u[h] = e.call(o, h) ? o[h] : l[h];
    return u;
  }, A = /[ -,\.\/:-@\[-\^`\{-~]/, n = /[ -,\.\/:-@\[\]\^`\{-~]/, i = /(^|\\+)?(\\[A-F0-9]{1,6})\x20(?![a-fA-F0-9\x20])/g, s = function a(o, l) {
    l = t(l, a.options), l.quotes != "single" && l.quotes != "double" && (l.quotes = "single");
    for (var u = l.quotes == "double" ? '"' : "'", h = l.isIdentifier, f = o.charAt(0), c = "", p = 0, g = o.length; p < g; ) {
      var v = o.charAt(p++), w = v.charCodeAt(), B = void 0;
      if (w < 32 || w > 126) {
        if (w >= 55296 && w <= 56319 && p < g) {
          var S = o.charCodeAt(p++);
          (S & 64512) == 56320 ? w = ((w & 1023) << 10) + (S & 1023) + 65536 : p--;
        }
        B = "\\" + w.toString(16).toUpperCase() + " ";
      } else
        l.escapeEverything ? A.test(v) ? B = "\\" + v : B = "\\" + w.toString(16).toUpperCase() + " " : /[\t\n\f\r\x0B]/.test(v) ? B = "\\" + w.toString(16).toUpperCase() + " " : v == "\\" || !h && (v == '"' && u == v || v == "'" && u == v) || h && n.test(v) ? B = "\\" + v : B = v;
      c += B;
    }
    return h && (/^-[-\d]/.test(c) ? c = "\\-" + c.slice(1) : /\d/.test(f) && (c = "\\3" + f + " " + c.slice(1))), c = c.replace(i, function(C, E, _) {
      return E && E.length % 2 ? C : (E || "") + _;
    }), !h && l.wrap ? u + c + u : c;
  };
  return s.options = {
    escapeEverything: !1,
    isIdentifier: !1,
    quotes: "single",
    wrap: !1
  }, s.version = "3.0.0", dd = s, dd;
}
var fL = hL();
const V5 = /* @__PURE__ */ uu(fL);
var gd, ry;
function dL() {
  if (ry) return gd;
  ry = 1;
  var r = 0, e = 1, t = 2, A = 3, n = 4, i = 5, s = 6, a = /[a-z0-9_-]/i, o = /[\s\t]/, l = function(f) {
    for (var c = !0, p = r, g = "", v = 0, w, B, S = []; ; ) {
      if (B = f[v], p === r) {
        if (!B && c)
          break;
        if (!B && !c)
          throw new Error("Parse error");
        if (B === '"' || B === "'")
          w = B, p = e, c = !1;
        else if (!o.test(B)) if (a.test(B))
          p = A, c = !1, v--;
        else
          throw new Error("Parse error");
      } else if (p === e)
        if (B)
          B === "\\" ? p = t : B === w ? (S.push(g), g = "", p = n) : g += B;
        else throw new Error("Parse Error");
      else if (p === t)
        if (B === w || B === "\\")
          g += B, p = e;
        else
          throw new Error("Parse error");
      else if (p === A)
        if (B)
          a.test(B) ? g += B : B === "," ? (S.push(g), g = "", p = r) : o.test(B) ? p = i : B === "\\" && (p = s);
        else {
          S.push(g);
          break;
        }
      else if (p === s) {
        if (/[0-9a-f]/i.test(B))
          throw new Error("Parse error");
        g += B, p = A;
      } else if (p === i)
        if (B) {
          if (a.test(B))
            g += " " + B, p = A;
          else if (B === ",")
            S.push(g), g = "", p = r;
          else if (!o.test(B)) throw new Error("Parse error");
        } else {
          S.push(g);
          break;
        }
      else if (p === n)
        if (B) {
          if (B === ",")
            p = r;
          else if (!o.test(B)) throw new Error("Parse error");
        } else break;
      v++;
    }
    return S;
  }, u = /[^a-z0-9_-]/i, h = function(f, c) {
    var p = c && c.quote || '"';
    if (p !== '"' && p !== "'")
      throw new Error("Quote must be `'` or `\"`");
    for (var g = new RegExp(p, "g"), v = [], w = 0; w < f.length; ++w) {
      var B = f[w];
      u.test(B) && (B = B.replace(/\\/g, "\\\\").replace(g, "\\" + p), B = p + B + p), v.push(B);
    }
    return v.join(", ");
  };
  return gd = {
    parse: l,
    stringify: h
  }, gd;
}
var gL = dL();
const pL = /* @__PURE__ */ uu(gL);
var pd, Ay;
function mL() {
  if (Ay) return pd;
  Ay = 1;
  var r = { a: 7, c: 6, h: 1, l: 2, m: 2, r: 4, q: 4, s: 4, t: 2, v: 1, z: 0 }, e = [
    5760,
    6158,
    8192,
    8193,
    8194,
    8195,
    8196,
    8197,
    8198,
    8199,
    8200,
    8201,
    8202,
    8239,
    8287,
    12288,
    65279
  ];
  function t(c) {
    return c === 10 || c === 13 || c === 8232 || c === 8233 || // Line terminators
    // White spaces
    c === 32 || c === 9 || c === 11 || c === 12 || c === 160 || c >= 5760 && e.indexOf(c) >= 0;
  }
  function A(c) {
    switch (c | 32) {
      case 109:
      case 122:
      case 108:
      case 104:
      case 118:
      case 99:
      case 115:
      case 113:
      case 116:
      case 97:
      case 114:
        return !0;
    }
    return !1;
  }
  function n(c) {
    return (c | 32) === 97;
  }
  function i(c) {
    return c >= 48 && c <= 57;
  }
  function s(c) {
    return c >= 48 && c <= 57 || /* 0..9 */
    c === 43 || /* + */
    c === 45 || /* - */
    c === 46;
  }
  function a(c) {
    this.index = 0, this.path = c, this.max = c.length, this.result = [], this.param = 0, this.err = "", this.segmentStart = 0, this.data = [];
  }
  function o(c) {
    for (; c.index < c.max && t(c.path.charCodeAt(c.index)); )
      c.index++;
  }
  function l(c) {
    var p = c.path.charCodeAt(c.index);
    if (p === 48) {
      c.param = 0, c.index++;
      return;
    }
    if (p === 49) {
      c.param = 1, c.index++;
      return;
    }
    c.err = "SvgPath: arc flag can be 0 or 1 only (at pos " + c.index + ")";
  }
  function u(c) {
    var p = c.index, g = p, v = c.max, w = !1, B = !1, S = !1, C = !1, E;
    if (g >= v) {
      c.err = "SvgPath: missed param (at pos " + g + ")";
      return;
    }
    if (E = c.path.charCodeAt(g), (E === 43 || E === 45) && (g++, E = g < v ? c.path.charCodeAt(g) : 0), !i(E) && E !== 46) {
      c.err = "SvgPath: param should start with 0..9 or `.` (at pos " + g + ")";
      return;
    }
    if (E !== 46) {
      if (w = E === 48, g++, E = g < v ? c.path.charCodeAt(g) : 0, w && g < v && E && i(E)) {
        c.err = "SvgPath: numbers started with `0` such as `09` are illegal (at pos " + p + ")";
        return;
      }
      for (; g < v && i(c.path.charCodeAt(g)); )
        g++, B = !0;
      E = g < v ? c.path.charCodeAt(g) : 0;
    }
    if (E === 46) {
      for (C = !0, g++; i(c.path.charCodeAt(g)); )
        g++, S = !0;
      E = g < v ? c.path.charCodeAt(g) : 0;
    }
    if (E === 101 || E === 69) {
      if (C && !B && !S) {
        c.err = "SvgPath: invalid float exponent (at pos " + g + ")";
        return;
      }
      if (g++, E = g < v ? c.path.charCodeAt(g) : 0, (E === 43 || E === 45) && g++, g < v && i(c.path.charCodeAt(g)))
        for (; g < v && i(c.path.charCodeAt(g)); )
          g++;
      else {
        c.err = "SvgPath: invalid float exponent (at pos " + g + ")";
        return;
      }
    }
    c.index = g, c.param = parseFloat(c.path.slice(p, g)) + 0;
  }
  function h(c) {
    var p, g;
    p = c.path[c.segmentStart], g = p.toLowerCase();
    var v = c.data;
    if (g === "m" && v.length > 2 && (c.result.push([p, v[0], v[1]]), v = v.slice(2), g = "l", p = p === "m" ? "l" : "L"), g === "r")
      c.result.push([p].concat(v));
    else
      for (; v.length >= r[g] && (c.result.push([p].concat(v.splice(0, r[g]))), !!r[g]); )
        ;
  }
  function f(c) {
    var p = c.max, g, v, w, B, S;
    if (c.segmentStart = c.index, g = c.path.charCodeAt(c.index), v = n(g), !A(g)) {
      c.err = "SvgPath: bad command " + c.path[c.index] + " (at pos " + c.index + ")";
      return;
    }
    if (B = r[c.path[c.index].toLowerCase()], c.index++, o(c), c.data = [], !B) {
      h(c);
      return;
    }
    for (w = !1; ; ) {
      for (S = B; S > 0; S--) {
        if (v && (S === 3 || S === 4) ? l(c) : u(c), c.err.length) {
          h(c);
          return;
        }
        c.data.push(c.param), o(c), w = !1, c.index < p && c.path.charCodeAt(c.index) === 44 && (c.index++, o(c), w = !0);
      }
      if (!w && (c.index >= c.max || !s(c.path.charCodeAt(c.index))))
        break;
    }
    h(c);
  }
  return pd = function(p) {
    var g = new a(p), v = g.max;
    for (o(g); g.index < v && !g.err.length; )
      f(g);
    return g.result.length && ("mM".indexOf(g.result[0][0]) < 0 ? (g.err = "SvgPath: string should start with `M` or `m`", g.result = []) : g.result[0][0] = "M"), {
      err: g.err,
      segments: g.result
    };
  }, pd;
}
var md, ny;
function K5() {
  if (ny) return md;
  ny = 1;
  function r(t, A) {
    return [
      t[0] * A[0] + t[2] * A[1],
      t[1] * A[0] + t[3] * A[1],
      t[0] * A[2] + t[2] * A[3],
      t[1] * A[2] + t[3] * A[3],
      t[0] * A[4] + t[2] * A[5] + t[4],
      t[1] * A[4] + t[3] * A[5] + t[5]
    ];
  }
  function e() {
    if (!(this instanceof e))
      return new e();
    this.queue = [], this.cache = null;
  }
  return e.prototype.matrix = function(t) {
    return t[0] === 1 && t[1] === 0 && t[2] === 0 && t[3] === 1 && t[4] === 0 && t[5] === 0 ? this : (this.cache = null, this.queue.push(t), this);
  }, e.prototype.translate = function(t, A) {
    return (t !== 0 || A !== 0) && (this.cache = null, this.queue.push([1, 0, 0, 1, t, A])), this;
  }, e.prototype.scale = function(t, A) {
    return (t !== 1 || A !== 1) && (this.cache = null, this.queue.push([t, 0, 0, A, 0, 0])), this;
  }, e.prototype.rotate = function(t, A, n) {
    var i, s, a;
    return t !== 0 && (this.translate(A, n), i = t * Math.PI / 180, s = Math.cos(i), a = Math.sin(i), this.queue.push([s, a, -a, s, 0, 0]), this.cache = null, this.translate(-A, -n)), this;
  }, e.prototype.skewX = function(t) {
    return t !== 0 && (this.cache = null, this.queue.push([1, 0, Math.tan(t * Math.PI / 180), 1, 0, 0])), this;
  }, e.prototype.skewY = function(t) {
    return t !== 0 && (this.cache = null, this.queue.push([1, Math.tan(t * Math.PI / 180), 0, 1, 0, 0])), this;
  }, e.prototype.toArray = function() {
    if (this.cache)
      return this.cache;
    if (!this.queue.length)
      return this.cache = [1, 0, 0, 1, 0, 0], this.cache;
    if (this.cache = this.queue[0], this.queue.length === 1)
      return this.cache;
    for (var t = 1; t < this.queue.length; t++)
      this.cache = r(this.cache, this.queue[t]);
    return this.cache;
  }, e.prototype.calc = function(t, A, n) {
    var i;
    return this.queue.length ? (this.cache || (this.cache = this.toArray()), i = this.cache, [
      t * i[0] + A * i[2] + (n ? 0 : i[4]),
      t * i[1] + A * i[3] + (n ? 0 : i[5])
    ]) : [t, A];
  }, md = e, md;
}
var vd, iy;
function vL() {
  if (iy) return vd;
  iy = 1;
  var r = K5(), e = {
    matrix: !0,
    scale: !0,
    rotate: !0,
    translate: !0,
    skewX: !0,
    skewY: !0
  }, t = /\s*(matrix|translate|scale|rotate|skewX|skewY)\s*\(\s*(.+?)\s*\)[\s,]*/, A = /[\s,]+/;
  return vd = function(i) {
    var s = new r(), a, o;
    return i.split(t).forEach(function(l) {
      if (l.length) {
        if (typeof e[l] < "u") {
          a = l;
          return;
        }
        switch (o = l.split(A).map(function(u) {
          return +u || 0;
        }), a) {
          case "matrix":
            o.length === 6 && s.matrix(o);
            return;
          case "scale":
            o.length === 1 ? s.scale(o[0], o[0]) : o.length === 2 && s.scale(o[0], o[1]);
            return;
          case "rotate":
            o.length === 1 ? s.rotate(o[0], 0, 0) : o.length === 3 && s.rotate(o[0], o[1], o[2]);
            return;
          case "translate":
            o.length === 1 ? s.translate(o[0], 0) : o.length === 2 && s.translate(o[0], o[1]);
            return;
          case "skewX":
            o.length === 1 && s.skewX(o[0]);
            return;
          case "skewY":
            o.length === 1 && s.skewY(o[0]);
            return;
        }
      }
    }), s;
  }, vd;
}
var wd, sy;
function wL() {
  if (sy) return wd;
  sy = 1;
  var r = Math.PI * 2;
  function e(n, i, s, a) {
    var o = n * a - i * s < 0 ? -1 : 1, l = n * s + i * a;
    return l > 1 && (l = 1), l < -1 && (l = -1), o * Math.acos(l);
  }
  function t(n, i, s, a, o, l, u, h, f, c) {
    var p = c * (n - s) / 2 + f * (i - a) / 2, g = -f * (n - s) / 2 + c * (i - a) / 2, v = u * u, w = h * h, B = p * p, S = g * g, C = v * w - v * S - w * B;
    C < 0 && (C = 0), C /= v * S + w * B, C = Math.sqrt(C) * (o === l ? -1 : 1);
    var E = C * u / h * g, _ = C * -h / u * p, I = c * E - f * _ + (n + s) / 2, O = f * E + c * _ + (i + a) / 2, U = (p - E) / u, V = (g - _) / h, F = (-p - E) / u, P = (-g - _) / h, D = e(1, 0, U, V), R = e(U, V, F, P);
    return l === 0 && R > 0 && (R -= r), l === 1 && R < 0 && (R += r), [I, O, D, R];
  }
  function A(n, i) {
    var s = 1.3333333333333333 * Math.tan(i / 4), a = Math.cos(n), o = Math.sin(n), l = Math.cos(n + i), u = Math.sin(n + i);
    return [a, o, a - o * s, o + a * s, l + u * s, u - l * s, l, u];
  }
  return wd = function(i, s, a, o, l, u, h, f, c) {
    var p = Math.sin(c * r / 360), g = Math.cos(c * r / 360), v = g * (i - a) / 2 + p * (s - o) / 2, w = -p * (i - a) / 2 + g * (s - o) / 2;
    if (v === 0 && w === 0)
      return [];
    if (h === 0 || f === 0)
      return [];
    h = Math.abs(h), f = Math.abs(f);
    var B = v * v / (h * h) + w * w / (f * f);
    B > 1 && (h *= Math.sqrt(B), f *= Math.sqrt(B));
    var S = t(i, s, a, o, l, u, h, f, p, g), C = [], E = S[2], _ = S[3], I = Math.max(Math.ceil(Math.abs(_) / (r / 4)), 1);
    _ /= I;
    for (var O = 0; O < I; O++)
      C.push(A(E, _)), E += _;
    return C.map(function(U) {
      for (var V = 0; V < U.length; V += 2) {
        var F = U[V + 0], P = U[V + 1];
        F *= h, P *= f;
        var D = g * F - p * P, R = p * F + g * P;
        U[V + 0] = D + S[0], U[V + 1] = R + S[1];
      }
      return U;
    });
  }, wd;
}
var yd, ay;
function yL() {
  if (ay) return yd;
  ay = 1;
  var r = 1e-10, e = Math.PI / 180;
  function t(A, n, i) {
    if (!(this instanceof t))
      return new t(A, n, i);
    this.rx = A, this.ry = n, this.ax = i;
  }
  return t.prototype.transform = function(A) {
    var n = Math.cos(this.ax * e), i = Math.sin(this.ax * e), s = [
      this.rx * (A[0] * n + A[2] * i),
      this.rx * (A[1] * n + A[3] * i),
      this.ry * (-A[0] * i + A[2] * n),
      this.ry * (-A[1] * i + A[3] * n)
    ], a = s[0] * s[0] + s[2] * s[2], o = s[1] * s[1] + s[3] * s[3], l = ((s[0] - s[3]) * (s[0] - s[3]) + (s[2] + s[1]) * (s[2] + s[1])) * ((s[0] + s[3]) * (s[0] + s[3]) + (s[2] - s[1]) * (s[2] - s[1])), u = (a + o) / 2;
    if (l < r * u)
      return this.rx = this.ry = Math.sqrt(u), this.ax = 0, this;
    var h = s[0] * s[1] + s[2] * s[3];
    l = Math.sqrt(l);
    var f = u + l / 2, c = u - l / 2;
    return this.ax = Math.abs(h) < r && Math.abs(f - o) < r ? 90 : Math.atan(
      Math.abs(h) > Math.abs(f - o) ? (f - a) / h : h / (f - o)
    ) * 180 / Math.PI, this.ax >= 0 ? (this.rx = Math.sqrt(f), this.ry = Math.sqrt(c)) : (this.ax += 90, this.rx = Math.sqrt(c), this.ry = Math.sqrt(f)), this;
  }, t.prototype.isDegenerate = function() {
    return this.rx < r * this.ry || this.ry < r * this.rx;
  }, yd = t, yd;
}
var Bd, oy;
function BL() {
  if (oy) return Bd;
  oy = 1;
  var r = mL(), e = vL(), t = K5(), A = wL(), n = yL();
  function i(s) {
    if (!(this instanceof i))
      return new i(s);
    var a = r(s);
    this.segments = a.segments, this.err = a.err, this.__stack = [];
  }
  return i.from = function(s) {
    if (typeof s == "string") return new i(s);
    if (s instanceof i) {
      var a = new i("");
      return a.err = s.err, a.segments = s.segments.map(function(o) {
        return o.slice();
      }), a.__stack = s.__stack.map(function(o) {
        return t().matrix(o.toArray());
      }), a;
    }
    throw new Error("SvgPath.from: invalid param type " + s);
  }, i.prototype.__matrix = function(s) {
    var a = this, o;
    s.queue.length && this.iterate(function(l, u, h, f) {
      var c, p, g, v;
      switch (l[0]) {
        // Process 'assymetric' commands separately
        case "v":
          c = s.calc(0, l[1], !0), p = c[0] === 0 ? ["v", c[1]] : ["l", c[0], c[1]];
          break;
        case "V":
          c = s.calc(h, l[1], !1), p = c[0] === s.calc(h, f, !1)[0] ? ["V", c[1]] : ["L", c[0], c[1]];
          break;
        case "h":
          c = s.calc(l[1], 0, !0), p = c[1] === 0 ? ["h", c[0]] : ["l", c[0], c[1]];
          break;
        case "H":
          c = s.calc(l[1], f, !1), p = c[1] === s.calc(h, f, !1)[1] ? ["H", c[0]] : ["L", c[0], c[1]];
          break;
        case "a":
        case "A":
          var w = s.toArray(), B = n(l[1], l[2], l[3]).transform(w);
          if (w[0] * w[3] - w[1] * w[2] < 0 && (l[5] = l[5] ? "0" : "1"), c = s.calc(l[6], l[7], l[0] === "a"), l[0] === "A" && l[6] === h && l[7] === f || l[0] === "a" && l[6] === 0 && l[7] === 0) {
            p = [l[0] === "a" ? "l" : "L", c[0], c[1]];
            break;
          }
          B.isDegenerate() ? p = [l[0] === "a" ? "l" : "L", c[0], c[1]] : p = [l[0], B.rx, B.ry, B.ax, l[4], l[5], c[0], c[1]];
          break;
        case "m":
          v = u > 0, c = s.calc(l[1], l[2], v), p = ["m", c[0], c[1]];
          break;
        default:
          for (g = l[0], p = [g], v = g.toLowerCase() === g, o = 1; o < l.length; o += 2)
            c = s.calc(l[o], l[o + 1], v), p.push(c[0], c[1]);
      }
      a.segments[u] = p;
    }, !0);
  }, i.prototype.__evaluateStack = function() {
    var s, a;
    if (this.__stack.length) {
      if (this.__stack.length === 1) {
        this.__matrix(this.__stack[0]), this.__stack = [];
        return;
      }
      for (s = t(), a = this.__stack.length; --a >= 0; )
        s.matrix(this.__stack[a].toArray());
      this.__matrix(s), this.__stack = [];
    }
  }, i.prototype.toString = function() {
    var s = "", a = "", o = !1;
    this.__evaluateStack();
    for (var l = 0, u = this.segments.length; l < u; l++) {
      var h = this.segments[l], f = h[0];
      f !== a || f === "m" || f === "M" ? (f === "m" && a === "z" && (s += " "), s += f, o = !1) : o = !0;
      for (var c = 1; c < h.length; c++) {
        var p = h[c];
        c === 1 ? o && p >= 0 && (s += " ") : p >= 0 && (s += " "), s += p;
      }
      a = f;
    }
    return s;
  }, i.prototype.translate = function(s, a) {
    return this.__stack.push(t().translate(s, a || 0)), this;
  }, i.prototype.scale = function(s, a) {
    return this.__stack.push(t().scale(s, !a && a !== 0 ? s : a)), this;
  }, i.prototype.rotate = function(s, a, o) {
    return this.__stack.push(t().rotate(s, a || 0, o || 0)), this;
  }, i.prototype.skewX = function(s) {
    return this.__stack.push(t().skewX(s)), this;
  }, i.prototype.skewY = function(s) {
    return this.__stack.push(t().skewY(s)), this;
  }, i.prototype.matrix = function(s) {
    return this.__stack.push(t().matrix(s)), this;
  }, i.prototype.transform = function(s) {
    return s.trim() ? (this.__stack.push(e(s)), this) : this;
  }, i.prototype.round = function(s) {
    var a = 0, o = 0, l = 0, u = 0, h;
    return s = s || 0, this.__evaluateStack(), this.segments.forEach(function(f) {
      var c = f[0].toLowerCase() === f[0];
      switch (f[0]) {
        case "H":
        case "h":
          c && (f[1] += l), l = f[1] - f[1].toFixed(s), f[1] = +f[1].toFixed(s);
          return;
        case "V":
        case "v":
          c && (f[1] += u), u = f[1] - f[1].toFixed(s), f[1] = +f[1].toFixed(s);
          return;
        case "Z":
        case "z":
          l = a, u = o;
          return;
        case "M":
        case "m":
          c && (f[1] += l, f[2] += u), l = f[1] - f[1].toFixed(s), u = f[2] - f[2].toFixed(s), a = l, o = u, f[1] = +f[1].toFixed(s), f[2] = +f[2].toFixed(s);
          return;
        case "A":
        case "a":
          c && (f[6] += l, f[7] += u), l = f[6] - f[6].toFixed(s), u = f[7] - f[7].toFixed(s), f[1] = +f[1].toFixed(s), f[2] = +f[2].toFixed(s), f[3] = +f[3].toFixed(s + 2), f[6] = +f[6].toFixed(s), f[7] = +f[7].toFixed(s);
          return;
        default:
          h = f.length, c && (f[h - 2] += l, f[h - 1] += u), l = f[h - 2] - f[h - 2].toFixed(s), u = f[h - 1] - f[h - 1].toFixed(s), f.forEach(function(p, g) {
            g && (f[g] = +f[g].toFixed(s));
          });
          return;
      }
    }), this;
  }, i.prototype.iterate = function(s, a) {
    var o = this.segments, l = {}, u = !1, h = 0, f = 0, c = 0, p = 0, g, v, w;
    if (a || this.__evaluateStack(), o.forEach(function(B, S) {
      var C = s(B, S, h, f);
      Array.isArray(C) && (l[S] = C, u = !0);
      var E = B[0] === B[0].toLowerCase();
      switch (B[0]) {
        case "m":
        case "M":
          h = B[1] + (E ? h : 0), f = B[2] + (E ? f : 0), c = h, p = f;
          return;
        case "h":
        case "H":
          h = B[1] + (E ? h : 0);
          return;
        case "v":
        case "V":
          f = B[1] + (E ? f : 0);
          return;
        case "z":
        case "Z":
          h = c, f = p;
          return;
        default:
          h = B[B.length - 2] + (E ? h : 0), f = B[B.length - 1] + (E ? f : 0);
      }
    }), !u)
      return this;
    for (w = [], g = 0; g < o.length; g++)
      if (typeof l[g] < "u")
        for (v = 0; v < l[g].length; v++)
          w.push(l[g][v]);
      else
        w.push(o[g]);
    return this.segments = w, this;
  }, i.prototype.abs = function() {
    return this.iterate(function(s, a, o, l) {
      var u = s[0], h = u.toUpperCase(), f;
      if (u !== h)
        switch (s[0] = h, u) {
          case "v":
            s[1] += l;
            return;
          case "a":
            s[6] += o, s[7] += l;
            return;
          default:
            for (f = 1; f < s.length; f++)
              s[f] += f % 2 ? o : l;
        }
    }, !0), this;
  }, i.prototype.rel = function() {
    return this.iterate(function(s, a, o, l) {
      var u = s[0], h = u.toLowerCase(), f;
      if (u !== h && !(a === 0 && u === "M"))
        switch (s[0] = h, u) {
          case "V":
            s[1] -= l;
            return;
          case "A":
            s[6] -= o, s[7] -= l;
            return;
          default:
            for (f = 1; f < s.length; f++)
              s[f] -= f % 2 ? o : l;
        }
    }, !0), this;
  }, i.prototype.unarc = function() {
    return this.iterate(function(s, a, o, l) {
      var u, h, f, c = [], p = s[0];
      return p !== "A" && p !== "a" ? null : (p === "a" ? (h = o + s[6], f = l + s[7]) : (h = s[6], f = s[7]), u = A(o, l, h, f, s[4], s[5], s[1], s[2], s[3]), u.length === 0 ? [[s[0] === "a" ? "l" : "L", s[6], s[7]]] : (u.forEach(function(g) {
        c.push(["C", g[2], g[3], g[4], g[5], g[6], g[7]]);
      }), c));
    }), this;
  }, i.prototype.unshort = function() {
    var s = this.segments, a, o, l, u, h;
    return this.iterate(function(f, c, p, g) {
      var v = f[0], w = v.toUpperCase(), B;
      c && (w === "T" ? (B = v === "t", l = s[c - 1], l[0] === "Q" ? (a = l[1] - p, o = l[2] - g) : l[0] === "q" ? (a = l[1] - l[3], o = l[2] - l[4]) : (a = 0, o = 0), u = -a, h = -o, B || (u += p, h += g), s[c] = [
        B ? "q" : "Q",
        u,
        h,
        f[1],
        f[2]
      ]) : w === "S" && (B = v === "s", l = s[c - 1], l[0] === "C" ? (a = l[3] - p, o = l[4] - g) : l[0] === "c" ? (a = l[3] - l[5], o = l[4] - l[6]) : (a = 0, o = 0), u = -a, h = -o, B || (u += p, h += g), s[c] = [
        B ? "c" : "C",
        u,
        h,
        f[1],
        f[2],
        f[3],
        f[4]
      ]));
    }), this;
  }, Bd = i, Bd;
}
var bd, ly;
function bL() {
  return ly || (ly = 1, bd = BL()), bd;
}
var CL = bL();
const SL = /* @__PURE__ */ uu(CL);
var uy = function(r) {
  var e = r, t, A = {
    a: 0,
    b: 0,
    c: 0
  }, n = [], i = /(\[[^\]]+\])/g, s = /(#[^\#\s\+>~\.\[:\)]+)/g, a = /(\.[^\s\+>~\.\[:\)]+)/g, o = /(::[^\s\+>~\.\[:]+|:first-line|:first-letter|:before|:after)/gi, l = /(:(?!not|global|local)[\w-]+\([^\)]*\))/gi, u = /(:(?!not|global|local)[^\s\+>~\.\[:]+)/g, h = /([^\s\+>~\.\[:]+)/g;
  return t = function(f, c) {
    var p, g, v, w, B, S;
    if (f.test(e))
      for (p = e.match(f), g = 0, v = p.length; g < v; g += 1)
        A[c] += 1, w = p[g], B = e.indexOf(w), S = w.length, n.push({
          selector: r.substr(B, S),
          type: c,
          index: B,
          length: S
        }), e = e.replace(w, Array(S + 1).join(" "));
  }, (function() {
    var f = function(v) {
      var w, B, S, C;
      if (v.test(e))
        for (w = e.match(v), B = 0, S = w.length; B < S; B += 1)
          C = w[B], e = e.replace(C, Array(C.length + 1).join("A"));
    }, c = /\\[0-9A-Fa-f]{6}\s?/g, p = /\\[0-9A-Fa-f]{1,5}\s/g, g = /\\./g;
    f(c), f(p), f(g);
  })(), (function() {
    var f = /{[^]*/gm, c, p, g, v;
    if (f.test(e))
      for (c = e.match(f), p = 0, g = c.length; p < g; p += 1)
        v = c[p], e = e.replace(v, Array(v.length + 1).join(" "));
  })(), t(i, "b"), t(s, "a"), t(a, "b"), t(o, "c"), t(l, "b"), t(u, "b"), e = e.replace(/[\*\s\+>~]/g, " "), e = e.replace(/[#\.]/g, " "), e = e.replace(/:not/g, "    "), e = e.replace(/:local/g, "      "), e = e.replace(/:global/g, "       "), e = e.replace(/[\(\)]/g, " "), t(h, "c"), n.sort(function(f, c) {
    return f.index - c.index;
  }), {
    selector: r,
    specificity: "0," + A.a.toString() + "," + A.b.toString() + "," + A.c.toString(),
    specificityArray: [0, A.a, A.b, A.c],
    parts: n
  };
}, xL = function(r, e) {
  var t, A, n;
  if (typeof r == "string") {
    if (r.indexOf(",") !== -1)
      throw "Invalid CSS selector";
    t = uy(r).specificityArray;
  } else if (Array.isArray(r)) {
    if (r.filter(function(i) {
      return typeof i == "number";
    }).length !== 4)
      throw "Invalid specificity array";
    t = r;
  } else
    throw "Invalid CSS selector or specificity array";
  if (typeof e == "string") {
    if (e.indexOf(",") !== -1)
      throw "Invalid CSS selector";
    A = uy(e).specificityArray;
  } else if (Array.isArray(e)) {
    if (e.filter(function(i) {
      return typeof i == "number";
    }).length !== 4)
      throw "Invalid specificity array";
    A = e;
  } else
    throw "Invalid CSS selector or specificity array";
  for (n = 0; n < 4; n += 1) {
    if (t[n] < A[n])
      return -1;
    if (t[n] > A[n])
      return 1;
  }
  return 0;
}, rm = function(r, e) {
  return rm = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, A) {
    t.__proto__ = A;
  } || function(t, A) {
    for (var n in A) Object.prototype.hasOwnProperty.call(A, n) && (t[n] = A[n]);
  }, rm(r, e);
};
function nr(r, e) {
  if (typeof e != "function" && e !== null) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  function t() {
    this.constructor = r;
  }
  rm(r, e), r.prototype = e === null ? Object.create(e) : (t.prototype = e.prototype, new t());
}
var mh = function() {
  return mh = Object.assign || function(r) {
    for (var e, t = 1, A = arguments.length; t < A; t++) for (var n in e = arguments[t]) Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
    return r;
  }, mh.apply(this, arguments);
};
function lr(r, e, t, A) {
  return new (t || (t = Promise))((function(n, i) {
    function s(l) {
      try {
        o(A.next(l));
      } catch (u) {
        i(u);
      }
    }
    function a(l) {
      try {
        o(A.throw(l));
      } catch (u) {
        i(u);
      }
    }
    function o(l) {
      var u;
      l.done ? n(l.value) : (u = l.value, u instanceof t ? u : new t((function(h) {
        h(u);
      }))).then(s, a);
    }
    o((A = A.apply(r, e || [])).next());
  }));
}
function ur(r, e) {
  var t, A, n, i, s = { label: 0, sent: function() {
    if (1 & n[0]) throw n[1];
    return n[1];
  }, trys: [], ops: [] };
  return i = { next: a(0), throw: a(1), return: a(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function a(o) {
    return function(l) {
      return (function(u) {
        if (t) throw new TypeError("Generator is already executing.");
        for (; s; ) try {
          if (t = 1, A && (n = 2 & u[0] ? A.return : u[0] ? A.throw || ((n = A.return) && n.call(A), 0) : A.next) && !(n = n.call(A, u[1])).done) return n;
          switch (A = 0, n && (u = [2 & u[0], n.value]), u[0]) {
            case 0:
            case 1:
              n = u;
              break;
            case 4:
              return s.label++, { value: u[1], done: !1 };
            case 5:
              s.label++, A = u[1], u = [0];
              continue;
            case 7:
              u = s.ops.pop(), s.trys.pop();
              continue;
            default:
              if (n = s.trys, !((n = n.length > 0 && n[n.length - 1]) || u[0] !== 6 && u[0] !== 2)) {
                s = 0;
                continue;
              }
              if (u[0] === 3 && (!n || u[1] > n[0] && u[1] < n[3])) {
                s.label = u[1];
                break;
              }
              if (u[0] === 6 && s.label < n[1]) {
                s.label = n[1], n = u;
                break;
              }
              if (n && s.label < n[2]) {
                s.label = n[2], s.ops.push(u);
                break;
              }
              n[2] && s.ops.pop(), s.trys.pop();
              continue;
          }
          u = e.call(r, s);
        } catch (h) {
          u = [6, h], A = 0;
        } finally {
          t = n = 0;
        }
        if (5 & u[0]) throw u[1];
        return { value: u[0] ? u[1] : void 0, done: !0 };
      })([o, l]);
    };
  }
}
var ti = (function() {
  function r(e) {
    if (this.a = void 0, this.r = 0, this.g = 0, this.b = 0, this.simpleColors = {}, this.colorDefs = [], this.ok = !1, e) {
      for (var t in e.charAt(0) == "#" && (e = e.substr(1, 6)), e = (e = e.replace(/ /g, "")).toLowerCase(), this.simpleColors = { aliceblue: "f0f8ff", antiquewhite: "faebd7", aqua: "00ffff", aquamarine: "7fffd4", azure: "f0ffff", beige: "f5f5dc", bisque: "ffe4c4", black: "000000", blanchedalmond: "ffebcd", blue: "0000ff", blueviolet: "8a2be2", brown: "a52a2a", burlywood: "deb887", cadetblue: "5f9ea0", chartreuse: "7fff00", chocolate: "d2691e", coral: "ff7f50", cornflowerblue: "6495ed", cornsilk: "fff8dc", crimson: "dc143c", cyan: "00ffff", darkblue: "00008b", darkcyan: "008b8b", darkgoldenrod: "b8860b", darkgray: "a9a9a9", darkgrey: "a9a9a9", darkgreen: "006400", darkkhaki: "bdb76b", darkmagenta: "8b008b", darkolivegreen: "556b2f", darkorange: "ff8c00", darkorchid: "9932cc", darkred: "8b0000", darksalmon: "e9967a", darkseagreen: "8fbc8f", darkslateblue: "483d8b", darkslategray: "2f4f4f", darkslategrey: "2f4f4f", darkturquoise: "00ced1", darkviolet: "9400d3", deeppink: "ff1493", deepskyblue: "00bfff", dimgray: "696969", dimgrey: "696969", dodgerblue: "1e90ff", feldspar: "d19275", firebrick: "b22222", floralwhite: "fffaf0", forestgreen: "228b22", fuchsia: "ff00ff", gainsboro: "dcdcdc", ghostwhite: "f8f8ff", gold: "ffd700", goldenrod: "daa520", gray: "808080", grey: "808080", green: "008000", greenyellow: "adff2f", honeydew: "f0fff0", hotpink: "ff69b4", indianred: "cd5c5c", indigo: "4b0082", ivory: "fffff0", khaki: "f0e68c", lavender: "e6e6fa", lavenderblush: "fff0f5", lawngreen: "7cfc00", lemonchiffon: "fffacd", lightblue: "add8e6", lightcoral: "f08080", lightcyan: "e0ffff", lightgoldenrodyellow: "fafad2", lightgray: "d3d3d3", lightgrey: "d3d3d3", lightgreen: "90ee90", lightpink: "ffb6c1", lightsalmon: "ffa07a", lightseagreen: "20b2aa", lightskyblue: "87cefa", lightslateblue: "8470ff", lightslategray: "778899", lightslategrey: "778899", lightsteelblue: "b0c4de", lightyellow: "ffffe0", lime: "00ff00", limegreen: "32cd32", linen: "faf0e6", magenta: "ff00ff", maroon: "800000", mediumaquamarine: "66cdaa", mediumblue: "0000cd", mediumorchid: "ba55d3", mediumpurple: "9370d8", mediumseagreen: "3cb371", mediumslateblue: "7b68ee", mediumspringgreen: "00fa9a", mediumturquoise: "48d1cc", mediumvioletred: "c71585", midnightblue: "191970", mintcream: "f5fffa", mistyrose: "ffe4e1", moccasin: "ffe4b5", navajowhite: "ffdead", navy: "000080", oldlace: "fdf5e6", olive: "808000", olivedrab: "6b8e23", orange: "ffa500", orangered: "ff4500", orchid: "da70d6", palegoldenrod: "eee8aa", palegreen: "98fb98", paleturquoise: "afeeee", palevioletred: "d87093", papayawhip: "ffefd5", peachpuff: "ffdab9", peru: "cd853f", pink: "ffc0cb", plum: "dda0dd", powderblue: "b0e0e6", purple: "800080", red: "ff0000", rosybrown: "bc8f8f", royalblue: "4169e1", saddlebrown: "8b4513", salmon: "fa8072", sandybrown: "f4a460", seagreen: "2e8b57", seashell: "fff5ee", sienna: "a0522d", silver: "c0c0c0", skyblue: "87ceeb", slateblue: "6a5acd", slategray: "708090", slategrey: "708090", snow: "fffafa", springgreen: "00ff7f", steelblue: "4682b4", tan: "d2b48c", teal: "008080", thistle: "d8bfd8", tomato: "ff6347", turquoise: "40e0d0", violet: "ee82ee", violetred: "d02090", wheat: "f5deb3", white: "ffffff", whitesmoke: "f5f5f5", yellow: "ffff00", yellowgreen: "9acd32" }, this.simpleColors) e == t && (e = this.simpleColors[t]);
      this.colorDefs = [{ re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/, example: ["rgb(123, 234, 45)", "rgb(255,234,245)"], process: function(o) {
        return [parseInt(o[1]), parseInt(o[2]), parseInt(o[3])];
      } }, { re: /^rgb\(([0-9.]+)%,\s*([0-9.]+)%,\s*([0-9.]+)%\)$/, example: ["rgb(50.5%, 25.75%, 75.5%)", "rgb(100%,0%,0%)"], process: function(o) {
        return [Math.round(2.55 * parseFloat(o[1])), Math.round(2.55 * parseFloat(o[2])), Math.round(2.55 * parseFloat(o[3]))];
      } }, { re: /^(\w{2})(\w{2})(\w{2})$/, example: ["#00ff00", "336699"], process: function(o) {
        return [parseInt(o[1], 16), parseInt(o[2], 16), parseInt(o[3], 16)];
      } }, { re: /^(\w{1})(\w{1})(\w{1})$/, example: ["#fb0", "f0f"], process: function(o) {
        return [parseInt(o[1] + o[1], 16), parseInt(o[2] + o[2], 16), parseInt(o[3] + o[3], 16)];
      } }];
      for (var A = 0; A < this.colorDefs.length; A++) {
        var n = this.colorDefs[A].re, i = this.colorDefs[A].process, s = n.exec(e);
        if (s) {
          var a = i(s);
          this.r = a[0], this.g = a[1], this.b = a[2], this.ok = !0;
        }
      }
      this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b;
    }
  }
  return r.prototype.toRGB = function() {
    return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
  }, r.prototype.toRGBA = function() {
    return "rgba(" + this.r + ", " + this.g + ", " + this.b + ", " + (this.a || "1") + ")";
  }, r.prototype.toHex = function() {
    var e = this.r.toString(16), t = this.g.toString(16), A = this.b.toString(16);
    return e.length == 1 && (e = "0" + e), t.length == 1 && (t = "0" + t), A.length == 1 && (A = "0" + A), "#" + e + t + A;
  }, r.prototype.getHelpXML = function() {
    for (var e = [], t = 0; t < this.colorDefs.length; t++) for (var A = this.colorDefs[t].example, n = 0; n < A.length; n++) e[e.length] = A[n];
    for (var i in this.simpleColors) e[e.length] = i;
    var s = document.createElement("ul");
    for (s.setAttribute("id", "rgbcolor-examples"), t = 0; t < e.length; t++) try {
      var a = document.createElement("li"), o = new r(e[t]), l = document.createElement("div");
      l.style.cssText = "margin: 3px; border: 1px solid black; background:" + o.toHex() + "; color:" + o.toHex(), l.appendChild(document.createTextNode("test"));
      var u = document.createTextNode(" " + e[t] + " -> " + o.toRGB() + " -> " + o.toHex());
      a.appendChild(l), a.appendChild(u), s.appendChild(a);
    } catch {
    }
    return s;
  }, r;
})(), EA = (function() {
  function r(e) {
    this.color = e;
  }
  return r.prototype.getFillData = function(e, t) {
    return lr(this, void 0, void 0, (function() {
      return ur(this, (function(A) {
        return [2, void 0];
      }));
    }));
  }, r;
})(), _o = (function() {
  function r() {
    this.xmlSpace = "", this.whiteSpace = "", this.fill = null, this.fillOpacity = 1, this.fontFamily = "", this.fontSize = 16, this.fontStyle = "", this.fontWeight = "", this.opacity = 1, this.stroke = null, this.strokeDasharray = null, this.strokeDashoffset = 0, this.strokeLinecap = "", this.strokeLinejoin = "", this.strokeMiterlimit = 4, this.strokeOpacity = 1, this.strokeWidth = 1, this.alignmentBaseline = "", this.textAnchor = "", this.visibility = "", this.color = null, this.contextFill = null, this.contextStroke = null, this.fillRule = null;
  }
  return r.prototype.clone = function() {
    var e = new r();
    return e.xmlSpace = this.xmlSpace, e.whiteSpace = this.whiteSpace, e.fill = this.fill, e.fillOpacity = this.fillOpacity, e.fontFamily = this.fontFamily, e.fontSize = this.fontSize, e.fontStyle = this.fontStyle, e.fontWeight = this.fontWeight, e.opacity = this.opacity, e.stroke = this.stroke, e.strokeDasharray = this.strokeDasharray, e.strokeDashoffset = this.strokeDashoffset, e.strokeLinecap = this.strokeLinecap, e.strokeLinejoin = this.strokeLinejoin, e.strokeMiterlimit = this.strokeMiterlimit, e.strokeOpacity = this.strokeOpacity, e.strokeWidth = this.strokeWidth, e.textAnchor = this.textAnchor, e.alignmentBaseline = this.alignmentBaseline, e.visibility = this.visibility, e.color = this.color, e.fillRule = this.fillRule, e.contextFill = this.contextFill, e.contextStroke = this.contextStroke, e;
  }, r.default = function() {
    var e = new r();
    return e.xmlSpace = "default", e.whiteSpace = "normal", e.fill = new EA(new ti("rgb(0, 0, 0)")), e.fillOpacity = 1, e.fontFamily = "times", e.fontSize = 16, e.fontStyle = "normal", e.fontWeight = "normal", e.opacity = 1, e.stroke = null, e.strokeDasharray = null, e.strokeDashoffset = 0, e.strokeLinecap = "butt", e.strokeLinejoin = "miter", e.strokeMiterlimit = 4, e.strokeOpacity = 1, e.strokeWidth = 1, e.alignmentBaseline = "baseline", e.textAnchor = "start", e.visibility = "visible", e.color = new ti("rgb(0, 0, 0)"), e.fillRule = "nonzero", e.contextFill = null, e.contextStroke = null, e;
  }, r.getContextColors = function(e, t) {
    t === void 0 && (t = !1);
    var A = {};
    return e.attributeState.contextFill && (A.contextFill = e.attributeState.contextFill), e.attributeState.contextStroke && (A.contextStroke = e.attributeState.contextStroke), t && e.attributeState.color && (A.color = e.attributeState.color), A;
  }, r;
})(), js = (function() {
  function r(e, t) {
    var A, n, i;
    this.pdf = e, this.svg2pdfParameters = t.svg2pdfParameters, this.attributeState = t.attributeState ? t.attributeState.clone() : _o.default(), this.viewport = t.viewport, this.refsHandler = t.refsHandler, this.styleSheets = t.styleSheets, this.textMeasure = t.textMeasure, this.transform = (A = t.transform) !== null && A !== void 0 ? A : this.pdf.unitMatrix, this.withinClipPath = (n = t.withinClipPath) !== null && n !== void 0 && n, this.withinUse = (i = t.withinUse) !== null && i !== void 0 && i;
  }
  return r.prototype.clone = function(e) {
    var t, A, n, i;
    return e === void 0 && (e = {}), new r(this.pdf, { svg2pdfParameters: this.svg2pdfParameters, attributeState: e.attributeState ? e.attributeState.clone() : this.attributeState.clone(), viewport: (t = e.viewport) !== null && t !== void 0 ? t : this.viewport, refsHandler: this.refsHandler, styleSheets: this.styleSheets, textMeasure: this.textMeasure, transform: (A = e.transform) !== null && A !== void 0 ? A : this.transform, withinClipPath: (n = e.withinClipPath) !== null && n !== void 0 ? n : this.withinClipPath, withinUse: (i = e.withinUse) !== null && i !== void 0 ? i : this.withinUse });
  }, r;
})(), j5 = (function() {
  function r(e) {
    this.renderedElements = {}, this.idMap = e, this.idPrefix = String(r.instanceCounter++);
  }
  return r.prototype.getRendered = function(e, t, A) {
    return lr(this, void 0, void 0, (function() {
      var n, i;
      return ur(this, (function(s) {
        switch (s.label) {
          case 0:
            return n = this.generateKey(e, t), this.renderedElements.hasOwnProperty(n) ? [2, this.renderedElements[e]] : (i = this.get(e), this.renderedElements[n] = i, [4, A(i)]);
          case 1:
            return s.sent(), [2, i];
        }
      }));
    }));
  }, r.prototype.get = function(e) {
    return this.idMap[V5(e, { isIdentifier: !0 })];
  }, r.prototype.generateKey = function(e, t) {
    var A = "";
    return t && (A = ["color", "contextFill", "contextStroke"].map((function(n) {
      var i, s;
      return (s = (i = t[n]) === null || i === void 0 ? void 0 : i.toRGBA()) !== null && s !== void 0 ? s : "";
    })).join("|")), this.idPrefix + "|" + e + "|" + A;
  }, r.instanceCounter = 0, r;
})();
function cy(r, e) {
  return Math.atan2(e[1] - r[1], e[0] - r[0]);
}
var hy = 2 / 3;
function fy(r, e) {
  return [hy * (e[0] - r[0]) + r[0], hy * (e[1] - r[1]) + r[1]];
}
function El(r) {
  var e = Math.sqrt(r[0] * r[0] + r[1] * r[1]);
  return [r[0] / e, r[1] / e];
}
function Ao(r, e) {
  return El([e[0] - r[0], e[1] - r[1]]);
}
function vc(r, e) {
  return [r[0] + e[0], r[1] + e[1]];
}
function Cd(r, e) {
  var t = r[0], A = r[1];
  return [e.a * t + e.c * A + e.e, e.b * t + e.d * A + e.f];
}
var Uo = (function() {
  function r() {
    this.segments = [];
  }
  return r.prototype.moveTo = function(e, t) {
    return this.segments.push(new pA(e, t)), this;
  }, r.prototype.lineTo = function(e, t) {
    return this.segments.push(new Ls(e, t)), this;
  }, r.prototype.curveTo = function(e, t, A, n, i, s) {
    return this.segments.push(new wi(e, t, A, n, i, s)), this;
  }, r.prototype.close = function() {
    return this.segments.push(new Am()), this;
  }, r.prototype.transform = function(e) {
    this.segments.forEach((function(t) {
      if (t instanceof pA || t instanceof Ls || t instanceof wi) {
        var A = Cd([t.x, t.y], e);
        t.x = A[0], t.y = A[1];
      }
      if (t instanceof wi) {
        var n = Cd([t.x1, t.y1], e), i = Cd([t.x2, t.y2], e);
        t.x1 = n[0], t.y1 = n[1], t.x2 = i[0], t.y2 = i[1];
      }
    }));
  }, r.prototype.draw = function(e) {
    var t = e.pdf;
    this.segments.forEach((function(A) {
      A instanceof pA ? t.moveTo(A.x, A.y) : A instanceof Ls ? t.lineTo(A.x, A.y) : A instanceof wi ? t.curveTo(A.x1, A.y1, A.x2, A.y2, A.x, A.y) : t.close();
    }));
  }, r;
})(), pA = function(r, e) {
  this.x = r, this.y = e;
}, Ls = function(r, e) {
  this.x = r, this.y = e;
}, wi = function(r, e, t, A, n, i) {
  this.x1 = r, this.y1 = e, this.x2 = t, this.y2 = A, this.x = n, this.y = i;
}, Am = function() {
};
function Hs(r, e) {
  return e.split(",").indexOf((r.nodeName || r.tagName).toLowerCase()) >= 0;
}
function Le(r, e, t, A) {
  var n;
  A === void 0 && (A = t);
  var i = (n = r.style) === null || n === void 0 ? void 0 : n.getPropertyValue(A);
  if (i) return i;
  var s = e.getPropertyValue(r, A);
  return s || r.hasAttribute(t) && r.getAttribute(t) || void 0;
}
function ss(r, e, t) {
  if (Le(r.element, t.styleSheets, "display") === "none") return !1;
  var A = e, n = Le(r.element, t.styleSheets, "visibility");
  return n && (A = n !== "hidden"), A;
}
function qs(r, e, t) {
  var A = ss(r, e, t);
  return r.element.childNodes.length !== 0 && (r.children.forEach((function(n) {
    n.isVisible(A, t) && (A = !0);
  })), A);
}
var EL = (function() {
  function r() {
    this.markers = [];
  }
  return r.prototype.addMarker = function(e) {
    this.markers.push(e);
  }, r.prototype.draw = function(e) {
    return lr(this, void 0, void 0, (function() {
      var t, A, n, i, s, a, o, l;
      return ur(this, (function(u) {
        switch (u.label) {
          case 0:
            t = 0, u.label = 1;
          case 1:
            return t < this.markers.length ? (A = this.markers[t], n = void 0, i = A.angle, s = A.anchor, a = Math.cos(i), o = Math.sin(i), n = e.pdf.Matrix(a, o, -o, a, s[0], s[1]), n = e.pdf.matrixMult(e.pdf.Matrix(e.attributeState.strokeWidth, 0, 0, e.attributeState.strokeWidth, 0, 0), n), n = e.pdf.matrixMult(n, e.transform), e.pdf.saveGraphicsState(), l = _o.getContextColors(e), [4, e.refsHandler.getRendered(A.id, l, (function(h) {
              return h.apply(e);
            }))]) : [3, 4];
          case 2:
            u.sent(), e.pdf.doFormObject(e.refsHandler.generateKey(A.id, l), n), e.pdf.restoreGraphicsState(), u.label = 3;
          case 3:
            return t++, [3, 1];
          case 4:
            return [2];
        }
      }));
    }));
  }, r;
})(), Es = function(r, e, t, A) {
  A === void 0 && (A = !1), this.id = r, this.anchor = e, this.angle = t, this.isStartMarker = A;
}, av = /url\(["']?#([^"']+)["']?\)/, FL = { bottom: "bottom", "text-bottom": "bottom", top: "top", "text-top": "top", hanging: "hanging", middle: "middle", central: "middle", center: "middle", mathematical: "middle", ideographic: "ideographic", alphabetic: "alphabetic", baseline: "alphabetic" }, dy = "http://www.w3.org/2000/svg";
function Yi(r, e) {
  var t;
  return (t = r && r.toString().match(/^([\-0-9.]+)em$/)) ? parseFloat(t[1]) * e : (t = r && r.toString().match(/^([\-0-9.]+)(px|)$/)) ? parseFloat(t[1]) : 0;
}
function q5(r) {
  return FL[r] || "alphabetic";
}
function Tn(r) {
  for (var e, t = [], A = /[+-]?(?:(?:\d+\.?\d*)|(?:\d*\.?\d+))(?:[eE][+-]?\d+)?/g; e = A.exec(r); ) t.push(parseFloat(e[0]));
  return t;
}
function xo(r, e) {
  if (r === "transparent") {
    var t = new ti("rgb(0,0,0)");
    return t.a = 0, t;
  }
  if (e && r.toLowerCase() === "currentcolor") return e.color || new ti("rgb(0,0,0)");
  if (e && r.toLowerCase() === "context-stroke") return e.contextStroke || new ti("rgb(0,0,0)");
  if (e && r.toLowerCase() === "context-fill") return e.contextFill || new ti("rgb(0,0,0)");
  var A = /\s*rgba\(((?:[^,\)]*,){3}[^,\)]*)\)\s*/.exec(r);
  if (A) {
    var n = Tn(A[1]), i = new ti("rgb(" + n.slice(0, 3).join(",") + ")");
    return i.a = n[3], i;
  }
  return new ti(r);
}
var Ji = { "sans-serif": "helvetica", verdana: "helvetica", arial: "helvetica", fixed: "courier", monospace: "courier", terminal: "courier", serif: "times", cursive: "times", fantasy: "times" }, Sd, _L = (Sd = ot.version.split("."), parseFloat(Sd[0]) === 2 && parseFloat(Sd[1]) === 3);
function z5(r, e) {
  return _L ? e == 400 ? r == "italic" ? "italic" : "normal" : e == 700 && r !== "italic" ? "bold" : r + "" + e : e == 400 || e === "normal" ? r === "italic" ? "italic" : "normal" : e != 700 && e !== "bold" || r !== "normal" ? (e == 700 ? "bold" : e) + "" + r : "bold";
}
function ov(r, e) {
  if (Le(e.element, r.styleSheets, "display") === "none") return [0, 0, 0, 0];
  var t = [];
  return e.children.forEach((function(A) {
    var n = A.getBoundingBox(r);
    if (n[0] !== 0 || n[1] !== 0 || n[2] !== 0 || n[3] !== 0) {
      var i = A.computeNodeTransform(r);
      n[0] = n[0] * i.sx + i.tx, n[1] = n[1] * i.sy + i.ty, n[2] = n[2] * i.sx, n[3] = n[3] * i.sy, t = t.length === 0 ? n : [Math.min(t[0], n[0]), Math.min(t[1], n[1]), Math.max(t[0] + t[2], n[0] + n[2]) - Math.min(t[0], n[0]), Math.max(t[1] + t[3], n[1] + n[3]) - Math.min(t[1], n[1])];
    }
  })), t.length === 0 ? [0, 0, 0, 0] : t;
}
function cu(r, e) {
  var t = parseFloat, A = t(r.getAttribute("x1")) || t(Le(r, e.styleSheets, "x")) || t(Le(r, e.styleSheets, "cx")) - t(Le(r, e.styleSheets, "r")) || 0, n = t(r.getAttribute("x2")) || A + t(Le(r, e.styleSheets, "width")) || t(Le(r, e.styleSheets, "cx")) + t(Le(r, e.styleSheets, "r")) || 0, i = t(r.getAttribute("y1")) || t(Le(r, e.styleSheets, "y")) || t(Le(r, e.styleSheets, "cy")) - t(Le(r, e.styleSheets, "r")) || 0, s = t(r.getAttribute("y2")) || i + t(Le(r, e.styleSheets, "height")) || t(Le(r, e.styleSheets, "cy")) + t(Le(r, e.styleSheets, "r")) || 0;
  return [Math.min(A, n), Math.min(i, s), Math.max(A, n) - Math.min(A, n), Math.max(i, s) - Math.min(i, s)];
}
function hu(r, e, t, A, n, i, s, a) {
  a === void 0 && (a = !1);
  var o, l, u = e[0], h = e[1], f = e[2], c = e[3], p = n / f, g = i / c, v = r.getAttribute("preserveAspectRatio");
  if (v) {
    var w = v.split(" ");
    w[0] === "defer" && (w = w.slice(1)), o = w[0], l = w[1] || "meet";
  } else o = "xMidYMid", l = "meet";
  if (o !== "none" && (l === "meet" ? p = g = Math.min(p, g) : l === "slice" && (p = g = Math.max(p, g))), a) return s.pdf.Matrix(p, 0, 0, g, 0, 0);
  var B = t - u * p, S = A - h * g;
  o.indexOf("xMid") >= 0 ? B += (n - f * p) / 2 : o.indexOf("xMax") >= 0 && (B += n - f * p), o.indexOf("YMid") >= 0 ? S += (i - c * g) / 2 : o.indexOf("YMax") >= 0 && (S += i - c * g);
  var C = s.pdf.Matrix(1, 0, 0, 1, B, S), E = s.pdf.Matrix(p, 0, 0, g, 0, 0);
  return s.pdf.matrixMult(E, C);
}
function Th(r, e) {
  if (!r || r === "none") return e.pdf.unitMatrix;
  for (var t, A, n = /^[\s,]*matrix\(([^)]+)\)\s*/, i = /^[\s,]*translate\(([^)]+)\)\s*/, s = /^[\s,]*rotate\(([^)]+)\)\s*/, a = /^[\s,]*scale\(([^)]+)\)\s*/, o = /^[\s,]*skewX\(([^)]+)\)\s*/, l = /^[\s,]*skewY\(([^)]+)\)\s*/, u = e.pdf.unitMatrix; r.length > 0 && r.length !== A; ) {
    A = r.length;
    var h = n.exec(r);
    if (h && (t = Tn(h[1]), u = e.pdf.matrixMult(e.pdf.Matrix(t[0], t[1], t[2], t[3], t[4], t[5]), u), r = r.substr(h[0].length)), h = s.exec(r)) {
      t = Tn(h[1]);
      var f = Math.PI * t[0] / 180;
      if (u = e.pdf.matrixMult(e.pdf.Matrix(Math.cos(f), Math.sin(f), -Math.sin(f), Math.cos(f), 0, 0), u), t[1] || t[2]) {
        var c = e.pdf.Matrix(1, 0, 0, 1, t[1], t[2]), p = e.pdf.Matrix(1, 0, 0, 1, -t[1], -t[2]);
        u = e.pdf.matrixMult(p, e.pdf.matrixMult(u, c));
      }
      r = r.substr(h[0].length);
    }
    (h = i.exec(r)) && (t = Tn(h[1]), u = e.pdf.matrixMult(e.pdf.Matrix(1, 0, 0, 1, t[0], t[1] || 0), u), r = r.substr(h[0].length)), (h = a.exec(r)) && ((t = Tn(h[1]))[1] || (t[1] = t[0]), u = e.pdf.matrixMult(e.pdf.Matrix(t[0], 0, 0, t[1], 0, 0), u), r = r.substr(h[0].length)), (h = o.exec(r)) && (t = parseFloat(h[1]), t *= Math.PI / 180, u = e.pdf.matrixMult(e.pdf.Matrix(1, 0, Math.tan(t), 1, 0, 0), u), r = r.substr(h[0].length)), (h = l.exec(r)) && (t = parseFloat(h[1]), t *= Math.PI / 180, u = e.pdf.matrixMult(e.pdf.Matrix(1, Math.tan(t), 0, 1, 0, 0), u), r = r.substr(h[0].length));
  }
  return u;
}
var lv = (function() {
  function r(e, t) {
    this.element = e, this.children = t, this.parent = null;
  }
  return r.prototype.setParent = function(e) {
    this.parent = e;
  }, r.prototype.getParent = function() {
    return this.parent;
  }, r.prototype.getBoundingBox = function(e) {
    return Le(this.element, e.styleSheets, "display") === "none" ? [0, 0, 0, 0] : this.getBoundingBoxCore(e);
  }, r.prototype.computeNodeTransform = function(e) {
    var t = this.computeNodeTransformCore(e), A = Le(this.element, e.styleSheets, "transform");
    return A ? e.pdf.matrixMult(t, Th(A, e)) : t;
  }, r;
})(), fu = (function(r) {
  function e() {
    return r !== null && r.apply(this, arguments) || this;
  }
  return nr(e, r), e.prototype.render = function(t) {
    return Promise.resolve();
  }, e.prototype.getBoundingBoxCore = function(t) {
    return [];
  }, e.prototype.computeNodeTransformCore = function(t) {
    return t.pdf.unitMatrix;
  }, e;
})(lv), W5 = (function(r) {
  function e(t, A, n) {
    var i = r.call(this, A, n) || this;
    return i.pdfGradientType = t, i.contextColor = void 0, i;
  }
  return nr(e, r), e.prototype.apply = function(t) {
    return lr(this, void 0, void 0, (function() {
      var A, n, i, s, a, o;
      return ur(this, (function(l) {
        return (A = this.element.getAttribute("id")) ? (n = this.getStops(t.styleSheets), i = 0, s = !1, n.forEach((function(u) {
          var h = u.opacity;
          h && h !== 1 && (i += h, s = !0);
        })), s && (a = new Ta({ opacity: i / n.length })), o = new Qs(this.pdfGradientType, this.getCoordinates(), n, a), t.pdf.addShadingPattern(A, o), [2]) : [2];
      }));
    }));
  }, e.prototype.getStops = function(t) {
    var A = this;
    if (this.stops) return this.stops;
    if (this.contextColor === void 0) {
      this.contextColor = null;
      for (var n = this; n; ) {
        var i = Le(n.element, t, "color");
        if (i) {
          this.contextColor = xo(i, null);
          break;
        }
        n = n.getParent();
      }
    }
    var s = [];
    return this.children.forEach((function(a) {
      if (a.element.tagName.toLowerCase() === "stop") {
        var o = Le(a.element, t, "color"), l = xo(Le(a.element, t, "stop-color") || "", o ? { color: xo(o, null) } : { color: A.contextColor }), u = parseFloat(Le(a.element, t, "stop-opacity") || "1");
        s.push({ offset: e.parseGradientOffset(a.element.getAttribute("offset") || "0"), color: [l.r, l.g, l.b], opacity: u });
      }
    })), this.stops = s;
  }, e.prototype.getBoundingBoxCore = function(t) {
    return cu(this.element, t);
  }, e.prototype.computeNodeTransformCore = function(t) {
    return t.pdf.unitMatrix;
  }, e.prototype.isVisible = function(t, A) {
    return qs(this, t, A);
  }, e.parseGradientOffset = function(t) {
    var A = parseFloat(t);
    return !isNaN(A) && t.indexOf("%") >= 0 ? A / 100 : A;
  }, e;
})(fu), X5 = (function(r) {
  function e(t, A) {
    return r.call(this, "axial", t, A) || this;
  }
  return nr(e, r), e.prototype.getCoordinates = function() {
    return [parseFloat(this.element.getAttribute("x1") || "0"), parseFloat(this.element.getAttribute("y1") || "0"), parseFloat(this.element.getAttribute("x2") || "1"), parseFloat(this.element.getAttribute("y2") || "0")];
  }, e;
})(W5), Y5 = (function(r) {
  function e(t, A) {
    return r.call(this, "radial", t, A) || this;
  }
  return nr(e, r), e.prototype.getCoordinates = function() {
    var t = this.element.getAttribute("cx"), A = this.element.getAttribute("cy"), n = this.element.getAttribute("fx"), i = this.element.getAttribute("fy");
    return [parseFloat(n || t || "0.5"), parseFloat(i || A || "0.5"), 0, parseFloat(t || "0.5"), parseFloat(A || "0.5"), parseFloat(this.element.getAttribute("r") || "0.5")];
  }, e;
})(W5), UL = (function() {
  function r(e, t) {
    this.key = e, this.gradient = t;
  }
  return r.prototype.getFillData = function(e, t) {
    return lr(this, void 0, void 0, (function() {
      var A, n, i;
      return ur(this, (function(s) {
        switch (s.label) {
          case 0:
            return [4, t.refsHandler.getRendered(this.key, null, (function(a) {
              return a.apply(new js(t.pdf, { refsHandler: t.refsHandler, textMeasure: t.textMeasure, styleSheets: t.styleSheets, viewport: t.viewport, svg2pdfParameters: t.svg2pdfParameters }));
            }))];
          case 1:
            return s.sent(), this.gradient.element.hasAttribute("gradientUnits") && this.gradient.element.getAttribute("gradientUnits").toLowerCase() !== "objectboundingbox" ? A = t.pdf.unitMatrix : (n = e.getBoundingBox(t), A = t.pdf.Matrix(n[2], 0, 0, n[3], n[0], n[1])), i = Th(Le(this.gradient.element, t.styleSheets, "gradientTransform", "transform"), t), [2, { key: this.key, matrix: t.pdf.matrixMult(i, A) }];
        }
      }));
    }));
  }, r;
})(), J5 = (function(r) {
  function e() {
    return r !== null && r.apply(this, arguments) || this;
  }
  return nr(e, r), e.prototype.apply = function(t) {
    return lr(this, void 0, void 0, (function() {
      var A, n, i, s, a;
      return ur(this, (function(o) {
        switch (o.label) {
          case 0:
            if (!(A = this.element.getAttribute("id"))) return [2];
            n = this.getBoundingBox(t), i = new Ba([n[0], n[1], n[0] + n[2], n[1] + n[3]], n[2], n[3]), t.pdf.beginTilingPattern(i), s = 0, a = this.children, o.label = 1;
          case 1:
            return s < a.length ? [4, a[s].render(new js(t.pdf, { attributeState: t.attributeState, refsHandler: t.refsHandler, styleSheets: t.styleSheets, viewport: t.viewport, svg2pdfParameters: t.svg2pdfParameters, textMeasure: t.textMeasure }))] : [3, 4];
          case 2:
            o.sent(), o.label = 3;
          case 3:
            return s++, [3, 1];
          case 4:
            return t.pdf.endTilingPattern(A, i), [2];
        }
      }));
    }));
  }, e.prototype.getBoundingBoxCore = function(t) {
    return cu(this.element, t);
  }, e.prototype.computeNodeTransformCore = function(t) {
    return t.pdf.unitMatrix;
  }, e.prototype.isVisible = function(t, A) {
    return qs(this, t, A);
  }, e;
})(fu), IL = (function() {
  function r(e, t) {
    this.key = e, this.pattern = t;
  }
  return r.prototype.getFillData = function(e, t) {
    return lr(this, void 0, void 0, (function() {
      var A, n, i, s, a, o, l, u, h, f, c, p;
      return ur(this, (function(g) {
        switch (g.label) {
          case 0:
            return [4, t.refsHandler.getRendered(this.key, null, (function(v) {
              return v.apply(new js(t.pdf, { refsHandler: t.refsHandler, textMeasure: t.textMeasure, styleSheets: t.styleSheets, viewport: t.viewport, svg2pdfParameters: t.svg2pdfParameters }));
            }))];
          case 1:
            return g.sent(), A = { key: this.key, boundingBox: void 0, xStep: 0, yStep: 0, matrix: void 0 }, i = t.pdf.unitMatrix, this.pattern.element.hasAttribute("patternUnits") && this.pattern.element.getAttribute("patternUnits").toLowerCase() !== "objectboundingbox" || (n = e.getBoundingBox(t), i = t.pdf.Matrix(1, 0, 0, 1, n[0], n[1]), a = this.pattern.getBoundingBox(t), o = a[0] * n[0] || 0, l = a[1] * n[1] || 0, u = a[2] * n[2] || 0, h = a[3] * n[3] || 0, A.boundingBox = [o, l, o + u, l + h], A.xStep = u, A.yStep = h), s = t.pdf.unitMatrix, this.pattern.element.hasAttribute("patternContentUnits") && this.pattern.element.getAttribute("patternContentUnits").toLowerCase() === "objectboundingbox" && (n || (n = e.getBoundingBox(t)), s = t.pdf.Matrix(n[2], 0, 0, n[3], 0, 0), a = A.boundingBox || this.pattern.getBoundingBox(t), o = a[0] / n[0] || 0, l = a[1] / n[1] || 0, u = a[2] / n[2] || 0, h = a[3] / n[3] || 0, A.boundingBox = [o, l, o + u, l + h], A.xStep = u, A.yStep = h), f = t.pdf.unitMatrix, (c = Le(this.pattern.element, t.styleSheets, "patternTransform", "transform")) && (f = Th(c, t)), p = s, p = t.pdf.matrixMult(p, i), p = t.pdf.matrixMult(p, f), p = t.pdf.matrixMult(p, t.transform), A.matrix = p, [2, A];
        }
      }));
    }));
  }, r;
})();
function QL(r, e) {
  var t = av.exec(r);
  if (t) {
    var A = t[1], n = e.refsHandler.get(A);
    return n && (n instanceof X5 || n instanceof Y5) ? (function(s, a, o) {
      var l = a.getStops(o.styleSheets);
      if (l.length === 0) return null;
      if (l.length === 1) {
        var u = l[0].color, h = new ti();
        return h.ok = !0, h.r = u[0], h.g = u[1], h.b = u[2], h.a = l[0].opacity, new EA(h);
      }
      return new UL(s, a);
    })(A, n, e) : n && n instanceof J5 ? new IL(A, n) : new EA(new ti("rgb(0, 0, 0)"));
  }
  var i = xo(r, e.attributeState);
  return i.ok ? new EA(i) : null;
}
function uv(r, e, t) {
  var A = t || e.element, n = Le(A, r.styleSheets, "color");
  if (n) {
    var i = xo(n, r.attributeState);
    i.ok ? r.attributeState.color = i : r.attributeState.color = new ti("rgb(0,0,0)");
  }
  var s = Le(A, r.styleSheets, "visibility");
  s && (r.attributeState.visibility = s);
  var a = Le(A, r.styleSheets, "fill");
  a && (r.attributeState.fill = QL(a, r));
  var o = Le(A, r.styleSheets, "fill-opacity");
  o && (r.attributeState.fillOpacity = parseFloat(o));
  var l = Le(A, r.styleSheets, "stroke-opacity");
  l && (r.attributeState.strokeOpacity = parseFloat(l));
  var u = Le(A, r.styleSheets, "opacity");
  u && (r.attributeState.opacity = parseFloat(u));
  var h = Le(A, r.styleSheets, "stroke-width");
  h !== void 0 && h !== "" && (r.attributeState.strokeWidth = Math.abs(parseFloat(h)));
  var f = Le(A, r.styleSheets, "stroke");
  if (f) if (f === "none") r.attributeState.stroke = null;
  else {
    var c = xo(f, r.attributeState);
    c.ok && (r.attributeState.stroke = new EA(c));
  }
  f && r.attributeState.stroke instanceof EA && (r.attributeState.contextStroke = r.attributeState.stroke.color), a && r.attributeState.fill instanceof EA && (r.attributeState.contextFill = r.attributeState.fill.color);
  var p = Le(A, r.styleSheets, "stroke-linecap");
  p && (r.attributeState.strokeLinecap = p);
  var g = Le(A, r.styleSheets, "stroke-linejoin");
  g && (r.attributeState.strokeLinejoin = g);
  var v = Le(A, r.styleSheets, "stroke-dasharray");
  if (v) {
    var w = parseInt(Le(A, r.styleSheets, "stroke-dashoffset") || "0");
    r.attributeState.strokeDasharray = Tn(v), r.attributeState.strokeDashoffset = w;
  }
  var B = Le(A, r.styleSheets, "stroke-miterlimit");
  B !== void 0 && B !== "" && (r.attributeState.strokeMiterlimit = parseFloat(B));
  var S = A.getAttribute("xml:space");
  S && (r.attributeState.xmlSpace = S);
  var C = Le(A, r.styleSheets, "white-space");
  C && (r.attributeState.whiteSpace = C);
  var E = Le(A, r.styleSheets, "font-weight");
  E && (r.attributeState.fontWeight = E);
  var _ = Le(A, r.styleSheets, "font-style");
  _ && (r.attributeState.fontStyle = _);
  var I = Le(A, r.styleSheets, "font-family");
  if (I) {
    var O = pL.parse(I);
    r.attributeState.fontFamily = (function(J, ie, te) {
      var $ = z5(J.fontStyle, J.fontWeight), re = te.pdf.getFontList(), ue = "";
      return ie.some((function(se) {
        var T = re[se];
        return T && T.indexOf($) >= 0 ? (ue = se, !0) : (se = se.toLowerCase(), !!Ji.hasOwnProperty(se) && (ue = se, !0));
      })) || (ue = "times"), ue;
    })(r.attributeState, O, r);
  }
  var U = Le(A, r.styleSheets, "font-size");
  if (U) {
    var V = r.pdf.getFontSize();
    r.attributeState.fontSize = Yi(U, V);
  }
  var F = Le(A, r.styleSheets, "vertical-align") || Le(A, r.styleSheets, "alignment-baseline");
  if (F) {
    var P = F.match(/(baseline|text-bottom|alphabetic|ideographic|middle|central|mathematical|text-top|bottom|center|top|hanging)/);
    P && (r.attributeState.alignmentBaseline = P[0]);
  }
  var D = Le(A, r.styleSheets, "text-anchor");
  D && (r.attributeState.textAnchor = D);
  var R = Le(A, r.styleSheets, "fill-rule");
  R && (r.attributeState.fillRule = R);
}
function cv(r, e, t) {
  var A = 1, n = 1;
  A *= r.attributeState.fillOpacity, A *= r.attributeState.opacity, r.attributeState.fill instanceof EA && r.attributeState.fill.color.a !== void 0 && (A *= r.attributeState.fill.color.a), n *= r.attributeState.strokeOpacity, n *= r.attributeState.opacity, r.attributeState.stroke instanceof EA && r.attributeState.stroke.color.a !== void 0 && (n *= r.attributeState.stroke.color.a);
  var i, s, a = A < 1, o = n < 1;
  if (Hs(t, "use") ? (a = !0, o = !0, A *= r.attributeState.fill ? 1 : 0, n *= r.attributeState.stroke ? 1 : 0) : r.withinUse && (r.attributeState.fill !== e.attributeState.fill ? (a = !0, A *= r.attributeState.fill ? 1 : 0) : a && !r.attributeState.fill && (A = 0), r.attributeState.stroke !== e.attributeState.stroke ? (o = !0, n *= r.attributeState.stroke ? 1 : 0) : o && !r.attributeState.stroke && (n = 0)), a || o) {
    var l = {};
    a && (l.opacity = A), o && (l["stroke-opacity"] = n), r.pdf.setGState(new Ta(l));
  }
  if (r.attributeState.fill && r.attributeState.fill !== e.attributeState.fill && r.attributeState.fill instanceof EA && r.attributeState.fill.color.ok && !Hs(t, "text") && r.pdf.setFillColor(r.attributeState.fill.color.r, r.attributeState.fill.color.g, r.attributeState.fill.color.b), r.attributeState.strokeWidth !== e.attributeState.strokeWidth && r.pdf.setLineWidth(r.attributeState.strokeWidth), r.attributeState.stroke !== e.attributeState.stroke && r.attributeState.stroke instanceof EA && r.pdf.setDrawColor(r.attributeState.stroke.color.r, r.attributeState.stroke.color.g, r.attributeState.stroke.color.b), r.attributeState.strokeLinecap !== e.attributeState.strokeLinecap && r.pdf.setLineCap(r.attributeState.strokeLinecap), r.attributeState.strokeLinejoin !== e.attributeState.strokeLinejoin && r.pdf.setLineJoin(r.attributeState.strokeLinejoin), r.attributeState.strokeDasharray === e.attributeState.strokeDasharray && r.attributeState.strokeDashoffset === e.attributeState.strokeDashoffset || !r.attributeState.strokeDasharray || r.pdf.setLineDashPattern(r.attributeState.strokeDasharray, r.attributeState.strokeDashoffset), r.attributeState.strokeMiterlimit !== e.attributeState.strokeMiterlimit && r.pdf.setLineMiterLimit(r.attributeState.strokeMiterlimit), r.attributeState.fontFamily !== e.attributeState.fontFamily && (i = Ji.hasOwnProperty(r.attributeState.fontFamily) ? Ji[r.attributeState.fontFamily] : r.attributeState.fontFamily), r.attributeState.fill && r.attributeState.fill !== e.attributeState.fill && r.attributeState.fill instanceof EA && r.attributeState.fill.color.ok) {
    var u = r.attributeState.fill.color;
    r.pdf.setTextColor(u.r, u.g, u.b);
  }
  r.attributeState.fontWeight === e.attributeState.fontWeight && r.attributeState.fontStyle === e.attributeState.fontStyle || (s = z5(r.attributeState.fontStyle, r.attributeState.fontWeight)), i === void 0 && s === void 0 || (i === void 0 && (i = Ji.hasOwnProperty(r.attributeState.fontFamily) ? Ji[r.attributeState.fontFamily] : r.attributeState.fontFamily), r.pdf.setFont(i, s)), r.attributeState.fontSize !== e.attributeState.fontSize && r.pdf.setFontSize(r.attributeState.fontSize * r.pdf.internal.scaleFactor);
}
function $5(r, e, t) {
  var A = av.exec(r);
  if (A) {
    var n = A[1];
    return t.refsHandler.get(n) || void 0;
  }
}
function Z5(r, e, t) {
  return lr(this, void 0, void 0, (function() {
    var A, n;
    return ur(this, (function(i) {
      switch (i.label) {
        case 0:
          return A = t.clone(), e.element.hasAttribute("clipPathUnits") && e.element.getAttribute("clipPathUnits").toLowerCase() === "objectboundingbox" && (n = r.getBoundingBox(t), A.transform = t.pdf.matrixMult(t.pdf.Matrix(n[2], 0, 0, n[3], n[0], n[1]), t.transform)), [4, e.apply(A)];
        case 1:
          return i.sent(), [2];
      }
    }));
  }));
}
var ex = (function(r) {
  function e() {
    return r !== null && r.apply(this, arguments) || this;
  }
  return nr(e, r), e.prototype.render = function(t) {
    return lr(this, void 0, void 0, (function() {
      var A, n, i, s;
      return ur(this, (function(a) {
        switch (a.label) {
          case 0:
            return this.isVisible(t.attributeState.visibility !== "hidden", t) ? ((A = t.clone()).transform = A.pdf.matrixMult(this.computeNodeTransform(A), t.transform), uv(A, this), n = Le(this.element, A.styleSheets, "clip-path"), (i = n && n !== "none") ? (s = $5(n, 0, A)) ? s.isVisible(!0, A) ? (A.pdf.saveGraphicsState(), [4, Z5(this, s, A)]) : [3, 2] : [3, 4] : [3, 5]) : [2];
          case 1:
            return a.sent(), [3, 3];
          case 2:
            return [2];
          case 3:
            return [3, 5];
          case 4:
            i = !1, a.label = 5;
          case 5:
            return A.withinClipPath || A.pdf.saveGraphicsState(), cv(A, t, this.element), [4, this.renderCore(A)];
          case 6:
            return a.sent(), A.withinClipPath || A.pdf.restoreGraphicsState(), i && A.pdf.restoreGraphicsState(), [2];
        }
      }));
    }));
  }, e;
})(lv), Ph = (function(r) {
  function e() {
    return r !== null && r.apply(this, arguments) || this;
  }
  return nr(e, r), e;
})(ex), du = (function(r) {
  function e(t, A, n) {
    var i = r.call(this, A, n) || this;
    return i.cachedPath = null, i.hasMarkers = t, i;
  }
  return nr(e, r), e.prototype.renderCore = function(t) {
    return lr(this, void 0, void 0, (function() {
      var A;
      return ur(this, (function(n) {
        switch (n.label) {
          case 0:
            return (A = this.getCachedPath(t)) === null || A.segments.length === 0 ? [2] : (t.withinClipPath ? A.transform(t.transform) : t.pdf.setCurrentTransformationMatrix(t.transform), A.draw(t), [4, this.fillOrStroke(t)]);
          case 1:
            return n.sent(), this.hasMarkers ? [4, this.drawMarkers(t, A)] : [3, 3];
          case 2:
            n.sent(), n.label = 3;
          case 3:
            return [2];
        }
      }));
    }));
  }, e.prototype.getCachedPath = function(t) {
    return this.cachedPath || (this.cachedPath = this.getPath(t));
  }, e.prototype.drawMarkers = function(t, A) {
    return lr(this, void 0, void 0, (function() {
      return ur(this, (function(n) {
        switch (n.label) {
          case 0:
            return [4, this.getMarkers(A, t).draw(t.clone({ transform: t.pdf.unitMatrix }))];
          case 1:
            return n.sent(), [2];
        }
      }));
    }));
  }, e.prototype.fillOrStroke = function(t) {
    return lr(this, void 0, void 0, (function() {
      var A, n, i, s, a;
      return ur(this, (function(o) {
        switch (o.label) {
          case 0:
            return t.withinClipPath ? [2] : (A = t.attributeState.fill, n = t.attributeState.stroke && t.attributeState.strokeWidth !== 0, A ? [4, A.getFillData(this, t)] : [3, 2]);
          case 1:
            return s = o.sent(), [3, 3];
          case 2:
            s = void 0, o.label = 3;
          case 3:
            return i = s, a = t.attributeState.fillRule === "evenodd", A && n || t.withinUse ? a ? t.pdf.fillStrokeEvenOdd(i) : t.pdf.fillStroke(i) : A ? a ? t.pdf.fillEvenOdd(i) : t.pdf.fill(i) : n ? t.pdf.stroke() : t.pdf.discardPath(), [2];
        }
      }));
    }));
  }, e.prototype.getBoundingBoxCore = function(t) {
    var A = this.getCachedPath(t);
    if (!A || !A.segments.length) return [0, 0, 0, 0];
    for (var n = Number.POSITIVE_INFINITY, i = Number.POSITIVE_INFINITY, s = Number.NEGATIVE_INFINITY, a = Number.NEGATIVE_INFINITY, o = 0, l = 0, u = 0; u < A.segments.length; u++) {
      var h = A.segments[u];
      (h instanceof pA || h instanceof Ls || h instanceof wi) && (o = h.x, l = h.y), h instanceof wi ? (n = Math.min(n, o, h.x1, h.x2, h.x), s = Math.max(s, o, h.x1, h.x2, h.x), i = Math.min(i, l, h.y1, h.y2, h.y), a = Math.max(a, l, h.y1, h.y2, h.y)) : (n = Math.min(n, o), s = Math.max(s, o), i = Math.min(i, l), a = Math.max(a, l));
    }
    return [n, i, s - n, a - i];
  }, e.prototype.getMarkers = function(t, A) {
    var n = Le(this.element, A.styleSheets, "marker-start"), i = Le(this.element, A.styleSheets, "marker-mid"), s = Le(this.element, A.styleSheets, "marker-end"), a = new EL();
    if (n || i || s) {
      s && (s = xd(s)), n && (n = xd(n)), i && (i = xd(i));
      for (var o = t.segments, l = [1, 0], u = void 0, h = !1, f = [1, 0], c = !1, p = function(v) {
        var w = o[v], B = n && (v === 1 || !(o[v] instanceof pA) && o[v - 1] instanceof pA);
        B && o.forEach((function(O, U) {
          if (!c && O instanceof Am && U > v) {
            var V = o[U - 1];
            c = (V instanceof pA || V instanceof Ls || V instanceof wi) && V;
          }
        }));
        var S = s && (v === o.length - 1 || !(o[v] instanceof pA) && o[v + 1] instanceof pA), C = i && v > 0 && !(v === 1 && o[v - 1] instanceof pA), E = o[v - 1] || null;
        if (E instanceof pA || E instanceof Ls || E instanceof wi)
          if (w instanceof wi) B && a.addMarker(new Es(n, [E.x, E.y], cy(c ? [c.x, c.y] : [E.x, E.y], [w.x1, w.y1]), !0)), S && a.addMarker(new Es(s, [w.x, w.y], cy([w.x2, w.y2], [w.x, w.y]))), C && (u = Ao([E.x, E.y], [w.x1, w.y1]), u = E instanceof pA ? u : El(vc(l, u)), a.addMarker(new Es(i, [E.x, E.y], Math.atan2(u[1], u[0])))), l = Ao([w.x2, w.y2], [w.x, w.y]);
          else if (w instanceof pA || w instanceof Ls) {
            if (u = Ao([E.x, E.y], [w.x, w.y]), B) {
              var _ = c ? Ao([c.x, c.y], [w.x, w.y]) : u;
              a.addMarker(new Es(n, [E.x, E.y], Math.atan2(_[1], _[0]), !0));
            }
            S && a.addMarker(new Es(s, [w.x, w.y], Math.atan2(u[1], u[0]))), C && (_ = w instanceof pA ? l : E instanceof pA ? u : El(vc(l, u)), a.addMarker(new Es(i, [E.x, E.y], Math.atan2(_[1], _[0])))), l = u;
          } else w instanceof Am && (u = Ao([E.x, E.y], [h.x, h.y]), C && (_ = E instanceof pA ? u : El(vc(l, u)), a.addMarker(new Es(i, [E.x, E.y], Math.atan2(_[1], _[0])))), S && (_ = El(vc(u, f)), a.addMarker(new Es(s, [h.x, h.y], Math.atan2(_[1], _[0])))), l = u);
        else {
          h = w instanceof pA && w;
          var I = o[v + 1];
          (I instanceof pA || I instanceof Ls || I instanceof wi) && (f = Ao([h.x, h.y], [I.x, I.y]));
        }
      }, g = 0; g < o.length; g++) p(g);
    }
    return a.markers.forEach((function(v) {
      var w = A.refsHandler.get(v.id);
      if (w) {
        var B = Le(w.element, A.styleSheets, "orient");
        B != null && (v.isStartMarker && B === "auto-start-reverse" && (v.angle += Math.PI), isNaN(Number(B)) || (v.angle = parseFloat(B) / 180 * Math.PI));
      }
    })), a;
  }, e;
})(Ph);
function xd(r) {
  var e = av.exec(r);
  return e && e[1] || void 0;
}
var LL = (function(r) {
  function e(t, A) {
    return r.call(this, !0, t, A) || this;
  }
  return nr(e, r), e.prototype.getPath = function(t) {
    if (t.withinClipPath || t.attributeState.stroke === null) return null;
    var A = parseFloat(this.element.getAttribute("x1") || "0"), n = parseFloat(this.element.getAttribute("y1") || "0"), i = parseFloat(this.element.getAttribute("x2") || "0"), s = parseFloat(this.element.getAttribute("y2") || "0");
    return A || i || n || s ? new Uo().moveTo(A, n).lineTo(i, s) : null;
  }, e.prototype.computeNodeTransformCore = function(t) {
    return t.pdf.unitMatrix;
  }, e.prototype.isVisible = function(t, A) {
    return ss(this, t, A);
  }, e.prototype.fillOrStroke = function(t) {
    return lr(this, void 0, void 0, (function() {
      return ur(this, (function(A) {
        switch (A.label) {
          case 0:
            return t.attributeState.fill = null, [4, r.prototype.fillOrStroke.call(this, t)];
          case 1:
            return A.sent(), [2];
        }
      }));
    }));
  }, e;
})(du), tx = (function(r) {
  function e() {
    return r !== null && r.apply(this, arguments) || this;
  }
  return nr(e, r), e.prototype.apply = function(t) {
    return lr(this, void 0, void 0, (function() {
      var A, n, i, s, a;
      return ur(this, (function(o) {
        switch (o.label) {
          case 0:
            return this.isVisible(t.attributeState.visibility !== "hidden", t) ? ((A = t.clone()).transform = A.pdf.unitMatrix, uv(A, this), n = Le(this.element, A.styleSheets, "clip-path"), n && n !== "none" && (i = $5(n, 0, A)) ? i.isVisible(!0, A) ? [4, Z5(this, i, A)] : [3, 2] : [3, 3]) : [2];
          case 1:
            return o.sent(), [3, 3];
          case 2:
            return [2];
          case 3:
            cv(A, t, this.element), s = 0, a = this.children, o.label = 4;
          case 4:
            return s < a.length ? [4, a[s].render(A)] : [3, 7];
          case 5:
            o.sent(), o.label = 6;
          case 6:
            return s++, [3, 4];
          case 7:
            return [2];
        }
      }));
    }));
  }, e.prototype.getBoundingBoxCore = function(t) {
    return ov(t, this);
  }, e.prototype.isVisible = function(t, A) {
    return qs(this, t, A);
  }, e.prototype.computeNodeTransformCore = function(t) {
    var A = parseFloat(Le(this.element, t.styleSheets, "x") || "0"), n = parseFloat(Le(this.element, t.styleSheets, "y") || "0"), i = this.element.getAttribute("viewBox");
    if (i) {
      var s = Tn(i), a = parseFloat(Le(this.element, t.styleSheets, "width") || Le(this.element.ownerSVGElement, t.styleSheets, "width") || i[2]), o = parseFloat(Le(this.element, t.styleSheets, "height") || Le(this.element.ownerSVGElement, t.styleSheets, "height") || i[3]);
      return hu(this.element, s, A, n, a, o, t);
    }
    return t.pdf.Matrix(1, 0, 0, 1, A, n);
  }, e;
})(fu), Oh = function(r, e) {
  this.width = r, this.height = e;
}, NL = (function(r) {
  function e() {
    return r !== null && r.apply(this, arguments) || this;
  }
  return nr(e, r), e.prototype.renderCore = function(t) {
    return lr(this, void 0, void 0, (function() {
      var A, n, i, s, a, o, l, u, h, f, c, p, g;
      return ur(this, (function(v) {
        switch (v.label) {
          case 0:
            return A = parseFloat, (n = this.element.getAttribute("href") || this.element.getAttribute("xlink:href")) ? (i = n.substring(1), s = t.refsHandler.get(i), a = Hs(s.element, "symbol,svg") && s.element.hasAttribute("viewBox"), o = A(Le(this.element, t.styleSheets, "x") || "0"), l = A(Le(this.element, t.styleSheets, "y") || "0"), u = void 0, h = void 0, a ? (u = A(Le(this.element, t.styleSheets, "width") || Le(s.element, t.styleSheets, "width") || "0"), h = A(Le(this.element, t.styleSheets, "height") || Le(s.element, t.styleSheets, "height") || "0"), o += A(Le(s.element, t.styleSheets, "x") || "0"), l += A(Le(s.element, t.styleSheets, "y") || "0"), c = Tn(s.element.getAttribute("viewBox")), f = hu(s.element, c, o, l, u, h, t)) : f = t.pdf.Matrix(1, 0, 0, 1, o, l), p = _o.getContextColors(t, !0), g = new js(t.pdf, { refsHandler: t.refsHandler, styleSheets: t.styleSheets, withinUse: !0, viewport: a ? new Oh(u, h) : t.viewport, svg2pdfParameters: t.svg2pdfParameters, textMeasure: t.textMeasure, attributeState: Object.assign(_o.default(), p) }), [4, t.refsHandler.getRendered(i, p, (function(w) {
              return e.renderReferencedNode(w, i, g);
            }))]) : [2];
          case 1:
            return v.sent(), t.pdf.saveGraphicsState(), t.pdf.setCurrentTransformationMatrix(t.transform), a && Le(s.element, t.styleSheets, "overflow") !== "visible" && (t.pdf.rect(o, l, u, h), t.pdf.clip().discardPath()), t.pdf.doFormObject(t.refsHandler.generateKey(i, p), f), t.pdf.restoreGraphicsState(), [2];
        }
      }));
    }));
  }, e.renderReferencedNode = function(t, A, n) {
    return lr(this, void 0, void 0, (function() {
      var i;
      return ur(this, (function(s) {
        switch (s.label) {
          case 0:
            return i = [(i = t.getBoundingBox(n))[0] - 0.5 * i[2], i[1] - 0.5 * i[3], 2 * i[2], 2 * i[3]], n.pdf.beginFormObject(i[0], i[1], i[2], i[3], n.pdf.unitMatrix), t instanceof tx ? [4, t.apply(n)] : [3, 2];
          case 1:
            return s.sent(), [3, 4];
          case 2:
            return [4, t.render(n)];
          case 3:
            s.sent(), s.label = 4;
          case 4:
            return n.pdf.endFormObject(n.refsHandler.generateKey(A, n.attributeState)), [2];
        }
      }));
    }));
  }, e.prototype.getBoundingBoxCore = function(t) {
    return cu(this.element, t);
  }, e.prototype.isVisible = function(t, A) {
    return ss(this, t, A);
  }, e.prototype.computeNodeTransformCore = function(t) {
    return t.pdf.unitMatrix;
  }, e;
})(Ph), TL = (function(r) {
  function e(t, A) {
    return r.call(this, !1, t, A) || this;
  }
  return nr(e, r), e.prototype.getPath = function(t) {
    var A = parseFloat(Le(this.element, t.styleSheets, "width") || "0"), n = parseFloat(Le(this.element, t.styleSheets, "height") || "0");
    if (!isFinite(A) || A <= 0 || !isFinite(n) || n <= 0) return null;
    var i = Le(this.element, t.styleSheets, "rx"), s = Le(this.element, t.styleSheets, "ry"), a = Math.min(parseFloat(i || s || "0"), 0.5 * A), o = Math.min(parseFloat(s || i || "0"), 0.5 * n), l = parseFloat(Le(this.element, t.styleSheets, "x") || "0"), u = parseFloat(Le(this.element, t.styleSheets, "y") || "0"), h = 4 / 3 * (Math.SQRT2 - 1);
    return a === 0 && o === 0 ? new Uo().moveTo(l, u).lineTo(l + A, u).lineTo(l + A, u + n).lineTo(l, u + n).close() : new Uo().moveTo(l += a, u).lineTo(l += A - 2 * a, u).curveTo(l + a * h, u, l + a, u + (o - o * h), l += a, u += o).lineTo(l, u += n - 2 * o).curveTo(l, u + o * h, l - a * h, u + o, l -= a, u += o).lineTo(l += 2 * a - A, u).curveTo(l - a * h, u, l - a, u - o * h, l -= a, u -= o).lineTo(l, u += 2 * o - n).curveTo(l, u - o * h, l + a * h, u - o, l += a, u -= o).close();
  }, e.prototype.computeNodeTransformCore = function(t) {
    return t.pdf.unitMatrix;
  }, e.prototype.isVisible = function(t, A) {
    return ss(this, t, A);
  }, e;
})(du), rx = (function(r) {
  function e(t, A) {
    return r.call(this, !1, t, A) || this;
  }
  return nr(e, r), e.prototype.getPath = function(t) {
    var A = this.getRx(t), n = this.getRy(t);
    if (!isFinite(A) || n <= 0 || !isFinite(n) || n <= 0) return null;
    var i = parseFloat(Le(this.element, t.styleSheets, "cx") || "0"), s = parseFloat(Le(this.element, t.styleSheets, "cy") || "0"), a = 4 / 3 * (Math.SQRT2 - 1) * A, o = 4 / 3 * (Math.SQRT2 - 1) * n;
    return new Uo().moveTo(i + A, s).curveTo(i + A, s - o, i + a, s - n, i, s - n).curveTo(i - a, s - n, i - A, s - o, i - A, s).curveTo(i - A, s + o, i - a, s + n, i, s + n).curveTo(i + a, s + n, i + A, s + o, i + A, s);
  }, e.prototype.computeNodeTransformCore = function(t) {
    return t.pdf.unitMatrix;
  }, e.prototype.isVisible = function(t, A) {
    return ss(this, t, A);
  }, e;
})(du), PL = (function(r) {
  function e(t, A) {
    return r.call(this, t, A) || this;
  }
  return nr(e, r), e.prototype.getRx = function(t) {
    return parseFloat(Le(this.element, t.styleSheets, "rx") || "0");
  }, e.prototype.getRy = function(t) {
    return parseFloat(Le(this.element, t.styleSheets, "ry") || "0");
  }, e;
})(rx);
function Ax(r) {
  var e = "invisible", t = r.stroke && r.strokeWidth !== 0, A = r.fill;
  return A && t ? e = "fillThenStroke" : A ? e = "fill" : t && (e = "stroke"), e;
}
function gy(r) {
  return r.replace(/[\n\r]/g, "");
}
function py(r) {
  return r.replace(/[\t]/g, " ");
}
function my(r) {
  return r.replace(/ +/g, " ");
}
function vy(r, e, t) {
  switch (Le(r, t.styleSheets, "text-transform")) {
    case "uppercase":
      return e.toUpperCase();
    case "lowercase":
      return e.toLowerCase();
    default:
      return e;
  }
}
var Ed = (function() {
  function r(e, t, A, n) {
    this.textNode = e, this.texts = [], this.textNodes = [], this.contexts = [], this.textAnchor = t, this.originX = A, this.originY = n, this.textMeasures = [];
  }
  return r.prototype.setX = function(e) {
    this.originX = e;
  }, r.prototype.setY = function(e) {
    this.originY = e;
  }, r.prototype.add = function(e, t, A) {
    this.texts.push(t), this.textNodes.push(e), this.contexts.push(A);
  }, r.prototype.rightTrimText = function() {
    for (var e = this.texts.length - 1; e >= 0; e--)
      if (this.contexts[e].attributeState.xmlSpace === "preserve" || this.contexts[e].attributeState.whiteSpace === "pre" || (this.texts[e] = this.texts[e].replace(/\s+$/, "")), this.texts[e].match(/[^\s]/)) return !1;
    return !0;
  }, r.prototype.measureText = function(e) {
    for (var t = 0; t < this.texts.length; t++) this.textMeasures.push({ width: e.textMeasure.measureTextWidth(this.texts[t], this.contexts[t].attributeState), length: this.texts[t].length });
  }, r.prototype.put = function(e, t) {
    var A, n, i, s, a = [], o = [], l = [], u = this.originX, h = this.originY, f = u, c = u;
    for (A = 0; A < this.textNodes.length; A++) {
      n = this.textNodes[A], i = this.contexts[A], s = this.textMeasures[A] || { width: e.textMeasure.measureTextWidth(this.texts[A], this.contexts[A].attributeState), length: this.texts[A].length };
      var p = u, g = h;
      if (n.nodeName !== "#text" && !a.includes(n)) {
        a.push(n);
        var v = r.resolveRelativePositionAttribute(n, "dx");
        v !== null && (p += Yi(v, i.attributeState.fontSize));
        var w = r.resolveRelativePositionAttribute(n, "dy");
        w !== null && (g += Yi(w, i.attributeState.fontSize));
      }
      o[A] = p, l[A] = g, u = p + s.width + s.length * t, h = g, f = Math.min(f, p), c = Math.max(c, u);
    }
    var B = 0;
    switch (this.textAnchor) {
      case "start":
        B = 0;
        break;
      case "middle":
        B = (c - f) / 2;
        break;
      case "end":
        B = c - f;
    }
    for (A = 0; A < this.textNodes.length; A++) if (n = this.textNodes[A], i = this.contexts[A], n.nodeName === "#text" || i.attributeState.visibility !== "hidden") {
      e.pdf.saveGraphicsState(), cv(i, e, n);
      var S = i.attributeState.alignmentBaseline, C = Ax(i.attributeState);
      e.pdf.text(this.texts[A], o[A] - B, l[A], { baseline: q5(S), angle: e.transform, renderingMode: C === "fill" ? void 0 : C, charSpace: t === 0 ? void 0 : t }), e.pdf.restoreGraphicsState();
    }
    return [u, h];
  }, r.resolveRelativePositionAttribute = function(e, t) {
    for (var A, n = e; n && Hs(n, "tspan"); ) {
      if (n.hasAttribute(t)) return n.getAttribute(t);
      if (((A = e.parentElement) === null || A === void 0 ? void 0 : A.firstChild) !== e) break;
      n = n.parentElement;
    }
    return null;
  }, r;
})(), OL = (function(r) {
  function e() {
    var t = r !== null && r.apply(this, arguments) || this;
    return t.boundingBox = [], t;
  }
  return nr(e, r), e.prototype.processTSpans = function(t, A, n, i, s, a) {
    for (var o = n.pdf.getFontSize(), l = n.attributeState.xmlSpace === "preserve" || n.attributeState.whiteSpace === "pre", u = !0, h = !1, f = 0; f < A.childNodes.length; f++) {
      var c = A.childNodes[f];
      if (c.textContent) {
        var p = c.textContent;
        if (c.nodeName === "#text") {
          var g = gy(p);
          g = py(g), l || (g = my(g), u && g.match(/^\s/) && (h = !0), g.match(/[^\s]/) && (u = !1), a.prevText.match(/\s$/) && (g = g.replace(/^\s+/, "")));
          var v = vy(A, g, n);
          s.add(A, v, n), a.prevText = p, a.prevContext = n;
        } else if (!Hs(c, "title")) {
          if (Hs(c, "tspan")) {
            var w = c, B = w.getAttribute("x");
            if (B !== null) {
              var S = Yi(B, o);
              s = new Ed(this, Le(w, n.styleSheets, "text-anchor") || n.attributeState.textAnchor, S, 0), i.push({ type: "y", chunk: s });
            }
            var C = w.getAttribute("y");
            if (C !== null) {
              var E = Yi(C, o);
              s = new Ed(this, Le(w, n.styleSheets, "text-anchor") || n.attributeState.textAnchor, 0, E), i.push({ type: "x", chunk: s });
            }
            var _ = n.clone();
            uv(_, t, w), this.processTSpans(t, w, _, i, s, a);
          }
        }
      }
    }
    return h;
  }, e.prototype.renderCore = function(t) {
    return lr(this, void 0, void 0, (function() {
      var A, n, i, s, a, o, l, u, h, f, c, p, g, v, w, B, S, C, E, _, I, O, U;
      return ur(this, (function(V) {
        if (t.pdf.saveGraphicsState(), A = 0, n = 0, i = 1, s = t.pdf.getFontSize(), a = Yi(this.element.getAttribute("x"), s), o = Yi(this.element.getAttribute("y"), s), l = Yi(this.element.getAttribute("dx"), s), u = Yi(this.element.getAttribute("dy"), s), h = parseFloat(this.element.getAttribute("textLength") || "0"), f = t.attributeState.visibility, this.element.childElementCount === 0) c = this.element.textContent || "", p = (function(F, P) {
          return F = py(F = gy(F)), P.xmlSpace === "preserve" || P.whiteSpace === "pre" || (F = my(F = F.trim())), F;
        })(c, t.attributeState), g = vy(this.element, p, t), A = t.textMeasure.getTextOffset(g, t.attributeState), h > 0 && (v = t.textMeasure.measureTextWidth(g, t.attributeState), !(t.attributeState.xmlSpace === "preserve" || t.attributeState.whiteSpace === "pre") && c.match(/^\s/) && (i = 0), n = (h - v) / (g.length - i) || 0), f === "visible" && (w = t.attributeState.alignmentBaseline, B = Ax(t.attributeState), t.pdf.text(g, a + l - A, o + u, { baseline: q5(w), angle: t.transform, renderingMode: B === "fill" ? void 0 : B, charSpace: n === 0 ? void 0 : n }), this.boundingBox = [a + l - A, o + u + 0.1 * s, t.textMeasure.measureTextWidth(g, t.attributeState), s]);
        else {
          for (S = [], C = new Ed(this, t.attributeState.textAnchor, a + l, o + u), S.push({ type: "", chunk: C }), E = this.processTSpans(this, this.element, t, S, C, { prevText: " ", prevContext: t }), i = E ? 0 : 1, _ = !0, I = S.length - 1; I >= 0; I--) _ && (_ = S[I].chunk.rightTrimText());
          h > 0 && (O = 0, U = 0, S.forEach((function(F) {
            var P = F.chunk;
            P.measureText(t), P.textMeasures.forEach((function(D) {
              var R = D.width, J = D.length;
              O += R, U += J;
            }));
          })), n = (h - O) / (U - i)), S.reduce((function(F, P) {
            var D = P.type, R = P.chunk;
            return D === "x" ? R.setX(F[0]) : D === "y" && R.setY(F[1]), R.put(t, n);
          }), [0, 0]);
        }
        return t.pdf.restoreGraphicsState(), [2];
      }));
    }));
  }, e.prototype.isVisible = function(t, A) {
    return qs(this, t, A);
  }, e.prototype.getBoundingBoxCore = function(t) {
    return this.boundingBox.length > 0 ? this.boundingBox : cu(this.element, t);
  }, e.prototype.computeNodeTransformCore = function(t) {
    return t.pdf.unitMatrix;
  }, e;
})(Ph), ML = (function(r) {
  function e(t, A) {
    return r.call(this, !0, t, A) || this;
  }
  return nr(e, r), e.prototype.computeNodeTransformCore = function(t) {
    return t.pdf.unitMatrix;
  }, e.prototype.isVisible = function(t, A) {
    return ss(this, t, A);
  }, e.prototype.getPath = function(t) {
    var A, n, i = new SL(Le(this.element, t.styleSheets, "d") || "").unshort().unarc().abs(), s = new Uo();
    return i.iterate((function(a) {
      switch (a[0]) {
        case "M":
          s.moveTo(a[1], a[2]);
          break;
        case "L":
          s.lineTo(a[1], a[2]);
          break;
        case "H":
          s.lineTo(a[1], n);
          break;
        case "V":
          s.lineTo(A, a[1]);
          break;
        case "C":
          s.curveTo(a[1], a[2], a[3], a[4], a[5], a[6]);
          break;
        case "Q":
          var o = fy([A, n], [a[1], a[2]]), l = fy([a[3], a[4]], [a[1], a[2]]);
          s.curveTo(o[0], o[1], l[0], l[1], a[3], a[4]);
          break;
        case "Z":
          s.close();
      }
      switch (a[0]) {
        case "M":
        case "L":
          A = a[1], n = a[2];
          break;
        case "H":
          A = a[1];
          break;
        case "V":
          n = a[1];
          break;
        case "C":
          A = a[5], n = a[6];
          break;
        case "Q":
          A = a[3], n = a[4];
      }
    })), s;
  }, e;
})(du), RL = /^\s*data:(([^/,;]+\/[^/,;]+)(?:;([^,;=]+=[^,;=]+))?)?(?:;(base64))?,((?:.|\s)*)$/i, kL = (function(r) {
  function e(t, A) {
    var n = r.call(this, t, A) || this;
    return n.imageLoadingPromise = null, n.imageUrl = n.element.getAttribute("xlink:href") || n.element.getAttribute("href"), n.imageUrl && (n.imageLoadingPromise = e.fetchImageData(n.imageUrl)), n;
  }
  return nr(e, r), e.prototype.renderCore = function(t) {
    return lr(this, void 0, void 0, (function() {
      var A, n, i, s, a, o, l, u, h, f, c, p, g, v, w, B, S, C;
      return ur(this, (function(E) {
        switch (E.label) {
          case 0:
            return this.imageLoadingPromise ? (t.pdf.setCurrentTransformationMatrix(t.transform), A = parseFloat(Le(this.element, t.styleSheets, "width") || "0"), n = parseFloat(Le(this.element, t.styleSheets, "height") || "0"), i = parseFloat(Le(this.element, t.styleSheets, "x") || "0"), s = parseFloat(Le(this.element, t.styleSheets, "y") || "0"), !isFinite(A) || A <= 0 || !isFinite(n) || n <= 0 ? [2] : [4, this.imageLoadingPromise]) : [2];
          case 1:
            return a = E.sent(), o = a.data, (l = a.format).indexOf("svg") !== 0 ? [3, 3] : (u = new DOMParser(), h = u.parseFromString(o, "image/svg+xml").firstElementChild, (!(f = this.element.getAttribute("preserveAspectRatio")) || f.indexOf("defer") < 0 || !h.getAttribute("preserveAspectRatio")) && h.setAttribute("preserveAspectRatio", f || ""), h.setAttribute("x", String(i)), h.setAttribute("y", String(s)), h.setAttribute("width", String(A)), h.setAttribute("height", String(n)), [4, hv(h, c = {}).render(new js(t.pdf, { refsHandler: new j5(c), styleSheets: t.styleSheets, viewport: new Oh(A, n), svg2pdfParameters: t.svg2pdfParameters, textMeasure: t.textMeasure }))]);
          case 2:
            return E.sent(), [2];
          case 3:
            p = "data:image/".concat(l, ";base64,").concat(btoa(o)), E.label = 4;
          case 4:
            return E.trys.push([4, 6, , 7]), [4, e.getImageDimensions(p)];
          case 5:
            return g = E.sent(), v = g[0], w = g[1], B = [0, 0, v, w], S = hu(this.element, B, i, s, A, n, t), t.pdf.setCurrentTransformationMatrix(S), t.pdf.addImage(p, "", 0, 0, v, w), [3, 7];
          case 6:
            return C = E.sent(), typeof console == "object" && console.warn && console.warn("Could not load image ".concat(this.imageUrl, `. 
`).concat(C)), [3, 7];
          case 7:
            return [2];
        }
      }));
    }));
  }, e.prototype.getBoundingBoxCore = function(t) {
    return cu(this.element, t);
  }, e.prototype.computeNodeTransformCore = function(t) {
    return t.pdf.unitMatrix;
  }, e.prototype.isVisible = function(t, A) {
    return ss(this, t, A);
  }, e.fetchImageData = function(t) {
    return lr(this, void 0, void 0, (function() {
      var A, n, i, s, a;
      return ur(this, (function(o) {
        switch (o.label) {
          case 0:
            if (!(i = t.match(RL))) return [3, 1];
            if (s = i[2], (a = s.split("/"))[0] !== "image") throw new Error("Unsupported image URL: ".concat(t));
            return n = a[1], A = i[5], i[4] === "base64" ? (A = A.replace(/\s/g, ""), A = atob(A)) : A = decodeURIComponent(A), [3, 3];
          case 1:
            return [4, e.fetchImage(t)];
          case 2:
            A = o.sent(), n = t.substring(t.lastIndexOf(".") + 1), o.label = 3;
          case 3:
            return [2, { data: A, format: n }];
        }
      }));
    }));
  }, e.fetchImage = function(t) {
    return new Promise((function(A, n) {
      var i = new XMLHttpRequest();
      i.open("GET", t, !0), i.responseType = "arraybuffer", i.onload = function() {
        if (i.status !== 200) throw new Error("Error ".concat(i.status, ": Failed to load image '").concat(t, "'"));
        for (var s = new Uint8Array(i.response), a = "", o = 0; o < s.length; o++) a += String.fromCharCode(s[o]);
        A(a);
      }, i.onerror = n, i.onabort = n, i.send(null);
    }));
  }, e.getMimeType = function(t) {
    switch (t = t.toLowerCase()) {
      case "jpg":
      case "jpeg":
        return "image/jpeg";
      default:
        return "image/".concat(t);
    }
  }, e.getImageDimensions = function(t) {
    return new Promise((function(A, n) {
      var i = new Image();
      i.onload = function() {
        A([i.width, i.height]);
      }, i.onerror = n, i.src = t;
    }));
  }, e;
})(Ph), nx = (function(r) {
  function e(t, A, n) {
    var i = r.call(this, !0, A, n) || this;
    return i.closed = t, i;
  }
  return nr(e, r), e.prototype.getPath = function(t) {
    if (!this.element.hasAttribute("points") || this.element.getAttribute("points") === "") return null;
    var A = e.parsePointsString(this.element.getAttribute("points")), n = new Uo();
    if (A.length < 1) return n;
    n.moveTo(A[0][0], A[0][1]);
    for (var i = 1; i < A.length; i++) n.lineTo(A[i][0], A[i][1]);
    return this.closed && n.close(), n;
  }, e.prototype.isVisible = function(t, A) {
    return ss(this, t, A);
  }, e.prototype.computeNodeTransformCore = function(t) {
    return t.pdf.unitMatrix;
  }, e.parsePointsString = function(t) {
    for (var A = Tn(t), n = [], i = 0; i < A.length - 1; i += 2) {
      var s = A[i], a = A[i + 1];
      n.push([s, a]);
    }
    return n;
  }, e;
})(du), HL = (function(r) {
  function e(t, A) {
    return r.call(this, !0, t, A) || this;
  }
  return nr(e, r), e;
})(nx), DL = (function(r) {
  function e() {
    return r !== null && r.apply(this, arguments) || this;
  }
  return nr(e, r), e.prototype.render = function(t) {
    return Promise.resolve();
  }, e.prototype.getBoundingBoxCore = function(t) {
    return [0, 0, 0, 0];
  }, e.prototype.computeNodeTransformCore = function(t) {
    return t.pdf.unitMatrix;
  }, e.prototype.isVisible = function(t, A) {
    return ss(this, t, A);
  }, e;
})(lv), GL = (function(r) {
  function e() {
    return r !== null && r.apply(this, arguments) || this;
  }
  return nr(e, r), e.prototype.apply = function(t) {
    return lr(this, void 0, void 0, (function() {
      var A, n, i, s, a, o;
      return ur(this, (function(l) {
        switch (l.label) {
          case 0:
            A = this.computeNodeTransform(t), n = this.getBoundingBox(t), t.pdf.beginFormObject(n[0], n[1], n[2], n[3], A), i = _o.getContextColors(t), (function(u) {
              var h = u.attributeState, f = u.pdf, c = 1, p = 1;
              c *= h.fillOpacity, c *= h.opacity, h.fill instanceof EA && h.fill.color.a !== void 0 && (c *= h.fill.color.a), p *= h.strokeOpacity, p *= h.opacity, h.stroke instanceof EA && h.stroke.color.a !== void 0 && (p *= h.stroke.color.a);
              var g, v = {};
              if (v.opacity = c, v["stroke-opacity"] = p, f.setGState(new Ta(v)), h.fill && h.fill instanceof EA && h.fill.color.ok ? f.setFillColor(h.fill.color.r, h.fill.color.g, h.fill.color.b) : f.setFillColor(0, 0, 0), f.setLineWidth(h.strokeWidth), h.stroke instanceof EA ? f.setDrawColor(h.stroke.color.r, h.stroke.color.g, h.stroke.color.b) : f.setDrawColor(0, 0, 0), f.setLineCap(h.strokeLinecap), f.setLineJoin(h.strokeLinejoin), h.strokeDasharray ? f.setLineDashPattern(h.strokeDasharray, h.strokeDashoffset) : f.setLineDashPattern([], 0), f.setLineMiterLimit(h.strokeMiterlimit), g = Ji.hasOwnProperty(h.fontFamily) ? Ji[h.fontFamily] : h.fontFamily, h.fill && h.fill instanceof EA && h.fill.color.ok) {
                var w = h.fill.color;
                f.setTextColor(w.r, w.g, w.b);
              } else f.setTextColor(0, 0, 0);
              var B = "";
              h.fontWeight === "bold" && (B = "bold"), h.fontStyle === "italic" && (B += "italic"), B === "" && (B = "normal"), g !== void 0 || B !== void 0 ? (g === void 0 && (g = Ji.hasOwnProperty(h.fontFamily) ? Ji[h.fontFamily] : h.fontFamily), f.setFont(g, B)) : f.setFont("helvetica", B), f.setFontSize(h.fontSize * f.internal.scaleFactor);
            })(s = new js(t.pdf, { refsHandler: t.refsHandler, styleSheets: t.styleSheets, viewport: t.viewport, svg2pdfParameters: t.svg2pdfParameters, textMeasure: t.textMeasure, attributeState: Object.assign(_o.default(), i) })), a = 0, o = this.children, l.label = 1;
          case 1:
            return a < o.length ? [4, o[a].render(s)] : [3, 4];
          case 2:
            l.sent(), l.label = 3;
          case 3:
            return a++, [3, 1];
          case 4:
            return t.pdf.endFormObject(s.refsHandler.generateKey(this.element.getAttribute("id"), i)), [2];
        }
      }));
    }));
  }, e.prototype.getBoundingBoxCore = function(t) {
    var A, n = this.element.getAttribute("viewBox");
    return n && (A = Tn(n)), [A && A[0] || 0, A && A[1] || 0, A && A[2] || parseFloat(this.element.getAttribute("markerWidth") || "3"), A && A[3] || parseFloat(this.element.getAttribute("markerHeight") || "3")];
  }, e.prototype.computeNodeTransformCore = function(t) {
    var A, n = parseFloat(this.element.getAttribute("refX") || "0"), i = parseFloat(this.element.getAttribute("refY") || "0"), s = this.element.getAttribute("viewBox");
    if (s) {
      var a = Tn(s);
      A = hu(this.element, a, 0, 0, parseFloat(this.element.getAttribute("markerWidth") || "3"), parseFloat(this.element.getAttribute("markerHeight") || "3"), t, !0), A = t.pdf.matrixMult(t.pdf.Matrix(1, 0, 0, 1, -n, -i), A);
    } else A = t.pdf.Matrix(1, 0, 0, 1, -n, -i);
    return A;
  }, e.prototype.isVisible = function(t, A) {
    return qs(this, t, A);
  }, e;
})(fu), VL = (function(r) {
  function e(t, A) {
    return r.call(this, t, A) || this;
  }
  return nr(e, r), e.prototype.getR = function(t) {
    var A;
    return (A = this.r) !== null && A !== void 0 ? A : this.r = parseFloat(Le(this.element, t.styleSheets, "r") || "0");
  }, e.prototype.getRx = function(t) {
    return this.getR(t);
  }, e.prototype.getRy = function(t) {
    return this.getR(t);
  }, e;
})(rx), KL = (function(r) {
  function e(t, A) {
    return r.call(this, !1, t, A) || this;
  }
  return nr(e, r), e;
})(nx), ix = (function(r) {
  function e() {
    return r !== null && r.apply(this, arguments) || this;
  }
  return nr(e, r), e.prototype.renderCore = function(t) {
    return lr(this, void 0, void 0, (function() {
      var A, n;
      return ur(this, (function(i) {
        switch (i.label) {
          case 0:
            A = 0, n = this.children, i.label = 1;
          case 1:
            return A < n.length ? [4, n[A].render(t)] : [3, 4];
          case 2:
            i.sent(), i.label = 3;
          case 3:
            return A++, [3, 1];
          case 4:
            return [2];
        }
      }));
    }));
  }, e.prototype.getBoundingBoxCore = function(t) {
    return ov(t, this);
  }, e;
})(ex), jL = (function(r) {
  function e() {
    return r !== null && r.apply(this, arguments) || this;
  }
  return nr(e, r), e.prototype.isVisible = function(t, A) {
    return qs(this, t, A);
  }, e.prototype.render = function(t) {
    return lr(this, void 0, void 0, (function() {
      var A, n, i, s, a;
      return ur(this, (function(o) {
        switch (o.label) {
          case 0:
            return this.isVisible(t.attributeState.visibility !== "hidden", t) ? (A = this.getX(t), n = this.getY(t), i = this.getWidth(t), s = this.getHeight(t), t.pdf.saveGraphicsState(), a = t.transform, this.element.hasAttribute("transform") && (a = t.pdf.matrixMult(Th(this.element.getAttribute("transform"), t), a)), t.pdf.setCurrentTransformationMatrix(a), t.withinUse || Le(this.element, t.styleSheets, "overflow") === "visible" || t.pdf.rect(A, n, i, s).clip().discardPath(), [4, r.prototype.render.call(this, t.clone({ transform: t.pdf.unitMatrix, viewport: t.withinUse ? t.viewport : new Oh(i, s) }))]) : [2];
          case 1:
            return o.sent(), t.pdf.restoreGraphicsState(), [2];
        }
      }));
    }));
  }, e.prototype.computeNodeTransform = function(t) {
    return this.computeNodeTransformCore(t);
  }, e.prototype.computeNodeTransformCore = function(t) {
    if (t.withinUse) return t.pdf.unitMatrix;
    var A, n = this.getX(t), i = this.getY(t), s = this.getViewBox();
    if (s) {
      var a = this.getWidth(t), o = this.getHeight(t);
      A = hu(this.element, s, n, i, a, o, t);
    } else A = t.pdf.Matrix(1, 0, 0, 1, n, i);
    return A;
  }, e.prototype.getWidth = function(t) {
    if (this.width !== void 0) return this.width;
    var A, n, i = t.svg2pdfParameters;
    if (this.isOutermostSvg(t)) if (i.width != null) A = i.width;
    else if (n = Le(this.element, t.styleSheets, "width")) A = parseFloat(n);
    else {
      var s = this.getViewBox();
      if (s && (i.height != null || Le(this.element, t.styleSheets, "height"))) {
        var a = s[2] / s[3];
        A = this.getHeight(t) * a;
      } else A = Math.min(300, t.viewport.width, 2 * t.viewport.height);
    }
    else A = (n = Le(this.element, t.styleSheets, "width")) ? parseFloat(n) : t.viewport.width;
    return this.width = A;
  }, e.prototype.getHeight = function(t) {
    if (this.height !== void 0) return this.height;
    var A, n, i = t.svg2pdfParameters;
    if (this.isOutermostSvg(t)) if (i.height != null) A = i.height;
    else if (n = Le(this.element, t.styleSheets, "height")) A = parseFloat(n);
    else {
      var s = this.getViewBox();
      if (s) {
        var a = s[2] / s[3];
        A = this.getWidth(t) / a;
      } else A = Math.min(150, t.viewport.width / 2, t.viewport.height);
    }
    else A = (n = Le(this.element, t.styleSheets, "height")) ? parseFloat(n) : t.viewport.height;
    return this.height = A;
  }, e.prototype.getX = function(t) {
    if (this.x !== void 0) return this.x;
    if (this.isOutermostSvg(t)) return this.x = 0;
    var A = Le(this.element, t.styleSheets, "x");
    return this.x = A ? parseFloat(A) : 0;
  }, e.prototype.getY = function(t) {
    if (this.y !== void 0) return this.y;
    if (this.isOutermostSvg(t)) return this.y = 0;
    var A = Le(this.element, t.styleSheets, "y");
    return this.y = A ? parseFloat(A) : 0;
  }, e.prototype.getViewBox = function() {
    if (this.viewBox !== void 0) return this.viewBox;
    var t = this.element.getAttribute("viewBox");
    return this.viewBox = t ? Tn(t) : void 0;
  }, e.prototype.isOutermostSvg = function(t) {
    return t.svg2pdfParameters.element === this.element;
  }, e;
})(ix), sx = (function(r) {
  function e() {
    return r !== null && r.apply(this, arguments) || this;
  }
  return nr(e, r), e.prototype.isVisible = function(t, A) {
    return qs(this, t, A);
  }, e.prototype.computeNodeTransformCore = function(t) {
    return t.pdf.unitMatrix;
  }, e;
})(ix), qL = (function(r) {
  function e() {
    return r !== null && r.apply(this, arguments) || this;
  }
  return nr(e, r), e.prototype.renderCore = function(t) {
    return lr(this, void 0, void 0, (function() {
      var A, n, i, s;
      return ur(this, (function(a) {
        switch (a.label) {
          case 0:
            return [4, r.prototype.renderCore.call(this, t)];
          case 1:
            return a.sent(), (A = Le(this.element, t.styleSheets, "href")) && (n = this.getBoundingBox(t), i = t.pdf.internal.scaleFactor, s = t.pdf.internal.pageSize.getHeight(), t.pdf.link(i * (n[0] * t.transform.sx + t.transform.tx), s - i * (n[1] * t.transform.sy + t.transform.ty), i * n[2], i * n[3], { url: A })), [2];
        }
      }));
    }));
  }, e;
})(sx), zL = (function(r) {
  function e() {
    return r !== null && r.apply(this, arguments) || this;
  }
  return nr(e, r), e.prototype.apply = function(t) {
    return lr(this, void 0, void 0, (function() {
      var A, n, i, s, a;
      return ur(this, (function(o) {
        switch (o.label) {
          case 0:
            if (!this.isVisible(!0, t)) return [2];
            A = t.pdf.matrixMult(this.computeNodeTransform(t), t.transform), t.pdf.setCurrentTransformationMatrix(A), n = 0, i = this.children, o.label = 1;
          case 1:
            return n < i.length ? [4, i[n].render(new js(t.pdf, { refsHandler: t.refsHandler, styleSheets: t.styleSheets, viewport: t.viewport, withinClipPath: !0, svg2pdfParameters: t.svg2pdfParameters, textMeasure: t.textMeasure }))] : [3, 4];
          case 2:
            o.sent(), o.label = 3;
          case 3:
            return n++, [3, 1];
          case 4:
            return s = this.children.length > 0 && !!Le(this.children[0].element, t.styleSheets, "clip-rule"), a = s ? this.getClipRuleAttr(this.children[0].element, t.styleSheets) : this.getClipRuleAttr(this.element, t.styleSheets), t.pdf.clip(a).discardPath(), t.pdf.setCurrentTransformationMatrix(A.inversed()), [2];
        }
      }));
    }));
  }, e.prototype.getBoundingBoxCore = function(t) {
    return ov(t, this);
  }, e.prototype.isVisible = function(t, A) {
    return qs(this, t, A);
  }, e.prototype.getClipRuleAttr = function(t, A) {
    return Le(t, A, "clip-rule") === "evenodd" ? "evenodd" : void 0;
  }, e;
})(fu);
function hv(r, e) {
  var t, A = [];
  switch ((function(i, s) {
    for (var a = [], o = 0; o < i.childNodes.length; o++) {
      var l = i.childNodes[o];
      l.nodeName.charAt(0) !== "#" && a.push(l);
    }
    for (o = 0; o < a.length; o++) s(o, a[o]);
  })(r, (function(i, s) {
    return A.push(hv(s, e));
  })), r.tagName.toLowerCase()) {
    case "a":
      t = new qL(r, A);
      break;
    case "g":
      t = new sx(r, A);
      break;
    case "circle":
      t = new VL(r, A);
      break;
    case "clippath":
      t = new zL(r, A);
      break;
    case "ellipse":
      t = new PL(r, A);
      break;
    case "lineargradient":
      t = new X5(r, A);
      break;
    case "image":
      t = new kL(r, A);
      break;
    case "line":
      t = new LL(r, A);
      break;
    case "marker":
      t = new GL(r, A);
      break;
    case "path":
      t = new ML(r, A);
      break;
    case "pattern":
      t = new J5(r, A);
      break;
    case "polygon":
      t = new HL(r, A);
      break;
    case "polyline":
      t = new KL(r, A);
      break;
    case "radialgradient":
      t = new Y5(r, A);
      break;
    case "rect":
      t = new TL(r, A);
      break;
    case "svg":
      t = new jL(r, A);
      break;
    case "symbol":
      t = new tx(r, A);
      break;
    case "text":
      t = new OL(r, A);
      break;
    case "use":
      t = new NL(r, A);
      break;
    default:
      t = new DL(r, A);
  }
  if (e != null && t.element.hasAttribute("id")) {
    var n = V5(t.element.id, { isIdentifier: !0 });
    e[n] = e[n] || t;
  }
  return t.children.forEach((function(i) {
    return i.setParent(t);
  })), t;
}
var WL = (function() {
  function r(e, t) {
    this.rootSvg = e, this.loadExternalSheets = t, this.styleSheets = [];
  }
  return r.prototype.load = function() {
    return lr(this, void 0, void 0, (function() {
      var e;
      return ur(this, (function(t) {
        switch (t.label) {
          case 0:
            return [4, this.collectStyleSheetTexts()];
          case 1:
            return e = t.sent(), this.parseCssSheets(e), [2];
        }
      }));
    }));
  }, r.prototype.collectStyleSheetTexts = function() {
    return lr(this, void 0, void 0, (function() {
      var e, t, A, n, i;
      return ur(this, (function(s) {
        switch (s.label) {
          case 0:
            if (e = [], this.loadExternalSheets && this.rootSvg.ownerDocument) for (n = 0; n < this.rootSvg.ownerDocument.childNodes.length; n++) (t = this.rootSvg.ownerDocument.childNodes[n]).nodeName === "xml-stylesheet" && typeof t.data == "string" && e.push(r.loadSheet(t.data.match(/href=["'].*?["']/)[0].split("=")[1].slice(1, -1)));
            for (A = this.rootSvg.querySelectorAll("style,link"), n = 0; n < A.length; n++) Hs(i = A[n], "style") ? e.push(i.textContent) : this.loadExternalSheets && Hs(i, "link") && i.getAttribute("rel") === "stylesheet" && i.hasAttribute("href") && e.push(r.loadSheet(i.getAttribute("href")));
            return [4, Promise.all(e)];
          case 1:
            return [2, s.sent().filter((function(a) {
              return a !== null;
            }))];
        }
      }));
    }));
  }, r.prototype.parseCssSheets = function(e) {
    for (var t = document.implementation.createHTMLDocument(""), A = 0, n = e; A < n.length; A++) {
      var i = n[A], s = t.createElement("style");
      s.textContent = i, t.body.appendChild(s);
      var a = s.sheet;
      if (a instanceof CSSStyleSheet) {
        for (var o = a.cssRules.length - 1; o >= 0; o--) {
          var l = a.cssRules[o];
          if (l instanceof CSSStyleRule) {
            var u = l;
            if (u.selectorText.indexOf(",") >= 0) {
              a.deleteRule(o);
              for (var h = u.cssText.substring(u.selectorText.length), f = r.splitSelectorAtCommas(u.selectorText), c = 0; c < f.length; c++) a.insertRule(f[c] + h, o + c);
            }
          } else a.deleteRule(o);
        }
        this.styleSheets.push(a);
      }
    }
  }, r.splitSelectorAtCommas = function(e) {
    for (var t, A = /,|["']/g, n = /[^\\]["]/g, i = /[^\\][']/g, s = [], a = "initial", o = -1, l = n, u = 0; u < e.length; ) switch (a) {
      case "initial":
        A.lastIndex = u, (t = A.exec(e)) ? (t[0] === "," ? (s.push(e.substring(o + 1, A.lastIndex - 1).trim()), o = A.lastIndex - 1) : (a = "withinQuotes", l = t[0] === '"' ? n : i), u = A.lastIndex) : (s.push(e.substring(o + 1).trim()), u = e.length);
        break;
      case "withinQuotes":
        l.lastIndex = u, (t = l.exec(e)) && (u = l.lastIndex, a = "initial");
    }
    return s;
  }, r.loadSheet = function(e) {
    return new Promise((function(t, A) {
      var n = new XMLHttpRequest();
      n.open("GET", e, !0), n.responseType = "text", n.onload = function() {
        n.status !== 200 && A(new Error("Error ".concat(n.status, ": Failed to load '").concat(e, "'"))), t(n.responseText);
      }, n.onerror = A, n.onabort = A, n.send(null);
    })).catch((function() {
      return null;
    }));
  }, r.prototype.getPropertyValue = function(e, t) {
    for (var A = [], n = 0, i = this.styleSheets; n < i.length; n++) for (var s = i[n], a = 0; a < s.cssRules.length; a++) {
      var o = s.cssRules[a];
      o.style.getPropertyValue(t) && e.matches(o.selectorText) && A.push(o);
    }
    if (A.length !== 0)
      return A.reduce((function(l, u) {
        return f = u, ((c = (h = l).style.getPropertyPriority(t)) !== f.style.getPropertyPriority(t) ? c === "important" ? 1 : -1 : xL(h.selectorText, f.selectorText)) === 1 ? l : u;
        var h, f, c;
      })).style.getPropertyValue(t) || void 0;
  }, r;
})(), XL = (function() {
  function r() {
    this.measureMethods = {};
  }
  return r.prototype.getTextOffset = function(e, t) {
    var A = t.textAnchor;
    if (A === "start") return 0;
    var n = this.measureTextWidth(e, t), i = 0;
    switch (A) {
      case "end":
        i = n;
        break;
      case "middle":
        i = n / 2;
    }
    return i;
  }, r.prototype.measureTextWidth = function(e, t) {
    if (e.length === 0) return 0;
    var A = t.fontFamily;
    return this.getMeasureFunction(A).call(this, e, t.fontFamily, t.fontSize + "px", t.fontStyle, t.fontWeight);
  }, r.prototype.getMeasurementTextNode = function() {
    if (!this.textMeasuringTextElement) {
      this.textMeasuringTextElement = document.createElementNS(dy, "text");
      var e = document.createElementNS(dy, "svg");
      e.appendChild(this.textMeasuringTextElement), e.style.setProperty("position", "absolute"), e.style.setProperty("visibility", "hidden"), document.body.appendChild(e);
    }
    return this.textMeasuringTextElement;
  }, r.prototype.canvasTextMeasure = function(e, t, A, n, i) {
    var s = document.createElement("canvas").getContext("2d");
    return s != null ? (s.font = [n, i, A, t].join(" "), s.measureText(e).width) : 0;
  }, r.prototype.svgTextMeasure = function(e, t, A, n, i, s) {
    s === void 0 && (s = this.getMeasurementTextNode());
    var a = s;
    return a.setAttribute("font-family", t), a.setAttribute("font-size", A), a.setAttribute("font-style", n), a.setAttribute("font-weight", i), a.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"), a.textContent = e, a.getBBox().width;
  }, r.prototype.getMeasureFunction = function(e) {
    var t = this.measureMethods[e];
    if (!t) {
      var A = "16px", n = "normal", i = "normal", s = this.canvasTextMeasure(r.testString, e, A, n, i), a = this.svgTextMeasure(r.testString, e, A, n, i);
      t = Math.abs(s - a) < r.epsilon ? this.canvasTextMeasure : this.svgTextMeasure, this.measureMethods[e] = t;
    }
    return t;
  }, r.prototype.cleanupTextMeasuring = function() {
    if (this.textMeasuringTextElement) {
      var e = this.textMeasuringTextElement.parentNode;
      e && document.body.removeChild(e), this.textMeasuringTextElement = void 0;
    }
  }, r.testString = `abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ 0123456789!"$%&/()=?'\\+*-_.:,;^}][{#~|<>`, r.epsilon = 0.1, r;
})();
function YL(r, e) {
  return lr(this, arguments, void 0, (function(t, A, n) {
    var i, s, a, o, l, u, h, f, c, p, g, v, w, B;
    return n === void 0 && (n = {}), ur(this, (function(S) {
      switch (S.label) {
        case 0:
          return i = (v = n.x) !== null && v !== void 0 ? v : 0, s = (w = n.y) !== null && w !== void 0 ? w : 0, a = (B = n.loadExternalStyleSheets) !== null && B !== void 0 && B, l = new j5(o = {}), [4, (u = new WL(t, a)).load()];
        case 1:
          return S.sent(), h = new Oh(A.internal.pageSize.getWidth(), A.internal.pageSize.getHeight()), f = mh(mh({}, n), { element: t }), c = new XL(), p = new js(A, { refsHandler: l, styleSheets: u, viewport: h, svg2pdfParameters: f, textMeasure: c }), A.advancedAPI(), A.saveGraphicsState(), A.setCurrentTransformationMatrix(A.Matrix(1, 0, 0, 1, i, s)), A.setLineWidth(p.attributeState.strokeWidth), g = p.attributeState.fill.color, A.setFillColor(g.r, g.g, g.b), A.setFont(p.attributeState.fontFamily), A.setFontSize(p.attributeState.fontSize * A.internal.scaleFactor), [4, hv(t, o).render(p)];
        case 2:
          return S.sent(), A.restoreGraphicsState(), A.compatAPI(), p.textMeasure.cleanupTextMeasuring(), [2, A];
      }
    }));
  }));
}
ot.API.svg = function(r, e) {
  return e === void 0 && (e = {}), YL(r, this, e);
};
const {
  InsertElementCommand: nm,
  RemoveElementCommand: JL,
  ChangeElementCommand: $L,
  BatchCommand: ax
} = Pa;
let we = null;
const ZL = (r) => {
  we = r, we.setSvgString = rN, we.importSvgString = AN, we.uniquifyElems = aN, we.setUseData = oN, we.convertGradients = uN, we.removeUnusedDefElems = lN, we.svgCanvasToString = eN, we.svgToString = tN, we.embedImage = nN, we.rasterExport = iN, we.exportPDF = sN;
}, eN = () => {
  for (; we.removeUnusedDefElems() > 0; )
    ;
  we.pathActions.clear(!0), we.getSvgContent().childNodes.forEach((n, i) => {
    i && n.nodeType === 8 && n.data.includes("Created with") && we.getSvgContent().firstChild.before(n);
  }), we.getCurrentGroup() && (Vs(), we.selectOnly([we.getCurrentGroup()]));
  const e = [], t = we.getSvgContent().querySelectorAll("g[data-gsvg]");
  Array.prototype.forEach.call(t, (n) => {
    const i = n.attributes;
    let s = i.length;
    for (let a = 0; a < s; a++)
      (i[a].nodeName === "id" || i[a].nodeName === "style") && s--;
    if (s <= 0) {
      const a = n.firstChild;
      e.push(a), n.replaceWith(a);
    }
  });
  const A = we.svgToString(we.getSvgContent(), 0);
  return e.length && Array.prototype.forEach.call(e, (n) => {
    we.groupSvgElem(n);
  }), A;
}, tN = (r, e) => {
  const t = we.getCurConfig(), A = we.getNsMap(), n = [], i = t.baseUnit, s = new RegExp("^-?[\\d\\.]+" + i + "$");
  if (r) {
    Ih(r);
    const a = [...r.attributes], o = r.childNodes;
    a.sort((l, u) => l.name > u.name ? -1 : 1);
    for (let l = 0; l < e; l++)
      n.push(" ");
    if (n.push("<"), n.push(r.localName), r.id === "svgcontent") {
      const l = we.getResolution();
      let u = "";
      t.dynamicOutput ? (u = r.getAttribute("viewBox"), n.push(' viewBox="' + u + '" xmlns="' + nt.SVG + '"')) : (i !== "px" && (l.w = ch(l.w, i) + i, l.h = ch(l.h, i) + i), n.push(
        ' width="' + l.w + '" height="' + l.h + '" xmlns="' + nt.SVG + '"'
      ));
      const h = {}, f = r.querySelectorAll("*"), c = Array.prototype.slice.call(f);
      c.push(r), Array.prototype.forEach.call(c, (v) => {
        const w = v.namespaceURI;
        if (w && !h[w] && A[w] && A[w] !== "xmlns" && A[w] !== "xml" && (h[w] = !0, n.push(" xmlns:" + A[w] + '="' + w + '"')), v.attributes.length > 0)
          for (const [, B] of Object.entries(v.attributes)) {
            const S = B.namespaceURI;
            S && !h[S] && A[S] !== "xmlns" && A[S] !== "xml" && (h[S] = !0, n.push(" xmlns:" + A[S] + '="' + S + '"'));
          }
      });
      let p = a.length;
      const g = [
        "width",
        "height",
        "xmlns",
        "x",
        "y",
        "viewBox",
        "id",
        "overflow"
      ];
      for (; p--; ) {
        const v = a[p], w = Tl(v.value);
        v.nodeName.startsWith("xmlns:") || w !== "" && !g.includes(v.localName) && (!v.namespaceURI || A[v.namespaceURI]) && (n.push(" "), n.push(v.nodeName), n.push('="'), n.push(w), n.push('"'));
      }
    } else {
      if (r.nodeName === "defs" && !r.firstChild)
        return "";
      const l = ["-moz-math-font-style", "_moz-math-font-style"];
      for (let u = a.length - 1; u >= 0; u--) {
        const h = a[u];
        let f = Tl(h.value);
        if (!l.includes(h.localName)) {
          if (f === "null") {
            const c = h.localName.replace(
              /-[a-z]/g,
              (p) => p[1].toUpperCase()
            );
            if (Object.prototype.hasOwnProperty.call(r.style, c))
              continue;
          }
          if (f !== "") {
            if (f.startsWith("pointer-events") || h.localName === "class" && f.startsWith("se_"))
              continue;
            if (n.push(" "), h.localName === "d" && (f = we.pathActions.convertPath(r, !0)), isNaN(f) ? s.test(f) && (f = yn(f) + i) : f = yn(f), we.getSvgOptionApply() && r.nodeName === "image" && h.localName === "href" && we.getSvgOptionImages() && we.getSvgOptionImages() === "embed") {
              const c = we.getEncodableImages(f);
              c && (f = c);
            }
            (!h.namespaceURI || h.namespaceURI === nt.SVG || A[h.namespaceURI]) && (n.push(h.nodeName), n.push('="'), n.push(f), n.push('"'));
          }
        }
      }
    }
    if (r.hasChildNodes()) {
      n.push(">"), e++;
      let l = !1;
      for (let u = 0; u < o.length; u++) {
        const h = o.item(u);
        switch (h.nodeType) {
          case 1:
            n.push(`
`), n.push(we.svgToString(h, e));
            break;
          case 3: {
            const f = h.nodeValue.replace(/^\s+|\s+$/g, "");
            f !== "" && (l = !0, n.push(String(Tl(f))));
            break;
          }
          case 4:
            n.push(`
`), n.push(new Array(e + 1).join(" ")), n.push("<![CDATA["), n.push(h.nodeValue), n.push("]]>");
            break;
          case 8:
            n.push(`
`), n.push(new Array(e + 1).join(" ")), n.push("<!--"), n.push(h.data), n.push("-->");
            break;
        }
      }
      if (e--, !l) {
        n.push(`
`);
        for (let u = 0; u < e; u++)
          n.push(" ");
      }
      n.push("</"), n.push(r.localName), n.push(">");
    } else
      n.push("/>");
  }
  return n.join("");
}, rN = (r, e) => {
  const t = we.getCurConfig(), A = we.getDataStorage();
  try {
    const n = jm(r);
    if (n.firstElementChild && n.firstElementChild.namespaceURI !== nt.SVG)
      return !1;
    we.prepareSvg(n);
    const i = new ax("Change Source"), { nextSibling: s } = we.getSvgContent();
    we.getSvgContent().remove();
    const a = we.getSvgContent();
    i.addSubCommand(
      new JL(a, s, we.getSvgRoot())
    ), we.getDOMDocument().adoptNode ? we.setSvgContent(
      we.getDOMDocument().adoptNode(n.documentElement)
    ) : we.setSvgContent(
      we.getDOMDocument().importNode(n.documentElement, !0)
    ), we.getSvgRoot().append(we.getSvgContent());
    const o = we.getSvgContent();
    we.current_drawing_ = new D0(
      we.getSvgContent(),
      we.getIdPrefix()
    );
    const l = we.getCurrentDrawing().getNonce();
    l ? we.call("setnonce", l) : we.call("unsetnonce");
    const u = o.querySelectorAll("image");
    Array.prototype.forEach.call(u, (E) => {
      qm(E);
      const _ = we.getHref(E);
      if (_) {
        if (_.startsWith("data:")) {
          const I = _.match(/svgedit_url=(.*?);/);
          if (I) {
            const O = decodeURIComponent(I[1]), U = new Image();
            U.addEventListener("load", () => {
              Rn(E, _);
            }), U.src = O;
          }
        }
        we.embedImage(_);
      }
    });
    const h = o.querySelectorAll("[id]"), f = {}, c = h.length;
    for (let E = 0; E < c; E++) {
      const _ = h[E].id ? h[E].id : "undefined";
      isNaN(f[_]) && (f[_] = 0), f[_]++;
    }
    Object.entries(f).forEach(([E, _]) => {
      if (_ > 1) {
        const I = o.querySelectorAll('[id="' + E + '"]');
        for (let O = 1; O < I.length; O++)
          I[O].setAttribute("id", we.getNextId());
      }
    });
    const p = o.querySelectorAll("svg");
    if (Array.prototype.forEach.call(p, (E) => {
      if (Au(E.parentNode, "defs"))
        return;
      we.uniquifyElems(E);
      const _ = E.parentNode;
      _.childNodes.length === 1 && _.nodeName === "g" ? (A.put(_, "gsvg", E), _.id = _.id || we.getNextId()) : we.groupSvgElem(E);
    }), Sa()) {
      const E = Cn(), _ = o.querySelectorAll(
        "linearGradient, radialGradient, pattern"
      );
      Array.prototype.forEach.call(_, (I) => {
        E.appendChild(I);
      });
    }
    we.setUseData(o), we.convertGradients(o);
    const g = {
      id: "svgcontent",
      overflow: t.show_outside_canvas ? "visible" : "hidden"
    };
    let v = !1;
    if (o.getAttribute("viewBox")) {
      const _ = o.getAttribute("viewBox").split(/[ ,]+/);
      g.width = _[2], g.height = _[3];
    } else
      ["width", "height"].forEach((E) => {
        const _ = o.getAttribute(E) || "100%";
        String(_).substr(-1) === "%" ? v = !0 : g[E] = xA(E, _);
      });
    Rl();
    const w = o.children;
    if (Array.prototype.forEach.call(w, (E) => {
      const _ = E.querySelectorAll(we.getVisElems());
      Array.prototype.forEach.call(_, (I) => {
        I.id || (I.id = we.getNextId());
      });
    }), v) {
      const E = Mn();
      g.width = E.width + E.x, g.height = E.height + E.y;
    }
    g.width <= 0 && (g.width = 100), g.height <= 0 && (g.height = 100);
    for (const [E, _] of Object.entries(g))
      o.setAttribute(E, _);
    we.contentW = g.width, we.contentH = g.height, i.addSubCommand(new nm(we.getSvgContent()));
    const B = o.getAttribute("width"), S = o.getAttribute("height"), C = { width: B, height: S };
    i.addSubCommand(
      new $L(we.getSvgRoot(), C)
    ), we.setZoom(1), we.clearSelection(), DS(), we.getSvgRoot().append(we.selectorManager.selectorParentGroup), e || we.addCommandToHistory(i), we.call("sourcechanged", [we.getSvgContent()]);
  } catch (n) {
    return console.error(n), !1;
  }
  return !0;
}, AN = (r, e) => {
  const t = we.getDataStorage();
  let A, n, i;
  try {
    const s = N4(r);
    let a = !1;
    we.getImportIds(s) && we.getImportIds(s).symbol && nu(we.getImportIds(s).symbol, "#svgroot")?.length && (a = !0);
    const o = new ax("Import Image");
    let l;
    if (a)
      l = we.getImportIds(s).symbol, n = we.getImportIds(s).xform;
    else {
      const u = jm(r);
      we.prepareSvg(u);
      const h = we.getDOMDocument().adoptNode ? we.getDOMDocument().adoptNode(u.documentElement) : we.getDOMDocument().importNode(u.documentElement, !0);
      we.uniquifyElems(h);
      const f = xA("width", h.getAttribute("width")), c = xA("height", h.getAttribute("height")), p = h.getAttribute("viewBox"), g = p ? p.split(/[ ,]+/) : [0, 0, f, c];
      for (A = 0; A < 4; ++A)
        g[A] = Number(g[A]);
      const v = Number(we.getSvgContent().getAttribute("height"));
      n = c > f ? "scale(" + v / 3 / g[3] + ")" : "scale(" + v / 3 / g[2] + ")", n = "translate(0) " + n + " translate(0)", l = we.getDOMDocument().createElementNS(nt.SVG, "symbol");
      const w = Cn();
      if (Sa()) {
        const S = h.querySelectorAll(
          "linearGradient, radialGradient, pattern"
        );
        Array.prototype.forEach.call(S, (C) => {
          w.appendChild(C);
        });
      }
      for (; h.firstChild; ) {
        const S = h.firstChild;
        l.append(S);
      }
      const B = h.attributes;
      for (const S of B)
        l.setAttribute(S.nodeName, S.value);
      l.id = we.getNextId(), we.setImportIds(s, {
        symbol: l,
        xform: n
      }), Cn().append(l), o.addSubCommand(new nm(l));
    }
    i = we.getDOMDocument().createElementNS(nt.SVG, "use"), i.id = we.getNextId(), we.setHref(i, "#" + l.id), (we.getCurrentGroup() || we.getCurrentDrawing().getCurrentLayer()).append(i), o.addSubCommand(new nm(i)), we.clearSelection(), e || (i.setAttribute("transform", n), Qa(i)), t.put(i, "symbol", l), t.put(i, "ref", l), we.addToSelection([i]), we.addCommandToHistory(o), we.call("changed", [we.getSvgContent()]);
  } catch (s) {
    return console.error(s), null;
  }
  return i;
}, nN = (r) => new Promise((e, t) => {
  const A = new Image();
  A.addEventListener("load", (n) => {
    const i = document.createElement("canvas");
    i.width = n.currentTarget.width, i.height = n.currentTarget.height, i.getContext("2d").drawImage(n.currentTarget, 0, 0);
    try {
      let s = ";svgedit_url=" + encodeURIComponent(r);
      s = i.toDataURL().replace(";base64", s + ";base64"), we.setEncodableImages(r, s);
    } catch {
      we.setEncodableImages(r, !1);
    }
    we.setGoodImage(r), e(we.getEncodableImages(r));
  }), A.addEventListener("error", (n) => {
    t(
      new Error(
        `error loading image: ${n.currentTarget.attributes.src.value}`
      )
    );
  }), A.setAttribute("src", r);
}), ox = () => {
  const r = we.getUIStrings();
  we.clearSelection();
  const e = [], t = [], A = {
    feGaussianBlur: r.NoBlur,
    foreignObject: r.NoforeignObject,
    "[stroke-dasharray]": r.NoDashArray
  }, n = we.getSvgContent();
  "font" in document.querySelector("CANVAS").getContext("2d") || (A.text = r.NoText);
  for (const [i, s] of Object.entries(A))
    n.querySelectorAll(i).length && (t.push(i), e.push(s));
  return { issues: e, issueCodes: t };
}, lx = async (r) => {
  const e = r.querySelectorAll("image"), t = Array.from(e).map(async (A) => {
    const n = A.getAttribute("xlink:href") || A.getAttribute("href");
    if (n && !n.startsWith("data:"))
      try {
        const s = await (await fetch(n)).blob(), a = new FileReader();
        return new Promise((o) => {
          a.onload = () => {
            Rn(A, a.result), o();
          }, a.readAsDataURL(s);
        });
      } catch (i) {
        console.error("Failed to fetch image:", i);
      }
  });
  await Promise.all(t);
}, iN = (r = "PNG", e = 1, t = "Exported Image", A = {}) => new Promise((n, i) => {
  const a = `image/${(r === "ICO" ? "BMP" : r).toLowerCase()}`, { issues: o, issueCodes: l } = ox(), u = we.getSvgContent(), h = u.cloneNode(!0);
  lx(h).then(() => {
    const f = new XMLSerializer().serializeToString(h), c = new Blob([f], {
      type: "image/svg+xml;charset=utf-8"
    }), p = URL.createObjectURL(c), g = document.createElement("canvas"), v = g.getContext("2d"), w = u.clientWidth || u.getAttribute("width"), B = u.clientHeight || u.getAttribute("height");
    g.width = w, g.height = B;
    const S = new Image();
    S.onload = () => {
      v.drawImage(S, 0, 0, w, B), URL.revokeObjectURL(p);
      const C = g.toDataURL(a, e);
      let E;
      const _ = (I) => {
        const O = {
          datauri: C,
          bloburl: I,
          svg: f,
          issues: o,
          issueCodes: l,
          type: r,
          mimeType: a,
          quality: e,
          windowName: t
        };
        A.avoidEvent || we.call("exported", O), n(O);
      };
      g.toBlob(
        (I) => {
          E = URL.createObjectURL(I), _(E);
        },
        a,
        e
      );
    }, S.onerror = (C) => {
      console.error("Failed to load SVG into image element:", C), i(C);
    }, S.src = p;
  }).catch(i);
}), sN = (r = "svg.pdf", e = T_() ? "save" : "dataurlstring") => new Promise((t, A) => {
  const n = we.getResolution(), i = n.w > n.h ? "landscape" : "portrait", s = "pt", a = we.getSvgContent().cloneNode(!0);
  lx(a).then(() => {
    const o = new XMLSerializer().serializeToString(a), l = new Blob([o], {
      type: "image/svg+xml;charset=utf-8"
    }), u = URL.createObjectURL(l), h = document.createElement("canvas"), f = h.getContext("2d");
    h.width = n.w, h.height = n.h;
    const c = new Image();
    c.onload = () => {
      f.drawImage(c, 0, 0, n.w, n.h), URL.revokeObjectURL(u);
      const p = h.toDataURL("image/png"), g = new ot({ orientation: i, unit: s, format: [n.w, n.h] }), v = we.getDocumentTitle();
      g.setProperties({ title: v }), g.addImage(p, "PNG", 0, 0, n.w, n.h);
      const { issues: w, issueCodes: B } = ox(), S = { issues: w, issueCodes: B, windowName: r, outputType: e };
      S.output = g.output(
        e,
        e === "save" ? r : void 0
      ), we.call("exportedPDF", S), t(S);
    }, c.onerror = (p) => {
      console.error("Failed to load SVG into image element:", p), A(p);
    }, c.src = u;
  }).catch(A);
}), aN = (r) => {
  const e = {}, t = [
    "filter",
    "linearGradient",
    "pattern",
    "radialGradient",
    "symbol",
    "textPath",
    "use"
  ];
  rs(r, (A) => {
    if (A.nodeType === 1) {
      A.id && (A.id in e || (e[A.id] = { elem: null, attrs: [], hrefs: [] }), e[A.id].elem = A), we.getrefAttrs().forEach((i) => {
        const s = A.getAttributeNode(i);
        if (s) {
          const a = we.getUrlFromAttr(s.value), o = a ? a.substr(1) : null;
          o && (o in e || (e[o] = { elem: null, attrs: [], hrefs: [] }), e[o].attrs.push(s));
        }
      });
      const n = we.getHref(A);
      if (n && t.includes(A.nodeName)) {
        const i = n.substr(1);
        i && (i in e || (e[i] = { elem: null, attrs: [], hrefs: [] }), e[i].hrefs.push(A));
      }
    }
  });
  for (const A in e) {
    if (!A)
      continue;
    const { elem: n } = e[A];
    if (n) {
      const i = we.getNextId();
      n.id = i;
      const { attrs: s } = e[A];
      let a = s.length;
      for (; a--; ) {
        const u = s[a];
        u.ownerElement.setAttribute(u.name, "url(#" + i + ")");
      }
      const o = e[A].hrefs;
      let l = o.length;
      for (; l--; ) {
        const u = o[l];
        we.setHref(u, "#" + i);
      }
    }
  }
}, oN = (r) => {
  let e = r;
  r.tagName !== "use" && (e = e.querySelectorAll("use")), Array.prototype.forEach.call(e, (t, A) => {
    const n = we.getDataStorage(), i = we.getHref(t).substr(1), s = we.getElement(i);
    s && (n.put(t, "ref", s), (s.tagName === "symbol" || s.tagName === "svg") && (n.put(t, "symbol", s), n.put(t, "ref", s)));
  });
}, lN = () => {
  const r = we.getSvgContent().getElementsByTagNameNS(nt.SVG, "defs");
  if (!r || !r.length)
    return 0;
  const e = [];
  let t = 0;
  const A = [
    "fill",
    "stroke",
    "filter",
    "marker-start",
    "marker-mid",
    "marker-end"
  ], n = A.length, i = we.getSvgContent().getElementsByTagNameNS(nt.SVG, "*"), s = i.length;
  let a, o;
  for (a = 0; a < s; a++) {
    const l = i[a];
    for (o = 0; o < n; o++) {
      const h = we.getUrlFromAttr(l.getAttribute(A[o]));
      h && e.push(h.substr(1));
    }
    const u = $i(l);
    u && u.startsWith("#") && e.push(u.substr(1));
  }
  return Array.prototype.forEach.call(r, (l, u) => {
    const h = l.querySelectorAll(
      "linearGradient, radialGradient, filter, marker, svg, symbol"
    );
    for (u = h.length; u--; ) {
      const f = h[u], { id: c } = f;
      e.includes(c) || (we.setRemovedElements(c, f), f.remove(), t++);
    }
  }), t;
}, uN = (r) => {
  let e = r.querySelectorAll("linearGradient, radialGradient");
  !e.length && qS() && (e = Array.prototype.filter.call(r.querySelectorAll("*"), (t) => t.tagName.includes("Gradient"))), Array.prototype.forEach.call(e, (t) => {
    if (t.getAttribute("gradientUnits") === "userSpaceOnUse") {
      const A = we.getSvgContent();
      let n = A.querySelectorAll(
        '[fill="url(#' + t.id + ')"],[stroke="url(#' + t.id + ')"]'
      );
      if (!n.length) {
        const s = A.querySelectorAll(
          '[*|href="#' + t.id + '"]'
        );
        if (s.length)
          if ((s[0].tagName === "linearGradient" || s[0].tagName === "radialGradient") && s[0].getAttribute("gradientUnits") === "userSpaceOnUse")
            n = A.querySelectorAll(
              '[fill="url(#' + s[0].id + ')"],[stroke="url(#' + s[0].id + ')"]'
            );
          else
            return;
        else
          return;
      }
      const i = Nr(n[0]);
      if (!i)
        return;
      if (t.tagName === "linearGradient") {
        const s = {
          x1: t.getAttribute("x1"),
          y1: t.getAttribute("y1"),
          x2: t.getAttribute("x2"),
          y2: t.getAttribute("y2")
        }, a = yr(t);
        if (a?.numberOfItems > 0) {
          const o = vr(a).matrix, l = zt(s.x1, s.y1, o), u = zt(s.x2, s.y2, o);
          s.x1 = l.x, s.y1 = l.y, s.x2 = u.x, s.y2 = u.y, t.removeAttribute("gradientTransform");
        }
        t.setAttribute("x1", (s.x1 - i.x) / i.width), t.setAttribute("y1", (s.y1 - i.y) / i.height), t.setAttribute("x2", (s.x2 - i.x) / i.width), t.setAttribute("y2", (s.y2 - i.y) / i.height), t.removeAttribute("gradientUnits");
      }
    }
  });
};
let rA, va;
const vh = window.ontouchstart ? 10 : 4;
class Mh {
  /**
  * @param {Integer} id - Internally identify the selector
  * @param {Element} elem - DOM element associated with this selector
  * @param {module:utilities.BBoxObject} [bbox] - Optional bbox to use for initialization (prevents duplicate `getBBox` call).
  */
  constructor(e, t, A) {
    this.id = e, this.selectedElement = t, this.locked = !0, this.selectorGroup = rA.createSVGElement({
      element: "g",
      attr: { id: "selectorGroup" + this.id }
    }), this.selectorRect = rA.createSVGElement({
      element: "path",
      attr: {
        id: "selectedBox" + this.id,
        fill: "none",
        stroke: "#22C",
        "stroke-width": "1",
        "stroke-dasharray": "5,5",
        // need to specify this so that the rect is not selectable
        style: "pointer-events:none"
      }
    }), this.selectorGroup.append(this.selectorRect), this.gripCoords = {
      nw: null,
      n: null,
      ne: null,
      e: null,
      se: null,
      s: null,
      sw: null,
      w: null
    }, this.reset(this.selectedElement, A);
  }
  /**
  * Used to reset the id and element that the selector is attached to.
  * @param {Element} e - DOM element associated with this selector
  * @param {module:utilities.BBoxObject} bbox - Optional bbox to use for reset (prevents duplicate getBBox call).
  * @returns {void}
  */
  reset(e, t) {
    this.locked = !0, this.selectedElement = e, this.resize(t), this.selectorGroup.setAttribute("display", "inline");
  }
  /**
  * Show the resize grips of this selector.
  * @param {boolean} show - Indicates whether grips should be shown or not
  * @returns {void}
  */
  showGrips(e) {
    const t = e ? "inline" : "none";
    va.selectorGripsGroup.setAttribute("display", t);
    const A = this.selectedElement;
    this.hasGrips = e, A && e && (this.selectorGroup.append(va.selectorGripsGroup), Mh.updateGripCursors(MA(A)));
  }
  /**
  * Updates the selector to match the element's size.
  * @param {module:utilities.BBoxObject} [bbox] - BBox to use for resize (prevents duplicate getBBox call).
  * @returns {void}
  */
  resize(e) {
    const t = rA.getDataStorage(), A = this.selectorRect, n = va, i = n.selectorGrips, s = this.selectedElement, a = rA.getZoom();
    let o = 1 / a;
    const l = s.getAttribute("stroke-width");
    s.getAttribute("stroke") !== "none" && !isNaN(l) && (o += l / 2);
    const { tagName: u } = s;
    u === "text" && (o += 2 / a);
    let f = document.createElementNS(nt.SVG, "svg").createSVGMatrix(), c = s;
    for (; c.parentNode; )
      c.parentNode && c.parentNode.tagName === "g" && c.parentNode.transform && c.parentNode.transform.baseVal.numberOfItems && (f = wn(vr(yr(s.parentNode)).matrix, f)), c = c.parentNode;
    const p = yr(s), g = f ? wn(f, vr(p).matrix) : vr(p).matrix;
    if (g.e *= a, g.f *= a, e || (e = Nr(s)), u === "g" && !t.has(s, "gsvg")) {
      const v = BS([s.childNodes]);
      v && (e = v);
    }
    if (e) {
      const v = e.x, w = e.y, B = e.width, S = e.height;
      o *= a;
      const C = Vm(v * a, w * a, B * a, S * a, g), { aabox: E } = C;
      let _ = E.x - o, I = E.y - o, O = E.width + o * 2, U = E.height + o * 2;
      const V = _ + O / 2, F = I + U / 2, P = MA(s);
      if (P) {
        const J = rA.getSvgRoot().createSVGTransform();
        J.setRotate(-P, V, F);
        const ie = J.matrix;
        C.tl = zt(C.tl.x, C.tl.y, ie), C.tr = zt(C.tr.x, C.tr.y, ie), C.bl = zt(C.bl.x, C.bl.y, ie), C.br = zt(C.br.x, C.br.y, ie);
        const { tl: te } = C;
        let $ = te.x, re = te.y, ue = te.x, se = te.y;
        const { min: T, max: G } = Math;
        $ = T($, T(C.tr.x, T(C.bl.x, C.br.x))) - o, re = T(re, T(C.tr.y, T(C.bl.y, C.br.y))) - o, ue = G(ue, G(C.tr.x, G(C.bl.x, C.br.x))) + o, se = G(se, G(C.tr.y, G(C.bl.y, C.br.y))) + o, _ = $, I = re, O = ue - $, U = se - re;
      }
      const D = "M" + _ + "," + I + " L" + (_ + O) + "," + I + " " + (_ + O) + "," + (I + U) + " " + _ + "," + (I + U) + "z", R = P ? "rotate(" + [P, V, F].join(",") + ")" : "";
      this.gripCoords = {
        nw: [_, I],
        ne: [_ + O, I],
        sw: [_, I + U],
        se: [_ + O, I + U],
        n: [_ + O / 2, I],
        w: [_, I + U / 2],
        e: [_ + O, I + U / 2],
        s: [_ + O / 2, I + U]
      }, A.setAttribute("d", D), this.selectorGroup.setAttribute("transform", R), Object.entries(this.gripCoords).forEach(([J, ie]) => {
        i[J].setAttribute("cx", ie[0]), i[J].setAttribute("cy", ie[1]);
      }), n.rotateGripConnector.setAttribute("x1", _ + O / 2), n.rotateGripConnector.setAttribute("y1", I), n.rotateGripConnector.setAttribute("x2", _ + O / 2), n.rotateGripConnector.setAttribute("y2", I - vh * 5), n.rotateGrip.setAttribute("cx", _ + O / 2), n.rotateGrip.setAttribute("cy", I - vh * 5);
    }
  }
  // STATIC methods
  /**
  * Updates cursors for corner grips on rotation so arrows point the right way.
  * @param {Float} angle - Current rotation angle in degrees
  * @returns {void}
  */
  static updateGripCursors(e) {
    const t = Object.keys(va.selectorGrips);
    let A = Math.round(e / 45);
    for (A < 0 && (A += 8); A > 0; )
      t.push(t.shift()), A--;
    Object.values(va.selectorGrips).forEach((n, i) => {
      n.setAttribute("style", "cursor:" + t[i] + "-resize");
    });
  }
}
class cN {
  /**
   * Sets up properties and calls `initGroup`.
   */
  constructor() {
    this.selectorParentGroup = null, this.rubberBandBox = null, this.selectors = [], this.selectorMap = {}, this.selectorGrips = {
      nw: null,
      n: null,
      ne: null,
      e: null,
      se: null,
      s: null,
      sw: null,
      w: null
    }, this.selectorGripsGroup = null, this.rotateGripConnector = null, this.rotateGrip = null, this.initGroup();
  }
  /**
  * Resets the parent selector group element.
  * @returns {void}
  */
  initGroup() {
    const e = rA.getDataStorage();
    if (this.selectorParentGroup?.parentNode && this.selectorParentGroup.remove(), this.selectorParentGroup = rA.createSVGElement({
      element: "g",
      attr: { id: "selectorParentGroup" }
    }), this.selectorGripsGroup = rA.createSVGElement({
      element: "g",
      attr: { display: "none" }
    }), this.selectorParentGroup.append(this.selectorGripsGroup), rA.getSvgRoot().append(this.selectorParentGroup), this.selectorMap = {}, this.selectors = [], this.rubberBandBox = null, Object.keys(this.selectorGrips).forEach((s) => {
      const a = rA.createSVGElement({
        element: "circle",
        attr: {
          id: "selectorGrip_resize_" + s,
          fill: "#22C",
          r: vh,
          style: "cursor:" + s + "-resize",
          // This expands the mouse-able area of the grips making them
          // easier to grab with the mouse.
          // This works in Opera and WebKit, but does not work in Firefox
          // see https://bugzilla.mozilla.org/show_bug.cgi?id=500174
          "stroke-width": 2,
          "pointer-events": "all"
        }
      });
      e.put(a, "dir", s), e.put(a, "type", "resize"), this.selectorGrips[s] = a, this.selectorGripsGroup.append(a);
    }), this.rotateGripConnector = rA.createSVGElement({
      element: "line",
      attr: {
        id: "selectorGrip_rotateconnector",
        stroke: "#22C",
        "stroke-width": "1"
      }
    }), this.selectorGripsGroup.append(this.rotateGripConnector), this.rotateGrip = rA.createSVGElement({
      element: "circle",
      attr: {
        id: "selectorGrip_rotate",
        fill: "lime",
        r: vh,
        stroke: "#22C",
        "stroke-width": 2,
        style: `cursor:url(${rA.curConfig.imgPath}/rotate.svg) 12 12, auto;`
      }
    }), this.selectorGripsGroup.append(this.rotateGrip), e.put(this.rotateGrip, "type", "rotate"), document.getElementById("canvasBackground"))
      return;
    const [t, A] = rA.curConfig.dimensions, n = rA.createSVGElement({
      element: "svg",
      attr: {
        id: "canvasBackground",
        width: t,
        height: A,
        x: 0,
        y: 0,
        overflow: qS() ? "none" : "visible",
        // Chrome 7 has a problem with this when zooming out
        style: "pointer-events:none"
      }
    }), i = rA.createSVGElement({
      element: "rect",
      attr: {
        width: "100%",
        height: "100%",
        x: 0,
        y: 0,
        "stroke-width": 1,
        stroke: "#000",
        fill: "#FFF",
        style: "pointer-events:none"
      }
    });
    n.append(i), rA.getSvgRoot().insertBefore(n, rA.getSvgContent());
  }
  /**
  *
  * @param {Element} elem - DOM element to get the selector for
  * @param {module:utilities.BBoxObject} [bbox] - Optional bbox to use for reset (prevents duplicate getBBox call).
  * @returns {Selector} The selector based on the given element
  */
  requestSelector(e, t) {
    if (!e)
      return null;
    const A = this.selectors.length;
    if (typeof this.selectorMap[e.id] == "object")
      return this.selectorMap[e.id].locked = !0, this.selectorMap[e.id];
    for (let n = 0; n < A; ++n)
      if (!this.selectors[n]?.locked)
        return this.selectors[n].locked = !0, this.selectors[n].reset(e, t), this.selectorMap[e.id] = this.selectors[n], this.selectors[n];
    return this.selectors[A] = new Mh(A, e, t), this.selectorParentGroup.append(this.selectors[A].selectorGroup), this.selectorMap[e.id] = this.selectors[A], this.selectors[A];
  }
  /**
  * Removes the selector of the given element (hides selection box).
  *
  * @param {Element} elem - DOM element to remove the selector for
  * @returns {void}
  */
  releaseSelector(e) {
    if (!e)
      return;
    const t = this.selectors.length, A = this.selectorMap[e.id];
    A?.locked || console.warn("WARNING! selector was released but was already unlocked");
    for (let n = 0; n < t; ++n)
      if (this.selectors[n] && this.selectors[n] === A) {
        delete this.selectorMap[e.id], A.locked = !1, A.selectedElement = null, A.showGrips(!1);
        try {
          A.selectorGroup.setAttribute("display", "none");
        } catch {
        }
        break;
      }
  }
  /**
  * @returns {SVGRectElement} The rubberBandBox DOM element. This is the rectangle drawn by
  * the user for selecting/zooming
  */
  getRubberBandBox() {
    return this.rubberBandBox || (this.rubberBandBox = rA.createSVGElement({
      element: "rect",
      attr: {
        id: "selectorRubberBand",
        fill: "#22C",
        "fill-opacity": 0.15,
        stroke: "#22C",
        "stroke-width": 0.5,
        display: "none",
        style: "pointer-events:none"
      }
    }), this.selectorParentGroup.append(this.rubberBandBox)), this.rubberBandBox;
  }
}
const hN = (r) => {
  rA = r, va = new cN();
}, fN = () => va;
let fo = null;
const dN = (r) => {
  fo = r;
}, gN = () => {
  const r = fo.getCurConfig(), { dimensions: e } = r, t = fo.getSvgContent();
  for (; t.firstChild; )
    t.removeChild(t.firstChild);
  const A = fo.getSvgRoot();
  t.setAttribute("id", "svgcontent"), t.setAttribute("width", e[0]), t.setAttribute("height", e[1]), t.setAttribute("x", e[0]), t.setAttribute("y", e[1]), t.setAttribute("overflow", r.show_outside_canvas ? "visible" : "hidden"), t.setAttribute("xmlns", nt.SVG), t.setAttribute("xmlns:se", nt.SE), t.setAttribute("xmlns:xlink", nt.XLINK), A.appendChild(t);
  const n = fo.getDOMDocument().createComment(" Created with SVG-edit - https://github.com/SVG-Edit/svgedit");
  fo.getSvgContent().append(n);
}, pN = {
  _storage: /* @__PURE__ */ new WeakMap(),
  put: function(r, e, t) {
    this._storage.has(r) || this._storage.set(r, /* @__PURE__ */ new Map()), this._storage.get(r).set(e, t);
  },
  get: function(r, e) {
    return this._storage.get(r)?.get(e);
  },
  has: function(r, e) {
    return this._storage.has(r) && this._storage.get(r).has(e);
  },
  remove: function(r, e) {
    const t = this._storage.get(r).delete(e);
    return this._storage.get(r).size === 0 && this._storage.delete(r), t;
  }
};
const mN = "a,circle,ellipse,foreignObject,g,image,line,path,polygon,polyline,rect,svg,text,tspan,use", wy = [
  "clip-path",
  "fill",
  "filter",
  "marker-end",
  "marker-mid",
  "marker-start",
  "mask",
  "stroke"
], vN = 0.8, wN = 10, Ki = "svgedit_clipboard";
class fA {
  /**
   * @param {HTMLElement} container - The container HTML element that should hold the SVG root element
   * @param {module:SVGeditor.configObj.curConfig} config - An object that contains configuration data
   */
  constructor(e, t) {
    this.initializeSvgCanvasMethods(), x4(this);
    const { pathActions: A } = VS;
    this.saveOptions = { round_digits: 2 }, this.importIds = {}, this.extensions = {}, this.removedElements = {}, this.started = !1, this.startTransform = null, this.currentMode = "select", this.currentResizeMode = "none", this.justSelected = null, this.rubberBox = null, this.curBBoxes = [], this.lastClickPoint = null, this.events = {}, this.rootSctm = null, this.drawnPath = null, this.freehand = {
      // Mouse events
      minx: null,
      miny: null,
      maxx: null,
      maxy: null
    }, this.dAttr = null, this.startX = null, this.startY = null, this.rStartX = null, this.rStartY = null, this.initBbox = {}, this.sumDistance = 0, this.controllPoint2 = { x: 0, y: 0 }, this.controllPoint1 = { x: 0, y: 0 }, this.start = { x: 0, y: 0 }, this.end = { x: 0, y: 0 }, this.bSpline = { x: 0, y: 0 }, this.nextPos = { x: 0, y: 0 }, this.idprefix = "svg_", this.encodableImages = {}, this.curConfig = {
      // Default configuration options
      show_outside_canvas: !0,
      selectNew: !0,
      dimensions: [640, 480]
    }, t && (this.curConfig = fA.mergeDeep(this.curConfig, t)), this.lastGoodImgUrl = `${this.curConfig.imgPath}/logo.svg`;
    const { dimensions: n } = this.curConfig;
    this.svgdoc = window.document, this.container = e, this.svgroot = U_(this.svgdoc, n), e.append(this.svgroot), this.svgContent = this.svgdoc.createElementNS(nt.SVG, "svg"), __(this), dN(this), this.clearSvgContentElement(), this.current_drawing_ = new D0(this.svgContent, this.idprefix), this.zoom = 1, this.currentGroup = null;
    const i = {
      shape: {
        fill: (this.curConfig.initFill.color === "none" ? "" : "#") + this.curConfig.initFill.color,
        fill_paint: null,
        fill_opacity: this.curConfig.initFill.opacity,
        stroke: "#" + this.curConfig.initStroke.color,
        stroke_paint: null,
        stroke_opacity: this.curConfig.initStroke.opacity,
        stroke_width: this.curConfig.initStroke.width,
        stroke_dasharray: "none",
        stroke_linejoin: "miter",
        stroke_linecap: "butt",
        opacity: this.curConfig.initOpacity
      }
    };
    i.text = fA.mergeDeep({}, i.shape), i.text = fA.mergeDeep(i.text, {
      fill: "#000000",
      stroke_width: this.curConfig.text?.stroke_width,
      font_size: this.curConfig.text?.font_size,
      font_family: this.curConfig.text?.font_family
    }), this.curText = i.text, this.curShape = i.shape, this.curProperties = this.curShape, this.selectedElements = [], uU(this), L4(this), ZU(this), tI(this), hN(this), R_(this), G_(this), this.nsMap = fS(), this.selectorManager = fN(), this.pathActions = A, OS(this), this.uiStrings = {}, this.opacAni = document.createElementNS(nt.SVG, "animate"), this.opacAni.setAttribute("attributeName", "opacity"), this.opacAni.setAttribute("begin", "indefinite"), this.opacAni.setAttribute("dur", 1), this.opacAni.setAttribute("fill", "freeze"), this.svgroot.appendChild(this.opacAni), rU(this), Z_(this), ZL(this), h_(this), cU(this);
    const s = (o) => (o.preventDefault(), !1);
    e.addEventListener("mousedown", this.mouseDownEvent), e.addEventListener("mousemove", this.mouseMoveEvent), fh(e, s), e.addEventListener("dblclick", this.dblClickEvent), e.addEventListener("mouseup", this.mouseUpEvent), e.addEventListener("mouseleave", this.mouseOutEvent), e.addEventListener("mousewheel", this.DOMMouseScrollEvent), e.addEventListener("DOMMouseScroll", this.DOMMouseScrollEvent), this.linkControlPoints = A.linkControlPoints, this.curCommand = null, this.filter = null, this.filterHidden = !1, vI(this), rI(this);
    const a = (o) => {
      o.newValue && (o.key === Ki + "_startup" ? (localStorage.removeItem(Ki + "_startup"), this.flashStorage()) : o.key === Ki && sessionStorage.setItem(Ki, o.newValue));
    };
    window.addEventListener("storage", a, !1), localStorage.setItem(Ki + "_startup", Math.random()), E_(this), this.contentW = this.getResolution().w, this.contentH = this.getResolution().h, this.clear(), this.modeChangeEvent();
  }
  // End constructor
  getSvgOption() {
    return this.saveOptions;
  }
  setSvgOption(e, t) {
    this.saveOptions[e] = t;
  }
  getSelectedElements() {
    return this.selectedElements;
  }
  setSelectedElements(e, t) {
    this.selectedElements[e] = t;
  }
  setEmptySelectedElements() {
    this.selectedElements = [];
  }
  getSvgRoot() {
    return this.svgroot;
  }
  getDOMDocument() {
    return this.svgdoc;
  }
  getDOMContainer() {
    return this.container;
  }
  getCurConfig() {
    return this.curConfig;
  }
  setIdPrefix(e) {
    this.idprefix = e;
  }
  getCurrentDrawing() {
    return this.current_drawing_;
  }
  getCurShape() {
    return this.curShape;
  }
  getCurrentGroup() {
    return this.currentGroup;
  }
  getBaseUnit() {
    return this.curConfig.baseUnit;
  }
  getHeight() {
    return this.svgContent.getAttribute("height") / this.zoom;
  }
  getWidth() {
    return this.svgContent.getAttribute("width") / this.zoom;
  }
  getRoundDigits() {
    return this.saveOptions.round_digits;
  }
  getSnappingStep() {
    return this.curConfig.snappingStep;
  }
  getGridSnapping() {
    return this.curConfig.gridSnapping;
  }
  getStartTransform() {
    return this.startTransform;
  }
  setStartTransform(e) {
    this.startTransform = e;
  }
  getZoom() {
    return this.zoom;
  }
  round(e) {
    return Number.parseInt(e * this.zoom) / this.zoom;
  }
  createSVGElement(e) {
    return this.addSVGElementsFromJson(e);
  }
  getContainer() {
    return this.container;
  }
  setStarted(e) {
    this.started = e;
  }
  getRubberBox() {
    return this.rubberBox;
  }
  setRubberBox(e) {
    return this.rubberBox = e, this.rubberBox;
  }
  addPtsToSelection({ closedSubpath: e, grips: t }) {
    this.pathActions.canDeleteNodes = !0, this.pathActions.closed_subpath = e, this.call("pointsAdded", { closedSubpath: e, grips: t }), this.call("selected", t);
  }
  /**
   * @param {PlainObject} changes
   * @param {ChangeElementCommand} changes.cmd
   * @param {SVGPathElement} changes.elem
   * @fires module:svgcanvas.SvgCanvas#event:changed
   * @returns {void}
   */
  endChanges({ cmd: e, elem: t }) {
    this.addCommandToHistory(e), this.call("changed", [t]);
  }
  getCurrentMode() {
    return this.currentMode;
  }
  setCurrentMode(e) {
    return this.currentMode = e, this.currentMode;
  }
  getDrawnPath() {
    return this.drawnPath;
  }
  setDrawnPath(e) {
    return this.drawnPath = e, this.drawnPath;
  }
  setCurrentGroup(e) {
    this.currentGroup = e;
  }
  changeSvgContent() {
    this.call("changed", [this.svgContent]);
  }
  getStarted() {
    return this.started;
  }
  getCanvas() {
    return this;
  }
  getrootSctm() {
    return this.rootSctm;
  }
  getStartX() {
    return this.startX;
  }
  setStartX(e) {
    this.startX = e;
  }
  getStartY() {
    return this.startY;
  }
  setStartY(e) {
    this.startY = e;
  }
  getRStartX() {
    return this.rStartX;
  }
  getRStartY() {
    return this.rStartY;
  }
  getInitBbox() {
    return this.initBbox;
  }
  getCurrentResizeMode() {
    return this.currentResizeMode;
  }
  getJustSelected() {
    return this.justSelected;
  }
  getOpacAni() {
    return this.opacAni;
  }
  getParameter() {
    return this.parameter;
  }
  getNextParameter() {
    return this.nextParameter;
  }
  getStepCount() {
    return wN;
  }
  getThreSholdDist() {
    return vN;
  }
  getSumDistance() {
    return this.sumDistance;
  }
  getStart(e) {
    return this.start[e];
  }
  getEnd(e) {
    return this.end[e];
  }
  getbSpline(e) {
    return this.bSpline[e];
  }
  getNextPos(e) {
    return this.nextPos[e];
  }
  getControllPoint1(e) {
    return this.controllPoint1[e];
  }
  getControllPoint2(e) {
    return this.controllPoint2[e];
  }
  getFreehand(e) {
    return this.freehand[e];
  }
  getDrawing() {
    return this.getCurrentDrawing();
  }
  getDAttr() {
    return this.dAttr;
  }
  getLastGoodImgUrl() {
    return this.lastGoodImgUrl;
  }
  getCurText(e) {
    return this.curText[e];
  }
  setDAttr(e) {
    this.dAttr = e;
  }
  setEnd(e, t) {
    this.end[e] = t;
  }
  setControllPoint1(e, t) {
    this.controllPoint1[e] = t;
  }
  setControllPoint2(e, t) {
    this.controllPoint2[e] = t;
  }
  setJustSelected(e) {
    this.justSelected = e;
  }
  setParameter(e) {
    this.parameter = e;
  }
  setStart(e) {
    this.start = e;
  }
  setRStartX(e) {
    this.rStartX = e;
  }
  setRStartY(e) {
    this.rStartY = e;
  }
  setSumDistance(e) {
    this.sumDistance = e;
  }
  setbSpline(e) {
    this.bSpline = e;
  }
  setNextPos(e) {
    this.nextPos = e;
  }
  setNextParameter(e) {
    this.nextParameter = e;
  }
  setCurText(e, t) {
    this.curText[e] = t;
  }
  setFreehand(e, t) {
    this.freehand[e] = t;
  }
  setCurBBoxes(e) {
    this.curBBoxes = e;
  }
  getCurBBoxes() {
    return this.curBBoxes;
  }
  setInitBbox(e) {
    this.initBbox = e;
  }
  setRootSctm(e) {
    this.rootSctm = e;
  }
  setCurrentResizeMode(e) {
    this.currentResizeMode = e;
  }
  getLastClickPoint(e) {
    return this.lastClickPoint[e];
  }
  setLastClickPoint(e) {
    this.lastClickPoint = e;
  }
  getId() {
    return this.getCurrentDrawing().getId();
  }
  getUIStrings() {
    return this.uiStrings;
  }
  getNsMap() {
    return this.nsMap;
  }
  getSvgOptionApply() {
    return this.saveOptions.apply;
  }
  getSvgOptionImages() {
    return this.saveOptions.images;
  }
  getEncodableImages(e) {
    return this.encodableImages[e];
  }
  setEncodableImages(e, t) {
    this.encodableImages[e] = t;
  }
  getVisElems() {
    return mN;
  }
  getIdPrefix() {
    return this.idprefix;
  }
  getDataStorage() {
    return pN;
  }
  setZoom(e) {
    this.zoom = e;
  }
  getImportIds(e) {
    return this.importIds[e];
  }
  setImportIds(e, t) {
    this.importIds[e] = t;
  }
  setRemovedElements(e, t) {
    this.removedElements[e] = t;
  }
  setSvgContent(e) {
    this.svgContent = e;
  }
  getrefAttrs() {
    return wy;
  }
  setCanvas(e, t) {
    this[e] = t;
  }
  setCurProperties(e, t) {
    this.curProperties[e] = t;
  }
  getCurProperties(e) {
    return this.curProperties[e];
  }
  setCurShape(e, t) {
    this.curShape[e] = t;
  }
  gettingSelectorManager() {
    return this.selectorManager;
  }
  getContentW() {
    return this.contentW;
  }
  getContentH() {
    return this.contentH;
  }
  getClipboardID() {
    return Ki;
  }
  getSvgContent() {
    return this.svgContent;
  }
  getExtensions() {
    return this.extensions;
  }
  getSelector() {
    return Mh;
  }
  getMode() {
    return this.currentMode;
  }
  // The current editor mode string
  getNextId() {
    return this.getCurrentDrawing().getNextId();
  }
  getCurCommand() {
    return this.curCommand;
  }
  setCurCommand(e) {
    this.curCommand = e;
  }
  getFilter() {
    return this.filter;
  }
  setFilter(e) {
    this.filter = e;
  }
  getFilterHidden() {
    return this.filterHidden;
  }
  setFilterHidden(e) {
    this.filterHidden = e;
  }
  /**
   * Sets the editor's mode to the given string.
   * @function module:svgcanvas.SvgCanvas#setMode
   * @param {string} name - String with the new mode to change to
   * @returns {void}
   */
  setMode(e) {
    this.pathActions.clear(!0), this.textActions.clear(), this.curProperties = this.selectedElements[0]?.nodeName === "text" ? this.curText : this.curShape, this.currentMode = e, this.modeEvent && document.dispatchEvent(this.modeEvent);
  }
  /**
   * Clears the current document. This is not an undoable action.
   * @function module:svgcanvas.SvgCanvas#clear
   * @fires module:svgcanvas.SvgCanvas#event:beforeClear|afterClear
   * @returns {void}
   */
  clear() {
    this.call("beforeClear"), this.pathActions.clear(), this.clearSelection(), this.clearSvgContentElement(), this.current_drawing_ = new D0(this.svgContent), this.createLayer(), this.undoMgr.resetUndoStack(), this.selectorManager.initGroup(), this.rubberBox = this.selectorManager.getRubberBandBox(), this.call("afterClear");
  }
  async addExtension(e, t, { importLocale: A }) {
    if (typeof t != "function")
      throw new TypeError(
        "Function argument expected for `svgcanvas.addExtension`"
      );
    if (e in this.extensions)
      throw new Error(
        'Cannot add extension "' + e + '", an extension by that name already exists.'
      );
    const n = {
      importLocale: A,
      svgroot: this.svgroot,
      svgContent: this.svgContent,
      nonce: this.getCurrentDrawing().getNonce(),
      selectorManager: this.selectorManager
    }, i = await t(n);
    return i && (i.name = e), this.extensions[e] = i, this.call("extension_added", i);
  }
  addCommandToHistory(e) {
    this.undoMgr.addCommandToHistory(e);
  }
  restoreRefElements(e) {
    const t = {};
    wy.forEach((n, i) => {
      t[n] = e.getAttribute(n);
    }), Object.values(t).forEach((n) => {
      if (n?.startsWith("url(")) {
        const i = hh(n).substr(1);
        Xt(i) || (Cn().append(this.removedElements[i]), delete this.removedElements[i]);
      }
    });
    const A = e.getElementsByTagName("*");
    if (A.length)
      for (let n = 0, i = A.length; n < i; n++)
        this.restoreRefElements(A[n]);
  }
  call(e, t) {
    if (this.events[e])
      return this.events[e](window, t);
  }
  /**
   * Attaches a callback function to an event.
   * @function module:svgcanvas.SvgCanvas#bind
   * @param  {string} ev - String indicating the name of the event
   * @param {module:svgcanvas.EventHandler} f - The callback function to bind to the event
   * @returns {module:svgcanvas.EventHandler} The previous event
   */
  bind(e, t) {
    const A = this.events[e];
    return this.events[e] = t, A;
  }
  /**
   * Flash the clipboard data momentarily on localStorage so all tabs can see.
   * @returns {void}
   */
  flashStorage() {
    const e = sessionStorage.getItem(Ki);
    localStorage.setItem(Ki, e), setTimeout(() => {
      localStorage.removeItem(Ki);
    }, 1);
  }
  /**
   * Selects only the given elements, shortcut for `clearSelection(); addToSelection()`.
   * @function module:svgcanvas.SvgCanvas#selectOnly
   * @param {Element[]} elems - an array of DOM elements to be selected
   * @param {boolean} showGrips - Indicates whether the resize grips should be shown
   * @returns {void}
   */
  selectOnly(e, t) {
    this.clearSelection(!0), this.addToSelection(e, t);
  }
  /**
   * Removes elements from the selection.
   * @function module:svgcanvas.SvgCanvas#removeFromSelection
   * @param {Element[]} elemsToRemove - An array of elements to remove from selection
   * @returns {void}
   */
  removeFromSelection(e) {
    if (!this.selectedElements[0] || !e.length)
      return;
    const t = [], A = this.selectedElements.length;
    for (let n = 0; n < A; ++n) {
      const i = this.selectedElements[n];
      i && (e.includes(i) ? this.selectorManager.releaseSelector(i) : t.push(i));
    }
    this.selectedElements = t;
  }
  /**
   * Clears the selection, then adds all elements in the current layer to the selection.
   * @function module:svgcanvas.SvgCanvas#selectAllInCurrentLayer
   * @returns {void}
   */
  selectAllInCurrentLayer() {
    const e = this.getCurrentDrawing().getCurrentLayer();
    e && (this.currentMode = "select", this.currentGroup ? this.selectOnly(this.currentGroup.children) : this.selectOnly(e.children));
  }
  getOpacity() {
    return this.curShape.opacity;
  }
  /**
   * @function module:svgcanvas.SvgCanvas#getSnapToGrid
   * @returns {boolean} The current snap to grid setting
   */
  getSnapToGrid() {
    return this.curConfig.gridSnapping;
  }
  /**
   * @function module:svgcanvas.SvgCanvas#getVersion
   * @returns {string} A string which describes the revision number of SvgCanvas.
   */
  getVersion() {
    return "svgcanvas.js ($Rev$)";
  }
  /**
   * Update interface strings with given values.
   * @function module:svgcanvas.SvgCanvas#setUiStrings
   * @param {module:path.uiStrings} strs - Object with strings (see the [locales API]{@link module:locale.LocaleStrings} and the [tutorial]{@tutorial LocaleDocs})
   * @returns {void}
   */
  setUiStrings(e) {
    Object.assign(this.uiStrings, e.notification), NS(e);
  }
  /**
   * Update configuration options with given values.
   * @function module:svgcanvas.SvgCanvas#setConfig
   * @param {module:SVGEditor.Config} opts - Object with options
   * @returns {void}
   */
  setConfig(e) {
    Object.assign(this.curConfig, e);
  }
  /**
   * @function module:svgcanvas.SvgCanvas#getDocumentTitle
   * @returns {string|void} The current document title or an empty string if not found
   */
  getDocumentTitle() {
    return this.getTitle(this.svgContent);
  }
  getOffset() {
    return {
      x: Number(this.svgContent.getAttribute("x")),
      y: Number(this.svgContent.getAttribute("y"))
    };
  }
  getColor(e) {
    return this.curProperties[e];
  }
  setStrokePaint(e) {
    this.setPaint("stroke", e);
  }
  /**
   * @function module:svgcanvas.SvgCanvas#setFillPaint
   * @param {module:jGraduate~Paint} paint
   * @returns {void}
   */
  setFillPaint(e) {
    this.setPaint("fill", e);
  }
  /**
   * @function module:svgcanvas.SvgCanvas#getStrokeWidth
   * @returns {Float|string} The current stroke-width value
   */
  getStrokeWidth() {
    return this.curProperties.stroke_width;
  }
  /**
   * @function module:svgcanvas.SvgCanvas#getStyle
   * @returns {module:svgcanvas.StyleOptions} current style options
   */
  getStyle() {
    return this.curShape;
  }
  /**
   * Sets the given opacity on the current selected elements.
   * @function module:svgcanvas.SvgCanvas#setOpacity
   * @param {string} val
   * @returns {void}
   */
  setOpacity(e) {
    this.curShape.opacity = e, this.changeSelectedAttribute("opacity", e);
  }
  /**
   * @function module:svgcanvas.SvgCanvas#getFillOpacity
   * @returns {Float} the current fill opacity
   */
  getFillOpacity() {
    return this.curShape.fill_opacity;
  }
  /**
   * @function module:svgcanvas.SvgCanvas#getStrokeOpacity
   * @returns {string} the current stroke opacity
   */
  getStrokeOpacity() {
    return this.curShape.stroke_opacity;
  }
  /**
   * Sets the current fill/stroke opacity.
   * @function module:svgcanvas.SvgCanvas#setPaintOpacity
   * @param {string} type - String with "fill" or "stroke"
   * @param {Float} val - Float with the new opacity value
   * @param {boolean} preventUndo - Indicates whether or not this should be an undoable action
   * @returns {void}
   */
  setPaintOpacity(e, t, A) {
    this.curShape[e + "_opacity"] = t, A ? this.changeSelectedAttributeNoUndo(e + "-opacity", t) : this.changeSelectedAttribute(e + "-opacity", t);
  }
  /**
   * Gets the current fill/stroke opacity.
   * @function module:svgcanvas.SvgCanvas#getPaintOpacity
   * @param {"fill"|"stroke"} type - String with "fill" or "stroke"
   * @returns {Float} Fill/stroke opacity
   */
  getPaintOpacity(e) {
    return e === "fill" ? this.getFillOpacity() : this.getStrokeOpacity();
  }
  /**
   * Gets the `stdDeviation` blur value of the given element.
   * @function module:svgcanvas.SvgCanvas#getBlur
   * @param {Element} elem - The element to check the blur value for
   * @returns {string} stdDeviation blur attribute value
   */
  getBlur(e) {
    let t = 0;
    if (e) {
      const A = e.getAttribute("filter");
      if (A) {
        const n = Xt(e.id + "_blur");
        if (n)
          t = n.firstChild.getAttribute("stdDeviation");
        else {
          const i = Ua(A), s = R0(i);
          s !== null && (t = s.getAttribute("stdDeviation"));
        }
      }
    }
    return t;
  }
  /**
   * Sets a given URL to be a "last good image" URL.
   * @function module:svgcanvas.SvgCanvas#setGoodImage
   * @param {string} val
   * @returns {void}
   */
  setGoodImage(e) {
    this.lastGoodImgUrl = e;
  }
  /**
   * Returns the current drawing as raw SVG XML text.
   * @function module:svgcanvas.SvgCanvas#getSvgString
   * @returns {string} The current drawing as raw SVG XML text.
   */
  getSvgString() {
    return this.saveOptions.apply = !1, this.svgCanvasToString();
  }
  /**
   * This function determines whether to use a nonce in the prefix, when
   * generating IDs for future documents in SVG-Edit.
   * If you're controlling SVG-Edit externally, and want randomized IDs, call
   * this BEFORE calling `svgCanvas.setSvgString`.
   * @function module:svgcanvas.SvgCanvas#randomizeIds
   * @param {boolean} [enableRandomization] If true, adds a nonce to the prefix. Thus
   * `svgCanvas.randomizeIds() <==> svgCanvas.randomizeIds(true)`
   * @returns {void}
   */
  randomizeIds(e) {
    arguments.length > 0 && e === !1 ? O1(!1, this.getCurrentDrawing()) : O1(!0, this.getCurrentDrawing());
  }
  /**
   * Convert selected element to a path, or get the BBox of an element-as-path.
   * @function module:svgcanvas.SvgCanvas#convertToPath
   * @todo (codedread): Remove the getBBox argument and split this function into two.
   * @param {Element} elem - The DOM element to be converted
   * @param {boolean} getBBox - Boolean on whether or not to only return the path's BBox
   * @returns {void|DOMRect|false|SVGPathElement|null} If the getBBox flag is true, the resulting path's bounding box object.
   * Otherwise the resulting path element is returned.
   */
  convertToPath(e, t) {
    if (!e) {
      this.selectedElements.forEach((i) => {
        i && this.convertToPath(i);
      });
      return;
    }
    if (t)
      return M0(
        e,
        this.addSVGElementsFromJson,
        this.pathActions
      );
    const A = {
      fill: this.curShape.fill,
      "fill-opacity": this.curShape.fill_opacity,
      stroke: this.curShape.stroke,
      "stroke-width": this.curShape.stroke_width,
      "stroke-dasharray": this.curShape.stroke_dasharray,
      "stroke-linejoin": this.curShape.stroke_linejoin,
      "stroke-linecap": this.curShape.stroke_linecap,
      "stroke-opacity": this.curShape.stroke_opacity,
      opacity: this.curShape.opacity,
      visibility: "hidden"
    };
    return H4(e, A, this);
  }
  /**
   * Removes all selected elements from the DOM and adds the change to the
   * history stack. Remembers removed elements on the clipboard.
   * @function module:svgcanvas.SvgCanvas#cutSelectedElements
   * @returns {void}
   */
  cutSelectedElements() {
    this.copySelectedElements(), this.deleteSelectedElements();
  }
  initializeSvgCanvasMethods() {
    this.getJsonFromSvgElements = WS, this.addSVGElementsFromJson = XS, this.clearSvgContentElement = gN, this.textActions = eU, this.getStrokedBBox = Mn, this.getVisibleElements = iu, this.stringToHTML = CS, this.insertChildAtIndex = G4, this.getClosest = Au, this.getParents = nu, this.isLayer = Bn.isLayer, this.matrixMultiply = wn, this.hasMatrixTransform = Qo, this.transformListToTransform = vr, this.convertToNum = xA, this.convertUnit = ch, this.findDefs = Cn, this.getUrlFromAttr = hh, this.getHref = $i, this.setHref = Rn, this.getBBox = Nr, this.getRotationAngle = MA, this.getElement = Xt, this.getRefElem = Ua, this.assignAttributes = qt, this.cleanupElement = Ih, this.remapElement = xl, this.recalculateDimensions = Qa, this.sanitizeSvg = V0, this.pasteElements = F_, this.identifyLayers = Rl, this.createLayer = d_, this.cloneLayer = g_, this.deleteCurrentLayer = p_, this.setCurrentLayer = m_, this.renameCurrentLayer = v_, this.setCurrentLayerPosition = w_, this.indexCurrentLayer = f_, this.setLayerVisibility = y_, this.moveSelectedToLayer = B_, this.mergeLayer = b_, this.mergeAllLayers = C_, this.leaveContext = Vs, this.setContext = jS, this.changeSelectedAttributeNoUndo = zS, this.changeSelectedAttribute = H_, this.setBlurNoUndo = wI, this.setBlurOffsets = yI, this.setBlur = BI, this.smoothControlPoints = kS, this.getTypeMap = Gm, this.history = Pa, this.NS = nt, this.$id = SS, this.$qq = xS, this.$qa = ES, this.$click = fh, this.encode64 = mS, this.decode64 = vS, this.mergeDeep = ru;
  }
  /**
   * Creates modeChange event, adds it as an svgCanvas property
   * **/
  modeChangeEvent() {
    const e = new CustomEvent("modeChange", { detail: { getMode: () => this.getMode() } });
    this.modeEvent = e;
  }
}
fA.$id = SS;
fA.$qq = xS;
fA.$qa = ES;
fA.$click = fh;
fA.encode64 = mS;
fA.decode64 = vS;
fA.mergeDeep = ru;
fA.getClosest = Au;
fA.getParents = nu;
fA.blankPageObjectURL = M4;
fA.Paint = uS;
fA.getTypeMap = Gm;
fA.convertToNum = xA;
fA.isValidUnit = F4;
fA.convertUnit = ch;
var im = function(r, e) {
  return im = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, A) {
    t.__proto__ = A;
  } || function(t, A) {
    for (var n in A) Object.prototype.hasOwnProperty.call(A, n) && (t[n] = A[n]);
  }, im(r, e);
};
function ii(r, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  im(r, e);
  function t() {
    this.constructor = r;
  }
  r.prototype = e === null ? Object.create(e) : (t.prototype = e.prototype, new t());
}
var sm = function() {
  return sm = Object.assign || function(e) {
    for (var t, A = 1, n = arguments.length; A < n; A++) {
      t = arguments[A];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, sm.apply(this, arguments);
};
function jA(r, e, t, A) {
  function n(i) {
    return i instanceof t ? i : new t(function(s) {
      s(i);
    });
  }
  return new (t || (t = Promise))(function(i, s) {
    function a(u) {
      try {
        l(A.next(u));
      } catch (h) {
        s(h);
      }
    }
    function o(u) {
      try {
        l(A.throw(u));
      } catch (h) {
        s(h);
      }
    }
    function l(u) {
      u.done ? i(u.value) : n(u.value).then(a, o);
    }
    l((A = A.apply(r, [])).next());
  });
}
function TA(r, e) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1) throw i[1];
    return i[1];
  }, trys: [], ops: [] }, A, n, i, s;
  return s = { next: a(0), throw: a(1), return: a(2) }, typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function a(l) {
    return function(u) {
      return o([l, u]);
    };
  }
  function o(l) {
    if (A) throw new TypeError("Generator is already executing.");
    for (; t; ) try {
      if (A = 1, n && (i = l[0] & 2 ? n.return : l[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, l[1])).done) return i;
      switch (n = 0, i && (l = [l[0] & 2, i.value]), l[0]) {
        case 0:
        case 1:
          i = l;
          break;
        case 4:
          return t.label++, { value: l[1], done: !1 };
        case 5:
          t.label++, n = l[1], l = [0];
          continue;
        case 7:
          l = t.ops.pop(), t.trys.pop();
          continue;
        default:
          if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (l[0] === 6 || l[0] === 2)) {
            t = 0;
            continue;
          }
          if (l[0] === 3 && (!i || l[1] > i[0] && l[1] < i[3])) {
            t.label = l[1];
            break;
          }
          if (l[0] === 6 && t.label < i[1]) {
            t.label = i[1], i = l;
            break;
          }
          if (i && t.label < i[2]) {
            t.label = i[2], t.ops.push(l);
            break;
          }
          i[2] && t.ops.pop(), t.trys.pop();
          continue;
      }
      l = e.call(r, t);
    } catch (u) {
      l = [6, u], n = 0;
    } finally {
      A = i = 0;
    }
    if (l[0] & 5) throw l[1];
    return { value: l[0] ? l[1] : void 0, done: !0 };
  }
}
function wc(r, e, t) {
  if (arguments.length === 2) for (var A = 0, n = e.length, i; A < n; A++)
    (i || !(A in e)) && (i || (i = Array.prototype.slice.call(e, 0, A)), i[A] = e[A]);
  return r.concat(i || e);
}
var As = (
  /** @class */
  (function() {
    function r(e, t, A, n) {
      this.left = e, this.top = t, this.width = A, this.height = n;
    }
    return r.prototype.add = function(e, t, A, n) {
      return new r(this.left + e, this.top + t, this.width + A, this.height + n);
    }, r.fromClientRect = function(e, t) {
      return new r(t.left + e.windowBounds.left, t.top + e.windowBounds.top, t.width, t.height);
    }, r.fromDOMRectList = function(e, t) {
      var A = Array.from(t).find(function(n) {
        return n.width !== 0;
      });
      return A ? new r(A.left + e.windowBounds.left, A.top + e.windowBounds.top, A.width, A.height) : r.EMPTY;
    }, r.EMPTY = new r(0, 0, 0, 0), r;
  })()
), Rh = function(r, e) {
  return As.fromClientRect(r, e.getBoundingClientRect());
}, yN = function(r) {
  var e = r.body, t = r.documentElement;
  if (!e || !t)
    throw new Error("Unable to get document size");
  var A = Math.max(Math.max(e.scrollWidth, t.scrollWidth), Math.max(e.offsetWidth, t.offsetWidth), Math.max(e.clientWidth, t.clientWidth)), n = Math.max(Math.max(e.scrollHeight, t.scrollHeight), Math.max(e.offsetHeight, t.offsetHeight), Math.max(e.clientHeight, t.clientHeight));
  return new As(0, 0, A, n);
}, kh = function(r) {
  for (var e = [], t = 0, A = r.length; t < A; ) {
    var n = r.charCodeAt(t++);
    if (n >= 55296 && n <= 56319 && t < A) {
      var i = r.charCodeAt(t++);
      (i & 64512) === 56320 ? e.push(((n & 1023) << 10) + (i & 1023) + 65536) : (e.push(n), t--);
    } else
      e.push(n);
  }
  return e;
}, Kr = function() {
  for (var r = [], e = 0; e < arguments.length; e++)
    r[e] = arguments[e];
  if (String.fromCodePoint)
    return String.fromCodePoint.apply(String, r);
  var t = r.length;
  if (!t)
    return "";
  for (var A = [], n = -1, i = ""; ++n < t; ) {
    var s = r[n];
    s <= 65535 ? A.push(s) : (s -= 65536, A.push((s >> 10) + 55296, s % 1024 + 56320)), (n + 1 === t || A.length > 16384) && (i += String.fromCharCode.apply(String, A), A.length = 0);
  }
  return i;
}, yy = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", BN = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var yc = 0; yc < yy.length; yc++)
  BN[yy.charCodeAt(yc)] = yc;
var By = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Fl = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var Bc = 0; Bc < By.length; Bc++)
  Fl[By.charCodeAt(Bc)] = Bc;
var bN = function(r) {
  var e = r.length * 0.75, t = r.length, A, n = 0, i, s, a, o;
  r[r.length - 1] === "=" && (e--, r[r.length - 2] === "=" && e--);
  var l = typeof ArrayBuffer < "u" && typeof Uint8Array < "u" && typeof Uint8Array.prototype.slice < "u" ? new ArrayBuffer(e) : new Array(e), u = Array.isArray(l) ? l : new Uint8Array(l);
  for (A = 0; A < t; A += 4)
    i = Fl[r.charCodeAt(A)], s = Fl[r.charCodeAt(A + 1)], a = Fl[r.charCodeAt(A + 2)], o = Fl[r.charCodeAt(A + 3)], u[n++] = i << 2 | s >> 4, u[n++] = (s & 15) << 4 | a >> 2, u[n++] = (a & 3) << 6 | o & 63;
  return l;
}, CN = function(r) {
  for (var e = r.length, t = [], A = 0; A < e; A += 2)
    t.push(r[A + 1] << 8 | r[A]);
  return t;
}, SN = function(r) {
  for (var e = r.length, t = [], A = 0; A < e; A += 4)
    t.push(r[A + 3] << 24 | r[A + 2] << 16 | r[A + 1] << 8 | r[A]);
  return t;
}, Ea = 5, fv = 11, Fd = 2, xN = fv - Ea, ux = 65536 >> Ea, EN = 1 << Ea, _d = EN - 1, FN = 1024 >> Ea, _N = ux + FN, UN = _N, IN = 32, QN = UN + IN, LN = 65536 >> fv, NN = 1 << xN, TN = NN - 1, by = function(r, e, t) {
  return r.slice ? r.slice(e, t) : new Uint16Array(Array.prototype.slice.call(r, e, t));
}, PN = function(r, e, t) {
  return r.slice ? r.slice(e, t) : new Uint32Array(Array.prototype.slice.call(r, e, t));
}, ON = function(r, e) {
  var t = bN(r), A = Array.isArray(t) ? SN(t) : new Uint32Array(t), n = Array.isArray(t) ? CN(t) : new Uint16Array(t), i = 24, s = by(n, i / 2, A[4] / 2), a = A[5] === 2 ? by(n, (i + A[4]) / 2) : PN(A, Math.ceil((i + A[4]) / 4));
  return new MN(A[0], A[1], A[2], A[3], s, a);
}, MN = (
  /** @class */
  (function() {
    function r(e, t, A, n, i, s) {
      this.initialValue = e, this.errorValue = t, this.highStart = A, this.highValueIndex = n, this.index = i, this.data = s;
    }
    return r.prototype.get = function(e) {
      var t;
      if (e >= 0) {
        if (e < 55296 || e > 56319 && e <= 65535)
          return t = this.index[e >> Ea], t = (t << Fd) + (e & _d), this.data[t];
        if (e <= 65535)
          return t = this.index[ux + (e - 55296 >> Ea)], t = (t << Fd) + (e & _d), this.data[t];
        if (e < this.highStart)
          return t = QN - LN + (e >> fv), t = this.index[t], t += e >> Ea & TN, t = this.index[t], t = (t << Fd) + (e & _d), this.data[t];
        if (e <= 1114111)
          return this.data[this.highValueIndex];
      }
      return this.errorValue;
    }, r;
  })()
), Cy = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", RN = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var bc = 0; bc < Cy.length; bc++)
  RN[Cy.charCodeAt(bc)] = bc;
var kN = "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", Sy = 50, HN = 1, cx = 2, hx = 3, DN = 4, GN = 5, xy = 7, fx = 8, Ey = 9, Ts = 10, am = 11, Fy = 12, om = 13, VN = 14, _l = 15, lm = 16, Cc = 17, hl = 18, KN = 19, _y = 20, um = 21, fl = 22, Ud = 23, no = 24, vn = 25, Ul = 26, Il = 27, io = 28, jN = 29, wa = 30, qN = 31, Sc = 32, xc = 33, cm = 34, hm = 35, fm = 36, $l = 37, dm = 38, nh = 39, ih = 40, Id = 41, dx = 42, zN = 43, WN = [9001, 65288], gx = "!", Mt = "×", Ec = "÷", gm = ON(kN), ji = [wa, fm], pm = [HN, cx, hx, GN], px = [Ts, fx], Uy = [Il, Ul], XN = pm.concat(px), Iy = [dm, nh, ih, cm, hm], YN = [_l, om], JN = function(r, e) {
  e === void 0 && (e = "strict");
  var t = [], A = [], n = [];
  return r.forEach(function(i, s) {
    var a = gm.get(i);
    if (a > Sy ? (n.push(!0), a -= Sy) : n.push(!1), ["normal", "auto", "loose"].indexOf(e) !== -1 && [8208, 8211, 12316, 12448].indexOf(i) !== -1)
      return A.push(s), t.push(lm);
    if (a === DN || a === am) {
      if (s === 0)
        return A.push(s), t.push(wa);
      var o = t[s - 1];
      return XN.indexOf(o) === -1 ? (A.push(A[s - 1]), t.push(o)) : (A.push(s), t.push(wa));
    }
    if (A.push(s), a === qN)
      return t.push(e === "strict" ? um : $l);
    if (a === dx || a === jN)
      return t.push(wa);
    if (a === zN)
      return i >= 131072 && i <= 196605 || i >= 196608 && i <= 262141 ? t.push($l) : t.push(wa);
    t.push(a);
  }), [A, t, n];
}, Qd = function(r, e, t, A) {
  var n = A[t];
  if (Array.isArray(r) ? r.indexOf(n) !== -1 : r === n)
    for (var i = t; i <= A.length; ) {
      i++;
      var s = A[i];
      if (s === e)
        return !0;
      if (s !== Ts)
        break;
    }
  if (n === Ts)
    for (var i = t; i > 0; ) {
      i--;
      var a = A[i];
      if (Array.isArray(r) ? r.indexOf(a) !== -1 : r === a)
        for (var o = t; o <= A.length; ) {
          o++;
          var s = A[o];
          if (s === e)
            return !0;
          if (s !== Ts)
            break;
        }
      if (a !== Ts)
        break;
    }
  return !1;
}, Qy = function(r, e) {
  for (var t = r; t >= 0; ) {
    var A = e[t];
    if (A === Ts)
      t--;
    else
      return A;
  }
  return 0;
}, $N = function(r, e, t, A, n) {
  if (t[A] === 0)
    return Mt;
  var i = A - 1;
  if (Array.isArray(n) && n[i] === !0)
    return Mt;
  var s = i - 1, a = i + 1, o = e[i], l = s >= 0 ? e[s] : 0, u = e[a];
  if (o === cx && u === hx)
    return Mt;
  if (pm.indexOf(o) !== -1)
    return gx;
  if (pm.indexOf(u) !== -1 || px.indexOf(u) !== -1)
    return Mt;
  if (Qy(i, e) === fx)
    return Ec;
  if (gm.get(r[i]) === am || (o === Sc || o === xc) && gm.get(r[a]) === am || o === xy || u === xy || o === Ey || [Ts, om, _l].indexOf(o) === -1 && u === Ey || [Cc, hl, KN, no, io].indexOf(u) !== -1 || Qy(i, e) === fl || Qd(Ud, fl, i, e) || Qd([Cc, hl], um, i, e) || Qd(Fy, Fy, i, e))
    return Mt;
  if (o === Ts)
    return Ec;
  if (o === Ud || u === Ud)
    return Mt;
  if (u === lm || o === lm)
    return Ec;
  if ([om, _l, um].indexOf(u) !== -1 || o === VN || l === fm && YN.indexOf(o) !== -1 || o === io && u === fm || u === _y || ji.indexOf(u) !== -1 && o === vn || ji.indexOf(o) !== -1 && u === vn || o === Il && [$l, Sc, xc].indexOf(u) !== -1 || [$l, Sc, xc].indexOf(o) !== -1 && u === Ul || ji.indexOf(o) !== -1 && Uy.indexOf(u) !== -1 || Uy.indexOf(o) !== -1 && ji.indexOf(u) !== -1 || // (PR | PO) × ( OP | HY )? NU
  [Il, Ul].indexOf(o) !== -1 && (u === vn || [fl, _l].indexOf(u) !== -1 && e[a + 1] === vn) || // ( OP | HY ) × NU
  [fl, _l].indexOf(o) !== -1 && u === vn || // NU ×	(NU | SY | IS)
  o === vn && [vn, io, no].indexOf(u) !== -1)
    return Mt;
  if ([vn, io, no, Cc, hl].indexOf(u) !== -1)
    for (var h = i; h >= 0; ) {
      var f = e[h];
      if (f === vn)
        return Mt;
      if ([io, no].indexOf(f) !== -1)
        h--;
      else
        break;
    }
  if ([Il, Ul].indexOf(u) !== -1)
    for (var h = [Cc, hl].indexOf(o) !== -1 ? s : i; h >= 0; ) {
      var f = e[h];
      if (f === vn)
        return Mt;
      if ([io, no].indexOf(f) !== -1)
        h--;
      else
        break;
    }
  if (dm === o && [dm, nh, cm, hm].indexOf(u) !== -1 || [nh, cm].indexOf(o) !== -1 && [nh, ih].indexOf(u) !== -1 || [ih, hm].indexOf(o) !== -1 && u === ih || Iy.indexOf(o) !== -1 && [_y, Ul].indexOf(u) !== -1 || Iy.indexOf(u) !== -1 && o === Il || ji.indexOf(o) !== -1 && ji.indexOf(u) !== -1 || o === no && ji.indexOf(u) !== -1 || ji.concat(vn).indexOf(o) !== -1 && u === fl && WN.indexOf(r[a]) === -1 || ji.concat(vn).indexOf(u) !== -1 && o === hl)
    return Mt;
  if (o === Id && u === Id) {
    for (var c = t[i], p = 1; c > 0 && (c--, e[c] === Id); )
      p++;
    if (p % 2 !== 0)
      return Mt;
  }
  return o === Sc && u === xc ? Mt : Ec;
}, ZN = function(r, e) {
  e || (e = { lineBreak: "normal", wordBreak: "normal" });
  var t = JN(r, e.lineBreak), A = t[0], n = t[1], i = t[2];
  (e.wordBreak === "break-all" || e.wordBreak === "break-word") && (n = n.map(function(a) {
    return [vn, wa, dx].indexOf(a) !== -1 ? $l : a;
  }));
  var s = e.wordBreak === "keep-all" ? i.map(function(a, o) {
    return a && r[o] >= 19968 && r[o] <= 40959;
  }) : void 0;
  return [A, n, s];
}, eT = (
  /** @class */
  (function() {
    function r(e, t, A, n) {
      this.codePoints = e, this.required = t === gx, this.start = A, this.end = n;
    }
    return r.prototype.slice = function() {
      return Kr.apply(void 0, this.codePoints.slice(this.start, this.end));
    }, r;
  })()
), tT = function(r, e) {
  var t = kh(r), A = ZN(t, e), n = A[0], i = A[1], s = A[2], a = t.length, o = 0, l = 0;
  return {
    next: function() {
      if (l >= a)
        return { done: !0, value: null };
      for (var u = Mt; l < a && (u = $N(t, i, n, ++l, s)) === Mt; )
        ;
      if (u !== Mt || l === a) {
        var h = new eT(t, u, o, l);
        return o = l, { value: h, done: !1 };
      }
      return { done: !0, value: null };
    }
  };
}, rT = 1, AT = 2, gu = 4, Ly = 8, wh = 10, Ny = 47, Gl = 92, nT = 9, iT = 32, Fc = 34, dl = 61, sT = 35, aT = 36, oT = 37, _c = 39, Uc = 40, gl = 41, lT = 95, tn = 45, uT = 33, cT = 60, hT = 62, fT = 64, dT = 91, gT = 93, pT = 61, mT = 123, Ic = 63, vT = 125, Ty = 124, wT = 126, yT = 128, Py = 65533, Ld = 42, ba = 43, BT = 44, bT = 58, CT = 59, Zl = 46, ST = 0, xT = 8, ET = 11, FT = 14, _T = 31, UT = 127, pi = -1, mx = 48, vx = 97, wx = 101, IT = 102, QT = 117, LT = 122, yx = 65, Bx = 69, bx = 70, NT = 85, TT = 90, PA = function(r) {
  return r >= mx && r <= 57;
}, PT = function(r) {
  return r >= 55296 && r <= 57343;
}, so = function(r) {
  return PA(r) || r >= yx && r <= bx || r >= vx && r <= IT;
}, OT = function(r) {
  return r >= vx && r <= LT;
}, MT = function(r) {
  return r >= yx && r <= TT;
}, RT = function(r) {
  return OT(r) || MT(r);
}, kT = function(r) {
  return r >= yT;
}, Qc = function(r) {
  return r === wh || r === nT || r === iT;
}, yh = function(r) {
  return RT(r) || kT(r) || r === lT;
}, Oy = function(r) {
  return yh(r) || PA(r) || r === tn;
}, HT = function(r) {
  return r >= ST && r <= xT || r === ET || r >= FT && r <= _T || r === UT;
}, Us = function(r, e) {
  return r !== Gl ? !1 : e !== wh;
}, Lc = function(r, e, t) {
  return r === tn ? yh(e) || Us(e, t) : yh(r) ? !0 : !!(r === Gl && Us(r, e));
}, Nd = function(r, e, t) {
  return r === ba || r === tn ? PA(e) ? !0 : e === Zl && PA(t) : PA(r === Zl ? e : r);
}, DT = function(r) {
  var e = 0, t = 1;
  (r[e] === ba || r[e] === tn) && (r[e] === tn && (t = -1), e++);
  for (var A = []; PA(r[e]); )
    A.push(r[e++]);
  var n = A.length ? parseInt(Kr.apply(void 0, A), 10) : 0;
  r[e] === Zl && e++;
  for (var i = []; PA(r[e]); )
    i.push(r[e++]);
  var s = i.length, a = s ? parseInt(Kr.apply(void 0, i), 10) : 0;
  (r[e] === Bx || r[e] === wx) && e++;
  var o = 1;
  (r[e] === ba || r[e] === tn) && (r[e] === tn && (o = -1), e++);
  for (var l = []; PA(r[e]); )
    l.push(r[e++]);
  var u = l.length ? parseInt(Kr.apply(void 0, l), 10) : 0;
  return t * (n + a * Math.pow(10, -s)) * Math.pow(10, o * u);
}, GT = {
  type: 2
  /* LEFT_PARENTHESIS_TOKEN */
}, VT = {
  type: 3
  /* RIGHT_PARENTHESIS_TOKEN */
}, KT = {
  type: 4
  /* COMMA_TOKEN */
}, jT = {
  type: 13
  /* SUFFIX_MATCH_TOKEN */
}, qT = {
  type: 8
  /* PREFIX_MATCH_TOKEN */
}, zT = {
  type: 21
  /* COLUMN_TOKEN */
}, WT = {
  type: 9
  /* DASH_MATCH_TOKEN */
}, XT = {
  type: 10
  /* INCLUDE_MATCH_TOKEN */
}, YT = {
  type: 11
  /* LEFT_CURLY_BRACKET_TOKEN */
}, JT = {
  type: 12
  /* RIGHT_CURLY_BRACKET_TOKEN */
}, $T = {
  type: 14
  /* SUBSTRING_MATCH_TOKEN */
}, Nc = {
  type: 23
  /* BAD_URL_TOKEN */
}, ZT = {
  type: 1
  /* BAD_STRING_TOKEN */
}, eP = {
  type: 25
  /* CDO_TOKEN */
}, tP = {
  type: 24
  /* CDC_TOKEN */
}, rP = {
  type: 26
  /* COLON_TOKEN */
}, AP = {
  type: 27
  /* SEMICOLON_TOKEN */
}, nP = {
  type: 28
  /* LEFT_SQUARE_BRACKET_TOKEN */
}, iP = {
  type: 29
  /* RIGHT_SQUARE_BRACKET_TOKEN */
}, sP = {
  type: 31
  /* WHITESPACE_TOKEN */
}, mm = {
  type: 32
  /* EOF_TOKEN */
}, Cx = (
  /** @class */
  (function() {
    function r() {
      this._value = [];
    }
    return r.prototype.write = function(e) {
      this._value = this._value.concat(kh(e));
    }, r.prototype.read = function() {
      for (var e = [], t = this.consumeToken(); t !== mm; )
        e.push(t), t = this.consumeToken();
      return e;
    }, r.prototype.consumeToken = function() {
      var e = this.consumeCodePoint();
      switch (e) {
        case Fc:
          return this.consumeStringToken(Fc);
        case sT:
          var t = this.peekCodePoint(0), A = this.peekCodePoint(1), n = this.peekCodePoint(2);
          if (Oy(t) || Us(A, n)) {
            var i = Lc(t, A, n) ? AT : rT, s = this.consumeName();
            return { type: 5, value: s, flags: i };
          }
          break;
        case aT:
          if (this.peekCodePoint(0) === dl)
            return this.consumeCodePoint(), jT;
          break;
        case _c:
          return this.consumeStringToken(_c);
        case Uc:
          return GT;
        case gl:
          return VT;
        case Ld:
          if (this.peekCodePoint(0) === dl)
            return this.consumeCodePoint(), $T;
          break;
        case ba:
          if (Nd(e, this.peekCodePoint(0), this.peekCodePoint(1)))
            return this.reconsumeCodePoint(e), this.consumeNumericToken();
          break;
        case BT:
          return KT;
        case tn:
          var a = e, o = this.peekCodePoint(0), l = this.peekCodePoint(1);
          if (Nd(a, o, l))
            return this.reconsumeCodePoint(e), this.consumeNumericToken();
          if (Lc(a, o, l))
            return this.reconsumeCodePoint(e), this.consumeIdentLikeToken();
          if (o === tn && l === hT)
            return this.consumeCodePoint(), this.consumeCodePoint(), tP;
          break;
        case Zl:
          if (Nd(e, this.peekCodePoint(0), this.peekCodePoint(1)))
            return this.reconsumeCodePoint(e), this.consumeNumericToken();
          break;
        case Ny:
          if (this.peekCodePoint(0) === Ld)
            for (this.consumeCodePoint(); ; ) {
              var u = this.consumeCodePoint();
              if (u === Ld && (u = this.consumeCodePoint(), u === Ny))
                return this.consumeToken();
              if (u === pi)
                return this.consumeToken();
            }
          break;
        case bT:
          return rP;
        case CT:
          return AP;
        case cT:
          if (this.peekCodePoint(0) === uT && this.peekCodePoint(1) === tn && this.peekCodePoint(2) === tn)
            return this.consumeCodePoint(), this.consumeCodePoint(), eP;
          break;
        case fT:
          var h = this.peekCodePoint(0), f = this.peekCodePoint(1), c = this.peekCodePoint(2);
          if (Lc(h, f, c)) {
            var s = this.consumeName();
            return { type: 7, value: s };
          }
          break;
        case dT:
          return nP;
        case Gl:
          if (Us(e, this.peekCodePoint(0)))
            return this.reconsumeCodePoint(e), this.consumeIdentLikeToken();
          break;
        case gT:
          return iP;
        case pT:
          if (this.peekCodePoint(0) === dl)
            return this.consumeCodePoint(), qT;
          break;
        case mT:
          return YT;
        case vT:
          return JT;
        case QT:
        case NT:
          var p = this.peekCodePoint(0), g = this.peekCodePoint(1);
          return p === ba && (so(g) || g === Ic) && (this.consumeCodePoint(), this.consumeUnicodeRangeToken()), this.reconsumeCodePoint(e), this.consumeIdentLikeToken();
        case Ty:
          if (this.peekCodePoint(0) === dl)
            return this.consumeCodePoint(), WT;
          if (this.peekCodePoint(0) === Ty)
            return this.consumeCodePoint(), zT;
          break;
        case wT:
          if (this.peekCodePoint(0) === dl)
            return this.consumeCodePoint(), XT;
          break;
        case pi:
          return mm;
      }
      return Qc(e) ? (this.consumeWhiteSpace(), sP) : PA(e) ? (this.reconsumeCodePoint(e), this.consumeNumericToken()) : yh(e) ? (this.reconsumeCodePoint(e), this.consumeIdentLikeToken()) : { type: 6, value: Kr(e) };
    }, r.prototype.consumeCodePoint = function() {
      var e = this._value.shift();
      return typeof e > "u" ? -1 : e;
    }, r.prototype.reconsumeCodePoint = function(e) {
      this._value.unshift(e);
    }, r.prototype.peekCodePoint = function(e) {
      return e >= this._value.length ? -1 : this._value[e];
    }, r.prototype.consumeUnicodeRangeToken = function() {
      for (var e = [], t = this.consumeCodePoint(); so(t) && e.length < 6; )
        e.push(t), t = this.consumeCodePoint();
      for (var A = !1; t === Ic && e.length < 6; )
        e.push(t), t = this.consumeCodePoint(), A = !0;
      if (A) {
        var n = parseInt(Kr.apply(void 0, e.map(function(o) {
          return o === Ic ? mx : o;
        })), 16), i = parseInt(Kr.apply(void 0, e.map(function(o) {
          return o === Ic ? bx : o;
        })), 16);
        return { type: 30, start: n, end: i };
      }
      var s = parseInt(Kr.apply(void 0, e), 16);
      if (this.peekCodePoint(0) === tn && so(this.peekCodePoint(1))) {
        this.consumeCodePoint(), t = this.consumeCodePoint();
        for (var a = []; so(t) && a.length < 6; )
          a.push(t), t = this.consumeCodePoint();
        var i = parseInt(Kr.apply(void 0, a), 16);
        return { type: 30, start: s, end: i };
      } else
        return { type: 30, start: s, end: s };
    }, r.prototype.consumeIdentLikeToken = function() {
      var e = this.consumeName();
      return e.toLowerCase() === "url" && this.peekCodePoint(0) === Uc ? (this.consumeCodePoint(), this.consumeUrlToken()) : this.peekCodePoint(0) === Uc ? (this.consumeCodePoint(), { type: 19, value: e }) : { type: 20, value: e };
    }, r.prototype.consumeUrlToken = function() {
      var e = [];
      if (this.consumeWhiteSpace(), this.peekCodePoint(0) === pi)
        return { type: 22, value: "" };
      var t = this.peekCodePoint(0);
      if (t === _c || t === Fc) {
        var A = this.consumeStringToken(this.consumeCodePoint());
        return A.type === 0 && (this.consumeWhiteSpace(), this.peekCodePoint(0) === pi || this.peekCodePoint(0) === gl) ? (this.consumeCodePoint(), { type: 22, value: A.value }) : (this.consumeBadUrlRemnants(), Nc);
      }
      for (; ; ) {
        var n = this.consumeCodePoint();
        if (n === pi || n === gl)
          return { type: 22, value: Kr.apply(void 0, e) };
        if (Qc(n))
          return this.consumeWhiteSpace(), this.peekCodePoint(0) === pi || this.peekCodePoint(0) === gl ? (this.consumeCodePoint(), { type: 22, value: Kr.apply(void 0, e) }) : (this.consumeBadUrlRemnants(), Nc);
        if (n === Fc || n === _c || n === Uc || HT(n))
          return this.consumeBadUrlRemnants(), Nc;
        if (n === Gl)
          if (Us(n, this.peekCodePoint(0)))
            e.push(this.consumeEscapedCodePoint());
          else
            return this.consumeBadUrlRemnants(), Nc;
        else
          e.push(n);
      }
    }, r.prototype.consumeWhiteSpace = function() {
      for (; Qc(this.peekCodePoint(0)); )
        this.consumeCodePoint();
    }, r.prototype.consumeBadUrlRemnants = function() {
      for (; ; ) {
        var e = this.consumeCodePoint();
        if (e === gl || e === pi)
          return;
        Us(e, this.peekCodePoint(0)) && this.consumeEscapedCodePoint();
      }
    }, r.prototype.consumeStringSlice = function(e) {
      for (var t = 5e4, A = ""; e > 0; ) {
        var n = Math.min(t, e);
        A += Kr.apply(void 0, this._value.splice(0, n)), e -= n;
      }
      return this._value.shift(), A;
    }, r.prototype.consumeStringToken = function(e) {
      var t = "", A = 0;
      do {
        var n = this._value[A];
        if (n === pi || n === void 0 || n === e)
          return t += this.consumeStringSlice(A), { type: 0, value: t };
        if (n === wh)
          return this._value.splice(0, A), ZT;
        if (n === Gl) {
          var i = this._value[A + 1];
          i !== pi && i !== void 0 && (i === wh ? (t += this.consumeStringSlice(A), A = -1, this._value.shift()) : Us(n, i) && (t += this.consumeStringSlice(A), t += Kr(this.consumeEscapedCodePoint()), A = -1));
        }
        A++;
      } while (!0);
    }, r.prototype.consumeNumber = function() {
      var e = [], t = gu, A = this.peekCodePoint(0);
      for ((A === ba || A === tn) && e.push(this.consumeCodePoint()); PA(this.peekCodePoint(0)); )
        e.push(this.consumeCodePoint());
      A = this.peekCodePoint(0);
      var n = this.peekCodePoint(1);
      if (A === Zl && PA(n))
        for (e.push(this.consumeCodePoint(), this.consumeCodePoint()), t = Ly; PA(this.peekCodePoint(0)); )
          e.push(this.consumeCodePoint());
      A = this.peekCodePoint(0), n = this.peekCodePoint(1);
      var i = this.peekCodePoint(2);
      if ((A === Bx || A === wx) && ((n === ba || n === tn) && PA(i) || PA(n)))
        for (e.push(this.consumeCodePoint(), this.consumeCodePoint()), t = Ly; PA(this.peekCodePoint(0)); )
          e.push(this.consumeCodePoint());
      return [DT(e), t];
    }, r.prototype.consumeNumericToken = function() {
      var e = this.consumeNumber(), t = e[0], A = e[1], n = this.peekCodePoint(0), i = this.peekCodePoint(1), s = this.peekCodePoint(2);
      if (Lc(n, i, s)) {
        var a = this.consumeName();
        return { type: 15, number: t, flags: A, unit: a };
      }
      return n === oT ? (this.consumeCodePoint(), { type: 16, number: t, flags: A }) : { type: 17, number: t, flags: A };
    }, r.prototype.consumeEscapedCodePoint = function() {
      var e = this.consumeCodePoint();
      if (so(e)) {
        for (var t = Kr(e); so(this.peekCodePoint(0)) && t.length < 6; )
          t += Kr(this.consumeCodePoint());
        Qc(this.peekCodePoint(0)) && this.consumeCodePoint();
        var A = parseInt(t, 16);
        return A === 0 || PT(A) || A > 1114111 ? Py : A;
      }
      return e === pi ? Py : e;
    }, r.prototype.consumeName = function() {
      for (var e = ""; ; ) {
        var t = this.consumeCodePoint();
        if (Oy(t))
          e += Kr(t);
        else if (Us(t, this.peekCodePoint(0)))
          e += Kr(this.consumeEscapedCodePoint());
        else
          return this.reconsumeCodePoint(t), e;
      }
    }, r;
  })()
), Sx = (
  /** @class */
  (function() {
    function r(e) {
      this._tokens = e;
    }
    return r.create = function(e) {
      var t = new Cx();
      return t.write(e), new r(t.read());
    }, r.parseValue = function(e) {
      return r.create(e).parseComponentValue();
    }, r.parseValues = function(e) {
      return r.create(e).parseComponentValues();
    }, r.prototype.parseComponentValue = function() {
      for (var e = this.consumeToken(); e.type === 31; )
        e = this.consumeToken();
      if (e.type === 32)
        throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
      this.reconsumeToken(e);
      var t = this.consumeComponentValue();
      do
        e = this.consumeToken();
      while (e.type === 31);
      if (e.type === 32)
        return t;
      throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
    }, r.prototype.parseComponentValues = function() {
      for (var e = []; ; ) {
        var t = this.consumeComponentValue();
        if (t.type === 32)
          return e;
        e.push(t), e.push();
      }
    }, r.prototype.consumeComponentValue = function() {
      var e = this.consumeToken();
      switch (e.type) {
        case 11:
        case 28:
        case 2:
          return this.consumeSimpleBlock(e.type);
        case 19:
          return this.consumeFunction(e);
      }
      return e;
    }, r.prototype.consumeSimpleBlock = function(e) {
      for (var t = { type: e, values: [] }, A = this.consumeToken(); ; ) {
        if (A.type === 32 || oP(A, e))
          return t;
        this.reconsumeToken(A), t.values.push(this.consumeComponentValue()), A = this.consumeToken();
      }
    }, r.prototype.consumeFunction = function(e) {
      for (var t = {
        name: e.value,
        values: [],
        type: 18
        /* FUNCTION */
      }; ; ) {
        var A = this.consumeToken();
        if (A.type === 32 || A.type === 3)
          return t;
        this.reconsumeToken(A), t.values.push(this.consumeComponentValue());
      }
    }, r.prototype.consumeToken = function() {
      var e = this._tokens.shift();
      return typeof e > "u" ? mm : e;
    }, r.prototype.reconsumeToken = function(e) {
      this._tokens.unshift(e);
    }, r;
  })()
), pu = function(r) {
  return r.type === 15;
}, Po = function(r) {
  return r.type === 17;
}, Ar = function(r) {
  return r.type === 20;
}, aP = function(r) {
  return r.type === 0;
}, vm = function(r, e) {
  return Ar(r) && r.value === e;
}, xx = function(r) {
  return r.type !== 31;
}, Io = function(r) {
  return r.type !== 31 && r.type !== 4;
}, bi = function(r) {
  var e = [], t = [];
  return r.forEach(function(A) {
    if (A.type === 4) {
      if (t.length === 0)
        throw new Error("Error parsing function args, zero tokens for arg");
      e.push(t), t = [];
      return;
    }
    A.type !== 31 && t.push(A);
  }), t.length && e.push(t), e;
}, oP = function(r, e) {
  return e === 11 && r.type === 12 || e === 28 && r.type === 29 ? !0 : e === 2 && r.type === 3;
}, Ds = function(r) {
  return r.type === 17 || r.type === 15;
}, nA = function(r) {
  return r.type === 16 || Ds(r);
}, Ex = function(r) {
  return r.length > 1 ? [r[0], r[1]] : [r[0]];
}, FA = {
  type: 17,
  number: 0,
  flags: gu
}, dv = {
  type: 16,
  number: 50,
  flags: gu
}, Ps = {
  type: 16,
  number: 100,
  flags: gu
}, Ql = function(r, e, t) {
  var A = r[0], n = r[1];
  return [dr(A, e), dr(typeof n < "u" ? n : A, t)];
}, dr = function(r, e) {
  if (r.type === 16)
    return r.number / 100 * e;
  if (pu(r))
    switch (r.unit) {
      case "rem":
      case "em":
        return 16 * r.number;
      // TODO use correct font-size
      case "px":
      default:
        return r.number;
    }
  return r.number;
}, Fx = "deg", _x = "grad", Ux = "rad", Ix = "turn", Hh = {
  name: "angle",
  parse: function(r, e) {
    if (e.type === 15)
      switch (e.unit) {
        case Fx:
          return Math.PI * e.number / 180;
        case _x:
          return Math.PI / 200 * e.number;
        case Ux:
          return e.number;
        case Ix:
          return Math.PI * 2 * e.number;
      }
    throw new Error("Unsupported angle type");
  }
}, Qx = function(r) {
  return r.type === 15 && (r.unit === Fx || r.unit === _x || r.unit === Ux || r.unit === Ix);
}, Lx = function(r) {
  var e = r.filter(Ar).map(function(t) {
    return t.value;
  }).join(" ");
  switch (e) {
    case "to bottom right":
    case "to right bottom":
    case "left top":
    case "top left":
      return [FA, FA];
    case "to top":
    case "bottom":
      return Pn(0);
    case "to bottom left":
    case "to left bottom":
    case "right top":
    case "top right":
      return [FA, Ps];
    case "to right":
    case "left":
      return Pn(90);
    case "to top left":
    case "to left top":
    case "right bottom":
    case "bottom right":
      return [Ps, Ps];
    case "to bottom":
    case "top":
      return Pn(180);
    case "to top right":
    case "to right top":
    case "left bottom":
    case "bottom left":
      return [Ps, FA];
    case "to left":
    case "right":
      return Pn(270);
  }
  return 0;
}, Pn = function(r) {
  return Math.PI * r / 180;
}, Ms = {
  name: "color",
  parse: function(r, e) {
    if (e.type === 18) {
      var t = lP[e.name];
      if (typeof t > "u")
        throw new Error('Attempting to parse an unsupported color function "' + e.name + '"');
      return t(r, e.values);
    }
    if (e.type === 5) {
      if (e.value.length === 3) {
        var A = e.value.substring(0, 1), n = e.value.substring(1, 2), i = e.value.substring(2, 3);
        return Os(parseInt(A + A, 16), parseInt(n + n, 16), parseInt(i + i, 16), 1);
      }
      if (e.value.length === 4) {
        var A = e.value.substring(0, 1), n = e.value.substring(1, 2), i = e.value.substring(2, 3), s = e.value.substring(3, 4);
        return Os(parseInt(A + A, 16), parseInt(n + n, 16), parseInt(i + i, 16), parseInt(s + s, 16) / 255);
      }
      if (e.value.length === 6) {
        var A = e.value.substring(0, 2), n = e.value.substring(2, 4), i = e.value.substring(4, 6);
        return Os(parseInt(A, 16), parseInt(n, 16), parseInt(i, 16), 1);
      }
      if (e.value.length === 8) {
        var A = e.value.substring(0, 2), n = e.value.substring(2, 4), i = e.value.substring(4, 6), s = e.value.substring(6, 8);
        return Os(parseInt(A, 16), parseInt(n, 16), parseInt(i, 16), parseInt(s, 16) / 255);
      }
    }
    if (e.type === 20) {
      var a = Zi[e.value.toUpperCase()];
      if (typeof a < "u")
        return a;
    }
    return Zi.TRANSPARENT;
  }
}, Rs = function(r) {
  return (255 & r) === 0;
}, gA = function(r) {
  var e = 255 & r, t = 255 & r >> 8, A = 255 & r >> 16, n = 255 & r >> 24;
  return e < 255 ? "rgba(" + n + "," + A + "," + t + "," + e / 255 + ")" : "rgb(" + n + "," + A + "," + t + ")";
}, Os = function(r, e, t, A) {
  return (r << 24 | e << 16 | t << 8 | Math.round(A * 255) << 0) >>> 0;
}, My = function(r, e) {
  if (r.type === 17)
    return r.number;
  if (r.type === 16) {
    var t = e === 3 ? 1 : 255;
    return e === 3 ? r.number / 100 * t : Math.round(r.number / 100 * t);
  }
  return 0;
}, Ry = function(r, e) {
  var t = e.filter(Io);
  if (t.length === 3) {
    var A = t.map(My), n = A[0], i = A[1], s = A[2];
    return Os(n, i, s, 1);
  }
  if (t.length === 4) {
    var a = t.map(My), n = a[0], i = a[1], s = a[2], o = a[3];
    return Os(n, i, s, o);
  }
  return 0;
};
function Td(r, e, t) {
  return t < 0 && (t += 1), t >= 1 && (t -= 1), t < 1 / 6 ? (e - r) * t * 6 + r : t < 1 / 2 ? e : t < 2 / 3 ? (e - r) * 6 * (2 / 3 - t) + r : r;
}
var ky = function(r, e) {
  var t = e.filter(Io), A = t[0], n = t[1], i = t[2], s = t[3], a = (A.type === 17 ? Pn(A.number) : Hh.parse(r, A)) / (Math.PI * 2), o = nA(n) ? n.number / 100 : 0, l = nA(i) ? i.number / 100 : 0, u = typeof s < "u" && nA(s) ? dr(s, 1) : 1;
  if (o === 0)
    return Os(l * 255, l * 255, l * 255, 1);
  var h = l <= 0.5 ? l * (o + 1) : l + o - l * o, f = l * 2 - h, c = Td(f, h, a + 1 / 3), p = Td(f, h, a), g = Td(f, h, a - 1 / 3);
  return Os(c * 255, p * 255, g * 255, u);
}, lP = {
  hsl: ky,
  hsla: ky,
  rgb: Ry,
  rgba: Ry
}, Vl = function(r, e) {
  return Ms.parse(r, Sx.create(e).parseComponentValue());
}, Zi = {
  ALICEBLUE: 4042850303,
  ANTIQUEWHITE: 4209760255,
  AQUA: 16777215,
  AQUAMARINE: 2147472639,
  AZURE: 4043309055,
  BEIGE: 4126530815,
  BISQUE: 4293182719,
  BLACK: 255,
  BLANCHEDALMOND: 4293643775,
  BLUE: 65535,
  BLUEVIOLET: 2318131967,
  BROWN: 2771004159,
  BURLYWOOD: 3736635391,
  CADETBLUE: 1604231423,
  CHARTREUSE: 2147418367,
  CHOCOLATE: 3530104575,
  CORAL: 4286533887,
  CORNFLOWERBLUE: 1687547391,
  CORNSILK: 4294499583,
  CRIMSON: 3692313855,
  CYAN: 16777215,
  DARKBLUE: 35839,
  DARKCYAN: 9145343,
  DARKGOLDENROD: 3095837695,
  DARKGRAY: 2846468607,
  DARKGREEN: 6553855,
  DARKGREY: 2846468607,
  DARKKHAKI: 3182914559,
  DARKMAGENTA: 2332068863,
  DARKOLIVEGREEN: 1433087999,
  DARKORANGE: 4287365375,
  DARKORCHID: 2570243327,
  DARKRED: 2332033279,
  DARKSALMON: 3918953215,
  DARKSEAGREEN: 2411499519,
  DARKSLATEBLUE: 1211993087,
  DARKSLATEGRAY: 793726975,
  DARKSLATEGREY: 793726975,
  DARKTURQUOISE: 13554175,
  DARKVIOLET: 2483082239,
  DEEPPINK: 4279538687,
  DEEPSKYBLUE: 12582911,
  DIMGRAY: 1768516095,
  DIMGREY: 1768516095,
  DODGERBLUE: 512819199,
  FIREBRICK: 2988581631,
  FLORALWHITE: 4294635775,
  FORESTGREEN: 579543807,
  FUCHSIA: 4278255615,
  GAINSBORO: 3705462015,
  GHOSTWHITE: 4177068031,
  GOLD: 4292280575,
  GOLDENROD: 3668254975,
  GRAY: 2155905279,
  GREEN: 8388863,
  GREENYELLOW: 2919182335,
  GREY: 2155905279,
  HONEYDEW: 4043305215,
  HOTPINK: 4285117695,
  INDIANRED: 3445382399,
  INDIGO: 1258324735,
  IVORY: 4294963455,
  KHAKI: 4041641215,
  LAVENDER: 3873897215,
  LAVENDERBLUSH: 4293981695,
  LAWNGREEN: 2096890111,
  LEMONCHIFFON: 4294626815,
  LIGHTBLUE: 2916673279,
  LIGHTCORAL: 4034953471,
  LIGHTCYAN: 3774873599,
  LIGHTGOLDENRODYELLOW: 4210742015,
  LIGHTGRAY: 3553874943,
  LIGHTGREEN: 2431553791,
  LIGHTGREY: 3553874943,
  LIGHTPINK: 4290167295,
  LIGHTSALMON: 4288707327,
  LIGHTSEAGREEN: 548580095,
  LIGHTSKYBLUE: 2278488831,
  LIGHTSLATEGRAY: 2005441023,
  LIGHTSLATEGREY: 2005441023,
  LIGHTSTEELBLUE: 2965692159,
  LIGHTYELLOW: 4294959359,
  LIME: 16711935,
  LIMEGREEN: 852308735,
  LINEN: 4210091775,
  MAGENTA: 4278255615,
  MAROON: 2147483903,
  MEDIUMAQUAMARINE: 1724754687,
  MEDIUMBLUE: 52735,
  MEDIUMORCHID: 3126187007,
  MEDIUMPURPLE: 2473647103,
  MEDIUMSEAGREEN: 1018393087,
  MEDIUMSLATEBLUE: 2070474495,
  MEDIUMSPRINGGREEN: 16423679,
  MEDIUMTURQUOISE: 1221709055,
  MEDIUMVIOLETRED: 3340076543,
  MIDNIGHTBLUE: 421097727,
  MINTCREAM: 4127193855,
  MISTYROSE: 4293190143,
  MOCCASIN: 4293178879,
  NAVAJOWHITE: 4292783615,
  NAVY: 33023,
  OLDLACE: 4260751103,
  OLIVE: 2155872511,
  OLIVEDRAB: 1804477439,
  ORANGE: 4289003775,
  ORANGERED: 4282712319,
  ORCHID: 3664828159,
  PALEGOLDENROD: 4008225535,
  PALEGREEN: 2566625535,
  PALETURQUOISE: 2951671551,
  PALEVIOLETRED: 3681588223,
  PAPAYAWHIP: 4293907967,
  PEACHPUFF: 4292524543,
  PERU: 3448061951,
  PINK: 4290825215,
  PLUM: 3718307327,
  POWDERBLUE: 2967529215,
  PURPLE: 2147516671,
  REBECCAPURPLE: 1714657791,
  RED: 4278190335,
  ROSYBROWN: 3163525119,
  ROYALBLUE: 1097458175,
  SADDLEBROWN: 2336560127,
  SALMON: 4202722047,
  SANDYBROWN: 4104413439,
  SEAGREEN: 780883967,
  SEASHELL: 4294307583,
  SIENNA: 2689740287,
  SILVER: 3233857791,
  SKYBLUE: 2278484991,
  SLATEBLUE: 1784335871,
  SLATEGRAY: 1887473919,
  SLATEGREY: 1887473919,
  SNOW: 4294638335,
  SPRINGGREEN: 16744447,
  STEELBLUE: 1182971135,
  TAN: 3535047935,
  TEAL: 8421631,
  THISTLE: 3636451583,
  TOMATO: 4284696575,
  TRANSPARENT: 0,
  TURQUOISE: 1088475391,
  VIOLET: 4001558271,
  WHEAT: 4125012991,
  WHITE: 4294967295,
  WHITESMOKE: 4126537215,
  YELLOW: 4294902015,
  YELLOWGREEN: 2597139199
}, uP = {
  name: "background-clip",
  initialValue: "border-box",
  prefix: !1,
  type: 1,
  parse: function(r, e) {
    return e.map(function(t) {
      if (Ar(t))
        switch (t.value) {
          case "padding-box":
            return 1;
          case "content-box":
            return 2;
        }
      return 0;
    });
  }
}, cP = {
  name: "background-color",
  initialValue: "transparent",
  prefix: !1,
  type: 3,
  format: "color"
}, Dh = function(r, e) {
  var t = Ms.parse(r, e[0]), A = e[1];
  return A && nA(A) ? { color: t, stop: A } : { color: t, stop: null };
}, Hy = function(r, e) {
  var t = r[0], A = r[r.length - 1];
  t.stop === null && (t.stop = FA), A.stop === null && (A.stop = Ps);
  for (var n = [], i = 0, s = 0; s < r.length; s++) {
    var a = r[s].stop;
    if (a !== null) {
      var o = dr(a, e);
      o > i ? n.push(o) : n.push(i), i = o;
    } else
      n.push(null);
  }
  for (var l = null, s = 0; s < n.length; s++) {
    var u = n[s];
    if (u === null)
      l === null && (l = s);
    else if (l !== null) {
      for (var h = s - l, f = n[l - 1], c = (u - f) / (h + 1), p = 1; p <= h; p++)
        n[l + p - 1] = c * p;
      l = null;
    }
  }
  return r.map(function(g, v) {
    var w = g.color;
    return { color: w, stop: Math.max(Math.min(1, n[v] / e), 0) };
  });
}, hP = function(r, e, t) {
  var A = e / 2, n = t / 2, i = dr(r[0], e) - A, s = n - dr(r[1], t);
  return (Math.atan2(s, i) + Math.PI * 2) % (Math.PI * 2);
}, fP = function(r, e, t) {
  var A = typeof r == "number" ? r : hP(r, e, t), n = Math.abs(e * Math.sin(A)) + Math.abs(t * Math.cos(A)), i = e / 2, s = t / 2, a = n / 2, o = Math.sin(A - Math.PI / 2) * a, l = Math.cos(A - Math.PI / 2) * a;
  return [n, i - l, i + l, s - o, s + o];
}, $n = function(r, e) {
  return Math.sqrt(r * r + e * e);
}, Dy = function(r, e, t, A, n) {
  var i = [
    [0, 0],
    [0, e],
    [r, 0],
    [r, e]
  ];
  return i.reduce(function(s, a) {
    var o = a[0], l = a[1], u = $n(t - o, A - l);
    return (n ? u < s.optimumDistance : u > s.optimumDistance) ? {
      optimumCorner: a,
      optimumDistance: u
    } : s;
  }, {
    optimumDistance: n ? 1 / 0 : -1 / 0,
    optimumCorner: null
  }).optimumCorner;
}, dP = function(r, e, t, A, n) {
  var i = 0, s = 0;
  switch (r.size) {
    case 0:
      r.shape === 0 ? i = s = Math.min(Math.abs(e), Math.abs(e - A), Math.abs(t), Math.abs(t - n)) : r.shape === 1 && (i = Math.min(Math.abs(e), Math.abs(e - A)), s = Math.min(Math.abs(t), Math.abs(t - n)));
      break;
    case 2:
      if (r.shape === 0)
        i = s = Math.min($n(e, t), $n(e, t - n), $n(e - A, t), $n(e - A, t - n));
      else if (r.shape === 1) {
        var a = Math.min(Math.abs(t), Math.abs(t - n)) / Math.min(Math.abs(e), Math.abs(e - A)), o = Dy(A, n, e, t, !0), l = o[0], u = o[1];
        i = $n(l - e, (u - t) / a), s = a * i;
      }
      break;
    case 1:
      r.shape === 0 ? i = s = Math.max(Math.abs(e), Math.abs(e - A), Math.abs(t), Math.abs(t - n)) : r.shape === 1 && (i = Math.max(Math.abs(e), Math.abs(e - A)), s = Math.max(Math.abs(t), Math.abs(t - n)));
      break;
    case 3:
      if (r.shape === 0)
        i = s = Math.max($n(e, t), $n(e, t - n), $n(e - A, t), $n(e - A, t - n));
      else if (r.shape === 1) {
        var a = Math.max(Math.abs(t), Math.abs(t - n)) / Math.max(Math.abs(e), Math.abs(e - A)), h = Dy(A, n, e, t, !1), l = h[0], u = h[1];
        i = $n(l - e, (u - t) / a), s = a * i;
      }
      break;
  }
  return Array.isArray(r.size) && (i = dr(r.size[0], A), s = r.size.length === 2 ? dr(r.size[1], n) : i), [i, s];
}, gP = function(r, e) {
  var t = Pn(180), A = [];
  return bi(e).forEach(function(n, i) {
    if (i === 0) {
      var s = n[0];
      if (s.type === 20 && s.value === "to") {
        t = Lx(n);
        return;
      } else if (Qx(s)) {
        t = Hh.parse(r, s);
        return;
      }
    }
    var a = Dh(r, n);
    A.push(a);
  }), {
    angle: t,
    stops: A,
    type: 1
    /* LINEAR_GRADIENT */
  };
}, Tc = function(r, e) {
  var t = Pn(180), A = [];
  return bi(e).forEach(function(n, i) {
    if (i === 0) {
      var s = n[0];
      if (s.type === 20 && ["top", "left", "right", "bottom"].indexOf(s.value) !== -1) {
        t = Lx(n);
        return;
      } else if (Qx(s)) {
        t = (Hh.parse(r, s) + Pn(270)) % Pn(360);
        return;
      }
    }
    var a = Dh(r, n);
    A.push(a);
  }), {
    angle: t,
    stops: A,
    type: 1
    /* LINEAR_GRADIENT */
  };
}, pP = function(r, e) {
  var t = Pn(180), A = [], n = 1, i = 0, s = 3, a = [];
  return bi(e).forEach(function(o, l) {
    var u = o[0];
    if (l === 0) {
      if (Ar(u) && u.value === "linear") {
        n = 1;
        return;
      } else if (Ar(u) && u.value === "radial") {
        n = 2;
        return;
      }
    }
    if (u.type === 18) {
      if (u.name === "from") {
        var h = Ms.parse(r, u.values[0]);
        A.push({ stop: FA, color: h });
      } else if (u.name === "to") {
        var h = Ms.parse(r, u.values[0]);
        A.push({ stop: Ps, color: h });
      } else if (u.name === "color-stop") {
        var f = u.values.filter(Io);
        if (f.length === 2) {
          var h = Ms.parse(r, f[1]), c = f[0];
          Po(c) && A.push({
            stop: { type: 16, number: c.number * 100, flags: c.flags },
            color: h
          });
        }
      }
    }
  }), n === 1 ? {
    angle: (t + Pn(180)) % Pn(360),
    stops: A,
    type: n
  } : { size: s, shape: i, stops: A, position: a, type: n };
}, Nx = "closest-side", Tx = "farthest-side", Px = "closest-corner", Ox = "farthest-corner", Mx = "circle", Rx = "ellipse", kx = "cover", Hx = "contain", mP = function(r, e) {
  var t = 0, A = 3, n = [], i = [];
  return bi(e).forEach(function(s, a) {
    var o = !0;
    if (a === 0) {
      var l = !1;
      o = s.reduce(function(h, f) {
        if (l)
          if (Ar(f))
            switch (f.value) {
              case "center":
                return i.push(dv), h;
              case "top":
              case "left":
                return i.push(FA), h;
              case "right":
              case "bottom":
                return i.push(Ps), h;
            }
          else (nA(f) || Ds(f)) && i.push(f);
        else if (Ar(f))
          switch (f.value) {
            case Mx:
              return t = 0, !1;
            case Rx:
              return t = 1, !1;
            case "at":
              return l = !0, !1;
            case Nx:
              return A = 0, !1;
            case kx:
            case Tx:
              return A = 1, !1;
            case Hx:
            case Px:
              return A = 2, !1;
            case Ox:
              return A = 3, !1;
          }
        else if (Ds(f) || nA(f))
          return Array.isArray(A) || (A = []), A.push(f), !1;
        return h;
      }, o);
    }
    if (o) {
      var u = Dh(r, s);
      n.push(u);
    }
  }), {
    size: A,
    shape: t,
    stops: n,
    position: i,
    type: 2
    /* RADIAL_GRADIENT */
  };
}, Pc = function(r, e) {
  var t = 0, A = 3, n = [], i = [];
  return bi(e).forEach(function(s, a) {
    var o = !0;
    if (a === 0 ? o = s.reduce(function(u, h) {
      if (Ar(h))
        switch (h.value) {
          case "center":
            return i.push(dv), !1;
          case "top":
          case "left":
            return i.push(FA), !1;
          case "right":
          case "bottom":
            return i.push(Ps), !1;
        }
      else if (nA(h) || Ds(h))
        return i.push(h), !1;
      return u;
    }, o) : a === 1 && (o = s.reduce(function(u, h) {
      if (Ar(h))
        switch (h.value) {
          case Mx:
            return t = 0, !1;
          case Rx:
            return t = 1, !1;
          case Hx:
          case Nx:
            return A = 0, !1;
          case Tx:
            return A = 1, !1;
          case Px:
            return A = 2, !1;
          case kx:
          case Ox:
            return A = 3, !1;
        }
      else if (Ds(h) || nA(h))
        return Array.isArray(A) || (A = []), A.push(h), !1;
      return u;
    }, o)), o) {
      var l = Dh(r, s);
      n.push(l);
    }
  }), {
    size: A,
    shape: t,
    stops: n,
    position: i,
    type: 2
    /* RADIAL_GRADIENT */
  };
}, vP = function(r) {
  return r.type === 1;
}, wP = function(r) {
  return r.type === 2;
}, gv = {
  name: "image",
  parse: function(r, e) {
    if (e.type === 22) {
      var t = {
        url: e.value,
        type: 0
        /* URL */
      };
      return r.cache.addImage(e.value), t;
    }
    if (e.type === 18) {
      var A = Dx[e.name];
      if (typeof A > "u")
        throw new Error('Attempting to parse an unsupported image function "' + e.name + '"');
      return A(r, e.values);
    }
    throw new Error("Unsupported image type " + e.type);
  }
};
function yP(r) {
  return !(r.type === 20 && r.value === "none") && (r.type !== 18 || !!Dx[r.name]);
}
var Dx = {
  "linear-gradient": gP,
  "-moz-linear-gradient": Tc,
  "-ms-linear-gradient": Tc,
  "-o-linear-gradient": Tc,
  "-webkit-linear-gradient": Tc,
  "radial-gradient": mP,
  "-moz-radial-gradient": Pc,
  "-ms-radial-gradient": Pc,
  "-o-radial-gradient": Pc,
  "-webkit-radial-gradient": Pc,
  "-webkit-gradient": pP
}, BP = {
  name: "background-image",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: function(r, e) {
    if (e.length === 0)
      return [];
    var t = e[0];
    return t.type === 20 && t.value === "none" ? [] : e.filter(function(A) {
      return Io(A) && yP(A);
    }).map(function(A) {
      return gv.parse(r, A);
    });
  }
}, bP = {
  name: "background-origin",
  initialValue: "border-box",
  prefix: !1,
  type: 1,
  parse: function(r, e) {
    return e.map(function(t) {
      if (Ar(t))
        switch (t.value) {
          case "padding-box":
            return 1;
          case "content-box":
            return 2;
        }
      return 0;
    });
  }
}, CP = {
  name: "background-position",
  initialValue: "0% 0%",
  type: 1,
  prefix: !1,
  parse: function(r, e) {
    return bi(e).map(function(t) {
      return t.filter(nA);
    }).map(Ex);
  }
}, SP = {
  name: "background-repeat",
  initialValue: "repeat",
  prefix: !1,
  type: 1,
  parse: function(r, e) {
    return bi(e).map(function(t) {
      return t.filter(Ar).map(function(A) {
        return A.value;
      }).join(" ");
    }).map(xP);
  }
}, xP = function(r) {
  switch (r) {
    case "no-repeat":
      return 1;
    case "repeat-x":
    case "repeat no-repeat":
      return 2;
    case "repeat-y":
    case "no-repeat repeat":
      return 3;
    case "repeat":
    default:
      return 0;
  }
}, Eo;
(function(r) {
  r.AUTO = "auto", r.CONTAIN = "contain", r.COVER = "cover";
})(Eo || (Eo = {}));
var EP = {
  name: "background-size",
  initialValue: "0",
  prefix: !1,
  type: 1,
  parse: function(r, e) {
    return bi(e).map(function(t) {
      return t.filter(FP);
    });
  }
}, FP = function(r) {
  return Ar(r) || nA(r);
}, Gh = function(r) {
  return {
    name: "border-" + r + "-color",
    initialValue: "transparent",
    prefix: !1,
    type: 3,
    format: "color"
  };
}, _P = Gh("top"), UP = Gh("right"), IP = Gh("bottom"), QP = Gh("left"), Vh = function(r) {
  return {
    name: "border-radius-" + r,
    initialValue: "0 0",
    prefix: !1,
    type: 1,
    parse: function(e, t) {
      return Ex(t.filter(nA));
    }
  };
}, LP = Vh("top-left"), NP = Vh("top-right"), TP = Vh("bottom-right"), PP = Vh("bottom-left"), Kh = function(r) {
  return {
    name: "border-" + r + "-style",
    initialValue: "solid",
    prefix: !1,
    type: 2,
    parse: function(e, t) {
      switch (t) {
        case "none":
          return 0;
        case "dashed":
          return 2;
        case "dotted":
          return 3;
        case "double":
          return 4;
      }
      return 1;
    }
  };
}, OP = Kh("top"), MP = Kh("right"), RP = Kh("bottom"), kP = Kh("left"), jh = function(r) {
  return {
    name: "border-" + r + "-width",
    initialValue: "0",
    type: 0,
    prefix: !1,
    parse: function(e, t) {
      return pu(t) ? t.number : 0;
    }
  };
}, HP = jh("top"), DP = jh("right"), GP = jh("bottom"), VP = jh("left"), KP = {
  name: "color",
  initialValue: "transparent",
  prefix: !1,
  type: 3,
  format: "color"
}, jP = {
  name: "direction",
  initialValue: "ltr",
  prefix: !1,
  type: 2,
  parse: function(r, e) {
    switch (e) {
      case "rtl":
        return 1;
      case "ltr":
      default:
        return 0;
    }
  }
}, qP = {
  name: "display",
  initialValue: "inline-block",
  prefix: !1,
  type: 1,
  parse: function(r, e) {
    return e.filter(Ar).reduce(
      function(t, A) {
        return t | zP(A.value);
      },
      0
      /* NONE */
    );
  }
}, zP = function(r) {
  switch (r) {
    case "block":
    case "-webkit-box":
      return 2;
    case "inline":
      return 4;
    case "run-in":
      return 8;
    case "flow":
      return 16;
    case "flow-root":
      return 32;
    case "table":
      return 64;
    case "flex":
    case "-webkit-flex":
      return 128;
    case "grid":
    case "-ms-grid":
      return 256;
    case "ruby":
      return 512;
    case "subgrid":
      return 1024;
    case "list-item":
      return 2048;
    case "table-row-group":
      return 4096;
    case "table-header-group":
      return 8192;
    case "table-footer-group":
      return 16384;
    case "table-row":
      return 32768;
    case "table-cell":
      return 65536;
    case "table-column-group":
      return 131072;
    case "table-column":
      return 262144;
    case "table-caption":
      return 524288;
    case "ruby-base":
      return 1048576;
    case "ruby-text":
      return 2097152;
    case "ruby-base-container":
      return 4194304;
    case "ruby-text-container":
      return 8388608;
    case "contents":
      return 16777216;
    case "inline-block":
      return 33554432;
    case "inline-list-item":
      return 67108864;
    case "inline-table":
      return 134217728;
    case "inline-flex":
      return 268435456;
    case "inline-grid":
      return 536870912;
  }
  return 0;
}, WP = {
  name: "float",
  initialValue: "none",
  prefix: !1,
  type: 2,
  parse: function(r, e) {
    switch (e) {
      case "left":
        return 1;
      case "right":
        return 2;
      case "inline-start":
        return 3;
      case "inline-end":
        return 4;
    }
    return 0;
  }
}, XP = {
  name: "letter-spacing",
  initialValue: "0",
  prefix: !1,
  type: 0,
  parse: function(r, e) {
    return e.type === 20 && e.value === "normal" ? 0 : e.type === 17 || e.type === 15 ? e.number : 0;
  }
}, Bh;
(function(r) {
  r.NORMAL = "normal", r.STRICT = "strict";
})(Bh || (Bh = {}));
var YP = {
  name: "line-break",
  initialValue: "normal",
  prefix: !1,
  type: 2,
  parse: function(r, e) {
    switch (e) {
      case "strict":
        return Bh.STRICT;
      case "normal":
      default:
        return Bh.NORMAL;
    }
  }
}, JP = {
  name: "line-height",
  initialValue: "normal",
  prefix: !1,
  type: 4
  /* TOKEN_VALUE */
}, Gy = function(r, e) {
  return Ar(r) && r.value === "normal" ? 1.2 * e : r.type === 17 ? e * r.number : nA(r) ? dr(r, e) : e;
}, $P = {
  name: "list-style-image",
  initialValue: "none",
  type: 0,
  prefix: !1,
  parse: function(r, e) {
    return e.type === 20 && e.value === "none" ? null : gv.parse(r, e);
  }
}, ZP = {
  name: "list-style-position",
  initialValue: "outside",
  prefix: !1,
  type: 2,
  parse: function(r, e) {
    switch (e) {
      case "inside":
        return 0;
      case "outside":
      default:
        return 1;
    }
  }
}, wm = {
  name: "list-style-type",
  initialValue: "none",
  prefix: !1,
  type: 2,
  parse: function(r, e) {
    switch (e) {
      case "disc":
        return 0;
      case "circle":
        return 1;
      case "square":
        return 2;
      case "decimal":
        return 3;
      case "cjk-decimal":
        return 4;
      case "decimal-leading-zero":
        return 5;
      case "lower-roman":
        return 6;
      case "upper-roman":
        return 7;
      case "lower-greek":
        return 8;
      case "lower-alpha":
        return 9;
      case "upper-alpha":
        return 10;
      case "arabic-indic":
        return 11;
      case "armenian":
        return 12;
      case "bengali":
        return 13;
      case "cambodian":
        return 14;
      case "cjk-earthly-branch":
        return 15;
      case "cjk-heavenly-stem":
        return 16;
      case "cjk-ideographic":
        return 17;
      case "devanagari":
        return 18;
      case "ethiopic-numeric":
        return 19;
      case "georgian":
        return 20;
      case "gujarati":
        return 21;
      case "gurmukhi":
        return 22;
      case "hebrew":
        return 22;
      case "hiragana":
        return 23;
      case "hiragana-iroha":
        return 24;
      case "japanese-formal":
        return 25;
      case "japanese-informal":
        return 26;
      case "kannada":
        return 27;
      case "katakana":
        return 28;
      case "katakana-iroha":
        return 29;
      case "khmer":
        return 30;
      case "korean-hangul-formal":
        return 31;
      case "korean-hanja-formal":
        return 32;
      case "korean-hanja-informal":
        return 33;
      case "lao":
        return 34;
      case "lower-armenian":
        return 35;
      case "malayalam":
        return 36;
      case "mongolian":
        return 37;
      case "myanmar":
        return 38;
      case "oriya":
        return 39;
      case "persian":
        return 40;
      case "simp-chinese-formal":
        return 41;
      case "simp-chinese-informal":
        return 42;
      case "tamil":
        return 43;
      case "telugu":
        return 44;
      case "thai":
        return 45;
      case "tibetan":
        return 46;
      case "trad-chinese-formal":
        return 47;
      case "trad-chinese-informal":
        return 48;
      case "upper-armenian":
        return 49;
      case "disclosure-open":
        return 50;
      case "disclosure-closed":
        return 51;
      case "none":
      default:
        return -1;
    }
  }
}, qh = function(r) {
  return {
    name: "margin-" + r,
    initialValue: "0",
    prefix: !1,
    type: 4
    /* TOKEN_VALUE */
  };
}, eO = qh("top"), tO = qh("right"), rO = qh("bottom"), AO = qh("left"), nO = {
  name: "overflow",
  initialValue: "visible",
  prefix: !1,
  type: 1,
  parse: function(r, e) {
    return e.filter(Ar).map(function(t) {
      switch (t.value) {
        case "hidden":
          return 1;
        case "scroll":
          return 2;
        case "clip":
          return 3;
        case "auto":
          return 4;
        case "visible":
        default:
          return 0;
      }
    });
  }
}, iO = {
  name: "overflow-wrap",
  initialValue: "normal",
  prefix: !1,
  type: 2,
  parse: function(r, e) {
    switch (e) {
      case "break-word":
        return "break-word";
      case "normal":
      default:
        return "normal";
    }
  }
}, zh = function(r) {
  return {
    name: "padding-" + r,
    initialValue: "0",
    prefix: !1,
    type: 3,
    format: "length-percentage"
  };
}, sO = zh("top"), aO = zh("right"), oO = zh("bottom"), lO = zh("left"), uO = {
  name: "text-align",
  initialValue: "left",
  prefix: !1,
  type: 2,
  parse: function(r, e) {
    switch (e) {
      case "right":
        return 2;
      case "center":
      case "justify":
        return 1;
      case "left":
      default:
        return 0;
    }
  }
}, cO = {
  name: "position",
  initialValue: "static",
  prefix: !1,
  type: 2,
  parse: function(r, e) {
    switch (e) {
      case "relative":
        return 1;
      case "absolute":
        return 2;
      case "fixed":
        return 3;
      case "sticky":
        return 4;
    }
    return 0;
  }
}, hO = {
  name: "text-shadow",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: function(r, e) {
    return e.length === 1 && vm(e[0], "none") ? [] : bi(e).map(function(t) {
      for (var A = {
        color: Zi.TRANSPARENT,
        offsetX: FA,
        offsetY: FA,
        blur: FA
      }, n = 0, i = 0; i < t.length; i++) {
        var s = t[i];
        Ds(s) ? (n === 0 ? A.offsetX = s : n === 1 ? A.offsetY = s : A.blur = s, n++) : A.color = Ms.parse(r, s);
      }
      return A;
    });
  }
}, fO = {
  name: "text-transform",
  initialValue: "none",
  prefix: !1,
  type: 2,
  parse: function(r, e) {
    switch (e) {
      case "uppercase":
        return 2;
      case "lowercase":
        return 1;
      case "capitalize":
        return 3;
    }
    return 0;
  }
}, dO = {
  name: "transform",
  initialValue: "none",
  prefix: !0,
  type: 0,
  parse: function(r, e) {
    if (e.type === 20 && e.value === "none")
      return null;
    if (e.type === 18) {
      var t = mO[e.name];
      if (typeof t > "u")
        throw new Error('Attempting to parse an unsupported transform function "' + e.name + '"');
      return t(e.values);
    }
    return null;
  }
}, gO = function(r) {
  var e = r.filter(function(t) {
    return t.type === 17;
  }).map(function(t) {
    return t.number;
  });
  return e.length === 6 ? e : null;
}, pO = function(r) {
  var e = r.filter(function(o) {
    return o.type === 17;
  }).map(function(o) {
    return o.number;
  }), t = e[0], A = e[1];
  e[2], e[3];
  var n = e[4], i = e[5];
  e[6], e[7], e[8], e[9], e[10], e[11];
  var s = e[12], a = e[13];
  return e[14], e[15], e.length === 16 ? [t, A, n, i, s, a] : null;
}, mO = {
  matrix: gO,
  matrix3d: pO
}, Vy = {
  type: 16,
  number: 50,
  flags: gu
}, vO = [Vy, Vy], wO = {
  name: "transform-origin",
  initialValue: "50% 50%",
  prefix: !0,
  type: 1,
  parse: function(r, e) {
    var t = e.filter(nA);
    return t.length !== 2 ? vO : [t[0], t[1]];
  }
}, yO = {
  name: "visible",
  initialValue: "none",
  prefix: !1,
  type: 2,
  parse: function(r, e) {
    switch (e) {
      case "hidden":
        return 1;
      case "collapse":
        return 2;
      case "visible":
      default:
        return 0;
    }
  }
}, Kl;
(function(r) {
  r.NORMAL = "normal", r.BREAK_ALL = "break-all", r.KEEP_ALL = "keep-all";
})(Kl || (Kl = {}));
var BO = {
  name: "word-break",
  initialValue: "normal",
  prefix: !1,
  type: 2,
  parse: function(r, e) {
    switch (e) {
      case "break-all":
        return Kl.BREAK_ALL;
      case "keep-all":
        return Kl.KEEP_ALL;
      case "normal":
      default:
        return Kl.NORMAL;
    }
  }
}, bO = {
  name: "z-index",
  initialValue: "auto",
  prefix: !1,
  type: 0,
  parse: function(r, e) {
    if (e.type === 20)
      return { auto: !0, order: 0 };
    if (Po(e))
      return { auto: !1, order: e.number };
    throw new Error("Invalid z-index number parsed");
  }
}, Gx = {
  name: "time",
  parse: function(r, e) {
    if (e.type === 15)
      switch (e.unit.toLowerCase()) {
        case "s":
          return 1e3 * e.number;
        case "ms":
          return e.number;
      }
    throw new Error("Unsupported time type");
  }
}, CO = {
  name: "opacity",
  initialValue: "1",
  type: 0,
  prefix: !1,
  parse: function(r, e) {
    return Po(e) ? e.number : 1;
  }
}, SO = {
  name: "text-decoration-color",
  initialValue: "transparent",
  prefix: !1,
  type: 3,
  format: "color"
}, xO = {
  name: "text-decoration-line",
  initialValue: "none",
  prefix: !1,
  type: 1,
  parse: function(r, e) {
    return e.filter(Ar).map(function(t) {
      switch (t.value) {
        case "underline":
          return 1;
        case "overline":
          return 2;
        case "line-through":
          return 3;
        case "none":
          return 4;
      }
      return 0;
    }).filter(function(t) {
      return t !== 0;
    });
  }
}, EO = {
  name: "font-family",
  initialValue: "",
  prefix: !1,
  type: 1,
  parse: function(r, e) {
    var t = [], A = [];
    return e.forEach(function(n) {
      switch (n.type) {
        case 20:
        case 0:
          t.push(n.value);
          break;
        case 17:
          t.push(n.number.toString());
          break;
        case 4:
          A.push(t.join(" ")), t.length = 0;
          break;
      }
    }), t.length && A.push(t.join(" ")), A.map(function(n) {
      return n.indexOf(" ") === -1 ? n : "'" + n + "'";
    });
  }
}, FO = {
  name: "font-size",
  initialValue: "0",
  prefix: !1,
  type: 3,
  format: "length"
}, _O = {
  name: "font-weight",
  initialValue: "normal",
  type: 0,
  prefix: !1,
  parse: function(r, e) {
    if (Po(e))
      return e.number;
    if (Ar(e))
      switch (e.value) {
        case "bold":
          return 700;
        case "normal":
        default:
          return 400;
      }
    return 400;
  }
}, UO = {
  name: "font-variant",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: function(r, e) {
    return e.filter(Ar).map(function(t) {
      return t.value;
    });
  }
}, IO = {
  name: "font-style",
  initialValue: "normal",
  prefix: !1,
  type: 2,
  parse: function(r, e) {
    switch (e) {
      case "oblique":
        return "oblique";
      case "italic":
        return "italic";
      case "normal":
      default:
        return "normal";
    }
  }
}, hA = function(r, e) {
  return (r & e) !== 0;
}, QO = {
  name: "content",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: function(r, e) {
    if (e.length === 0)
      return [];
    var t = e[0];
    return t.type === 20 && t.value === "none" ? [] : e;
  }
}, LO = {
  name: "counter-increment",
  initialValue: "none",
  prefix: !0,
  type: 1,
  parse: function(r, e) {
    if (e.length === 0)
      return null;
    var t = e[0];
    if (t.type === 20 && t.value === "none")
      return null;
    for (var A = [], n = e.filter(xx), i = 0; i < n.length; i++) {
      var s = n[i], a = n[i + 1];
      if (s.type === 20) {
        var o = a && Po(a) ? a.number : 1;
        A.push({ counter: s.value, increment: o });
      }
    }
    return A;
  }
}, NO = {
  name: "counter-reset",
  initialValue: "none",
  prefix: !0,
  type: 1,
  parse: function(r, e) {
    if (e.length === 0)
      return [];
    for (var t = [], A = e.filter(xx), n = 0; n < A.length; n++) {
      var i = A[n], s = A[n + 1];
      if (Ar(i) && i.value !== "none") {
        var a = s && Po(s) ? s.number : 0;
        t.push({ counter: i.value, reset: a });
      }
    }
    return t;
  }
}, TO = {
  name: "duration",
  initialValue: "0s",
  prefix: !1,
  type: 1,
  parse: function(r, e) {
    return e.filter(pu).map(function(t) {
      return Gx.parse(r, t);
    });
  }
}, PO = {
  name: "quotes",
  initialValue: "none",
  prefix: !0,
  type: 1,
  parse: function(r, e) {
    if (e.length === 0)
      return null;
    var t = e[0];
    if (t.type === 20 && t.value === "none")
      return null;
    var A = [], n = e.filter(aP);
    if (n.length % 2 !== 0)
      return null;
    for (var i = 0; i < n.length; i += 2) {
      var s = n[i].value, a = n[i + 1].value;
      A.push({ open: s, close: a });
    }
    return A;
  }
}, Ky = function(r, e, t) {
  if (!r)
    return "";
  var A = r[Math.min(e, r.length - 1)];
  return A ? t ? A.open : A.close : "";
}, OO = {
  name: "box-shadow",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: function(r, e) {
    return e.length === 1 && vm(e[0], "none") ? [] : bi(e).map(function(t) {
      for (var A = {
        color: 255,
        offsetX: FA,
        offsetY: FA,
        blur: FA,
        spread: FA,
        inset: !1
      }, n = 0, i = 0; i < t.length; i++) {
        var s = t[i];
        vm(s, "inset") ? A.inset = !0 : Ds(s) ? (n === 0 ? A.offsetX = s : n === 1 ? A.offsetY = s : n === 2 ? A.blur = s : A.spread = s, n++) : A.color = Ms.parse(r, s);
      }
      return A;
    });
  }
}, MO = {
  name: "paint-order",
  initialValue: "normal",
  prefix: !1,
  type: 1,
  parse: function(r, e) {
    var t = [
      0,
      1,
      2
      /* MARKERS */
    ], A = [];
    return e.filter(Ar).forEach(function(n) {
      switch (n.value) {
        case "stroke":
          A.push(
            1
            /* STROKE */
          );
          break;
        case "fill":
          A.push(
            0
            /* FILL */
          );
          break;
        case "markers":
          A.push(
            2
            /* MARKERS */
          );
          break;
      }
    }), t.forEach(function(n) {
      A.indexOf(n) === -1 && A.push(n);
    }), A;
  }
}, RO = {
  name: "-webkit-text-stroke-color",
  initialValue: "currentcolor",
  prefix: !1,
  type: 3,
  format: "color"
}, kO = {
  name: "-webkit-text-stroke-width",
  initialValue: "0",
  type: 0,
  prefix: !1,
  parse: function(r, e) {
    return pu(e) ? e.number : 0;
  }
}, HO = (
  /** @class */
  (function() {
    function r(e, t) {
      var A, n;
      this.animationDuration = Ye(e, TO, t.animationDuration), this.backgroundClip = Ye(e, uP, t.backgroundClip), this.backgroundColor = Ye(e, cP, t.backgroundColor), this.backgroundImage = Ye(e, BP, t.backgroundImage), this.backgroundOrigin = Ye(e, bP, t.backgroundOrigin), this.backgroundPosition = Ye(e, CP, t.backgroundPosition), this.backgroundRepeat = Ye(e, SP, t.backgroundRepeat), this.backgroundSize = Ye(e, EP, t.backgroundSize), this.borderTopColor = Ye(e, _P, t.borderTopColor), this.borderRightColor = Ye(e, UP, t.borderRightColor), this.borderBottomColor = Ye(e, IP, t.borderBottomColor), this.borderLeftColor = Ye(e, QP, t.borderLeftColor), this.borderTopLeftRadius = Ye(e, LP, t.borderTopLeftRadius), this.borderTopRightRadius = Ye(e, NP, t.borderTopRightRadius), this.borderBottomRightRadius = Ye(e, TP, t.borderBottomRightRadius), this.borderBottomLeftRadius = Ye(e, PP, t.borderBottomLeftRadius), this.borderTopStyle = Ye(e, OP, t.borderTopStyle), this.borderRightStyle = Ye(e, MP, t.borderRightStyle), this.borderBottomStyle = Ye(e, RP, t.borderBottomStyle), this.borderLeftStyle = Ye(e, kP, t.borderLeftStyle), this.borderTopWidth = Ye(e, HP, t.borderTopWidth), this.borderRightWidth = Ye(e, DP, t.borderRightWidth), this.borderBottomWidth = Ye(e, GP, t.borderBottomWidth), this.borderLeftWidth = Ye(e, VP, t.borderLeftWidth), this.boxShadow = Ye(e, OO, t.boxShadow), this.color = Ye(e, KP, t.color), this.direction = Ye(e, jP, t.direction), this.display = Ye(e, qP, t.display), this.float = Ye(e, WP, t.cssFloat), this.fontFamily = Ye(e, EO, t.fontFamily), this.fontSize = Ye(e, FO, t.fontSize), this.fontStyle = Ye(e, IO, t.fontStyle), this.fontVariant = Ye(e, UO, t.fontVariant), this.fontWeight = Ye(e, _O, t.fontWeight), this.letterSpacing = Ye(e, XP, t.letterSpacing), this.lineBreak = Ye(e, YP, t.lineBreak), this.lineHeight = Ye(e, JP, t.lineHeight), this.listStyleImage = Ye(e, $P, t.listStyleImage), this.listStylePosition = Ye(e, ZP, t.listStylePosition), this.listStyleType = Ye(e, wm, t.listStyleType), this.marginTop = Ye(e, eO, t.marginTop), this.marginRight = Ye(e, tO, t.marginRight), this.marginBottom = Ye(e, rO, t.marginBottom), this.marginLeft = Ye(e, AO, t.marginLeft), this.opacity = Ye(e, CO, t.opacity);
      var i = Ye(e, nO, t.overflow);
      this.overflowX = i[0], this.overflowY = i[i.length > 1 ? 1 : 0], this.overflowWrap = Ye(e, iO, t.overflowWrap), this.paddingTop = Ye(e, sO, t.paddingTop), this.paddingRight = Ye(e, aO, t.paddingRight), this.paddingBottom = Ye(e, oO, t.paddingBottom), this.paddingLeft = Ye(e, lO, t.paddingLeft), this.paintOrder = Ye(e, MO, t.paintOrder), this.position = Ye(e, cO, t.position), this.textAlign = Ye(e, uO, t.textAlign), this.textDecorationColor = Ye(e, SO, (A = t.textDecorationColor) !== null && A !== void 0 ? A : t.color), this.textDecorationLine = Ye(e, xO, (n = t.textDecorationLine) !== null && n !== void 0 ? n : t.textDecoration), this.textShadow = Ye(e, hO, t.textShadow), this.textTransform = Ye(e, fO, t.textTransform), this.transform = Ye(e, dO, t.transform), this.transformOrigin = Ye(e, wO, t.transformOrigin), this.visibility = Ye(e, yO, t.visibility), this.webkitTextStrokeColor = Ye(e, RO, t.webkitTextStrokeColor), this.webkitTextStrokeWidth = Ye(e, kO, t.webkitTextStrokeWidth), this.wordBreak = Ye(e, BO, t.wordBreak), this.zIndex = Ye(e, bO, t.zIndex);
    }
    return r.prototype.isVisible = function() {
      return this.display > 0 && this.opacity > 0 && this.visibility === 0;
    }, r.prototype.isTransparent = function() {
      return Rs(this.backgroundColor);
    }, r.prototype.isTransformed = function() {
      return this.transform !== null;
    }, r.prototype.isPositioned = function() {
      return this.position !== 0;
    }, r.prototype.isPositionedWithZIndex = function() {
      return this.isPositioned() && !this.zIndex.auto;
    }, r.prototype.isFloating = function() {
      return this.float !== 0;
    }, r.prototype.isInlineLevel = function() {
      return hA(
        this.display,
        4
        /* INLINE */
      ) || hA(
        this.display,
        33554432
        /* INLINE_BLOCK */
      ) || hA(
        this.display,
        268435456
        /* INLINE_FLEX */
      ) || hA(
        this.display,
        536870912
        /* INLINE_GRID */
      ) || hA(
        this.display,
        67108864
        /* INLINE_LIST_ITEM */
      ) || hA(
        this.display,
        134217728
        /* INLINE_TABLE */
      );
    }, r;
  })()
), DO = (
  /** @class */
  /* @__PURE__ */ (function() {
    function r(e, t) {
      this.content = Ye(e, QO, t.content), this.quotes = Ye(e, PO, t.quotes);
    }
    return r;
  })()
), jy = (
  /** @class */
  /* @__PURE__ */ (function() {
    function r(e, t) {
      this.counterIncrement = Ye(e, LO, t.counterIncrement), this.counterReset = Ye(e, NO, t.counterReset);
    }
    return r;
  })()
), Ye = function(r, e, t) {
  var A = new Cx(), n = t !== null && typeof t < "u" ? t.toString() : e.initialValue;
  A.write(n);
  var i = new Sx(A.read());
  switch (e.type) {
    case 2:
      var s = i.parseComponentValue();
      return e.parse(r, Ar(s) ? s.value : e.initialValue);
    case 0:
      return e.parse(r, i.parseComponentValue());
    case 1:
      return e.parse(r, i.parseComponentValues());
    case 4:
      return i.parseComponentValue();
    case 3:
      switch (e.format) {
        case "angle":
          return Hh.parse(r, i.parseComponentValue());
        case "color":
          return Ms.parse(r, i.parseComponentValue());
        case "image":
          return gv.parse(r, i.parseComponentValue());
        case "length":
          var a = i.parseComponentValue();
          return Ds(a) ? a : FA;
        case "length-percentage":
          var o = i.parseComponentValue();
          return nA(o) ? o : FA;
        case "time":
          return Gx.parse(r, i.parseComponentValue());
      }
      break;
  }
}, GO = "data-html2canvas-debug", VO = function(r) {
  var e = r.getAttribute(GO);
  switch (e) {
    case "all":
      return 1;
    case "clone":
      return 2;
    case "parse":
      return 3;
    case "render":
      return 4;
    default:
      return 0;
  }
}, ym = function(r, e) {
  var t = VO(r);
  return t === 1 || e === t;
}, Ci = (
  /** @class */
  /* @__PURE__ */ (function() {
    function r(e, t) {
      if (this.context = e, this.textNodes = [], this.elements = [], this.flags = 0, ym(
        t,
        3
        /* PARSE */
      ))
        debugger;
      this.styles = new HO(e, window.getComputedStyle(t, null)), Cm(t) && (this.styles.animationDuration.some(function(A) {
        return A > 0;
      }) && (t.style.animationDuration = "0s"), this.styles.transform !== null && (t.style.transform = "none")), this.bounds = Rh(this.context, t), ym(
        t,
        4
        /* RENDER */
      ) && (this.flags |= 16);
    }
    return r;
  })()
), KO = "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", qy = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Ll = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var Oc = 0; Oc < qy.length; Oc++)
  Ll[qy.charCodeAt(Oc)] = Oc;
var jO = function(r) {
  var e = r.length * 0.75, t = r.length, A, n = 0, i, s, a, o;
  r[r.length - 1] === "=" && (e--, r[r.length - 2] === "=" && e--);
  var l = typeof ArrayBuffer < "u" && typeof Uint8Array < "u" && typeof Uint8Array.prototype.slice < "u" ? new ArrayBuffer(e) : new Array(e), u = Array.isArray(l) ? l : new Uint8Array(l);
  for (A = 0; A < t; A += 4)
    i = Ll[r.charCodeAt(A)], s = Ll[r.charCodeAt(A + 1)], a = Ll[r.charCodeAt(A + 2)], o = Ll[r.charCodeAt(A + 3)], u[n++] = i << 2 | s >> 4, u[n++] = (s & 15) << 4 | a >> 2, u[n++] = (a & 3) << 6 | o & 63;
  return l;
}, qO = function(r) {
  for (var e = r.length, t = [], A = 0; A < e; A += 2)
    t.push(r[A + 1] << 8 | r[A]);
  return t;
}, zO = function(r) {
  for (var e = r.length, t = [], A = 0; A < e; A += 4)
    t.push(r[A + 3] << 24 | r[A + 2] << 16 | r[A + 1] << 8 | r[A]);
  return t;
}, Fa = 5, pv = 11, Pd = 2, WO = pv - Fa, Vx = 65536 >> Fa, XO = 1 << Fa, Od = XO - 1, YO = 1024 >> Fa, JO = Vx + YO, $O = JO, ZO = 32, eM = $O + ZO, tM = 65536 >> pv, rM = 1 << WO, AM = rM - 1, zy = function(r, e, t) {
  return r.slice ? r.slice(e, t) : new Uint16Array(Array.prototype.slice.call(r, e, t));
}, nM = function(r, e, t) {
  return r.slice ? r.slice(e, t) : new Uint32Array(Array.prototype.slice.call(r, e, t));
}, iM = function(r, e) {
  var t = jO(r), A = Array.isArray(t) ? zO(t) : new Uint32Array(t), n = Array.isArray(t) ? qO(t) : new Uint16Array(t), i = 24, s = zy(n, i / 2, A[4] / 2), a = A[5] === 2 ? zy(n, (i + A[4]) / 2) : nM(A, Math.ceil((i + A[4]) / 4));
  return new sM(A[0], A[1], A[2], A[3], s, a);
}, sM = (
  /** @class */
  (function() {
    function r(e, t, A, n, i, s) {
      this.initialValue = e, this.errorValue = t, this.highStart = A, this.highValueIndex = n, this.index = i, this.data = s;
    }
    return r.prototype.get = function(e) {
      var t;
      if (e >= 0) {
        if (e < 55296 || e > 56319 && e <= 65535)
          return t = this.index[e >> Fa], t = (t << Pd) + (e & Od), this.data[t];
        if (e <= 65535)
          return t = this.index[Vx + (e - 55296 >> Fa)], t = (t << Pd) + (e & Od), this.data[t];
        if (e < this.highStart)
          return t = eM - tM + (e >> pv), t = this.index[t], t += e >> Fa & AM, t = this.index[t], t = (t << Pd) + (e & Od), this.data[t];
        if (e <= 1114111)
          return this.data[this.highValueIndex];
      }
      return this.errorValue;
    }, r;
  })()
), Wy = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", aM = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var Mc = 0; Mc < Wy.length; Mc++)
  aM[Wy.charCodeAt(Mc)] = Mc;
var oM = 1, Md = 2, Rd = 3, Xy = 4, Yy = 5, lM = 7, Jy = 8, kd = 9, Hd = 10, $y = 11, Zy = 12, e2 = 13, t2 = 14, Dd = 15, uM = function(r) {
  for (var e = [], t = 0, A = r.length; t < A; ) {
    var n = r.charCodeAt(t++);
    if (n >= 55296 && n <= 56319 && t < A) {
      var i = r.charCodeAt(t++);
      (i & 64512) === 56320 ? e.push(((n & 1023) << 10) + (i & 1023) + 65536) : (e.push(n), t--);
    } else
      e.push(n);
  }
  return e;
}, cM = function() {
  for (var r = [], e = 0; e < arguments.length; e++)
    r[e] = arguments[e];
  if (String.fromCodePoint)
    return String.fromCodePoint.apply(String, r);
  var t = r.length;
  if (!t)
    return "";
  for (var A = [], n = -1, i = ""; ++n < t; ) {
    var s = r[n];
    s <= 65535 ? A.push(s) : (s -= 65536, A.push((s >> 10) + 55296, s % 1024 + 56320)), (n + 1 === t || A.length > 16384) && (i += String.fromCharCode.apply(String, A), A.length = 0);
  }
  return i;
}, hM = iM(KO), Ln = "×", Gd = "÷", fM = function(r) {
  return hM.get(r);
}, dM = function(r, e, t) {
  var A = t - 2, n = e[A], i = e[t - 1], s = e[t];
  if (i === Md && s === Rd)
    return Ln;
  if (i === Md || i === Rd || i === Xy || s === Md || s === Rd || s === Xy)
    return Gd;
  if (i === Jy && [Jy, kd, $y, Zy].indexOf(s) !== -1 || (i === $y || i === kd) && (s === kd || s === Hd) || (i === Zy || i === Hd) && s === Hd || s === e2 || s === Yy || s === lM || i === oM)
    return Ln;
  if (i === e2 && s === t2) {
    for (; n === Yy; )
      n = e[--A];
    if (n === t2)
      return Ln;
  }
  if (i === Dd && s === Dd) {
    for (var a = 0; n === Dd; )
      a++, n = e[--A];
    if (a % 2 === 0)
      return Ln;
  }
  return Gd;
}, gM = function(r) {
  var e = uM(r), t = e.length, A = 0, n = 0, i = e.map(fM);
  return {
    next: function() {
      if (A >= t)
        return { done: !0, value: null };
      for (var s = Ln; A < t && (s = dM(e, i, ++A)) === Ln; )
        ;
      if (s !== Ln || A === t) {
        var a = cM.apply(null, e.slice(n, A));
        return n = A, { value: a, done: !1 };
      }
      return { done: !0, value: null };
    }
  };
}, pM = function(r) {
  for (var e = gM(r), t = [], A; !(A = e.next()).done; )
    A.value && t.push(A.value.slice());
  return t;
}, mM = function(r) {
  var e = 123;
  if (r.createRange) {
    var t = r.createRange();
    if (t.getBoundingClientRect) {
      var A = r.createElement("boundtest");
      A.style.height = e + "px", A.style.display = "block", r.body.appendChild(A), t.selectNode(A);
      var n = t.getBoundingClientRect(), i = Math.round(n.height);
      if (r.body.removeChild(A), i === e)
        return !0;
    }
  }
  return !1;
}, vM = function(r) {
  var e = r.createElement("boundtest");
  e.style.width = "50px", e.style.display = "block", e.style.fontSize = "12px", e.style.letterSpacing = "0px", e.style.wordSpacing = "0px", r.body.appendChild(e);
  var t = r.createRange();
  e.innerHTML = typeof "".repeat == "function" ? "&#128104;".repeat(10) : "";
  var A = e.firstChild, n = kh(A.data).map(function(o) {
    return Kr(o);
  }), i = 0, s = {}, a = n.every(function(o, l) {
    t.setStart(A, i), t.setEnd(A, i + o.length);
    var u = t.getBoundingClientRect();
    i += o.length;
    var h = u.x > s.x || u.y > s.y;
    return s = u, l === 0 ? !0 : h;
  });
  return r.body.removeChild(e), a;
}, wM = function() {
  return typeof new Image().crossOrigin < "u";
}, yM = function() {
  return typeof new XMLHttpRequest().responseType == "string";
}, BM = function(r) {
  var e = new Image(), t = r.createElement("canvas"), A = t.getContext("2d");
  if (!A)
    return !1;
  e.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
  try {
    A.drawImage(e, 0, 0), t.toDataURL();
  } catch {
    return !1;
  }
  return !0;
}, r2 = function(r) {
  return r[0] === 0 && r[1] === 255 && r[2] === 0 && r[3] === 255;
}, bM = function(r) {
  var e = r.createElement("canvas"), t = 100;
  e.width = t, e.height = t;
  var A = e.getContext("2d");
  if (!A)
    return Promise.reject(!1);
  A.fillStyle = "rgb(0, 255, 0)", A.fillRect(0, 0, t, t);
  var n = new Image(), i = e.toDataURL();
  n.src = i;
  var s = Bm(t, t, 0, 0, n);
  return A.fillStyle = "red", A.fillRect(0, 0, t, t), A2(s).then(function(a) {
    A.drawImage(a, 0, 0);
    var o = A.getImageData(0, 0, t, t).data;
    A.fillStyle = "red", A.fillRect(0, 0, t, t);
    var l = r.createElement("div");
    return l.style.backgroundImage = "url(" + i + ")", l.style.height = t + "px", r2(o) ? A2(Bm(t, t, 0, 0, l)) : Promise.reject(!1);
  }).then(function(a) {
    return A.drawImage(a, 0, 0), r2(A.getImageData(0, 0, t, t).data);
  }).catch(function() {
    return !1;
  });
}, Bm = function(r, e, t, A, n) {
  var i = "http://www.w3.org/2000/svg", s = document.createElementNS(i, "svg"), a = document.createElementNS(i, "foreignObject");
  return s.setAttributeNS(null, "width", r.toString()), s.setAttributeNS(null, "height", e.toString()), a.setAttributeNS(null, "width", "100%"), a.setAttributeNS(null, "height", "100%"), a.setAttributeNS(null, "x", t.toString()), a.setAttributeNS(null, "y", A.toString()), a.setAttributeNS(null, "externalResourcesRequired", "true"), s.appendChild(a), a.appendChild(n), s;
}, A2 = function(r) {
  return new Promise(function(e, t) {
    var A = new Image();
    A.onload = function() {
      return e(A);
    }, A.onerror = t, A.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(r));
  });
}, SA = {
  get SUPPORT_RANGE_BOUNDS() {
    var r = mM(document);
    return Object.defineProperty(SA, "SUPPORT_RANGE_BOUNDS", { value: r }), r;
  },
  get SUPPORT_WORD_BREAKING() {
    var r = SA.SUPPORT_RANGE_BOUNDS && vM(document);
    return Object.defineProperty(SA, "SUPPORT_WORD_BREAKING", { value: r }), r;
  },
  get SUPPORT_SVG_DRAWING() {
    var r = BM(document);
    return Object.defineProperty(SA, "SUPPORT_SVG_DRAWING", { value: r }), r;
  },
  get SUPPORT_FOREIGNOBJECT_DRAWING() {
    var r = typeof Array.from == "function" && typeof window.fetch == "function" ? bM(document) : Promise.resolve(!1);
    return Object.defineProperty(SA, "SUPPORT_FOREIGNOBJECT_DRAWING", { value: r }), r;
  },
  get SUPPORT_CORS_IMAGES() {
    var r = wM();
    return Object.defineProperty(SA, "SUPPORT_CORS_IMAGES", { value: r }), r;
  },
  get SUPPORT_RESPONSE_TYPE() {
    var r = yM();
    return Object.defineProperty(SA, "SUPPORT_RESPONSE_TYPE", { value: r }), r;
  },
  get SUPPORT_CORS_XHR() {
    var r = "withCredentials" in new XMLHttpRequest();
    return Object.defineProperty(SA, "SUPPORT_CORS_XHR", { value: r }), r;
  },
  get SUPPORT_NATIVE_TEXT_SEGMENTATION() {
    var r = !!(typeof Intl < "u" && Intl.Segmenter);
    return Object.defineProperty(SA, "SUPPORT_NATIVE_TEXT_SEGMENTATION", { value: r }), r;
  }
}, jl = (
  /** @class */
  /* @__PURE__ */ (function() {
    function r(e, t) {
      this.text = e, this.bounds = t;
    }
    return r;
  })()
), CM = function(r, e, t, A) {
  var n = EM(e, t), i = [], s = 0;
  return n.forEach(function(a) {
    if (t.textDecorationLine.length || a.trim().length > 0)
      if (SA.SUPPORT_RANGE_BOUNDS) {
        var o = n2(A, s, a.length).getClientRects();
        if (o.length > 1) {
          var l = mv(a), u = 0;
          l.forEach(function(f) {
            i.push(new jl(f, As.fromDOMRectList(r, n2(A, u + s, f.length).getClientRects()))), u += f.length;
          });
        } else
          i.push(new jl(a, As.fromDOMRectList(r, o)));
      } else {
        var h = A.splitText(a.length);
        i.push(new jl(a, SM(r, A))), A = h;
      }
    else SA.SUPPORT_RANGE_BOUNDS || (A = A.splitText(a.length));
    s += a.length;
  }), i;
}, SM = function(r, e) {
  var t = e.ownerDocument;
  if (t) {
    var A = t.createElement("html2canvaswrapper");
    A.appendChild(e.cloneNode(!0));
    var n = e.parentNode;
    if (n) {
      n.replaceChild(A, e);
      var i = Rh(r, A);
      return A.firstChild && n.replaceChild(A.firstChild, A), i;
    }
  }
  return As.EMPTY;
}, n2 = function(r, e, t) {
  var A = r.ownerDocument;
  if (!A)
    throw new Error("Node has no owner document");
  var n = A.createRange();
  return n.setStart(r, e), n.setEnd(r, e + t), n;
}, mv = function(r) {
  if (SA.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
    var e = new Intl.Segmenter(void 0, { granularity: "grapheme" });
    return Array.from(e.segment(r)).map(function(t) {
      return t.segment;
    });
  }
  return pM(r);
}, xM = function(r, e) {
  if (SA.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
    var t = new Intl.Segmenter(void 0, {
      granularity: "word"
    });
    return Array.from(t.segment(r)).map(function(A) {
      return A.segment;
    });
  }
  return _M(r, e);
}, EM = function(r, e) {
  return e.letterSpacing !== 0 ? mv(r) : xM(r, e);
}, FM = [32, 160, 4961, 65792, 65793, 4153, 4241], _M = function(r, e) {
  for (var t = tT(r, {
    lineBreak: e.lineBreak,
    wordBreak: e.overflowWrap === "break-word" ? "break-word" : e.wordBreak
  }), A = [], n, i = function() {
    if (n.value) {
      var s = n.value.slice(), a = kh(s), o = "";
      a.forEach(function(l) {
        FM.indexOf(l) === -1 ? o += Kr(l) : (o.length && A.push(o), A.push(Kr(l)), o = "");
      }), o.length && A.push(o);
    }
  }; !(n = t.next()).done; )
    i();
  return A;
}, UM = (
  /** @class */
  /* @__PURE__ */ (function() {
    function r(e, t, A) {
      this.text = IM(t.data, A.textTransform), this.textBounds = CM(e, this.text, A, t);
    }
    return r;
  })()
), IM = function(r, e) {
  switch (e) {
    case 1:
      return r.toLowerCase();
    case 3:
      return r.replace(QM, LM);
    case 2:
      return r.toUpperCase();
    default:
      return r;
  }
}, QM = /(^|\s|:|-|\(|\))([a-z])/g, LM = function(r, e, t) {
  return r.length > 0 ? e + t.toUpperCase() : r;
}, Kx = (
  /** @class */
  (function(r) {
    ii(e, r);
    function e(t, A) {
      var n = r.call(this, t, A) || this;
      return n.src = A.currentSrc || A.src, n.intrinsicWidth = A.naturalWidth, n.intrinsicHeight = A.naturalHeight, n.context.cache.addImage(n.src), n;
    }
    return e;
  })(Ci)
), jx = (
  /** @class */
  (function(r) {
    ii(e, r);
    function e(t, A) {
      var n = r.call(this, t, A) || this;
      return n.canvas = A, n.intrinsicWidth = A.width, n.intrinsicHeight = A.height, n;
    }
    return e;
  })(Ci)
), qx = (
  /** @class */
  (function(r) {
    ii(e, r);
    function e(t, A) {
      var n = r.call(this, t, A) || this, i = new XMLSerializer(), s = Rh(t, A);
      return A.setAttribute("width", s.width + "px"), A.setAttribute("height", s.height + "px"), n.svg = "data:image/svg+xml," + encodeURIComponent(i.serializeToString(A)), n.intrinsicWidth = A.width.baseVal.value, n.intrinsicHeight = A.height.baseVal.value, n.context.cache.addImage(n.svg), n;
    }
    return e;
  })(Ci)
), zx = (
  /** @class */
  (function(r) {
    ii(e, r);
    function e(t, A) {
      var n = r.call(this, t, A) || this;
      return n.value = A.value, n;
    }
    return e;
  })(Ci)
), bm = (
  /** @class */
  (function(r) {
    ii(e, r);
    function e(t, A) {
      var n = r.call(this, t, A) || this;
      return n.start = A.start, n.reversed = typeof A.reversed == "boolean" && A.reversed === !0, n;
    }
    return e;
  })(Ci)
), NM = [
  {
    type: 15,
    flags: 0,
    unit: "px",
    number: 3
  }
], TM = [
  {
    type: 16,
    flags: 0,
    number: 50
  }
], PM = function(r) {
  return r.width > r.height ? new As(r.left + (r.width - r.height) / 2, r.top, r.height, r.height) : r.width < r.height ? new As(r.left, r.top + (r.height - r.width) / 2, r.width, r.width) : r;
}, OM = function(r) {
  var e = r.type === MM ? new Array(r.value.length + 1).join("•") : r.value;
  return e.length === 0 ? r.placeholder || "" : e;
}, bh = "checkbox", Ch = "radio", MM = "password", i2 = 707406591, vv = (
  /** @class */
  (function(r) {
    ii(e, r);
    function e(t, A) {
      var n = r.call(this, t, A) || this;
      switch (n.type = A.type.toLowerCase(), n.checked = A.checked, n.value = OM(A), (n.type === bh || n.type === Ch) && (n.styles.backgroundColor = 3739148031, n.styles.borderTopColor = n.styles.borderRightColor = n.styles.borderBottomColor = n.styles.borderLeftColor = 2779096575, n.styles.borderTopWidth = n.styles.borderRightWidth = n.styles.borderBottomWidth = n.styles.borderLeftWidth = 1, n.styles.borderTopStyle = n.styles.borderRightStyle = n.styles.borderBottomStyle = n.styles.borderLeftStyle = 1, n.styles.backgroundClip = [
        0
        /* BORDER_BOX */
      ], n.styles.backgroundOrigin = [
        0
        /* BORDER_BOX */
      ], n.bounds = PM(n.bounds)), n.type) {
        case bh:
          n.styles.borderTopRightRadius = n.styles.borderTopLeftRadius = n.styles.borderBottomRightRadius = n.styles.borderBottomLeftRadius = NM;
          break;
        case Ch:
          n.styles.borderTopRightRadius = n.styles.borderTopLeftRadius = n.styles.borderBottomRightRadius = n.styles.borderBottomLeftRadius = TM;
          break;
      }
      return n;
    }
    return e;
  })(Ci)
), Wx = (
  /** @class */
  (function(r) {
    ii(e, r);
    function e(t, A) {
      var n = r.call(this, t, A) || this, i = A.options[A.selectedIndex || 0];
      return n.value = i && i.text || "", n;
    }
    return e;
  })(Ci)
), Xx = (
  /** @class */
  (function(r) {
    ii(e, r);
    function e(t, A) {
      var n = r.call(this, t, A) || this;
      return n.value = A.value, n;
    }
    return e;
  })(Ci)
), Yx = (
  /** @class */
  (function(r) {
    ii(e, r);
    function e(t, A) {
      var n = r.call(this, t, A) || this;
      n.src = A.src, n.width = parseInt(A.width, 10) || 0, n.height = parseInt(A.height, 10) || 0, n.backgroundColor = n.styles.backgroundColor;
      try {
        if (A.contentWindow && A.contentWindow.document && A.contentWindow.document.documentElement) {
          n.tree = $x(t, A.contentWindow.document.documentElement);
          var i = A.contentWindow.document.documentElement ? Vl(t, getComputedStyle(A.contentWindow.document.documentElement).backgroundColor) : Zi.TRANSPARENT, s = A.contentWindow.document.body ? Vl(t, getComputedStyle(A.contentWindow.document.body).backgroundColor) : Zi.TRANSPARENT;
          n.backgroundColor = Rs(i) ? Rs(s) ? n.styles.backgroundColor : s : i;
        }
      } catch {
      }
      return n;
    }
    return e;
  })(Ci)
), RM = ["OL", "UL", "MENU"], sh = function(r, e, t, A) {
  for (var n = e.firstChild, i = void 0; n; n = i)
    if (i = n.nextSibling, Zx(n) && n.data.trim().length > 0)
      t.textNodes.push(new UM(r, n, t.styles));
    else if (yo(n))
      if (AE(n) && n.assignedNodes)
        n.assignedNodes().forEach(function(a) {
          return sh(r, a, t, A);
        });
      else {
        var s = Jx(r, n);
        s.styles.isVisible() && (kM(n, s, A) ? s.flags |= 4 : HM(s.styles) && (s.flags |= 2), RM.indexOf(n.tagName) !== -1 && (s.flags |= 8), t.elements.push(s), n.slot, n.shadowRoot ? sh(r, n.shadowRoot, s, A) : !Sh(n) && !eE(n) && !xh(n) && sh(r, n, s, A));
      }
}, Jx = function(r, e) {
  return Sm(e) ? new Kx(r, e) : tE(e) ? new jx(r, e) : eE(e) ? new qx(r, e) : DM(e) ? new zx(r, e) : GM(e) ? new bm(r, e) : VM(e) ? new vv(r, e) : xh(e) ? new Wx(r, e) : Sh(e) ? new Xx(r, e) : rE(e) ? new Yx(r, e) : new Ci(r, e);
}, $x = function(r, e) {
  var t = Jx(r, e);
  return t.flags |= 4, sh(r, e, t, t), t;
}, kM = function(r, e, t) {
  return e.styles.isPositionedWithZIndex() || e.styles.opacity < 1 || e.styles.isTransformed() || wv(r) && t.styles.isTransparent();
}, HM = function(r) {
  return r.isPositioned() || r.isFloating();
}, Zx = function(r) {
  return r.nodeType === Node.TEXT_NODE;
}, yo = function(r) {
  return r.nodeType === Node.ELEMENT_NODE;
}, Cm = function(r) {
  return yo(r) && typeof r.style < "u" && !ah(r);
}, ah = function(r) {
  return typeof r.className == "object";
}, DM = function(r) {
  return r.tagName === "LI";
}, GM = function(r) {
  return r.tagName === "OL";
}, VM = function(r) {
  return r.tagName === "INPUT";
}, KM = function(r) {
  return r.tagName === "HTML";
}, eE = function(r) {
  return r.tagName === "svg";
}, wv = function(r) {
  return r.tagName === "BODY";
}, tE = function(r) {
  return r.tagName === "CANVAS";
}, s2 = function(r) {
  return r.tagName === "VIDEO";
}, Sm = function(r) {
  return r.tagName === "IMG";
}, rE = function(r) {
  return r.tagName === "IFRAME";
}, a2 = function(r) {
  return r.tagName === "STYLE";
}, jM = function(r) {
  return r.tagName === "SCRIPT";
}, Sh = function(r) {
  return r.tagName === "TEXTAREA";
}, xh = function(r) {
  return r.tagName === "SELECT";
}, AE = function(r) {
  return r.tagName === "SLOT";
}, o2 = function(r) {
  return r.tagName.indexOf("-") > 0;
}, qM = (
  /** @class */
  (function() {
    function r() {
      this.counters = {};
    }
    return r.prototype.getCounterValue = function(e) {
      var t = this.counters[e];
      return t && t.length ? t[t.length - 1] : 1;
    }, r.prototype.getCounterValues = function(e) {
      var t = this.counters[e];
      return t || [];
    }, r.prototype.pop = function(e) {
      var t = this;
      e.forEach(function(A) {
        return t.counters[A].pop();
      });
    }, r.prototype.parse = function(e) {
      var t = this, A = e.counterIncrement, n = e.counterReset, i = !0;
      A !== null && A.forEach(function(a) {
        var o = t.counters[a.counter];
        o && a.increment !== 0 && (i = !1, o.length || o.push(1), o[Math.max(0, o.length - 1)] += a.increment);
      });
      var s = [];
      return i && n.forEach(function(a) {
        var o = t.counters[a.counter];
        s.push(a.counter), o || (o = t.counters[a.counter] = []), o.push(a.reset);
      }), s;
    }, r;
  })()
), l2 = {
  integers: [1e3, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
  values: ["M", "CM", "D", "CD", "C", "XC", "L", "XL", "X", "IX", "V", "IV", "I"]
}, u2 = {
  integers: [
    9e3,
    8e3,
    7e3,
    6e3,
    5e3,
    4e3,
    3e3,
    2e3,
    1e3,
    900,
    800,
    700,
    600,
    500,
    400,
    300,
    200,
    100,
    90,
    80,
    70,
    60,
    50,
    40,
    30,
    20,
    10,
    9,
    8,
    7,
    6,
    5,
    4,
    3,
    2,
    1
  ],
  values: [
    "Ք",
    "Փ",
    "Ւ",
    "Ց",
    "Ր",
    "Տ",
    "Վ",
    "Ս",
    "Ռ",
    "Ջ",
    "Պ",
    "Չ",
    "Ո",
    "Շ",
    "Ն",
    "Յ",
    "Մ",
    "Ճ",
    "Ղ",
    "Ձ",
    "Հ",
    "Կ",
    "Ծ",
    "Խ",
    "Լ",
    "Ի",
    "Ժ",
    "Թ",
    "Ը",
    "Է",
    "Զ",
    "Ե",
    "Դ",
    "Գ",
    "Բ",
    "Ա"
  ]
}, zM = {
  integers: [
    1e4,
    9e3,
    8e3,
    7e3,
    6e3,
    5e3,
    4e3,
    3e3,
    2e3,
    1e3,
    400,
    300,
    200,
    100,
    90,
    80,
    70,
    60,
    50,
    40,
    30,
    20,
    19,
    18,
    17,
    16,
    15,
    10,
    9,
    8,
    7,
    6,
    5,
    4,
    3,
    2,
    1
  ],
  values: [
    "י׳",
    "ט׳",
    "ח׳",
    "ז׳",
    "ו׳",
    "ה׳",
    "ד׳",
    "ג׳",
    "ב׳",
    "א׳",
    "ת",
    "ש",
    "ר",
    "ק",
    "צ",
    "פ",
    "ע",
    "ס",
    "נ",
    "מ",
    "ל",
    "כ",
    "יט",
    "יח",
    "יז",
    "טז",
    "טו",
    "י",
    "ט",
    "ח",
    "ז",
    "ו",
    "ה",
    "ד",
    "ג",
    "ב",
    "א"
  ]
}, WM = {
  integers: [
    1e4,
    9e3,
    8e3,
    7e3,
    6e3,
    5e3,
    4e3,
    3e3,
    2e3,
    1e3,
    900,
    800,
    700,
    600,
    500,
    400,
    300,
    200,
    100,
    90,
    80,
    70,
    60,
    50,
    40,
    30,
    20,
    10,
    9,
    8,
    7,
    6,
    5,
    4,
    3,
    2,
    1
  ],
  values: [
    "ჵ",
    "ჰ",
    "ჯ",
    "ჴ",
    "ხ",
    "ჭ",
    "წ",
    "ძ",
    "ც",
    "ჩ",
    "შ",
    "ყ",
    "ღ",
    "ქ",
    "ფ",
    "ჳ",
    "ტ",
    "ს",
    "რ",
    "ჟ",
    "პ",
    "ო",
    "ჲ",
    "ნ",
    "მ",
    "ლ",
    "კ",
    "ი",
    "თ",
    "ჱ",
    "ზ",
    "ვ",
    "ე",
    "დ",
    "გ",
    "ბ",
    "ა"
  ]
}, ao = function(r, e, t, A, n, i) {
  return r < e || r > t ? eu(r, n, i.length > 0) : A.integers.reduce(function(s, a, o) {
    for (; r >= a; )
      r -= a, s += A.values[o];
    return s;
  }, "") + i;
}, nE = function(r, e, t, A) {
  var n = "";
  do
    t || r--, n = A(r) + n, r /= e;
  while (r * e >= e);
  return n;
}, Vr = function(r, e, t, A, n) {
  var i = t - e + 1;
  return (r < 0 ? "-" : "") + (nE(Math.abs(r), i, A, function(s) {
    return Kr(Math.floor(s % i) + e);
  }) + n);
}, ha = function(r, e, t) {
  t === void 0 && (t = ". ");
  var A = e.length;
  return nE(Math.abs(r), A, !1, function(n) {
    return e[Math.floor(n % A)];
  }) + t;
}, go = 1, Fs = 2, _s = 4, Nl = 8, qi = function(r, e, t, A, n, i) {
  if (r < -9999 || r > 9999)
    return eu(r, 4, n.length > 0);
  var s = Math.abs(r), a = n;
  if (s === 0)
    return e[0] + a;
  for (var o = 0; s > 0 && o <= 4; o++) {
    var l = s % 10;
    l === 0 && hA(i, go) && a !== "" ? a = e[l] + a : l > 1 || l === 1 && o === 0 || l === 1 && o === 1 && hA(i, Fs) || l === 1 && o === 1 && hA(i, _s) && r > 100 || l === 1 && o > 1 && hA(i, Nl) ? a = e[l] + (o > 0 ? t[o - 1] : "") + a : l === 1 && o > 0 && (a = t[o - 1] + a), s = Math.floor(s / 10);
  }
  return (r < 0 ? A : "") + a;
}, c2 = "十百千萬", h2 = "拾佰仟萬", f2 = "マイナス", Vd = "마이너스", eu = function(r, e, t) {
  var A = t ? ". " : "", n = t ? "、" : "", i = t ? ", " : "", s = t ? " " : "";
  switch (e) {
    case 0:
      return "•" + s;
    case 1:
      return "◦" + s;
    case 2:
      return "◾" + s;
    case 5:
      var a = Vr(r, 48, 57, !0, A);
      return a.length < 4 ? "0" + a : a;
    case 4:
      return ha(r, "〇一二三四五六七八九", n);
    case 6:
      return ao(r, 1, 3999, l2, 3, A).toLowerCase();
    case 7:
      return ao(r, 1, 3999, l2, 3, A);
    case 8:
      return Vr(r, 945, 969, !1, A);
    case 9:
      return Vr(r, 97, 122, !1, A);
    case 10:
      return Vr(r, 65, 90, !1, A);
    case 11:
      return Vr(r, 1632, 1641, !0, A);
    case 12:
    case 49:
      return ao(r, 1, 9999, u2, 3, A);
    case 35:
      return ao(r, 1, 9999, u2, 3, A).toLowerCase();
    case 13:
      return Vr(r, 2534, 2543, !0, A);
    case 14:
    case 30:
      return Vr(r, 6112, 6121, !0, A);
    case 15:
      return ha(r, "子丑寅卯辰巳午未申酉戌亥", n);
    case 16:
      return ha(r, "甲乙丙丁戊己庚辛壬癸", n);
    case 17:
    case 48:
      return qi(r, "零一二三四五六七八九", c2, "負", n, Fs | _s | Nl);
    case 47:
      return qi(r, "零壹貳參肆伍陸柒捌玖", h2, "負", n, go | Fs | _s | Nl);
    case 42:
      return qi(r, "零一二三四五六七八九", c2, "负", n, Fs | _s | Nl);
    case 41:
      return qi(r, "零壹贰叁肆伍陆柒捌玖", h2, "负", n, go | Fs | _s | Nl);
    case 26:
      return qi(r, "〇一二三四五六七八九", "十百千万", f2, n, 0);
    case 25:
      return qi(r, "零壱弐参四伍六七八九", "拾百千万", f2, n, go | Fs | _s);
    case 31:
      return qi(r, "영일이삼사오육칠팔구", "십백천만", Vd, i, go | Fs | _s);
    case 33:
      return qi(r, "零一二三四五六七八九", "十百千萬", Vd, i, 0);
    case 32:
      return qi(r, "零壹貳參四五六七八九", "拾百千", Vd, i, go | Fs | _s);
    case 18:
      return Vr(r, 2406, 2415, !0, A);
    case 20:
      return ao(r, 1, 19999, WM, 3, A);
    case 21:
      return Vr(r, 2790, 2799, !0, A);
    case 22:
      return Vr(r, 2662, 2671, !0, A);
    case 22:
      return ao(r, 1, 10999, zM, 3, A);
    case 23:
      return ha(r, "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん");
    case 24:
      return ha(r, "いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす");
    case 27:
      return Vr(r, 3302, 3311, !0, A);
    case 28:
      return ha(r, "アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン", n);
    case 29:
      return ha(r, "イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス", n);
    case 34:
      return Vr(r, 3792, 3801, !0, A);
    case 37:
      return Vr(r, 6160, 6169, !0, A);
    case 38:
      return Vr(r, 4160, 4169, !0, A);
    case 39:
      return Vr(r, 2918, 2927, !0, A);
    case 40:
      return Vr(r, 1776, 1785, !0, A);
    case 43:
      return Vr(r, 3046, 3055, !0, A);
    case 44:
      return Vr(r, 3174, 3183, !0, A);
    case 45:
      return Vr(r, 3664, 3673, !0, A);
    case 46:
      return Vr(r, 3872, 3881, !0, A);
    case 3:
    default:
      return Vr(r, 48, 57, !0, A);
  }
}, iE = "data-html2canvas-ignore", d2 = (
  /** @class */
  (function() {
    function r(e, t, A) {
      if (this.context = e, this.options = A, this.scrolledElements = [], this.referenceElement = t, this.counters = new qM(), this.quoteDepth = 0, !t.ownerDocument)
        throw new Error("Cloned element does not have an owner document");
      this.documentElement = this.cloneNode(t.ownerDocument.documentElement, !1);
    }
    return r.prototype.toIFrame = function(e, t) {
      var A = this, n = XM(e, t);
      if (!n.contentWindow)
        return Promise.reject("Unable to find iframe window");
      var i = e.defaultView.pageXOffset, s = e.defaultView.pageYOffset, a = n.contentWindow, o = a.document, l = $M(n).then(function() {
        return jA(A, void 0, void 0, function() {
          var u, h;
          return TA(this, function(f) {
            switch (f.label) {
              case 0:
                return this.scrolledElements.forEach(rR), a && (a.scrollTo(t.left, t.top), /(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (a.scrollY !== t.top || a.scrollX !== t.left) && (this.context.logger.warn("Unable to restore scroll position for cloned document"), this.context.windowBounds = this.context.windowBounds.add(a.scrollX - t.left, a.scrollY - t.top, 0, 0))), u = this.options.onclone, h = this.clonedReferenceElement, typeof h > "u" ? [2, Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")] : o.fonts && o.fonts.ready ? [4, o.fonts.ready] : [3, 2];
              case 1:
                f.sent(), f.label = 2;
              case 2:
                return /(AppleWebKit)/g.test(navigator.userAgent) ? [4, JM(o)] : [3, 4];
              case 3:
                f.sent(), f.label = 4;
              case 4:
                return typeof u == "function" ? [2, Promise.resolve().then(function() {
                  return u(o, h);
                }).then(function() {
                  return n;
                })] : [2, n];
            }
          });
        });
      });
      return o.open(), o.write(eR(document.doctype) + "<html></html>"), tR(this.referenceElement.ownerDocument, i, s), o.replaceChild(o.adoptNode(this.documentElement), o.documentElement), o.close(), l;
    }, r.prototype.createElementClone = function(e) {
      if (ym(
        e,
        2
        /* CLONE */
      ))
        debugger;
      if (tE(e))
        return this.createCanvasClone(e);
      if (s2(e))
        return this.createVideoClone(e);
      if (a2(e))
        return this.createStyleClone(e);
      var t = e.cloneNode(!1);
      return Sm(t) && (Sm(e) && e.currentSrc && e.currentSrc !== e.src && (t.src = e.currentSrc, t.srcset = ""), t.loading === "lazy" && (t.loading = "eager")), o2(t) ? this.createCustomElementClone(t) : t;
    }, r.prototype.createCustomElementClone = function(e) {
      var t = document.createElement("html2canvascustomelement");
      return Kd(e.style, t), t;
    }, r.prototype.createStyleClone = function(e) {
      try {
        var t = e.sheet;
        if (t && t.cssRules) {
          var A = [].slice.call(t.cssRules, 0).reduce(function(i, s) {
            return s && typeof s.cssText == "string" ? i + s.cssText : i;
          }, ""), n = e.cloneNode(!1);
          return n.textContent = A, n;
        }
      } catch (i) {
        if (this.context.logger.error("Unable to access cssRules property", i), i.name !== "SecurityError")
          throw i;
      }
      return e.cloneNode(!1);
    }, r.prototype.createCanvasClone = function(e) {
      var t;
      if (this.options.inlineImages && e.ownerDocument) {
        var A = e.ownerDocument.createElement("img");
        try {
          return A.src = e.toDataURL(), A;
        } catch {
          this.context.logger.info("Unable to inline canvas contents, canvas is tainted", e);
        }
      }
      var n = e.cloneNode(!1);
      try {
        n.width = e.width, n.height = e.height;
        var i = e.getContext("2d"), s = n.getContext("2d");
        if (s)
          if (!this.options.allowTaint && i)
            s.putImageData(i.getImageData(0, 0, e.width, e.height), 0, 0);
          else {
            var a = (t = e.getContext("webgl2")) !== null && t !== void 0 ? t : e.getContext("webgl");
            if (a) {
              var o = a.getContextAttributes();
              o?.preserveDrawingBuffer === !1 && this.context.logger.warn("Unable to clone WebGL context as it has preserveDrawingBuffer=false", e);
            }
            s.drawImage(e, 0, 0);
          }
        return n;
      } catch {
        this.context.logger.info("Unable to clone canvas as it is tainted", e);
      }
      return n;
    }, r.prototype.createVideoClone = function(e) {
      var t = e.ownerDocument.createElement("canvas");
      t.width = e.offsetWidth, t.height = e.offsetHeight;
      var A = t.getContext("2d");
      try {
        return A && (A.drawImage(e, 0, 0, t.width, t.height), this.options.allowTaint || A.getImageData(0, 0, t.width, t.height)), t;
      } catch {
        this.context.logger.info("Unable to clone video as it is tainted", e);
      }
      var n = e.ownerDocument.createElement("canvas");
      return n.width = e.offsetWidth, n.height = e.offsetHeight, n;
    }, r.prototype.appendChildNode = function(e, t, A) {
      (!yo(t) || !jM(t) && !t.hasAttribute(iE) && (typeof this.options.ignoreElements != "function" || !this.options.ignoreElements(t))) && (!this.options.copyStyles || !yo(t) || !a2(t)) && e.appendChild(this.cloneNode(t, A));
    }, r.prototype.cloneChildNodes = function(e, t, A) {
      for (var n = this, i = e.shadowRoot ? e.shadowRoot.firstChild : e.firstChild; i; i = i.nextSibling)
        if (yo(i) && AE(i) && typeof i.assignedNodes == "function") {
          var s = i.assignedNodes();
          s.length && s.forEach(function(a) {
            return n.appendChildNode(t, a, A);
          });
        } else
          this.appendChildNode(t, i, A);
    }, r.prototype.cloneNode = function(e, t) {
      if (Zx(e))
        return document.createTextNode(e.data);
      if (!e.ownerDocument)
        return e.cloneNode(!1);
      var A = e.ownerDocument.defaultView;
      if (A && yo(e) && (Cm(e) || ah(e))) {
        var n = this.createElementClone(e);
        n.style.transitionProperty = "none";
        var i = A.getComputedStyle(e), s = A.getComputedStyle(e, ":before"), a = A.getComputedStyle(e, ":after");
        this.referenceElement === e && Cm(n) && (this.clonedReferenceElement = n), wv(n) && iR(n);
        var o = this.counters.parse(new jy(this.context, i)), l = this.resolvePseudoContent(e, n, s, ql.BEFORE);
        o2(e) && (t = !0), s2(e) || this.cloneChildNodes(e, n, t), l && n.insertBefore(l, n.firstChild);
        var u = this.resolvePseudoContent(e, n, a, ql.AFTER);
        return u && n.appendChild(u), this.counters.pop(o), (i && (this.options.copyStyles || ah(e)) && !rE(e) || t) && Kd(i, n), (e.scrollTop !== 0 || e.scrollLeft !== 0) && this.scrolledElements.push([n, e.scrollLeft, e.scrollTop]), (Sh(e) || xh(e)) && (Sh(n) || xh(n)) && (n.value = e.value), n;
      }
      return e.cloneNode(!1);
    }, r.prototype.resolvePseudoContent = function(e, t, A, n) {
      var i = this;
      if (A) {
        var s = A.content, a = t.ownerDocument;
        if (!(!a || !s || s === "none" || s === "-moz-alt-content" || A.display === "none")) {
          this.counters.parse(new jy(this.context, A));
          var o = new DO(this.context, A), l = a.createElement("html2canvaspseudoelement");
          Kd(A, l), o.content.forEach(function(h) {
            if (h.type === 0)
              l.appendChild(a.createTextNode(h.value));
            else if (h.type === 22) {
              var f = a.createElement("img");
              f.src = h.value, f.style.opacity = "1", l.appendChild(f);
            } else if (h.type === 18) {
              if (h.name === "attr") {
                var c = h.values.filter(Ar);
                c.length && l.appendChild(a.createTextNode(e.getAttribute(c[0].value) || ""));
              } else if (h.name === "counter") {
                var p = h.values.filter(Io), g = p[0], v = p[1];
                if (g && Ar(g)) {
                  var w = i.counters.getCounterValue(g.value), B = v && Ar(v) ? wm.parse(i.context, v.value) : 3;
                  l.appendChild(a.createTextNode(eu(w, B, !1)));
                }
              } else if (h.name === "counters") {
                var S = h.values.filter(Io), g = S[0], C = S[1], v = S[2];
                if (g && Ar(g)) {
                  var E = i.counters.getCounterValues(g.value), _ = v && Ar(v) ? wm.parse(i.context, v.value) : 3, I = C && C.type === 0 ? C.value : "", O = E.map(function(F) {
                    return eu(F, _, !1);
                  }).join(I);
                  l.appendChild(a.createTextNode(O));
                }
              }
            } else if (h.type === 20)
              switch (h.value) {
                case "open-quote":
                  l.appendChild(a.createTextNode(Ky(o.quotes, i.quoteDepth++, !0)));
                  break;
                case "close-quote":
                  l.appendChild(a.createTextNode(Ky(o.quotes, --i.quoteDepth, !1)));
                  break;
                default:
                  l.appendChild(a.createTextNode(h.value));
              }
          }), l.className = xm + " " + Em;
          var u = n === ql.BEFORE ? " " + xm : " " + Em;
          return ah(t) ? t.className.baseValue += u : t.className += u, l;
        }
      }
    }, r.destroy = function(e) {
      return e.parentNode ? (e.parentNode.removeChild(e), !0) : !1;
    }, r;
  })()
), ql;
(function(r) {
  r[r.BEFORE = 0] = "BEFORE", r[r.AFTER = 1] = "AFTER";
})(ql || (ql = {}));
var XM = function(r, e) {
  var t = r.createElement("iframe");
  return t.className = "html2canvas-container", t.style.visibility = "hidden", t.style.position = "fixed", t.style.left = "-10000px", t.style.top = "0px", t.style.border = "0", t.width = e.width.toString(), t.height = e.height.toString(), t.scrolling = "no", t.setAttribute(iE, "true"), r.body.appendChild(t), t;
}, YM = function(r) {
  return new Promise(function(e) {
    if (r.complete) {
      e();
      return;
    }
    if (!r.src) {
      e();
      return;
    }
    r.onload = e, r.onerror = e;
  });
}, JM = function(r) {
  return Promise.all([].slice.call(r.images, 0).map(YM));
}, $M = function(r) {
  return new Promise(function(e, t) {
    var A = r.contentWindow;
    if (!A)
      return t("No window assigned for iframe");
    var n = A.document;
    A.onload = r.onload = function() {
      A.onload = r.onload = null;
      var i = setInterval(function() {
        n.body.childNodes.length > 0 && n.readyState === "complete" && (clearInterval(i), e(r));
      }, 50);
    };
  });
}, ZM = [
  "all",
  "d",
  "content"
  // Safari shows pseudoelements if content is set
], Kd = function(r, e) {
  for (var t = r.length - 1; t >= 0; t--) {
    var A = r.item(t);
    ZM.indexOf(A) === -1 && e.style.setProperty(A, r.getPropertyValue(A));
  }
  return e;
}, eR = function(r) {
  var e = "";
  return r && (e += "<!DOCTYPE ", r.name && (e += r.name), r.internalSubset && (e += r.internalSubset), r.publicId && (e += '"' + r.publicId + '"'), r.systemId && (e += '"' + r.systemId + '"'), e += ">"), e;
}, tR = function(r, e, t) {
  r && r.defaultView && (e !== r.defaultView.pageXOffset || t !== r.defaultView.pageYOffset) && r.defaultView.scrollTo(e, t);
}, rR = function(r) {
  var e = r[0], t = r[1], A = r[2];
  e.scrollLeft = t, e.scrollTop = A;
}, AR = ":before", nR = ":after", xm = "___html2canvas___pseudoelement_before", Em = "___html2canvas___pseudoelement_after", g2 = `{
    content: "" !important;
    display: none !important;
}`, iR = function(r) {
  sR(r, "." + xm + AR + g2 + `
         .` + Em + nR + g2);
}, sR = function(r, e) {
  var t = r.ownerDocument;
  if (t) {
    var A = t.createElement("style");
    A.textContent = e, r.appendChild(A);
  }
}, sE = (
  /** @class */
  (function() {
    function r() {
    }
    return r.getOrigin = function(e) {
      var t = r._link;
      return t ? (t.href = e, t.href = t.href, t.protocol + t.hostname + t.port) : "about:blank";
    }, r.isSameOrigin = function(e) {
      return r.getOrigin(e) === r._origin;
    }, r.setContext = function(e) {
      r._link = e.document.createElement("a"), r._origin = r.getOrigin(e.location.href);
    }, r._origin = "about:blank", r;
  })()
), aR = (
  /** @class */
  (function() {
    function r(e, t) {
      this.context = e, this._options = t, this._cache = {};
    }
    return r.prototype.addImage = function(e) {
      var t = Promise.resolve();
      return this.has(e) || (qd(e) || cR(e)) && (this._cache[e] = this.loadImage(e)).catch(function() {
      }), t;
    }, r.prototype.match = function(e) {
      return this._cache[e];
    }, r.prototype.loadImage = function(e) {
      return jA(this, void 0, void 0, function() {
        var t, A, n, i, s = this;
        return TA(this, function(a) {
          switch (a.label) {
            case 0:
              return t = sE.isSameOrigin(e), A = !jd(e) && this._options.useCORS === !0 && SA.SUPPORT_CORS_IMAGES && !t, n = !jd(e) && !t && !qd(e) && typeof this._options.proxy == "string" && SA.SUPPORT_CORS_XHR && !A, !t && this._options.allowTaint === !1 && !jd(e) && !qd(e) && !n && !A ? [
                2
                /*return*/
              ] : (i = e, n ? [4, this.proxy(i)] : [3, 2]);
            case 1:
              i = a.sent(), a.label = 2;
            case 2:
              return this.context.logger.debug("Added image " + e.substring(0, 256)), [4, new Promise(function(o, l) {
                var u = new Image();
                u.onload = function() {
                  return o(u);
                }, u.onerror = l, (hR(i) || A) && (u.crossOrigin = "anonymous"), u.src = i, u.complete === !0 && setTimeout(function() {
                  return o(u);
                }, 500), s._options.imageTimeout > 0 && setTimeout(function() {
                  return l("Timed out (" + s._options.imageTimeout + "ms) loading image");
                }, s._options.imageTimeout);
              })];
            case 3:
              return [2, a.sent()];
          }
        });
      });
    }, r.prototype.has = function(e) {
      return typeof this._cache[e] < "u";
    }, r.prototype.keys = function() {
      return Promise.resolve(Object.keys(this._cache));
    }, r.prototype.proxy = function(e) {
      var t = this, A = this._options.proxy;
      if (!A)
        throw new Error("No proxy defined");
      var n = e.substring(0, 256);
      return new Promise(function(i, s) {
        var a = SA.SUPPORT_RESPONSE_TYPE ? "blob" : "text", o = new XMLHttpRequest();
        o.onload = function() {
          if (o.status === 200)
            if (a === "text")
              i(o.response);
            else {
              var h = new FileReader();
              h.addEventListener("load", function() {
                return i(h.result);
              }, !1), h.addEventListener("error", function(f) {
                return s(f);
              }, !1), h.readAsDataURL(o.response);
            }
          else
            s("Failed to proxy resource " + n + " with status code " + o.status);
        }, o.onerror = s;
        var l = A.indexOf("?") > -1 ? "&" : "?";
        if (o.open("GET", "" + A + l + "url=" + encodeURIComponent(e) + "&responseType=" + a), a !== "text" && o instanceof XMLHttpRequest && (o.responseType = a), t._options.imageTimeout) {
          var u = t._options.imageTimeout;
          o.timeout = u, o.ontimeout = function() {
            return s("Timed out (" + u + "ms) proxying " + n);
          };
        }
        o.send();
      });
    }, r;
  })()
), oR = /^data:image\/svg\+xml/i, lR = /^data:image\/.*;base64,/i, uR = /^data:image\/.*/i, cR = function(r) {
  return SA.SUPPORT_SVG_DRAWING || !fR(r);
}, jd = function(r) {
  return uR.test(r);
}, hR = function(r) {
  return lR.test(r);
}, qd = function(r) {
  return r.substr(0, 4) === "blob";
}, fR = function(r) {
  return r.substr(-3).toLowerCase() === "svg" || oR.test(r);
}, qe = (
  /** @class */
  (function() {
    function r(e, t) {
      this.type = 0, this.x = e, this.y = t;
    }
    return r.prototype.add = function(e, t) {
      return new r(this.x + e, this.y + t);
    }, r;
  })()
), oo = function(r, e, t) {
  return new qe(r.x + (e.x - r.x) * t, r.y + (e.y - r.y) * t);
}, Rc = (
  /** @class */
  (function() {
    function r(e, t, A, n) {
      this.type = 1, this.start = e, this.startControl = t, this.endControl = A, this.end = n;
    }
    return r.prototype.subdivide = function(e, t) {
      var A = oo(this.start, this.startControl, e), n = oo(this.startControl, this.endControl, e), i = oo(this.endControl, this.end, e), s = oo(A, n, e), a = oo(n, i, e), o = oo(s, a, e);
      return t ? new r(this.start, A, s, o) : new r(o, a, i, this.end);
    }, r.prototype.add = function(e, t) {
      return new r(this.start.add(e, t), this.startControl.add(e, t), this.endControl.add(e, t), this.end.add(e, t));
    }, r.prototype.reverse = function() {
      return new r(this.end, this.endControl, this.startControl, this.start);
    }, r;
  })()
), Nn = function(r) {
  return r.type === 1;
}, dR = (
  /** @class */
  /* @__PURE__ */ (function() {
    function r(e) {
      var t = e.styles, A = e.bounds, n = Ql(t.borderTopLeftRadius, A.width, A.height), i = n[0], s = n[1], a = Ql(t.borderTopRightRadius, A.width, A.height), o = a[0], l = a[1], u = Ql(t.borderBottomRightRadius, A.width, A.height), h = u[0], f = u[1], c = Ql(t.borderBottomLeftRadius, A.width, A.height), p = c[0], g = c[1], v = [];
      v.push((i + o) / A.width), v.push((p + h) / A.width), v.push((s + g) / A.height), v.push((l + f) / A.height);
      var w = Math.max.apply(Math, v);
      w > 1 && (i /= w, s /= w, o /= w, l /= w, h /= w, f /= w, p /= w, g /= w);
      var B = A.width - o, S = A.height - f, C = A.width - h, E = A.height - g, _ = t.borderTopWidth, I = t.borderRightWidth, O = t.borderBottomWidth, U = t.borderLeftWidth, V = dr(t.paddingTop, e.bounds.width), F = dr(t.paddingRight, e.bounds.width), P = dr(t.paddingBottom, e.bounds.width), D = dr(t.paddingLeft, e.bounds.width);
      this.topLeftBorderDoubleOuterBox = i > 0 || s > 0 ? br(A.left + U / 3, A.top + _ / 3, i - U / 3, s - _ / 3, $t.TOP_LEFT) : new qe(A.left + U / 3, A.top + _ / 3), this.topRightBorderDoubleOuterBox = i > 0 || s > 0 ? br(A.left + B, A.top + _ / 3, o - I / 3, l - _ / 3, $t.TOP_RIGHT) : new qe(A.left + A.width - I / 3, A.top + _ / 3), this.bottomRightBorderDoubleOuterBox = h > 0 || f > 0 ? br(A.left + C, A.top + S, h - I / 3, f - O / 3, $t.BOTTOM_RIGHT) : new qe(A.left + A.width - I / 3, A.top + A.height - O / 3), this.bottomLeftBorderDoubleOuterBox = p > 0 || g > 0 ? br(A.left + U / 3, A.top + E, p - U / 3, g - O / 3, $t.BOTTOM_LEFT) : new qe(A.left + U / 3, A.top + A.height - O / 3), this.topLeftBorderDoubleInnerBox = i > 0 || s > 0 ? br(A.left + U * 2 / 3, A.top + _ * 2 / 3, i - U * 2 / 3, s - _ * 2 / 3, $t.TOP_LEFT) : new qe(A.left + U * 2 / 3, A.top + _ * 2 / 3), this.topRightBorderDoubleInnerBox = i > 0 || s > 0 ? br(A.left + B, A.top + _ * 2 / 3, o - I * 2 / 3, l - _ * 2 / 3, $t.TOP_RIGHT) : new qe(A.left + A.width - I * 2 / 3, A.top + _ * 2 / 3), this.bottomRightBorderDoubleInnerBox = h > 0 || f > 0 ? br(A.left + C, A.top + S, h - I * 2 / 3, f - O * 2 / 3, $t.BOTTOM_RIGHT) : new qe(A.left + A.width - I * 2 / 3, A.top + A.height - O * 2 / 3), this.bottomLeftBorderDoubleInnerBox = p > 0 || g > 0 ? br(A.left + U * 2 / 3, A.top + E, p - U * 2 / 3, g - O * 2 / 3, $t.BOTTOM_LEFT) : new qe(A.left + U * 2 / 3, A.top + A.height - O * 2 / 3), this.topLeftBorderStroke = i > 0 || s > 0 ? br(A.left + U / 2, A.top + _ / 2, i - U / 2, s - _ / 2, $t.TOP_LEFT) : new qe(A.left + U / 2, A.top + _ / 2), this.topRightBorderStroke = i > 0 || s > 0 ? br(A.left + B, A.top + _ / 2, o - I / 2, l - _ / 2, $t.TOP_RIGHT) : new qe(A.left + A.width - I / 2, A.top + _ / 2), this.bottomRightBorderStroke = h > 0 || f > 0 ? br(A.left + C, A.top + S, h - I / 2, f - O / 2, $t.BOTTOM_RIGHT) : new qe(A.left + A.width - I / 2, A.top + A.height - O / 2), this.bottomLeftBorderStroke = p > 0 || g > 0 ? br(A.left + U / 2, A.top + E, p - U / 2, g - O / 2, $t.BOTTOM_LEFT) : new qe(A.left + U / 2, A.top + A.height - O / 2), this.topLeftBorderBox = i > 0 || s > 0 ? br(A.left, A.top, i, s, $t.TOP_LEFT) : new qe(A.left, A.top), this.topRightBorderBox = o > 0 || l > 0 ? br(A.left + B, A.top, o, l, $t.TOP_RIGHT) : new qe(A.left + A.width, A.top), this.bottomRightBorderBox = h > 0 || f > 0 ? br(A.left + C, A.top + S, h, f, $t.BOTTOM_RIGHT) : new qe(A.left + A.width, A.top + A.height), this.bottomLeftBorderBox = p > 0 || g > 0 ? br(A.left, A.top + E, p, g, $t.BOTTOM_LEFT) : new qe(A.left, A.top + A.height), this.topLeftPaddingBox = i > 0 || s > 0 ? br(A.left + U, A.top + _, Math.max(0, i - U), Math.max(0, s - _), $t.TOP_LEFT) : new qe(A.left + U, A.top + _), this.topRightPaddingBox = o > 0 || l > 0 ? br(A.left + Math.min(B, A.width - I), A.top + _, B > A.width + I ? 0 : Math.max(0, o - I), Math.max(0, l - _), $t.TOP_RIGHT) : new qe(A.left + A.width - I, A.top + _), this.bottomRightPaddingBox = h > 0 || f > 0 ? br(A.left + Math.min(C, A.width - U), A.top + Math.min(S, A.height - O), Math.max(0, h - I), Math.max(0, f - O), $t.BOTTOM_RIGHT) : new qe(A.left + A.width - I, A.top + A.height - O), this.bottomLeftPaddingBox = p > 0 || g > 0 ? br(A.left + U, A.top + Math.min(E, A.height - O), Math.max(0, p - U), Math.max(0, g - O), $t.BOTTOM_LEFT) : new qe(A.left + U, A.top + A.height - O), this.topLeftContentBox = i > 0 || s > 0 ? br(A.left + U + D, A.top + _ + V, Math.max(0, i - (U + D)), Math.max(0, s - (_ + V)), $t.TOP_LEFT) : new qe(A.left + U + D, A.top + _ + V), this.topRightContentBox = o > 0 || l > 0 ? br(A.left + Math.min(B, A.width + U + D), A.top + _ + V, B > A.width + U + D ? 0 : o - U + D, l - (_ + V), $t.TOP_RIGHT) : new qe(A.left + A.width - (I + F), A.top + _ + V), this.bottomRightContentBox = h > 0 || f > 0 ? br(A.left + Math.min(C, A.width - (U + D)), A.top + Math.min(S, A.height + _ + V), Math.max(0, h - (I + F)), f - (O + P), $t.BOTTOM_RIGHT) : new qe(A.left + A.width - (I + F), A.top + A.height - (O + P)), this.bottomLeftContentBox = p > 0 || g > 0 ? br(A.left + U + D, A.top + E, Math.max(0, p - (U + D)), g - (O + P), $t.BOTTOM_LEFT) : new qe(A.left + U + D, A.top + A.height - (O + P));
    }
    return r;
  })()
), $t;
(function(r) {
  r[r.TOP_LEFT = 0] = "TOP_LEFT", r[r.TOP_RIGHT = 1] = "TOP_RIGHT", r[r.BOTTOM_RIGHT = 2] = "BOTTOM_RIGHT", r[r.BOTTOM_LEFT = 3] = "BOTTOM_LEFT";
})($t || ($t = {}));
var br = function(r, e, t, A, n) {
  var i = 4 * ((Math.sqrt(2) - 1) / 3), s = t * i, a = A * i, o = r + t, l = e + A;
  switch (n) {
    case $t.TOP_LEFT:
      return new Rc(new qe(r, l), new qe(r, l - a), new qe(o - s, e), new qe(o, e));
    case $t.TOP_RIGHT:
      return new Rc(new qe(r, e), new qe(r + s, e), new qe(o, l - a), new qe(o, l));
    case $t.BOTTOM_RIGHT:
      return new Rc(new qe(o, e), new qe(o, e + a), new qe(r + s, l), new qe(r, l));
    case $t.BOTTOM_LEFT:
    default:
      return new Rc(new qe(o, l), new qe(o - s, l), new qe(r, e + a), new qe(r, e));
  }
}, Eh = function(r) {
  return [r.topLeftBorderBox, r.topRightBorderBox, r.bottomRightBorderBox, r.bottomLeftBorderBox];
}, gR = function(r) {
  return [
    r.topLeftContentBox,
    r.topRightContentBox,
    r.bottomRightContentBox,
    r.bottomLeftContentBox
  ];
}, Fh = function(r) {
  return [
    r.topLeftPaddingBox,
    r.topRightPaddingBox,
    r.bottomRightPaddingBox,
    r.bottomLeftPaddingBox
  ];
}, pR = (
  /** @class */
  /* @__PURE__ */ (function() {
    function r(e, t, A) {
      this.offsetX = e, this.offsetY = t, this.matrix = A, this.type = 0, this.target = 6;
    }
    return r;
  })()
), kc = (
  /** @class */
  /* @__PURE__ */ (function() {
    function r(e, t) {
      this.path = e, this.target = t, this.type = 1;
    }
    return r;
  })()
), mR = (
  /** @class */
  /* @__PURE__ */ (function() {
    function r(e) {
      this.opacity = e, this.type = 2, this.target = 6;
    }
    return r;
  })()
), vR = function(r) {
  return r.type === 0;
}, aE = function(r) {
  return r.type === 1;
}, wR = function(r) {
  return r.type === 2;
}, p2 = function(r, e) {
  return r.length === e.length ? r.some(function(t, A) {
    return t === e[A];
  }) : !1;
}, yR = function(r, e, t, A, n) {
  return r.map(function(i, s) {
    switch (s) {
      case 0:
        return i.add(e, t);
      case 1:
        return i.add(e + A, t);
      case 2:
        return i.add(e + A, t + n);
      case 3:
        return i.add(e, t + n);
    }
    return i;
  });
}, oE = (
  /** @class */
  /* @__PURE__ */ (function() {
    function r(e) {
      this.element = e, this.inlineLevel = [], this.nonInlineLevel = [], this.negativeZIndex = [], this.zeroOrAutoZIndexOrTransformedOrOpacity = [], this.positiveZIndex = [], this.nonPositionedFloats = [], this.nonPositionedInlineLevel = [];
    }
    return r;
  })()
), lE = (
  /** @class */
  (function() {
    function r(e, t) {
      if (this.container = e, this.parent = t, this.effects = [], this.curves = new dR(this.container), this.container.styles.opacity < 1 && this.effects.push(new mR(this.container.styles.opacity)), this.container.styles.transform !== null) {
        var A = this.container.bounds.left + this.container.styles.transformOrigin[0].number, n = this.container.bounds.top + this.container.styles.transformOrigin[1].number, i = this.container.styles.transform;
        this.effects.push(new pR(A, n, i));
      }
      if (this.container.styles.overflowX !== 0) {
        var s = Eh(this.curves), a = Fh(this.curves);
        p2(s, a) ? this.effects.push(new kc(
          s,
          6
          /* CONTENT */
        )) : (this.effects.push(new kc(
          s,
          2
          /* BACKGROUND_BORDERS */
        )), this.effects.push(new kc(
          a,
          4
          /* CONTENT */
        )));
      }
    }
    return r.prototype.getEffects = function(e) {
      for (var t = [
        2,
        3
        /* FIXED */
      ].indexOf(this.container.styles.position) === -1, A = this.parent, n = this.effects.slice(0); A; ) {
        var i = A.effects.filter(function(o) {
          return !aE(o);
        });
        if (t || A.container.styles.position !== 0 || !A.parent) {
          if (n.unshift.apply(n, i), t = [
            2,
            3
            /* FIXED */
          ].indexOf(A.container.styles.position) === -1, A.container.styles.overflowX !== 0) {
            var s = Eh(A.curves), a = Fh(A.curves);
            p2(s, a) || n.unshift(new kc(
              a,
              6
              /* CONTENT */
            ));
          }
        } else
          n.unshift.apply(n, i);
        A = A.parent;
      }
      return n.filter(function(o) {
        return hA(o.target, e);
      });
    }, r;
  })()
), Fm = function(r, e, t, A) {
  r.container.elements.forEach(function(n) {
    var i = hA(
      n.flags,
      4
      /* CREATES_REAL_STACKING_CONTEXT */
    ), s = hA(
      n.flags,
      2
      /* CREATES_STACKING_CONTEXT */
    ), a = new lE(n, r);
    hA(
      n.styles.display,
      2048
      /* LIST_ITEM */
    ) && A.push(a);
    var o = hA(
      n.flags,
      8
      /* IS_LIST_OWNER */
    ) ? [] : A;
    if (i || s) {
      var l = i || n.styles.isPositioned() ? t : e, u = new oE(a);
      if (n.styles.isPositioned() || n.styles.opacity < 1 || n.styles.isTransformed()) {
        var h = n.styles.zIndex.order;
        if (h < 0) {
          var f = 0;
          l.negativeZIndex.some(function(p, g) {
            return h > p.element.container.styles.zIndex.order ? (f = g, !1) : f > 0;
          }), l.negativeZIndex.splice(f, 0, u);
        } else if (h > 0) {
          var c = 0;
          l.positiveZIndex.some(function(p, g) {
            return h >= p.element.container.styles.zIndex.order ? (c = g + 1, !1) : c > 0;
          }), l.positiveZIndex.splice(c, 0, u);
        } else
          l.zeroOrAutoZIndexOrTransformedOrOpacity.push(u);
      } else
        n.styles.isFloating() ? l.nonPositionedFloats.push(u) : l.nonPositionedInlineLevel.push(u);
      Fm(a, u, i ? u : t, o);
    } else
      n.styles.isInlineLevel() ? e.inlineLevel.push(a) : e.nonInlineLevel.push(a), Fm(a, e, t, o);
    hA(
      n.flags,
      8
      /* IS_LIST_OWNER */
    ) && uE(n, o);
  });
}, uE = function(r, e) {
  for (var t = r instanceof bm ? r.start : 1, A = r instanceof bm ? r.reversed : !1, n = 0; n < e.length; n++) {
    var i = e[n];
    i.container instanceof zx && typeof i.container.value == "number" && i.container.value !== 0 && (t = i.container.value), i.listValue = eu(t, i.container.styles.listStyleType, !0), t += A ? -1 : 1;
  }
}, BR = function(r) {
  var e = new lE(r, null), t = new oE(e), A = [];
  return Fm(e, t, t, A), uE(e.container, A), t;
}, m2 = function(r, e) {
  switch (e) {
    case 0:
      return On(r.topLeftBorderBox, r.topLeftPaddingBox, r.topRightBorderBox, r.topRightPaddingBox);
    case 1:
      return On(r.topRightBorderBox, r.topRightPaddingBox, r.bottomRightBorderBox, r.bottomRightPaddingBox);
    case 2:
      return On(r.bottomRightBorderBox, r.bottomRightPaddingBox, r.bottomLeftBorderBox, r.bottomLeftPaddingBox);
    case 3:
    default:
      return On(r.bottomLeftBorderBox, r.bottomLeftPaddingBox, r.topLeftBorderBox, r.topLeftPaddingBox);
  }
}, bR = function(r, e) {
  switch (e) {
    case 0:
      return On(r.topLeftBorderBox, r.topLeftBorderDoubleOuterBox, r.topRightBorderBox, r.topRightBorderDoubleOuterBox);
    case 1:
      return On(r.topRightBorderBox, r.topRightBorderDoubleOuterBox, r.bottomRightBorderBox, r.bottomRightBorderDoubleOuterBox);
    case 2:
      return On(r.bottomRightBorderBox, r.bottomRightBorderDoubleOuterBox, r.bottomLeftBorderBox, r.bottomLeftBorderDoubleOuterBox);
    case 3:
    default:
      return On(r.bottomLeftBorderBox, r.bottomLeftBorderDoubleOuterBox, r.topLeftBorderBox, r.topLeftBorderDoubleOuterBox);
  }
}, CR = function(r, e) {
  switch (e) {
    case 0:
      return On(r.topLeftBorderDoubleInnerBox, r.topLeftPaddingBox, r.topRightBorderDoubleInnerBox, r.topRightPaddingBox);
    case 1:
      return On(r.topRightBorderDoubleInnerBox, r.topRightPaddingBox, r.bottomRightBorderDoubleInnerBox, r.bottomRightPaddingBox);
    case 2:
      return On(r.bottomRightBorderDoubleInnerBox, r.bottomRightPaddingBox, r.bottomLeftBorderDoubleInnerBox, r.bottomLeftPaddingBox);
    case 3:
    default:
      return On(r.bottomLeftBorderDoubleInnerBox, r.bottomLeftPaddingBox, r.topLeftBorderDoubleInnerBox, r.topLeftPaddingBox);
  }
}, SR = function(r, e) {
  switch (e) {
    case 0:
      return Hc(r.topLeftBorderStroke, r.topRightBorderStroke);
    case 1:
      return Hc(r.topRightBorderStroke, r.bottomRightBorderStroke);
    case 2:
      return Hc(r.bottomRightBorderStroke, r.bottomLeftBorderStroke);
    case 3:
    default:
      return Hc(r.bottomLeftBorderStroke, r.topLeftBorderStroke);
  }
}, Hc = function(r, e) {
  var t = [];
  return Nn(r) ? t.push(r.subdivide(0.5, !1)) : t.push(r), Nn(e) ? t.push(e.subdivide(0.5, !0)) : t.push(e), t;
}, On = function(r, e, t, A) {
  var n = [];
  return Nn(r) ? n.push(r.subdivide(0.5, !1)) : n.push(r), Nn(t) ? n.push(t.subdivide(0.5, !0)) : n.push(t), Nn(A) ? n.push(A.subdivide(0.5, !0).reverse()) : n.push(A), Nn(e) ? n.push(e.subdivide(0.5, !1).reverse()) : n.push(e), n;
}, cE = function(r) {
  var e = r.bounds, t = r.styles;
  return e.add(t.borderLeftWidth, t.borderTopWidth, -(t.borderRightWidth + t.borderLeftWidth), -(t.borderTopWidth + t.borderBottomWidth));
}, _h = function(r) {
  var e = r.styles, t = r.bounds, A = dr(e.paddingLeft, t.width), n = dr(e.paddingRight, t.width), i = dr(e.paddingTop, t.width), s = dr(e.paddingBottom, t.width);
  return t.add(A + e.borderLeftWidth, i + e.borderTopWidth, -(e.borderRightWidth + e.borderLeftWidth + A + n), -(e.borderTopWidth + e.borderBottomWidth + i + s));
}, xR = function(r, e) {
  return r === 0 ? e.bounds : r === 2 ? _h(e) : cE(e);
}, ER = function(r, e) {
  return r === 0 ? e.bounds : r === 2 ? _h(e) : cE(e);
}, zd = function(r, e, t) {
  var A = xR(po(r.styles.backgroundOrigin, e), r), n = ER(po(r.styles.backgroundClip, e), r), i = FR(po(r.styles.backgroundSize, e), t, A), s = i[0], a = i[1], o = Ql(po(r.styles.backgroundPosition, e), A.width - s, A.height - a), l = _R(po(r.styles.backgroundRepeat, e), o, i, A, n), u = Math.round(A.left + o[0]), h = Math.round(A.top + o[1]);
  return [l, u, h, s, a];
}, lo = function(r) {
  return Ar(r) && r.value === Eo.AUTO;
}, Dc = function(r) {
  return typeof r == "number";
}, FR = function(r, e, t) {
  var A = e[0], n = e[1], i = e[2], s = r[0], a = r[1];
  if (!s)
    return [0, 0];
  if (nA(s) && a && nA(a))
    return [dr(s, t.width), dr(a, t.height)];
  var o = Dc(i);
  if (Ar(s) && (s.value === Eo.CONTAIN || s.value === Eo.COVER)) {
    if (Dc(i)) {
      var l = t.width / t.height;
      return l < i != (s.value === Eo.COVER) ? [t.width, t.width / i] : [t.height * i, t.height];
    }
    return [t.width, t.height];
  }
  var u = Dc(A), h = Dc(n), f = u || h;
  if (lo(s) && (!a || lo(a))) {
    if (u && h)
      return [A, n];
    if (!o && !f)
      return [t.width, t.height];
    if (f && o) {
      var c = u ? A : n * i, p = h ? n : A / i;
      return [c, p];
    }
    var g = u ? A : t.width, v = h ? n : t.height;
    return [g, v];
  }
  if (o) {
    var w = 0, B = 0;
    return nA(s) ? w = dr(s, t.width) : nA(a) && (B = dr(a, t.height)), lo(s) ? w = B * i : (!a || lo(a)) && (B = w / i), [w, B];
  }
  var S = null, C = null;
  if (nA(s) ? S = dr(s, t.width) : a && nA(a) && (C = dr(a, t.height)), S !== null && (!a || lo(a)) && (C = u && h ? S / A * n : t.height), C !== null && lo(s) && (S = u && h ? C / n * A : t.width), S !== null && C !== null)
    return [S, C];
  throw new Error("Unable to calculate background-size for element");
}, po = function(r, e) {
  var t = r[e];
  return typeof t > "u" ? r[0] : t;
}, _R = function(r, e, t, A, n) {
  var i = e[0], s = e[1], a = t[0], o = t[1];
  switch (r) {
    case 2:
      return [
        new qe(Math.round(A.left), Math.round(A.top + s)),
        new qe(Math.round(A.left + A.width), Math.round(A.top + s)),
        new qe(Math.round(A.left + A.width), Math.round(o + A.top + s)),
        new qe(Math.round(A.left), Math.round(o + A.top + s))
      ];
    case 3:
      return [
        new qe(Math.round(A.left + i), Math.round(A.top)),
        new qe(Math.round(A.left + i + a), Math.round(A.top)),
        new qe(Math.round(A.left + i + a), Math.round(A.height + A.top)),
        new qe(Math.round(A.left + i), Math.round(A.height + A.top))
      ];
    case 1:
      return [
        new qe(Math.round(A.left + i), Math.round(A.top + s)),
        new qe(Math.round(A.left + i + a), Math.round(A.top + s)),
        new qe(Math.round(A.left + i + a), Math.round(A.top + s + o)),
        new qe(Math.round(A.left + i), Math.round(A.top + s + o))
      ];
    default:
      return [
        new qe(Math.round(n.left), Math.round(n.top)),
        new qe(Math.round(n.left + n.width), Math.round(n.top)),
        new qe(Math.round(n.left + n.width), Math.round(n.height + n.top)),
        new qe(Math.round(n.left), Math.round(n.height + n.top))
      ];
  }
}, UR = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7", v2 = "Hidden Text", IR = (
  /** @class */
  (function() {
    function r(e) {
      this._data = {}, this._document = e;
    }
    return r.prototype.parseMetrics = function(e, t) {
      var A = this._document.createElement("div"), n = this._document.createElement("img"), i = this._document.createElement("span"), s = this._document.body;
      A.style.visibility = "hidden", A.style.fontFamily = e, A.style.fontSize = t, A.style.margin = "0", A.style.padding = "0", A.style.whiteSpace = "nowrap", s.appendChild(A), n.src = UR, n.width = 1, n.height = 1, n.style.margin = "0", n.style.padding = "0", n.style.verticalAlign = "baseline", i.style.fontFamily = e, i.style.fontSize = t, i.style.margin = "0", i.style.padding = "0", i.appendChild(this._document.createTextNode(v2)), A.appendChild(i), A.appendChild(n);
      var a = n.offsetTop - i.offsetTop + 2;
      A.removeChild(i), A.appendChild(this._document.createTextNode(v2)), A.style.lineHeight = "normal", n.style.verticalAlign = "super";
      var o = n.offsetTop - A.offsetTop + 2;
      return s.removeChild(A), { baseline: a, middle: o };
    }, r.prototype.getMetrics = function(e, t) {
      var A = e + " " + t;
      return typeof this._data[A] > "u" && (this._data[A] = this.parseMetrics(e, t)), this._data[A];
    }, r;
  })()
), hE = (
  /** @class */
  /* @__PURE__ */ (function() {
    function r(e, t) {
      this.context = e, this.options = t;
    }
    return r;
  })()
), QR = 1e4, LR = (
  /** @class */
  (function(r) {
    ii(e, r);
    function e(t, A) {
      var n = r.call(this, t, A) || this;
      return n._activeEffects = [], n.canvas = A.canvas ? A.canvas : document.createElement("canvas"), n.ctx = n.canvas.getContext("2d"), A.canvas || (n.canvas.width = Math.floor(A.width * A.scale), n.canvas.height = Math.floor(A.height * A.scale), n.canvas.style.width = A.width + "px", n.canvas.style.height = A.height + "px"), n.fontMetrics = new IR(document), n.ctx.scale(n.options.scale, n.options.scale), n.ctx.translate(-A.x, -A.y), n.ctx.textBaseline = "bottom", n._activeEffects = [], n.context.logger.debug("Canvas renderer initialized (" + A.width + "x" + A.height + ") with scale " + A.scale), n;
    }
    return e.prototype.applyEffects = function(t) {
      for (var A = this; this._activeEffects.length; )
        this.popEffect();
      t.forEach(function(n) {
        return A.applyEffect(n);
      });
    }, e.prototype.applyEffect = function(t) {
      this.ctx.save(), wR(t) && (this.ctx.globalAlpha = t.opacity), vR(t) && (this.ctx.translate(t.offsetX, t.offsetY), this.ctx.transform(t.matrix[0], t.matrix[1], t.matrix[2], t.matrix[3], t.matrix[4], t.matrix[5]), this.ctx.translate(-t.offsetX, -t.offsetY)), aE(t) && (this.path(t.path), this.ctx.clip()), this._activeEffects.push(t);
    }, e.prototype.popEffect = function() {
      this._activeEffects.pop(), this.ctx.restore();
    }, e.prototype.renderStack = function(t) {
      return jA(this, void 0, void 0, function() {
        var A;
        return TA(this, function(n) {
          switch (n.label) {
            case 0:
              return A = t.element.container.styles, A.isVisible() ? [4, this.renderStackContent(t)] : [3, 2];
            case 1:
              n.sent(), n.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.renderNode = function(t) {
      return jA(this, void 0, void 0, function() {
        return TA(this, function(A) {
          switch (A.label) {
            case 0:
              if (hA(
                t.container.flags,
                16
                /* DEBUG_RENDER */
              ))
                debugger;
              return t.container.styles.isVisible() ? [4, this.renderNodeBackgroundAndBorders(t)] : [3, 3];
            case 1:
              return A.sent(), [4, this.renderNodeContent(t)];
            case 2:
              A.sent(), A.label = 3;
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.renderTextWithLetterSpacing = function(t, A, n) {
      var i = this;
      if (A === 0)
        this.ctx.fillText(t.text, t.bounds.left, t.bounds.top + n);
      else {
        var s = mv(t.text);
        s.reduce(function(a, o) {
          return i.ctx.fillText(o, a, t.bounds.top + n), a + i.ctx.measureText(o).width;
        }, t.bounds.left);
      }
    }, e.prototype.createFontStyle = function(t) {
      var A = t.fontVariant.filter(function(s) {
        return s === "normal" || s === "small-caps";
      }).join(""), n = MR(t.fontFamily).join(", "), i = pu(t.fontSize) ? "" + t.fontSize.number + t.fontSize.unit : t.fontSize.number + "px";
      return [
        [t.fontStyle, A, t.fontWeight, i, n].join(" "),
        n,
        i
      ];
    }, e.prototype.renderTextNode = function(t, A) {
      return jA(this, void 0, void 0, function() {
        var n, i, s, a, o, l, u, h, f = this;
        return TA(this, function(c) {
          return n = this.createFontStyle(A), i = n[0], s = n[1], a = n[2], this.ctx.font = i, this.ctx.direction = A.direction === 1 ? "rtl" : "ltr", this.ctx.textAlign = "left", this.ctx.textBaseline = "alphabetic", o = this.fontMetrics.getMetrics(s, a), l = o.baseline, u = o.middle, h = A.paintOrder, t.textBounds.forEach(function(p) {
            h.forEach(function(g) {
              switch (g) {
                case 0:
                  f.ctx.fillStyle = gA(A.color), f.renderTextWithLetterSpacing(p, A.letterSpacing, l);
                  var v = A.textShadow;
                  v.length && p.text.trim().length && (v.slice(0).reverse().forEach(function(w) {
                    f.ctx.shadowColor = gA(w.color), f.ctx.shadowOffsetX = w.offsetX.number * f.options.scale, f.ctx.shadowOffsetY = w.offsetY.number * f.options.scale, f.ctx.shadowBlur = w.blur.number, f.renderTextWithLetterSpacing(p, A.letterSpacing, l);
                  }), f.ctx.shadowColor = "", f.ctx.shadowOffsetX = 0, f.ctx.shadowOffsetY = 0, f.ctx.shadowBlur = 0), A.textDecorationLine.length && (f.ctx.fillStyle = gA(A.textDecorationColor || A.color), A.textDecorationLine.forEach(function(w) {
                    switch (w) {
                      case 1:
                        f.ctx.fillRect(p.bounds.left, Math.round(p.bounds.top + l), p.bounds.width, 1);
                        break;
                      case 2:
                        f.ctx.fillRect(p.bounds.left, Math.round(p.bounds.top), p.bounds.width, 1);
                        break;
                      case 3:
                        f.ctx.fillRect(p.bounds.left, Math.ceil(p.bounds.top + u), p.bounds.width, 1);
                        break;
                    }
                  }));
                  break;
                case 1:
                  A.webkitTextStrokeWidth && p.text.trim().length && (f.ctx.strokeStyle = gA(A.webkitTextStrokeColor), f.ctx.lineWidth = A.webkitTextStrokeWidth, f.ctx.lineJoin = window.chrome ? "miter" : "round", f.ctx.strokeText(p.text, p.bounds.left, p.bounds.top + l)), f.ctx.strokeStyle = "", f.ctx.lineWidth = 0, f.ctx.lineJoin = "miter";
                  break;
              }
            });
          }), [
            2
            /*return*/
          ];
        });
      });
    }, e.prototype.renderReplacedElement = function(t, A, n) {
      if (n && t.intrinsicWidth > 0 && t.intrinsicHeight > 0) {
        var i = _h(t), s = Fh(A);
        this.path(s), this.ctx.save(), this.ctx.clip(), this.ctx.drawImage(n, 0, 0, t.intrinsicWidth, t.intrinsicHeight, i.left, i.top, i.width, i.height), this.ctx.restore();
      }
    }, e.prototype.renderNodeContent = function(t) {
      return jA(this, void 0, void 0, function() {
        var A, n, i, s, a, o, B, B, l, u, h, f, C, c, p, E, g, v, w, B, S, C, E;
        return TA(this, function(_) {
          switch (_.label) {
            case 0:
              this.applyEffects(t.getEffects(
                4
                /* CONTENT */
              )), A = t.container, n = t.curves, i = A.styles, s = 0, a = A.textNodes, _.label = 1;
            case 1:
              return s < a.length ? (o = a[s], [4, this.renderTextNode(o, i)]) : [3, 4];
            case 2:
              _.sent(), _.label = 3;
            case 3:
              return s++, [3, 1];
            case 4:
              if (!(A instanceof Kx)) return [3, 8];
              _.label = 5;
            case 5:
              return _.trys.push([5, 7, , 8]), [4, this.context.cache.match(A.src)];
            case 6:
              return B = _.sent(), this.renderReplacedElement(A, n, B), [3, 8];
            case 7:
              return _.sent(), this.context.logger.error("Error loading image " + A.src), [3, 8];
            case 8:
              if (A instanceof jx && this.renderReplacedElement(A, n, A.canvas), !(A instanceof qx)) return [3, 12];
              _.label = 9;
            case 9:
              return _.trys.push([9, 11, , 12]), [4, this.context.cache.match(A.svg)];
            case 10:
              return B = _.sent(), this.renderReplacedElement(A, n, B), [3, 12];
            case 11:
              return _.sent(), this.context.logger.error("Error loading svg " + A.svg.substring(0, 255)), [3, 12];
            case 12:
              return A instanceof Yx && A.tree ? (l = new e(this.context, {
                scale: this.options.scale,
                backgroundColor: A.backgroundColor,
                x: 0,
                y: 0,
                width: A.width,
                height: A.height
              }), [4, l.render(A.tree)]) : [3, 14];
            case 13:
              u = _.sent(), A.width && A.height && this.ctx.drawImage(u, 0, 0, A.width, A.height, A.bounds.left, A.bounds.top, A.bounds.width, A.bounds.height), _.label = 14;
            case 14:
              if (A instanceof vv && (h = Math.min(A.bounds.width, A.bounds.height), A.type === bh ? A.checked && (this.ctx.save(), this.path([
                new qe(A.bounds.left + h * 0.39363, A.bounds.top + h * 0.79),
                new qe(A.bounds.left + h * 0.16, A.bounds.top + h * 0.5549),
                new qe(A.bounds.left + h * 0.27347, A.bounds.top + h * 0.44071),
                new qe(A.bounds.left + h * 0.39694, A.bounds.top + h * 0.5649),
                new qe(A.bounds.left + h * 0.72983, A.bounds.top + h * 0.23),
                new qe(A.bounds.left + h * 0.84, A.bounds.top + h * 0.34085),
                new qe(A.bounds.left + h * 0.39363, A.bounds.top + h * 0.79)
              ]), this.ctx.fillStyle = gA(i2), this.ctx.fill(), this.ctx.restore()) : A.type === Ch && A.checked && (this.ctx.save(), this.ctx.beginPath(), this.ctx.arc(A.bounds.left + h / 2, A.bounds.top + h / 2, h / 4, 0, Math.PI * 2, !0), this.ctx.fillStyle = gA(i2), this.ctx.fill(), this.ctx.restore())), NR(A) && A.value.length) {
                switch (f = this.createFontStyle(i), C = f[0], c = f[1], p = this.fontMetrics.getMetrics(C, c).baseline, this.ctx.font = C, this.ctx.fillStyle = gA(i.color), this.ctx.textBaseline = "alphabetic", this.ctx.textAlign = PR(A.styles.textAlign), E = _h(A), g = 0, A.styles.textAlign) {
                  case 1:
                    g += E.width / 2;
                    break;
                  case 2:
                    g += E.width;
                    break;
                }
                v = E.add(g, 0, 0, -E.height / 2 + 1), this.ctx.save(), this.path([
                  new qe(E.left, E.top),
                  new qe(E.left + E.width, E.top),
                  new qe(E.left + E.width, E.top + E.height),
                  new qe(E.left, E.top + E.height)
                ]), this.ctx.clip(), this.renderTextWithLetterSpacing(new jl(A.value, v), i.letterSpacing, p), this.ctx.restore(), this.ctx.textBaseline = "alphabetic", this.ctx.textAlign = "left";
              }
              if (!hA(
                A.styles.display,
                2048
                /* LIST_ITEM */
              )) return [3, 20];
              if (A.styles.listStyleImage === null) return [3, 19];
              if (w = A.styles.listStyleImage, w.type !== 0) return [3, 18];
              B = void 0, S = w.url, _.label = 15;
            case 15:
              return _.trys.push([15, 17, , 18]), [4, this.context.cache.match(S)];
            case 16:
              return B = _.sent(), this.ctx.drawImage(B, A.bounds.left - (B.width + 10), A.bounds.top), [3, 18];
            case 17:
              return _.sent(), this.context.logger.error("Error loading list-style-image " + S), [3, 18];
            case 18:
              return [3, 20];
            case 19:
              t.listValue && A.styles.listStyleType !== -1 && (C = this.createFontStyle(i)[0], this.ctx.font = C, this.ctx.fillStyle = gA(i.color), this.ctx.textBaseline = "middle", this.ctx.textAlign = "right", E = new As(A.bounds.left, A.bounds.top + dr(A.styles.paddingTop, A.bounds.width), A.bounds.width, Gy(i.lineHeight, i.fontSize.number) / 2 + 1), this.renderTextWithLetterSpacing(new jl(t.listValue, E), i.letterSpacing, Gy(i.lineHeight, i.fontSize.number) / 2 + 2), this.ctx.textBaseline = "bottom", this.ctx.textAlign = "left"), _.label = 20;
            case 20:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.renderStackContent = function(t) {
      return jA(this, void 0, void 0, function() {
        var A, n, w, i, s, w, a, o, w, l, u, w, h, f, w, c, p, w, g, v, w;
        return TA(this, function(B) {
          switch (B.label) {
            case 0:
              if (hA(
                t.element.container.flags,
                16
                /* DEBUG_RENDER */
              ))
                debugger;
              return [4, this.renderNodeBackgroundAndBorders(t.element)];
            case 1:
              B.sent(), A = 0, n = t.negativeZIndex, B.label = 2;
            case 2:
              return A < n.length ? (w = n[A], [4, this.renderStack(w)]) : [3, 5];
            case 3:
              B.sent(), B.label = 4;
            case 4:
              return A++, [3, 2];
            case 5:
              return [4, this.renderNodeContent(t.element)];
            case 6:
              B.sent(), i = 0, s = t.nonInlineLevel, B.label = 7;
            case 7:
              return i < s.length ? (w = s[i], [4, this.renderNode(w)]) : [3, 10];
            case 8:
              B.sent(), B.label = 9;
            case 9:
              return i++, [3, 7];
            case 10:
              a = 0, o = t.nonPositionedFloats, B.label = 11;
            case 11:
              return a < o.length ? (w = o[a], [4, this.renderStack(w)]) : [3, 14];
            case 12:
              B.sent(), B.label = 13;
            case 13:
              return a++, [3, 11];
            case 14:
              l = 0, u = t.nonPositionedInlineLevel, B.label = 15;
            case 15:
              return l < u.length ? (w = u[l], [4, this.renderStack(w)]) : [3, 18];
            case 16:
              B.sent(), B.label = 17;
            case 17:
              return l++, [3, 15];
            case 18:
              h = 0, f = t.inlineLevel, B.label = 19;
            case 19:
              return h < f.length ? (w = f[h], [4, this.renderNode(w)]) : [3, 22];
            case 20:
              B.sent(), B.label = 21;
            case 21:
              return h++, [3, 19];
            case 22:
              c = 0, p = t.zeroOrAutoZIndexOrTransformedOrOpacity, B.label = 23;
            case 23:
              return c < p.length ? (w = p[c], [4, this.renderStack(w)]) : [3, 26];
            case 24:
              B.sent(), B.label = 25;
            case 25:
              return c++, [3, 23];
            case 26:
              g = 0, v = t.positiveZIndex, B.label = 27;
            case 27:
              return g < v.length ? (w = v[g], [4, this.renderStack(w)]) : [3, 30];
            case 28:
              B.sent(), B.label = 29;
            case 29:
              return g++, [3, 27];
            case 30:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.mask = function(t) {
      this.ctx.beginPath(), this.ctx.moveTo(0, 0), this.ctx.lineTo(this.canvas.width, 0), this.ctx.lineTo(this.canvas.width, this.canvas.height), this.ctx.lineTo(0, this.canvas.height), this.ctx.lineTo(0, 0), this.formatPath(t.slice(0).reverse()), this.ctx.closePath();
    }, e.prototype.path = function(t) {
      this.ctx.beginPath(), this.formatPath(t), this.ctx.closePath();
    }, e.prototype.formatPath = function(t) {
      var A = this;
      t.forEach(function(n, i) {
        var s = Nn(n) ? n.start : n;
        i === 0 ? A.ctx.moveTo(s.x, s.y) : A.ctx.lineTo(s.x, s.y), Nn(n) && A.ctx.bezierCurveTo(n.startControl.x, n.startControl.y, n.endControl.x, n.endControl.y, n.end.x, n.end.y);
      });
    }, e.prototype.renderRepeat = function(t, A, n, i) {
      this.path(t), this.ctx.fillStyle = A, this.ctx.translate(n, i), this.ctx.fill(), this.ctx.translate(-n, -i);
    }, e.prototype.resizeImage = function(t, A, n) {
      var i;
      if (t.width === A && t.height === n)
        return t;
      var s = (i = this.canvas.ownerDocument) !== null && i !== void 0 ? i : document, a = s.createElement("canvas");
      a.width = Math.max(1, A), a.height = Math.max(1, n);
      var o = a.getContext("2d");
      return o.drawImage(t, 0, 0, t.width, t.height, 0, 0, A, n), a;
    }, e.prototype.renderBackgroundImage = function(t) {
      return jA(this, void 0, void 0, function() {
        var A, n, i, s, a, o;
        return TA(this, function(l) {
          switch (l.label) {
            case 0:
              A = t.styles.backgroundImage.length - 1, n = function(u) {
                var h, f, c, V, ie, te, D, R, O, p, V, ie, te, D, R, g, v, w, B, S, C, E, _, I, O, U, V, F, P, D, R, J, ie, te, $, re, ue, se, T, G, X, Y;
                return TA(this, function(ee) {
                  switch (ee.label) {
                    case 0:
                      if (u.type !== 0) return [3, 5];
                      h = void 0, f = u.url, ee.label = 1;
                    case 1:
                      return ee.trys.push([1, 3, , 4]), [4, i.context.cache.match(f)];
                    case 2:
                      return h = ee.sent(), [3, 4];
                    case 3:
                      return ee.sent(), i.context.logger.error("Error loading background-image " + f), [3, 4];
                    case 4:
                      return h && (c = zd(t, A, [
                        h.width,
                        h.height,
                        h.width / h.height
                      ]), V = c[0], ie = c[1], te = c[2], D = c[3], R = c[4], O = i.ctx.createPattern(i.resizeImage(h, D, R), "repeat"), i.renderRepeat(V, O, ie, te)), [3, 6];
                    case 5:
                      vP(u) ? (p = zd(t, A, [null, null, null]), V = p[0], ie = p[1], te = p[2], D = p[3], R = p[4], g = fP(u.angle, D, R), v = g[0], w = g[1], B = g[2], S = g[3], C = g[4], E = document.createElement("canvas"), E.width = D, E.height = R, _ = E.getContext("2d"), I = _.createLinearGradient(w, S, B, C), Hy(u.stops, v).forEach(function(oe) {
                        return I.addColorStop(oe.stop, gA(oe.color));
                      }), _.fillStyle = I, _.fillRect(0, 0, D, R), D > 0 && R > 0 && (O = i.ctx.createPattern(E, "repeat"), i.renderRepeat(V, O, ie, te))) : wP(u) && (U = zd(t, A, [
                        null,
                        null,
                        null
                      ]), V = U[0], F = U[1], P = U[2], D = U[3], R = U[4], J = u.position.length === 0 ? [dv] : u.position, ie = dr(J[0], D), te = dr(J[J.length - 1], R), $ = dP(u, ie, te, D, R), re = $[0], ue = $[1], re > 0 && ue > 0 && (se = i.ctx.createRadialGradient(F + ie, P + te, 0, F + ie, P + te, re), Hy(u.stops, re * 2).forEach(function(oe) {
                        return se.addColorStop(oe.stop, gA(oe.color));
                      }), i.path(V), i.ctx.fillStyle = se, re !== ue ? (T = t.bounds.left + 0.5 * t.bounds.width, G = t.bounds.top + 0.5 * t.bounds.height, X = ue / re, Y = 1 / X, i.ctx.save(), i.ctx.translate(T, G), i.ctx.transform(1, 0, 0, X, 0, 0), i.ctx.translate(-T, -G), i.ctx.fillRect(F, Y * (P - G) + G, D, R * Y), i.ctx.restore()) : i.ctx.fill())), ee.label = 6;
                    case 6:
                      return A--, [
                        2
                        /*return*/
                      ];
                  }
                });
              }, i = this, s = 0, a = t.styles.backgroundImage.slice(0).reverse(), l.label = 1;
            case 1:
              return s < a.length ? (o = a[s], [5, n(o)]) : [3, 4];
            case 2:
              l.sent(), l.label = 3;
            case 3:
              return s++, [3, 1];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.renderSolidBorder = function(t, A, n) {
      return jA(this, void 0, void 0, function() {
        return TA(this, function(i) {
          return this.path(m2(n, A)), this.ctx.fillStyle = gA(t), this.ctx.fill(), [
            2
            /*return*/
          ];
        });
      });
    }, e.prototype.renderDoubleBorder = function(t, A, n, i) {
      return jA(this, void 0, void 0, function() {
        var s, a;
        return TA(this, function(o) {
          switch (o.label) {
            case 0:
              return A < 3 ? [4, this.renderSolidBorder(t, n, i)] : [3, 2];
            case 1:
              return o.sent(), [
                2
                /*return*/
              ];
            case 2:
              return s = bR(i, n), this.path(s), this.ctx.fillStyle = gA(t), this.ctx.fill(), a = CR(i, n), this.path(a), this.ctx.fill(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.renderNodeBackgroundAndBorders = function(t) {
      return jA(this, void 0, void 0, function() {
        var A, n, i, s, a, o, l, u, h = this;
        return TA(this, function(f) {
          switch (f.label) {
            case 0:
              return this.applyEffects(t.getEffects(
                2
                /* BACKGROUND_BORDERS */
              )), A = t.container.styles, n = !Rs(A.backgroundColor) || A.backgroundImage.length, i = [
                { style: A.borderTopStyle, color: A.borderTopColor, width: A.borderTopWidth },
                { style: A.borderRightStyle, color: A.borderRightColor, width: A.borderRightWidth },
                { style: A.borderBottomStyle, color: A.borderBottomColor, width: A.borderBottomWidth },
                { style: A.borderLeftStyle, color: A.borderLeftColor, width: A.borderLeftWidth }
              ], s = TR(po(A.backgroundClip, 0), t.curves), n || A.boxShadow.length ? (this.ctx.save(), this.path(s), this.ctx.clip(), Rs(A.backgroundColor) || (this.ctx.fillStyle = gA(A.backgroundColor), this.ctx.fill()), [4, this.renderBackgroundImage(t.container)]) : [3, 2];
            case 1:
              f.sent(), this.ctx.restore(), A.boxShadow.slice(0).reverse().forEach(function(c) {
                h.ctx.save();
                var p = Eh(t.curves), g = c.inset ? 0 : QR, v = yR(p, -g + (c.inset ? 1 : -1) * c.spread.number, (c.inset ? 1 : -1) * c.spread.number, c.spread.number * (c.inset ? -2 : 2), c.spread.number * (c.inset ? -2 : 2));
                c.inset ? (h.path(p), h.ctx.clip(), h.mask(v)) : (h.mask(p), h.ctx.clip(), h.path(v)), h.ctx.shadowOffsetX = c.offsetX.number + g, h.ctx.shadowOffsetY = c.offsetY.number, h.ctx.shadowColor = gA(c.color), h.ctx.shadowBlur = c.blur.number, h.ctx.fillStyle = c.inset ? gA(c.color) : "rgba(0,0,0,1)", h.ctx.fill(), h.ctx.restore();
              }), f.label = 2;
            case 2:
              a = 0, o = 0, l = i, f.label = 3;
            case 3:
              return o < l.length ? (u = l[o], u.style !== 0 && !Rs(u.color) && u.width > 0 ? u.style !== 2 ? [3, 5] : [4, this.renderDashedDottedBorder(
                u.color,
                u.width,
                a,
                t.curves,
                2
                /* DASHED */
              )] : [3, 11]) : [3, 13];
            case 4:
              return f.sent(), [3, 11];
            case 5:
              return u.style !== 3 ? [3, 7] : [4, this.renderDashedDottedBorder(
                u.color,
                u.width,
                a,
                t.curves,
                3
                /* DOTTED */
              )];
            case 6:
              return f.sent(), [3, 11];
            case 7:
              return u.style !== 4 ? [3, 9] : [4, this.renderDoubleBorder(u.color, u.width, a, t.curves)];
            case 8:
              return f.sent(), [3, 11];
            case 9:
              return [4, this.renderSolidBorder(u.color, a, t.curves)];
            case 10:
              f.sent(), f.label = 11;
            case 11:
              a++, f.label = 12;
            case 12:
              return o++, [3, 3];
            case 13:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.renderDashedDottedBorder = function(t, A, n, i, s) {
      return jA(this, void 0, void 0, function() {
        var a, o, l, u, h, f, c, p, g, v, w, B, S, C, E, _, E, _;
        return TA(this, function(I) {
          return this.ctx.save(), a = SR(i, n), o = m2(i, n), s === 2 && (this.path(o), this.ctx.clip()), Nn(o[0]) ? (l = o[0].start.x, u = o[0].start.y) : (l = o[0].x, u = o[0].y), Nn(o[1]) ? (h = o[1].end.x, f = o[1].end.y) : (h = o[1].x, f = o[1].y), n === 0 || n === 2 ? c = Math.abs(l - h) : c = Math.abs(u - f), this.ctx.beginPath(), s === 3 ? this.formatPath(a) : this.formatPath(o.slice(0, 2)), p = A < 3 ? A * 3 : A * 2, g = A < 3 ? A * 2 : A, s === 3 && (p = A, g = A), v = !0, c <= p * 2 ? v = !1 : c <= p * 2 + g ? (w = c / (2 * p + g), p *= w, g *= w) : (B = Math.floor((c + g) / (p + g)), S = (c - B * p) / (B - 1), C = (c - (B + 1) * p) / B, g = C <= 0 || Math.abs(g - S) < Math.abs(g - C) ? S : C), v && (s === 3 ? this.ctx.setLineDash([0, p + g]) : this.ctx.setLineDash([p, g])), s === 3 ? (this.ctx.lineCap = "round", this.ctx.lineWidth = A) : this.ctx.lineWidth = A * 2 + 1.1, this.ctx.strokeStyle = gA(t), this.ctx.stroke(), this.ctx.setLineDash([]), s === 2 && (Nn(o[0]) && (E = o[3], _ = o[0], this.ctx.beginPath(), this.formatPath([new qe(E.end.x, E.end.y), new qe(_.start.x, _.start.y)]), this.ctx.stroke()), Nn(o[1]) && (E = o[1], _ = o[2], this.ctx.beginPath(), this.formatPath([new qe(E.end.x, E.end.y), new qe(_.start.x, _.start.y)]), this.ctx.stroke())), this.ctx.restore(), [
            2
            /*return*/
          ];
        });
      });
    }, e.prototype.render = function(t) {
      return jA(this, void 0, void 0, function() {
        var A;
        return TA(this, function(n) {
          switch (n.label) {
            case 0:
              return this.options.backgroundColor && (this.ctx.fillStyle = gA(this.options.backgroundColor), this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height)), A = BR(t), [4, this.renderStack(A)];
            case 1:
              return n.sent(), this.applyEffects([]), [2, this.canvas];
          }
        });
      });
    }, e;
  })(hE)
), NR = function(r) {
  return r instanceof Xx || r instanceof Wx ? !0 : r instanceof vv && r.type !== Ch && r.type !== bh;
}, TR = function(r, e) {
  switch (r) {
    case 0:
      return Eh(e);
    case 2:
      return gR(e);
    case 1:
    default:
      return Fh(e);
  }
}, PR = function(r) {
  switch (r) {
    case 1:
      return "center";
    case 2:
      return "right";
    case 0:
    default:
      return "left";
  }
}, OR = ["-apple-system", "system-ui"], MR = function(r) {
  return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? r.filter(function(e) {
    return OR.indexOf(e) === -1;
  }) : r;
}, RR = (
  /** @class */
  (function(r) {
    ii(e, r);
    function e(t, A) {
      var n = r.call(this, t, A) || this;
      return n.canvas = A.canvas ? A.canvas : document.createElement("canvas"), n.ctx = n.canvas.getContext("2d"), n.options = A, n.canvas.width = Math.floor(A.width * A.scale), n.canvas.height = Math.floor(A.height * A.scale), n.canvas.style.width = A.width + "px", n.canvas.style.height = A.height + "px", n.ctx.scale(n.options.scale, n.options.scale), n.ctx.translate(-A.x, -A.y), n.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + A.width + "x" + A.height + " at " + A.x + "," + A.y + ") with scale " + A.scale), n;
    }
    return e.prototype.render = function(t) {
      return jA(this, void 0, void 0, function() {
        var A, n;
        return TA(this, function(i) {
          switch (i.label) {
            case 0:
              return A = Bm(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, t), [4, kR(A)];
            case 1:
              return n = i.sent(), this.options.backgroundColor && (this.ctx.fillStyle = gA(this.options.backgroundColor), this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale)), this.ctx.drawImage(n, -this.options.x * this.options.scale, -this.options.y * this.options.scale), [2, this.canvas];
          }
        });
      });
    }, e;
  })(hE)
), kR = function(r) {
  return new Promise(function(e, t) {
    var A = new Image();
    A.onload = function() {
      e(A);
    }, A.onerror = t, A.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(r));
  });
}, HR = (
  /** @class */
  (function() {
    function r(e) {
      var t = e.id, A = e.enabled;
      this.id = t, this.enabled = A, this.start = Date.now();
    }
    return r.prototype.debug = function() {
      for (var e = [], t = 0; t < arguments.length; t++)
        e[t] = arguments[t];
      this.enabled && (typeof window < "u" && window.console && typeof console.debug == "function" ? console.debug.apply(console, wc([this.id, this.getTime() + "ms"], e)) : this.info.apply(this, e));
    }, r.prototype.getTime = function() {
      return Date.now() - this.start;
    }, r.prototype.info = function() {
      for (var e = [], t = 0; t < arguments.length; t++)
        e[t] = arguments[t];
      this.enabled && typeof window < "u" && window.console && typeof console.info == "function" && console.info.apply(console, wc([this.id, this.getTime() + "ms"], e));
    }, r.prototype.warn = function() {
      for (var e = [], t = 0; t < arguments.length; t++)
        e[t] = arguments[t];
      this.enabled && (typeof window < "u" && window.console && typeof console.warn == "function" ? console.warn.apply(console, wc([this.id, this.getTime() + "ms"], e)) : this.info.apply(this, e));
    }, r.prototype.error = function() {
      for (var e = [], t = 0; t < arguments.length; t++)
        e[t] = arguments[t];
      this.enabled && (typeof window < "u" && window.console && typeof console.error == "function" ? console.error.apply(console, wc([this.id, this.getTime() + "ms"], e)) : this.info.apply(this, e));
    }, r.instances = {}, r;
  })()
), DR = (
  /** @class */
  (function() {
    function r(e, t) {
      var A;
      this.windowBounds = t, this.instanceName = "#" + r.instanceCount++, this.logger = new HR({ id: this.instanceName, enabled: e.logging }), this.cache = (A = e.cache) !== null && A !== void 0 ? A : new aR(this, e);
    }
    return r.instanceCount = 1, r;
  })()
), GR = function(r, e) {
  return e === void 0 && (e = {}), VR(r, e);
};
typeof window < "u" && sE.setContext(window);
var VR = function(r, e) {
  return jA(void 0, void 0, void 0, function() {
    var t, A, n, i, s, a, o, l, u, h, f, c, p, g, v, w, B, S, C, E, I, _, I, O, U, V, F, P, D, R, J, ie, te, $, re, ue, se, T, G, X;
    return TA(this, function(Y) {
      switch (Y.label) {
        case 0:
          if (!r || typeof r != "object")
            return [2, Promise.reject("Invalid element provided as first argument")];
          if (t = r.ownerDocument, !t)
            throw new Error("Element is not attached to a Document");
          if (A = t.defaultView, !A)
            throw new Error("Document is not attached to a Window");
          return n = {
            allowTaint: (O = e.allowTaint) !== null && O !== void 0 ? O : !1,
            imageTimeout: (U = e.imageTimeout) !== null && U !== void 0 ? U : 15e3,
            proxy: e.proxy,
            useCORS: (V = e.useCORS) !== null && V !== void 0 ? V : !1
          }, i = sm({ logging: (F = e.logging) !== null && F !== void 0 ? F : !0, cache: e.cache }, n), s = {
            windowWidth: (P = e.windowWidth) !== null && P !== void 0 ? P : A.innerWidth,
            windowHeight: (D = e.windowHeight) !== null && D !== void 0 ? D : A.innerHeight,
            scrollX: (R = e.scrollX) !== null && R !== void 0 ? R : A.pageXOffset,
            scrollY: (J = e.scrollY) !== null && J !== void 0 ? J : A.pageYOffset
          }, a = new As(s.scrollX, s.scrollY, s.windowWidth, s.windowHeight), o = new DR(i, a), l = (ie = e.foreignObjectRendering) !== null && ie !== void 0 ? ie : !1, u = {
            allowTaint: (te = e.allowTaint) !== null && te !== void 0 ? te : !1,
            onclone: e.onclone,
            ignoreElements: e.ignoreElements,
            inlineImages: l,
            copyStyles: l
          }, o.logger.debug("Starting document clone with size " + a.width + "x" + a.height + " scrolled to " + -a.left + "," + -a.top), h = new d2(o, r, u), f = h.clonedReferenceElement, f ? [4, h.toIFrame(t, a)] : [2, Promise.reject("Unable to find element in cloned iframe")];
        case 1:
          return c = Y.sent(), p = wv(f) || KM(f) ? yN(f.ownerDocument) : Rh(o, f), g = p.width, v = p.height, w = p.left, B = p.top, S = KR(o, f, e.backgroundColor), C = {
            canvas: e.canvas,
            backgroundColor: S,
            scale: (re = ($ = e.scale) !== null && $ !== void 0 ? $ : A.devicePixelRatio) !== null && re !== void 0 ? re : 1,
            x: ((ue = e.x) !== null && ue !== void 0 ? ue : 0) + w,
            y: ((se = e.y) !== null && se !== void 0 ? se : 0) + B,
            width: (T = e.width) !== null && T !== void 0 ? T : Math.ceil(g),
            height: (G = e.height) !== null && G !== void 0 ? G : Math.ceil(v)
          }, l ? (o.logger.debug("Document cloned, using foreign object rendering"), I = new RR(o, C), [4, I.render(f)]) : [3, 3];
        case 2:
          return E = Y.sent(), [3, 5];
        case 3:
          return o.logger.debug("Document cloned, element located at " + w + "," + B + " with size " + g + "x" + v + " using computed rendering"), o.logger.debug("Starting DOM parsing"), _ = $x(o, f), S === _.styles.backgroundColor && (_.styles.backgroundColor = Zi.TRANSPARENT), o.logger.debug("Starting renderer for element at " + C.x + "," + C.y + " with size " + C.width + "x" + C.height), I = new LR(o, C), [4, I.render(_)];
        case 4:
          E = Y.sent(), Y.label = 5;
        case 5:
          return (!((X = e.removeContainer) !== null && X !== void 0) || X) && (d2.destroy(c) || o.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore")), o.logger.debug("Finished rendering"), [2, E];
      }
    });
  });
}, KR = function(r, e, t) {
  var A = e.ownerDocument, n = A.documentElement ? Vl(r, getComputedStyle(A.documentElement).backgroundColor) : Zi.TRANSPARENT, i = A.body ? Vl(r, getComputedStyle(A.body).backgroundColor) : Zi.TRANSPARENT, s = typeof t == "string" ? Vl(r, t) : t === null ? Zi.TRANSPARENT : 4294967295;
  return e === A.documentElement ? Rs(n) ? Rs(i) ? s : i : n : s;
};
const jR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: GR
}, Symbol.toStringTag, { value: "Module" }));
const {
  entries: fE,
  setPrototypeOf: w2,
  isFrozen: qR,
  getPrototypeOf: zR,
  getOwnPropertyDescriptor: WR
} = Object;
let {
  freeze: qA,
  seal: Hn,
  create: dE
} = Object, {
  apply: _m,
  construct: Um
} = typeof Reflect < "u" && Reflect;
qA || (qA = function(e) {
  return e;
});
Hn || (Hn = function(e) {
  return e;
});
_m || (_m = function(e, t, A) {
  return e.apply(t, A);
});
Um || (Um = function(e, t) {
  return new e(...t);
});
const Gc = zA(Array.prototype.forEach), XR = zA(Array.prototype.lastIndexOf), y2 = zA(Array.prototype.pop), pl = zA(Array.prototype.push), YR = zA(Array.prototype.splice), oh = zA(String.prototype.toLowerCase), Wd = zA(String.prototype.toString), B2 = zA(String.prototype.match), ml = zA(String.prototype.replace), JR = zA(String.prototype.indexOf), $R = zA(String.prototype.trim), ei = zA(Object.prototype.hasOwnProperty), KA = zA(RegExp.prototype.test), vl = ZR(TypeError);
function zA(r) {
  return function(e) {
    for (var t = arguments.length, A = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
      A[n - 1] = arguments[n];
    return _m(r, e, A);
  };
}
function ZR(r) {
  return function() {
    for (var e = arguments.length, t = new Array(e), A = 0; A < e; A++)
      t[A] = arguments[A];
    return Um(r, t);
  };
}
function Pt(r, e) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : oh;
  w2 && w2(r, null);
  let A = e.length;
  for (; A--; ) {
    let n = e[A];
    if (typeof n == "string") {
      const i = t(n);
      i !== n && (qR(e) || (e[A] = i), n = i);
    }
    r[n] = !0;
  }
  return r;
}
function ek(r) {
  for (let e = 0; e < r.length; e++)
    ei(r, e) || (r[e] = null);
  return r;
}
function pa(r) {
  const e = dE(null);
  for (const [t, A] of fE(r))
    ei(r, t) && (Array.isArray(A) ? e[t] = ek(A) : A && typeof A == "object" && A.constructor === Object ? e[t] = pa(A) : e[t] = A);
  return e;
}
function wl(r, e) {
  for (; r !== null; ) {
    const A = WR(r, e);
    if (A) {
      if (A.get)
        return zA(A.get);
      if (typeof A.value == "function")
        return zA(A.value);
    }
    r = zR(r);
  }
  function t() {
    return null;
  }
  return t;
}
const b2 = qA(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Xd = qA(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), Yd = qA(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), tk = qA(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Jd = qA(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), rk = qA(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), C2 = qA(["#text"]), S2 = qA(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), $d = qA(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), x2 = qA(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), Vc = qA(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), Ak = Hn(/\{\{[\w\W]*|[\w\W]*\}\}/gm), nk = Hn(/<%[\w\W]*|[\w\W]*%>/gm), ik = Hn(/\$\{[\w\W]*/gm), sk = Hn(/^data-[\-\w.\u00B7-\uFFFF]+$/), ak = Hn(/^aria-[\-\w]+$/), gE = Hn(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), ok = Hn(/^(?:\w+script|data):/i), lk = Hn(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), pE = Hn(/^html$/i), uk = Hn(/^[a-z][.\w]*(-[.\w]+)+$/i);
var E2 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: ak,
  ATTR_WHITESPACE: lk,
  CUSTOM_ELEMENT: uk,
  DATA_ATTR: sk,
  DOCTYPE_NAME: pE,
  ERB_EXPR: nk,
  IS_ALLOWED_URI: gE,
  IS_SCRIPT_OR_DATA: ok,
  MUSTACHE_EXPR: Ak,
  TMPLIT_EXPR: ik
});
const yl = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, ck = function() {
  return typeof window > "u" ? null : window;
}, hk = function(e, t) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let A = null;
  const n = "data-tt-policy-suffix";
  t && t.hasAttribute(n) && (A = t.getAttribute(n));
  const i = "dompurify" + (A ? "#" + A : "");
  try {
    return e.createPolicy(i, {
      createHTML(s) {
        return s;
      },
      createScriptURL(s) {
        return s;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + i + " could not be created."), null;
  }
}, F2 = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function mE() {
  let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ck();
  const e = ($e) => mE($e);
  if (e.version = "3.2.4", e.removed = [], !r || !r.document || r.document.nodeType !== yl.document || !r.Element)
    return e.isSupported = !1, e;
  let {
    document: t
  } = r;
  const A = t, n = A.currentScript, {
    DocumentFragment: i,
    HTMLTemplateElement: s,
    Node: a,
    Element: o,
    NodeFilter: l,
    NamedNodeMap: u = r.NamedNodeMap || r.MozNamedAttrMap,
    HTMLFormElement: h,
    DOMParser: f,
    trustedTypes: c
  } = r, p = o.prototype, g = wl(p, "cloneNode"), v = wl(p, "remove"), w = wl(p, "nextSibling"), B = wl(p, "childNodes"), S = wl(p, "parentNode");
  if (typeof s == "function") {
    const $e = t.createElement("template");
    $e.content && $e.content.ownerDocument && (t = $e.content.ownerDocument);
  }
  let C, E = "";
  const {
    implementation: _,
    createNodeIterator: I,
    createDocumentFragment: O,
    getElementsByTagName: U
  } = t, {
    importNode: V
  } = A;
  let F = F2();
  e.isSupported = typeof fE == "function" && typeof S == "function" && _ && _.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: P,
    ERB_EXPR: D,
    TMPLIT_EXPR: R,
    DATA_ATTR: J,
    ARIA_ATTR: ie,
    IS_SCRIPT_OR_DATA: te,
    ATTR_WHITESPACE: $,
    CUSTOM_ELEMENT: re
  } = E2;
  let {
    IS_ALLOWED_URI: ue
  } = E2, se = null;
  const T = Pt({}, [...b2, ...Xd, ...Yd, ...Jd, ...C2]);
  let G = null;
  const X = Pt({}, [...S2, ...$d, ...x2, ...Vc]);
  let Y = Object.seal(dE(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), ee = null, oe = null, ge = !0, pe = !0, me = !1, Ee = !0, Ne = !1, Te = !0, Ge = !1, j = !1, Pe = !1, ft = !1, et = !1, xe = !1, rt = !0, ke = !1;
  const We = "user-content-";
  let ze = !0, Ce = !1, Oe = {}, Re = null;
  const Ke = Pt({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let Xe = null;
  const Ve = Pt({}, ["audio", "video", "img", "source", "image", "track"]);
  let dt = null;
  const je = Pt({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), Tt = "http://www.w3.org/1998/Math/MathML", Et = "http://www.w3.org/2000/svg", mt = "http://www.w3.org/1999/xhtml";
  let yt = mt, Gt = !1, it = null;
  const Vt = Pt({}, [Tt, Et, mt], Wd);
  let lt = Pt({}, ["mi", "mo", "mn", "ms", "mtext"]), wt = Pt({}, ["annotation-xml"]);
  const Yt = Pt({}, ["title", "style", "font", "a", "script"]);
  let ut = null;
  const Bt = ["application/xhtml+xml", "text/html"], Kt = "text/html";
  let cr = null, Sr = null;
  const Gn = t.createElement("form"), an = function(ne) {
    return ne instanceof RegExp || ne instanceof Function;
  }, vt = function() {
    let ne = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(Sr && Sr === ne)) {
      if ((!ne || typeof ne != "object") && (ne = {}), ne = pa(ne), ut = // eslint-disable-next-line unicorn/prefer-includes
      Bt.indexOf(ne.PARSER_MEDIA_TYPE) === -1 ? Kt : ne.PARSER_MEDIA_TYPE, cr = ut === "application/xhtml+xml" ? Wd : oh, se = ei(ne, "ALLOWED_TAGS") ? Pt({}, ne.ALLOWED_TAGS, cr) : T, G = ei(ne, "ALLOWED_ATTR") ? Pt({}, ne.ALLOWED_ATTR, cr) : X, it = ei(ne, "ALLOWED_NAMESPACES") ? Pt({}, ne.ALLOWED_NAMESPACES, Wd) : Vt, dt = ei(ne, "ADD_URI_SAFE_ATTR") ? Pt(pa(je), ne.ADD_URI_SAFE_ATTR, cr) : je, Xe = ei(ne, "ADD_DATA_URI_TAGS") ? Pt(pa(Ve), ne.ADD_DATA_URI_TAGS, cr) : Ve, Re = ei(ne, "FORBID_CONTENTS") ? Pt({}, ne.FORBID_CONTENTS, cr) : Ke, ee = ei(ne, "FORBID_TAGS") ? Pt({}, ne.FORBID_TAGS, cr) : {}, oe = ei(ne, "FORBID_ATTR") ? Pt({}, ne.FORBID_ATTR, cr) : {}, Oe = ei(ne, "USE_PROFILES") ? ne.USE_PROFILES : !1, ge = ne.ALLOW_ARIA_ATTR !== !1, pe = ne.ALLOW_DATA_ATTR !== !1, me = ne.ALLOW_UNKNOWN_PROTOCOLS || !1, Ee = ne.ALLOW_SELF_CLOSE_IN_ATTR !== !1, Ne = ne.SAFE_FOR_TEMPLATES || !1, Te = ne.SAFE_FOR_XML !== !1, Ge = ne.WHOLE_DOCUMENT || !1, ft = ne.RETURN_DOM || !1, et = ne.RETURN_DOM_FRAGMENT || !1, xe = ne.RETURN_TRUSTED_TYPE || !1, Pe = ne.FORCE_BODY || !1, rt = ne.SANITIZE_DOM !== !1, ke = ne.SANITIZE_NAMED_PROPS || !1, ze = ne.KEEP_CONTENT !== !1, Ce = ne.IN_PLACE || !1, ue = ne.ALLOWED_URI_REGEXP || gE, yt = ne.NAMESPACE || mt, lt = ne.MATHML_TEXT_INTEGRATION_POINTS || lt, wt = ne.HTML_INTEGRATION_POINTS || wt, Y = ne.CUSTOM_ELEMENT_HANDLING || {}, ne.CUSTOM_ELEMENT_HANDLING && an(ne.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (Y.tagNameCheck = ne.CUSTOM_ELEMENT_HANDLING.tagNameCheck), ne.CUSTOM_ELEMENT_HANDLING && an(ne.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (Y.attributeNameCheck = ne.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), ne.CUSTOM_ELEMENT_HANDLING && typeof ne.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (Y.allowCustomizedBuiltInElements = ne.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), Ne && (pe = !1), et && (ft = !0), Oe && (se = Pt({}, C2), G = [], Oe.html === !0 && (Pt(se, b2), Pt(G, S2)), Oe.svg === !0 && (Pt(se, Xd), Pt(G, $d), Pt(G, Vc)), Oe.svgFilters === !0 && (Pt(se, Yd), Pt(G, $d), Pt(G, Vc)), Oe.mathMl === !0 && (Pt(se, Jd), Pt(G, x2), Pt(G, Vc))), ne.ADD_TAGS && (se === T && (se = pa(se)), Pt(se, ne.ADD_TAGS, cr)), ne.ADD_ATTR && (G === X && (G = pa(G)), Pt(G, ne.ADD_ATTR, cr)), ne.ADD_URI_SAFE_ATTR && Pt(dt, ne.ADD_URI_SAFE_ATTR, cr), ne.FORBID_CONTENTS && (Re === Ke && (Re = pa(Re)), Pt(Re, ne.FORBID_CONTENTS, cr)), ze && (se["#text"] = !0), Ge && Pt(se, ["html", "head", "body"]), se.table && (Pt(se, ["tbody"]), delete ee.tbody), ne.TRUSTED_TYPES_POLICY) {
        if (typeof ne.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw vl('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof ne.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw vl('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        C = ne.TRUSTED_TYPES_POLICY, E = C.createHTML("");
      } else
        C === void 0 && (C = hk(c, n)), C !== null && typeof E == "string" && (E = C.createHTML(""));
      qA && qA(ne), Sr = ne;
    }
  }, Sn = Pt({}, [...Xd, ...Yd, ...tk]), xn = Pt({}, [...Jd, ...rk]), YA = function(ne) {
    let Qe = S(ne);
    (!Qe || !Qe.tagName) && (Qe = {
      namespaceURI: yt,
      tagName: "template"
    });
    const Je = oh(ne.tagName), Wt = oh(Qe.tagName);
    return it[ne.namespaceURI] ? ne.namespaceURI === Et ? Qe.namespaceURI === mt ? Je === "svg" : Qe.namespaceURI === Tt ? Je === "svg" && (Wt === "annotation-xml" || lt[Wt]) : !!Sn[Je] : ne.namespaceURI === Tt ? Qe.namespaceURI === mt ? Je === "math" : Qe.namespaceURI === Et ? Je === "math" && wt[Wt] : !!xn[Je] : ne.namespaceURI === mt ? Qe.namespaceURI === Et && !wt[Wt] || Qe.namespaceURI === Tt && !lt[Wt] ? !1 : !xn[Je] && (Yt[Je] || !Sn[Je]) : !!(ut === "application/xhtml+xml" && it[ne.namespaceURI]) : !1;
  }, xr = function(ne) {
    pl(e.removed, {
      element: ne
    });
    try {
      S(ne).removeChild(ne);
    } catch {
      v(ne);
    }
  }, ir = function(ne, Qe) {
    try {
      pl(e.removed, {
        attribute: Qe.getAttributeNode(ne),
        from: Qe
      });
    } catch {
      pl(e.removed, {
        attribute: null,
        from: Qe
      });
    }
    if (Qe.removeAttribute(ne), ne === "is")
      if (ft || et)
        try {
          xr(Qe);
        } catch {
        }
      else
        try {
          Qe.setAttribute(ne, "");
        } catch {
        }
  }, Or = function(ne) {
    let Qe = null, Je = null;
    if (Pe)
      ne = "<remove></remove>" + ne;
    else {
      const Er = B2(ne, /^[\r\n\t ]+/);
      Je = Er && Er[0];
    }
    ut === "application/xhtml+xml" && yt === mt && (ne = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + ne + "</body></html>");
    const Wt = C ? C.createHTML(ne) : ne;
    if (yt === mt)
      try {
        Qe = new f().parseFromString(Wt, ut);
      } catch {
      }
    if (!Qe || !Qe.documentElement) {
      Qe = _.createDocument(yt, "template", null);
      try {
        Qe.documentElement.innerHTML = Gt ? E : Wt;
      } catch {
      }
    }
    const Yr = Qe.body || Qe.documentElement;
    return ne && Je && Yr.insertBefore(t.createTextNode(Je), Yr.childNodes[0] || null), yt === mt ? U.call(Qe, Ge ? "html" : "body")[0] : Ge ? Qe.documentElement : Yr;
  }, Xr = function(ne) {
    return I.call(
      ne.ownerDocument || ne,
      ne,
      // eslint-disable-next-line no-bitwise
      l.SHOW_ELEMENT | l.SHOW_COMMENT | l.SHOW_TEXT | l.SHOW_PROCESSING_INSTRUCTION | l.SHOW_CDATA_SECTION,
      null
    );
  }, Vn = function(ne) {
    return ne instanceof h && (typeof ne.nodeName != "string" || typeof ne.textContent != "string" || typeof ne.removeChild != "function" || !(ne.attributes instanceof u) || typeof ne.removeAttribute != "function" || typeof ne.setAttribute != "function" || typeof ne.namespaceURI != "string" || typeof ne.insertBefore != "function" || typeof ne.hasChildNodes != "function");
  }, Kn = function(ne) {
    return typeof a == "function" && ne instanceof a;
  };
  function Mr($e, ne, Qe) {
    Gc($e, (Je) => {
      Je.call(e, ne, Qe, Sr);
    });
  }
  const on = function(ne) {
    let Qe = null;
    if (Mr(F.beforeSanitizeElements, ne, null), Vn(ne))
      return xr(ne), !0;
    const Je = cr(ne.nodeName);
    if (Mr(F.uponSanitizeElement, ne, {
      tagName: Je,
      allowedTags: se
    }), ne.hasChildNodes() && !Kn(ne.firstElementChild) && KA(/<[/\w]/g, ne.innerHTML) && KA(/<[/\w]/g, ne.textContent) || ne.nodeType === yl.progressingInstruction || Te && ne.nodeType === yl.comment && KA(/<[/\w]/g, ne.data))
      return xr(ne), !0;
    if (!se[Je] || ee[Je]) {
      if (!ee[Je] && $A(Je) && (Y.tagNameCheck instanceof RegExp && KA(Y.tagNameCheck, Je) || Y.tagNameCheck instanceof Function && Y.tagNameCheck(Je)))
        return !1;
      if (ze && !Re[Je]) {
        const Wt = S(ne) || ne.parentNode, Yr = B(ne) || ne.childNodes;
        if (Yr && Wt) {
          const Er = Yr.length;
          for (let iA = Er - 1; iA >= 0; --iA) {
            const kA = g(Yr[iA], !0);
            kA.__removalCount = (ne.__removalCount || 0) + 1, Wt.insertBefore(kA, w(ne));
          }
        }
      }
      return xr(ne), !0;
    }
    return ne instanceof o && !YA(ne) || (Je === "noscript" || Je === "noembed" || Je === "noframes") && KA(/<\/no(script|embed|frames)/i, ne.innerHTML) ? (xr(ne), !0) : (Ne && ne.nodeType === yl.text && (Qe = ne.textContent, Gc([P, D, R], (Wt) => {
      Qe = ml(Qe, Wt, " ");
    }), ne.textContent !== Qe && (pl(e.removed, {
      element: ne.cloneNode()
    }), ne.textContent = Qe)), Mr(F.afterSanitizeElements, ne, null), !1);
  }, JA = function(ne, Qe, Je) {
    if (rt && (Qe === "id" || Qe === "name") && (Je in t || Je in Gn))
      return !1;
    if (!(pe && !oe[Qe] && KA(J, Qe))) {
      if (!(ge && KA(ie, Qe))) {
        if (!G[Qe] || oe[Qe]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !($A(ne) && (Y.tagNameCheck instanceof RegExp && KA(Y.tagNameCheck, ne) || Y.tagNameCheck instanceof Function && Y.tagNameCheck(ne)) && (Y.attributeNameCheck instanceof RegExp && KA(Y.attributeNameCheck, Qe) || Y.attributeNameCheck instanceof Function && Y.attributeNameCheck(Qe)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            Qe === "is" && Y.allowCustomizedBuiltInElements && (Y.tagNameCheck instanceof RegExp && KA(Y.tagNameCheck, Je) || Y.tagNameCheck instanceof Function && Y.tagNameCheck(Je)))
          ) return !1;
        } else if (!dt[Qe]) {
          if (!KA(ue, ml(Je, $, ""))) {
            if (!((Qe === "src" || Qe === "xlink:href" || Qe === "href") && ne !== "script" && JR(Je, "data:") === 0 && Xe[ne])) {
              if (!(me && !KA(te, ml(Je, $, "")))) {
                if (Je)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, $A = function(ne) {
    return ne !== "annotation-xml" && B2(ne, re);
  }, RA = function(ne) {
    Mr(F.beforeSanitizeAttributes, ne, null);
    const {
      attributes: Qe
    } = ne;
    if (!Qe || Vn(ne))
      return;
    const Je = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: G,
      forceKeepAttr: void 0
    };
    let Wt = Qe.length;
    for (; Wt--; ) {
      const Yr = Qe[Wt], {
        name: Er,
        namespaceURI: iA,
        value: kA
      } = Yr, dA = cr(Er);
      let Rr = Er === "value" ? kA : $R(kA);
      if (Je.attrName = dA, Je.attrValue = Rr, Je.keepAttr = !0, Je.forceKeepAttr = void 0, Mr(F.uponSanitizeAttribute, ne, Je), Rr = Je.attrValue, ke && (dA === "id" || dA === "name") && (ir(Er, ne), Rr = We + Rr), Te && KA(/((--!?|])>)|<\/(style|title)/i, Rr)) {
        ir(Er, ne);
        continue;
      }
      if (Je.forceKeepAttr || (ir(Er, ne), !Je.keepAttr))
        continue;
      if (!Ee && KA(/\/>/i, Rr)) {
        ir(Er, ne);
        continue;
      }
      Ne && Gc([P, D, R], (os) => {
        Rr = ml(Rr, os, " ");
      });
      const Xs = cr(ne.nodeName);
      if (JA(Xs, dA, Rr)) {
        if (C && typeof c == "object" && typeof c.getAttributeType == "function" && !iA)
          switch (c.getAttributeType(Xs, dA)) {
            case "TrustedHTML": {
              Rr = C.createHTML(Rr);
              break;
            }
            case "TrustedScriptURL": {
              Rr = C.createScriptURL(Rr);
              break;
            }
          }
        try {
          iA ? ne.setAttributeNS(iA, Er, Rr) : ne.setAttribute(Er, Rr), Vn(ne) ? xr(ne) : y2(e.removed);
        } catch {
        }
      }
    }
    Mr(F.afterSanitizeAttributes, ne, null);
  }, Ei = function $e(ne) {
    let Qe = null;
    const Je = Xr(ne);
    for (Mr(F.beforeSanitizeShadowDOM, ne, null); Qe = Je.nextNode(); )
      Mr(F.uponSanitizeShadowNode, Qe, null), on(Qe), RA(Qe), Qe.content instanceof i && $e(Qe.content);
    Mr(F.afterSanitizeShadowDOM, ne, null);
  };
  return e.sanitize = function($e) {
    let ne = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Qe = null, Je = null, Wt = null, Yr = null;
    if (Gt = !$e, Gt && ($e = "<!-->"), typeof $e != "string" && !Kn($e))
      if (typeof $e.toString == "function") {
        if ($e = $e.toString(), typeof $e != "string")
          throw vl("dirty is not a string, aborting");
      } else
        throw vl("toString is not a function");
    if (!e.isSupported)
      return $e;
    if (j || vt(ne), e.removed = [], typeof $e == "string" && (Ce = !1), Ce) {
      if ($e.nodeName) {
        const kA = cr($e.nodeName);
        if (!se[kA] || ee[kA])
          throw vl("root node is forbidden and cannot be sanitized in-place");
      }
    } else if ($e instanceof a)
      Qe = Or("<!---->"), Je = Qe.ownerDocument.importNode($e, !0), Je.nodeType === yl.element && Je.nodeName === "BODY" || Je.nodeName === "HTML" ? Qe = Je : Qe.appendChild(Je);
    else {
      if (!ft && !Ne && !Ge && // eslint-disable-next-line unicorn/prefer-includes
      $e.indexOf("<") === -1)
        return C && xe ? C.createHTML($e) : $e;
      if (Qe = Or($e), !Qe)
        return ft ? null : xe ? E : "";
    }
    Qe && Pe && xr(Qe.firstChild);
    const Er = Xr(Ce ? $e : Qe);
    for (; Wt = Er.nextNode(); )
      on(Wt), RA(Wt), Wt.content instanceof i && Ei(Wt.content);
    if (Ce)
      return $e;
    if (ft) {
      if (et)
        for (Yr = O.call(Qe.ownerDocument); Qe.firstChild; )
          Yr.appendChild(Qe.firstChild);
      else
        Yr = Qe;
      return (G.shadowroot || G.shadowrootmode) && (Yr = V.call(A, Yr, !0)), Yr;
    }
    let iA = Ge ? Qe.outerHTML : Qe.innerHTML;
    return Ge && se["!doctype"] && Qe.ownerDocument && Qe.ownerDocument.doctype && Qe.ownerDocument.doctype.name && KA(pE, Qe.ownerDocument.doctype.name) && (iA = "<!DOCTYPE " + Qe.ownerDocument.doctype.name + `>
` + iA), Ne && Gc([P, D, R], (kA) => {
      iA = ml(iA, kA, " ");
    }), C && xe ? C.createHTML(iA) : iA;
  }, e.setConfig = function() {
    let $e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    vt($e), j = !0;
  }, e.clearConfig = function() {
    Sr = null, j = !1;
  }, e.isValidAttribute = function($e, ne, Qe) {
    Sr || vt({});
    const Je = cr($e), Wt = cr(ne);
    return JA(Je, Wt, Qe);
  }, e.addHook = function($e, ne) {
    typeof ne == "function" && pl(F[$e], ne);
  }, e.removeHook = function($e, ne) {
    if (ne !== void 0) {
      const Qe = XR(F[$e], ne);
      return Qe === -1 ? void 0 : YR(F[$e], Qe, 1)[0];
    }
    return y2(F[$e]);
  }, e.removeHooks = function($e) {
    F[$e] = [];
  }, e.removeAllHooks = function() {
    F = F2();
  }, e;
}
var fk = mE();
const dk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: fk
}, Symbol.toStringTag, { value: "Module" }));
var _2 = {}, U2 = {}, Bl, I2;
function Cr() {
  if (I2) return Bl;
  I2 = 1;
  var r = function(e) {
    return e && e.Math === Math && e;
  };
  return Bl = // eslint-disable-next-line es/no-global-this -- safe
  r(typeof globalThis == "object" && globalThis) || r(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  r(typeof self == "object" && self) || r(typeof tm == "object" && tm) || r(typeof Bl == "object" && Bl) || // eslint-disable-next-line no-new-func -- fallback
  /* @__PURE__ */ (function() {
    return this;
  })() || Function("return this")(), Bl;
}
var Zd = {}, eg, Q2;
function Tr() {
  return Q2 || (Q2 = 1, eg = function(r) {
    try {
      return !!r();
    } catch {
      return !0;
    }
  }), eg;
}
var tg, L2;
function si() {
  if (L2) return tg;
  L2 = 1;
  var r = Tr();
  return tg = !r(function() {
    return Object.defineProperty({}, 1, { get: function() {
      return 7;
    } })[1] !== 7;
  }), tg;
}
var rg, N2;
function Wh() {
  if (N2) return rg;
  N2 = 1;
  var r = Tr();
  return rg = !r(function() {
    var e = (function() {
    }).bind();
    return typeof e != "function" || e.hasOwnProperty("prototype");
  }), rg;
}
var Ag, T2;
function _A() {
  if (T2) return Ag;
  T2 = 1;
  var r = Wh(), e = Function.prototype.call;
  return Ag = r ? e.bind(e) : function() {
    return e.apply(e, arguments);
  }, Ag;
}
var ng = {}, P2;
function gk() {
  if (P2) return ng;
  P2 = 1;
  var r = {}.propertyIsEnumerable, e = Object.getOwnPropertyDescriptor, t = e && !r.call({ 1: 2 }, 1);
  return ng.f = t ? function(n) {
    var i = e(this, n);
    return !!i && i.enumerable;
  } : r, ng;
}
var ig, O2;
function yv() {
  return O2 || (O2 = 1, ig = function(r, e) {
    return {
      enumerable: !(r & 1),
      configurable: !(r & 2),
      writable: !(r & 4),
      value: e
    };
  }), ig;
}
var sg, M2;
function Pr() {
  if (M2) return sg;
  M2 = 1;
  var r = Wh(), e = Function.prototype, t = e.call, A = r && e.bind.bind(t, t);
  return sg = r ? A : function(n) {
    return function() {
      return t.apply(n, arguments);
    };
  }, sg;
}
var ag, R2;
function ka() {
  if (R2) return ag;
  R2 = 1;
  var r = Pr(), e = r({}.toString), t = r("".slice);
  return ag = function(A) {
    return t(e(A), 8, -1);
  }, ag;
}
var og, k2;
function vE() {
  if (k2) return og;
  k2 = 1;
  var r = Pr(), e = Tr(), t = ka(), A = Object, n = r("".split);
  return og = e(function() {
    return !A("z").propertyIsEnumerable(0);
  }) ? function(i) {
    return t(i) === "String" ? n(i, "") : A(i);
  } : A, og;
}
var lg, H2;
function Xh() {
  return H2 || (H2 = 1, lg = function(r) {
    return r == null;
  }), lg;
}
var ug, D2;
function ai() {
  if (D2) return ug;
  D2 = 1;
  var r = Xh(), e = TypeError;
  return ug = function(t) {
    if (r(t)) throw new e("Can't call method on " + t);
    return t;
  }, ug;
}
var cg, G2;
function mu() {
  if (G2) return cg;
  G2 = 1;
  var r = vE(), e = ai();
  return cg = function(t) {
    return r(e(t));
  }, cg;
}
var hg, V2;
function Wr() {
  if (V2) return hg;
  V2 = 1;
  var r = typeof document == "object" && document.all;
  return hg = typeof r > "u" && r !== void 0 ? function(e) {
    return typeof e == "function" || e === r;
  } : function(e) {
    return typeof e == "function";
  }, hg;
}
var fg, K2;
function sn() {
  if (K2) return fg;
  K2 = 1;
  var r = Wr();
  return fg = function(e) {
    return typeof e == "object" ? e !== null : r(e);
  }, fg;
}
var dg, j2;
function Ha() {
  if (j2) return dg;
  j2 = 1;
  var r = Cr(), e = Wr(), t = function(A) {
    return e(A) ? A : void 0;
  };
  return dg = function(A, n) {
    return arguments.length < 2 ? t(r[A]) : r[A] && r[A][n];
  }, dg;
}
var gg, q2;
function Yh() {
  if (q2) return gg;
  q2 = 1;
  var r = Pr();
  return gg = r({}.isPrototypeOf), gg;
}
var pg, z2;
function vu() {
  if (z2) return pg;
  z2 = 1;
  var r = Cr(), e = r.navigator, t = e && e.userAgent;
  return pg = t ? String(t) : "", pg;
}
var mg, W2;
function Bv() {
  if (W2) return mg;
  W2 = 1;
  var r = Cr(), e = vu(), t = r.process, A = r.Deno, n = t && t.versions || A && A.version, i = n && n.v8, s, a;
  return i && (s = i.split("."), a = s[0] > 0 && s[0] < 4 ? 1 : +(s[0] + s[1])), !a && e && (s = e.match(/Edge\/(\d+)/), (!s || s[1] >= 74) && (s = e.match(/Chrome\/(\d+)/), s && (a = +s[1]))), mg = a, mg;
}
var vg, X2;
function wE() {
  if (X2) return vg;
  X2 = 1;
  var r = Bv(), e = Tr(), t = Cr(), A = t.String;
  return vg = !!Object.getOwnPropertySymbols && !e(function() {
    var n = Symbol("symbol detection");
    return !A(n) || !(Object(n) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && r && r < 41;
  }), vg;
}
var wg, Y2;
function yE() {
  if (Y2) return wg;
  Y2 = 1;
  var r = wE();
  return wg = r && !Symbol.sham && typeof Symbol.iterator == "symbol", wg;
}
var yg, J2;
function BE() {
  if (J2) return yg;
  J2 = 1;
  var r = Ha(), e = Wr(), t = Yh(), A = yE(), n = Object;
  return yg = A ? function(i) {
    return typeof i == "symbol";
  } : function(i) {
    var s = r("Symbol");
    return e(s) && t(s.prototype, n(i));
  }, yg;
}
var Bg, $2;
function Jh() {
  if ($2) return Bg;
  $2 = 1;
  var r = String;
  return Bg = function(e) {
    try {
      return r(e);
    } catch {
      return "Object";
    }
  }, Bg;
}
var bg, Z2;
function as() {
  if (Z2) return bg;
  Z2 = 1;
  var r = Wr(), e = Jh(), t = TypeError;
  return bg = function(A) {
    if (r(A)) return A;
    throw new t(e(A) + " is not a function");
  }, bg;
}
var Cg, eB;
function Oo() {
  if (eB) return Cg;
  eB = 1;
  var r = as(), e = Xh();
  return Cg = function(t, A) {
    var n = t[A];
    return e(n) ? void 0 : r(n);
  }, Cg;
}
var Sg, tB;
function pk() {
  if (tB) return Sg;
  tB = 1;
  var r = _A(), e = Wr(), t = sn(), A = TypeError;
  return Sg = function(n, i) {
    var s, a;
    if (i === "string" && e(s = n.toString) && !t(a = r(s, n)) || e(s = n.valueOf) && !t(a = r(s, n)) || i !== "string" && e(s = n.toString) && !t(a = r(s, n))) return a;
    throw new A("Can't convert object to primitive value");
  }, Sg;
}
var xg = { exports: {} }, Eg, rB;
function Si() {
  return rB || (rB = 1, Eg = !1), Eg;
}
var Fg, AB;
function bv() {
  if (AB) return Fg;
  AB = 1;
  var r = Cr(), e = Object.defineProperty;
  return Fg = function(t, A) {
    try {
      e(r, t, { value: A, configurable: !0, writable: !0 });
    } catch {
      r[t] = A;
    }
    return A;
  }, Fg;
}
var nB;
function Cv() {
  if (nB) return xg.exports;
  nB = 1;
  var r = Si(), e = Cr(), t = bv(), A = "__core-js_shared__", n = xg.exports = e[A] || t(A, {});
  return (n.versions || (n.versions = [])).push({
    version: "3.47.0",
    mode: r ? "pure" : "global",
    copyright: "© 2014-2025 Denis Pushkarev (zloirock.ru), 2025 CoreJS Company (core-js.io)",
    license: "https://github.com/zloirock/core-js/blob/v3.47.0/LICENSE",
    source: "https://github.com/zloirock/core-js"
  }), xg.exports;
}
var _g, iB;
function Sv() {
  if (iB) return _g;
  iB = 1;
  var r = Cv();
  return _g = function(e, t) {
    return r[e] || (r[e] = t || {});
  }, _g;
}
var Ug, sB;
function $h() {
  if (sB) return Ug;
  sB = 1;
  var r = ai(), e = Object;
  return Ug = function(t) {
    return e(r(t));
  }, Ug;
}
var Ig, aB;
function oi() {
  if (aB) return Ig;
  aB = 1;
  var r = Pr(), e = $h(), t = r({}.hasOwnProperty);
  return Ig = Object.hasOwn || function(n, i) {
    return t(e(n), i);
  }, Ig;
}
var Qg, oB;
function bE() {
  if (oB) return Qg;
  oB = 1;
  var r = Pr(), e = 0, t = Math.random(), A = r(1.1.toString);
  return Qg = function(n) {
    return "Symbol(" + (n === void 0 ? "" : n) + ")_" + A(++e + t, 36);
  }, Qg;
}
var Lg, lB;
function vA() {
  if (lB) return Lg;
  lB = 1;
  var r = Cr(), e = Sv(), t = oi(), A = bE(), n = wE(), i = yE(), s = r.Symbol, a = e("wks"), o = i ? s.for || s : s && s.withoutSetter || A;
  return Lg = function(l) {
    return t(a, l) || (a[l] = n && t(s, l) ? s[l] : o("Symbol." + l)), a[l];
  }, Lg;
}
var Ng, uB;
function mk() {
  if (uB) return Ng;
  uB = 1;
  var r = _A(), e = sn(), t = BE(), A = Oo(), n = pk(), i = vA(), s = TypeError, a = i("toPrimitive");
  return Ng = function(o, l) {
    if (!e(o) || t(o)) return o;
    var u = A(o, a), h;
    if (u) {
      if (l === void 0 && (l = "default"), h = r(u, o, l), !e(h) || t(h)) return h;
      throw new s("Can't convert object to primitive value");
    }
    return l === void 0 && (l = "number"), n(o, l);
  }, Ng;
}
var Tg, cB;
function CE() {
  if (cB) return Tg;
  cB = 1;
  var r = mk(), e = BE();
  return Tg = function(t) {
    var A = r(t, "string");
    return e(A) ? A : A + "";
  }, Tg;
}
var Pg, hB;
function Zh() {
  if (hB) return Pg;
  hB = 1;
  var r = Cr(), e = sn(), t = r.document, A = e(t) && e(t.createElement);
  return Pg = function(n) {
    return A ? t.createElement(n) : {};
  }, Pg;
}
var Og, fB;
function SE() {
  if (fB) return Og;
  fB = 1;
  var r = si(), e = Tr(), t = Zh();
  return Og = !r && !e(function() {
    return Object.defineProperty(t("div"), "a", {
      get: function() {
        return 7;
      }
    }).a !== 7;
  }), Og;
}
var dB;
function ef() {
  if (dB) return Zd;
  dB = 1;
  var r = si(), e = _A(), t = gk(), A = yv(), n = mu(), i = CE(), s = oi(), a = SE(), o = Object.getOwnPropertyDescriptor;
  return Zd.f = r ? o : function(u, h) {
    if (u = n(u), h = i(h), a) try {
      return o(u, h);
    } catch {
    }
    if (s(u, h)) return A(!e(t.f, u, h), u[h]);
  }, Zd;
}
var Mg = {}, Rg, gB;
function xE() {
  if (gB) return Rg;
  gB = 1;
  var r = si(), e = Tr();
  return Rg = r && e(function() {
    return Object.defineProperty(function() {
    }, "prototype", {
      value: 42,
      writable: !1
    }).prototype !== 42;
  }), Rg;
}
var kg, pB;
function WA() {
  if (pB) return kg;
  pB = 1;
  var r = sn(), e = String, t = TypeError;
  return kg = function(A) {
    if (r(A)) return A;
    throw new t(e(A) + " is not an object");
  }, kg;
}
var mB;
function zs() {
  if (mB) return Mg;
  mB = 1;
  var r = si(), e = SE(), t = xE(), A = WA(), n = CE(), i = TypeError, s = Object.defineProperty, a = Object.getOwnPropertyDescriptor, o = "enumerable", l = "configurable", u = "writable";
  return Mg.f = r ? t ? function(f, c, p) {
    if (A(f), c = n(c), A(p), typeof f == "function" && c === "prototype" && "value" in p && u in p && !p[u]) {
      var g = a(f, c);
      g && g[u] && (f[c] = p.value, p = {
        configurable: l in p ? p[l] : g[l],
        enumerable: o in p ? p[o] : g[o],
        writable: !1
      });
    }
    return s(f, c, p);
  } : s : function(f, c, p) {
    if (A(f), c = n(c), A(p), e) try {
      return s(f, c, p);
    } catch {
    }
    if ("get" in p || "set" in p) throw new i("Accessors not supported");
    return "value" in p && (f[c] = p.value), f;
  }, Mg;
}
var Hg, vB;
function wu() {
  if (vB) return Hg;
  vB = 1;
  var r = si(), e = zs(), t = yv();
  return Hg = r ? function(A, n, i) {
    return e.f(A, n, t(1, i));
  } : function(A, n, i) {
    return A[n] = i, A;
  }, Hg;
}
var Dg = { exports: {} }, Gg, wB;
function tf() {
  if (wB) return Gg;
  wB = 1;
  var r = si(), e = oi(), t = Function.prototype, A = r && Object.getOwnPropertyDescriptor, n = e(t, "name"), i = n && (function() {
  }).name === "something", s = n && (!r || r && A(t, "name").configurable);
  return Gg = {
    EXISTS: n,
    PROPER: i,
    CONFIGURABLE: s
  }, Gg;
}
var Vg, yB;
function xv() {
  if (yB) return Vg;
  yB = 1;
  var r = Pr(), e = Wr(), t = Cv(), A = r(Function.toString);
  return e(t.inspectSource) || (t.inspectSource = function(n) {
    return A(n);
  }), Vg = t.inspectSource, Vg;
}
var Kg, BB;
function vk() {
  if (BB) return Kg;
  BB = 1;
  var r = Cr(), e = Wr(), t = r.WeakMap;
  return Kg = e(t) && /native code/.test(String(t)), Kg;
}
var jg, bB;
function Ev() {
  if (bB) return jg;
  bB = 1;
  var r = Sv(), e = bE(), t = r("keys");
  return jg = function(A) {
    return t[A] || (t[A] = e(A));
  }, jg;
}
var qg, CB;
function Fv() {
  return CB || (CB = 1, qg = {}), qg;
}
var zg, SB;
function rf() {
  if (SB) return zg;
  SB = 1;
  var r = vk(), e = Cr(), t = sn(), A = wu(), n = oi(), i = Cv(), s = Ev(), a = Fv(), o = "Object already initialized", l = e.TypeError, u = e.WeakMap, h, f, c, p = function(B) {
    return c(B) ? f(B) : h(B, {});
  }, g = function(B) {
    return function(S) {
      var C;
      if (!t(S) || (C = f(S)).type !== B)
        throw new l("Incompatible receiver, " + B + " required");
      return C;
    };
  };
  if (r || i.state) {
    var v = i.state || (i.state = new u());
    v.get = v.get, v.has = v.has, v.set = v.set, h = function(B, S) {
      if (v.has(B)) throw new l(o);
      return S.facade = B, v.set(B, S), S;
    }, f = function(B) {
      return v.get(B) || {};
    }, c = function(B) {
      return v.has(B);
    };
  } else {
    var w = s("state");
    a[w] = !0, h = function(B, S) {
      if (n(B, w)) throw new l(o);
      return S.facade = B, A(B, w, S), S;
    }, f = function(B) {
      return n(B, w) ? B[w] : {};
    }, c = function(B) {
      return n(B, w);
    };
  }
  return zg = {
    set: h,
    get: f,
    has: c,
    enforce: p,
    getterFor: g
  }, zg;
}
var xB;
function EE() {
  if (xB) return Dg.exports;
  xB = 1;
  var r = Pr(), e = Tr(), t = Wr(), A = oi(), n = si(), i = tf().CONFIGURABLE, s = xv(), a = rf(), o = a.enforce, l = a.get, u = String, h = Object.defineProperty, f = r("".slice), c = r("".replace), p = r([].join), g = n && !e(function() {
    return h(function() {
    }, "length", { value: 8 }).length !== 8;
  }), v = String(String).split("String"), w = Dg.exports = function(B, S, C) {
    f(u(S), 0, 7) === "Symbol(" && (S = "[" + c(u(S), /^Symbol\(([^)]*)\).*$/, "$1") + "]"), C && C.getter && (S = "get " + S), C && C.setter && (S = "set " + S), (!A(B, "name") || i && B.name !== S) && (n ? h(B, "name", { value: S, configurable: !0 }) : B.name = S), g && C && A(C, "arity") && B.length !== C.arity && h(B, "length", { value: C.arity });
    try {
      C && A(C, "constructor") && C.constructor ? n && h(B, "prototype", { writable: !1 }) : B.prototype && (B.prototype = void 0);
    } catch {
    }
    var E = o(B);
    return A(E, "source") || (E.source = p(v, typeof S == "string" ? S : "")), B;
  };
  return Function.prototype.toString = w(function() {
    return t(this) && l(this).source || s(this);
  }, "toString"), Dg.exports;
}
var Wg, EB;
function Da() {
  if (EB) return Wg;
  EB = 1;
  var r = Wr(), e = zs(), t = EE(), A = bv();
  return Wg = function(n, i, s, a) {
    a || (a = {});
    var o = a.enumerable, l = a.name !== void 0 ? a.name : i;
    if (r(s) && t(s, l, a), a.global)
      o ? n[i] = s : A(i, s);
    else {
      try {
        a.unsafe ? n[i] && (o = !0) : delete n[i];
      } catch {
      }
      o ? n[i] = s : e.f(n, i, {
        value: s,
        enumerable: !1,
        configurable: !a.nonConfigurable,
        writable: !a.nonWritable
      });
    }
    return n;
  }, Wg;
}
var Xg = {}, Yg, FB;
function wk() {
  if (FB) return Yg;
  FB = 1;
  var r = Math.ceil, e = Math.floor;
  return Yg = Math.trunc || function(A) {
    var n = +A;
    return (n > 0 ? e : r)(n);
  }, Yg;
}
var Jg, _B;
function Af() {
  if (_B) return Jg;
  _B = 1;
  var r = wk();
  return Jg = function(e) {
    var t = +e;
    return t !== t || t === 0 ? 0 : r(t);
  }, Jg;
}
var $g, UB;
function yk() {
  if (UB) return $g;
  UB = 1;
  var r = Af(), e = Math.max, t = Math.min;
  return $g = function(A, n) {
    var i = r(A);
    return i < 0 ? e(i + n, 0) : t(i, n);
  }, $g;
}
var Zg, IB;
function Mo() {
  if (IB) return Zg;
  IB = 1;
  var r = Af(), e = Math.min;
  return Zg = function(t) {
    var A = r(t);
    return A > 0 ? e(A, 9007199254740991) : 0;
  }, Zg;
}
var ep, QB;
function _v() {
  if (QB) return ep;
  QB = 1;
  var r = Mo();
  return ep = function(e) {
    return r(e.length);
  }, ep;
}
var tp, LB;
function FE() {
  if (LB) return tp;
  LB = 1;
  var r = mu(), e = yk(), t = _v(), A = function(n) {
    return function(i, s, a) {
      var o = r(i), l = t(o);
      if (l === 0) return !n && -1;
      var u = e(a, l), h;
      if (n && s !== s) {
        for (; l > u; )
          if (h = o[u++], h !== h) return !0;
      } else for (; l > u; u++)
        if ((n || u in o) && o[u] === s) return n || u || 0;
      return !n && -1;
    };
  };
  return tp = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: A(!0),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: A(!1)
  }, tp;
}
var rp, NB;
function _E() {
  if (NB) return rp;
  NB = 1;
  var r = Pr(), e = oi(), t = mu(), A = FE().indexOf, n = Fv(), i = r([].push);
  return rp = function(s, a) {
    var o = t(s), l = 0, u = [], h;
    for (h in o) !e(n, h) && e(o, h) && i(u, h);
    for (; a.length > l; ) e(o, h = a[l++]) && (~A(u, h) || i(u, h));
    return u;
  }, rp;
}
var Ap, TB;
function Uv() {
  return TB || (TB = 1, Ap = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
  ]), Ap;
}
var PB;
function Bk() {
  if (PB) return Xg;
  PB = 1;
  var r = _E(), e = Uv(), t = e.concat("length", "prototype");
  return Xg.f = Object.getOwnPropertyNames || function(n) {
    return r(n, t);
  }, Xg;
}
var np = {}, OB;
function bk() {
  return OB || (OB = 1, np.f = Object.getOwnPropertySymbols), np;
}
var ip, MB;
function Ck() {
  if (MB) return ip;
  MB = 1;
  var r = Ha(), e = Pr(), t = Bk(), A = bk(), n = WA(), i = e([].concat);
  return ip = r("Reflect", "ownKeys") || function(a) {
    var o = t.f(n(a)), l = A.f;
    return l ? i(o, l(a)) : o;
  }, ip;
}
var sp, RB;
function Sk() {
  if (RB) return sp;
  RB = 1;
  var r = oi(), e = Ck(), t = ef(), A = zs();
  return sp = function(n, i, s) {
    for (var a = e(i), o = A.f, l = t.f, u = 0; u < a.length; u++) {
      var h = a[u];
      !r(n, h) && !(s && r(s, h)) && o(n, h, l(i, h));
    }
  }, sp;
}
var ap, kB;
function UE() {
  if (kB) return ap;
  kB = 1;
  var r = Tr(), e = Wr(), t = /#|\.prototype\./, A = function(o, l) {
    var u = i[n(o)];
    return u === a ? !0 : u === s ? !1 : e(l) ? r(l) : !!l;
  }, n = A.normalize = function(o) {
    return String(o).replace(t, ".").toLowerCase();
  }, i = A.data = {}, s = A.NATIVE = "N", a = A.POLYFILL = "P";
  return ap = A, ap;
}
var op, HB;
function XA() {
  if (HB) return op;
  HB = 1;
  var r = Cr(), e = ef().f, t = wu(), A = Da(), n = bv(), i = Sk(), s = UE();
  return op = function(a, o) {
    var l = a.target, u = a.global, h = a.stat, f, c, p, g, v, w;
    if (u ? c = r : h ? c = r[l] || n(l, {}) : c = r[l] && r[l].prototype, c) for (p in o) {
      if (v = o[p], a.dontCallGetSet ? (w = e(c, p), g = w && w.value) : g = c[p], f = s(u ? p : l + (h ? "." : "#") + p, a.forced), !f && g !== void 0) {
        if (typeof v == typeof g) continue;
        i(v, g);
      }
      (a.sham || g && g.sham) && t(v, "sham", !0), A(c, p, v, a);
    }
  }, op;
}
var lp, DB;
function IE() {
  if (DB) return lp;
  DB = 1;
  var r = Cr(), e = vu(), t = ka(), A = function(n) {
    return e.slice(0, n.length) === n;
  };
  return lp = (function() {
    return A("Bun/") ? "BUN" : A("Cloudflare-Workers") ? "CLOUDFLARE" : A("Deno/") ? "DENO" : A("Node.js/") ? "NODE" : r.Bun && typeof Bun.version == "string" ? "BUN" : r.Deno && typeof Deno.version == "object" ? "DENO" : t(r.process) === "process" ? "NODE" : r.window && r.document ? "BROWSER" : "REST";
  })(), lp;
}
var up, GB;
function nf() {
  if (GB) return up;
  GB = 1;
  var r = IE();
  return up = r === "NODE", up;
}
var cp, VB;
function xk() {
  if (VB) return cp;
  VB = 1;
  var r = Cr();
  return cp = r, cp;
}
var hp, KB;
function Ek() {
  if (KB) return hp;
  KB = 1;
  var r = Pr(), e = as();
  return hp = function(t, A, n) {
    try {
      return r(e(Object.getOwnPropertyDescriptor(t, A)[n]));
    } catch {
    }
  }, hp;
}
var fp, jB;
function Fk() {
  if (jB) return fp;
  jB = 1;
  var r = sn();
  return fp = function(e) {
    return r(e) || e === null;
  }, fp;
}
var dp, qB;
function _k() {
  if (qB) return dp;
  qB = 1;
  var r = Fk(), e = String, t = TypeError;
  return dp = function(A) {
    if (r(A)) return A;
    throw new t("Can't set " + e(A) + " as a prototype");
  }, dp;
}
var gp, zB;
function QE() {
  if (zB) return gp;
  zB = 1;
  var r = Ek(), e = sn(), t = ai(), A = _k();
  return gp = Object.setPrototypeOf || ("__proto__" in {} ? (function() {
    var n = !1, i = {}, s;
    try {
      s = r(Object.prototype, "__proto__", "set"), s(i, []), n = i instanceof Array;
    } catch {
    }
    return function(o, l) {
      return t(o), A(l), e(o) && (n ? s(o, l) : o.__proto__ = l), o;
    };
  })() : void 0), gp;
}
var pp, WB;
function sf() {
  if (WB) return pp;
  WB = 1;
  var r = zs().f, e = oi(), t = vA(), A = t("toStringTag");
  return pp = function(n, i, s) {
    n && !s && (n = n.prototype), n && !e(n, A) && r(n, A, { configurable: !0, value: i });
  }, pp;
}
var mp, XB;
function Uk() {
  if (XB) return mp;
  XB = 1;
  var r = EE(), e = zs();
  return mp = function(t, A, n) {
    return n.get && r(n.get, A, { getter: !0 }), n.set && r(n.set, A, { setter: !0 }), e.f(t, A, n);
  }, mp;
}
var vp, YB;
function Ik() {
  if (YB) return vp;
  YB = 1;
  var r = Ha(), e = Uk(), t = vA(), A = si(), n = t("species");
  return vp = function(i) {
    var s = r(i);
    A && s && !s[n] && e(s, n, {
      configurable: !0,
      get: function() {
        return this;
      }
    });
  }, vp;
}
var wp, JB;
function Qk() {
  if (JB) return wp;
  JB = 1;
  var r = Yh(), e = TypeError;
  return wp = function(t, A) {
    if (r(A, t)) return t;
    throw new e("Incorrect invocation");
  }, wp;
}
var yp, $B;
function Lk() {
  if ($B) return yp;
  $B = 1;
  var r = vA(), e = r("toStringTag"), t = {};
  return t[e] = "z", yp = String(t) === "[object z]", yp;
}
var Bp, ZB;
function Iv() {
  if (ZB) return Bp;
  ZB = 1;
  var r = Lk(), e = Wr(), t = ka(), A = vA(), n = A("toStringTag"), i = Object, s = t(/* @__PURE__ */ (function() {
    return arguments;
  })()) === "Arguments", a = function(o, l) {
    try {
      return o[l];
    } catch {
    }
  };
  return Bp = r ? t : function(o) {
    var l, u, h;
    return o === void 0 ? "Undefined" : o === null ? "Null" : typeof (u = a(l = i(o), n)) == "string" ? u : s ? t(l) : (h = t(l)) === "Object" && e(l.callee) ? "Arguments" : h;
  }, Bp;
}
var bp, eb;
function Nk() {
  if (eb) return bp;
  eb = 1;
  var r = Pr(), e = Tr(), t = Wr(), A = Iv(), n = Ha(), i = xv(), s = function() {
  }, a = n("Reflect", "construct"), o = /^\s*(?:class|function)\b/, l = r(o.exec), u = !o.test(s), h = function(p) {
    if (!t(p)) return !1;
    try {
      return a(s, [], p), !0;
    } catch {
      return !1;
    }
  }, f = function(p) {
    if (!t(p)) return !1;
    switch (A(p)) {
      case "AsyncFunction":
      case "GeneratorFunction":
      case "AsyncGeneratorFunction":
        return !1;
    }
    try {
      return u || !!l(o, i(p));
    } catch {
      return !0;
    }
  };
  return f.sham = !0, bp = !a || e(function() {
    var c;
    return h(h.call) || !h(Object) || !h(function() {
      c = !0;
    }) || c;
  }) ? f : h, bp;
}
var Cp, tb;
function Tk() {
  if (tb) return Cp;
  tb = 1;
  var r = Nk(), e = Jh(), t = TypeError;
  return Cp = function(A) {
    if (r(A)) return A;
    throw new t(e(A) + " is not a constructor");
  }, Cp;
}
var Sp, rb;
function LE() {
  if (rb) return Sp;
  rb = 1;
  var r = WA(), e = Tk(), t = Xh(), A = vA(), n = A("species");
  return Sp = function(i, s) {
    var a = r(i).constructor, o;
    return a === void 0 || t(o = r(a)[n]) ? s : e(o);
  }, Sp;
}
var xp, Ab;
function NE() {
  if (Ab) return xp;
  Ab = 1;
  var r = Wh(), e = Function.prototype, t = e.apply, A = e.call;
  return xp = typeof Reflect == "object" && Reflect.apply || (r ? A.bind(t) : function() {
    return A.apply(t, arguments);
  }), xp;
}
var Ep, nb;
function af() {
  if (nb) return Ep;
  nb = 1;
  var r = ka(), e = Pr();
  return Ep = function(t) {
    if (r(t) === "Function") return e(t);
  }, Ep;
}
var Fp, ib;
function Qv() {
  if (ib) return Fp;
  ib = 1;
  var r = af(), e = as(), t = Wh(), A = r(r.bind);
  return Fp = function(n, i) {
    return e(n), i === void 0 ? n : t ? A(n, i) : function() {
      return n.apply(i, arguments);
    };
  }, Fp;
}
var _p, sb;
function TE() {
  if (sb) return _p;
  sb = 1;
  var r = Ha();
  return _p = r("document", "documentElement"), _p;
}
var Up, ab;
function Pk() {
  if (ab) return Up;
  ab = 1;
  var r = Pr();
  return Up = r([].slice), Up;
}
var Ip, ob;
function Ok() {
  if (ob) return Ip;
  ob = 1;
  var r = TypeError;
  return Ip = function(e, t) {
    if (e < t) throw new r("Not enough arguments");
    return e;
  }, Ip;
}
var Qp, lb;
function PE() {
  if (lb) return Qp;
  lb = 1;
  var r = vu();
  return Qp = /(?:ipad|iphone|ipod).*applewebkit/i.test(r), Qp;
}
var Lp, ub;
function OE() {
  if (ub) return Lp;
  ub = 1;
  var r = Cr(), e = NE(), t = Qv(), A = Wr(), n = oi(), i = Tr(), s = TE(), a = Pk(), o = Zh(), l = Ok(), u = PE(), h = nf(), f = r.setImmediate, c = r.clearImmediate, p = r.process, g = r.Dispatch, v = r.Function, w = r.MessageChannel, B = r.String, S = 0, C = {}, E = "onreadystatechange", _, I, O, U;
  i(function() {
    _ = r.location;
  });
  var V = function(R) {
    if (n(C, R)) {
      var J = C[R];
      delete C[R], J();
    }
  }, F = function(R) {
    return function() {
      V(R);
    };
  }, P = function(R) {
    V(R.data);
  }, D = function(R) {
    r.postMessage(B(R), _.protocol + "//" + _.host);
  };
  return (!f || !c) && (f = function(J) {
    l(arguments.length, 1);
    var ie = A(J) ? J : v(J), te = a(arguments, 1);
    return C[++S] = function() {
      e(ie, void 0, te);
    }, I(S), S;
  }, c = function(J) {
    delete C[J];
  }, h ? I = function(R) {
    p.nextTick(F(R));
  } : g && g.now ? I = function(R) {
    g.now(F(R));
  } : w && !u ? (O = new w(), U = O.port2, O.port1.onmessage = P, I = t(U.postMessage, U)) : r.addEventListener && A(r.postMessage) && !r.importScripts && _ && _.protocol !== "file:" && !i(D) ? (I = D, r.addEventListener("message", P, !1)) : E in o("script") ? I = function(R) {
    s.appendChild(o("script"))[E] = function() {
      s.removeChild(this), V(R);
    };
  } : I = function(R) {
    setTimeout(F(R), 0);
  }), Lp = {
    set: f,
    clear: c
  }, Lp;
}
var Np, cb;
function Mk() {
  if (cb) return Np;
  cb = 1;
  var r = Cr(), e = si(), t = Object.getOwnPropertyDescriptor;
  return Np = function(A) {
    if (!e) return r[A];
    var n = t(r, A);
    return n && n.value;
  }, Np;
}
var Tp, hb;
function ME() {
  if (hb) return Tp;
  hb = 1;
  var r = function() {
    this.head = null, this.tail = null;
  };
  return r.prototype = {
    add: function(e) {
      var t = { item: e, next: null }, A = this.tail;
      A ? A.next = t : this.head = t, this.tail = t;
    },
    get: function() {
      var e = this.head;
      if (e) {
        var t = this.head = e.next;
        return t === null && (this.tail = null), e.item;
      }
    }
  }, Tp = r, Tp;
}
var Pp, fb;
function Rk() {
  if (fb) return Pp;
  fb = 1;
  var r = vu();
  return Pp = /ipad|iphone|ipod/i.test(r) && typeof Pebble < "u", Pp;
}
var Op, db;
function kk() {
  if (db) return Op;
  db = 1;
  var r = vu();
  return Op = /web0s(?!.*chrome)/i.test(r), Op;
}
var Mp, gb;
function Hk() {
  if (gb) return Mp;
  gb = 1;
  var r = Cr(), e = Mk(), t = Qv(), A = OE().set, n = ME(), i = PE(), s = Rk(), a = kk(), o = nf(), l = r.MutationObserver || r.WebKitMutationObserver, u = r.document, h = r.process, f = r.Promise, c = e("queueMicrotask"), p, g, v, w, B;
  if (!c) {
    var S = new n(), C = function() {
      var E, _;
      for (o && (E = h.domain) && E.exit(); _ = S.get(); ) try {
        _();
      } catch (I) {
        throw S.head && p(), I;
      }
      E && E.enter();
    };
    !i && !o && !a && l && u ? (g = !0, v = u.createTextNode(""), new l(C).observe(v, { characterData: !0 }), p = function() {
      v.data = g = !g;
    }) : !s && f && f.resolve ? (w = f.resolve(void 0), w.constructor = f, B = t(w.then, w), p = function() {
      B(C);
    }) : o ? p = function() {
      h.nextTick(C);
    } : (A = t(A, r), p = function() {
      A(C);
    }), c = function(E) {
      S.head || p(), S.add(E);
    };
  }
  return Mp = c, Mp;
}
var Rp, pb;
function Dk() {
  return pb || (pb = 1, Rp = function(r, e) {
    try {
      arguments.length === 1 ? console.error(r) : console.error(r, e);
    } catch {
    }
  }), Rp;
}
var kp, mb;
function Lv() {
  return mb || (mb = 1, kp = function(r) {
    try {
      return { error: !1, value: r() };
    } catch (e) {
      return { error: !0, value: e };
    }
  }), kp;
}
var Hp, vb;
function yu() {
  if (vb) return Hp;
  vb = 1;
  var r = Cr();
  return Hp = r.Promise, Hp;
}
var Dp, wb;
function Bu() {
  if (wb) return Dp;
  wb = 1;
  var r = Cr(), e = yu(), t = Wr(), A = UE(), n = xv(), i = vA(), s = IE(), a = Si(), o = Bv(), l = e && e.prototype, u = i("species"), h = !1, f = t(r.PromiseRejectionEvent), c = A("Promise", function() {
    var p = n(e), g = p !== String(e);
    if (!g && o === 66 || a && !(l.catch && l.finally)) return !0;
    if (!o || o < 51 || !/native code/.test(p)) {
      var v = new e(function(S) {
        S(1);
      }), w = function(S) {
        S(function() {
        }, function() {
        });
      }, B = v.constructor = {};
      if (B[u] = w, h = v.then(function() {
      }) instanceof w, !h) return !0;
    }
    return !g && (s === "BROWSER" || s === "DENO") && !f;
  });
  return Dp = {
    CONSTRUCTOR: c,
    REJECTION_EVENT: f,
    SUBCLASSING: h
  }, Dp;
}
var Gp = {}, yb;
function bu() {
  if (yb) return Gp;
  yb = 1;
  var r = as(), e = TypeError, t = function(A) {
    var n, i;
    this.promise = new A(function(s, a) {
      if (n !== void 0 || i !== void 0) throw new e("Bad Promise constructor");
      n = s, i = a;
    }), this.resolve = r(n), this.reject = r(i);
  };
  return Gp.f = function(A) {
    return new t(A);
  }, Gp;
}
var Bb;
function Gk() {
  if (Bb) return U2;
  Bb = 1;
  var r = XA(), e = Si(), t = nf(), A = Cr(), n = xk(), i = _A(), s = Da(), a = QE(), o = sf(), l = Ik(), u = as(), h = Wr(), f = sn(), c = Qk(), p = LE(), g = OE().set, v = Hk(), w = Dk(), B = Lv(), S = ME(), C = rf(), E = yu(), _ = Bu(), I = bu(), O = "Promise", U = _.CONSTRUCTOR, V = _.REJECTION_EVENT, F = _.SUBCLASSING, P = C.getterFor(O), D = C.set, R = E && E.prototype, J = E, ie = R, te = A.TypeError, $ = A.document, re = A.process, ue = I.f, se = ue, T = !!($ && $.createEvent && A.dispatchEvent), G = "unhandledrejection", X = "rejectionhandled", Y = 0, ee = 1, oe = 2, ge = 1, pe = 2, me, Ee, Ne, Te, Ge = function(Ce) {
    var Oe;
    return f(Ce) && h(Oe = Ce.then) ? Oe : !1;
  }, j = function(Ce, Oe) {
    var Re = Oe.value, Ke = Oe.state === ee, Xe = Ke ? Ce.ok : Ce.fail, Ve = Ce.resolve, dt = Ce.reject, je = Ce.domain, Tt, Et, mt;
    try {
      Xe ? (Ke || (Oe.rejection === pe && rt(Oe), Oe.rejection = ge), Xe === !0 ? Tt = Re : (je && je.enter(), Tt = Xe(Re), je && (je.exit(), mt = !0)), Tt === Ce.promise ? dt(new te("Promise-chain cycle")) : (Et = Ge(Tt)) ? i(Et, Tt, Ve, dt) : Ve(Tt)) : dt(Re);
    } catch (yt) {
      je && !mt && je.exit(), dt(yt);
    }
  }, Pe = function(Ce, Oe) {
    Ce.notified || (Ce.notified = !0, v(function() {
      for (var Re = Ce.reactions, Ke; Ke = Re.get(); )
        j(Ke, Ce);
      Ce.notified = !1, Oe && !Ce.rejection && et(Ce);
    }));
  }, ft = function(Ce, Oe, Re) {
    var Ke, Xe;
    T ? (Ke = $.createEvent("Event"), Ke.promise = Oe, Ke.reason = Re, Ke.initEvent(Ce, !1, !0), A.dispatchEvent(Ke)) : Ke = { promise: Oe, reason: Re }, !V && (Xe = A["on" + Ce]) ? Xe(Ke) : Ce === G && w("Unhandled promise rejection", Re);
  }, et = function(Ce) {
    i(g, A, function() {
      var Oe = Ce.facade, Re = Ce.value, Ke = xe(Ce), Xe;
      if (Ke && (Xe = B(function() {
        t ? re.emit("unhandledRejection", Re, Oe) : ft(G, Oe, Re);
      }), Ce.rejection = t || xe(Ce) ? pe : ge, Xe.error))
        throw Xe.value;
    });
  }, xe = function(Ce) {
    return Ce.rejection !== ge && !Ce.parent;
  }, rt = function(Ce) {
    i(g, A, function() {
      var Oe = Ce.facade;
      t ? re.emit("rejectionHandled", Oe) : ft(X, Oe, Ce.value);
    });
  }, ke = function(Ce, Oe, Re) {
    return function(Ke) {
      Ce(Oe, Ke, Re);
    };
  }, We = function(Ce, Oe, Re) {
    Ce.done || (Ce.done = !0, Re && (Ce = Re), Ce.value = Oe, Ce.state = oe, Pe(Ce, !0));
  }, ze = function(Ce, Oe, Re) {
    if (!Ce.done) {
      Ce.done = !0, Re && (Ce = Re);
      try {
        if (Ce.facade === Oe) throw new te("Promise can't be resolved itself");
        var Ke = Ge(Oe);
        Ke ? v(function() {
          var Xe = { done: !1 };
          try {
            i(
              Ke,
              Oe,
              ke(ze, Xe, Ce),
              ke(We, Xe, Ce)
            );
          } catch (Ve) {
            We(Xe, Ve, Ce);
          }
        }) : (Ce.value = Oe, Ce.state = ee, Pe(Ce, !1));
      } catch (Xe) {
        We({ done: !1 }, Xe, Ce);
      }
    }
  };
  if (U && (J = function(Oe) {
    c(this, ie), u(Oe), i(me, this);
    var Re = P(this);
    try {
      Oe(ke(ze, Re), ke(We, Re));
    } catch (Ke) {
      We(Re, Ke);
    }
  }, ie = J.prototype, me = function(Oe) {
    D(this, {
      type: O,
      done: !1,
      notified: !1,
      parent: !1,
      reactions: new S(),
      rejection: !1,
      state: Y,
      value: null
    });
  }, me.prototype = s(ie, "then", function(Oe, Re) {
    var Ke = P(this), Xe = ue(p(this, J));
    return Ke.parent = !0, Xe.ok = h(Oe) ? Oe : !0, Xe.fail = h(Re) && Re, Xe.domain = t ? re.domain : void 0, Ke.state === Y ? Ke.reactions.add(Xe) : v(function() {
      j(Xe, Ke);
    }), Xe.promise;
  }), Ee = function() {
    var Ce = new me(), Oe = P(Ce);
    this.promise = Ce, this.resolve = ke(ze, Oe), this.reject = ke(We, Oe);
  }, I.f = ue = function(Ce) {
    return Ce === J || Ce === Ne ? new Ee(Ce) : se(Ce);
  }, !e && h(E) && R !== Object.prototype)) {
    Te = R.then, F || s(R, "then", function(Oe, Re) {
      var Ke = this;
      return new J(function(Xe, Ve) {
        i(Te, Ke, Xe, Ve);
      }).then(Oe, Re);
    }, { unsafe: !0 });
    try {
      delete R.constructor;
    } catch {
    }
    a && a(R, ie);
  }
  return r({ global: !0, constructor: !0, wrap: !0, forced: U }, {
    Promise: J
  }), Ne = n.Promise, o(J, O, !1, !0), l(O), U2;
}
var bb = {}, Vp, Cb;
function Cu() {
  return Cb || (Cb = 1, Vp = {}), Vp;
}
var Kp, Sb;
function Vk() {
  if (Sb) return Kp;
  Sb = 1;
  var r = vA(), e = Cu(), t = r("iterator"), A = Array.prototype;
  return Kp = function(n) {
    return n !== void 0 && (e.Array === n || A[t] === n);
  }, Kp;
}
var jp, xb;
function RE() {
  if (xb) return jp;
  xb = 1;
  var r = Iv(), e = Oo(), t = Xh(), A = Cu(), n = vA(), i = n("iterator");
  return jp = function(s) {
    if (!t(s)) return e(s, i) || e(s, "@@iterator") || A[r(s)];
  }, jp;
}
var qp, Eb;
function Kk() {
  if (Eb) return qp;
  Eb = 1;
  var r = _A(), e = as(), t = WA(), A = Jh(), n = RE(), i = TypeError;
  return qp = function(s, a) {
    var o = arguments.length < 2 ? n(s) : a;
    if (e(o)) return t(r(o, s));
    throw new i(A(s) + " is not iterable");
  }, qp;
}
var zp, Fb;
function jk() {
  if (Fb) return zp;
  Fb = 1;
  var r = _A(), e = WA(), t = Oo();
  return zp = function(A, n, i) {
    var s, a;
    e(A);
    try {
      if (s = t(A, "return"), !s) {
        if (n === "throw") throw i;
        return i;
      }
      s = r(s, A);
    } catch (o) {
      a = !0, s = o;
    }
    if (n === "throw") throw i;
    if (a) throw s;
    return e(s), i;
  }, zp;
}
var Wp, _b;
function kE() {
  if (_b) return Wp;
  _b = 1;
  var r = Qv(), e = _A(), t = WA(), A = Jh(), n = Vk(), i = _v(), s = Yh(), a = Kk(), o = RE(), l = jk(), u = TypeError, h = function(c, p) {
    this.stopped = c, this.result = p;
  }, f = h.prototype;
  return Wp = function(c, p, g) {
    var v = g && g.that, w = !!(g && g.AS_ENTRIES), B = !!(g && g.IS_RECORD), S = !!(g && g.IS_ITERATOR), C = !!(g && g.INTERRUPTED), E = r(p, v), _, I, O, U, V, F, P, D = function(J) {
      return _ && l(_, "normal"), new h(!0, J);
    }, R = function(J) {
      return w ? (t(J), C ? E(J[0], J[1], D) : E(J[0], J[1])) : C ? E(J, D) : E(J);
    };
    if (B)
      _ = c.iterator;
    else if (S)
      _ = c;
    else {
      if (I = o(c), !I) throw new u(A(c) + " is not iterable");
      if (n(I)) {
        for (O = 0, U = i(c); U > O; O++)
          if (V = R(c[O]), V && s(f, V)) return V;
        return new h(!1);
      }
      _ = a(c, I);
    }
    for (F = B ? c.next : _.next; !(P = e(F, _)).done; ) {
      try {
        V = R(P.value);
      } catch (J) {
        l(_, "throw", J);
      }
      if (typeof V == "object" && V && s(f, V)) return V;
    }
    return new h(!1);
  }, Wp;
}
var Xp, Ub;
function qk() {
  if (Ub) return Xp;
  Ub = 1;
  var r = vA(), e = r("iterator"), t = !1;
  try {
    var A = 0, n = {
      next: function() {
        return { done: !!A++ };
      },
      return: function() {
        t = !0;
      }
    };
    n[e] = function() {
      return this;
    }, Array.from(n, function() {
      throw 2;
    });
  } catch {
  }
  return Xp = function(i, s) {
    try {
      if (!s && !t) return !1;
    } catch {
      return !1;
    }
    var a = !1;
    try {
      var o = {};
      o[e] = function() {
        return {
          next: function() {
            return { done: a = !0 };
          }
        };
      }, i(o);
    } catch {
    }
    return a;
  }, Xp;
}
var Yp, Ib;
function HE() {
  if (Ib) return Yp;
  Ib = 1;
  var r = yu(), e = qk(), t = Bu().CONSTRUCTOR;
  return Yp = t || !e(function(A) {
    r.all(A).then(void 0, function() {
    });
  }), Yp;
}
var Qb;
function zk() {
  if (Qb) return bb;
  Qb = 1;
  var r = XA(), e = _A(), t = as(), A = bu(), n = Lv(), i = kE(), s = HE();
  return r({ target: "Promise", stat: !0, forced: s }, {
    all: function(o) {
      var l = this, u = A.f(l), h = u.resolve, f = u.reject, c = n(function() {
        var p = t(l.resolve), g = [], v = 0, w = 1;
        i(o, function(B) {
          var S = v++, C = !1;
          w++, e(p, l, B).then(function(E) {
            C || (C = !0, g[S] = E, --w || h(g));
          }, f);
        }), --w || h(g);
      });
      return c.error && f(c.value), u.promise;
    }
  }), bb;
}
var Lb = {}, Nb;
function Wk() {
  if (Nb) return Lb;
  Nb = 1;
  var r = XA(), e = Si(), t = Bu().CONSTRUCTOR, A = yu(), n = Ha(), i = Wr(), s = Da(), a = A && A.prototype;
  if (r({ target: "Promise", proto: !0, forced: t, real: !0 }, {
    catch: function(l) {
      return this.then(void 0, l);
    }
  }), !e && i(A)) {
    var o = n("Promise").prototype.catch;
    a.catch !== o && s(a, "catch", o, { unsafe: !0 });
  }
  return Lb;
}
var Tb = {}, Pb;
function Xk() {
  if (Pb) return Tb;
  Pb = 1;
  var r = XA(), e = _A(), t = as(), A = bu(), n = Lv(), i = kE(), s = HE();
  return r({ target: "Promise", stat: !0, forced: s }, {
    race: function(o) {
      var l = this, u = A.f(l), h = u.reject, f = n(function() {
        var c = t(l.resolve);
        i(o, function(p) {
          e(c, l, p).then(u.resolve, h);
        });
      });
      return f.error && h(f.value), u.promise;
    }
  }), Tb;
}
var Ob = {}, Mb;
function Yk() {
  if (Mb) return Ob;
  Mb = 1;
  var r = XA(), e = bu(), t = Bu().CONSTRUCTOR;
  return r({ target: "Promise", stat: !0, forced: t }, {
    reject: function(n) {
      var i = e.f(this), s = i.reject;
      return s(n), i.promise;
    }
  }), Ob;
}
var Rb = {}, Jp, kb;
function Jk() {
  if (kb) return Jp;
  kb = 1;
  var r = WA(), e = sn(), t = bu();
  return Jp = function(A, n) {
    if (r(A), e(n) && n.constructor === A) return n;
    var i = t.f(A), s = i.resolve;
    return s(n), i.promise;
  }, Jp;
}
var Hb;
function $k() {
  if (Hb) return Rb;
  Hb = 1;
  var r = XA(), e = Ha(), t = Si(), A = yu(), n = Bu().CONSTRUCTOR, i = Jk(), s = e("Promise"), a = t && !n;
  return r({ target: "Promise", stat: !0, forced: t || n }, {
    resolve: function(l) {
      return i(a && this === s ? A : this, l);
    }
  }), Rb;
}
var Db;
function Zk() {
  return Db || (Db = 1, Gk(), zk(), Wk(), Xk(), Yk(), $k()), _2;
}
Zk();
function Gb(r, e, t, A, n, i, s) {
  try {
    var a = r[i](s), o = a.value;
  } catch (l) {
    return void t(l);
  }
  a.done ? e(o) : Promise.resolve(o).then(A, n);
}
function ns(r) {
  return function() {
    var e = this, t = arguments;
    return new Promise(function(A, n) {
      var i = r.apply(e, t);
      function s(o) {
        Gb(i, A, n, s, a, "next", o);
      }
      function a(o) {
        Gb(i, A, n, s, a, "throw", o);
      }
      s(void 0);
    });
  };
}
var Vb = {}, Kb = {}, $p, jb;
function xi() {
  if (jb) return $p;
  jb = 1;
  var r = Iv(), e = String;
  return $p = function(t) {
    if (r(t) === "Symbol") throw new TypeError("Cannot convert a Symbol value to a string");
    return e(t);
  }, $p;
}
var Zp, qb;
function DE() {
  if (qb) return Zp;
  qb = 1;
  var r = WA();
  return Zp = function() {
    var e = r(this), t = "";
    return e.hasIndices && (t += "d"), e.global && (t += "g"), e.ignoreCase && (t += "i"), e.multiline && (t += "m"), e.dotAll && (t += "s"), e.unicode && (t += "u"), e.unicodeSets && (t += "v"), e.sticky && (t += "y"), t;
  }, Zp;
}
var e0, zb;
function GE() {
  if (zb) return e0;
  zb = 1;
  var r = Tr(), e = Cr(), t = e.RegExp, A = r(function() {
    var s = t("a", "y");
    return s.lastIndex = 2, s.exec("abcd") !== null;
  }), n = A || r(function() {
    return !t("a", "y").sticky;
  }), i = A || r(function() {
    var s = t("^r", "gy");
    return s.lastIndex = 2, s.exec("str") !== null;
  });
  return e0 = {
    BROKEN_CARET: i,
    MISSED_STICKY: n,
    UNSUPPORTED_Y: A
  }, e0;
}
var t0 = {}, r0, Wb;
function e6() {
  if (Wb) return r0;
  Wb = 1;
  var r = _E(), e = Uv();
  return r0 = Object.keys || function(A) {
    return r(A, e);
  }, r0;
}
var Xb;
function t6() {
  if (Xb) return t0;
  Xb = 1;
  var r = si(), e = xE(), t = zs(), A = WA(), n = mu(), i = e6();
  return t0.f = r && !e ? Object.defineProperties : function(a, o) {
    A(a);
    for (var l = n(o), u = i(o), h = u.length, f = 0, c; h > f; ) t.f(a, c = u[f++], l[c]);
    return a;
  }, t0;
}
var A0, Yb;
function of() {
  if (Yb) return A0;
  Yb = 1;
  var r = WA(), e = t6(), t = Uv(), A = Fv(), n = TE(), i = Zh(), s = Ev(), a = ">", o = "<", l = "prototype", u = "script", h = s("IE_PROTO"), f = function() {
  }, c = function(B) {
    return o + u + a + B + o + "/" + u + a;
  }, p = function(B) {
    B.write(c("")), B.close();
    var S = B.parentWindow.Object;
    return B = null, S;
  }, g = function() {
    var B = i("iframe"), S = "java" + u + ":", C;
    return B.style.display = "none", n.appendChild(B), B.src = String(S), C = B.contentWindow.document, C.open(), C.write(c("document.F=Object")), C.close(), C.F;
  }, v, w = function() {
    try {
      v = new ActiveXObject("htmlfile");
    } catch {
    }
    w = typeof document < "u" ? document.domain && v ? p(v) : g() : p(v);
    for (var B = t.length; B--; ) delete w[l][t[B]];
    return w();
  };
  return A[h] = !0, A0 = Object.create || function(S, C) {
    var E;
    return S !== null ? (f[l] = r(S), E = new f(), f[l] = null, E[h] = S) : E = w(), C === void 0 ? E : e.f(E, C);
  }, A0;
}
var n0, Jb;
function r6() {
  if (Jb) return n0;
  Jb = 1;
  var r = Tr(), e = Cr(), t = e.RegExp;
  return n0 = r(function() {
    var A = t(".", "s");
    return !(A.dotAll && A.test(`
`) && A.flags === "s");
  }), n0;
}
var i0, $b;
function A6() {
  if ($b) return i0;
  $b = 1;
  var r = Tr(), e = Cr(), t = e.RegExp;
  return i0 = r(function() {
    var A = t("(?<a>b)", "g");
    return A.exec("b").groups.a !== "b" || "b".replace(A, "$<a>c") !== "bc";
  }), i0;
}
var s0, Zb;
function Nv() {
  if (Zb) return s0;
  Zb = 1;
  var r = _A(), e = Pr(), t = xi(), A = DE(), n = GE(), i = Sv(), s = of(), a = rf().get, o = r6(), l = A6(), u = i("native-string-replace", String.prototype.replace), h = RegExp.prototype.exec, f = h, c = e("".charAt), p = e("".indexOf), g = e("".replace), v = e("".slice), w = (function() {
    var E = /a/, _ = /b*/g;
    return r(h, E, "a"), r(h, _, "a"), E.lastIndex !== 0 || _.lastIndex !== 0;
  })(), B = n.BROKEN_CARET, S = /()??/.exec("")[1] !== void 0, C = w || S || B || o || l;
  return C && (f = function(_) {
    var I = this, O = a(I), U = t(_), V = O.raw, F, P, D, R, J, ie, te;
    if (V)
      return V.lastIndex = I.lastIndex, F = r(f, V, U), I.lastIndex = V.lastIndex, F;
    var $ = O.groups, re = B && I.sticky, ue = r(A, I), se = I.source, T = 0, G = U;
    if (re && (ue = g(ue, "y", ""), p(ue, "g") === -1 && (ue += "g"), G = v(U, I.lastIndex), I.lastIndex > 0 && (!I.multiline || I.multiline && c(U, I.lastIndex - 1) !== `
`) && (se = "(?: " + se + ")", G = " " + G, T++), P = new RegExp("^(?:" + se + ")", ue)), S && (P = new RegExp("^" + se + "$(?!\\s)", ue)), w && (D = I.lastIndex), R = r(h, re ? P : I, G), re ? R ? (R.input = v(R.input, T), R[0] = v(R[0], T), R.index = I.lastIndex, I.lastIndex += R[0].length) : I.lastIndex = 0 : w && R && (I.lastIndex = I.global ? R.index + R[0].length : D), S && R && R.length > 1 && r(u, R[0], P, function() {
      for (J = 1; J < arguments.length - 2; J++)
        arguments[J] === void 0 && (R[J] = void 0);
    }), R && $)
      for (R.groups = ie = s(null), J = 0; J < $.length; J++)
        te = $[J], ie[te[0]] = R[te[1]];
    return R;
  }), s0 = f, s0;
}
var eC;
function n6() {
  if (eC) return Kb;
  eC = 1;
  var r = XA(), e = Nv();
  return r({ target: "RegExp", proto: !0, forced: /./.exec !== e }, {
    exec: e
  }), Kb;
}
var a0, tC;
function Tv() {
  if (tC) return a0;
  tC = 1, n6();
  var r = _A(), e = Da(), t = Nv(), A = Tr(), n = vA(), i = wu(), s = n("species"), a = RegExp.prototype;
  return a0 = function(o, l, u, h) {
    var f = n(o), c = !A(function() {
      var w = {};
      return w[f] = function() {
        return 7;
      }, ""[o](w) !== 7;
    }), p = c && !A(function() {
      var w = !1, B = /a/;
      if (o === "split") {
        var S = {};
        S[s] = function() {
          return B;
        }, B = { constructor: S, flags: "" }, B[f] = /./[f];
      }
      return B.exec = function() {
        return w = !0, null;
      }, B[f](""), !w;
    });
    if (!c || !p || u) {
      var g = /./[f], v = l(f, ""[o], function(w, B, S, C, E) {
        var _ = B.exec;
        return _ === t || _ === a.exec ? c && !E ? { done: !0, value: r(g, B, S, C) } : { done: !0, value: r(w, S, B, C) } : { done: !1 };
      });
      e(String.prototype, o, v[0]), e(a, f, v[1]);
    }
    h && i(a[f], "sham", !0);
  }, a0;
}
var o0, rC;
function i6() {
  if (rC) return o0;
  rC = 1;
  var r = Pr(), e = Af(), t = xi(), A = ai(), n = r("".charAt), i = r("".charCodeAt), s = r("".slice), a = function(o) {
    return function(l, u) {
      var h = t(A(l)), f = e(u), c = h.length, p, g;
      return f < 0 || f >= c ? o ? "" : void 0 : (p = i(h, f), p < 55296 || p > 56319 || f + 1 === c || (g = i(h, f + 1)) < 56320 || g > 57343 ? o ? n(h, f) : p : o ? s(h, f, f + 2) : (p - 55296 << 10) + (g - 56320) + 65536);
    };
  };
  return o0 = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: a(!1),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: a(!0)
  }, o0;
}
var l0, AC;
function Pv() {
  if (AC) return l0;
  AC = 1;
  var r = i6().charAt;
  return l0 = function(e, t, A) {
    return t + (A ? r(e, t).length : 1);
  }, l0;
}
var u0, nC;
function s6() {
  if (nC) return u0;
  nC = 1;
  var r = Cr(), e = Tr(), t = r.RegExp, A = !e(function() {
    var n = !0;
    try {
      t(".", "d");
    } catch {
      n = !1;
    }
    var i = {}, s = "", a = n ? "dgimsy" : "gimsy", o = function(f, c) {
      Object.defineProperty(i, f, { get: function() {
        return s += c, !0;
      } });
    }, l = {
      dotAll: "s",
      global: "g",
      ignoreCase: "i",
      multiline: "m",
      sticky: "y"
    };
    n && (l.hasIndices = "d");
    for (var u in l) o(u, l[u]);
    var h = Object.getOwnPropertyDescriptor(t.prototype, "flags").get.call(i);
    return h !== a || s !== a;
  });
  return u0 = { correct: A }, u0;
}
var c0, iC;
function Ov() {
  if (iC) return c0;
  iC = 1;
  var r = _A(), e = oi(), t = Yh(), A = s6(), n = DE(), i = RegExp.prototype;
  return c0 = A.correct ? function(s) {
    return s.flags;
  } : function(s) {
    return !A.correct && t(i, s) && !e(s, "flags") ? r(n, s) : s.flags;
  }, c0;
}
var h0, sC;
function Mv() {
  if (sC) return h0;
  sC = 1;
  var r = _A(), e = WA(), t = Wr(), A = ka(), n = Nv(), i = TypeError;
  return h0 = function(s, a) {
    var o = s.exec;
    if (t(o)) {
      var l = r(o, s, a);
      return l !== null && e(l), l;
    }
    if (A(s) === "RegExp") return r(n, s, a);
    throw new i("RegExp#exec called on incompatible receiver");
  }, h0;
}
var aC;
function a6() {
  if (aC) return Vb;
  aC = 1;
  var r = _A(), e = Pr(), t = Tv(), A = WA(), n = sn(), i = Mo(), s = xi(), a = ai(), o = Oo(), l = Pv(), u = Ov(), h = Mv(), f = e("".indexOf);
  return t("match", function(c, p, g) {
    return [
      // `String.prototype.match` method
      // https://tc39.es/ecma262/#sec-string.prototype.match
      function(w) {
        var B = a(this), S = n(w) ? o(w, c) : void 0;
        return S ? r(S, w, B) : new RegExp(w)[c](s(B));
      },
      // `RegExp.prototype[@@match]` method
      // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
      function(v) {
        var w = A(this), B = s(v), S = g(p, w, B);
        if (S.done) return S.value;
        var C = s(u(w));
        if (f(C, "g") === -1) return h(w, B);
        var E = f(C, "u") !== -1;
        w.lastIndex = 0;
        for (var _ = [], I = 0, O; (O = h(w, B)) !== null; ) {
          var U = s(O[0]);
          _[I] = U, U === "" && (w.lastIndex = l(B, i(w.lastIndex), E)), I++;
        }
        return I === 0 ? null : _;
      }
    ];
  }), Vb;
}
a6();
var oC = {}, f0, lC;
function o6() {
  if (lC) return f0;
  lC = 1;
  var r = Pr(), e = $h(), t = Math.floor, A = r("".charAt), n = r("".replace), i = r("".slice), s = /\$([$&'`]|\d{1,2}|<[^>]*>)/g, a = /\$([$&'`]|\d{1,2})/g;
  return f0 = function(o, l, u, h, f, c) {
    var p = u + o.length, g = h.length, v = a;
    return f !== void 0 && (f = e(f), v = s), n(c, v, function(w, B) {
      var S;
      switch (A(B, 0)) {
        case "$":
          return "$";
        case "&":
          return o;
        case "`":
          return i(l, 0, u);
        case "'":
          return i(l, p);
        case "<":
          S = f[i(B, 1, -1)];
          break;
        default:
          var C = +B;
          if (C === 0) return w;
          if (C > g) {
            var E = t(C / 10);
            return E === 0 ? w : E <= g ? h[E - 1] === void 0 ? A(B, 1) : h[E - 1] + A(B, 1) : w;
          }
          S = h[C - 1];
      }
      return S === void 0 ? "" : S;
    });
  }, f0;
}
var uC;
function l6() {
  if (uC) return oC;
  uC = 1;
  var r = NE(), e = _A(), t = Pr(), A = Tv(), n = Tr(), i = WA(), s = Wr(), a = sn(), o = Af(), l = Mo(), u = xi(), h = ai(), f = Pv(), c = Oo(), p = o6(), g = Ov(), v = Mv(), w = vA(), B = w("replace"), S = Math.max, C = Math.min, E = t([].concat), _ = t([].push), I = t("".indexOf), O = t("".slice), U = function(D) {
    return D === void 0 ? D : String(D);
  }, V = (function() {
    return "a".replace(/./, "$0") === "$0";
  })(), F = (function() {
    return /./[B] ? /./[B]("a", "$0") === "" : !1;
  })(), P = !n(function() {
    var D = /./;
    return D.exec = function() {
      var R = [];
      return R.groups = { a: "7" }, R;
    }, "".replace(D, "$<a>") !== "7";
  });
  return A("replace", function(D, R, J) {
    var ie = F ? "$" : "$0";
    return [
      // `String.prototype.replace` method
      // https://tc39.es/ecma262/#sec-string.prototype.replace
      function($, re) {
        var ue = h(this), se = a($) ? c($, B) : void 0;
        return se ? e(se, $, ue, re) : e(R, u(ue), $, re);
      },
      // `RegExp.prototype[@@replace]` method
      // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
      function(te, $) {
        var re = i(this), ue = u(te);
        if (typeof $ == "string" && I($, ie) === -1 && I($, "$<") === -1) {
          var se = J(R, re, ue, $);
          if (se.done) return se.value;
        }
        var T = s($);
        T || ($ = u($));
        var G = u(g(re)), X = I(G, "g") !== -1, Y;
        X && (Y = I(G, "u") !== -1, re.lastIndex = 0);
        for (var ee = [], oe; oe = v(re, ue), !(oe === null || (_(ee, oe), !X)); ) {
          var ge = u(oe[0]);
          ge === "" && (re.lastIndex = f(ue, l(re.lastIndex), Y));
        }
        for (var pe = "", me = 0, Ee = 0; Ee < ee.length; Ee++) {
          oe = ee[Ee];
          for (var Ne = u(oe[0]), Te = S(C(o(oe.index), ue.length), 0), Ge = [], j, Pe = 1; Pe < oe.length; Pe++) _(Ge, U(oe[Pe]));
          var ft = oe.groups;
          if (T) {
            var et = E([Ne], Ge, Te, ue);
            ft !== void 0 && _(et, ft), j = u(r($, void 0, et));
          } else
            j = p(Ne, ue, Te, Ge, ft, $);
          Te >= me && (pe += O(ue, me, Te) + j, me = Te + Ne.length);
        }
        return pe + O(ue, me);
      }
    ];
  }, !P || !V || F), oC;
}
l6();
var cC = {}, d0, hC;
function u6() {
  if (hC) return d0;
  hC = 1;
  var r = sn(), e = ka(), t = vA(), A = t("match");
  return d0 = function(n) {
    var i;
    return r(n) && ((i = n[A]) !== void 0 ? !!i : e(n) === "RegExp");
  }, d0;
}
var g0, fC;
function Rv() {
  if (fC) return g0;
  fC = 1;
  var r = u6(), e = TypeError;
  return g0 = function(t) {
    if (r(t))
      throw new e("The method doesn't accept regular expressions");
    return t;
  }, g0;
}
var p0, dC;
function kv() {
  if (dC) return p0;
  dC = 1;
  var r = vA(), e = r("match");
  return p0 = function(t) {
    var A = /./;
    try {
      "/./"[t](A);
    } catch {
      try {
        return A[e] = !1, "/./"[t](A);
      } catch {
      }
    }
    return !1;
  }, p0;
}
var gC;
function c6() {
  if (gC) return cC;
  gC = 1;
  var r = XA(), e = af(), t = ef().f, A = Mo(), n = xi(), i = Rv(), s = ai(), a = kv(), o = Si(), l = e("".slice), u = Math.min, h = a("startsWith"), f = !o && !h && !!(function() {
    var c = t(String.prototype, "startsWith");
    return c && !c.writable;
  })();
  return r({ target: "String", proto: !0, forced: !f && !h }, {
    startsWith: function(p) {
      var g = n(s(this));
      i(p);
      var v = A(u(arguments.length > 1 ? arguments[1] : void 0, g.length)), w = n(p);
      return l(g, v, v + w.length) === w;
    }
  }), cC;
}
c6();
var m0, pC;
function h6() {
  if (pC) return m0;
  pC = 1;
  var r = vA(), e = of(), t = zs().f, A = r("unscopables"), n = Array.prototype;
  return n[A] === void 0 && t(n, A, {
    configurable: !0,
    value: e(null)
  }), m0 = function(i) {
    n[A][i] = !0;
  }, m0;
}
var v0, mC;
function f6() {
  if (mC) return v0;
  mC = 1;
  var r = Tr();
  return v0 = !r(function() {
    function e() {
    }
    return e.prototype.constructor = null, Object.getPrototypeOf(new e()) !== e.prototype;
  }), v0;
}
var w0, vC;
function VE() {
  if (vC) return w0;
  vC = 1;
  var r = oi(), e = Wr(), t = $h(), A = Ev(), n = f6(), i = A("IE_PROTO"), s = Object, a = s.prototype;
  return w0 = n ? s.getPrototypeOf : function(o) {
    var l = t(o);
    if (r(l, i)) return l[i];
    var u = l.constructor;
    return e(u) && l instanceof u ? u.prototype : l instanceof s ? a : null;
  }, w0;
}
var y0, wC;
function KE() {
  if (wC) return y0;
  wC = 1;
  var r = Tr(), e = Wr(), t = sn(), A = of(), n = VE(), i = Da(), s = vA(), a = Si(), o = s("iterator"), l = !1, u, h, f;
  [].keys && (f = [].keys(), "next" in f ? (h = n(n(f)), h !== Object.prototype && (u = h)) : l = !0);
  var c = !t(u) || r(function() {
    var p = {};
    return u[o].call(p) !== p;
  });
  return c ? u = {} : a && (u = A(u)), e(u[o]) || i(u, o, function() {
    return this;
  }), y0 = {
    IteratorPrototype: u,
    BUGGY_SAFARI_ITERATORS: l
  }, y0;
}
var B0, yC;
function d6() {
  if (yC) return B0;
  yC = 1;
  var r = KE().IteratorPrototype, e = of(), t = yv(), A = sf(), n = Cu(), i = function() {
    return this;
  };
  return B0 = function(s, a, o, l) {
    var u = a + " Iterator";
    return s.prototype = e(r, { next: t(+!l, o) }), A(s, u, !1, !0), n[u] = i, s;
  }, B0;
}
var b0, BC;
function g6() {
  if (BC) return b0;
  BC = 1;
  var r = XA(), e = _A(), t = Si(), A = tf(), n = Wr(), i = d6(), s = VE(), a = QE(), o = sf(), l = wu(), u = Da(), h = vA(), f = Cu(), c = KE(), p = A.PROPER, g = A.CONFIGURABLE, v = c.IteratorPrototype, w = c.BUGGY_SAFARI_ITERATORS, B = h("iterator"), S = "keys", C = "values", E = "entries", _ = function() {
    return this;
  };
  return b0 = function(I, O, U, V, F, P, D) {
    i(U, O, V);
    var R = function(X) {
      if (X === F && re) return re;
      if (!w && X && X in te) return te[X];
      switch (X) {
        case S:
          return function() {
            return new U(this, X);
          };
        case C:
          return function() {
            return new U(this, X);
          };
        case E:
          return function() {
            return new U(this, X);
          };
      }
      return function() {
        return new U(this);
      };
    }, J = O + " Iterator", ie = !1, te = I.prototype, $ = te[B] || te["@@iterator"] || F && te[F], re = !w && $ || R(F), ue = O === "Array" && te.entries || $, se, T, G;
    if (ue && (se = s(ue.call(new I())), se !== Object.prototype && se.next && (!t && s(se) !== v && (a ? a(se, v) : n(se[B]) || u(se, B, _)), o(se, J, !0, !0), t && (f[J] = _))), p && F === C && $ && $.name !== C && (!t && g ? l(te, "name", C) : (ie = !0, re = function() {
      return e($, this);
    })), F)
      if (T = {
        values: R(C),
        keys: P ? re : R(S),
        entries: R(E)
      }, D) for (G in T)
        (w || ie || !(G in te)) && u(te, G, T[G]);
      else r({ target: O, proto: !0, forced: w || ie }, T);
    return (!t || D) && te[B] !== re && u(te, B, re, { name: F }), f[O] = re, T;
  }, b0;
}
var C0, bC;
function p6() {
  return bC || (bC = 1, C0 = function(r, e) {
    return { value: r, done: e };
  }), C0;
}
var S0, CC;
function jE() {
  if (CC) return S0;
  CC = 1;
  var r = mu(), e = h6(), t = Cu(), A = rf(), n = zs().f, i = g6(), s = p6(), a = Si(), o = si(), l = "Array Iterator", u = A.set, h = A.getterFor(l);
  S0 = i(Array, "Array", function(c, p) {
    u(this, {
      type: l,
      target: r(c),
      // target
      index: 0,
      // next index
      kind: p
      // kind
    });
  }, function() {
    var c = h(this), p = c.target, g = c.index++;
    if (!p || g >= p.length)
      return c.target = null, s(void 0, !0);
    switch (c.kind) {
      case "keys":
        return s(g, !1);
      case "values":
        return s(p[g], !1);
    }
    return s([g, p[g]], !1);
  }, "values");
  var f = t.Arguments = t.Array;
  if (e("keys"), e("values"), e("entries"), !a && o && f.name !== "values") try {
    n(f, "name", { value: "values" });
  } catch {
  }
  return S0;
}
jE();
var SC = {}, x0, xC;
function m6() {
  return xC || (xC = 1, x0 = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
  }), x0;
}
var E0, EC;
function v6() {
  if (EC) return E0;
  EC = 1;
  var r = Zh(), e = r("span").classList, t = e && e.constructor && e.constructor.prototype;
  return E0 = t === Object.prototype ? void 0 : t, E0;
}
var FC;
function w6() {
  if (FC) return SC;
  FC = 1;
  var r = Cr(), e = m6(), t = v6(), A = jE(), n = wu(), i = sf(), s = vA(), a = s("iterator"), o = A.values, l = function(h, f) {
    if (h) {
      if (h[a] !== o) try {
        n(h, a, o);
      } catch {
        h[a] = o;
      }
      if (i(h, f, !0), e[f]) {
        for (var c in A)
          if (h[c] !== A[c]) try {
            n(h, c, A[c]);
          } catch {
            h[c] = A[c];
          }
      }
    }
  };
  for (var u in e)
    l(r[u] && r[u].prototype, u);
  return l(t, "DOMTokenList"), SC;
}
w6();
function y6(r, e) {
  if (jt(r) != "object" || !r) return r;
  var t = r[Symbol.toPrimitive];
  if (t !== void 0) {
    var A = t.call(r, e);
    if (jt(A) != "object") return A;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(r);
}
function B6(r) {
  var e = y6(r, "string");
  return jt(e) == "symbol" ? e : e + "";
}
function Hv(r, e, t) {
  return (e = B6(e)) in r ? Object.defineProperty(r, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : r[e] = t, r;
}
var _C = {}, F0, UC;
function b6() {
  if (UC) return F0;
  UC = 1;
  var r = as(), e = $h(), t = vE(), A = _v(), n = TypeError, i = "Reduce of empty array with no initial value", s = function(a) {
    return function(o, l, u, h) {
      var f = e(o), c = t(f), p = A(f);
      if (r(l), p === 0 && u < 2) throw new n(i);
      var g = a ? p - 1 : 0, v = a ? -1 : 1;
      if (u < 2) for (; ; ) {
        if (g in c) {
          h = c[g], g += v;
          break;
        }
        if (g += v, a ? g < 0 : p <= g)
          throw new n(i);
      }
      for (; a ? g >= 0 : p > g; g += v) g in c && (h = l(h, c[g], g, f));
      return h;
    };
  };
  return F0 = {
    // `Array.prototype.reduce` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduce
    left: s(!1),
    // `Array.prototype.reduceRight` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduceright
    right: s(!0)
  }, F0;
}
var _0, IC;
function qE() {
  if (IC) return _0;
  IC = 1;
  var r = Tr();
  return _0 = function(e, t) {
    var A = [][e];
    return !!A && r(function() {
      A.call(null, t || function() {
        return 1;
      }, 1);
    });
  }, _0;
}
var QC;
function C6() {
  if (QC) return _C;
  QC = 1;
  var r = XA(), e = b6().left, t = qE(), A = Bv(), n = nf(), i = !n && A > 79 && A < 83, s = i || !t("reduce");
  return r({ target: "Array", proto: !0, forced: s }, {
    reduce: function(o) {
      var l = arguments.length;
      return e(this, o, l, l > 1 ? arguments[1] : void 0);
    }
  }), _C;
}
C6();
var LC = {}, NC;
function S6() {
  if (NC) return LC;
  NC = 1;
  var r = XA(), e = af(), t = ef().f, A = Mo(), n = xi(), i = Rv(), s = ai(), a = kv(), o = Si(), l = e("".slice), u = Math.min, h = a("endsWith"), f = !o && !h && !!(function() {
    var c = t(String.prototype, "endsWith");
    return c && !c.writable;
  })();
  return r({ target: "String", proto: !0, forced: !f && !h }, {
    endsWith: function(p) {
      var g = n(s(this));
      i(p);
      var v = arguments.length > 1 ? arguments[1] : void 0, w = g.length, B = v === void 0 ? w : u(A(v), w), S = n(p);
      return l(g, B - S.length, B) === S;
    }
  }), LC;
}
S6();
var TC = {}, PC;
function x6() {
  if (PC) return TC;
  PC = 1;
  var r = _A(), e = Pr(), t = Tv(), A = WA(), n = sn(), i = ai(), s = LE(), a = Pv(), o = Mo(), l = xi(), u = Oo(), h = Mv(), f = GE(), c = Tr(), p = f.UNSUPPORTED_Y, g = 4294967295, v = Math.min, w = e([].push), B = e("".slice), S = !c(function() {
    var E = /(?:)/, _ = E.exec;
    E.exec = function() {
      return _.apply(this, arguments);
    };
    var I = "ab".split(E);
    return I.length !== 2 || I[0] !== "a" || I[1] !== "b";
  }), C = "abbc".split(/(b)*/)[1] === "c" || // eslint-disable-next-line regexp/no-empty-group -- required for testing
  "test".split(/(?:)/, -1).length !== 4 || "ab".split(/(?:ab)*/).length !== 2 || ".".split(/(.?)(.?)/).length !== 4 || // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
  ".".split(/()()/).length > 1 || "".split(/.?/).length;
  return t("split", function(E, _, I) {
    var O = "0".split(void 0, 0).length ? function(U, V) {
      return U === void 0 && V === 0 ? [] : r(_, this, U, V);
    } : _;
    return [
      // `String.prototype.split` method
      // https://tc39.es/ecma262/#sec-string.prototype.split
      function(V, F) {
        var P = i(this), D = n(V) ? u(V, E) : void 0;
        return D ? r(D, V, P, F) : r(O, l(P), V, F);
      },
      // `RegExp.prototype[@@split]` method
      // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
      //
      // NOTE: This cannot be properly polyfilled in engines that don't support
      // the 'y' flag.
      function(U, V) {
        var F = A(this), P = l(U);
        if (!C) {
          var D = I(O, F, P, V, O !== _);
          if (D.done) return D.value;
        }
        var R = s(F, RegExp), J = F.unicode, ie = (F.ignoreCase ? "i" : "") + (F.multiline ? "m" : "") + (F.unicode ? "u" : "") + (p ? "g" : "y"), te = new R(p ? "^(?:" + F.source + ")" : F, ie), $ = V === void 0 ? g : V >>> 0;
        if ($ === 0) return [];
        if (P.length === 0) return h(te, P) === null ? [P] : [];
        for (var re = 0, ue = 0, se = []; ue < P.length; ) {
          te.lastIndex = p ? 0 : ue;
          var T = h(te, p ? B(P, ue) : P), G;
          if (T === null || (G = v(o(te.lastIndex + (p ? ue : 0)), P.length)) === re)
            ue = a(P, ue, J);
          else {
            if (w(se, B(P, re, ue)), se.length === $) return se;
            for (var X = 1; X <= T.length - 1; X++)
              if (w(se, T[X]), se.length === $) return se;
            ue = re = G;
          }
        }
        return w(se, B(P, re)), se;
      }
    ];
  }, C || !S, p), TC;
}
x6();
var bl = { exports: {} }, ma = { exports: {} }, E6 = ma.exports, OC;
function F6() {
  return OC || (OC = 1, (function() {
    var r, e, t, A, n, i;
    typeof performance < "u" && performance !== null && performance.now ? ma.exports = function() {
      return performance.now();
    } : typeof process < "u" && process !== null && process.hrtime ? (ma.exports = function() {
      return (r() - n) / 1e6;
    }, e = process.hrtime, r = function() {
      var s;
      return s = e(), s[0] * 1e9 + s[1];
    }, A = r(), i = process.uptime() * 1e9, n = A - i) : Date.now ? (ma.exports = function() {
      return Date.now() - t;
    }, t = Date.now()) : (ma.exports = function() {
      return (/* @__PURE__ */ new Date()).getTime() - t;
    }, t = (/* @__PURE__ */ new Date()).getTime());
  }).call(E6)), ma.exports;
}
var MC;
function _6() {
  if (MC) return bl.exports;
  MC = 1;
  for (var r = F6(), e = typeof window > "u" ? tm : window, t = ["moz", "webkit"], A = "AnimationFrame", n = e["request" + A], i = e["cancel" + A] || e["cancelRequest" + A], s = 0; !n && s < t.length; s++)
    n = e[t[s] + "Request" + A], i = e[t[s] + "Cancel" + A] || e[t[s] + "CancelRequest" + A];
  if (!n || !i) {
    var a = 0, o = 0, l = [], u = 1e3 / 60;
    n = function(h) {
      if (l.length === 0) {
        var f = r(), c = Math.max(0, u - (f - a));
        a = c + f, setTimeout(function() {
          var p = l.slice(0);
          l.length = 0;
          for (var g = 0; g < p.length; g++)
            if (!p[g].cancelled)
              try {
                p[g].callback(a);
              } catch (v) {
                setTimeout(function() {
                  throw v;
                }, 0);
              }
        }, Math.round(c));
      }
      return l.push({
        handle: ++o,
        callback: h,
        cancelled: !1
      }), o;
    }, i = function(h) {
      for (var f = 0; f < l.length; f++)
        l[f].handle === h && (l[f].cancelled = !0);
    };
  }
  return bl.exports = function(h) {
    return n.call(e, h);
  }, bl.exports.cancel = function() {
    i.apply(e, arguments);
  }, bl.exports.polyfill = function(h) {
    h || (h = e), h.requestAnimationFrame = n, h.cancelAnimationFrame = i;
  }, bl.exports;
}
var U6 = _6();
const U0 = /* @__PURE__ */ uu(U6);
var RC = {}, I0, kC;
function zE() {
  return kC || (kC = 1, I0 = `	
\v\f\r                　\u2028\u2029\uFEFF`), I0;
}
var Q0, HC;
function I6() {
  if (HC) return Q0;
  HC = 1;
  var r = Pr(), e = ai(), t = xi(), A = zE(), n = r("".replace), i = RegExp("^[" + A + "]+"), s = RegExp("(^|[^" + A + "])[" + A + "]+$"), a = function(o) {
    return function(l) {
      var u = t(e(l));
      return o & 1 && (u = n(u, i, "")), o & 2 && (u = n(u, s, "$1")), u;
    };
  };
  return Q0 = {
    // `String.prototype.{ trimLeft, trimStart }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimstart
    start: a(1),
    // `String.prototype.{ trimRight, trimEnd }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimend
    end: a(2),
    // `String.prototype.trim` method
    // https://tc39.es/ecma262/#sec-string.prototype.trim
    trim: a(3)
  }, Q0;
}
var L0, DC;
function Q6() {
  if (DC) return L0;
  DC = 1;
  var r = tf().PROPER, e = Tr(), t = zE(), A = "​᠎";
  return L0 = function(n) {
    return e(function() {
      return !!t[n]() || A[n]() !== A || r && t[n].name !== n;
    });
  }, L0;
}
var GC;
function L6() {
  if (GC) return RC;
  GC = 1;
  var r = XA(), e = I6().trim, t = Q6();
  return r({ target: "String", proto: !0, forced: t("trim") }, {
    trim: function() {
      return e(this);
    }
  }), RC;
}
L6();
var N0, VC;
function N6() {
  return VC || (VC = 1, N0 = function(r) {
    this.ok = !1, this.alpha = 1, r.charAt(0) == "#" && (r = r.substr(1, 6)), r = r.replace(/ /g, ""), r = r.toLowerCase();
    var e = {
      aliceblue: "f0f8ff",
      antiquewhite: "faebd7",
      aqua: "00ffff",
      aquamarine: "7fffd4",
      azure: "f0ffff",
      beige: "f5f5dc",
      bisque: "ffe4c4",
      black: "000000",
      blanchedalmond: "ffebcd",
      blue: "0000ff",
      blueviolet: "8a2be2",
      brown: "a52a2a",
      burlywood: "deb887",
      cadetblue: "5f9ea0",
      chartreuse: "7fff00",
      chocolate: "d2691e",
      coral: "ff7f50",
      cornflowerblue: "6495ed",
      cornsilk: "fff8dc",
      crimson: "dc143c",
      cyan: "00ffff",
      darkblue: "00008b",
      darkcyan: "008b8b",
      darkgoldenrod: "b8860b",
      darkgray: "a9a9a9",
      darkgreen: "006400",
      darkkhaki: "bdb76b",
      darkmagenta: "8b008b",
      darkolivegreen: "556b2f",
      darkorange: "ff8c00",
      darkorchid: "9932cc",
      darkred: "8b0000",
      darksalmon: "e9967a",
      darkseagreen: "8fbc8f",
      darkslateblue: "483d8b",
      darkslategray: "2f4f4f",
      darkturquoise: "00ced1",
      darkviolet: "9400d3",
      deeppink: "ff1493",
      deepskyblue: "00bfff",
      dimgray: "696969",
      dodgerblue: "1e90ff",
      feldspar: "d19275",
      firebrick: "b22222",
      floralwhite: "fffaf0",
      forestgreen: "228b22",
      fuchsia: "ff00ff",
      gainsboro: "dcdcdc",
      ghostwhite: "f8f8ff",
      gold: "ffd700",
      goldenrod: "daa520",
      gray: "808080",
      green: "008000",
      greenyellow: "adff2f",
      honeydew: "f0fff0",
      hotpink: "ff69b4",
      indianred: "cd5c5c",
      indigo: "4b0082",
      ivory: "fffff0",
      khaki: "f0e68c",
      lavender: "e6e6fa",
      lavenderblush: "fff0f5",
      lawngreen: "7cfc00",
      lemonchiffon: "fffacd",
      lightblue: "add8e6",
      lightcoral: "f08080",
      lightcyan: "e0ffff",
      lightgoldenrodyellow: "fafad2",
      lightgrey: "d3d3d3",
      lightgreen: "90ee90",
      lightpink: "ffb6c1",
      lightsalmon: "ffa07a",
      lightseagreen: "20b2aa",
      lightskyblue: "87cefa",
      lightslateblue: "8470ff",
      lightslategray: "778899",
      lightsteelblue: "b0c4de",
      lightyellow: "ffffe0",
      lime: "00ff00",
      limegreen: "32cd32",
      linen: "faf0e6",
      magenta: "ff00ff",
      maroon: "800000",
      mediumaquamarine: "66cdaa",
      mediumblue: "0000cd",
      mediumorchid: "ba55d3",
      mediumpurple: "9370d8",
      mediumseagreen: "3cb371",
      mediumslateblue: "7b68ee",
      mediumspringgreen: "00fa9a",
      mediumturquoise: "48d1cc",
      mediumvioletred: "c71585",
      midnightblue: "191970",
      mintcream: "f5fffa",
      mistyrose: "ffe4e1",
      moccasin: "ffe4b5",
      navajowhite: "ffdead",
      navy: "000080",
      oldlace: "fdf5e6",
      olive: "808000",
      olivedrab: "6b8e23",
      orange: "ffa500",
      orangered: "ff4500",
      orchid: "da70d6",
      palegoldenrod: "eee8aa",
      palegreen: "98fb98",
      paleturquoise: "afeeee",
      palevioletred: "d87093",
      papayawhip: "ffefd5",
      peachpuff: "ffdab9",
      peru: "cd853f",
      pink: "ffc0cb",
      plum: "dda0dd",
      powderblue: "b0e0e6",
      purple: "800080",
      rebeccapurple: "663399",
      red: "ff0000",
      rosybrown: "bc8f8f",
      royalblue: "4169e1",
      saddlebrown: "8b4513",
      salmon: "fa8072",
      sandybrown: "f4a460",
      seagreen: "2e8b57",
      seashell: "fff5ee",
      sienna: "a0522d",
      silver: "c0c0c0",
      skyblue: "87ceeb",
      slateblue: "6a5acd",
      slategray: "708090",
      snow: "fffafa",
      springgreen: "00ff7f",
      steelblue: "4682b4",
      tan: "d2b48c",
      teal: "008080",
      thistle: "d8bfd8",
      tomato: "ff6347",
      turquoise: "40e0d0",
      violet: "ee82ee",
      violetred: "d02090",
      wheat: "f5deb3",
      white: "ffffff",
      whitesmoke: "f5f5f5",
      yellow: "ffff00",
      yellowgreen: "9acd32"
    };
    r = e[r] || r;
    for (var t = [
      {
        re: /^rgba\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3}),\s*((?:\d?\.)?\d)\)$/,
        example: ["rgba(123, 234, 45, 0.8)", "rgba(255,234,245,1.0)"],
        process: function(o) {
          return [
            parseInt(o[1]),
            parseInt(o[2]),
            parseInt(o[3]),
            parseFloat(o[4])
          ];
        }
      },
      {
        re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
        example: ["rgb(123, 234, 45)", "rgb(255,234,245)"],
        process: function(o) {
          return [
            parseInt(o[1]),
            parseInt(o[2]),
            parseInt(o[3])
          ];
        }
      },
      {
        re: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        example: ["#00ff00", "336699"],
        process: function(o) {
          return [
            parseInt(o[1], 16),
            parseInt(o[2], 16),
            parseInt(o[3], 16)
          ];
        }
      },
      {
        re: /^([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        example: ["#fb0", "f0f"],
        process: function(o) {
          return [
            parseInt(o[1] + o[1], 16),
            parseInt(o[2] + o[2], 16),
            parseInt(o[3] + o[3], 16)
          ];
        }
      }
    ], A = 0; A < t.length; A++) {
      var n = t[A].re, i = t[A].process, s = n.exec(r);
      if (s) {
        var a = i(s);
        this.r = a[0], this.g = a[1], this.b = a[2], a.length > 3 && (this.alpha = a[3]), this.ok = !0;
      }
    }
    this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b, this.alpha = this.alpha < 0 ? 0 : this.alpha > 1 || isNaN(this.alpha) ? 1 : this.alpha, this.toRGB = function() {
      return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
    }, this.toRGBA = function() {
      return "rgba(" + this.r + ", " + this.g + ", " + this.b + ", " + this.alpha + ")";
    }, this.toHex = function() {
      var o = this.r.toString(16), l = this.g.toString(16), u = this.b.toString(16);
      return o.length == 1 && (o = "0" + o), l.length == 1 && (l = "0" + l), u.length == 1 && (u = "0" + u), "#" + o + l + u;
    }, this.getHelpXML = function() {
      for (var o = new Array(), l = 0; l < t.length; l++)
        for (var u = t[l].example, h = 0; h < u.length; h++)
          o[o.length] = u[h];
      for (var f in e)
        o[o.length] = f;
      var c = document.createElement("ul");
      c.setAttribute("id", "rgbcolor-examples");
      for (var l = 0; l < o.length; l++)
        try {
          var p = document.createElement("li"), g = new RGBColor(o[l]), v = document.createElement("div");
          v.style.cssText = "margin: 3px; border: 1px solid black; background:" + g.toHex() + "; color:" + g.toHex(), v.appendChild(document.createTextNode("test"));
          var w = document.createTextNode(
            " " + o[l] + " -> " + g.toRGB() + " -> " + g.toHex()
          );
          p.appendChild(v), p.appendChild(w), c.appendChild(p);
        } catch {
        }
      return c;
    };
  }), N0;
}
var T6 = N6();
const Im = /* @__PURE__ */ uu(T6);
var KC = {}, jC;
function P6() {
  if (jC) return KC;
  jC = 1;
  var r = XA(), e = af(), t = FE().indexOf, A = qE(), n = e([].indexOf), i = !!n && 1 / n([1], 1, -0) < 0, s = i || !A("indexOf");
  return r({ target: "Array", proto: !0, forced: s }, {
    indexOf: function(o) {
      var l = arguments.length > 1 ? arguments[1] : void 0;
      return i ? n(this, o, l) || 0 : t(this, o, l);
    }
  }), KC;
}
P6();
var qC = {}, zC;
function O6() {
  if (zC) return qC;
  zC = 1;
  var r = XA(), e = Pr(), t = Rv(), A = ai(), n = xi(), i = kv(), s = e("".indexOf);
  return r({ target: "String", proto: !0, forced: !i("includes") }, {
    includes: function(o) {
      return !!~s(
        n(A(this)),
        n(t(o)),
        arguments.length > 1 ? arguments[1] : void 0
      );
    }
  }), qC;
}
O6();
var WC = {}, T0, XC;
function M6() {
  if (XC) return T0;
  XC = 1;
  var r = ka();
  return T0 = Array.isArray || function(t) {
    return r(t) === "Array";
  }, T0;
}
var YC;
function R6() {
  if (YC) return WC;
  YC = 1;
  var r = XA(), e = Pr(), t = M6(), A = e([].reverse), n = [1, 2];
  return r({ target: "Array", proto: !0, forced: String(n) === String(n.reverse()) }, {
    reverse: function() {
      return t(this) && (this.length = this.length), A(this);
    }
  }), WC;
}
R6();
var WE = function(r, e) {
  return (WE = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, A) {
    t.__proto__ = A;
  } || function(t, A) {
    for (var n in A) Object.prototype.hasOwnProperty.call(A, n) && (t[n] = A[n]);
  })(r, e);
};
function XE(r, e) {
  if (typeof e != "function" && e !== null) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  function t() {
    this.constructor = r;
  }
  WE(r, e), r.prototype = e === null ? Object.create(e) : (t.prototype = e.prototype, new t());
}
function k6(r) {
  var e = "";
  Array.isArray(r) || (r = [r]);
  for (var t = 0; t < r.length; t++) {
    var A = r[t];
    if (A.type === Ue.CLOSE_PATH) e += "z";
    else if (A.type === Ue.HORIZ_LINE_TO) e += (A.relative ? "h" : "H") + A.x;
    else if (A.type === Ue.VERT_LINE_TO) e += (A.relative ? "v" : "V") + A.y;
    else if (A.type === Ue.MOVE_TO) e += (A.relative ? "m" : "M") + A.x + " " + A.y;
    else if (A.type === Ue.LINE_TO) e += (A.relative ? "l" : "L") + A.x + " " + A.y;
    else if (A.type === Ue.CURVE_TO) e += (A.relative ? "c" : "C") + A.x1 + " " + A.y1 + " " + A.x2 + " " + A.y2 + " " + A.x + " " + A.y;
    else if (A.type === Ue.SMOOTH_CURVE_TO) e += (A.relative ? "s" : "S") + A.x2 + " " + A.y2 + " " + A.x + " " + A.y;
    else if (A.type === Ue.QUAD_TO) e += (A.relative ? "q" : "Q") + A.x1 + " " + A.y1 + " " + A.x + " " + A.y;
    else if (A.type === Ue.SMOOTH_QUAD_TO) e += (A.relative ? "t" : "T") + A.x + " " + A.y;
    else {
      if (A.type !== Ue.ARC) throw new Error('Unexpected command type "' + A.type + '" at index ' + t + ".");
      e += (A.relative ? "a" : "A") + A.rX + " " + A.rY + " " + A.xRot + " " + +A.lArcFlag + " " + +A.sweepFlag + " " + A.x + " " + A.y;
    }
  }
  return e;
}
function Qm(r, e) {
  var t = r[0], A = r[1];
  return [t * Math.cos(e) - A * Math.sin(e), t * Math.sin(e) + A * Math.cos(e)];
}
function Zn() {
  for (var r = [], e = 0; e < arguments.length; e++) r[e] = arguments[e];
  for (var t = 0; t < r.length; t++) if (typeof r[t] != "number") throw new Error("assertNumbers arguments[" + t + "] is not a number. " + typeof r[t] + " == typeof " + r[t]);
  return !0;
}
var Is = Math.PI;
function P0(r, e, t) {
  r.lArcFlag = r.lArcFlag === 0 ? 0 : 1, r.sweepFlag = r.sweepFlag === 0 ? 0 : 1;
  var A = r.rX, n = r.rY, i = r.x, s = r.y;
  A = Math.abs(r.rX), n = Math.abs(r.rY);
  var a = Qm([(e - i) / 2, (t - s) / 2], -r.xRot / 180 * Is), o = a[0], l = a[1], u = Math.pow(o, 2) / Math.pow(A, 2) + Math.pow(l, 2) / Math.pow(n, 2);
  1 < u && (A *= Math.sqrt(u), n *= Math.sqrt(u)), r.rX = A, r.rY = n;
  var h = Math.pow(A, 2) * Math.pow(l, 2) + Math.pow(n, 2) * Math.pow(o, 2), f = (r.lArcFlag !== r.sweepFlag ? 1 : -1) * Math.sqrt(Math.max(0, (Math.pow(A, 2) * Math.pow(n, 2) - h) / h)), c = A * l / n * f, p = -n * o / A * f, g = Qm([c, p], r.xRot / 180 * Is);
  r.cX = g[0] + (e + i) / 2, r.cY = g[1] + (t + s) / 2, r.phi1 = Math.atan2((l - p) / n, (o - c) / A), r.phi2 = Math.atan2((-l - p) / n, (-o - c) / A), r.sweepFlag === 0 && r.phi2 > r.phi1 && (r.phi2 -= 2 * Is), r.sweepFlag === 1 && r.phi2 < r.phi1 && (r.phi2 += 2 * Is), r.phi1 *= 180 / Is, r.phi2 *= 180 / Is;
}
function JC(r, e, t) {
  Zn(r, e, t);
  var A = r * r + e * e - t * t;
  if (0 > A) return [];
  if (A === 0) return [[r * t / (r * r + e * e), e * t / (r * r + e * e)]];
  var n = Math.sqrt(A);
  return [[(r * t + e * n) / (r * r + e * e), (e * t - r * n) / (r * r + e * e)], [(r * t - e * n) / (r * r + e * e), (e * t + r * n) / (r * r + e * e)]];
}
var tA, zi = Math.PI / 180;
function $C(r, e, t) {
  return (1 - t) * r + t * e;
}
function ZC(r, e, t, A) {
  return r + Math.cos(A / 180 * Is) * e + Math.sin(A / 180 * Is) * t;
}
function eS(r, e, t, A) {
  var n = 1e-6, i = e - r, s = t - e, a = 3 * i + 3 * (A - t) - 6 * s, o = 6 * (s - i), l = 3 * i;
  return Math.abs(a) < n ? [-l / o] : (function(u, h, f) {
    var c = u * u / 4 - h;
    if (c < -f) return [];
    if (c <= f) return [-u / 2];
    var p = Math.sqrt(c);
    return [-u / 2 - p, -u / 2 + p];
  })(o / a, l / a, n);
}
function tS(r, e, t, A, n) {
  var i = 1 - n;
  return r * (i * i * i) + e * (3 * i * i * n) + t * (3 * i * n * n) + A * (n * n * n);
}
(function(r) {
  function e() {
    return n((function(a, o, l) {
      return a.relative && (a.x1 !== void 0 && (a.x1 += o), a.y1 !== void 0 && (a.y1 += l), a.x2 !== void 0 && (a.x2 += o), a.y2 !== void 0 && (a.y2 += l), a.x !== void 0 && (a.x += o), a.y !== void 0 && (a.y += l), a.relative = !1), a;
    }));
  }
  function t() {
    var a = NaN, o = NaN, l = NaN, u = NaN;
    return n((function(h, f, c) {
      return h.type & Ue.SMOOTH_CURVE_TO && (h.type = Ue.CURVE_TO, a = isNaN(a) ? f : a, o = isNaN(o) ? c : o, h.x1 = h.relative ? f - a : 2 * f - a, h.y1 = h.relative ? c - o : 2 * c - o), h.type & Ue.CURVE_TO ? (a = h.relative ? f + h.x2 : h.x2, o = h.relative ? c + h.y2 : h.y2) : (a = NaN, o = NaN), h.type & Ue.SMOOTH_QUAD_TO && (h.type = Ue.QUAD_TO, l = isNaN(l) ? f : l, u = isNaN(u) ? c : u, h.x1 = h.relative ? f - l : 2 * f - l, h.y1 = h.relative ? c - u : 2 * c - u), h.type & Ue.QUAD_TO ? (l = h.relative ? f + h.x1 : h.x1, u = h.relative ? c + h.y1 : h.y1) : (l = NaN, u = NaN), h;
    }));
  }
  function A() {
    var a = NaN, o = NaN;
    return n((function(l, u, h) {
      if (l.type & Ue.SMOOTH_QUAD_TO && (l.type = Ue.QUAD_TO, a = isNaN(a) ? u : a, o = isNaN(o) ? h : o, l.x1 = l.relative ? u - a : 2 * u - a, l.y1 = l.relative ? h - o : 2 * h - o), l.type & Ue.QUAD_TO) {
        a = l.relative ? u + l.x1 : l.x1, o = l.relative ? h + l.y1 : l.y1;
        var f = l.x1, c = l.y1;
        l.type = Ue.CURVE_TO, l.x1 = ((l.relative ? 0 : u) + 2 * f) / 3, l.y1 = ((l.relative ? 0 : h) + 2 * c) / 3, l.x2 = (l.x + 2 * f) / 3, l.y2 = (l.y + 2 * c) / 3;
      } else a = NaN, o = NaN;
      return l;
    }));
  }
  function n(a) {
    var o = 0, l = 0, u = NaN, h = NaN;
    return function(f) {
      if (isNaN(u) && !(f.type & Ue.MOVE_TO)) throw new Error("path must start with moveto");
      var c = a(f, o, l, u, h);
      return f.type & Ue.CLOSE_PATH && (o = u, l = h), f.x !== void 0 && (o = f.relative ? o + f.x : f.x), f.y !== void 0 && (l = f.relative ? l + f.y : f.y), f.type & Ue.MOVE_TO && (u = o, h = l), c;
    };
  }
  function i(a, o, l, u, h, f) {
    return Zn(a, o, l, u, h, f), n((function(c, p, g, v) {
      var w = c.x1, B = c.x2, S = c.relative && !isNaN(v), C = c.x !== void 0 ? c.x : S ? 0 : p, E = c.y !== void 0 ? c.y : S ? 0 : g;
      function _(T) {
        return T * T;
      }
      c.type & Ue.HORIZ_LINE_TO && o !== 0 && (c.type = Ue.LINE_TO, c.y = c.relative ? 0 : g), c.type & Ue.VERT_LINE_TO && l !== 0 && (c.type = Ue.LINE_TO, c.x = c.relative ? 0 : p), c.x !== void 0 && (c.x = c.x * a + E * l + (S ? 0 : h)), c.y !== void 0 && (c.y = C * o + c.y * u + (S ? 0 : f)), c.x1 !== void 0 && (c.x1 = c.x1 * a + c.y1 * l + (S ? 0 : h)), c.y1 !== void 0 && (c.y1 = w * o + c.y1 * u + (S ? 0 : f)), c.x2 !== void 0 && (c.x2 = c.x2 * a + c.y2 * l + (S ? 0 : h)), c.y2 !== void 0 && (c.y2 = B * o + c.y2 * u + (S ? 0 : f));
      var I = a * u - o * l;
      if (c.xRot !== void 0 && (a !== 1 || o !== 0 || l !== 0 || u !== 1)) if (I === 0) delete c.rX, delete c.rY, delete c.xRot, delete c.lArcFlag, delete c.sweepFlag, c.type = Ue.LINE_TO;
      else {
        var O = c.xRot * Math.PI / 180, U = Math.sin(O), V = Math.cos(O), F = 1 / _(c.rX), P = 1 / _(c.rY), D = _(V) * F + _(U) * P, R = 2 * U * V * (F - P), J = _(U) * F + _(V) * P, ie = D * u * u - R * o * u + J * o * o, te = R * (a * u + o * l) - 2 * (D * l * u + J * a * o), $ = D * l * l - R * a * l + J * a * a, re = (Math.atan2(te, ie - $) + Math.PI) % Math.PI / 2, ue = Math.sin(re), se = Math.cos(re);
        c.rX = Math.abs(I) / Math.sqrt(ie * _(se) + te * ue * se + $ * _(ue)), c.rY = Math.abs(I) / Math.sqrt(ie * _(ue) - te * ue * se + $ * _(se)), c.xRot = 180 * re / Math.PI;
      }
      return c.sweepFlag !== void 0 && 0 > I && (c.sweepFlag = +!c.sweepFlag), c;
    }));
  }
  function s() {
    return function(a) {
      var o = {};
      for (var l in a) o[l] = a[l];
      return o;
    };
  }
  r.ROUND = function(a) {
    function o(l) {
      return Math.round(l * a) / a;
    }
    return a === void 0 && (a = 1e13), Zn(a), function(l) {
      return l.x1 !== void 0 && (l.x1 = o(l.x1)), l.y1 !== void 0 && (l.y1 = o(l.y1)), l.x2 !== void 0 && (l.x2 = o(l.x2)), l.y2 !== void 0 && (l.y2 = o(l.y2)), l.x !== void 0 && (l.x = o(l.x)), l.y !== void 0 && (l.y = o(l.y)), l.rX !== void 0 && (l.rX = o(l.rX)), l.rY !== void 0 && (l.rY = o(l.rY)), l;
    };
  }, r.TO_ABS = e, r.TO_REL = function() {
    return n((function(a, o, l) {
      return a.relative || (a.x1 !== void 0 && (a.x1 -= o), a.y1 !== void 0 && (a.y1 -= l), a.x2 !== void 0 && (a.x2 -= o), a.y2 !== void 0 && (a.y2 -= l), a.x !== void 0 && (a.x -= o), a.y !== void 0 && (a.y -= l), a.relative = !0), a;
    }));
  }, r.NORMALIZE_HVZ = function(a, o, l) {
    return a === void 0 && (a = !0), o === void 0 && (o = !0), l === void 0 && (l = !0), n((function(u, h, f, c, p) {
      if (isNaN(c) && !(u.type & Ue.MOVE_TO)) throw new Error("path must start with moveto");
      return o && u.type & Ue.HORIZ_LINE_TO && (u.type = Ue.LINE_TO, u.y = u.relative ? 0 : f), l && u.type & Ue.VERT_LINE_TO && (u.type = Ue.LINE_TO, u.x = u.relative ? 0 : h), a && u.type & Ue.CLOSE_PATH && (u.type = Ue.LINE_TO, u.x = u.relative ? c - h : c, u.y = u.relative ? p - f : p), u.type & Ue.ARC && (u.rX === 0 || u.rY === 0) && (u.type = Ue.LINE_TO, delete u.rX, delete u.rY, delete u.xRot, delete u.lArcFlag, delete u.sweepFlag), u;
    }));
  }, r.NORMALIZE_ST = t, r.QT_TO_C = A, r.INFO = n, r.SANITIZE = function(a) {
    a === void 0 && (a = 0), Zn(a);
    var o = NaN, l = NaN, u = NaN, h = NaN;
    return n((function(f, c, p, g, v) {
      var w = Math.abs, B = !1, S = 0, C = 0;
      if (f.type & Ue.SMOOTH_CURVE_TO && (S = isNaN(o) ? 0 : c - o, C = isNaN(l) ? 0 : p - l), f.type & (Ue.CURVE_TO | Ue.SMOOTH_CURVE_TO) ? (o = f.relative ? c + f.x2 : f.x2, l = f.relative ? p + f.y2 : f.y2) : (o = NaN, l = NaN), f.type & Ue.SMOOTH_QUAD_TO ? (u = isNaN(u) ? c : 2 * c - u, h = isNaN(h) ? p : 2 * p - h) : f.type & Ue.QUAD_TO ? (u = f.relative ? c + f.x1 : f.x1, h = f.relative ? p + f.y1 : f.y2) : (u = NaN, h = NaN), f.type & Ue.LINE_COMMANDS || f.type & Ue.ARC && (f.rX === 0 || f.rY === 0 || !f.lArcFlag) || f.type & Ue.CURVE_TO || f.type & Ue.SMOOTH_CURVE_TO || f.type & Ue.QUAD_TO || f.type & Ue.SMOOTH_QUAD_TO) {
        var E = f.x === void 0 ? 0 : f.relative ? f.x : f.x - c, _ = f.y === void 0 ? 0 : f.relative ? f.y : f.y - p;
        S = isNaN(u) ? f.x1 === void 0 ? S : f.relative ? f.x : f.x1 - c : u - c, C = isNaN(h) ? f.y1 === void 0 ? C : f.relative ? f.y : f.y1 - p : h - p;
        var I = f.x2 === void 0 ? 0 : f.relative ? f.x : f.x2 - c, O = f.y2 === void 0 ? 0 : f.relative ? f.y : f.y2 - p;
        w(E) <= a && w(_) <= a && w(S) <= a && w(C) <= a && w(I) <= a && w(O) <= a && (B = !0);
      }
      return f.type & Ue.CLOSE_PATH && w(c - g) <= a && w(p - v) <= a && (B = !0), B ? [] : f;
    }));
  }, r.MATRIX = i, r.ROTATE = function(a, o, l) {
    o === void 0 && (o = 0), l === void 0 && (l = 0), Zn(a, o, l);
    var u = Math.sin(a), h = Math.cos(a);
    return i(h, u, -u, h, o - o * h + l * u, l - o * u - l * h);
  }, r.TRANSLATE = function(a, o) {
    return o === void 0 && (o = 0), Zn(a, o), i(1, 0, 0, 1, a, o);
  }, r.SCALE = function(a, o) {
    return o === void 0 && (o = a), Zn(a, o), i(a, 0, 0, o, 0, 0);
  }, r.SKEW_X = function(a) {
    return Zn(a), i(1, 0, Math.atan(a), 1, 0, 0);
  }, r.SKEW_Y = function(a) {
    return Zn(a), i(1, Math.atan(a), 0, 1, 0, 0);
  }, r.X_AXIS_SYMMETRY = function(a) {
    return a === void 0 && (a = 0), Zn(a), i(-1, 0, 0, 1, a, 0);
  }, r.Y_AXIS_SYMMETRY = function(a) {
    return a === void 0 && (a = 0), Zn(a), i(1, 0, 0, -1, 0, a);
  }, r.A_TO_C = function() {
    return n((function(a, o, l) {
      return Ue.ARC === a.type ? (function(u, h, f) {
        var c, p, g, v;
        u.cX || P0(u, h, f);
        for (var w = Math.min(u.phi1, u.phi2), B = Math.max(u.phi1, u.phi2) - w, S = Math.ceil(B / 90), C = new Array(S), E = h, _ = f, I = 0; I < S; I++) {
          var O = $C(u.phi1, u.phi2, I / S), U = $C(u.phi1, u.phi2, (I + 1) / S), V = U - O, F = 4 / 3 * Math.tan(V * zi / 4), P = [Math.cos(O * zi) - F * Math.sin(O * zi), Math.sin(O * zi) + F * Math.cos(O * zi)], D = P[0], R = P[1], J = [Math.cos(U * zi), Math.sin(U * zi)], ie = J[0], te = J[1], $ = [ie + F * Math.sin(U * zi), te - F * Math.cos(U * zi)], re = $[0], ue = $[1];
          C[I] = { relative: u.relative, type: Ue.CURVE_TO };
          var se = function(T, G) {
            var X = Qm([T * u.rX, G * u.rY], u.xRot), Y = X[0], ee = X[1];
            return [u.cX + Y, u.cY + ee];
          };
          c = se(D, R), C[I].x1 = c[0], C[I].y1 = c[1], p = se(re, ue), C[I].x2 = p[0], C[I].y2 = p[1], g = se(ie, te), C[I].x = g[0], C[I].y = g[1], u.relative && (C[I].x1 -= E, C[I].y1 -= _, C[I].x2 -= E, C[I].y2 -= _, C[I].x -= E, C[I].y -= _), E = (v = [C[I].x, C[I].y])[0], _ = v[1];
        }
        return C;
      })(a, a.relative ? 0 : o, a.relative ? 0 : l) : a;
    }));
  }, r.ANNOTATE_ARCS = function() {
    return n((function(a, o, l) {
      return a.relative && (o = 0, l = 0), Ue.ARC === a.type && P0(a, o, l), a;
    }));
  }, r.CLONE = s, r.CALCULATE_BOUNDS = function() {
    var a = function(f) {
      var c = {};
      for (var p in f) c[p] = f[p];
      return c;
    }, o = e(), l = A(), u = t(), h = n((function(f, c, p) {
      var g = u(l(o(a(f))));
      function v(ue) {
        ue > h.maxX && (h.maxX = ue), ue < h.minX && (h.minX = ue);
      }
      function w(ue) {
        ue > h.maxY && (h.maxY = ue), ue < h.minY && (h.minY = ue);
      }
      if (g.type & Ue.DRAWING_COMMANDS && (v(c), w(p)), g.type & Ue.HORIZ_LINE_TO && v(g.x), g.type & Ue.VERT_LINE_TO && w(g.y), g.type & Ue.LINE_TO && (v(g.x), w(g.y)), g.type & Ue.CURVE_TO) {
        v(g.x), w(g.y);
        for (var B = 0, S = eS(c, g.x1, g.x2, g.x); B < S.length; B++)
          0 < (re = S[B]) && 1 > re && v(tS(c, g.x1, g.x2, g.x, re));
        for (var C = 0, E = eS(p, g.y1, g.y2, g.y); C < E.length; C++)
          0 < (re = E[C]) && 1 > re && w(tS(p, g.y1, g.y2, g.y, re));
      }
      if (g.type & Ue.ARC) {
        v(g.x), w(g.y), P0(g, c, p);
        for (var _ = g.xRot / 180 * Math.PI, I = Math.cos(_) * g.rX, O = Math.sin(_) * g.rX, U = -Math.sin(_) * g.rY, V = Math.cos(_) * g.rY, F = g.phi1 < g.phi2 ? [g.phi1, g.phi2] : -180 > g.phi2 ? [g.phi2 + 360, g.phi1 + 360] : [g.phi2, g.phi1], P = F[0], D = F[1], R = function(ue) {
          var se = ue[0], T = ue[1], G = 180 * Math.atan2(T, se) / Math.PI;
          return G < P ? G + 360 : G;
        }, J = 0, ie = JC(U, -I, 0).map(R); J < ie.length; J++)
          (re = ie[J]) > P && re < D && v(ZC(g.cX, I, U, re));
        for (var te = 0, $ = JC(V, -O, 0).map(R); te < $.length; te++) {
          var re;
          (re = $[te]) > P && re < D && w(ZC(g.cY, O, V, re));
        }
      }
      return f;
    }));
    return h.minX = 1 / 0, h.maxX = -1 / 0, h.minY = 1 / 0, h.maxY = -1 / 0, h;
  };
})(tA || (tA = {}));
var Jn, YE = (function() {
  function r() {
  }
  return r.prototype.round = function(e) {
    return this.transform(tA.ROUND(e));
  }, r.prototype.toAbs = function() {
    return this.transform(tA.TO_ABS());
  }, r.prototype.toRel = function() {
    return this.transform(tA.TO_REL());
  }, r.prototype.normalizeHVZ = function(e, t, A) {
    return this.transform(tA.NORMALIZE_HVZ(e, t, A));
  }, r.prototype.normalizeST = function() {
    return this.transform(tA.NORMALIZE_ST());
  }, r.prototype.qtToC = function() {
    return this.transform(tA.QT_TO_C());
  }, r.prototype.aToC = function() {
    return this.transform(tA.A_TO_C());
  }, r.prototype.sanitize = function(e) {
    return this.transform(tA.SANITIZE(e));
  }, r.prototype.translate = function(e, t) {
    return this.transform(tA.TRANSLATE(e, t));
  }, r.prototype.scale = function(e, t) {
    return this.transform(tA.SCALE(e, t));
  }, r.prototype.rotate = function(e, t, A) {
    return this.transform(tA.ROTATE(e, t, A));
  }, r.prototype.matrix = function(e, t, A, n, i, s) {
    return this.transform(tA.MATRIX(e, t, A, n, i, s));
  }, r.prototype.skewX = function(e) {
    return this.transform(tA.SKEW_X(e));
  }, r.prototype.skewY = function(e) {
    return this.transform(tA.SKEW_Y(e));
  }, r.prototype.xSymmetry = function(e) {
    return this.transform(tA.X_AXIS_SYMMETRY(e));
  }, r.prototype.ySymmetry = function(e) {
    return this.transform(tA.Y_AXIS_SYMMETRY(e));
  }, r.prototype.annotateArcs = function() {
    return this.transform(tA.ANNOTATE_ARCS());
  }, r;
})(), H6 = function(r) {
  return r === " " || r === "	" || r === "\r" || r === `
`;
}, rS = function(r) {
  return 48 <= r.charCodeAt(0) && r.charCodeAt(0) <= 57;
}, D6 = (function(r) {
  function e() {
    var t = r.call(this) || this;
    return t.curNumber = "", t.curCommandType = -1, t.curCommandRelative = !1, t.canParseCommandOrComma = !0, t.curNumberHasExp = !1, t.curNumberHasExpDigits = !1, t.curNumberHasDecimal = !1, t.curArgs = [], t;
  }
  return XE(e, r), e.prototype.finish = function(t) {
    if (t === void 0 && (t = []), this.parse(" ", t), this.curArgs.length !== 0 || !this.canParseCommandOrComma) throw new SyntaxError("Unterminated command at the path end.");
    return t;
  }, e.prototype.parse = function(t, A) {
    var n = this;
    A === void 0 && (A = []);
    for (var i = function(h) {
      A.push(h), n.curArgs.length = 0, n.canParseCommandOrComma = !0;
    }, s = 0; s < t.length; s++) {
      var a = t[s], o = !(this.curCommandType !== Ue.ARC || this.curArgs.length !== 3 && this.curArgs.length !== 4 || this.curNumber.length !== 1 || this.curNumber !== "0" && this.curNumber !== "1"), l = rS(a) && (this.curNumber === "0" && a === "0" || o);
      if (!rS(a) || l) if (a !== "e" && a !== "E") if (a !== "-" && a !== "+" || !this.curNumberHasExp || this.curNumberHasExpDigits) if (a !== "." || this.curNumberHasExp || this.curNumberHasDecimal || o) {
        if (this.curNumber && this.curCommandType !== -1) {
          var u = Number(this.curNumber);
          if (isNaN(u)) throw new SyntaxError("Invalid number ending at " + s);
          if (this.curCommandType === Ue.ARC) {
            if (this.curArgs.length === 0 || this.curArgs.length === 1) {
              if (0 > u) throw new SyntaxError('Expected positive number, got "' + u + '" at index "' + s + '"');
            } else if ((this.curArgs.length === 3 || this.curArgs.length === 4) && this.curNumber !== "0" && this.curNumber !== "1") throw new SyntaxError('Expected a flag, got "' + this.curNumber + '" at index "' + s + '"');
          }
          this.curArgs.push(u), this.curArgs.length === G6[this.curCommandType] && (Ue.HORIZ_LINE_TO === this.curCommandType ? i({ type: Ue.HORIZ_LINE_TO, relative: this.curCommandRelative, x: u }) : Ue.VERT_LINE_TO === this.curCommandType ? i({ type: Ue.VERT_LINE_TO, relative: this.curCommandRelative, y: u }) : this.curCommandType === Ue.MOVE_TO || this.curCommandType === Ue.LINE_TO || this.curCommandType === Ue.SMOOTH_QUAD_TO ? (i({ type: this.curCommandType, relative: this.curCommandRelative, x: this.curArgs[0], y: this.curArgs[1] }), Ue.MOVE_TO === this.curCommandType && (this.curCommandType = Ue.LINE_TO)) : this.curCommandType === Ue.CURVE_TO ? i({ type: Ue.CURVE_TO, relative: this.curCommandRelative, x1: this.curArgs[0], y1: this.curArgs[1], x2: this.curArgs[2], y2: this.curArgs[3], x: this.curArgs[4], y: this.curArgs[5] }) : this.curCommandType === Ue.SMOOTH_CURVE_TO ? i({ type: Ue.SMOOTH_CURVE_TO, relative: this.curCommandRelative, x2: this.curArgs[0], y2: this.curArgs[1], x: this.curArgs[2], y: this.curArgs[3] }) : this.curCommandType === Ue.QUAD_TO ? i({ type: Ue.QUAD_TO, relative: this.curCommandRelative, x1: this.curArgs[0], y1: this.curArgs[1], x: this.curArgs[2], y: this.curArgs[3] }) : this.curCommandType === Ue.ARC && i({ type: Ue.ARC, relative: this.curCommandRelative, rX: this.curArgs[0], rY: this.curArgs[1], xRot: this.curArgs[2], lArcFlag: this.curArgs[3], sweepFlag: this.curArgs[4], x: this.curArgs[5], y: this.curArgs[6] })), this.curNumber = "", this.curNumberHasExpDigits = !1, this.curNumberHasExp = !1, this.curNumberHasDecimal = !1, this.canParseCommandOrComma = !0;
        }
        if (!H6(a)) if (a === "," && this.canParseCommandOrComma) this.canParseCommandOrComma = !1;
        else if (a !== "+" && a !== "-" && a !== ".") if (l) this.curNumber = a, this.curNumberHasDecimal = !1;
        else {
          if (this.curArgs.length !== 0) throw new SyntaxError("Unterminated command at index " + s + ".");
          if (!this.canParseCommandOrComma) throw new SyntaxError('Unexpected character "' + a + '" at index ' + s + ". Command cannot follow comma");
          if (this.canParseCommandOrComma = !1, a !== "z" && a !== "Z") if (a === "h" || a === "H") this.curCommandType = Ue.HORIZ_LINE_TO, this.curCommandRelative = a === "h";
          else if (a === "v" || a === "V") this.curCommandType = Ue.VERT_LINE_TO, this.curCommandRelative = a === "v";
          else if (a === "m" || a === "M") this.curCommandType = Ue.MOVE_TO, this.curCommandRelative = a === "m";
          else if (a === "l" || a === "L") this.curCommandType = Ue.LINE_TO, this.curCommandRelative = a === "l";
          else if (a === "c" || a === "C") this.curCommandType = Ue.CURVE_TO, this.curCommandRelative = a === "c";
          else if (a === "s" || a === "S") this.curCommandType = Ue.SMOOTH_CURVE_TO, this.curCommandRelative = a === "s";
          else if (a === "q" || a === "Q") this.curCommandType = Ue.QUAD_TO, this.curCommandRelative = a === "q";
          else if (a === "t" || a === "T") this.curCommandType = Ue.SMOOTH_QUAD_TO, this.curCommandRelative = a === "t";
          else {
            if (a !== "a" && a !== "A") throw new SyntaxError('Unexpected character "' + a + '" at index ' + s + ".");
            this.curCommandType = Ue.ARC, this.curCommandRelative = a === "a";
          }
          else A.push({ type: Ue.CLOSE_PATH }), this.canParseCommandOrComma = !0, this.curCommandType = -1;
        }
        else this.curNumber = a, this.curNumberHasDecimal = a === ".";
      } else this.curNumber += a, this.curNumberHasDecimal = !0;
      else this.curNumber += a;
      else this.curNumber += a, this.curNumberHasExp = !0;
      else this.curNumber += a, this.curNumberHasExpDigits = this.curNumberHasExp;
    }
    return A;
  }, e.prototype.transform = function(t) {
    return Object.create(this, { parse: { value: function(A, n) {
      n === void 0 && (n = []);
      for (var i = 0, s = Object.getPrototypeOf(this).parse.call(this, A); i < s.length; i++) {
        var a = s[i], o = t(a);
        Array.isArray(o) ? n.push.apply(n, o) : n.push(o);
      }
      return n;
    } } });
  }, e;
})(YE), Ue = (function(r) {
  function e(t) {
    var A = r.call(this) || this;
    return A.commands = typeof t == "string" ? e.parse(t) : t, A;
  }
  return XE(e, r), e.prototype.encode = function() {
    return e.encode(this.commands);
  }, e.prototype.getBounds = function() {
    var t = tA.CALCULATE_BOUNDS();
    return this.transform(t), t;
  }, e.prototype.transform = function(t) {
    for (var A = [], n = 0, i = this.commands; n < i.length; n++) {
      var s = t(i[n]);
      Array.isArray(s) ? A.push.apply(A, s) : A.push(s);
    }
    return this.commands = A, this;
  }, e.encode = function(t) {
    return k6(t);
  }, e.parse = function(t) {
    var A = new D6(), n = [];
    return A.parse(t, n), A.finish(n), n;
  }, e.CLOSE_PATH = 1, e.MOVE_TO = 2, e.HORIZ_LINE_TO = 4, e.VERT_LINE_TO = 8, e.LINE_TO = 16, e.CURVE_TO = 32, e.SMOOTH_CURVE_TO = 64, e.QUAD_TO = 128, e.SMOOTH_QUAD_TO = 256, e.ARC = 512, e.LINE_COMMANDS = e.LINE_TO | e.HORIZ_LINE_TO | e.VERT_LINE_TO, e.DRAWING_COMMANDS = e.HORIZ_LINE_TO | e.VERT_LINE_TO | e.LINE_TO | e.CURVE_TO | e.SMOOTH_CURVE_TO | e.QUAD_TO | e.SMOOTH_QUAD_TO | e.ARC, e;
})(YE), G6 = ((Jn = {})[Ue.MOVE_TO] = 2, Jn[Ue.LINE_TO] = 2, Jn[Ue.HORIZ_LINE_TO] = 1, Jn[Ue.VERT_LINE_TO] = 1, Jn[Ue.CLOSE_PATH] = 0, Jn[Ue.QUAD_TO] = 4, Jn[Ue.SMOOTH_QUAD_TO] = 2, Jn[Ue.CURVE_TO] = 6, Jn[Ue.SMOOTH_CURVE_TO] = 4, Jn[Ue.ARC] = 7, Jn), AS = {}, nS;
function V6() {
  if (nS) return AS;
  nS = 1;
  var r = tf().PROPER, e = Da(), t = WA(), A = xi(), n = Tr(), i = Ov(), s = "toString", a = RegExp.prototype, o = a[s], l = n(function() {
    return o.call({ source: "a", flags: "b" }) !== "/a/b";
  }), u = r && o.name !== s;
  return (l || u) && e(a, s, function() {
    var f = t(this), c = A(f.source), p = A(i(f));
    return "/" + c + "/" + p;
  }, { unsafe: !0 }), AS;
}
V6();
function lh(r) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? lh = function(e) {
    return typeof e;
  } : lh = function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, lh(r);
}
function K6(r, e) {
  if (!(r instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
var j6 = [512, 512, 456, 512, 328, 456, 335, 512, 405, 328, 271, 456, 388, 335, 292, 512, 454, 405, 364, 328, 298, 271, 496, 456, 420, 388, 360, 335, 312, 292, 273, 512, 482, 454, 428, 405, 383, 364, 345, 328, 312, 298, 284, 271, 259, 496, 475, 456, 437, 420, 404, 388, 374, 360, 347, 335, 323, 312, 302, 292, 282, 273, 265, 512, 497, 482, 468, 454, 441, 428, 417, 405, 394, 383, 373, 364, 354, 345, 337, 328, 320, 312, 305, 298, 291, 284, 278, 271, 265, 259, 507, 496, 485, 475, 465, 456, 446, 437, 428, 420, 412, 404, 396, 388, 381, 374, 367, 360, 354, 347, 341, 335, 329, 323, 318, 312, 307, 302, 297, 292, 287, 282, 278, 273, 269, 265, 261, 512, 505, 497, 489, 482, 475, 468, 461, 454, 447, 441, 435, 428, 422, 417, 411, 405, 399, 394, 389, 383, 378, 373, 368, 364, 359, 354, 350, 345, 341, 337, 332, 328, 324, 320, 316, 312, 309, 305, 301, 298, 294, 291, 287, 284, 281, 278, 274, 271, 268, 265, 262, 259, 257, 507, 501, 496, 491, 485, 480, 475, 470, 465, 460, 456, 451, 446, 442, 437, 433, 428, 424, 420, 416, 412, 408, 404, 400, 396, 392, 388, 385, 381, 377, 374, 370, 367, 363, 360, 357, 354, 350, 347, 344, 341, 338, 335, 332, 329, 326, 323, 320, 318, 315, 312, 310, 307, 304, 302, 299, 297, 294, 292, 289, 287, 285, 282, 280, 278, 275, 273, 271, 269, 267, 265, 263, 261, 259], q6 = [9, 11, 12, 13, 13, 14, 14, 15, 15, 15, 15, 16, 16, 16, 16, 17, 17, 17, 17, 17, 17, 17, 18, 18, 18, 18, 18, 18, 18, 18, 18, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24];
function z6(r, e, t, A, n) {
  if (typeof r == "string" && (r = document.getElementById(r)), !r || lh(r) !== "object" || !("getContext" in r))
    throw new TypeError("Expecting canvas with `getContext` method in processCanvasRGB(A) calls!");
  var i = r.getContext("2d");
  try {
    return i.getImageData(e, t, A, n);
  } catch (s) {
    throw new Error("unable to access image data: " + s);
  }
}
function W6(r, e, t, A, n, i) {
  if (!(isNaN(i) || i < 1)) {
    i |= 0;
    var s = z6(r, e, t, A, n);
    s = X6(s, e, t, A, n, i), r.getContext("2d").putImageData(s, e, t);
  }
}
function X6(r, e, t, A, n, i) {
  for (var s = r.data, a = 2 * i + 1, o = A - 1, l = n - 1, u = i + 1, h = u * (u + 1) / 2, f = new iS(), c = f, p, g = 1; g < a; g++)
    c = c.next = new iS(), g === u && (p = c);
  c.next = f;
  for (var v = null, w = null, B = 0, S = 0, C = j6[i], E = q6[i], _ = 0; _ < n; _++) {
    c = f;
    for (var I = s[S], O = s[S + 1], U = s[S + 2], V = s[S + 3], F = 0; F < u; F++)
      c.r = I, c.g = O, c.b = U, c.a = V, c = c.next;
    for (var P = 0, D = 0, R = 0, J = 0, ie = u * I, te = u * O, $ = u * U, re = u * V, ue = h * I, se = h * O, T = h * U, G = h * V, X = 1; X < u; X++) {
      var Y = S + ((o < X ? o : X) << 2), ee = s[Y], oe = s[Y + 1], ge = s[Y + 2], pe = s[Y + 3], me = u - X;
      ue += (c.r = ee) * me, se += (c.g = oe) * me, T += (c.b = ge) * me, G += (c.a = pe) * me, P += ee, D += oe, R += ge, J += pe, c = c.next;
    }
    v = f, w = p;
    for (var Ee = 0; Ee < A; Ee++) {
      var Ne = G * C >>> E;
      if (s[S + 3] = Ne, Ne !== 0) {
        var Te = 255 / Ne;
        s[S] = (ue * C >>> E) * Te, s[S + 1] = (se * C >>> E) * Te, s[S + 2] = (T * C >>> E) * Te;
      } else
        s[S] = s[S + 1] = s[S + 2] = 0;
      ue -= ie, se -= te, T -= $, G -= re, ie -= v.r, te -= v.g, $ -= v.b, re -= v.a;
      var Ge = Ee + i + 1;
      Ge = B + (Ge < o ? Ge : o) << 2, P += v.r = s[Ge], D += v.g = s[Ge + 1], R += v.b = s[Ge + 2], J += v.a = s[Ge + 3], ue += P, se += D, T += R, G += J, v = v.next;
      var j = w, Pe = j.r, ft = j.g, et = j.b, xe = j.a;
      ie += Pe, te += ft, $ += et, re += xe, P -= Pe, D -= ft, R -= et, J -= xe, w = w.next, S += 4;
    }
    B += A;
  }
  for (var rt = 0; rt < A; rt++) {
    S = rt << 2;
    var ke = s[S], We = s[S + 1], ze = s[S + 2], Ce = s[S + 3], Oe = u * ke, Re = u * We, Ke = u * ze, Xe = u * Ce, Ve = h * ke, dt = h * We, je = h * ze, Tt = h * Ce;
    c = f;
    for (var Et = 0; Et < u; Et++)
      c.r = ke, c.g = We, c.b = ze, c.a = Ce, c = c.next;
    for (var mt = A, yt = 0, Gt = 0, it = 0, Vt = 0, lt = 1; lt <= i; lt++) {
      S = mt + rt << 2;
      var wt = u - lt;
      Ve += (c.r = ke = s[S]) * wt, dt += (c.g = We = s[S + 1]) * wt, je += (c.b = ze = s[S + 2]) * wt, Tt += (c.a = Ce = s[S + 3]) * wt, Vt += ke, yt += We, Gt += ze, it += Ce, c = c.next, lt < l && (mt += A);
    }
    S = rt, v = f, w = p;
    for (var Yt = 0; Yt < n; Yt++) {
      var ut = S << 2;
      s[ut + 3] = Ce = Tt * C >>> E, Ce > 0 ? (Ce = 255 / Ce, s[ut] = (Ve * C >>> E) * Ce, s[ut + 1] = (dt * C >>> E) * Ce, s[ut + 2] = (je * C >>> E) * Ce) : s[ut] = s[ut + 1] = s[ut + 2] = 0, Ve -= Oe, dt -= Re, je -= Ke, Tt -= Xe, Oe -= v.r, Re -= v.g, Ke -= v.b, Xe -= v.a, ut = rt + ((ut = Yt + u) < l ? ut : l) * A << 2, Ve += Vt += v.r = s[ut], dt += yt += v.g = s[ut + 1], je += Gt += v.b = s[ut + 2], Tt += it += v.a = s[ut + 3], v = v.next, Oe += ke = w.r, Re += We = w.g, Ke += ze = w.b, Xe += Ce = w.a, Vt -= ke, yt -= We, Gt -= ze, it -= Ce, w = w.next, S += A;
    }
  }
  return r;
}
var iS = (
  /**
   * Set properties.
   */
  function r() {
    K6(this, r), this.r = 0, this.g = 0, this.b = 0, this.a = 0, this.next = null;
  }
);
function Y6() {
  var {
    DOMParser: r
  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = {
    window: null,
    ignoreAnimation: !0,
    ignoreMouse: !0,
    DOMParser: r,
    createCanvas(t, A) {
      return new OffscreenCanvas(t, A);
    },
    createImage(t) {
      return ns(function* () {
        var A = yield fetch(t), n = yield A.blob(), i = yield createImageBitmap(n);
        return i;
      })();
    }
  };
  return (typeof DOMParser < "u" || typeof r > "u") && Reflect.deleteProperty(e, "DOMParser"), e;
}
function J6(r) {
  var {
    DOMParser: e,
    canvas: t,
    fetch: A
  } = r;
  return {
    window: null,
    ignoreAnimation: !0,
    ignoreMouse: !0,
    DOMParser: e,
    fetch: A,
    createCanvas: t.createCanvas,
    createImage: t.loadImage
  };
}
var $6 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  offscreen: Y6,
  node: J6
});
function Ga(r) {
  return r.replace(/(?!\u3000)\s+/gm, " ");
}
function JE(r) {
  return r.replace(/^[\n \t]+/, "");
}
function $E(r) {
  return r.replace(/[\n \t]+$/, "");
}
function An(r) {
  var e = (r || "").match(/-?(\d+(?:\.\d*(?:[eE][+-]?\d+)?)?|\.\d+)(?=\D|$)/gm) || [];
  return e.map(parseFloat);
}
var Z6 = /^[A-Z-]+$/;
function ZE(r) {
  return Z6.test(r) ? r.toLowerCase() : r;
}
function Dv(r) {
  var e = /url\(('([^']+)'|"([^"]+)"|([^'")]+))\)/.exec(r) || [];
  return e[2] || e[3] || e[4];
}
function eF(r) {
  if (!r.startsWith("rgb"))
    return r;
  var e = 3, t = r.replace(/\d+(\.\d+)?/g, (A, n) => e-- && n ? String(Math.round(parseFloat(A))) : A);
  return t;
}
var e8 = /(\[[^\]]+\])/g, t8 = /(#[^\s+>~.[:]+)/g, r8 = /(\.[^\s+>~.[:]+)/g, A8 = /(::[^\s+>~.[:]+|:first-line|:first-letter|:before|:after)/gi, n8 = /(:[\w-]+\([^)]*\))/gi, i8 = /(:[^\s+>~.[:]+)/g, s8 = /([^\s+>~.[:]+)/g;
function fa(r, e) {
  var t = e.exec(r);
  return t ? [r.replace(e, " "), t.length] : [r, 0];
}
function tF(r) {
  var e = [0, 0, 0], t = r.replace(/:not\(([^)]*)\)/g, "     $1 ").replace(/{[\s\S]*/gm, " "), A = 0;
  return [t, A] = fa(t, e8), e[1] += A, [t, A] = fa(t, t8), e[0] += A, [t, A] = fa(t, r8), e[1] += A, [t, A] = fa(t, A8), e[2] += A, [t, A] = fa(t, n8), e[1] += A, [t, A] = fa(t, i8), e[1] += A, t = t.replace(/[*\s+>~]/g, " ").replace(/[#.]/g, " "), [t, A] = fa(t, s8), e[2] += A, e.join("");
}
var _a = 1e-8;
function Lm(r) {
  return Math.sqrt(Math.pow(r[0], 2) + Math.pow(r[1], 2));
}
function Uh(r, e) {
  return (r[0] * e[0] + r[1] * e[1]) / (Lm(r) * Lm(e));
}
function Nm(r, e) {
  return (r[0] * e[1] < r[1] * e[0] ? -1 : 1) * Math.acos(Uh(r, e));
}
function Tm(r) {
  return r * r * r;
}
function Pm(r) {
  return 3 * r * r * (1 - r);
}
function Om(r) {
  return 3 * r * (1 - r) * (1 - r);
}
function Mm(r) {
  return (1 - r) * (1 - r) * (1 - r);
}
function Rm(r) {
  return r * r;
}
function km(r) {
  return 2 * r * (1 - r);
}
function Hm(r) {
  return (1 - r) * (1 - r);
}
class pt {
  constructor(e, t, A) {
    this.document = e, this.name = t, this.value = A, this.isNormalizedColor = !1;
  }
  static empty(e) {
    return new pt(e, "EMPTY", "");
  }
  split() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : " ", {
      document: t,
      name: A
    } = this;
    return Ga(this.getString()).trim().split(e).map((n) => new pt(t, A, n));
  }
  hasValue(e) {
    var {
      value: t
    } = this;
    return t !== null && t !== "" && (e || t !== 0) && typeof t < "u";
  }
  isString(e) {
    var {
      value: t
    } = this, A = typeof t == "string";
    return !A || !e ? A : e.test(t);
  }
  isUrlDefinition() {
    return this.isString(/^url\(/);
  }
  isPixels() {
    if (!this.hasValue())
      return !1;
    var e = this.getString();
    switch (!0) {
      case e.endsWith("px"):
      case /^[0-9]+$/.test(e):
        return !0;
      default:
        return !1;
    }
  }
  setValue(e) {
    return this.value = e, this;
  }
  getValue(e) {
    return typeof e > "u" || this.hasValue() ? this.value : e;
  }
  getNumber(e) {
    if (!this.hasValue())
      return typeof e > "u" ? 0 : parseFloat(e);
    var {
      value: t
    } = this, A = parseFloat(t);
    return this.isString(/%$/) && (A /= 100), A;
  }
  getString(e) {
    return typeof e > "u" || this.hasValue() ? typeof this.value > "u" ? "" : String(this.value) : String(e);
  }
  getColor(e) {
    var t = this.getString(e);
    return this.isNormalizedColor || (this.isNormalizedColor = !0, t = eF(t), this.value = t), t;
  }
  getDpi() {
    return 96;
  }
  getRem() {
    return this.document.rootEmSize;
  }
  getEm() {
    return this.document.emSize;
  }
  getUnits() {
    return this.getString().replace(/[0-9.-]/g, "");
  }
  getPixels(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    if (!this.hasValue())
      return 0;
    var [A, n] = typeof e == "boolean" ? [void 0, e] : [e], {
      viewPort: i
    } = this.document.screen;
    switch (!0) {
      case this.isString(/vmin$/):
        return this.getNumber() / 100 * Math.min(i.computeSize("x"), i.computeSize("y"));
      case this.isString(/vmax$/):
        return this.getNumber() / 100 * Math.max(i.computeSize("x"), i.computeSize("y"));
      case this.isString(/vw$/):
        return this.getNumber() / 100 * i.computeSize("x");
      case this.isString(/vh$/):
        return this.getNumber() / 100 * i.computeSize("y");
      case this.isString(/rem$/):
        return this.getNumber() * this.getRem();
      case this.isString(/em$/):
        return this.getNumber() * this.getEm();
      case this.isString(/ex$/):
        return this.getNumber() * this.getEm() / 2;
      case this.isString(/px$/):
        return this.getNumber();
      case this.isString(/pt$/):
        return this.getNumber() * this.getDpi() * (1 / 72);
      case this.isString(/pc$/):
        return this.getNumber() * 15;
      case this.isString(/cm$/):
        return this.getNumber() * this.getDpi() / 2.54;
      case this.isString(/mm$/):
        return this.getNumber() * this.getDpi() / 25.4;
      case this.isString(/in$/):
        return this.getNumber() * this.getDpi();
      case (this.isString(/%$/) && n):
        return this.getNumber() * this.getEm();
      case this.isString(/%$/):
        return this.getNumber() * i.computeSize(A);
      default: {
        var s = this.getNumber();
        return t && s < 1 ? s * i.computeSize(A) : s;
      }
    }
  }
  getMilliseconds() {
    return this.hasValue() ? this.isString(/ms$/) ? this.getNumber() : this.getNumber() * 1e3 : 0;
  }
  getRadians() {
    if (!this.hasValue())
      return 0;
    switch (!0) {
      case this.isString(/deg$/):
        return this.getNumber() * (Math.PI / 180);
      case this.isString(/grad$/):
        return this.getNumber() * (Math.PI / 200);
      case this.isString(/rad$/):
        return this.getNumber();
      default:
        return this.getNumber() * (Math.PI / 180);
    }
  }
  getDefinition() {
    var e = this.getString(), t = /#([^)'"]+)/.exec(e);
    return t && (t = t[1]), t || (t = e), this.document.definitions[t];
  }
  getFillStyleDefinition(e, t) {
    var A = this.getDefinition();
    if (!A)
      return null;
    if (typeof A.createGradient == "function")
      return A.createGradient(this.document.ctx, e, t);
    if (typeof A.createPattern == "function") {
      if (A.getHrefAttribute().hasValue()) {
        var n = A.getAttribute("patternTransform");
        A = A.getHrefAttribute().getDefinition(), n.hasValue() && A.getAttribute("patternTransform", !0).setValue(n.value);
      }
      return A.createPattern(this.document.ctx, e, t);
    }
    return null;
  }
  getTextBaseline() {
    return this.hasValue() ? pt.textBaselineMapping[this.getString()] : null;
  }
  addOpacity(e) {
    for (var t = this.getColor(), A = t.length, n = 0, i = 0; i < A && (t[i] === "," && n++, n !== 3); i++)
      ;
    if (e.hasValue() && this.isString() && n !== 3) {
      var s = new Im(t);
      s.ok && (s.alpha = e.getNumber(), t = s.toRGBA());
    }
    return new pt(this.document, this.name, t);
  }
}
pt.textBaselineMapping = {
  baseline: "alphabetic",
  "before-edge": "top",
  "text-before-edge": "top",
  middle: "middle",
  central: "middle",
  "after-edge": "bottom",
  "text-after-edge": "bottom",
  ideographic: "ideographic",
  alphabetic: "alphabetic",
  hanging: "hanging",
  mathematical: "alphabetic"
};
class rF {
  constructor() {
    this.viewPorts = [];
  }
  clear() {
    this.viewPorts = [];
  }
  setCurrent(e, t) {
    this.viewPorts.push({
      width: e,
      height: t
    });
  }
  removeCurrent() {
    this.viewPorts.pop();
  }
  getCurrent() {
    var {
      viewPorts: e
    } = this;
    return e[e.length - 1];
  }
  get width() {
    return this.getCurrent().width;
  }
  get height() {
    return this.getCurrent().height;
  }
  computeSize(e) {
    return typeof e == "number" ? e : e === "x" ? this.width : e === "y" ? this.height : Math.sqrt(Math.pow(this.width, 2) + Math.pow(this.height, 2)) / Math.sqrt(2);
  }
}
class Lr {
  constructor(e, t) {
    this.x = e, this.y = t;
  }
  static parse(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, [A = t, n = t] = An(e);
    return new Lr(A, n);
  }
  static parseScale(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, [A = t, n = A] = An(e);
    return new Lr(A, n);
  }
  static parsePath(e) {
    for (var t = An(e), A = t.length, n = [], i = 0; i < A; i += 2)
      n.push(new Lr(t[i], t[i + 1]));
    return n;
  }
  angleTo(e) {
    return Math.atan2(e.y - this.y, e.x - this.x);
  }
  applyTransform(e) {
    var {
      x: t,
      y: A
    } = this, n = t * e[0] + A * e[2] + e[4], i = t * e[1] + A * e[3] + e[5];
    this.x = n, this.y = i;
  }
}
class AF {
  constructor(e) {
    this.screen = e, this.working = !1, this.events = [], this.eventElements = [], this.onClick = this.onClick.bind(this), this.onMouseMove = this.onMouseMove.bind(this);
  }
  isWorking() {
    return this.working;
  }
  start() {
    if (!this.working) {
      var {
        screen: e,
        onClick: t,
        onMouseMove: A
      } = this, n = e.ctx.canvas;
      n.onclick = t, n.onmousemove = A, this.working = !0;
    }
  }
  stop() {
    if (this.working) {
      var e = this.screen.ctx.canvas;
      this.working = !1, e.onclick = null, e.onmousemove = null;
    }
  }
  hasEvents() {
    return this.working && this.events.length > 0;
  }
  runEvents() {
    if (this.working) {
      var {
        screen: e,
        events: t,
        eventElements: A
      } = this, {
        style: n
      } = e.ctx.canvas;
      n && (n.cursor = ""), t.forEach((i, s) => {
        for (var {
          run: a
        } = i, o = A[s]; o; )
          a(o), o = o.parent;
      }), this.events = [], this.eventElements = [];
    }
  }
  checkPath(e, t) {
    if (!(!this.working || !t)) {
      var {
        events: A,
        eventElements: n
      } = this;
      A.forEach((i, s) => {
        var {
          x: a,
          y: o
        } = i;
        !n[s] && t.isPointInPath && t.isPointInPath(a, o) && (n[s] = e);
      });
    }
  }
  checkBoundingBox(e, t) {
    if (!(!this.working || !t)) {
      var {
        events: A,
        eventElements: n
      } = this;
      A.forEach((i, s) => {
        var {
          x: a,
          y: o
        } = i;
        !n[s] && t.isPointInBox(a, o) && (n[s] = e);
      });
    }
  }
  mapXY(e, t) {
    for (var {
      window: A,
      ctx: n
    } = this.screen, i = new Lr(e, t), s = n.canvas; s; )
      i.x -= s.offsetLeft, i.y -= s.offsetTop, s = s.offsetParent;
    return A.scrollX && (i.x += A.scrollX), A.scrollY && (i.y += A.scrollY), i;
  }
  onClick(e) {
    var {
      x: t,
      y: A
    } = this.mapXY(e.clientX, e.clientY);
    this.events.push({
      type: "onclick",
      x: t,
      y: A,
      run(n) {
        n.onClick && n.onClick();
      }
    });
  }
  onMouseMove(e) {
    var {
      x: t,
      y: A
    } = this.mapXY(e.clientX, e.clientY);
    this.events.push({
      type: "onmousemove",
      x: t,
      y: A,
      run(n) {
        n.onMouseMove && n.onMouseMove();
      }
    });
  }
}
var nF = typeof window < "u" ? window : null, iF = typeof fetch < "u" ? fetch.bind(void 0) : null;
class Su {
  constructor(e) {
    var {
      fetch: t = iF,
      window: A = nF
    } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.ctx = e, this.FRAMERATE = 30, this.MAX_VIRTUAL_PIXELS = 3e4, this.CLIENT_WIDTH = 800, this.CLIENT_HEIGHT = 600, this.viewPort = new rF(), this.mouse = new AF(this), this.animations = [], this.waits = [], this.frameDuration = 0, this.isReadyLock = !1, this.isFirstRender = !0, this.intervalId = null, this.window = A, this.fetch = t;
  }
  wait(e) {
    this.waits.push(e);
  }
  ready() {
    return this.readyPromise ? this.readyPromise : Promise.resolve();
  }
  isReady() {
    if (this.isReadyLock)
      return !0;
    var e = this.waits.every((t) => t());
    return e && (this.waits = [], this.resolveReady && this.resolveReady()), this.isReadyLock = e, e;
  }
  setDefaults(e) {
    e.strokeStyle = "rgba(0,0,0,0)", e.lineCap = "butt", e.lineJoin = "miter", e.miterLimit = 4;
  }
  setViewBox(e) {
    var {
      document: t,
      ctx: A,
      aspectRatio: n,
      width: i,
      desiredWidth: s,
      height: a,
      desiredHeight: o,
      minX: l = 0,
      minY: u = 0,
      refX: h,
      refY: f,
      clip: c = !1,
      clipX: p = 0,
      clipY: g = 0
    } = e, v = Ga(n).replace(/^defer\s/, ""), [w, B] = v.split(" "), S = w || "xMidYMid", C = B || "meet", E = i / s, _ = a / o, I = Math.min(E, _), O = Math.max(E, _), U = s, V = o;
    C === "meet" && (U *= I, V *= I), C === "slice" && (U *= O, V *= O);
    var F = new pt(t, "refX", h), P = new pt(t, "refY", f), D = F.hasValue() && P.hasValue();
    if (D && A.translate(-I * F.getPixels("x"), -I * P.getPixels("y")), c) {
      var R = I * p, J = I * g;
      A.beginPath(), A.moveTo(R, J), A.lineTo(i, J), A.lineTo(i, a), A.lineTo(R, a), A.closePath(), A.clip();
    }
    if (!D) {
      var ie = C === "meet" && I === _, te = C === "slice" && O === _, $ = C === "meet" && I === E, re = C === "slice" && O === E;
      S.startsWith("xMid") && (ie || te) && A.translate(i / 2 - U / 2, 0), S.endsWith("YMid") && ($ || re) && A.translate(0, a / 2 - V / 2), S.startsWith("xMax") && (ie || te) && A.translate(i - U, 0), S.endsWith("YMax") && ($ || re) && A.translate(0, a - V);
    }
    switch (!0) {
      case S === "none":
        A.scale(E, _);
        break;
      case C === "meet":
        A.scale(I, I);
        break;
      case C === "slice":
        A.scale(O, O);
        break;
    }
    A.translate(-l, -u);
  }
  start(e) {
    var {
      enableRedraw: t = !1,
      ignoreMouse: A = !1,
      ignoreAnimation: n = !1,
      ignoreDimensions: i = !1,
      ignoreClear: s = !1,
      forceRedraw: a,
      scaleWidth: o,
      scaleHeight: l,
      offsetX: u,
      offsetY: h
    } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      FRAMERATE: f,
      mouse: c
    } = this, p = 1e3 / f;
    if (this.frameDuration = p, this.readyPromise = new Promise((S) => {
      this.resolveReady = S;
    }), this.isReady() && this.render(e, i, s, o, l, u, h), !!t) {
      var g = Date.now(), v = g, w = 0, B = () => {
        g = Date.now(), w = g - v, w >= p && (v = g - w % p, this.shouldUpdate(n, a) && (this.render(e, i, s, o, l, u, h), c.runEvents())), this.intervalId = U0(B);
      };
      A || c.start(), this.intervalId = U0(B);
    }
  }
  stop() {
    this.intervalId && (U0.cancel(this.intervalId), this.intervalId = null), this.mouse.stop();
  }
  shouldUpdate(e, t) {
    if (!e) {
      var {
        frameDuration: A
      } = this, n = this.animations.reduce((i, s) => s.update(A) || i, !1);
      if (n)
        return !0;
    }
    return !!(typeof t == "function" && t() || !this.isReadyLock && this.isReady() || this.mouse.hasEvents());
  }
  render(e, t, A, n, i, s, a) {
    var {
      CLIENT_WIDTH: o,
      CLIENT_HEIGHT: l,
      viewPort: u,
      ctx: h,
      isFirstRender: f
    } = this, c = h.canvas;
    u.clear(), c.width && c.height ? u.setCurrent(c.width, c.height) : u.setCurrent(o, l);
    var p = e.getStyle("width"), g = e.getStyle("height");
    !t && (f || typeof n != "number" && typeof i != "number") && (p.hasValue() && (c.width = p.getPixels("x"), c.style && (c.style.width = "".concat(c.width, "px"))), g.hasValue() && (c.height = g.getPixels("y"), c.style && (c.style.height = "".concat(c.height, "px"))));
    var v = c.clientWidth || c.width, w = c.clientHeight || c.height;
    if (t && p.hasValue() && g.hasValue() && (v = p.getPixels("x"), w = g.getPixels("y")), u.setCurrent(v, w), typeof s == "number" && e.getAttribute("x", !0).setValue(s), typeof a == "number" && e.getAttribute("y", !0).setValue(a), typeof n == "number" || typeof i == "number") {
      var B = An(e.getAttribute("viewBox").getString()), S = 0, C = 0;
      if (typeof n == "number") {
        var E = e.getStyle("width");
        E.hasValue() ? S = E.getPixels("x") / n : isNaN(B[2]) || (S = B[2] / n);
      }
      if (typeof i == "number") {
        var _ = e.getStyle("height");
        _.hasValue() ? C = _.getPixels("y") / i : isNaN(B[3]) || (C = B[3] / i);
      }
      S || (S = C), C || (C = S), e.getAttribute("width", !0).setValue(n), e.getAttribute("height", !0).setValue(i);
      var I = e.getStyle("transform", !0, !0);
      I.setValue("".concat(I.getString(), " scale(").concat(1 / S, ", ").concat(1 / C, ")"));
    }
    A || h.clearRect(0, 0, v, w), e.render(h), f && (this.isFirstRender = !1);
  }
}
Su.defaultWindow = nF;
Su.defaultFetch = iF;
var {
  defaultFetch: a8
} = Su, o8 = typeof DOMParser < "u" ? DOMParser : null;
class uh {
  constructor() {
    var {
      fetch: e = a8,
      DOMParser: t = o8
    } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.fetch = e, this.DOMParser = t;
  }
  parse(e) {
    var t = this;
    return ns(function* () {
      return e.startsWith("<") ? t.parseFromString(e) : t.load(e);
    })();
  }
  parseFromString(e) {
    var t = new this.DOMParser();
    try {
      return this.checkDocument(t.parseFromString(e, "image/svg+xml"));
    } catch {
      return this.checkDocument(t.parseFromString(e, "text/xml"));
    }
  }
  checkDocument(e) {
    var t = e.getElementsByTagName("parsererror")[0];
    if (t)
      throw new Error(t.textContent);
    return e;
  }
  load(e) {
    var t = this;
    return ns(function* () {
      var A = yield t.fetch(e), n = yield A.text();
      return t.parseFromString(n);
    })();
  }
}
class sF {
  constructor(e, t) {
    this.type = "translate", this.point = null, this.point = Lr.parse(t);
  }
  apply(e) {
    var {
      x: t,
      y: A
    } = this.point;
    e.translate(t || 0, A || 0);
  }
  unapply(e) {
    var {
      x: t,
      y: A
    } = this.point;
    e.translate(-1 * t || 0, -1 * A || 0);
  }
  applyToPoint(e) {
    var {
      x: t,
      y: A
    } = this.point;
    e.applyTransform([1, 0, 0, 1, t || 0, A || 0]);
  }
}
class aF {
  constructor(e, t, A) {
    this.type = "rotate", this.angle = null, this.originX = null, this.originY = null, this.cx = 0, this.cy = 0;
    var n = An(t);
    this.angle = new pt(e, "angle", n[0]), this.originX = A[0], this.originY = A[1], this.cx = n[1] || 0, this.cy = n[2] || 0;
  }
  apply(e) {
    var {
      cx: t,
      cy: A,
      originX: n,
      originY: i,
      angle: s
    } = this, a = t + n.getPixels("x"), o = A + i.getPixels("y");
    e.translate(a, o), e.rotate(s.getRadians()), e.translate(-a, -o);
  }
  unapply(e) {
    var {
      cx: t,
      cy: A,
      originX: n,
      originY: i,
      angle: s
    } = this, a = t + n.getPixels("x"), o = A + i.getPixels("y");
    e.translate(a, o), e.rotate(-1 * s.getRadians()), e.translate(-a, -o);
  }
  applyToPoint(e) {
    var {
      cx: t,
      cy: A,
      angle: n
    } = this, i = n.getRadians();
    e.applyTransform([
      1,
      0,
      0,
      1,
      t || 0,
      A || 0
      // this.p.y
    ]), e.applyTransform([Math.cos(i), Math.sin(i), -Math.sin(i), Math.cos(i), 0, 0]), e.applyTransform([
      1,
      0,
      0,
      1,
      -t || 0,
      -A || 0
      // -this.p.y
    ]);
  }
}
class oF {
  constructor(e, t, A) {
    this.type = "scale", this.scale = null, this.originX = null, this.originY = null;
    var n = Lr.parseScale(t);
    (n.x === 0 || n.y === 0) && (n.x = _a, n.y = _a), this.scale = n, this.originX = A[0], this.originY = A[1];
  }
  apply(e) {
    var {
      scale: {
        x: t,
        y: A
      },
      originX: n,
      originY: i
    } = this, s = n.getPixels("x"), a = i.getPixels("y");
    e.translate(s, a), e.scale(t, A || t), e.translate(-s, -a);
  }
  unapply(e) {
    var {
      scale: {
        x: t,
        y: A
      },
      originX: n,
      originY: i
    } = this, s = n.getPixels("x"), a = i.getPixels("y");
    e.translate(s, a), e.scale(1 / t, 1 / A || t), e.translate(-s, -a);
  }
  applyToPoint(e) {
    var {
      x: t,
      y: A
    } = this.scale;
    e.applyTransform([t || 0, 0, 0, A || 0, 0, 0]);
  }
}
class Gv {
  constructor(e, t, A) {
    this.type = "matrix", this.matrix = [], this.originX = null, this.originY = null, this.matrix = An(t), this.originX = A[0], this.originY = A[1];
  }
  apply(e) {
    var {
      originX: t,
      originY: A,
      matrix: n
    } = this, i = t.getPixels("x"), s = A.getPixels("y");
    e.translate(i, s), e.transform(n[0], n[1], n[2], n[3], n[4], n[5]), e.translate(-i, -s);
  }
  unapply(e) {
    var {
      originX: t,
      originY: A,
      matrix: n
    } = this, i = n[0], s = n[2], a = n[4], o = n[1], l = n[3], u = n[5], h = 0, f = 0, c = 1, p = 1 / (i * (l * c - u * f) - s * (o * c - u * h) + a * (o * f - l * h)), g = t.getPixels("x"), v = A.getPixels("y");
    e.translate(g, v), e.transform(p * (l * c - u * f), p * (u * h - o * c), p * (a * f - s * c), p * (i * c - a * h), p * (s * u - a * l), p * (a * o - i * u)), e.translate(-g, -v);
  }
  applyToPoint(e) {
    e.applyTransform(this.matrix);
  }
}
class Vv extends Gv {
  constructor(e, t, A) {
    super(e, t, A), this.type = "skew", this.angle = null, this.angle = new pt(e, "angle", t);
  }
}
class lF extends Vv {
  constructor(e, t, A) {
    super(e, t, A), this.type = "skewX", this.matrix = [1, 0, Math.tan(this.angle.getRadians()), 1, 0, 0];
  }
}
class uF extends Vv {
  constructor(e, t, A) {
    super(e, t, A), this.type = "skewY", this.matrix = [1, Math.tan(this.angle.getRadians()), 0, 1, 0, 0];
  }
}
function l8(r) {
  return Ga(r).trim().replace(/\)([a-zA-Z])/g, ") $1").replace(/\)(\s?,\s?)/g, ") ").split(/\s(?=[a-z])/);
}
function u8(r) {
  var [e, t] = r.split("(");
  return [e.trim(), t.trim().replace(")", "")];
}
class Gs {
  constructor(e, t, A) {
    this.document = e, this.transforms = [];
    var n = l8(t);
    n.forEach((i) => {
      if (i !== "none") {
        var [s, a] = u8(i), o = Gs.transformTypes[s];
        typeof o < "u" && this.transforms.push(new o(this.document, a, A));
      }
    });
  }
  static fromElement(e, t) {
    var A = t.getStyle("transform", !1, !0), [n, i = n] = t.getStyle("transform-origin", !1, !0).split(), s = [n, i];
    return A.hasValue() ? new Gs(e, A.getString(), s) : null;
  }
  apply(e) {
    for (var {
      transforms: t
    } = this, A = t.length, n = 0; n < A; n++)
      t[n].apply(e);
  }
  unapply(e) {
    for (var {
      transforms: t
    } = this, A = t.length, n = A - 1; n >= 0; n--)
      t[n].unapply(e);
  }
  // TODO: applyToPoint unused ... remove?
  applyToPoint(e) {
    for (var {
      transforms: t
    } = this, A = t.length, n = 0; n < A; n++)
      t[n].applyToPoint(e);
  }
}
Gs.transformTypes = {
  translate: sF,
  rotate: aF,
  scale: oF,
  matrix: Gv,
  skewX: lF,
  skewY: uF
};
class gr {
  constructor(e, t) {
    var A = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
    if (this.document = e, this.node = t, this.captureTextNodes = A, this.attributes = /* @__PURE__ */ Object.create(null), this.styles = /* @__PURE__ */ Object.create(null), this.stylesSpecificity = /* @__PURE__ */ Object.create(null), this.animationFrozen = !1, this.animationFrozenValue = "", this.parent = null, this.children = [], !(!t || t.nodeType !== 1)) {
      if (Array.from(t.attributes).forEach((a) => {
        var o = ZE(a.nodeName);
        this.attributes[o] = new pt(e, o, a.value);
      }), this.addStylesFromStyleDefinition(), this.getAttribute("style").hasValue()) {
        var n = this.getAttribute("style").getString().split(";").map((a) => a.trim());
        n.forEach((a) => {
          if (a) {
            var [o, l] = a.split(":").map((u) => u.trim());
            this.styles[o] = new pt(e, o, l);
          }
        });
      }
      var {
        definitions: i
      } = e, s = this.getAttribute("id");
      s.hasValue() && (i[s.getString()] || (i[s.getString()] = this)), Array.from(t.childNodes).forEach((a) => {
        if (a.nodeType === 1)
          this.addChild(a);
        else if (A && (a.nodeType === 3 || a.nodeType === 4)) {
          var o = e.createTextNode(a);
          o.getText().length > 0 && this.addChild(o);
        }
      });
    }
  }
  getAttribute(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, A = this.attributes[e];
    if (!A && t) {
      var n = new pt(this.document, e, "");
      return this.attributes[e] = n, n;
    }
    return A || pt.empty(this.document);
  }
  getHrefAttribute() {
    for (var e in this.attributes)
      if (e === "href" || e.endsWith(":href"))
        return this.attributes[e];
    return pt.empty(this.document);
  }
  getStyle(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, A = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, n = this.styles[e];
    if (n)
      return n;
    var i = this.getAttribute(e);
    if (i != null && i.hasValue())
      return this.styles[e] = i, i;
    if (!A) {
      var {
        parent: s
      } = this;
      if (s) {
        var a = s.getStyle(e);
        if (a != null && a.hasValue())
          return a;
      }
    }
    if (t) {
      var o = new pt(this.document, e, "");
      return this.styles[e] = o, o;
    }
    return n || pt.empty(this.document);
  }
  render(e) {
    if (!(this.getStyle("display").getString() === "none" || this.getStyle("visibility").getString() === "hidden")) {
      if (e.save(), this.getStyle("mask").hasValue()) {
        var t = this.getStyle("mask").getDefinition();
        t && (this.applyEffects(e), t.apply(e, this));
      } else if (this.getStyle("filter").getValue("none") !== "none") {
        var A = this.getStyle("filter").getDefinition();
        A && (this.applyEffects(e), A.apply(e, this));
      } else
        this.setContext(e), this.renderChildren(e), this.clearContext(e);
      e.restore();
    }
  }
  setContext(e) {
  }
  applyEffects(e) {
    var t = Gs.fromElement(this.document, this);
    t && t.apply(e);
    var A = this.getStyle("clip-path", !1, !0);
    if (A.hasValue()) {
      var n = A.getDefinition();
      n && n.apply(e);
    }
  }
  clearContext(e) {
  }
  renderChildren(e) {
    this.children.forEach((t) => {
      t.render(e);
    });
  }
  addChild(e) {
    var t = e instanceof gr ? e : this.document.createElement(e);
    t.parent = this, gr.ignoreChildTypes.includes(t.type) || this.children.push(t);
  }
  matchesSelector(e) {
    var t, {
      node: A
    } = this;
    if (typeof A.matches == "function")
      return A.matches(e);
    var n = (t = A.getAttribute) === null || t === void 0 ? void 0 : t.call(A, "class");
    return !n || n === "" ? !1 : n.split(" ").some((i) => ".".concat(i) === e);
  }
  addStylesFromStyleDefinition() {
    var {
      styles: e,
      stylesSpecificity: t
    } = this.document;
    for (var A in e)
      if (!A.startsWith("@") && this.matchesSelector(A)) {
        var n = e[A], i = t[A];
        if (n)
          for (var s in n) {
            var a = this.stylesSpecificity[s];
            typeof a > "u" && (a = "000"), i >= a && (this.styles[s] = n[s], this.stylesSpecificity[s] = i);
          }
      }
  }
  removeStyles(e, t) {
    var A = t.reduce((n, i) => {
      var s = e.getStyle(i);
      if (!s.hasValue())
        return n;
      var a = s.getString();
      return s.setValue(""), [...n, [i, a]];
    }, []);
    return A;
  }
  restoreStyles(e, t) {
    t.forEach((A) => {
      var [n, i] = A;
      e.getStyle(n, !0).setValue(i);
    });
  }
  isFirstChild() {
    var e;
    return ((e = this.parent) === null || e === void 0 ? void 0 : e.children.indexOf(this)) === 0;
  }
}
gr.ignoreChildTypes = ["title"];
class cF extends gr {
  constructor(e, t, A) {
    super(e, t, A);
  }
}
function c8(r) {
  var e = r.trim();
  return /^('|")/.test(e) ? e : '"'.concat(e, '"');
}
function h8(r) {
  return typeof process > "u" ? r : r.trim().split(",").map(c8).join(",");
}
function f8(r) {
  if (!r)
    return "";
  var e = r.trim().toLowerCase();
  switch (e) {
    case "normal":
    case "italic":
    case "oblique":
    case "inherit":
    case "initial":
    case "unset":
      return e;
    default:
      return /^oblique\s+(-|)\d+deg$/.test(e) ? e : "";
  }
}
function d8(r) {
  if (!r)
    return "";
  var e = r.trim().toLowerCase();
  switch (e) {
    case "normal":
    case "bold":
    case "lighter":
    case "bolder":
    case "inherit":
    case "initial":
    case "unset":
      return e;
    default:
      return /^[\d.]+$/.test(e) ? e : "";
  }
}
class OA {
  constructor(e, t, A, n, i, s) {
    var a = s ? typeof s == "string" ? OA.parse(s) : s : {};
    this.fontFamily = i || a.fontFamily, this.fontSize = n || a.fontSize, this.fontStyle = e || a.fontStyle, this.fontWeight = A || a.fontWeight, this.fontVariant = t || a.fontVariant;
  }
  static parse() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", t = arguments.length > 1 ? arguments[1] : void 0, A = "", n = "", i = "", s = "", a = "", o = Ga(e).trim().split(" "), l = {
      fontSize: !1,
      fontStyle: !1,
      fontWeight: !1,
      fontVariant: !1
    };
    return o.forEach((u) => {
      switch (!0) {
        case (!l.fontStyle && OA.styles.includes(u)):
          u !== "inherit" && (A = u), l.fontStyle = !0;
          break;
        case (!l.fontVariant && OA.variants.includes(u)):
          u !== "inherit" && (n = u), l.fontStyle = !0, l.fontVariant = !0;
          break;
        case (!l.fontWeight && OA.weights.includes(u)):
          u !== "inherit" && (i = u), l.fontStyle = !0, l.fontVariant = !0, l.fontWeight = !0;
          break;
        case !l.fontSize:
          u !== "inherit" && ([s] = u.split("/")), l.fontStyle = !0, l.fontVariant = !0, l.fontWeight = !0, l.fontSize = !0;
          break;
        default:
          u !== "inherit" && (a += u);
      }
    }), new OA(A, n, i, s, a, t);
  }
  toString() {
    return [
      f8(this.fontStyle),
      this.fontVariant,
      d8(this.fontWeight),
      this.fontSize,
      // Wrap fontFamily only on nodejs and only for canvas.ctx
      h8(this.fontFamily)
    ].join(" ").trim();
  }
}
OA.styles = "normal|italic|oblique|inherit";
OA.variants = "normal|small-caps|inherit";
OA.weights = "normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900|inherit";
class Dn {
  constructor() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Number.NaN, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Number.NaN, A = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Number.NaN, n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Number.NaN;
    this.x1 = e, this.y1 = t, this.x2 = A, this.y2 = n, this.addPoint(e, t), this.addPoint(A, n);
  }
  get x() {
    return this.x1;
  }
  get y() {
    return this.y1;
  }
  get width() {
    return this.x2 - this.x1;
  }
  get height() {
    return this.y2 - this.y1;
  }
  addPoint(e, t) {
    typeof e < "u" && ((isNaN(this.x1) || isNaN(this.x2)) && (this.x1 = e, this.x2 = e), e < this.x1 && (this.x1 = e), e > this.x2 && (this.x2 = e)), typeof t < "u" && ((isNaN(this.y1) || isNaN(this.y2)) && (this.y1 = t, this.y2 = t), t < this.y1 && (this.y1 = t), t > this.y2 && (this.y2 = t));
  }
  addX(e) {
    this.addPoint(e, null);
  }
  addY(e) {
    this.addPoint(null, e);
  }
  addBoundingBox(e) {
    if (e) {
      var {
        x1: t,
        y1: A,
        x2: n,
        y2: i
      } = e;
      this.addPoint(t, A), this.addPoint(n, i);
    }
  }
  sumCubic(e, t, A, n, i) {
    return Math.pow(1 - e, 3) * t + 3 * Math.pow(1 - e, 2) * e * A + 3 * (1 - e) * Math.pow(e, 2) * n + Math.pow(e, 3) * i;
  }
  bezierCurveAdd(e, t, A, n, i) {
    var s = 6 * t - 12 * A + 6 * n, a = -3 * t + 9 * A - 9 * n + 3 * i, o = 3 * A - 3 * t;
    if (a === 0) {
      if (s === 0)
        return;
      var l = -o / s;
      0 < l && l < 1 && (e ? this.addX(this.sumCubic(l, t, A, n, i)) : this.addY(this.sumCubic(l, t, A, n, i)));
      return;
    }
    var u = Math.pow(s, 2) - 4 * o * a;
    if (!(u < 0)) {
      var h = (-s + Math.sqrt(u)) / (2 * a);
      0 < h && h < 1 && (e ? this.addX(this.sumCubic(h, t, A, n, i)) : this.addY(this.sumCubic(h, t, A, n, i)));
      var f = (-s - Math.sqrt(u)) / (2 * a);
      0 < f && f < 1 && (e ? this.addX(this.sumCubic(f, t, A, n, i)) : this.addY(this.sumCubic(f, t, A, n, i)));
    }
  }
  // from http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
  addBezierCurve(e, t, A, n, i, s, a, o) {
    this.addPoint(e, t), this.addPoint(a, o), this.bezierCurveAdd(!0, e, A, i, a), this.bezierCurveAdd(!1, t, n, s, o);
  }
  addQuadraticCurve(e, t, A, n, i, s) {
    var a = e + 0.6666666666666666 * (A - e), o = t + 2 / 3 * (n - t), l = a + 1 / 3 * (i - e), u = o + 1 / 3 * (s - t);
    this.addBezierCurve(e, t, a, l, o, u, i, s);
  }
  isPointInBox(e, t) {
    var {
      x1: A,
      y1: n,
      x2: i,
      y2: s
    } = this;
    return A <= e && e <= i && n <= t && t <= s;
  }
}
class Ut extends Ue {
  constructor(e) {
    super(e.replace(/([+\-.])\s+/gm, "$1").replace(/[^MmZzLlHhVvCcSsQqTtAae\d\s.,+-].*/g, "")), this.control = null, this.start = null, this.current = null, this.command = null, this.commands = this.commands, this.i = -1, this.previousCommand = null, this.points = [], this.angles = [];
  }
  reset() {
    this.i = -1, this.command = null, this.previousCommand = null, this.start = new Lr(0, 0), this.control = new Lr(0, 0), this.current = new Lr(0, 0), this.points = [], this.angles = [];
  }
  isEnd() {
    var {
      i: e,
      commands: t
    } = this;
    return e >= t.length - 1;
  }
  next() {
    var e = this.commands[++this.i];
    return this.previousCommand = this.command, this.command = e, e;
  }
  getPoint() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "x", t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "y", A = new Lr(this.command[e], this.command[t]);
    return this.makeAbsolute(A);
  }
  getAsControlPoint(e, t) {
    var A = this.getPoint(e, t);
    return this.control = A, A;
  }
  getAsCurrentPoint(e, t) {
    var A = this.getPoint(e, t);
    return this.current = A, A;
  }
  getReflectedControlPoint() {
    var e = this.previousCommand.type;
    if (e !== Ue.CURVE_TO && e !== Ue.SMOOTH_CURVE_TO && e !== Ue.QUAD_TO && e !== Ue.SMOOTH_QUAD_TO)
      return this.current;
    var {
      current: {
        x: t,
        y: A
      },
      control: {
        x: n,
        y: i
      }
    } = this, s = new Lr(2 * t - n, 2 * A - i);
    return s;
  }
  makeAbsolute(e) {
    if (this.command.relative) {
      var {
        x: t,
        y: A
      } = this.current;
      e.x += t, e.y += A;
    }
    return e;
  }
  addMarker(e, t, A) {
    var {
      points: n,
      angles: i
    } = this;
    A && i.length > 0 && !i[i.length - 1] && (i[i.length - 1] = n[n.length - 1].angleTo(A)), this.addMarkerAngle(e, t ? t.angleTo(e) : null);
  }
  addMarkerAngle(e, t) {
    this.points.push(e), this.angles.push(t);
  }
  getMarkerPoints() {
    return this.points;
  }
  getMarkerAngles() {
    for (var {
      angles: e
    } = this, t = e.length, A = 0; A < t; A++)
      if (!e[A]) {
        for (var n = A + 1; n < t; n++)
          if (e[n]) {
            e[A] = e[n];
            break;
          }
      }
    return e;
  }
}
class Ws extends gr {
  constructor() {
    super(...arguments), this.modifiedEmSizeStack = !1;
  }
  calculateOpacity() {
    for (var e = 1, t = this; t; ) {
      var A = t.getStyle("opacity", !1, !0);
      A.hasValue(!0) && (e *= A.getNumber()), t = t.parent;
    }
    return e;
  }
  setContext(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    if (!t) {
      var A = this.getStyle("fill"), n = this.getStyle("fill-opacity"), i = this.getStyle("stroke"), s = this.getStyle("stroke-opacity");
      if (A.isUrlDefinition()) {
        var a = A.getFillStyleDefinition(this, n);
        a && (e.fillStyle = a);
      } else if (A.hasValue()) {
        A.getString() === "currentColor" && A.setValue(this.getStyle("color").getColor());
        var o = A.getColor();
        o !== "inherit" && (e.fillStyle = o === "none" ? "rgba(0,0,0,0)" : o);
      }
      if (n.hasValue()) {
        var l = new pt(this.document, "fill", e.fillStyle).addOpacity(n).getColor();
        e.fillStyle = l;
      }
      if (i.isUrlDefinition()) {
        var u = i.getFillStyleDefinition(this, s);
        u && (e.strokeStyle = u);
      } else if (i.hasValue()) {
        i.getString() === "currentColor" && i.setValue(this.getStyle("color").getColor());
        var h = i.getString();
        h !== "inherit" && (e.strokeStyle = h === "none" ? "rgba(0,0,0,0)" : h);
      }
      if (s.hasValue()) {
        var f = new pt(this.document, "stroke", e.strokeStyle).addOpacity(s).getString();
        e.strokeStyle = f;
      }
      var c = this.getStyle("stroke-width");
      if (c.hasValue()) {
        var p = c.getPixels();
        e.lineWidth = p || _a;
      }
      var g = this.getStyle("stroke-linecap"), v = this.getStyle("stroke-linejoin"), w = this.getStyle("stroke-miterlimit"), B = this.getStyle("stroke-dasharray"), S = this.getStyle("stroke-dashoffset");
      if (g.hasValue() && (e.lineCap = g.getString()), v.hasValue() && (e.lineJoin = v.getString()), w.hasValue() && (e.miterLimit = w.getNumber()), B.hasValue() && B.getString() !== "none") {
        var C = An(B.getString());
        typeof e.setLineDash < "u" ? e.setLineDash(C) : typeof e.webkitLineDash < "u" ? e.webkitLineDash = C : typeof e.mozDash < "u" && !(C.length === 1 && C[0] === 0) && (e.mozDash = C);
        var E = S.getPixels();
        typeof e.lineDashOffset < "u" ? e.lineDashOffset = E : typeof e.webkitLineDashOffset < "u" ? e.webkitLineDashOffset = E : typeof e.mozDashOffset < "u" && (e.mozDashOffset = E);
      }
    }
    if (this.modifiedEmSizeStack = !1, typeof e.font < "u") {
      var _ = this.getStyle("font"), I = this.getStyle("font-style"), O = this.getStyle("font-variant"), U = this.getStyle("font-weight"), V = this.getStyle("font-size"), F = this.getStyle("font-family"), P = new OA(I.getString(), O.getString(), U.getString(), V.hasValue() ? "".concat(V.getPixels(!0), "px") : "", F.getString(), OA.parse(_.getString(), e.font));
      I.setValue(P.fontStyle), O.setValue(P.fontVariant), U.setValue(P.fontWeight), V.setValue(P.fontSize), F.setValue(P.fontFamily), e.font = P.toString(), V.isPixels() && (this.document.emSize = V.getPixels(), this.modifiedEmSizeStack = !0);
    }
    t || (this.applyEffects(e), e.globalAlpha = this.calculateOpacity());
  }
  clearContext(e) {
    super.clearContext(e), this.modifiedEmSizeStack && this.document.popEmSize();
  }
}
class er extends Ws {
  constructor(e, t, A) {
    super(e, t, A), this.type = "path", this.pathParser = null, this.pathParser = new Ut(this.getAttribute("d").getString());
  }
  path(e) {
    var {
      pathParser: t
    } = this, A = new Dn();
    for (t.reset(), e && e.beginPath(); !t.isEnd(); )
      switch (t.next().type) {
        case Ut.MOVE_TO:
          this.pathM(e, A);
          break;
        case Ut.LINE_TO:
          this.pathL(e, A);
          break;
        case Ut.HORIZ_LINE_TO:
          this.pathH(e, A);
          break;
        case Ut.VERT_LINE_TO:
          this.pathV(e, A);
          break;
        case Ut.CURVE_TO:
          this.pathC(e, A);
          break;
        case Ut.SMOOTH_CURVE_TO:
          this.pathS(e, A);
          break;
        case Ut.QUAD_TO:
          this.pathQ(e, A);
          break;
        case Ut.SMOOTH_QUAD_TO:
          this.pathT(e, A);
          break;
        case Ut.ARC:
          this.pathA(e, A);
          break;
        case Ut.CLOSE_PATH:
          this.pathZ(e, A);
          break;
      }
    return A;
  }
  getBoundingBox(e) {
    return this.path();
  }
  getMarkers() {
    var {
      pathParser: e
    } = this, t = e.getMarkerPoints(), A = e.getMarkerAngles(), n = t.map((i, s) => [i, A[s]]);
    return n;
  }
  renderChildren(e) {
    this.path(e), this.document.screen.mouse.checkPath(this, e);
    var t = this.getStyle("fill-rule");
    e.fillStyle !== "" && (t.getString("inherit") !== "inherit" ? e.fill(t.getString()) : e.fill()), e.strokeStyle !== "" && (this.getAttribute("vector-effect").getString() === "non-scaling-stroke" ? (e.save(), e.setTransform(1, 0, 0, 1, 0, 0), e.stroke(), e.restore()) : e.stroke());
    var A = this.getMarkers();
    if (A) {
      var n = A.length - 1, i = this.getStyle("marker-start"), s = this.getStyle("marker-mid"), a = this.getStyle("marker-end");
      if (i.isUrlDefinition()) {
        var o = i.getDefinition(), [l, u] = A[0];
        o.render(e, l, u);
      }
      if (s.isUrlDefinition())
        for (var h = s.getDefinition(), f = 1; f < n; f++) {
          var [c, p] = A[f];
          h.render(e, c, p);
        }
      if (a.isUrlDefinition()) {
        var g = a.getDefinition(), [v, w] = A[n];
        g.render(e, v, w);
      }
    }
  }
  static pathM(e) {
    var t = e.getAsCurrentPoint();
    return e.start = e.current, {
      point: t
    };
  }
  pathM(e, t) {
    var {
      pathParser: A
    } = this, {
      point: n
    } = er.pathM(A), {
      x: i,
      y: s
    } = n;
    A.addMarker(n), t.addPoint(i, s), e && e.moveTo(i, s);
  }
  static pathL(e) {
    var {
      current: t
    } = e, A = e.getAsCurrentPoint();
    return {
      current: t,
      point: A
    };
  }
  pathL(e, t) {
    var {
      pathParser: A
    } = this, {
      current: n,
      point: i
    } = er.pathL(A), {
      x: s,
      y: a
    } = i;
    A.addMarker(i, n), t.addPoint(s, a), e && e.lineTo(s, a);
  }
  static pathH(e) {
    var {
      current: t,
      command: A
    } = e, n = new Lr((A.relative ? t.x : 0) + A.x, t.y);
    return e.current = n, {
      current: t,
      point: n
    };
  }
  pathH(e, t) {
    var {
      pathParser: A
    } = this, {
      current: n,
      point: i
    } = er.pathH(A), {
      x: s,
      y: a
    } = i;
    A.addMarker(i, n), t.addPoint(s, a), e && e.lineTo(s, a);
  }
  static pathV(e) {
    var {
      current: t,
      command: A
    } = e, n = new Lr(t.x, (A.relative ? t.y : 0) + A.y);
    return e.current = n, {
      current: t,
      point: n
    };
  }
  pathV(e, t) {
    var {
      pathParser: A
    } = this, {
      current: n,
      point: i
    } = er.pathV(A), {
      x: s,
      y: a
    } = i;
    A.addMarker(i, n), t.addPoint(s, a), e && e.lineTo(s, a);
  }
  static pathC(e) {
    var {
      current: t
    } = e, A = e.getPoint("x1", "y1"), n = e.getAsControlPoint("x2", "y2"), i = e.getAsCurrentPoint();
    return {
      current: t,
      point: A,
      controlPoint: n,
      currentPoint: i
    };
  }
  pathC(e, t) {
    var {
      pathParser: A
    } = this, {
      current: n,
      point: i,
      controlPoint: s,
      currentPoint: a
    } = er.pathC(A);
    A.addMarker(a, s, i), t.addBezierCurve(n.x, n.y, i.x, i.y, s.x, s.y, a.x, a.y), e && e.bezierCurveTo(i.x, i.y, s.x, s.y, a.x, a.y);
  }
  static pathS(e) {
    var {
      current: t
    } = e, A = e.getReflectedControlPoint(), n = e.getAsControlPoint("x2", "y2"), i = e.getAsCurrentPoint();
    return {
      current: t,
      point: A,
      controlPoint: n,
      currentPoint: i
    };
  }
  pathS(e, t) {
    var {
      pathParser: A
    } = this, {
      current: n,
      point: i,
      controlPoint: s,
      currentPoint: a
    } = er.pathS(A);
    A.addMarker(a, s, i), t.addBezierCurve(n.x, n.y, i.x, i.y, s.x, s.y, a.x, a.y), e && e.bezierCurveTo(i.x, i.y, s.x, s.y, a.x, a.y);
  }
  static pathQ(e) {
    var {
      current: t
    } = e, A = e.getAsControlPoint("x1", "y1"), n = e.getAsCurrentPoint();
    return {
      current: t,
      controlPoint: A,
      currentPoint: n
    };
  }
  pathQ(e, t) {
    var {
      pathParser: A
    } = this, {
      current: n,
      controlPoint: i,
      currentPoint: s
    } = er.pathQ(A);
    A.addMarker(s, i, i), t.addQuadraticCurve(n.x, n.y, i.x, i.y, s.x, s.y), e && e.quadraticCurveTo(i.x, i.y, s.x, s.y);
  }
  static pathT(e) {
    var {
      current: t
    } = e, A = e.getReflectedControlPoint();
    e.control = A;
    var n = e.getAsCurrentPoint();
    return {
      current: t,
      controlPoint: A,
      currentPoint: n
    };
  }
  pathT(e, t) {
    var {
      pathParser: A
    } = this, {
      current: n,
      controlPoint: i,
      currentPoint: s
    } = er.pathT(A);
    A.addMarker(s, i, i), t.addQuadraticCurve(n.x, n.y, i.x, i.y, s.x, s.y), e && e.quadraticCurveTo(i.x, i.y, s.x, s.y);
  }
  static pathA(e) {
    var {
      current: t,
      command: A
    } = e, {
      rX: n,
      rY: i,
      xRot: s,
      lArcFlag: a,
      sweepFlag: o
    } = A, l = s * (Math.PI / 180), u = e.getAsCurrentPoint(), h = new Lr(Math.cos(l) * (t.x - u.x) / 2 + Math.sin(l) * (t.y - u.y) / 2, -Math.sin(l) * (t.x - u.x) / 2 + Math.cos(l) * (t.y - u.y) / 2), f = Math.pow(h.x, 2) / Math.pow(n, 2) + Math.pow(h.y, 2) / Math.pow(i, 2);
    f > 1 && (n *= Math.sqrt(f), i *= Math.sqrt(f));
    var c = (a === o ? -1 : 1) * Math.sqrt((Math.pow(n, 2) * Math.pow(i, 2) - Math.pow(n, 2) * Math.pow(h.y, 2) - Math.pow(i, 2) * Math.pow(h.x, 2)) / (Math.pow(n, 2) * Math.pow(h.y, 2) + Math.pow(i, 2) * Math.pow(h.x, 2)));
    isNaN(c) && (c = 0);
    var p = new Lr(c * n * h.y / i, c * -i * h.x / n), g = new Lr((t.x + u.x) / 2 + Math.cos(l) * p.x - Math.sin(l) * p.y, (t.y + u.y) / 2 + Math.sin(l) * p.x + Math.cos(l) * p.y), v = Nm([1, 0], [(h.x - p.x) / n, (h.y - p.y) / i]), w = [(h.x - p.x) / n, (h.y - p.y) / i], B = [(-h.x - p.x) / n, (-h.y - p.y) / i], S = Nm(w, B);
    return Uh(w, B) <= -1 && (S = Math.PI), Uh(w, B) >= 1 && (S = 0), {
      currentPoint: u,
      rX: n,
      rY: i,
      sweepFlag: o,
      xAxisRotation: l,
      centp: g,
      a1: v,
      ad: S
    };
  }
  pathA(e, t) {
    var {
      pathParser: A
    } = this, {
      currentPoint: n,
      rX: i,
      rY: s,
      sweepFlag: a,
      xAxisRotation: o,
      centp: l,
      a1: u,
      ad: h
    } = er.pathA(A), f = 1 - a ? 1 : -1, c = u + f * (h / 2), p = new Lr(l.x + i * Math.cos(c), l.y + s * Math.sin(c));
    if (A.addMarkerAngle(p, c - f * Math.PI / 2), A.addMarkerAngle(n, c - f * Math.PI), t.addPoint(n.x, n.y), e && !isNaN(u) && !isNaN(h)) {
      var g = i > s ? i : s, v = i > s ? 1 : i / s, w = i > s ? s / i : 1;
      e.translate(l.x, l.y), e.rotate(o), e.scale(v, w), e.arc(0, 0, g, u, u + h, !!(1 - a)), e.scale(1 / v, 1 / w), e.rotate(-o), e.translate(-l.x, -l.y);
    }
  }
  static pathZ(e) {
    e.current = e.start;
  }
  pathZ(e, t) {
    er.pathZ(this.pathParser), e && t.x1 !== t.x2 && t.y1 !== t.y2 && e.closePath();
  }
}
class Kv extends er {
  constructor(e, t, A) {
    super(e, t, A), this.type = "glyph", this.horizAdvX = this.getAttribute("horiz-adv-x").getNumber(), this.unicode = this.getAttribute("unicode").getString(), this.arabicForm = this.getAttribute("arabic-form").getString();
  }
}
class is extends Ws {
  constructor(e, t, A) {
    super(e, t, new.target === is ? !0 : A), this.type = "text", this.x = 0, this.y = 0, this.measureCache = -1;
  }
  setContext(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    super.setContext(e, t);
    var A = this.getStyle("dominant-baseline").getTextBaseline() || this.getStyle("alignment-baseline").getTextBaseline();
    A && (e.textBaseline = A);
  }
  initializeCoordinates() {
    this.x = 0, this.y = 0, this.leafTexts = [], this.textChunkStart = 0, this.minX = Number.POSITIVE_INFINITY, this.maxX = Number.NEGATIVE_INFINITY;
  }
  getBoundingBox(e) {
    if (this.type !== "text")
      return this.getTElementBoundingBox(e);
    this.initializeCoordinates(), this.adjustChildCoordinatesRecursive(e);
    var t = null;
    return this.children.forEach((A, n) => {
      var i = this.getChildBoundingBox(e, this, this, n);
      t ? t.addBoundingBox(i) : t = i;
    }), t;
  }
  getFontSize() {
    var {
      document: e,
      parent: t
    } = this, A = OA.parse(e.ctx.font).fontSize, n = t.getStyle("font-size").getNumber(A);
    return n;
  }
  getTElementBoundingBox(e) {
    var t = this.getFontSize();
    return new Dn(this.x, this.y - t, this.x + this.measureText(e), this.y);
  }
  getGlyph(e, t, A) {
    var n = t[A], i = null;
    if (e.isArabic) {
      var s = t.length, a = t[A - 1], o = t[A + 1], l = "isolated";
      if ((A === 0 || a === " ") && A < s - 1 && o !== " " && (l = "terminal"), A > 0 && a !== " " && A < s - 1 && o !== " " && (l = "medial"), A > 0 && a !== " " && (A === s - 1 || o === " ") && (l = "initial"), typeof e.glyphs[n] < "u") {
        var u = e.glyphs[n];
        i = u instanceof Kv ? u : u[l];
      }
    } else
      i = e.glyphs[n];
    return i || (i = e.missingGlyph), i;
  }
  getText() {
    return "";
  }
  getTextFromNode(e) {
    var t = e || this.node, A = Array.from(t.parentNode.childNodes), n = A.indexOf(t), i = A.length - 1, s = Ga(
      // textNode.value
      // || textNode.text
      t.textContent || ""
    );
    return n === 0 && (s = JE(s)), n === i && (s = $E(s)), s;
  }
  renderChildren(e) {
    if (this.type !== "text") {
      this.renderTElementChildren(e);
      return;
    }
    this.initializeCoordinates(), this.adjustChildCoordinatesRecursive(e), this.children.forEach((A, n) => {
      this.renderChild(e, this, this, n);
    });
    var {
      mouse: t
    } = this.document.screen;
    t.isWorking() && t.checkBoundingBox(this, this.getBoundingBox(e));
  }
  renderTElementChildren(e) {
    var {
      document: t,
      parent: A
    } = this, n = this.getText(), i = A.getStyle("font-family").getDefinition();
    if (i) {
      for (var {
        unitsPerEm: s
      } = i.fontFace, a = OA.parse(t.ctx.font), o = A.getStyle("font-size").getNumber(a.fontSize), l = A.getStyle("font-style").getString(a.fontStyle), u = o / s, h = i.isRTL ? n.split("").reverse().join("") : n, f = An(A.getAttribute("dx").getString()), c = h.length, p = 0; p < c; p++) {
        var g = this.getGlyph(i, h, p);
        e.translate(this.x, this.y), e.scale(u, -u);
        var v = e.lineWidth;
        e.lineWidth = e.lineWidth * s / o, l === "italic" && e.transform(1, 0, 0.4, 1, 0, 0), g.render(e), l === "italic" && e.transform(1, 0, -0.4, 1, 0, 0), e.lineWidth = v, e.scale(1 / u, -1 / u), e.translate(-this.x, -this.y), this.x += o * (g.horizAdvX || i.horizAdvX) / s, typeof f[p] < "u" && !isNaN(f[p]) && (this.x += f[p]);
      }
      return;
    }
    var {
      x: w,
      y: B
    } = this;
    e.fillStyle && e.fillText(n, w, B), e.strokeStyle && e.strokeText(n, w, B);
  }
  applyAnchoring() {
    if (!(this.textChunkStart >= this.leafTexts.length)) {
      var e = this.leafTexts[this.textChunkStart], t = e.getStyle("text-anchor").getString("start"), A = !1, n = 0;
      t === "start" && !A || t === "end" && A ? n = e.x - this.minX : t === "end" && !A || t === "start" && A ? n = e.x - this.maxX : n = e.x - (this.minX + this.maxX) / 2;
      for (var i = this.textChunkStart; i < this.leafTexts.length; i++)
        this.leafTexts[i].x += n;
      this.minX = Number.POSITIVE_INFINITY, this.maxX = Number.NEGATIVE_INFINITY, this.textChunkStart = this.leafTexts.length;
    }
  }
  adjustChildCoordinatesRecursive(e) {
    this.children.forEach((t, A) => {
      this.adjustChildCoordinatesRecursiveCore(e, this, this, A);
    }), this.applyAnchoring();
  }
  adjustChildCoordinatesRecursiveCore(e, t, A, n) {
    var i = A.children[n];
    i.children.length > 0 ? i.children.forEach((s, a) => {
      t.adjustChildCoordinatesRecursiveCore(e, t, i, a);
    }) : this.adjustChildCoordinates(e, t, A, n);
  }
  adjustChildCoordinates(e, t, A, n) {
    var i = A.children[n];
    if (typeof i.measureText != "function")
      return i;
    e.save(), i.setContext(e, !0);
    var s = i.getAttribute("x"), a = i.getAttribute("y"), o = i.getAttribute("dx"), l = i.getAttribute("dy"), u = i.getStyle("font-family").getDefinition(), h = !!u && u.isRTL;
    n === 0 && (s.hasValue() || s.setValue(i.getInheritedAttribute("x")), a.hasValue() || a.setValue(i.getInheritedAttribute("y")), o.hasValue() || o.setValue(i.getInheritedAttribute("dx")), l.hasValue() || l.setValue(i.getInheritedAttribute("dy")));
    var f = i.measureText(e);
    return h && (t.x -= f), s.hasValue() ? (t.applyAnchoring(), i.x = s.getPixels("x"), o.hasValue() && (i.x += o.getPixels("x"))) : (o.hasValue() && (t.x += o.getPixels("x")), i.x = t.x), t.x = i.x, h || (t.x += f), a.hasValue() ? (i.y = a.getPixels("y"), l.hasValue() && (i.y += l.getPixels("y"))) : (l.hasValue() && (t.y += l.getPixels("y")), i.y = t.y), t.y = i.y, t.leafTexts.push(i), t.minX = Math.min(t.minX, i.x, i.x + f), t.maxX = Math.max(t.maxX, i.x, i.x + f), i.clearContext(e), e.restore(), i;
  }
  getChildBoundingBox(e, t, A, n) {
    var i = A.children[n];
    if (typeof i.getBoundingBox != "function")
      return null;
    var s = i.getBoundingBox(e);
    return s ? (i.children.forEach((a, o) => {
      var l = t.getChildBoundingBox(e, t, i, o);
      s.addBoundingBox(l);
    }), s) : null;
  }
  renderChild(e, t, A, n) {
    var i = A.children[n];
    i.render(e), i.children.forEach((s, a) => {
      t.renderChild(e, t, i, a);
    });
  }
  measureText(e) {
    var {
      measureCache: t
    } = this;
    if (~t)
      return t;
    var A = this.getText(), n = this.measureTargetText(e, A);
    return this.measureCache = n, n;
  }
  measureTargetText(e, t) {
    if (!t.length)
      return 0;
    var {
      parent: A
    } = this, n = A.getStyle("font-family").getDefinition();
    if (n) {
      for (var i = this.getFontSize(), s = n.isRTL ? t.split("").reverse().join("") : t, a = An(A.getAttribute("dx").getString()), o = s.length, l = 0, u = 0; u < o; u++) {
        var h = this.getGlyph(n, s, u);
        l += (h.horizAdvX || n.horizAdvX) * i / n.fontFace.unitsPerEm, typeof a[u] < "u" && !isNaN(a[u]) && (l += a[u]);
      }
      return l;
    }
    if (!e.measureText)
      return t.length * 10;
    e.save(), this.setContext(e, !0);
    var {
      width: f
    } = e.measureText(t);
    return this.clearContext(e), e.restore(), f;
  }
  /**
   * Inherits positional attributes from {@link TextElement} parent(s). Attributes
   * are only inherited from a parent to its first child.
   * @param name - The attribute name.
   * @returns The attribute value or null.
   */
  getInheritedAttribute(e) {
    for (var t = this; t instanceof is && t.isFirstChild(); ) {
      var A = t.parent.getAttribute(e);
      if (A.hasValue(!0))
        return A.getValue("0");
      t = t.parent;
    }
    return null;
  }
}
class xu extends is {
  constructor(e, t, A) {
    super(e, t, new.target === xu ? !0 : A), this.type = "tspan", this.text = this.children.length > 0 ? "" : this.getTextFromNode();
  }
  getText() {
    return this.text;
  }
}
class g8 extends xu {
  constructor() {
    super(...arguments), this.type = "textNode";
  }
}
class Ro extends Ws {
  constructor() {
    super(...arguments), this.type = "svg", this.root = !1;
  }
  setContext(e) {
    var t, {
      document: A
    } = this, {
      screen: n,
      window: i
    } = A, s = e.canvas;
    if (n.setDefaults(e), s.style && typeof e.font < "u" && i && typeof i.getComputedStyle < "u") {
      e.font = i.getComputedStyle(s).getPropertyValue("font");
      var a = new pt(A, "fontSize", OA.parse(e.font).fontSize);
      a.hasValue() && (A.rootEmSize = a.getPixels("y"), A.emSize = A.rootEmSize);
    }
    this.getAttribute("x").hasValue() || this.getAttribute("x", !0).setValue(0), this.getAttribute("y").hasValue() || this.getAttribute("y", !0).setValue(0);
    var {
      width: o,
      height: l
    } = n.viewPort;
    this.getStyle("width").hasValue() || this.getStyle("width", !0).setValue("100%"), this.getStyle("height").hasValue() || this.getStyle("height", !0).setValue("100%"), this.getStyle("color").hasValue() || this.getStyle("color", !0).setValue("black");
    var u = this.getAttribute("refX"), h = this.getAttribute("refY"), f = this.getAttribute("viewBox"), c = f.hasValue() ? An(f.getString()) : null, p = !this.root && this.getStyle("overflow").getValue("hidden") !== "visible", g = 0, v = 0, w = 0, B = 0;
    c && (g = c[0], v = c[1]), this.root || (o = this.getStyle("width").getPixels("x"), l = this.getStyle("height").getPixels("y"), this.type === "marker" && (w = g, B = v, g = 0, v = 0)), n.viewPort.setCurrent(o, l), this.node && (!this.parent || ((t = this.node.parentNode) === null || t === void 0 ? void 0 : t.nodeName) === "foreignObject") && this.getStyle("transform", !1, !0).hasValue() && !this.getStyle("transform-origin", !1, !0).hasValue() && this.getStyle("transform-origin", !0, !0).setValue("50% 50%"), super.setContext(e), e.translate(this.getAttribute("x").getPixels("x"), this.getAttribute("y").getPixels("y")), c && (o = c[2], l = c[3]), A.setViewBox({
      ctx: e,
      aspectRatio: this.getAttribute("preserveAspectRatio").getString(),
      width: n.viewPort.width,
      desiredWidth: o,
      height: n.viewPort.height,
      desiredHeight: l,
      minX: g,
      minY: v,
      refX: u.getValue(),
      refY: h.getValue(),
      clip: p,
      clipX: w,
      clipY: B
    }), c && (n.viewPort.removeCurrent(), n.viewPort.setCurrent(o, l));
  }
  clearContext(e) {
    super.clearContext(e), this.document.screen.viewPort.removeCurrent();
  }
  /**
   * Resize SVG to fit in given size.
   * @param width
   * @param height
   * @param preserveAspectRatio
   */
  resize(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, A = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, n = this.getAttribute("width", !0), i = this.getAttribute("height", !0), s = this.getAttribute("viewBox"), a = this.getAttribute("style"), o = n.getNumber(0), l = i.getNumber(0);
    if (A)
      if (typeof A == "string")
        this.getAttribute("preserveAspectRatio", !0).setValue(A);
      else {
        var u = this.getAttribute("preserveAspectRatio");
        u.hasValue() && u.setValue(u.getString().replace(/^\s*(\S.*\S)\s*$/, "$1"));
      }
    if (n.setValue(e), i.setValue(t), s.hasValue() || s.setValue("0 0 ".concat(o || e, " ").concat(l || t)), a.hasValue()) {
      var h = this.getStyle("width"), f = this.getStyle("height");
      h.hasValue() && h.setValue("".concat(e, "px")), f.hasValue() && f.setValue("".concat(t, "px"));
    }
  }
}
class jv extends er {
  constructor() {
    super(...arguments), this.type = "rect";
  }
  path(e) {
    var t = this.getAttribute("x").getPixels("x"), A = this.getAttribute("y").getPixels("y"), n = this.getStyle("width", !1, !0).getPixels("x"), i = this.getStyle("height", !1, !0).getPixels("y"), s = this.getAttribute("rx"), a = this.getAttribute("ry"), o = s.getPixels("x"), l = a.getPixels("y");
    if (s.hasValue() && !a.hasValue() && (l = o), a.hasValue() && !s.hasValue() && (o = l), o = Math.min(o, n / 2), l = Math.min(l, i / 2), e) {
      var u = 4 * ((Math.sqrt(2) - 1) / 3);
      e.beginPath(), i > 0 && n > 0 && (e.moveTo(t + o, A), e.lineTo(t + n - o, A), e.bezierCurveTo(t + n - o + u * o, A, t + n, A + l - u * l, t + n, A + l), e.lineTo(t + n, A + i - l), e.bezierCurveTo(t + n, A + i - l + u * l, t + n - o + u * o, A + i, t + n - o, A + i), e.lineTo(t + o, A + i), e.bezierCurveTo(t + o - u * o, A + i, t, A + i - l + u * l, t, A + i - l), e.lineTo(t, A + l), e.bezierCurveTo(t, A + l - u * l, t + o - u * o, A, t + o, A), e.closePath());
    }
    return new Dn(t, A, t + n, A + i);
  }
  getMarkers() {
    return null;
  }
}
class hF extends er {
  constructor() {
    super(...arguments), this.type = "circle";
  }
  path(e) {
    var t = this.getAttribute("cx").getPixels("x"), A = this.getAttribute("cy").getPixels("y"), n = this.getAttribute("r").getPixels();
    return e && n > 0 && (e.beginPath(), e.arc(t, A, n, 0, Math.PI * 2, !1), e.closePath()), new Dn(t - n, A - n, t + n, A + n);
  }
  getMarkers() {
    return null;
  }
}
class fF extends er {
  constructor() {
    super(...arguments), this.type = "ellipse";
  }
  path(e) {
    var t = 4 * ((Math.sqrt(2) - 1) / 3), A = this.getAttribute("rx").getPixels("x"), n = this.getAttribute("ry").getPixels("y"), i = this.getAttribute("cx").getPixels("x"), s = this.getAttribute("cy").getPixels("y");
    return e && A > 0 && n > 0 && (e.beginPath(), e.moveTo(i + A, s), e.bezierCurveTo(i + A, s + t * n, i + t * A, s + n, i, s + n), e.bezierCurveTo(i - t * A, s + n, i - A, s + t * n, i - A, s), e.bezierCurveTo(i - A, s - t * n, i - t * A, s - n, i, s - n), e.bezierCurveTo(i + t * A, s - n, i + A, s - t * n, i + A, s), e.closePath()), new Dn(i - A, s - n, i + A, s + n);
  }
  getMarkers() {
    return null;
  }
}
class dF extends er {
  constructor() {
    super(...arguments), this.type = "line";
  }
  getPoints() {
    return [new Lr(this.getAttribute("x1").getPixels("x"), this.getAttribute("y1").getPixels("y")), new Lr(this.getAttribute("x2").getPixels("x"), this.getAttribute("y2").getPixels("y"))];
  }
  path(e) {
    var [{
      x: t,
      y: A
    }, {
      x: n,
      y: i
    }] = this.getPoints();
    return e && (e.beginPath(), e.moveTo(t, A), e.lineTo(n, i)), new Dn(t, A, n, i);
  }
  getMarkers() {
    var [e, t] = this.getPoints(), A = e.angleTo(t);
    return [[e, A], [t, A]];
  }
}
class qv extends er {
  constructor(e, t, A) {
    super(e, t, A), this.type = "polyline", this.points = [], this.points = Lr.parsePath(this.getAttribute("points").getString());
  }
  path(e) {
    var {
      points: t
    } = this, [{
      x: A,
      y: n
    }] = t, i = new Dn(A, n);
    return e && (e.beginPath(), e.moveTo(A, n)), t.forEach((s) => {
      var {
        x: a,
        y: o
      } = s;
      i.addPoint(a, o), e && e.lineTo(a, o);
    }), i;
  }
  getMarkers() {
    var {
      points: e
    } = this, t = e.length - 1, A = [];
    return e.forEach((n, i) => {
      i !== t && A.push([n, n.angleTo(e[i + 1])]);
    }), A.length > 0 && A.push([e[e.length - 1], A[A.length - 1][1]]), A;
  }
}
class gF extends qv {
  constructor() {
    super(...arguments), this.type = "polygon";
  }
  path(e) {
    var t = super.path(e), [{
      x: A,
      y: n
    }] = this.points;
    return e && (e.lineTo(A, n), e.closePath()), t;
  }
}
class pF extends gr {
  constructor() {
    super(...arguments), this.type = "pattern";
  }
  createPattern(e, t, A) {
    var n = this.getStyle("width").getPixels("x", !0), i = this.getStyle("height").getPixels("y", !0), s = new Ro(this.document, null);
    s.attributes.viewBox = new pt(this.document, "viewBox", this.getAttribute("viewBox").getValue()), s.attributes.width = new pt(this.document, "width", "".concat(n, "px")), s.attributes.height = new pt(this.document, "height", "".concat(i, "px")), s.attributes.transform = new pt(this.document, "transform", this.getAttribute("patternTransform").getValue()), s.children = this.children;
    var a = this.document.createCanvas(n, i), o = a.getContext("2d"), l = this.getAttribute("x"), u = this.getAttribute("y");
    l.hasValue() && u.hasValue() && o.translate(l.getPixels("x", !0), u.getPixels("y", !0)), A.hasValue() ? this.styles["fill-opacity"] = A : Reflect.deleteProperty(this.styles, "fill-opacity");
    for (var h = -1; h <= 1; h++)
      for (var f = -1; f <= 1; f++)
        o.save(), s.attributes.x = new pt(this.document, "x", h * a.width), s.attributes.y = new pt(this.document, "y", f * a.height), s.render(o), o.restore();
    var c = e.createPattern(a, "repeat");
    return c;
  }
}
class mF extends gr {
  constructor() {
    super(...arguments), this.type = "marker";
  }
  render(e, t, A) {
    if (t) {
      var {
        x: n,
        y: i
      } = t, s = this.getAttribute("orient").getString("auto"), a = this.getAttribute("markerUnits").getString("strokeWidth");
      e.translate(n, i), s === "auto" && e.rotate(A), a === "strokeWidth" && e.scale(e.lineWidth, e.lineWidth), e.save();
      var o = new Ro(this.document, null);
      o.type = this.type, o.attributes.viewBox = new pt(this.document, "viewBox", this.getAttribute("viewBox").getValue()), o.attributes.refX = new pt(this.document, "refX", this.getAttribute("refX").getValue()), o.attributes.refY = new pt(this.document, "refY", this.getAttribute("refY").getValue()), o.attributes.width = new pt(this.document, "width", this.getAttribute("markerWidth").getValue()), o.attributes.height = new pt(this.document, "height", this.getAttribute("markerHeight").getValue()), o.attributes.overflow = new pt(this.document, "overflow", this.getAttribute("overflow").getValue()), o.attributes.fill = new pt(this.document, "fill", this.getAttribute("fill").getColor("black")), o.attributes.stroke = new pt(this.document, "stroke", this.getAttribute("stroke").getValue("none")), o.children = this.children, o.render(e), e.restore(), a === "strokeWidth" && e.scale(1 / e.lineWidth, 1 / e.lineWidth), s === "auto" && e.rotate(-A), e.translate(-n, -i);
    }
  }
}
class vF extends gr {
  constructor() {
    super(...arguments), this.type = "defs";
  }
  render() {
  }
}
class lf extends Ws {
  constructor() {
    super(...arguments), this.type = "g";
  }
  getBoundingBox(e) {
    var t = new Dn();
    return this.children.forEach((A) => {
      t.addBoundingBox(A.getBoundingBox(e));
    }), t;
  }
}
class zv extends gr {
  constructor(e, t, A) {
    super(e, t, A), this.attributesToInherit = ["gradientUnits"], this.stops = [];
    var {
      stops: n,
      children: i
    } = this;
    i.forEach((s) => {
      s.type === "stop" && n.push(s);
    });
  }
  getGradientUnits() {
    return this.getAttribute("gradientUnits").getString("objectBoundingBox");
  }
  createGradient(e, t, A) {
    var n = this;
    this.getHrefAttribute().hasValue() && (n = this.getHrefAttribute().getDefinition(), this.inheritStopContainer(n));
    var {
      stops: i
    } = n, s = this.getGradient(e, t);
    if (!s)
      return this.addParentOpacity(A, i[i.length - 1].color);
    if (i.forEach((v) => {
      s.addColorStop(v.offset, this.addParentOpacity(A, v.color));
    }), this.getAttribute("gradientTransform").hasValue()) {
      var {
        document: a
      } = this, {
        MAX_VIRTUAL_PIXELS: o,
        viewPort: l
      } = a.screen, [u] = l.viewPorts, h = new jv(a, null);
      h.attributes.x = new pt(a, "x", -o / 3), h.attributes.y = new pt(a, "y", -o / 3), h.attributes.width = new pt(a, "width", o), h.attributes.height = new pt(a, "height", o);
      var f = new lf(a, null);
      f.attributes.transform = new pt(a, "transform", this.getAttribute("gradientTransform").getValue()), f.children = [h];
      var c = new Ro(a, null);
      c.attributes.x = new pt(a, "x", 0), c.attributes.y = new pt(a, "y", 0), c.attributes.width = new pt(a, "width", u.width), c.attributes.height = new pt(a, "height", u.height), c.children = [f];
      var p = a.createCanvas(u.width, u.height), g = p.getContext("2d");
      return g.fillStyle = s, c.render(g), g.createPattern(p, "no-repeat");
    }
    return s;
  }
  inheritStopContainer(e) {
    this.attributesToInherit.forEach((t) => {
      !this.getAttribute(t).hasValue() && e.getAttribute(t).hasValue() && this.getAttribute(t, !0).setValue(e.getAttribute(t).getValue());
    });
  }
  addParentOpacity(e, t) {
    if (e.hasValue()) {
      var A = new pt(this.document, "color", t);
      return A.addOpacity(e).getColor();
    }
    return t;
  }
}
class wF extends zv {
  constructor(e, t, A) {
    super(e, t, A), this.type = "linearGradient", this.attributesToInherit.push("x1", "y1", "x2", "y2");
  }
  getGradient(e, t) {
    var A = this.getGradientUnits() === "objectBoundingBox", n = A ? t.getBoundingBox(e) : null;
    if (A && !n)
      return null;
    !this.getAttribute("x1").hasValue() && !this.getAttribute("y1").hasValue() && !this.getAttribute("x2").hasValue() && !this.getAttribute("y2").hasValue() && (this.getAttribute("x1", !0).setValue(0), this.getAttribute("y1", !0).setValue(0), this.getAttribute("x2", !0).setValue(1), this.getAttribute("y2", !0).setValue(0));
    var i = A ? n.x + n.width * this.getAttribute("x1").getNumber() : this.getAttribute("x1").getPixels("x"), s = A ? n.y + n.height * this.getAttribute("y1").getNumber() : this.getAttribute("y1").getPixels("y"), a = A ? n.x + n.width * this.getAttribute("x2").getNumber() : this.getAttribute("x2").getPixels("x"), o = A ? n.y + n.height * this.getAttribute("y2").getNumber() : this.getAttribute("y2").getPixels("y");
    return i === a && s === o ? null : e.createLinearGradient(i, s, a, o);
  }
}
class yF extends zv {
  constructor(e, t, A) {
    super(e, t, A), this.type = "radialGradient", this.attributesToInherit.push("cx", "cy", "r", "fx", "fy", "fr");
  }
  getGradient(e, t) {
    var A = this.getGradientUnits() === "objectBoundingBox", n = t.getBoundingBox(e);
    if (A && !n)
      return null;
    this.getAttribute("cx").hasValue() || this.getAttribute("cx", !0).setValue("50%"), this.getAttribute("cy").hasValue() || this.getAttribute("cy", !0).setValue("50%"), this.getAttribute("r").hasValue() || this.getAttribute("r", !0).setValue("50%");
    var i = A ? n.x + n.width * this.getAttribute("cx").getNumber() : this.getAttribute("cx").getPixels("x"), s = A ? n.y + n.height * this.getAttribute("cy").getNumber() : this.getAttribute("cy").getPixels("y"), a = i, o = s;
    this.getAttribute("fx").hasValue() && (a = A ? n.x + n.width * this.getAttribute("fx").getNumber() : this.getAttribute("fx").getPixels("x")), this.getAttribute("fy").hasValue() && (o = A ? n.y + n.height * this.getAttribute("fy").getNumber() : this.getAttribute("fy").getPixels("y"));
    var l = A ? (n.width + n.height) / 2 * this.getAttribute("r").getNumber() : this.getAttribute("r").getPixels(), u = this.getAttribute("fr").getPixels();
    return e.createRadialGradient(a, o, u, i, s, l);
  }
}
class BF extends gr {
  constructor(e, t, A) {
    super(e, t, A), this.type = "stop";
    var n = Math.max(0, Math.min(1, this.getAttribute("offset").getNumber())), i = this.getStyle("stop-opacity"), s = this.getStyle("stop-color", !0);
    s.getString() === "" && s.setValue("#000"), i.hasValue() && (s = s.addOpacity(i)), this.offset = n, this.color = s.getColor();
  }
}
class uf extends gr {
  constructor(e, t, A) {
    super(e, t, A), this.type = "animate", this.duration = 0, this.initialValue = null, this.initialUnits = "", this.removed = !1, this.frozen = !1, e.screen.animations.push(this), this.begin = this.getAttribute("begin").getMilliseconds(), this.maxDuration = this.begin + this.getAttribute("dur").getMilliseconds(), this.from = this.getAttribute("from"), this.to = this.getAttribute("to"), this.values = new pt(e, "values", null);
    var n = this.getAttribute("values");
    n.hasValue() && this.values.setValue(n.getString().split(";"));
  }
  getProperty() {
    var e = this.getAttribute("attributeType").getString(), t = this.getAttribute("attributeName").getString();
    return e === "CSS" ? this.parent.getStyle(t, !0) : this.parent.getAttribute(t, !0);
  }
  calcValue() {
    var {
      initialUnits: e
    } = this, {
      progress: t,
      from: A,
      to: n
    } = this.getProgress(), i = A.getNumber() + (n.getNumber() - A.getNumber()) * t;
    return e === "%" && (i *= 100), "".concat(i).concat(e);
  }
  update(e) {
    var {
      parent: t
    } = this, A = this.getProperty();
    if (this.initialValue || (this.initialValue = A.getString(), this.initialUnits = A.getUnits()), this.duration > this.maxDuration) {
      var n = this.getAttribute("fill").getString("remove");
      if (this.getAttribute("repeatCount").getString() === "indefinite" || this.getAttribute("repeatDur").getString() === "indefinite")
        this.duration = 0;
      else if (n === "freeze" && !this.frozen)
        this.frozen = !0, t.animationFrozen = !0, t.animationFrozenValue = A.getString();
      else if (n === "remove" && !this.removed)
        return this.removed = !0, A.setValue(t.animationFrozen ? t.animationFrozenValue : this.initialValue), !0;
      return !1;
    }
    this.duration += e;
    var i = !1;
    if (this.begin < this.duration) {
      var s = this.calcValue(), a = this.getAttribute("type");
      if (a.hasValue()) {
        var o = a.getString();
        s = "".concat(o, "(").concat(s, ")");
      }
      A.setValue(s), i = !0;
    }
    return i;
  }
  getProgress() {
    var {
      document: e,
      values: t
    } = this, A = {
      progress: (this.duration - this.begin) / (this.maxDuration - this.begin)
    };
    if (t.hasValue()) {
      var n = A.progress * (t.getValue().length - 1), i = Math.floor(n), s = Math.ceil(n);
      A.from = new pt(e, "from", parseFloat(t.getValue()[i])), A.to = new pt(e, "to", parseFloat(t.getValue()[s])), A.progress = (n - i) / (s - i);
    } else
      A.from = this.from, A.to = this.to;
    return A;
  }
}
class bF extends uf {
  constructor() {
    super(...arguments), this.type = "animateColor";
  }
  calcValue() {
    var {
      progress: e,
      from: t,
      to: A
    } = this.getProgress(), n = new Im(t.getColor()), i = new Im(A.getColor());
    if (n.ok && i.ok) {
      var s = n.r + (i.r - n.r) * e, a = n.g + (i.g - n.g) * e, o = n.b + (i.b - n.b) * e;
      return "rgb(".concat(Math.floor(s), ", ").concat(Math.floor(a), ", ").concat(Math.floor(o), ")");
    }
    return this.getAttribute("from").getColor();
  }
}
class CF extends uf {
  constructor() {
    super(...arguments), this.type = "animateTransform";
  }
  calcValue() {
    var {
      progress: e,
      from: t,
      to: A
    } = this.getProgress(), n = An(t.getString()), i = An(A.getString()), s = n.map((a, o) => {
      var l = i[o];
      return a + (l - a) * e;
    }).join(" ");
    return s;
  }
}
class SF extends gr {
  constructor(e, t, A) {
    super(e, t, A), this.type = "font", this.glyphs = /* @__PURE__ */ Object.create(null), this.horizAdvX = this.getAttribute("horiz-adv-x").getNumber();
    var {
      definitions: n
    } = e, {
      children: i
    } = this;
    for (var s of i)
      switch (s.type) {
        case "font-face": {
          this.fontFace = s;
          var a = s.getStyle("font-family");
          a.hasValue() && (n[a.getString()] = this);
          break;
        }
        case "missing-glyph":
          this.missingGlyph = s;
          break;
        case "glyph": {
          var o = s;
          o.arabicForm ? (this.isRTL = !0, this.isArabic = !0, typeof this.glyphs[o.unicode] > "u" && (this.glyphs[o.unicode] = /* @__PURE__ */ Object.create(null)), this.glyphs[o.unicode][o.arabicForm] = o) : this.glyphs[o.unicode] = o;
          break;
        }
      }
  }
  render() {
  }
}
class xF extends gr {
  constructor(e, t, A) {
    super(e, t, A), this.type = "font-face", this.ascent = this.getAttribute("ascent").getNumber(), this.descent = this.getAttribute("descent").getNumber(), this.unitsPerEm = this.getAttribute("units-per-em").getNumber();
  }
}
class EF extends er {
  constructor() {
    super(...arguments), this.type = "missing-glyph", this.horizAdvX = 0;
  }
}
class FF extends is {
  constructor() {
    super(...arguments), this.type = "tref";
  }
  getText() {
    var e = this.getHrefAttribute().getDefinition();
    if (e) {
      var t = e.children[0];
      if (t)
        return t.getText();
    }
    return "";
  }
}
class _F extends is {
  constructor(e, t, A) {
    super(e, t, A), this.type = "a";
    var {
      childNodes: n
    } = t, i = n[0], s = n.length > 0 && Array.from(n).every((a) => a.nodeType === 3);
    this.hasText = s, this.text = s ? this.getTextFromNode(i) : "";
  }
  getText() {
    return this.text;
  }
  renderChildren(e) {
    if (this.hasText) {
      super.renderChildren(e);
      var {
        document: t,
        x: A,
        y: n
      } = this, {
        mouse: i
      } = t.screen, s = new pt(t, "fontSize", OA.parse(t.ctx.font).fontSize);
      i.isWorking() && i.checkBoundingBox(this, new Dn(A, n - s.getPixels("y"), A + this.measureText(e), n));
    } else if (this.children.length > 0) {
      var a = new lf(this.document, null);
      a.children = this.children, a.parent = this, a.render(e);
    }
  }
  onClick() {
    var {
      window: e
    } = this.document;
    e && e.open(this.getHrefAttribute().getString());
  }
  onMouseMove() {
    var e = this.document.ctx;
    e.canvas.style.cursor = "pointer";
  }
}
function sS(r, e) {
  var t = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var A = Object.getOwnPropertySymbols(r);
    e && (A = A.filter(function(n) {
      return Object.getOwnPropertyDescriptor(r, n).enumerable;
    })), t.push.apply(t, A);
  }
  return t;
}
function Kc(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? sS(Object(t), !0).forEach(function(A) {
      Hv(r, A, t[A]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : sS(Object(t)).forEach(function(A) {
      Object.defineProperty(r, A, Object.getOwnPropertyDescriptor(t, A));
    });
  }
  return r;
}
class UF extends is {
  constructor(e, t, A) {
    super(e, t, A), this.type = "textPath", this.textWidth = 0, this.textHeight = 0, this.pathLength = -1, this.glyphInfo = null, this.letterSpacingCache = [], this.measuresCache = /* @__PURE__ */ new Map([["", 0]]);
    var n = this.getHrefAttribute().getDefinition();
    this.text = this.getTextFromNode(), this.dataArray = this.parsePathData(n);
  }
  getText() {
    return this.text;
  }
  path(e) {
    var {
      dataArray: t
    } = this;
    e && e.beginPath(), t.forEach((A) => {
      var {
        type: n,
        points: i
      } = A;
      switch (n) {
        case Ut.LINE_TO:
          e && e.lineTo(i[0], i[1]);
          break;
        case Ut.MOVE_TO:
          e && e.moveTo(i[0], i[1]);
          break;
        case Ut.CURVE_TO:
          e && e.bezierCurveTo(i[0], i[1], i[2], i[3], i[4], i[5]);
          break;
        case Ut.QUAD_TO:
          e && e.quadraticCurveTo(i[0], i[1], i[2], i[3]);
          break;
        case Ut.ARC: {
          var [s, a, o, l, u, h, f, c] = i, p = o > l ? o : l, g = o > l ? 1 : o / l, v = o > l ? l / o : 1;
          e && (e.translate(s, a), e.rotate(f), e.scale(g, v), e.arc(0, 0, p, u, u + h, !!(1 - c)), e.scale(1 / g, 1 / v), e.rotate(-f), e.translate(-s, -a));
          break;
        }
        case Ut.CLOSE_PATH:
          e && e.closePath();
          break;
      }
    });
  }
  renderChildren(e) {
    this.setTextData(e), e.save();
    var t = this.parent.getStyle("text-decoration").getString(), A = this.getFontSize(), {
      glyphInfo: n
    } = this, i = e.fillStyle;
    t === "underline" && e.beginPath(), n.forEach((s, a) => {
      var {
        p0: o,
        p1: l,
        rotation: u,
        text: h
      } = s;
      e.save(), e.translate(o.x, o.y), e.rotate(u), e.fillStyle && e.fillText(h, 0, 0), e.strokeStyle && e.strokeText(h, 0, 0), e.restore(), t === "underline" && (a === 0 && e.moveTo(o.x, o.y + A / 8), e.lineTo(l.x, l.y + A / 5));
    }), t === "underline" && (e.lineWidth = A / 20, e.strokeStyle = i, e.stroke(), e.closePath()), e.restore();
  }
  getLetterSpacingAt() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return this.letterSpacingCache[e] || 0;
  }
  findSegmentToFitChar(e, t, A, n, i, s, a, o, l) {
    var u = s, h = this.measureText(e, o);
    o === " " && t === "justify" && A < n && (h += (n - A) / i), l > -1 && (u += this.getLetterSpacingAt(l));
    var f = this.textHeight / 20, c = this.getEquidistantPointOnPath(u, f, 0), p = this.getEquidistantPointOnPath(u + h, f, 0), g = {
      p0: c,
      p1: p
    }, v = c && p ? Math.atan2(p.y - c.y, p.x - c.x) : 0;
    if (a) {
      var w = Math.cos(Math.PI / 2 + v) * a, B = Math.cos(-v) * a;
      g.p0 = Kc(Kc({}, c), {}, {
        x: c.x + w,
        y: c.y + B
      }), g.p1 = Kc(Kc({}, p), {}, {
        x: p.x + w,
        y: p.y + B
      });
    }
    return u += h, {
      offset: u,
      segment: g,
      rotation: v
    };
  }
  measureText(e, t) {
    var {
      measuresCache: A
    } = this, n = t || this.getText();
    if (A.has(n))
      return A.get(n);
    var i = this.measureTargetText(e, n);
    return A.set(n, i), i;
  }
  // This method supposes what all custom fonts already loaded.
  // If some font will be loaded after this method call, <textPath> will not be rendered correctly.
  // You need to call this method manually to update glyphs cache.
  setTextData(e) {
    if (!this.glyphInfo) {
      var t = this.getText(), A = t.split(""), n = t.split(" ").length - 1, i = this.parent.getAttribute("dx").split().map((C) => C.getPixels("x")), s = this.parent.getAttribute("dy").getPixels("y"), a = this.parent.getStyle("text-anchor").getString("start"), o = this.getStyle("letter-spacing"), l = this.parent.getStyle("letter-spacing"), u = 0;
      !o.hasValue() || o.getValue() === "inherit" ? u = l.getPixels() : o.hasValue() && o.getValue() !== "initial" && o.getValue() !== "unset" && (u = o.getPixels());
      var h = [], f = t.length;
      this.letterSpacingCache = h;
      for (var c = 0; c < f; c++)
        h.push(typeof i[c] < "u" ? i[c] : u);
      var p = h.reduce((C, E, _) => _ === 0 ? 0 : C + E || 0, 0), g = this.measureText(e), v = Math.max(g + p, 0);
      this.textWidth = g, this.textHeight = this.getFontSize(), this.glyphInfo = [];
      var w = this.getPathLength(), B = this.getStyle("startOffset").getNumber(0) * w, S = 0;
      (a === "middle" || a === "center") && (S = -v / 2), (a === "end" || a === "right") && (S = -v), S += B, A.forEach((C, E) => {
        var {
          offset: _,
          segment: I,
          rotation: O
        } = this.findSegmentToFitChar(e, a, v, w, n, S, s, C, E);
        S = _, !(!I.p0 || !I.p1) && this.glyphInfo.push({
          // transposeX: midpoint.x,
          // transposeY: midpoint.y,
          text: A[E],
          p0: I.p0,
          p1: I.p1,
          rotation: O
        });
      });
    }
  }
  parsePathData(e) {
    if (this.pathLength = -1, !e)
      return [];
    var t = [], {
      pathParser: A
    } = e;
    for (A.reset(); !A.isEnd(); ) {
      var {
        current: n
      } = A, i = n ? n.x : 0, s = n ? n.y : 0, a = A.next(), o = a.type, l = [];
      switch (a.type) {
        case Ut.MOVE_TO:
          this.pathM(A, l);
          break;
        case Ut.LINE_TO:
          o = this.pathL(A, l);
          break;
        case Ut.HORIZ_LINE_TO:
          o = this.pathH(A, l);
          break;
        case Ut.VERT_LINE_TO:
          o = this.pathV(A, l);
          break;
        case Ut.CURVE_TO:
          this.pathC(A, l);
          break;
        case Ut.SMOOTH_CURVE_TO:
          o = this.pathS(A, l);
          break;
        case Ut.QUAD_TO:
          this.pathQ(A, l);
          break;
        case Ut.SMOOTH_QUAD_TO:
          o = this.pathT(A, l);
          break;
        case Ut.ARC:
          l = this.pathA(A);
          break;
        case Ut.CLOSE_PATH:
          er.pathZ(A);
          break;
      }
      a.type !== Ut.CLOSE_PATH ? t.push({
        type: o,
        points: l,
        start: {
          x: i,
          y: s
        },
        pathLength: this.calcLength(i, s, o, l)
      }) : t.push({
        type: Ut.CLOSE_PATH,
        points: [],
        pathLength: 0
      });
    }
    return t;
  }
  pathM(e, t) {
    var {
      x: A,
      y: n
    } = er.pathM(e).point;
    t.push(A, n);
  }
  pathL(e, t) {
    var {
      x: A,
      y: n
    } = er.pathL(e).point;
    return t.push(A, n), Ut.LINE_TO;
  }
  pathH(e, t) {
    var {
      x: A,
      y: n
    } = er.pathH(e).point;
    return t.push(A, n), Ut.LINE_TO;
  }
  pathV(e, t) {
    var {
      x: A,
      y: n
    } = er.pathV(e).point;
    return t.push(A, n), Ut.LINE_TO;
  }
  pathC(e, t) {
    var {
      point: A,
      controlPoint: n,
      currentPoint: i
    } = er.pathC(e);
    t.push(A.x, A.y, n.x, n.y, i.x, i.y);
  }
  pathS(e, t) {
    var {
      point: A,
      controlPoint: n,
      currentPoint: i
    } = er.pathS(e);
    return t.push(A.x, A.y, n.x, n.y, i.x, i.y), Ut.CURVE_TO;
  }
  pathQ(e, t) {
    var {
      controlPoint: A,
      currentPoint: n
    } = er.pathQ(e);
    t.push(A.x, A.y, n.x, n.y);
  }
  pathT(e, t) {
    var {
      controlPoint: A,
      currentPoint: n
    } = er.pathT(e);
    return t.push(A.x, A.y, n.x, n.y), Ut.QUAD_TO;
  }
  pathA(e) {
    var {
      rX: t,
      rY: A,
      sweepFlag: n,
      xAxisRotation: i,
      centp: s,
      a1: a,
      ad: o
    } = er.pathA(e);
    return n === 0 && o > 0 && (o -= 2 * Math.PI), n === 1 && o < 0 && (o += 2 * Math.PI), [s.x, s.y, t, A, a, o, i, n];
  }
  calcLength(e, t, A, n) {
    var i = 0, s = null, a = null, o = 0;
    switch (A) {
      case Ut.LINE_TO:
        return this.getLineLength(e, t, n[0], n[1]);
      case Ut.CURVE_TO:
        for (i = 0, s = this.getPointOnCubicBezier(0, e, t, n[0], n[1], n[2], n[3], n[4], n[5]), o = 0.01; o <= 1; o += 0.01)
          a = this.getPointOnCubicBezier(o, e, t, n[0], n[1], n[2], n[3], n[4], n[5]), i += this.getLineLength(s.x, s.y, a.x, a.y), s = a;
        return i;
      case Ut.QUAD_TO:
        for (i = 0, s = this.getPointOnQuadraticBezier(0, e, t, n[0], n[1], n[2], n[3]), o = 0.01; o <= 1; o += 0.01)
          a = this.getPointOnQuadraticBezier(o, e, t, n[0], n[1], n[2], n[3]), i += this.getLineLength(s.x, s.y, a.x, a.y), s = a;
        return i;
      case Ut.ARC: {
        i = 0;
        var l = n[4], u = n[5], h = n[4] + u, f = Math.PI / 180;
        if (Math.abs(l - h) < f && (f = Math.abs(l - h)), s = this.getPointOnEllipticalArc(n[0], n[1], n[2], n[3], l, 0), u < 0)
          for (o = l - f; o > h; o -= f)
            a = this.getPointOnEllipticalArc(n[0], n[1], n[2], n[3], o, 0), i += this.getLineLength(s.x, s.y, a.x, a.y), s = a;
        else
          for (o = l + f; o < h; o += f)
            a = this.getPointOnEllipticalArc(n[0], n[1], n[2], n[3], o, 0), i += this.getLineLength(s.x, s.y, a.x, a.y), s = a;
        return a = this.getPointOnEllipticalArc(n[0], n[1], n[2], n[3], h, 0), i += this.getLineLength(s.x, s.y, a.x, a.y), i;
      }
    }
    return 0;
  }
  getPointOnLine(e, t, A, n, i) {
    var s = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : t, a = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : A, o = (i - A) / (n - t + _a), l = Math.sqrt(e * e / (1 + o * o));
    n < t && (l *= -1);
    var u = o * l, h = null;
    if (n === t)
      h = {
        x: s,
        y: a + u
      };
    else if ((a - A) / (s - t + _a) === o)
      h = {
        x: s + l,
        y: a + u
      };
    else {
      var f = 0, c = 0, p = this.getLineLength(t, A, n, i);
      if (p < _a)
        return null;
      var g = (s - t) * (n - t) + (a - A) * (i - A);
      g /= p * p, f = t + g * (n - t), c = A + g * (i - A);
      var v = this.getLineLength(s, a, f, c), w = Math.sqrt(e * e - v * v);
      l = Math.sqrt(w * w / (1 + o * o)), n < t && (l *= -1), u = o * l, h = {
        x: f + l,
        y: c + u
      };
    }
    return h;
  }
  getPointOnPath(e) {
    var t = this.getPathLength(), A = 0, n = null;
    if (e < -5e-5 || e - 5e-5 > t)
      return null;
    var {
      dataArray: i
    } = this;
    for (var s of i) {
      if (s && (s.pathLength < 5e-5 || A + s.pathLength + 5e-5 < e)) {
        A += s.pathLength;
        continue;
      }
      var a = e - A, o = 0;
      switch (s.type) {
        case Ut.LINE_TO:
          n = this.getPointOnLine(a, s.start.x, s.start.y, s.points[0], s.points[1], s.start.x, s.start.y);
          break;
        case Ut.ARC: {
          var l = s.points[4], u = s.points[5], h = s.points[4] + u;
          if (o = l + a / s.pathLength * u, u < 0 && o < h || u >= 0 && o > h)
            break;
          n = this.getPointOnEllipticalArc(s.points[0], s.points[1], s.points[2], s.points[3], o, s.points[6]);
          break;
        }
        case Ut.CURVE_TO:
          o = a / s.pathLength, o > 1 && (o = 1), n = this.getPointOnCubicBezier(o, s.start.x, s.start.y, s.points[0], s.points[1], s.points[2], s.points[3], s.points[4], s.points[5]);
          break;
        case Ut.QUAD_TO:
          o = a / s.pathLength, o > 1 && (o = 1), n = this.getPointOnQuadraticBezier(o, s.start.x, s.start.y, s.points[0], s.points[1], s.points[2], s.points[3]);
          break;
      }
      if (n)
        return n;
      break;
    }
    return null;
  }
  getLineLength(e, t, A, n) {
    return Math.sqrt((A - e) * (A - e) + (n - t) * (n - t));
  }
  getPathLength() {
    return this.pathLength === -1 && (this.pathLength = this.dataArray.reduce((e, t) => t.pathLength > 0 ? e + t.pathLength : e, 0)), this.pathLength;
  }
  getPointOnCubicBezier(e, t, A, n, i, s, a, o, l) {
    var u = o * Tm(e) + s * Pm(e) + n * Om(e) + t * Mm(e), h = l * Tm(e) + a * Pm(e) + i * Om(e) + A * Mm(e);
    return {
      x: u,
      y: h
    };
  }
  getPointOnQuadraticBezier(e, t, A, n, i, s, a) {
    var o = s * Rm(e) + n * km(e) + t * Hm(e), l = a * Rm(e) + i * km(e) + A * Hm(e);
    return {
      x: o,
      y: l
    };
  }
  getPointOnEllipticalArc(e, t, A, n, i, s) {
    var a = Math.cos(s), o = Math.sin(s), l = {
      x: A * Math.cos(i),
      y: n * Math.sin(i)
    };
    return {
      x: e + (l.x * a - l.y * o),
      y: t + (l.x * o + l.y * a)
    };
  }
  // TODO need some optimisations. possibly build cache only for curved segments?
  buildEquidistantCache(e, t) {
    var A = this.getPathLength(), n = t || 0.25, i = e || A / 100;
    if (!this.equidistantCache || this.equidistantCache.step !== i || this.equidistantCache.precision !== n) {
      this.equidistantCache = {
        step: i,
        precision: n,
        points: []
      };
      for (var s = 0, a = 0; a <= A; a += n) {
        var o = this.getPointOnPath(a), l = this.getPointOnPath(a + n);
        !o || !l || (s += this.getLineLength(o.x, o.y, l.x, l.y), s >= i && (this.equidistantCache.points.push({
          x: o.x,
          y: o.y,
          distance: a
        }), s -= i));
      }
    }
  }
  getEquidistantPointOnPath(e, t, A) {
    if (this.buildEquidistantCache(t, A), e < 0 || e - this.getPathLength() > 5e-5)
      return null;
    var n = Math.round(e / this.getPathLength() * (this.equidistantCache.points.length - 1));
    return this.equidistantCache.points[n] || null;
  }
}
var p8 = /^\s*data:(([^/,;]+\/[^/,;]+)(?:;([^,;=]+=[^,;=]+))?)?(?:;(base64))?,(.*)$/i;
class IF extends Ws {
  constructor(e, t, A) {
    super(e, t, A), this.type = "image", this.loaded = !1;
    var n = this.getHrefAttribute().getString();
    if (n) {
      var i = n.endsWith(".svg") || /^\s*data:image\/svg\+xml/i.test(n);
      e.images.push(this), i ? this.loadSvg(n) : this.loadImage(n), this.isSvg = i;
    }
  }
  loadImage(e) {
    var t = this;
    return ns(function* () {
      try {
        var A = yield t.document.createImage(e);
        t.image = A;
      } catch (n) {
        console.error('Error while loading image "'.concat(e, '":'), n);
      }
      t.loaded = !0;
    })();
  }
  loadSvg(e) {
    var t = this;
    return ns(function* () {
      var A = p8.exec(e);
      if (A) {
        var n = A[5];
        A[4] === "base64" ? t.image = atob(n) : t.image = decodeURIComponent(n);
      } else
        try {
          var i = yield t.document.fetch(e), s = yield i.text();
          t.image = s;
        } catch (a) {
          console.error('Error while loading image "'.concat(e, '":'), a);
        }
      t.loaded = !0;
    })();
  }
  renderChildren(e) {
    var {
      document: t,
      image: A,
      loaded: n
    } = this, i = this.getAttribute("x").getPixels("x"), s = this.getAttribute("y").getPixels("y"), a = this.getStyle("width").getPixels("x"), o = this.getStyle("height").getPixels("y");
    if (!(!n || !A || !a || !o)) {
      if (e.save(), e.translate(i, s), this.isSvg) {
        var l = t.canvg.forkString(e, this.image, {
          ignoreMouse: !0,
          ignoreAnimation: !0,
          ignoreDimensions: !0,
          ignoreClear: !0,
          offsetX: 0,
          offsetY: 0,
          scaleWidth: a,
          scaleHeight: o
        });
        l.document.documentElement.parent = this, l.render();
      } else {
        var u = this.image;
        t.setViewBox({
          ctx: e,
          aspectRatio: this.getAttribute("preserveAspectRatio").getString(),
          width: a,
          desiredWidth: u.width,
          height: o,
          desiredHeight: u.height
        }), this.loaded && (typeof u.complete > "u" || u.complete) && e.drawImage(u, 0, 0);
      }
      e.restore();
    }
  }
  getBoundingBox() {
    var e = this.getAttribute("x").getPixels("x"), t = this.getAttribute("y").getPixels("y"), A = this.getStyle("width").getPixels("x"), n = this.getStyle("height").getPixels("y");
    return new Dn(e, t, e + A, t + n);
  }
}
class QF extends Ws {
  constructor() {
    super(...arguments), this.type = "symbol";
  }
  render(e) {
  }
}
class LF {
  constructor(e) {
    this.document = e, this.loaded = !1, e.fonts.push(this);
  }
  load(e, t) {
    var A = this;
    return ns(function* () {
      try {
        var {
          document: n
        } = A, i = yield n.canvg.parser.load(t), s = i.getElementsByTagName("font");
        Array.from(s).forEach((a) => {
          var o = n.createElement(a);
          n.definitions[e] = o;
        });
      } catch (a) {
        console.error('Error while loading font "'.concat(t, '":'), a);
      }
      A.loaded = !0;
    })();
  }
}
class Wv extends gr {
  constructor(e, t, A) {
    super(e, t, A), this.type = "style";
    var n = Ga(
      Array.from(t.childNodes).map((s) => s.textContent).join("").replace(/(\/\*([^*]|[\r\n]|(\*+([^*/]|[\r\n])))*\*+\/)|(^[\s]*\/\/.*)/gm, "").replace(/@import.*;/g, "")
      // remove imports
    ), i = n.split("}");
    i.forEach((s) => {
      var a = s.trim();
      if (a) {
        var o = a.split("{"), l = o[0].split(","), u = o[1].split(";");
        l.forEach((h) => {
          var f = h.trim();
          if (f) {
            var c = e.styles[f] || {};
            if (u.forEach((v) => {
              var w = v.indexOf(":"), B = v.substr(0, w).trim(), S = v.substr(w + 1, v.length - w).trim();
              B && S && (c[B] = new pt(e, B, S));
            }), e.styles[f] = c, e.stylesSpecificity[f] = tF(f), f === "@font-face") {
              var p = c["font-family"].getString().replace(/"|'/g, ""), g = c.src.getString().split(",");
              g.forEach((v) => {
                if (v.indexOf('format("svg")') > 0) {
                  var w = Dv(v);
                  w && new LF(e).load(p, w);
                }
              });
            }
          }
        });
      }
    });
  }
}
Wv.parseExternalUrl = Dv;
class NF extends Ws {
  constructor() {
    super(...arguments), this.type = "use";
  }
  setContext(e) {
    super.setContext(e);
    var t = this.getAttribute("x"), A = this.getAttribute("y");
    t.hasValue() && e.translate(t.getPixels("x"), 0), A.hasValue() && e.translate(0, A.getPixels("y"));
  }
  path(e) {
    var {
      element: t
    } = this;
    t && t.path(e);
  }
  renderChildren(e) {
    var {
      document: t,
      element: A
    } = this;
    if (A) {
      var n = A;
      if (A.type === "symbol" && (n = new Ro(t, null), n.attributes.viewBox = new pt(t, "viewBox", A.getAttribute("viewBox").getString()), n.attributes.preserveAspectRatio = new pt(t, "preserveAspectRatio", A.getAttribute("preserveAspectRatio").getString()), n.attributes.overflow = new pt(t, "overflow", A.getAttribute("overflow").getString()), n.children = A.children, A.styles.opacity = new pt(t, "opacity", this.calculateOpacity())), n.type === "svg") {
        var i = this.getStyle("width", !1, !0), s = this.getStyle("height", !1, !0);
        i.hasValue() && (n.attributes.width = new pt(t, "width", i.getString())), s.hasValue() && (n.attributes.height = new pt(t, "height", s.getString()));
      }
      var a = n.parent;
      n.parent = this, n.render(e), n.parent = a;
    }
  }
  getBoundingBox(e) {
    var {
      element: t
    } = this;
    return t ? t.getBoundingBox(e) : null;
  }
  elementTransform() {
    var {
      document: e,
      element: t
    } = this;
    return Gs.fromElement(e, t);
  }
  get element() {
    return this.cachedElement || (this.cachedElement = this.getHrefAttribute().getDefinition()), this.cachedElement;
  }
}
function jc(r, e, t, A, n, i) {
  return r[t * A * 4 + e * 4 + i];
}
function qc(r, e, t, A, n, i, s) {
  r[t * A * 4 + e * 4 + i] = s;
}
function eA(r, e, t) {
  var A = r[e];
  return A * t;
}
function Wi(r, e, t, A) {
  return e + Math.cos(r) * t + Math.sin(r) * A;
}
class Xv extends gr {
  constructor(e, t, A) {
    super(e, t, A), this.type = "feColorMatrix";
    var n = An(this.getAttribute("values").getString());
    switch (this.getAttribute("type").getString("matrix")) {
      // http://www.w3.org/TR/SVG/filters.html#feColorMatrixElement
      case "saturate": {
        var i = n[0];
        n = [0.213 + 0.787 * i, 0.715 - 0.715 * i, 0.072 - 0.072 * i, 0, 0, 0.213 - 0.213 * i, 0.715 + 0.285 * i, 0.072 - 0.072 * i, 0, 0, 0.213 - 0.213 * i, 0.715 - 0.715 * i, 0.072 + 0.928 * i, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1];
        break;
      }
      case "hueRotate": {
        var s = n[0] * Math.PI / 180;
        n = [Wi(s, 0.213, 0.787, -0.213), Wi(s, 0.715, -0.715, -0.715), Wi(s, 0.072, -0.072, 0.928), 0, 0, Wi(s, 0.213, -0.213, 0.143), Wi(s, 0.715, 0.285, 0.14), Wi(s, 0.072, -0.072, -0.283), 0, 0, Wi(s, 0.213, -0.213, -0.787), Wi(s, 0.715, -0.715, 0.715), Wi(s, 0.072, 0.928, 0.072), 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1];
        break;
      }
      case "luminanceToAlpha":
        n = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2125, 0.7154, 0.0721, 0, 0, 0, 0, 0, 0, 1];
        break;
    }
    this.matrix = n, this.includeOpacity = this.getAttribute("includeOpacity").hasValue();
  }
  apply(e, t, A, n, i) {
    for (var {
      includeOpacity: s,
      matrix: a
    } = this, o = e.getImageData(0, 0, n, i), l = 0; l < i; l++)
      for (var u = 0; u < n; u++) {
        var h = jc(o.data, u, l, n, i, 0), f = jc(o.data, u, l, n, i, 1), c = jc(o.data, u, l, n, i, 2), p = jc(o.data, u, l, n, i, 3), g = eA(a, 0, h) + eA(a, 1, f) + eA(a, 2, c) + eA(a, 3, p) + eA(a, 4, 1), v = eA(a, 5, h) + eA(a, 6, f) + eA(a, 7, c) + eA(a, 8, p) + eA(a, 9, 1), w = eA(a, 10, h) + eA(a, 11, f) + eA(a, 12, c) + eA(a, 13, p) + eA(a, 14, 1), B = eA(a, 15, h) + eA(a, 16, f) + eA(a, 17, c) + eA(a, 18, p) + eA(a, 19, 1);
        s && (g = 0, v = 0, w = 0, B *= p / 255), qc(o.data, u, l, n, i, 0, g), qc(o.data, u, l, n, i, 1, v), qc(o.data, u, l, n, i, 2, w), qc(o.data, u, l, n, i, 3, B);
      }
    e.clearRect(0, 0, n, i), e.putImageData(o, 0, 0);
  }
}
class Eu extends gr {
  constructor() {
    super(...arguments), this.type = "mask";
  }
  apply(e, t) {
    var {
      document: A
    } = this, n = this.getAttribute("x").getPixels("x"), i = this.getAttribute("y").getPixels("y"), s = this.getStyle("width").getPixels("x"), a = this.getStyle("height").getPixels("y");
    if (!s && !a) {
      var o = new Dn();
      this.children.forEach((p) => {
        o.addBoundingBox(p.getBoundingBox(e));
      }), n = Math.floor(o.x1), i = Math.floor(o.y1), s = Math.floor(o.width), a = Math.floor(o.height);
    }
    var l = this.removeStyles(t, Eu.ignoreStyles), u = A.createCanvas(n + s, i + a), h = u.getContext("2d");
    A.screen.setDefaults(h), this.renderChildren(h), new Xv(A, {
      nodeType: 1,
      childNodes: [],
      attributes: [{
        nodeName: "type",
        value: "luminanceToAlpha"
      }, {
        nodeName: "includeOpacity",
        value: "true"
      }]
    }).apply(h, 0, 0, n + s, i + a);
    var f = A.createCanvas(n + s, i + a), c = f.getContext("2d");
    A.screen.setDefaults(c), t.render(c), c.globalCompositeOperation = "destination-in", c.fillStyle = h.createPattern(u, "no-repeat"), c.fillRect(0, 0, n + s, i + a), e.fillStyle = c.createPattern(f, "no-repeat"), e.fillRect(0, 0, n + s, i + a), this.restoreStyles(t, l);
  }
  render(e) {
  }
}
Eu.ignoreStyles = ["mask", "transform", "clip-path"];
var aS = () => {
};
class TF extends gr {
  constructor() {
    super(...arguments), this.type = "clipPath";
  }
  apply(e) {
    var {
      document: t
    } = this, A = Reflect.getPrototypeOf(e), {
      beginPath: n,
      closePath: i
    } = e;
    A && (A.beginPath = aS, A.closePath = aS), Reflect.apply(n, e, []), this.children.forEach((s) => {
      if (!(typeof s.path > "u")) {
        var a = typeof s.elementTransform < "u" ? s.elementTransform() : null;
        a || (a = Gs.fromElement(t, s)), a && a.apply(e), s.path(e), A && (A.closePath = i), a && a.unapply(e);
      }
    }), Reflect.apply(i, e, []), e.clip(), A && (A.beginPath = n, A.closePath = i);
  }
  render(e) {
  }
}
class Fu extends gr {
  constructor() {
    super(...arguments), this.type = "filter";
  }
  apply(e, t) {
    var {
      document: A,
      children: n
    } = this, i = t.getBoundingBox(e);
    if (i) {
      var s = 0, a = 0;
      n.forEach((w) => {
        var B = w.extraFilterDistance || 0;
        s = Math.max(s, B), a = Math.max(a, B);
      });
      var o = Math.floor(i.width), l = Math.floor(i.height), u = o + 2 * s, h = l + 2 * a;
      if (!(u < 1 || h < 1)) {
        var f = Math.floor(i.x), c = Math.floor(i.y), p = this.removeStyles(t, Fu.ignoreStyles), g = A.createCanvas(u, h), v = g.getContext("2d");
        A.screen.setDefaults(v), v.translate(-f + s, -c + a), t.render(v), n.forEach((w) => {
          typeof w.apply == "function" && w.apply(v, 0, 0, u, h);
        }), e.drawImage(g, 0, 0, u, h, f - s, c - a, u, h), this.restoreStyles(t, p);
      }
    }
  }
  render(e) {
  }
}
Fu.ignoreStyles = ["filter", "transform", "clip-path"];
class PF extends gr {
  constructor(e, t, A) {
    super(e, t, A), this.type = "feDropShadow", this.addStylesFromStyleDefinition();
  }
  apply(e, t, A, n, i) {
  }
}
class OF extends gr {
  constructor() {
    super(...arguments), this.type = "feMorphology";
  }
  apply(e, t, A, n, i) {
  }
}
class MF extends gr {
  constructor() {
    super(...arguments), this.type = "feComposite";
  }
  apply(e, t, A, n, i) {
  }
}
class RF extends gr {
  constructor(e, t, A) {
    super(e, t, A), this.type = "feGaussianBlur", this.blurRadius = Math.floor(this.getAttribute("stdDeviation").getNumber()), this.extraFilterDistance = this.blurRadius;
  }
  apply(e, t, A, n, i) {
    var {
      document: s,
      blurRadius: a
    } = this, o = s.window ? s.window.document.body : null, l = e.canvas;
    l.id = s.getUniqueId(), o && (l.style.display = "none", o.appendChild(l)), W6(l, t, A, n, i, a), o && o.removeChild(l);
  }
}
class kF extends gr {
  constructor() {
    super(...arguments), this.type = "title";
  }
}
class HF extends gr {
  constructor() {
    super(...arguments), this.type = "desc";
  }
}
var m8 = {
  svg: Ro,
  rect: jv,
  circle: hF,
  ellipse: fF,
  line: dF,
  polyline: qv,
  polygon: gF,
  path: er,
  pattern: pF,
  marker: mF,
  defs: vF,
  linearGradient: wF,
  radialGradient: yF,
  stop: BF,
  animate: uf,
  animateColor: bF,
  animateTransform: CF,
  font: SF,
  "font-face": xF,
  "missing-glyph": EF,
  glyph: Kv,
  text: is,
  tspan: xu,
  tref: FF,
  a: _F,
  textPath: UF,
  image: IF,
  g: lf,
  symbol: QF,
  style: Wv,
  use: NF,
  mask: Eu,
  clipPath: TF,
  filter: Fu,
  feDropShadow: PF,
  feMorphology: OF,
  feComposite: MF,
  feColorMatrix: Xv,
  feGaussianBlur: RF,
  title: kF,
  desc: HF
};
function oS(r, e) {
  var t = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var A = Object.getOwnPropertySymbols(r);
    e && (A = A.filter(function(n) {
      return Object.getOwnPropertyDescriptor(r, n).enumerable;
    })), t.push.apply(t, A);
  }
  return t;
}
function v8(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? oS(Object(t), !0).forEach(function(A) {
      Hv(r, A, t[A]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : oS(Object(t)).forEach(function(A) {
      Object.defineProperty(r, A, Object.getOwnPropertyDescriptor(t, A));
    });
  }
  return r;
}
function w8(r, e) {
  var t = document.createElement("canvas");
  return t.width = r, t.height = e, t;
}
function y8(r) {
  return Dm.apply(this, arguments);
}
function Dm() {
  return Dm = ns(function* (r) {
    var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, t = document.createElement("img");
    return e && (t.crossOrigin = "Anonymous"), new Promise((A, n) => {
      t.onload = () => {
        A(t);
      }, t.onerror = (i, s, a, o, l) => {
        n(l);
      }, t.src = r;
    });
  }), Dm.apply(this, arguments);
}
class es {
  constructor(e) {
    var {
      rootEmSize: t = 12,
      emSize: A = 12,
      createCanvas: n = es.createCanvas,
      createImage: i = es.createImage,
      anonymousCrossOrigin: s
    } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.canvg = e, this.definitions = /* @__PURE__ */ Object.create(null), this.styles = /* @__PURE__ */ Object.create(null), this.stylesSpecificity = /* @__PURE__ */ Object.create(null), this.images = [], this.fonts = [], this.emSizeStack = [], this.uniqueId = 0, this.screen = e.screen, this.rootEmSize = t, this.emSize = A, this.createCanvas = n, this.createImage = this.bindCreateImage(i, s), this.screen.wait(this.isImagesLoaded.bind(this)), this.screen.wait(this.isFontsLoaded.bind(this));
  }
  bindCreateImage(e, t) {
    return typeof t == "boolean" ? (A, n) => e(A, typeof n == "boolean" ? n : t) : e;
  }
  get window() {
    return this.screen.window;
  }
  get fetch() {
    return this.screen.fetch;
  }
  get ctx() {
    return this.screen.ctx;
  }
  get emSize() {
    var {
      emSizeStack: e
    } = this;
    return e[e.length - 1];
  }
  set emSize(e) {
    var {
      emSizeStack: t
    } = this;
    t.push(e);
  }
  popEmSize() {
    var {
      emSizeStack: e
    } = this;
    e.pop();
  }
  getUniqueId() {
    return "canvg".concat(++this.uniqueId);
  }
  isImagesLoaded() {
    return this.images.every((e) => e.loaded);
  }
  isFontsLoaded() {
    return this.fonts.every((e) => e.loaded);
  }
  createDocumentElement(e) {
    var t = this.createElement(e.documentElement);
    return t.root = !0, t.addStylesFromStyleDefinition(), this.documentElement = t, t;
  }
  createElement(e) {
    var t = e.nodeName.replace(/^[^:]+:/, ""), A = es.elementTypes[t];
    return typeof A < "u" ? new A(this, e) : new cF(this, e);
  }
  createTextNode(e) {
    return new g8(this, e);
  }
  setViewBox(e) {
    this.screen.setViewBox(v8({
      document: this
    }, e));
  }
}
es.createCanvas = w8;
es.createImage = y8;
es.elementTypes = m8;
function lS(r, e) {
  var t = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var A = Object.getOwnPropertySymbols(r);
    e && (A = A.filter(function(n) {
      return Object.getOwnPropertyDescriptor(r, n).enumerable;
    })), t.push.apply(t, A);
  }
  return t;
}
function da(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? lS(Object(t), !0).forEach(function(A) {
      Hv(r, A, t[A]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : lS(Object(t)).forEach(function(A) {
      Object.defineProperty(r, A, Object.getOwnPropertyDescriptor(t, A));
    });
  }
  return r;
}
class Ca {
  /**
   * Main constructor.
   * @param ctx - Rendering context.
   * @param svg - SVG Document.
   * @param options - Rendering options.
   */
  constructor(e, t) {
    var A = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    this.parser = new uh(A), this.screen = new Su(e, A), this.options = A;
    var n = new es(this, A), i = n.createDocumentElement(t);
    this.document = n, this.documentElement = i;
  }
  /**
   * Create Canvg instance from SVG source string or URL.
   * @param ctx - Rendering context.
   * @param svg - SVG source string or URL.
   * @param options - Rendering options.
   * @returns Canvg instance.
   */
  static from(e, t) {
    var A = arguments;
    return ns(function* () {
      var n = A.length > 2 && A[2] !== void 0 ? A[2] : {}, i = new uh(n), s = yield i.parse(t);
      return new Ca(e, s, n);
    })();
  }
  /**
   * Create Canvg instance from SVG source string.
   * @param ctx - Rendering context.
   * @param svg - SVG source string.
   * @param options - Rendering options.
   * @returns Canvg instance.
   */
  static fromString(e, t) {
    var A = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = new uh(A), i = n.parseFromString(t);
    return new Ca(e, i, A);
  }
  /**
   * Create new Canvg instance with inherited options.
   * @param ctx - Rendering context.
   * @param svg - SVG source string or URL.
   * @param options - Rendering options.
   * @returns Canvg instance.
   */
  fork(e, t) {
    var A = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return Ca.from(e, t, da(da({}, this.options), A));
  }
  /**
   * Create new Canvg instance with inherited options.
   * @param ctx - Rendering context.
   * @param svg - SVG source string.
   * @param options - Rendering options.
   * @returns Canvg instance.
   */
  forkString(e, t) {
    var A = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return Ca.fromString(e, t, da(da({}, this.options), A));
  }
  /**
   * Document is ready promise.
   * @returns Ready promise.
   */
  ready() {
    return this.screen.ready();
  }
  /**
   * Document is ready value.
   * @returns Is ready or not.
   */
  isReady() {
    return this.screen.isReady();
  }
  /**
   * Render only first frame, ignoring animations and mouse.
   * @param options - Rendering options.
   */
  render() {
    var e = arguments, t = this;
    return ns(function* () {
      var A = e.length > 0 && e[0] !== void 0 ? e[0] : {};
      t.start(da({
        enableRedraw: !0,
        ignoreAnimation: !0,
        ignoreMouse: !0
      }, A)), yield t.ready(), t.stop();
    })();
  }
  /**
   * Start rendering.
   * @param options - Render options.
   */
  start() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, {
      documentElement: t,
      screen: A,
      options: n
    } = this;
    A.start(t, da(da({
      enableRedraw: !0
    }, n), e));
  }
  /**
   * Stop rendering.
   */
  stop() {
    this.screen.stop();
  }
  /**
   * Resize SVG to fit in given size.
   * @param width
   * @param height
   * @param preserveAspectRatio
   */
  resize(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, A = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
    this.documentElement.resize(e, t, A);
  }
}
const B8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AElement: _F,
  AnimateColorElement: bF,
  AnimateElement: uf,
  AnimateTransformElement: CF,
  BoundingBox: Dn,
  CB1: Tm,
  CB2: Pm,
  CB3: Om,
  CB4: Mm,
  Canvg: Ca,
  CircleElement: hF,
  ClipPathElement: TF,
  DefsElement: vF,
  DescElement: HF,
  Document: es,
  Element: gr,
  EllipseElement: fF,
  FeColorMatrixElement: Xv,
  FeCompositeElement: MF,
  FeDropShadowElement: PF,
  FeGaussianBlurElement: RF,
  FeMorphologyElement: OF,
  FilterElement: Fu,
  Font: OA,
  FontElement: SF,
  FontFaceElement: xF,
  GElement: lf,
  GlyphElement: Kv,
  GradientElement: zv,
  ImageElement: IF,
  LineElement: dF,
  LinearGradientElement: wF,
  MarkerElement: mF,
  MaskElement: Eu,
  Matrix: Gv,
  MissingGlyphElement: EF,
  Mouse: AF,
  PSEUDO_ZERO: _a,
  Parser: uh,
  PathElement: er,
  PathParser: Ut,
  PatternElement: pF,
  Point: Lr,
  PolygonElement: gF,
  PolylineElement: qv,
  Property: pt,
  QB1: Rm,
  QB2: km,
  QB3: Hm,
  RadialGradientElement: yF,
  RectElement: jv,
  RenderedElement: Ws,
  Rotate: aF,
  SVGElement: Ro,
  SVGFontLoader: LF,
  Scale: oF,
  Screen: Su,
  Skew: Vv,
  SkewX: lF,
  SkewY: uF,
  StopElement: BF,
  StyleElement: Wv,
  SymbolElement: QF,
  TRefElement: FF,
  TSpanElement: xu,
  TextElement: is,
  TextPathElement: UF,
  TitleElement: kF,
  Transform: Gs,
  Translate: sF,
  UnknownElement: cF,
  UseElement: NF,
  ViewPort: rF,
  compressSpaces: Ga,
  default: Ca,
  getSelectorSpecificity: tF,
  normalizeAttributeName: ZE,
  normalizeColor: eF,
  parseExternalUrl: Dv,
  presets: $6,
  toNumbers: An,
  trimLeft: JE,
  trimRight: $E,
  vectorMagnitude: Lm,
  vectorsAngle: Nm,
  vectorsRatio: Uh
}, Symbol.toStringTag, { value: "Module" }));
export {
  fA as default
};
//# sourceMappingURL=svgcanvas.js.map
